import { gql } from "@apollo/client";
import * as Apollo from "@apollo/client";

export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends " $fragmentName" | "__typename" ? T[P] : never };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
	ID: { input: string; output: string };
	String: { input: string; output: string };
	Boolean: { input: boolean; output: boolean };
	Int: { input: number; output: number };
	Float: { input: number; output: number };
	Bytes: { input: string; output: string };
	Cursor: { input: string; output: string };
	Map: { input: Record<string, any>; output: Record<string, any> };
	Time: { input: string; output: string };
	Upload: { input: File; output: File };
};

export type Announcement = Node & {
	__typename?: "Announcement";
	author: Maybe<User>;
	authorID: Maybe<Scalars["ID"]["output"]>;
	body: Scalars["String"]["output"];
	endTime: Maybe<Scalars["Time"]["output"]>;
	id: Scalars["ID"]["output"];
	mediaAttachments: Array<MediaAttachment>;
	sharingPolicy: Maybe<SharingPolicy>;
	socialReactions: Array<SocialReaction>;
	startTime: Scalars["Time"]["output"];
	title: Scalars["String"]["output"];
};

export type AnnouncementMediaAttachmentsArgs = {
	filters?: InputMaybe<Array<MediaAttachmentFilterInput>>;
	order?: InputMaybe<MediaAttachmentOrder>;
	pagination?: InputMaybe<EdgePagination>;
};

export type AnnouncementSocialReactionsArgs = {
	filters?: InputMaybe<Array<SocialReactionFilterInput>>;
	order?: InputMaybe<SocialReactionOrder>;
	pagination?: InputMaybe<EdgePagination>;
};

export type AnnouncementConnection = {
	__typename?: "AnnouncementConnection";
	edges: Array<AnnouncementEdge>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"]["output"];
};

export type AnnouncementCreateInput = {
	body: Scalars["String"]["input"];
	endTime?: InputMaybe<Scalars["Time"]["input"]>;
	mediaAttachments?: InputMaybe<Array<MediaAttachmentInAnnouncementCreateInput>>;
	sharingPolicy?: InputMaybe<SharingPolicyInAnnouncementCreateInput>;
	socialReactions?: InputMaybe<Array<SocialReactionInAnnouncementCreateInput>>;
	startTime?: InputMaybe<Scalars["Time"]["input"]>;
	title?: InputMaybe<Scalars["String"]["input"]>;
};

export type AnnouncementEdge = {
	__typename?: "AnnouncementEdge";
	cursor: Scalars["Cursor"]["output"];
	node: Announcement;
};

export type AnnouncementFilterInput = {
	and?: InputMaybe<Array<AnnouncementFilterInput>>;
	author?: InputMaybe<Array<UserFilterInput>>;
	authorIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	authorIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	authorIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	authorIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	authorIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	bodyContains?: InputMaybe<Scalars["String"]["input"]>;
	bodyEQ?: InputMaybe<Scalars["String"]["input"]>;
	bodyHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	bodyHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	bodyIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	bodyNEQ?: InputMaybe<Scalars["String"]["input"]>;
	bodyNotContains?: InputMaybe<Scalars["String"]["input"]>;
	bodyNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	bodyNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	bodyNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	endTimeEQ?: InputMaybe<Scalars["Time"]["input"]>;
	endTimeGT?: InputMaybe<Scalars["Time"]["input"]>;
	endTimeGTE?: InputMaybe<Scalars["Time"]["input"]>;
	endTimeIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	endTimeIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	endTimeLT?: InputMaybe<Scalars["Time"]["input"]>;
	endTimeLTE?: InputMaybe<Scalars["Time"]["input"]>;
	endTimeNEQ?: InputMaybe<Scalars["Time"]["input"]>;
	endTimeNotIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	hasAuthor?: InputMaybe<Scalars["Boolean"]["input"]>;
	hasMediaAttachments?: InputMaybe<Scalars["Boolean"]["input"]>;
	hasSharingPolicy?: InputMaybe<Scalars["Boolean"]["input"]>;
	hasSocialReactions?: InputMaybe<Scalars["Boolean"]["input"]>;
	idEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	mediaAttachments?: InputMaybe<Array<MediaAttachmentFilterInput>>;
	not?: InputMaybe<AnnouncementFilterInput>;
	or?: InputMaybe<Array<AnnouncementFilterInput>>;
	search?: InputMaybe<Scalars["String"]["input"]>;
	sharingPolicy?: InputMaybe<Array<SharingPolicyFilterInput>>;
	socialReactions?: InputMaybe<Array<SocialReactionFilterInput>>;
	startTimeEQ?: InputMaybe<Scalars["Time"]["input"]>;
	startTimeGT?: InputMaybe<Scalars["Time"]["input"]>;
	startTimeGTE?: InputMaybe<Scalars["Time"]["input"]>;
	startTimeIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	startTimeLT?: InputMaybe<Scalars["Time"]["input"]>;
	startTimeLTE?: InputMaybe<Scalars["Time"]["input"]>;
	startTimeNEQ?: InputMaybe<Scalars["Time"]["input"]>;
	startTimeNotIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	titleContains?: InputMaybe<Scalars["String"]["input"]>;
	titleEQ?: InputMaybe<Scalars["String"]["input"]>;
	titleHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	titleHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	titleIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	titleNEQ?: InputMaybe<Scalars["String"]["input"]>;
	titleNotContains?: InputMaybe<Scalars["String"]["input"]>;
	titleNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	titleNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	titleNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
};

export type AnnouncementHistory = Node & {
	__typename?: "AnnouncementHistory";
	authorID: Maybe<Scalars["ID"]["output"]>;
	body: Maybe<Scalars["String"]["output"]>;
	endTime: Maybe<Scalars["Time"]["output"]>;
	historyIsSystem: Scalars["Boolean"]["output"];
	historyTime: Scalars["Time"]["output"];
	historyType: HistoryType;
	historyUserID: Maybe<Scalars["ID"]["output"]>;
	id: Scalars["ID"]["output"];
	originalID: Maybe<Scalars["ID"]["output"]>;
	startTime: Maybe<Scalars["Time"]["output"]>;
	title: Maybe<Scalars["String"]["output"]>;
};

export type AnnouncementHistoryConnection = {
	__typename?: "AnnouncementHistoryConnection";
	edges: Array<AnnouncementHistoryEdge>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"]["output"];
};

export type AnnouncementHistoryEdge = {
	__typename?: "AnnouncementHistoryEdge";
	cursor: Scalars["Cursor"]["output"];
	node: AnnouncementHistory;
};

export type AnnouncementHistoryFilterInput = {
	and?: InputMaybe<Array<AnnouncementHistoryFilterInput>>;
	authorIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	authorIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	authorIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	authorIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	authorIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	bodyContains?: InputMaybe<Scalars["String"]["input"]>;
	bodyEQ?: InputMaybe<Scalars["String"]["input"]>;
	bodyHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	bodyHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	bodyIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	bodyIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	bodyNEQ?: InputMaybe<Scalars["String"]["input"]>;
	bodyNotContains?: InputMaybe<Scalars["String"]["input"]>;
	bodyNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	bodyNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	bodyNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	endTimeEQ?: InputMaybe<Scalars["Time"]["input"]>;
	endTimeGT?: InputMaybe<Scalars["Time"]["input"]>;
	endTimeGTE?: InputMaybe<Scalars["Time"]["input"]>;
	endTimeIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	endTimeIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	endTimeLT?: InputMaybe<Scalars["Time"]["input"]>;
	endTimeLTE?: InputMaybe<Scalars["Time"]["input"]>;
	endTimeNEQ?: InputMaybe<Scalars["Time"]["input"]>;
	endTimeNotIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	historyIsSystemEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyIsSystemNEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyTimeEQ?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeGT?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeGTE?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	historyTimeLT?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeLTE?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeNEQ?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeNotIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	historyTypeEQ?: InputMaybe<HistoryType>;
	historyTypeIn?: InputMaybe<Array<HistoryType>>;
	historyTypeNEQ?: InputMaybe<HistoryType>;
	historyTypeNotIn?: InputMaybe<Array<HistoryType>>;
	historyUserIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	historyUserIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	historyUserIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyUserIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	historyUserIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	not?: InputMaybe<AnnouncementHistoryFilterInput>;
	or?: InputMaybe<Array<AnnouncementHistoryFilterInput>>;
	originalIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	originalIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	originalIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	originalIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	originalIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	search?: InputMaybe<Scalars["String"]["input"]>;
	startTimeEQ?: InputMaybe<Scalars["Time"]["input"]>;
	startTimeGT?: InputMaybe<Scalars["Time"]["input"]>;
	startTimeGTE?: InputMaybe<Scalars["Time"]["input"]>;
	startTimeIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	startTimeIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	startTimeLT?: InputMaybe<Scalars["Time"]["input"]>;
	startTimeLTE?: InputMaybe<Scalars["Time"]["input"]>;
	startTimeNEQ?: InputMaybe<Scalars["Time"]["input"]>;
	startTimeNotIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	titleContains?: InputMaybe<Scalars["String"]["input"]>;
	titleEQ?: InputMaybe<Scalars["String"]["input"]>;
	titleHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	titleHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	titleIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	titleIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	titleNEQ?: InputMaybe<Scalars["String"]["input"]>;
	titleNotContains?: InputMaybe<Scalars["String"]["input"]>;
	titleNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	titleNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	titleNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
};

export type AnnouncementHistoryOrder = {
	direction: OrderDirection;
	field?: InputMaybe<AnnouncementHistoryOrderField>;
};

export enum AnnouncementHistoryOrderField {
	HistoryTime = "HISTORY_TIME",
}

export type AnnouncementInAuthorCreateInput = {
	body: Scalars["String"]["input"];
	endTime?: InputMaybe<Scalars["Time"]["input"]>;
	mediaAttachments?: InputMaybe<Array<MediaAttachmentInAnnouncementCreateInput>>;
	sharingPolicy?: InputMaybe<SharingPolicyInAnnouncementCreateInput>;
	socialReactions?: InputMaybe<Array<SocialReactionInAnnouncementCreateInput>>;
	startTime?: InputMaybe<Scalars["Time"]["input"]>;
	title?: InputMaybe<Scalars["String"]["input"]>;
};

export type AnnouncementInSharingPolicyCreateInput = {
	body: Scalars["String"]["input"];
	endTime?: InputMaybe<Scalars["Time"]["input"]>;
	mediaAttachments?: InputMaybe<Array<MediaAttachmentInAnnouncementCreateInput>>;
	socialReactions?: InputMaybe<Array<SocialReactionInAnnouncementCreateInput>>;
	startTime?: InputMaybe<Scalars["Time"]["input"]>;
	title?: InputMaybe<Scalars["String"]["input"]>;
};

export type AnnouncementOrder = {
	direction: OrderDirection;
	field?: InputMaybe<AnnouncementOrderField>;
};

export enum AnnouncementOrderField {
	StartTime = "START_TIME",
}

export type AnnouncementStatistics = {
	__typename?: "AnnouncementStatistics";
	count: Scalars["Int"]["output"];
	reactions: Scalars["Int"]["output"];
	views: Scalars["Int"]["output"];
};

export type AnnouncementUpdateBulkInput = {
	body?: InputMaybe<Scalars["String"]["input"]>;
	clearEndTime?: InputMaybe<Scalars["Boolean"]["input"]>;
	endTime?: InputMaybe<Scalars["Time"]["input"]>;
	startTime?: InputMaybe<Scalars["Time"]["input"]>;
	title?: InputMaybe<Scalars["String"]["input"]>;
};

export type AnnouncementUpdateInput = {
	body?: InputMaybe<Scalars["String"]["input"]>;
	clearEndTime?: InputMaybe<Scalars["Boolean"]["input"]>;
	endTime?: InputMaybe<Scalars["Time"]["input"]>;
	startTime?: InputMaybe<Scalars["Time"]["input"]>;
	title?: InputMaybe<Scalars["String"]["input"]>;
};

export type CalendarEvent = Node & {
	__typename?: "CalendarEvent";
	allowsResponses: Scalars["Boolean"]["output"];
	author: Maybe<User>;
	authorID: Maybe<Scalars["ID"]["output"]>;
	calendarEventResponses: Array<CalendarEventResponse>;
	createdAt: Scalars["Time"]["output"];
	description: Scalars["String"]["output"];
	endDate: Maybe<Scalars["Time"]["output"]>;
	endTime: Maybe<Scalars["Time"]["output"]>;
	id: Scalars["ID"]["output"];
	imageContentType: Scalars["String"]["output"];
	imageKey: Scalars["String"]["output"];
	imageURL: Scalars["String"]["output"];
	isAllDay: Scalars["Boolean"]["output"];
	isMultiDay: Scalars["Boolean"]["output"];
	location: Scalars["String"]["output"];
	mediaAttachments: Array<MediaAttachment>;
	name: Scalars["String"]["output"];
	sharingPolicy: Maybe<SharingPolicy>;
	startDate: Maybe<Scalars["Time"]["output"]>;
	startTime: Maybe<Scalars["Time"]["output"]>;
};

export type CalendarEventCalendarEventResponsesArgs = {
	filters?: InputMaybe<Array<CalendarEventResponseFilterInput>>;
	order?: InputMaybe<CalendarEventResponseOrder>;
	pagination?: InputMaybe<EdgePagination>;
};

export type CalendarEventMediaAttachmentsArgs = {
	filters?: InputMaybe<Array<MediaAttachmentFilterInput>>;
	order?: InputMaybe<MediaAttachmentOrder>;
	pagination?: InputMaybe<EdgePagination>;
};

export type CalendarEventConnection = {
	__typename?: "CalendarEventConnection";
	edges: Array<CalendarEventEdge>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"]["output"];
};

export type CalendarEventCreateInput = {
	allowsResponses?: InputMaybe<Scalars["Boolean"]["input"]>;
	calendarEventResponses?: InputMaybe<Array<CalendarEventResponseInCalendarEventCreateInput>>;
	description?: InputMaybe<Scalars["String"]["input"]>;
	endDate?: InputMaybe<Scalars["Time"]["input"]>;
	endTime?: InputMaybe<Scalars["Time"]["input"]>;
	imageContentType?: InputMaybe<Scalars["String"]["input"]>;
	imageKey?: InputMaybe<Scalars["String"]["input"]>;
	location?: InputMaybe<Scalars["String"]["input"]>;
	mediaAttachments?: InputMaybe<Array<MediaAttachmentInCalendarEventCreateInput>>;
	name: Scalars["String"]["input"];
	sharingPolicy?: InputMaybe<SharingPolicyInCalendarEventCreateInput>;
	startDate?: InputMaybe<Scalars["Time"]["input"]>;
	startTime?: InputMaybe<Scalars["Time"]["input"]>;
};

export type CalendarEventEdge = {
	__typename?: "CalendarEventEdge";
	cursor: Scalars["Cursor"]["output"];
	node: CalendarEvent;
};

export type CalendarEventFilterInput = {
	allowsResponsesEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	allowsResponsesNEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	and?: InputMaybe<Array<CalendarEventFilterInput>>;
	author?: InputMaybe<Array<UserFilterInput>>;
	authorIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	authorIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	authorIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	authorIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	authorIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	calendarEventResponses?: InputMaybe<Array<CalendarEventResponseFilterInput>>;
	createdAtEQ?: InputMaybe<Scalars["Time"]["input"]>;
	createdAtGT?: InputMaybe<Scalars["Time"]["input"]>;
	createdAtGTE?: InputMaybe<Scalars["Time"]["input"]>;
	createdAtIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	createdAtLT?: InputMaybe<Scalars["Time"]["input"]>;
	createdAtLTE?: InputMaybe<Scalars["Time"]["input"]>;
	createdAtNEQ?: InputMaybe<Scalars["Time"]["input"]>;
	createdAtNotIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	descriptionContains?: InputMaybe<Scalars["String"]["input"]>;
	descriptionEQ?: InputMaybe<Scalars["String"]["input"]>;
	descriptionHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	descriptionHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	descriptionIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	descriptionNEQ?: InputMaybe<Scalars["String"]["input"]>;
	descriptionNotContains?: InputMaybe<Scalars["String"]["input"]>;
	descriptionNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	descriptionNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	descriptionNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	endDateEQ?: InputMaybe<Scalars["Time"]["input"]>;
	endDateGT?: InputMaybe<Scalars["Time"]["input"]>;
	endDateGTE?: InputMaybe<Scalars["Time"]["input"]>;
	endDateIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	endDateIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	endDateLT?: InputMaybe<Scalars["Time"]["input"]>;
	endDateLTE?: InputMaybe<Scalars["Time"]["input"]>;
	endDateNEQ?: InputMaybe<Scalars["Time"]["input"]>;
	endDateNotIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	endTimeEQ?: InputMaybe<Scalars["Time"]["input"]>;
	endTimeGT?: InputMaybe<Scalars["Time"]["input"]>;
	endTimeGTE?: InputMaybe<Scalars["Time"]["input"]>;
	endTimeIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	endTimeIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	endTimeLT?: InputMaybe<Scalars["Time"]["input"]>;
	endTimeLTE?: InputMaybe<Scalars["Time"]["input"]>;
	endTimeNEQ?: InputMaybe<Scalars["Time"]["input"]>;
	endTimeNotIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	hasAuthor?: InputMaybe<Scalars["Boolean"]["input"]>;
	hasCalendarEventResponses?: InputMaybe<Scalars["Boolean"]["input"]>;
	hasMediaAttachments?: InputMaybe<Scalars["Boolean"]["input"]>;
	hasSharingPolicy?: InputMaybe<Scalars["Boolean"]["input"]>;
	idEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	imageContentTypeContains?: InputMaybe<Scalars["String"]["input"]>;
	imageContentTypeEQ?: InputMaybe<Scalars["String"]["input"]>;
	imageContentTypeHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	imageContentTypeHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	imageContentTypeIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	imageContentTypeNEQ?: InputMaybe<Scalars["String"]["input"]>;
	imageContentTypeNotContains?: InputMaybe<Scalars["String"]["input"]>;
	imageContentTypeNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	imageContentTypeNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	imageContentTypeNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	imageKeyContains?: InputMaybe<Scalars["String"]["input"]>;
	imageKeyEQ?: InputMaybe<Scalars["String"]["input"]>;
	imageKeyHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	imageKeyHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	imageKeyIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	imageKeyNEQ?: InputMaybe<Scalars["String"]["input"]>;
	imageKeyNotContains?: InputMaybe<Scalars["String"]["input"]>;
	imageKeyNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	imageKeyNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	imageKeyNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	locationContains?: InputMaybe<Scalars["String"]["input"]>;
	locationEQ?: InputMaybe<Scalars["String"]["input"]>;
	locationHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	locationHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	locationIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	locationNEQ?: InputMaybe<Scalars["String"]["input"]>;
	locationNotContains?: InputMaybe<Scalars["String"]["input"]>;
	locationNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	locationNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	locationNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	mediaAttachments?: InputMaybe<Array<MediaAttachmentFilterInput>>;
	nameContains?: InputMaybe<Scalars["String"]["input"]>;
	nameEQ?: InputMaybe<Scalars["String"]["input"]>;
	nameHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	nameHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	nameIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	nameNEQ?: InputMaybe<Scalars["String"]["input"]>;
	nameNotContains?: InputMaybe<Scalars["String"]["input"]>;
	nameNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	nameNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	nameNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	not?: InputMaybe<CalendarEventFilterInput>;
	or?: InputMaybe<Array<CalendarEventFilterInput>>;
	search?: InputMaybe<Scalars["String"]["input"]>;
	sharingPolicy?: InputMaybe<Array<SharingPolicyFilterInput>>;
	startDateEQ?: InputMaybe<Scalars["Time"]["input"]>;
	startDateGT?: InputMaybe<Scalars["Time"]["input"]>;
	startDateGTE?: InputMaybe<Scalars["Time"]["input"]>;
	startDateIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	startDateIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	startDateLT?: InputMaybe<Scalars["Time"]["input"]>;
	startDateLTE?: InputMaybe<Scalars["Time"]["input"]>;
	startDateNEQ?: InputMaybe<Scalars["Time"]["input"]>;
	startDateNotIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	startTimeEQ?: InputMaybe<Scalars["Time"]["input"]>;
	startTimeGT?: InputMaybe<Scalars["Time"]["input"]>;
	startTimeGTE?: InputMaybe<Scalars["Time"]["input"]>;
	startTimeIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	startTimeIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	startTimeLT?: InputMaybe<Scalars["Time"]["input"]>;
	startTimeLTE?: InputMaybe<Scalars["Time"]["input"]>;
	startTimeNEQ?: InputMaybe<Scalars["Time"]["input"]>;
	startTimeNotIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
};

export type CalendarEventHistory = Node & {
	__typename?: "CalendarEventHistory";
	allowsResponses: Maybe<Scalars["Boolean"]["output"]>;
	authorID: Maybe<Scalars["ID"]["output"]>;
	createdAt: Maybe<Scalars["Time"]["output"]>;
	description: Maybe<Scalars["String"]["output"]>;
	endDate: Maybe<Scalars["Time"]["output"]>;
	endTime: Maybe<Scalars["Time"]["output"]>;
	historyIsSystem: Scalars["Boolean"]["output"];
	historyTime: Scalars["Time"]["output"];
	historyType: HistoryType;
	historyUserID: Maybe<Scalars["ID"]["output"]>;
	id: Scalars["ID"]["output"];
	imageContentType: Maybe<Scalars["String"]["output"]>;
	imageKey: Maybe<Scalars["String"]["output"]>;
	location: Maybe<Scalars["String"]["output"]>;
	name: Maybe<Scalars["String"]["output"]>;
	originalID: Maybe<Scalars["ID"]["output"]>;
	startDate: Maybe<Scalars["Time"]["output"]>;
	startTime: Maybe<Scalars["Time"]["output"]>;
};

export type CalendarEventHistoryConnection = {
	__typename?: "CalendarEventHistoryConnection";
	edges: Array<CalendarEventHistoryEdge>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"]["output"];
};

export type CalendarEventHistoryEdge = {
	__typename?: "CalendarEventHistoryEdge";
	cursor: Scalars["Cursor"]["output"];
	node: CalendarEventHistory;
};

export type CalendarEventHistoryFilterInput = {
	allowsResponsesEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	allowsResponsesIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	allowsResponsesNEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	and?: InputMaybe<Array<CalendarEventHistoryFilterInput>>;
	authorIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	authorIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	authorIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	authorIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	authorIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	createdAtEQ?: InputMaybe<Scalars["Time"]["input"]>;
	createdAtGT?: InputMaybe<Scalars["Time"]["input"]>;
	createdAtGTE?: InputMaybe<Scalars["Time"]["input"]>;
	createdAtIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	createdAtIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	createdAtLT?: InputMaybe<Scalars["Time"]["input"]>;
	createdAtLTE?: InputMaybe<Scalars["Time"]["input"]>;
	createdAtNEQ?: InputMaybe<Scalars["Time"]["input"]>;
	createdAtNotIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	descriptionContains?: InputMaybe<Scalars["String"]["input"]>;
	descriptionEQ?: InputMaybe<Scalars["String"]["input"]>;
	descriptionHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	descriptionHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	descriptionIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	descriptionIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	descriptionNEQ?: InputMaybe<Scalars["String"]["input"]>;
	descriptionNotContains?: InputMaybe<Scalars["String"]["input"]>;
	descriptionNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	descriptionNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	descriptionNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	endDateEQ?: InputMaybe<Scalars["Time"]["input"]>;
	endDateGT?: InputMaybe<Scalars["Time"]["input"]>;
	endDateGTE?: InputMaybe<Scalars["Time"]["input"]>;
	endDateIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	endDateIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	endDateLT?: InputMaybe<Scalars["Time"]["input"]>;
	endDateLTE?: InputMaybe<Scalars["Time"]["input"]>;
	endDateNEQ?: InputMaybe<Scalars["Time"]["input"]>;
	endDateNotIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	endTimeEQ?: InputMaybe<Scalars["Time"]["input"]>;
	endTimeGT?: InputMaybe<Scalars["Time"]["input"]>;
	endTimeGTE?: InputMaybe<Scalars["Time"]["input"]>;
	endTimeIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	endTimeIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	endTimeLT?: InputMaybe<Scalars["Time"]["input"]>;
	endTimeLTE?: InputMaybe<Scalars["Time"]["input"]>;
	endTimeNEQ?: InputMaybe<Scalars["Time"]["input"]>;
	endTimeNotIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	historyIsSystemEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyIsSystemNEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyTimeEQ?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeGT?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeGTE?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	historyTimeLT?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeLTE?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeNEQ?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeNotIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	historyTypeEQ?: InputMaybe<HistoryType>;
	historyTypeIn?: InputMaybe<Array<HistoryType>>;
	historyTypeNEQ?: InputMaybe<HistoryType>;
	historyTypeNotIn?: InputMaybe<Array<HistoryType>>;
	historyUserIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	historyUserIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	historyUserIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyUserIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	historyUserIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	imageContentTypeContains?: InputMaybe<Scalars["String"]["input"]>;
	imageContentTypeEQ?: InputMaybe<Scalars["String"]["input"]>;
	imageContentTypeHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	imageContentTypeHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	imageContentTypeIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	imageContentTypeIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	imageContentTypeNEQ?: InputMaybe<Scalars["String"]["input"]>;
	imageContentTypeNotContains?: InputMaybe<Scalars["String"]["input"]>;
	imageContentTypeNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	imageContentTypeNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	imageContentTypeNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	imageKeyContains?: InputMaybe<Scalars["String"]["input"]>;
	imageKeyEQ?: InputMaybe<Scalars["String"]["input"]>;
	imageKeyHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	imageKeyHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	imageKeyIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	imageKeyIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	imageKeyNEQ?: InputMaybe<Scalars["String"]["input"]>;
	imageKeyNotContains?: InputMaybe<Scalars["String"]["input"]>;
	imageKeyNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	imageKeyNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	imageKeyNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	locationContains?: InputMaybe<Scalars["String"]["input"]>;
	locationEQ?: InputMaybe<Scalars["String"]["input"]>;
	locationHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	locationHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	locationIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	locationIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	locationNEQ?: InputMaybe<Scalars["String"]["input"]>;
	locationNotContains?: InputMaybe<Scalars["String"]["input"]>;
	locationNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	locationNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	locationNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	nameContains?: InputMaybe<Scalars["String"]["input"]>;
	nameEQ?: InputMaybe<Scalars["String"]["input"]>;
	nameHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	nameHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	nameIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	nameIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	nameNEQ?: InputMaybe<Scalars["String"]["input"]>;
	nameNotContains?: InputMaybe<Scalars["String"]["input"]>;
	nameNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	nameNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	nameNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	not?: InputMaybe<CalendarEventHistoryFilterInput>;
	or?: InputMaybe<Array<CalendarEventHistoryFilterInput>>;
	originalIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	originalIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	originalIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	originalIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	originalIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	search?: InputMaybe<Scalars["String"]["input"]>;
	startDateEQ?: InputMaybe<Scalars["Time"]["input"]>;
	startDateGT?: InputMaybe<Scalars["Time"]["input"]>;
	startDateGTE?: InputMaybe<Scalars["Time"]["input"]>;
	startDateIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	startDateIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	startDateLT?: InputMaybe<Scalars["Time"]["input"]>;
	startDateLTE?: InputMaybe<Scalars["Time"]["input"]>;
	startDateNEQ?: InputMaybe<Scalars["Time"]["input"]>;
	startDateNotIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	startTimeEQ?: InputMaybe<Scalars["Time"]["input"]>;
	startTimeGT?: InputMaybe<Scalars["Time"]["input"]>;
	startTimeGTE?: InputMaybe<Scalars["Time"]["input"]>;
	startTimeIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	startTimeIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	startTimeLT?: InputMaybe<Scalars["Time"]["input"]>;
	startTimeLTE?: InputMaybe<Scalars["Time"]["input"]>;
	startTimeNEQ?: InputMaybe<Scalars["Time"]["input"]>;
	startTimeNotIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
};

export type CalendarEventHistoryOrder = {
	direction: OrderDirection;
	field?: InputMaybe<CalendarEventHistoryOrderField>;
};

export enum CalendarEventHistoryOrderField {
	HistoryTime = "HISTORY_TIME",
}

export type CalendarEventInAuthorCreateInput = {
	allowsResponses?: InputMaybe<Scalars["Boolean"]["input"]>;
	calendarEventResponses?: InputMaybe<Array<CalendarEventResponseInCalendarEventCreateInput>>;
	description?: InputMaybe<Scalars["String"]["input"]>;
	endDate?: InputMaybe<Scalars["Time"]["input"]>;
	endTime?: InputMaybe<Scalars["Time"]["input"]>;
	imageContentType?: InputMaybe<Scalars["String"]["input"]>;
	imageKey?: InputMaybe<Scalars["String"]["input"]>;
	location?: InputMaybe<Scalars["String"]["input"]>;
	mediaAttachments?: InputMaybe<Array<MediaAttachmentInCalendarEventCreateInput>>;
	name: Scalars["String"]["input"];
	sharingPolicy?: InputMaybe<SharingPolicyInCalendarEventCreateInput>;
	startDate?: InputMaybe<Scalars["Time"]["input"]>;
	startTime?: InputMaybe<Scalars["Time"]["input"]>;
};

export type CalendarEventInSharingPolicyCreateInput = {
	allowsResponses?: InputMaybe<Scalars["Boolean"]["input"]>;
	calendarEventResponses?: InputMaybe<Array<CalendarEventResponseInCalendarEventCreateInput>>;
	description?: InputMaybe<Scalars["String"]["input"]>;
	endDate?: InputMaybe<Scalars["Time"]["input"]>;
	endTime?: InputMaybe<Scalars["Time"]["input"]>;
	imageContentType?: InputMaybe<Scalars["String"]["input"]>;
	imageKey?: InputMaybe<Scalars["String"]["input"]>;
	location?: InputMaybe<Scalars["String"]["input"]>;
	mediaAttachments?: InputMaybe<Array<MediaAttachmentInCalendarEventCreateInput>>;
	name: Scalars["String"]["input"];
	startDate?: InputMaybe<Scalars["Time"]["input"]>;
	startTime?: InputMaybe<Scalars["Time"]["input"]>;
};

export type CalendarEventOrder = {
	direction: OrderDirection;
	field?: InputMaybe<CalendarEventOrderField>;
};

export enum CalendarEventOrderField {
	CreatedAt = "CREATED_AT",
	EndDate = "END_DATE",
	EndTime = "END_TIME",
	Name = "NAME",
	StartDate = "START_DATE",
	StartTime = "START_TIME",
}

export type CalendarEventResponse = Node & {
	__typename?: "CalendarEventResponse";
	author: Maybe<User>;
	authorID: Maybe<Scalars["ID"]["output"]>;
	calendarEvent: CalendarEvent;
	calendarEventID: Scalars["ID"]["output"];
	id: Scalars["ID"]["output"];
	response: CalendarEventResponseResponse;
};

export type CalendarEventResponseConnection = {
	__typename?: "CalendarEventResponseConnection";
	edges: Array<CalendarEventResponseEdge>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"]["output"];
};

export type CalendarEventResponseCreateInput = {
	calendarEventID: Scalars["ID"]["input"];
	response: CalendarEventResponseResponse;
};

export type CalendarEventResponseEdge = {
	__typename?: "CalendarEventResponseEdge";
	cursor: Scalars["Cursor"]["output"];
	node: CalendarEventResponse;
};

export type CalendarEventResponseFilterInput = {
	and?: InputMaybe<Array<CalendarEventResponseFilterInput>>;
	author?: InputMaybe<Array<UserFilterInput>>;
	authorIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	authorIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	authorIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	authorIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	authorIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	calendarEvent?: InputMaybe<Array<CalendarEventFilterInput>>;
	calendarEventIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	calendarEventIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	calendarEventIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	calendarEventIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	hasAuthor?: InputMaybe<Scalars["Boolean"]["input"]>;
	idEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	not?: InputMaybe<CalendarEventResponseFilterInput>;
	or?: InputMaybe<Array<CalendarEventResponseFilterInput>>;
	responseEQ?: InputMaybe<CalendarEventResponseResponse>;
	responseIn?: InputMaybe<Array<CalendarEventResponseResponse>>;
	responseNEQ?: InputMaybe<CalendarEventResponseResponse>;
	responseNotIn?: InputMaybe<Array<CalendarEventResponseResponse>>;
};

export type CalendarEventResponseHistory = Node & {
	__typename?: "CalendarEventResponseHistory";
	authorID: Maybe<Scalars["ID"]["output"]>;
	calendarEventID: Maybe<Scalars["ID"]["output"]>;
	historyIsSystem: Scalars["Boolean"]["output"];
	historyTime: Scalars["Time"]["output"];
	historyType: HistoryType;
	historyUserID: Maybe<Scalars["ID"]["output"]>;
	id: Scalars["ID"]["output"];
	originalID: Maybe<Scalars["ID"]["output"]>;
	response: Maybe<CalendarEventResponseHistoryResponse>;
};

export type CalendarEventResponseHistoryConnection = {
	__typename?: "CalendarEventResponseHistoryConnection";
	edges: Array<CalendarEventResponseHistoryEdge>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"]["output"];
};

export type CalendarEventResponseHistoryEdge = {
	__typename?: "CalendarEventResponseHistoryEdge";
	cursor: Scalars["Cursor"]["output"];
	node: CalendarEventResponseHistory;
};

export type CalendarEventResponseHistoryFilterInput = {
	and?: InputMaybe<Array<CalendarEventResponseHistoryFilterInput>>;
	authorIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	authorIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	authorIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	authorIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	authorIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	calendarEventIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	calendarEventIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	calendarEventIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	calendarEventIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	calendarEventIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	historyIsSystemEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyIsSystemNEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyTimeEQ?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeGT?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeGTE?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	historyTimeLT?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeLTE?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeNEQ?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeNotIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	historyTypeEQ?: InputMaybe<HistoryType>;
	historyTypeIn?: InputMaybe<Array<HistoryType>>;
	historyTypeNEQ?: InputMaybe<HistoryType>;
	historyTypeNotIn?: InputMaybe<Array<HistoryType>>;
	historyUserIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	historyUserIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	historyUserIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyUserIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	historyUserIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	not?: InputMaybe<CalendarEventResponseHistoryFilterInput>;
	or?: InputMaybe<Array<CalendarEventResponseHistoryFilterInput>>;
	originalIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	originalIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	originalIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	originalIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	originalIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	responseEQ?: InputMaybe<CalendarEventResponseHistoryResponse>;
	responseIn?: InputMaybe<Array<CalendarEventResponseHistoryResponse>>;
	responseIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	responseNEQ?: InputMaybe<CalendarEventResponseHistoryResponse>;
	responseNotIn?: InputMaybe<Array<CalendarEventResponseHistoryResponse>>;
};

export type CalendarEventResponseHistoryOrder = {
	direction: OrderDirection;
	field?: InputMaybe<CalendarEventResponseHistoryOrderField>;
};

export enum CalendarEventResponseHistoryOrderField {
	HistoryTime = "HISTORY_TIME",
}

export enum CalendarEventResponseHistoryResponse {
	Attending = "attending",
	MaybeAttending = "maybe_attending",
	NotAttending = "not_attending",
}

export type CalendarEventResponseInAuthorCreateInput = {
	calendarEventID: Scalars["ID"]["input"];
	response: CalendarEventResponseResponse;
};

export type CalendarEventResponseInCalendarEventCreateInput = {
	response: CalendarEventResponseResponse;
};

export type CalendarEventResponseOrder = {
	direction: OrderDirection;
	field?: InputMaybe<CalendarEventResponseOrderField>;
};

export enum CalendarEventResponseOrderField {
	Response = "RESPONSE",
}

export enum CalendarEventResponseResponse {
	Attending = "attending",
	MaybeAttending = "maybe_attending",
	NotAttending = "not_attending",
}

export type CalendarEventResponseUpdateBulkInput = {
	response?: InputMaybe<CalendarEventResponseResponse>;
};

export type CalendarEventResponseUpdateInput = {
	response?: InputMaybe<CalendarEventResponseResponse>;
};

export type CalendarEventStatistics = {
	__typename?: "CalendarEventStatistics";
	count: Scalars["Int"]["output"];
	responsesAttending: Scalars["Int"]["output"];
	responsesMaybeAttending: Scalars["Int"]["output"];
	responsesNotAttending: Scalars["Int"]["output"];
};

export type CalendarEventUpdateBulkInput = {
	allowsResponses?: InputMaybe<Scalars["Boolean"]["input"]>;
	clearEndDate?: InputMaybe<Scalars["Boolean"]["input"]>;
	clearEndTime?: InputMaybe<Scalars["Boolean"]["input"]>;
	clearStartDate?: InputMaybe<Scalars["Boolean"]["input"]>;
	clearStartTime?: InputMaybe<Scalars["Boolean"]["input"]>;
	description?: InputMaybe<Scalars["String"]["input"]>;
	endDate?: InputMaybe<Scalars["Time"]["input"]>;
	endTime?: InputMaybe<Scalars["Time"]["input"]>;
	imageContentType?: InputMaybe<Scalars["String"]["input"]>;
	imageKey?: InputMaybe<Scalars["String"]["input"]>;
	location?: InputMaybe<Scalars["String"]["input"]>;
	name?: InputMaybe<Scalars["String"]["input"]>;
	startDate?: InputMaybe<Scalars["Time"]["input"]>;
	startTime?: InputMaybe<Scalars["Time"]["input"]>;
};

export type CalendarEventUpdateInput = {
	allowsResponses?: InputMaybe<Scalars["Boolean"]["input"]>;
	clearEndDate?: InputMaybe<Scalars["Boolean"]["input"]>;
	clearEndTime?: InputMaybe<Scalars["Boolean"]["input"]>;
	clearStartDate?: InputMaybe<Scalars["Boolean"]["input"]>;
	clearStartTime?: InputMaybe<Scalars["Boolean"]["input"]>;
	description?: InputMaybe<Scalars["String"]["input"]>;
	endDate?: InputMaybe<Scalars["Time"]["input"]>;
	endTime?: InputMaybe<Scalars["Time"]["input"]>;
	imageContentType?: InputMaybe<Scalars["String"]["input"]>;
	imageKey?: InputMaybe<Scalars["String"]["input"]>;
	location?: InputMaybe<Scalars["String"]["input"]>;
	name?: InputMaybe<Scalars["String"]["input"]>;
	startDate?: InputMaybe<Scalars["Time"]["input"]>;
	startTime?: InputMaybe<Scalars["Time"]["input"]>;
};

export type DeleteBulkResponse = {
	__typename?: "DeleteBulkResponse";
	ids: Array<Scalars["Int"]["output"]>;
	totalCount: Scalars["Int"]["output"];
};

export type EdgePagination = {
	first?: InputMaybe<Scalars["Int"]["input"]>;
};

export enum HistoryType {
	Create = "create",
	Delete = "delete",
	Update = "update",
}

export type LoginRecord = Node & {
	__typename?: "LoginRecord";
	createdAt: Scalars["Time"]["output"];
	id: Scalars["ID"]["output"];
	isTrusted: Scalars["Boolean"]["output"];
	session: Maybe<Session>;
	sessionID: Maybe<Scalars["ID"]["output"]>;
	user: Maybe<User>;
	userEmail: Scalars["String"]["output"];
	userID: Maybe<Scalars["ID"]["output"]>;
	wasBlocked: Scalars["Boolean"]["output"];
	wasSuccessful: Scalars["Boolean"]["output"];
};

export type LoginRecordConnection = {
	__typename?: "LoginRecordConnection";
	edges: Array<LoginRecordEdge>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"]["output"];
};

export type LoginRecordEdge = {
	__typename?: "LoginRecordEdge";
	cursor: Scalars["Cursor"]["output"];
	node: LoginRecord;
};

export type LoginRecordFilterInput = {
	and?: InputMaybe<Array<LoginRecordFilterInput>>;
	createdAtEQ?: InputMaybe<Scalars["Time"]["input"]>;
	createdAtGT?: InputMaybe<Scalars["Time"]["input"]>;
	createdAtGTE?: InputMaybe<Scalars["Time"]["input"]>;
	createdAtIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	createdAtLT?: InputMaybe<Scalars["Time"]["input"]>;
	createdAtLTE?: InputMaybe<Scalars["Time"]["input"]>;
	createdAtNEQ?: InputMaybe<Scalars["Time"]["input"]>;
	createdAtNotIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	hasSession?: InputMaybe<Scalars["Boolean"]["input"]>;
	hasUser?: InputMaybe<Scalars["Boolean"]["input"]>;
	idEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	isTrustedEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	isTrustedNEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	not?: InputMaybe<LoginRecordFilterInput>;
	or?: InputMaybe<Array<LoginRecordFilterInput>>;
	search?: InputMaybe<Scalars["String"]["input"]>;
	session?: InputMaybe<Array<SessionFilterInput>>;
	sessionIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	sessionIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	sessionIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	sessionIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	sessionIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	user?: InputMaybe<Array<UserFilterInput>>;
	userEmailContains?: InputMaybe<Scalars["String"]["input"]>;
	userEmailEQ?: InputMaybe<Scalars["String"]["input"]>;
	userEmailHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	userEmailHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	userEmailIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	userEmailNEQ?: InputMaybe<Scalars["String"]["input"]>;
	userEmailNotContains?: InputMaybe<Scalars["String"]["input"]>;
	userEmailNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	userEmailNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	userEmailNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	userIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	userIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	userIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	userIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	userIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	wasBlockedEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	wasBlockedNEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	wasSuccessfulEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	wasSuccessfulNEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type LoginRecordOrder = {
	direction: OrderDirection;
	field?: InputMaybe<LoginRecordOrderField>;
};

export enum LoginRecordOrderField {
	CreatedAt = "CREATED_AT",
	UserEmail = "USER_EMAIL",
}

export type MFAFactor = Node & {
	__typename?: "MFAFactor";
	count: Scalars["Int"]["output"];
	createdAt: Scalars["Time"]["output"];
	email: Scalars["String"]["output"];
	id: Scalars["ID"]["output"];
	isApp: Scalars["Boolean"]["output"];
	isVerified: Scalars["Boolean"]["output"];
	sms: Scalars["String"]["output"];
	user: User;
	userID: Scalars["ID"]["output"];
};

export type MFAFactorConnection = {
	__typename?: "MFAFactorConnection";
	edges: Array<MFAFactorEdge>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"]["output"];
};

export type MFAFactorEdge = {
	__typename?: "MFAFactorEdge";
	cursor: Scalars["Cursor"]["output"];
	node: MFAFactor;
};

export type MFAFactorFilterInput = {
	and?: InputMaybe<Array<MFAFactorFilterInput>>;
	countEQ?: InputMaybe<Scalars["Int"]["input"]>;
	countGT?: InputMaybe<Scalars["Int"]["input"]>;
	countGTE?: InputMaybe<Scalars["Int"]["input"]>;
	countIn?: InputMaybe<Array<Scalars["Int"]["input"]>>;
	countLT?: InputMaybe<Scalars["Int"]["input"]>;
	countLTE?: InputMaybe<Scalars["Int"]["input"]>;
	countNEQ?: InputMaybe<Scalars["Int"]["input"]>;
	countNotIn?: InputMaybe<Array<Scalars["Int"]["input"]>>;
	createdAtEQ?: InputMaybe<Scalars["Time"]["input"]>;
	createdAtGT?: InputMaybe<Scalars["Time"]["input"]>;
	createdAtGTE?: InputMaybe<Scalars["Time"]["input"]>;
	createdAtIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	createdAtLT?: InputMaybe<Scalars["Time"]["input"]>;
	createdAtLTE?: InputMaybe<Scalars["Time"]["input"]>;
	createdAtNEQ?: InputMaybe<Scalars["Time"]["input"]>;
	createdAtNotIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	emailContains?: InputMaybe<Scalars["String"]["input"]>;
	emailEQ?: InputMaybe<Scalars["String"]["input"]>;
	emailHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	emailHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	emailIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	emailNEQ?: InputMaybe<Scalars["String"]["input"]>;
	emailNotContains?: InputMaybe<Scalars["String"]["input"]>;
	emailNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	emailNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	emailNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	idEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	isAppEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	isAppNEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	isVerifiedEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	isVerifiedNEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	not?: InputMaybe<MFAFactorFilterInput>;
	or?: InputMaybe<Array<MFAFactorFilterInput>>;
	search?: InputMaybe<Scalars["String"]["input"]>;
	smsContains?: InputMaybe<Scalars["String"]["input"]>;
	smsEQ?: InputMaybe<Scalars["String"]["input"]>;
	smsHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	smsHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	smsIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	smsNEQ?: InputMaybe<Scalars["String"]["input"]>;
	smsNotContains?: InputMaybe<Scalars["String"]["input"]>;
	smsNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	smsNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	smsNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	user?: InputMaybe<Array<UserFilterInput>>;
	userIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	userIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	userIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	userIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
};

export type MFAFactorOrder = {
	direction: OrderDirection;
	field?: InputMaybe<MFAFactorOrderField>;
};

export enum MFAFactorOrderField {
	CreatedAt = "CREATED_AT",
}

export type MFAInvalidOTPAttempt = Node & {
	__typename?: "MFAInvalidOTPAttempt";
	createdAt: Scalars["Time"]["output"];
	id: Scalars["ID"]["output"];
	session: Maybe<Session>;
	sessionID: Maybe<Scalars["ID"]["output"]>;
	user: User;
	userID: Scalars["ID"]["output"];
};

export type MFAInvalidOTPAttemptConnection = {
	__typename?: "MFAInvalidOTPAttemptConnection";
	edges: Array<MFAInvalidOTPAttemptEdge>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"]["output"];
};

export type MFAInvalidOTPAttemptEdge = {
	__typename?: "MFAInvalidOTPAttemptEdge";
	cursor: Scalars["Cursor"]["output"];
	node: MFAInvalidOTPAttempt;
};

export type MFAInvalidOTPAttemptFilterInput = {
	and?: InputMaybe<Array<MFAInvalidOTPAttemptFilterInput>>;
	createdAtEQ?: InputMaybe<Scalars["Time"]["input"]>;
	createdAtGT?: InputMaybe<Scalars["Time"]["input"]>;
	createdAtGTE?: InputMaybe<Scalars["Time"]["input"]>;
	createdAtIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	createdAtLT?: InputMaybe<Scalars["Time"]["input"]>;
	createdAtLTE?: InputMaybe<Scalars["Time"]["input"]>;
	createdAtNEQ?: InputMaybe<Scalars["Time"]["input"]>;
	createdAtNotIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	hasSession?: InputMaybe<Scalars["Boolean"]["input"]>;
	idEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	not?: InputMaybe<MFAInvalidOTPAttemptFilterInput>;
	or?: InputMaybe<Array<MFAInvalidOTPAttemptFilterInput>>;
	session?: InputMaybe<Array<SessionFilterInput>>;
	sessionIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	sessionIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	sessionIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	sessionIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	sessionIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	user?: InputMaybe<Array<UserFilterInput>>;
	userIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	userIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	userIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	userIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
};

export type MFAInvalidOTPAttemptOrder = {
	direction: OrderDirection;
	field?: InputMaybe<MFAInvalidOTPAttemptOrderField>;
};

export enum MFAInvalidOTPAttemptOrderField {
	CreatedAt = "CREATED_AT",
}

export type MediaAttachment = Node & {
	__typename?: "MediaAttachment";
	announcement: Maybe<Announcement>;
	announcementID: Maybe<Scalars["ID"]["output"]>;
	calendarEvent: Maybe<CalendarEvent>;
	calendarEventID: Maybe<Scalars["ID"]["output"]>;
	description: Scalars["String"]["output"];
	displayOrder: Scalars["Int"]["output"];
	fileContentType: Scalars["String"]["output"];
	fileKey: Scalars["String"]["output"];
	fileURL: Scalars["String"]["output"];
	id: Scalars["ID"]["output"];
	isFile: Scalars["Boolean"]["output"];
	linkURL: Scalars["String"]["output"];
	message: Maybe<Message>;
	messageID: Maybe<Scalars["ID"]["output"]>;
	post: Maybe<Post>;
	postID: Maybe<Scalars["ID"]["output"]>;
	socialComments: Array<SocialComment>;
	socialReactions: Array<SocialReaction>;
	title: Scalars["String"]["output"];
};

export type MediaAttachmentSocialCommentsArgs = {
	filters?: InputMaybe<Array<SocialCommentFilterInput>>;
	order?: InputMaybe<SocialCommentOrder>;
	pagination?: InputMaybe<EdgePagination>;
};

export type MediaAttachmentSocialReactionsArgs = {
	filters?: InputMaybe<Array<SocialReactionFilterInput>>;
	order?: InputMaybe<SocialReactionOrder>;
	pagination?: InputMaybe<EdgePagination>;
};

export type MediaAttachmentConnection = {
	__typename?: "MediaAttachmentConnection";
	edges: Array<MediaAttachmentEdge>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"]["output"];
};

export type MediaAttachmentCreateInput = {
	announcementID?: InputMaybe<Scalars["ID"]["input"]>;
	calendarEventID?: InputMaybe<Scalars["ID"]["input"]>;
	description?: InputMaybe<Scalars["String"]["input"]>;
	displayOrder?: InputMaybe<Scalars["Int"]["input"]>;
	fileContentType?: InputMaybe<Scalars["String"]["input"]>;
	fileKey?: InputMaybe<Scalars["String"]["input"]>;
	linkURL?: InputMaybe<Scalars["String"]["input"]>;
	messageID?: InputMaybe<Scalars["ID"]["input"]>;
	postID?: InputMaybe<Scalars["ID"]["input"]>;
	socialComments?: InputMaybe<Array<SocialCommentInMediaAttachmentCreateInput>>;
	socialReactions?: InputMaybe<Array<SocialReactionInMediaAttachmentCreateInput>>;
	title?: InputMaybe<Scalars["String"]["input"]>;
};

export type MediaAttachmentEdge = {
	__typename?: "MediaAttachmentEdge";
	cursor: Scalars["Cursor"]["output"];
	node: MediaAttachment;
};

export type MediaAttachmentFilterInput = {
	and?: InputMaybe<Array<MediaAttachmentFilterInput>>;
	announcement?: InputMaybe<Array<AnnouncementFilterInput>>;
	announcementIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	announcementIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	announcementIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	announcementIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	announcementIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	calendarEvent?: InputMaybe<Array<CalendarEventFilterInput>>;
	calendarEventIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	calendarEventIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	calendarEventIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	calendarEventIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	calendarEventIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	descriptionContains?: InputMaybe<Scalars["String"]["input"]>;
	descriptionEQ?: InputMaybe<Scalars["String"]["input"]>;
	descriptionHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	descriptionHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	descriptionIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	descriptionNEQ?: InputMaybe<Scalars["String"]["input"]>;
	descriptionNotContains?: InputMaybe<Scalars["String"]["input"]>;
	descriptionNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	descriptionNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	descriptionNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	displayOrderEQ?: InputMaybe<Scalars["Int"]["input"]>;
	displayOrderGT?: InputMaybe<Scalars["Int"]["input"]>;
	displayOrderGTE?: InputMaybe<Scalars["Int"]["input"]>;
	displayOrderIn?: InputMaybe<Array<Scalars["Int"]["input"]>>;
	displayOrderLT?: InputMaybe<Scalars["Int"]["input"]>;
	displayOrderLTE?: InputMaybe<Scalars["Int"]["input"]>;
	displayOrderNEQ?: InputMaybe<Scalars["Int"]["input"]>;
	displayOrderNotIn?: InputMaybe<Array<Scalars["Int"]["input"]>>;
	fileContentTypeContains?: InputMaybe<Scalars["String"]["input"]>;
	fileContentTypeEQ?: InputMaybe<Scalars["String"]["input"]>;
	fileContentTypeHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	fileContentTypeHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	fileContentTypeIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	fileContentTypeNEQ?: InputMaybe<Scalars["String"]["input"]>;
	fileContentTypeNotContains?: InputMaybe<Scalars["String"]["input"]>;
	fileContentTypeNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	fileContentTypeNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	fileContentTypeNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	fileKeyContains?: InputMaybe<Scalars["String"]["input"]>;
	fileKeyEQ?: InputMaybe<Scalars["String"]["input"]>;
	fileKeyHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	fileKeyHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	fileKeyIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	fileKeyNEQ?: InputMaybe<Scalars["String"]["input"]>;
	fileKeyNotContains?: InputMaybe<Scalars["String"]["input"]>;
	fileKeyNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	fileKeyNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	fileKeyNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	hasAnnouncement?: InputMaybe<Scalars["Boolean"]["input"]>;
	hasCalendarEvent?: InputMaybe<Scalars["Boolean"]["input"]>;
	hasMessage?: InputMaybe<Scalars["Boolean"]["input"]>;
	hasPost?: InputMaybe<Scalars["Boolean"]["input"]>;
	hasSocialComments?: InputMaybe<Scalars["Boolean"]["input"]>;
	hasSocialReactions?: InputMaybe<Scalars["Boolean"]["input"]>;
	idEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	linkURLContains?: InputMaybe<Scalars["String"]["input"]>;
	linkURLEQ?: InputMaybe<Scalars["String"]["input"]>;
	linkURLHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	linkURLHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	linkURLIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	linkURLNEQ?: InputMaybe<Scalars["String"]["input"]>;
	linkURLNotContains?: InputMaybe<Scalars["String"]["input"]>;
	linkURLNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	linkURLNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	linkURLNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	message?: InputMaybe<Array<MessageFilterInput>>;
	messageIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	messageIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	messageIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	messageIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	messageIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	not?: InputMaybe<MediaAttachmentFilterInput>;
	or?: InputMaybe<Array<MediaAttachmentFilterInput>>;
	post?: InputMaybe<Array<PostFilterInput>>;
	postIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	postIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	postIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	postIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	postIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	search?: InputMaybe<Scalars["String"]["input"]>;
	socialComments?: InputMaybe<Array<SocialCommentFilterInput>>;
	socialReactions?: InputMaybe<Array<SocialReactionFilterInput>>;
	titleContains?: InputMaybe<Scalars["String"]["input"]>;
	titleEQ?: InputMaybe<Scalars["String"]["input"]>;
	titleHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	titleHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	titleIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	titleNEQ?: InputMaybe<Scalars["String"]["input"]>;
	titleNotContains?: InputMaybe<Scalars["String"]["input"]>;
	titleNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	titleNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	titleNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
};

export type MediaAttachmentHistory = Node & {
	__typename?: "MediaAttachmentHistory";
	announcementID: Maybe<Scalars["ID"]["output"]>;
	calendarEventID: Maybe<Scalars["ID"]["output"]>;
	description: Maybe<Scalars["String"]["output"]>;
	displayOrder: Maybe<Scalars["Int"]["output"]>;
	fileContentType: Maybe<Scalars["String"]["output"]>;
	fileKey: Maybe<Scalars["String"]["output"]>;
	historyIsSystem: Scalars["Boolean"]["output"];
	historyTime: Scalars["Time"]["output"];
	historyType: HistoryType;
	historyUserID: Maybe<Scalars["ID"]["output"]>;
	id: Scalars["ID"]["output"];
	linkURL: Maybe<Scalars["String"]["output"]>;
	messageID: Maybe<Scalars["ID"]["output"]>;
	originalID: Maybe<Scalars["ID"]["output"]>;
	postID: Maybe<Scalars["ID"]["output"]>;
	title: Maybe<Scalars["String"]["output"]>;
};

export type MediaAttachmentHistoryConnection = {
	__typename?: "MediaAttachmentHistoryConnection";
	edges: Array<MediaAttachmentHistoryEdge>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"]["output"];
};

export type MediaAttachmentHistoryEdge = {
	__typename?: "MediaAttachmentHistoryEdge";
	cursor: Scalars["Cursor"]["output"];
	node: MediaAttachmentHistory;
};

export type MediaAttachmentHistoryFilterInput = {
	and?: InputMaybe<Array<MediaAttachmentHistoryFilterInput>>;
	announcementIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	announcementIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	announcementIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	announcementIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	announcementIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	calendarEventIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	calendarEventIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	calendarEventIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	calendarEventIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	calendarEventIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	descriptionContains?: InputMaybe<Scalars["String"]["input"]>;
	descriptionEQ?: InputMaybe<Scalars["String"]["input"]>;
	descriptionHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	descriptionHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	descriptionIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	descriptionIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	descriptionNEQ?: InputMaybe<Scalars["String"]["input"]>;
	descriptionNotContains?: InputMaybe<Scalars["String"]["input"]>;
	descriptionNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	descriptionNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	descriptionNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	displayOrderEQ?: InputMaybe<Scalars["Int"]["input"]>;
	displayOrderGT?: InputMaybe<Scalars["Int"]["input"]>;
	displayOrderGTE?: InputMaybe<Scalars["Int"]["input"]>;
	displayOrderIn?: InputMaybe<Array<Scalars["Int"]["input"]>>;
	displayOrderIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	displayOrderLT?: InputMaybe<Scalars["Int"]["input"]>;
	displayOrderLTE?: InputMaybe<Scalars["Int"]["input"]>;
	displayOrderNEQ?: InputMaybe<Scalars["Int"]["input"]>;
	displayOrderNotIn?: InputMaybe<Array<Scalars["Int"]["input"]>>;
	fileContentTypeContains?: InputMaybe<Scalars["String"]["input"]>;
	fileContentTypeEQ?: InputMaybe<Scalars["String"]["input"]>;
	fileContentTypeHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	fileContentTypeHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	fileContentTypeIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	fileContentTypeIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	fileContentTypeNEQ?: InputMaybe<Scalars["String"]["input"]>;
	fileContentTypeNotContains?: InputMaybe<Scalars["String"]["input"]>;
	fileContentTypeNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	fileContentTypeNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	fileContentTypeNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	fileKeyContains?: InputMaybe<Scalars["String"]["input"]>;
	fileKeyEQ?: InputMaybe<Scalars["String"]["input"]>;
	fileKeyHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	fileKeyHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	fileKeyIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	fileKeyIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	fileKeyNEQ?: InputMaybe<Scalars["String"]["input"]>;
	fileKeyNotContains?: InputMaybe<Scalars["String"]["input"]>;
	fileKeyNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	fileKeyNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	fileKeyNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	historyIsSystemEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyIsSystemNEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyTimeEQ?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeGT?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeGTE?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	historyTimeLT?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeLTE?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeNEQ?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeNotIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	historyTypeEQ?: InputMaybe<HistoryType>;
	historyTypeIn?: InputMaybe<Array<HistoryType>>;
	historyTypeNEQ?: InputMaybe<HistoryType>;
	historyTypeNotIn?: InputMaybe<Array<HistoryType>>;
	historyUserIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	historyUserIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	historyUserIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyUserIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	historyUserIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	linkURLContains?: InputMaybe<Scalars["String"]["input"]>;
	linkURLEQ?: InputMaybe<Scalars["String"]["input"]>;
	linkURLHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	linkURLHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	linkURLIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	linkURLIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	linkURLNEQ?: InputMaybe<Scalars["String"]["input"]>;
	linkURLNotContains?: InputMaybe<Scalars["String"]["input"]>;
	linkURLNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	linkURLNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	linkURLNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	messageIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	messageIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	messageIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	messageIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	messageIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	not?: InputMaybe<MediaAttachmentHistoryFilterInput>;
	or?: InputMaybe<Array<MediaAttachmentHistoryFilterInput>>;
	originalIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	originalIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	originalIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	originalIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	originalIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	postIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	postIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	postIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	postIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	postIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	search?: InputMaybe<Scalars["String"]["input"]>;
	titleContains?: InputMaybe<Scalars["String"]["input"]>;
	titleEQ?: InputMaybe<Scalars["String"]["input"]>;
	titleHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	titleHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	titleIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	titleIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	titleNEQ?: InputMaybe<Scalars["String"]["input"]>;
	titleNotContains?: InputMaybe<Scalars["String"]["input"]>;
	titleNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	titleNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	titleNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
};

export type MediaAttachmentHistoryOrder = {
	direction: OrderDirection;
	field?: InputMaybe<MediaAttachmentHistoryOrderField>;
};

export enum MediaAttachmentHistoryOrderField {
	HistoryTime = "HISTORY_TIME",
}

export type MediaAttachmentInAnnouncementCreateInput = {
	calendarEventID?: InputMaybe<Scalars["ID"]["input"]>;
	description?: InputMaybe<Scalars["String"]["input"]>;
	displayOrder?: InputMaybe<Scalars["Int"]["input"]>;
	fileContentType?: InputMaybe<Scalars["String"]["input"]>;
	fileKey?: InputMaybe<Scalars["String"]["input"]>;
	linkURL?: InputMaybe<Scalars["String"]["input"]>;
	messageID?: InputMaybe<Scalars["ID"]["input"]>;
	postID?: InputMaybe<Scalars["ID"]["input"]>;
	socialComments?: InputMaybe<Array<SocialCommentInMediaAttachmentCreateInput>>;
	socialReactions?: InputMaybe<Array<SocialReactionInMediaAttachmentCreateInput>>;
	title?: InputMaybe<Scalars["String"]["input"]>;
};

export type MediaAttachmentInCalendarEventCreateInput = {
	announcementID?: InputMaybe<Scalars["ID"]["input"]>;
	description?: InputMaybe<Scalars["String"]["input"]>;
	displayOrder?: InputMaybe<Scalars["Int"]["input"]>;
	fileContentType?: InputMaybe<Scalars["String"]["input"]>;
	fileKey?: InputMaybe<Scalars["String"]["input"]>;
	linkURL?: InputMaybe<Scalars["String"]["input"]>;
	messageID?: InputMaybe<Scalars["ID"]["input"]>;
	postID?: InputMaybe<Scalars["ID"]["input"]>;
	socialComments?: InputMaybe<Array<SocialCommentInMediaAttachmentCreateInput>>;
	socialReactions?: InputMaybe<Array<SocialReactionInMediaAttachmentCreateInput>>;
	title?: InputMaybe<Scalars["String"]["input"]>;
};

export type MediaAttachmentInMessageCreateInput = {
	announcementID?: InputMaybe<Scalars["ID"]["input"]>;
	calendarEventID?: InputMaybe<Scalars["ID"]["input"]>;
	description?: InputMaybe<Scalars["String"]["input"]>;
	displayOrder?: InputMaybe<Scalars["Int"]["input"]>;
	fileContentType?: InputMaybe<Scalars["String"]["input"]>;
	fileKey?: InputMaybe<Scalars["String"]["input"]>;
	linkURL?: InputMaybe<Scalars["String"]["input"]>;
	postID?: InputMaybe<Scalars["ID"]["input"]>;
	socialComments?: InputMaybe<Array<SocialCommentInMediaAttachmentCreateInput>>;
	socialReactions?: InputMaybe<Array<SocialReactionInMediaAttachmentCreateInput>>;
	title?: InputMaybe<Scalars["String"]["input"]>;
};

export type MediaAttachmentInPostCreateInput = {
	announcementID?: InputMaybe<Scalars["ID"]["input"]>;
	calendarEventID?: InputMaybe<Scalars["ID"]["input"]>;
	description?: InputMaybe<Scalars["String"]["input"]>;
	displayOrder?: InputMaybe<Scalars["Int"]["input"]>;
	fileContentType?: InputMaybe<Scalars["String"]["input"]>;
	fileKey?: InputMaybe<Scalars["String"]["input"]>;
	linkURL?: InputMaybe<Scalars["String"]["input"]>;
	messageID?: InputMaybe<Scalars["ID"]["input"]>;
	socialComments?: InputMaybe<Array<SocialCommentInMediaAttachmentCreateInput>>;
	socialReactions?: InputMaybe<Array<SocialReactionInMediaAttachmentCreateInput>>;
	title?: InputMaybe<Scalars["String"]["input"]>;
};

export type MediaAttachmentOrder = {
	direction: OrderDirection;
	field?: InputMaybe<MediaAttachmentOrderField>;
};

export enum MediaAttachmentOrderField {
	DisplayOrder = "DISPLAY_ORDER",
}

export type MediaAttachmentUpdateBulkInput = {
	description?: InputMaybe<Scalars["String"]["input"]>;
	displayOrder?: InputMaybe<Scalars["Int"]["input"]>;
	fileContentType?: InputMaybe<Scalars["String"]["input"]>;
	fileKey?: InputMaybe<Scalars["String"]["input"]>;
	linkURL?: InputMaybe<Scalars["String"]["input"]>;
	title?: InputMaybe<Scalars["String"]["input"]>;
};

export type MediaAttachmentUpdateInput = {
	description?: InputMaybe<Scalars["String"]["input"]>;
	displayOrder?: InputMaybe<Scalars["Int"]["input"]>;
	fileContentType?: InputMaybe<Scalars["String"]["input"]>;
	fileKey?: InputMaybe<Scalars["String"]["input"]>;
	linkURL?: InputMaybe<Scalars["String"]["input"]>;
	title?: InputMaybe<Scalars["String"]["input"]>;
};

export type Message = Node & {
	__typename?: "Message";
	author: User;
	authorID: Scalars["ID"]["output"];
	body: Scalars["String"]["output"];
	createdAt: Scalars["Time"]["output"];
	id: Scalars["ID"]["output"];
	isRemoved: Scalars["Boolean"]["output"];
	lastEditedAt: Maybe<Scalars["Time"]["output"]>;
	mediaAttachments: Array<MediaAttachment>;
	messageGroup: MessageGroup;
	messageGroupID: Scalars["ID"]["output"];
	messageTopic: Maybe<MessageTopic>;
};

export type MessageMediaAttachmentsArgs = {
	filters?: InputMaybe<Array<MediaAttachmentFilterInput>>;
	order?: InputMaybe<MediaAttachmentOrder>;
	pagination?: InputMaybe<EdgePagination>;
};

export type MessageConnection = {
	__typename?: "MessageConnection";
	edges: Array<MessageEdge>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"]["output"];
};

export type MessageCreateInput = {
	body?: InputMaybe<Scalars["String"]["input"]>;
	mediaAttachments?: InputMaybe<Array<MediaAttachmentInMessageCreateInput>>;
	messageGroupID: Scalars["ID"]["input"];
	messageTopic?: InputMaybe<MessageTopicInMessageCreateInput>;
};

export type MessageEdge = {
	__typename?: "MessageEdge";
	cursor: Scalars["Cursor"]["output"];
	node: Message;
};

export type MessageFilterInput = {
	and?: InputMaybe<Array<MessageFilterInput>>;
	author?: InputMaybe<Array<UserFilterInput>>;
	authorIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	authorIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	authorIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	authorIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	bodyContains?: InputMaybe<Scalars["String"]["input"]>;
	bodyEQ?: InputMaybe<Scalars["String"]["input"]>;
	bodyHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	bodyHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	bodyIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	bodyNEQ?: InputMaybe<Scalars["String"]["input"]>;
	bodyNotContains?: InputMaybe<Scalars["String"]["input"]>;
	bodyNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	bodyNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	bodyNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	createdAtEQ?: InputMaybe<Scalars["Time"]["input"]>;
	createdAtGT?: InputMaybe<Scalars["Time"]["input"]>;
	createdAtGTE?: InputMaybe<Scalars["Time"]["input"]>;
	createdAtIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	createdAtLT?: InputMaybe<Scalars["Time"]["input"]>;
	createdAtLTE?: InputMaybe<Scalars["Time"]["input"]>;
	createdAtNEQ?: InputMaybe<Scalars["Time"]["input"]>;
	createdAtNotIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	hasMediaAttachments?: InputMaybe<Scalars["Boolean"]["input"]>;
	hasMessageTopic?: InputMaybe<Scalars["Boolean"]["input"]>;
	idEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	isRemovedEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	isRemovedNEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	lastEditedAtEQ?: InputMaybe<Scalars["Time"]["input"]>;
	lastEditedAtGT?: InputMaybe<Scalars["Time"]["input"]>;
	lastEditedAtGTE?: InputMaybe<Scalars["Time"]["input"]>;
	lastEditedAtIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	lastEditedAtIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	lastEditedAtLT?: InputMaybe<Scalars["Time"]["input"]>;
	lastEditedAtLTE?: InputMaybe<Scalars["Time"]["input"]>;
	lastEditedAtNEQ?: InputMaybe<Scalars["Time"]["input"]>;
	lastEditedAtNotIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	mediaAttachments?: InputMaybe<Array<MediaAttachmentFilterInput>>;
	messageGroup?: InputMaybe<Array<MessageGroupFilterInput>>;
	messageGroupIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	messageGroupIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	messageGroupIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	messageGroupIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	messageTopic?: InputMaybe<Array<MessageTopicFilterInput>>;
	not?: InputMaybe<MessageFilterInput>;
	or?: InputMaybe<Array<MessageFilterInput>>;
	search?: InputMaybe<Scalars["String"]["input"]>;
};

export type MessageGroup = Node & {
	__typename?: "MessageGroup";
	customName: Scalars["String"]["output"];
	id: Scalars["ID"]["output"];
	isOneOnOne: Scalars["Boolean"]["output"];
	messageGroupArchivePoints: Array<MessageGroupArchivePoint>;
	messages: Array<Message>;
	userGroups: Array<UserGroup>;
	users: Array<User>;
};

export type MessageGroupMessageGroupArchivePointsArgs = {
	filters?: InputMaybe<Array<MessageGroupArchivePointFilterInput>>;
	order?: InputMaybe<MessageGroupArchivePointOrder>;
	pagination?: InputMaybe<EdgePagination>;
};

export type MessageGroupMessagesArgs = {
	filters?: InputMaybe<Array<MessageFilterInput>>;
	order?: InputMaybe<MessageOrder>;
	pagination?: InputMaybe<EdgePagination>;
};

export type MessageGroupUserGroupsArgs = {
	filters?: InputMaybe<Array<UserGroupFilterInput>>;
	order?: InputMaybe<UserGroupOrder>;
	pagination?: InputMaybe<EdgePagination>;
};

export type MessageGroupUsersArgs = {
	filters?: InputMaybe<Array<UserFilterInput>>;
	order?: InputMaybe<UserOrder>;
	pagination?: InputMaybe<EdgePagination>;
};

export type MessageGroupArchivePoint = Node & {
	__typename?: "MessageGroupArchivePoint";
	author: User;
	authorID: Scalars["ID"]["output"];
	createdAt: Scalars["Time"]["output"];
	id: Scalars["ID"]["output"];
	messageGroup: MessageGroup;
	messageGroupID: Scalars["ID"]["output"];
};

export type MessageGroupArchivePointConnection = {
	__typename?: "MessageGroupArchivePointConnection";
	edges: Array<MessageGroupArchivePointEdge>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"]["output"];
};

export type MessageGroupArchivePointCreateInput = {
	messageGroupID: Scalars["ID"]["input"];
};

export type MessageGroupArchivePointEdge = {
	__typename?: "MessageGroupArchivePointEdge";
	cursor: Scalars["Cursor"]["output"];
	node: MessageGroupArchivePoint;
};

export type MessageGroupArchivePointFilterInput = {
	and?: InputMaybe<Array<MessageGroupArchivePointFilterInput>>;
	author?: InputMaybe<Array<UserFilterInput>>;
	authorIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	authorIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	authorIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	authorIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	createdAtEQ?: InputMaybe<Scalars["Time"]["input"]>;
	createdAtGT?: InputMaybe<Scalars["Time"]["input"]>;
	createdAtGTE?: InputMaybe<Scalars["Time"]["input"]>;
	createdAtIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	createdAtLT?: InputMaybe<Scalars["Time"]["input"]>;
	createdAtLTE?: InputMaybe<Scalars["Time"]["input"]>;
	createdAtNEQ?: InputMaybe<Scalars["Time"]["input"]>;
	createdAtNotIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	idEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	messageGroup?: InputMaybe<Array<MessageGroupFilterInput>>;
	messageGroupIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	messageGroupIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	messageGroupIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	messageGroupIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	not?: InputMaybe<MessageGroupArchivePointFilterInput>;
	or?: InputMaybe<Array<MessageGroupArchivePointFilterInput>>;
	search?: InputMaybe<Scalars["String"]["input"]>;
};

export type MessageGroupArchivePointHistory = Node & {
	__typename?: "MessageGroupArchivePointHistory";
	authorID: Maybe<Scalars["ID"]["output"]>;
	createdAt: Maybe<Scalars["Time"]["output"]>;
	historyIsSystem: Scalars["Boolean"]["output"];
	historyTime: Scalars["Time"]["output"];
	historyType: HistoryType;
	historyUserID: Maybe<Scalars["ID"]["output"]>;
	id: Scalars["ID"]["output"];
	messageGroupID: Maybe<Scalars["ID"]["output"]>;
	originalID: Maybe<Scalars["ID"]["output"]>;
};

export type MessageGroupArchivePointHistoryConnection = {
	__typename?: "MessageGroupArchivePointHistoryConnection";
	edges: Array<MessageGroupArchivePointHistoryEdge>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"]["output"];
};

export type MessageGroupArchivePointHistoryEdge = {
	__typename?: "MessageGroupArchivePointHistoryEdge";
	cursor: Scalars["Cursor"]["output"];
	node: MessageGroupArchivePointHistory;
};

export type MessageGroupArchivePointHistoryFilterInput = {
	and?: InputMaybe<Array<MessageGroupArchivePointHistoryFilterInput>>;
	authorIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	authorIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	authorIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	authorIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	authorIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	createdAtEQ?: InputMaybe<Scalars["Time"]["input"]>;
	createdAtGT?: InputMaybe<Scalars["Time"]["input"]>;
	createdAtGTE?: InputMaybe<Scalars["Time"]["input"]>;
	createdAtIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	createdAtIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	createdAtLT?: InputMaybe<Scalars["Time"]["input"]>;
	createdAtLTE?: InputMaybe<Scalars["Time"]["input"]>;
	createdAtNEQ?: InputMaybe<Scalars["Time"]["input"]>;
	createdAtNotIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	historyIsSystemEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyIsSystemNEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyTimeEQ?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeGT?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeGTE?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	historyTimeLT?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeLTE?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeNEQ?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeNotIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	historyTypeEQ?: InputMaybe<HistoryType>;
	historyTypeIn?: InputMaybe<Array<HistoryType>>;
	historyTypeNEQ?: InputMaybe<HistoryType>;
	historyTypeNotIn?: InputMaybe<Array<HistoryType>>;
	historyUserIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	historyUserIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	historyUserIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyUserIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	historyUserIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	messageGroupIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	messageGroupIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	messageGroupIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	messageGroupIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	messageGroupIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	not?: InputMaybe<MessageGroupArchivePointHistoryFilterInput>;
	or?: InputMaybe<Array<MessageGroupArchivePointHistoryFilterInput>>;
	originalIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	originalIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	originalIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	originalIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	originalIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
};

export type MessageGroupArchivePointHistoryOrder = {
	direction: OrderDirection;
	field?: InputMaybe<MessageGroupArchivePointHistoryOrderField>;
};

export enum MessageGroupArchivePointHistoryOrderField {
	HistoryTime = "HISTORY_TIME",
}

export type MessageGroupArchivePointInAuthorCreateInput = {
	messageGroupID: Scalars["ID"]["input"];
};

export type MessageGroupArchivePointInMessageGroupCreateInput = {
	_filler?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type MessageGroupArchivePointOrder = {
	direction: OrderDirection;
	field?: InputMaybe<MessageGroupArchivePointOrderField>;
};

export enum MessageGroupArchivePointOrderField {
	CreatedAt = "CREATED_AT",
}

export type MessageGroupArchivePointUpdateInput = {
	_filler?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type MessageGroupConnection = {
	__typename?: "MessageGroupConnection";
	edges: Array<MessageGroupEdge>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"]["output"];
};

export type MessageGroupCreateInput = {
	customName?: InputMaybe<Scalars["String"]["input"]>;
	isOneOnOne?: InputMaybe<Scalars["Boolean"]["input"]>;
	messageGroupArchivePoints?: InputMaybe<Array<MessageGroupArchivePointInMessageGroupCreateInput>>;
	messages?: InputMaybe<Array<MessageInMessageGroupCreateInput>>;
	userGroupIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	userIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
};

export type MessageGroupEdge = {
	__typename?: "MessageGroupEdge";
	cursor: Scalars["Cursor"]["output"];
	node: MessageGroup;
};

export type MessageGroupFilterInput = {
	and?: InputMaybe<Array<MessageGroupFilterInput>>;
	customNameContains?: InputMaybe<Scalars["String"]["input"]>;
	customNameEQ?: InputMaybe<Scalars["String"]["input"]>;
	customNameHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	customNameHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	customNameIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	customNameNEQ?: InputMaybe<Scalars["String"]["input"]>;
	customNameNotContains?: InputMaybe<Scalars["String"]["input"]>;
	customNameNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	customNameNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	customNameNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	hasMessageGroupArchivePoints?: InputMaybe<Scalars["Boolean"]["input"]>;
	hasMessages?: InputMaybe<Scalars["Boolean"]["input"]>;
	hasUserGroups?: InputMaybe<Scalars["Boolean"]["input"]>;
	hasUsers?: InputMaybe<Scalars["Boolean"]["input"]>;
	idEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	isOneOnOneEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	isOneOnOneNEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	messageGroupArchivePoints?: InputMaybe<Array<MessageGroupArchivePointFilterInput>>;
	messages?: InputMaybe<Array<MessageFilterInput>>;
	not?: InputMaybe<MessageGroupFilterInput>;
	or?: InputMaybe<Array<MessageGroupFilterInput>>;
	search?: InputMaybe<Scalars["String"]["input"]>;
	userGroups?: InputMaybe<Array<UserGroupFilterInput>>;
	users?: InputMaybe<Array<UserFilterInput>>;
};

export type MessageGroupHistory = Node & {
	__typename?: "MessageGroupHistory";
	customName: Maybe<Scalars["String"]["output"]>;
	historyIsSystem: Scalars["Boolean"]["output"];
	historyTime: Scalars["Time"]["output"];
	historyType: HistoryType;
	historyUserID: Maybe<Scalars["ID"]["output"]>;
	id: Scalars["ID"]["output"];
	isOneOnOne: Maybe<Scalars["Boolean"]["output"]>;
	originalID: Maybe<Scalars["ID"]["output"]>;
};

export type MessageGroupHistoryConnection = {
	__typename?: "MessageGroupHistoryConnection";
	edges: Array<MessageGroupHistoryEdge>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"]["output"];
};

export type MessageGroupHistoryEdge = {
	__typename?: "MessageGroupHistoryEdge";
	cursor: Scalars["Cursor"]["output"];
	node: MessageGroupHistory;
};

export type MessageGroupHistoryFilterInput = {
	and?: InputMaybe<Array<MessageGroupHistoryFilterInput>>;
	customNameContains?: InputMaybe<Scalars["String"]["input"]>;
	customNameEQ?: InputMaybe<Scalars["String"]["input"]>;
	customNameHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	customNameHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	customNameIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	customNameIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	customNameNEQ?: InputMaybe<Scalars["String"]["input"]>;
	customNameNotContains?: InputMaybe<Scalars["String"]["input"]>;
	customNameNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	customNameNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	customNameNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	historyIsSystemEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyIsSystemNEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyTimeEQ?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeGT?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeGTE?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	historyTimeLT?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeLTE?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeNEQ?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeNotIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	historyTypeEQ?: InputMaybe<HistoryType>;
	historyTypeIn?: InputMaybe<Array<HistoryType>>;
	historyTypeNEQ?: InputMaybe<HistoryType>;
	historyTypeNotIn?: InputMaybe<Array<HistoryType>>;
	historyUserIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	historyUserIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	historyUserIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyUserIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	historyUserIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	isOneOnOneEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	isOneOnOneIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	isOneOnOneNEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	not?: InputMaybe<MessageGroupHistoryFilterInput>;
	or?: InputMaybe<Array<MessageGroupHistoryFilterInput>>;
	originalIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	originalIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	originalIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	originalIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	originalIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	search?: InputMaybe<Scalars["String"]["input"]>;
};

export type MessageGroupHistoryOrder = {
	direction: OrderDirection;
	field?: InputMaybe<MessageGroupHistoryOrderField>;
};

export enum MessageGroupHistoryOrderField {
	HistoryTime = "HISTORY_TIME",
}

export type MessageGroupOrder = {
	direction: OrderDirection;
	field?: InputMaybe<MessageGroupOrderField>;
};

export enum MessageGroupOrderField {
	CustomName = "CUSTOM_NAME",
}

export type MessageGroupUpdateBulkInput = {
	addUserGroupIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	addUserIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	customName?: InputMaybe<Scalars["String"]["input"]>;
	isOneOnOne?: InputMaybe<Scalars["Boolean"]["input"]>;
	removeUserGroupIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	removeUserIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
};

export type MessageGroupUpdateInput = {
	addUserGroupIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	addUserIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	customName?: InputMaybe<Scalars["String"]["input"]>;
	isOneOnOne?: InputMaybe<Scalars["Boolean"]["input"]>;
	removeUserGroupIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	removeUserIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
};

export type MessageGroupUserGroupHistory = Node & {
	__typename?: "MessageGroupUserGroupHistory";
	historyIsSystem: Scalars["Boolean"]["output"];
	historyTime: Scalars["Time"]["output"];
	historyType: HistoryType;
	historyUserID: Maybe<Scalars["ID"]["output"]>;
	id: Scalars["ID"]["output"];
	messageGroupID: Maybe<Scalars["ID"]["output"]>;
	userGroupID: Maybe<Scalars["ID"]["output"]>;
};

export type MessageGroupUserGroupHistoryConnection = {
	__typename?: "MessageGroupUserGroupHistoryConnection";
	edges: Array<MessageGroupUserGroupHistoryEdge>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"]["output"];
};

export type MessageGroupUserGroupHistoryEdge = {
	__typename?: "MessageGroupUserGroupHistoryEdge";
	cursor: Scalars["Cursor"]["output"];
	node: MessageGroupUserGroupHistory;
};

export type MessageGroupUserGroupHistoryFilterInput = {
	and?: InputMaybe<Array<MessageGroupUserGroupHistoryFilterInput>>;
	historyIsSystemEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyIsSystemNEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyTimeEQ?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeGT?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeGTE?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	historyTimeLT?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeLTE?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeNEQ?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeNotIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	historyTypeEQ?: InputMaybe<HistoryType>;
	historyTypeIn?: InputMaybe<Array<HistoryType>>;
	historyTypeNEQ?: InputMaybe<HistoryType>;
	historyTypeNotIn?: InputMaybe<Array<HistoryType>>;
	historyUserIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	historyUserIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	historyUserIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyUserIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	historyUserIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	messageGroupIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	messageGroupIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	messageGroupIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	messageGroupIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	messageGroupIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	not?: InputMaybe<MessageGroupUserGroupHistoryFilterInput>;
	or?: InputMaybe<Array<MessageGroupUserGroupHistoryFilterInput>>;
	userGroupIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	userGroupIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	userGroupIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	userGroupIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	userGroupIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
};

export type MessageGroupUserGroupHistoryOrder = {
	direction: OrderDirection;
	field?: InputMaybe<MessageGroupUserGroupHistoryOrderField>;
};

export enum MessageGroupUserGroupHistoryOrderField {
	HistoryTime = "HISTORY_TIME",
}

export type MessageGroupUserHistory = Node & {
	__typename?: "MessageGroupUserHistory";
	historyIsSystem: Scalars["Boolean"]["output"];
	historyTime: Scalars["Time"]["output"];
	historyType: HistoryType;
	historyUserID: Maybe<Scalars["ID"]["output"]>;
	id: Scalars["ID"]["output"];
	messageGroupID: Maybe<Scalars["ID"]["output"]>;
	userID: Maybe<Scalars["ID"]["output"]>;
};

export type MessageGroupUserHistoryConnection = {
	__typename?: "MessageGroupUserHistoryConnection";
	edges: Array<MessageGroupUserHistoryEdge>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"]["output"];
};

export type MessageGroupUserHistoryEdge = {
	__typename?: "MessageGroupUserHistoryEdge";
	cursor: Scalars["Cursor"]["output"];
	node: MessageGroupUserHistory;
};

export type MessageGroupUserHistoryFilterInput = {
	and?: InputMaybe<Array<MessageGroupUserHistoryFilterInput>>;
	historyIsSystemEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyIsSystemNEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyTimeEQ?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeGT?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeGTE?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	historyTimeLT?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeLTE?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeNEQ?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeNotIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	historyTypeEQ?: InputMaybe<HistoryType>;
	historyTypeIn?: InputMaybe<Array<HistoryType>>;
	historyTypeNEQ?: InputMaybe<HistoryType>;
	historyTypeNotIn?: InputMaybe<Array<HistoryType>>;
	historyUserIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	historyUserIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	historyUserIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyUserIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	historyUserIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	messageGroupIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	messageGroupIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	messageGroupIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	messageGroupIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	messageGroupIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	not?: InputMaybe<MessageGroupUserHistoryFilterInput>;
	or?: InputMaybe<Array<MessageGroupUserHistoryFilterInput>>;
	userIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	userIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	userIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	userIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	userIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
};

export type MessageGroupUserHistoryOrder = {
	direction: OrderDirection;
	field?: InputMaybe<MessageGroupUserHistoryOrderField>;
};

export enum MessageGroupUserHistoryOrderField {
	HistoryTime = "HISTORY_TIME",
}

export type MessageHistory = Node & {
	__typename?: "MessageHistory";
	authorID: Maybe<Scalars["ID"]["output"]>;
	body: Maybe<Scalars["String"]["output"]>;
	createdAt: Maybe<Scalars["Time"]["output"]>;
	historyIsSystem: Scalars["Boolean"]["output"];
	historyTime: Scalars["Time"]["output"];
	historyType: HistoryType;
	historyUserID: Maybe<Scalars["ID"]["output"]>;
	id: Scalars["ID"]["output"];
	isRemoved: Maybe<Scalars["Boolean"]["output"]>;
	lastEditedAt: Maybe<Scalars["Time"]["output"]>;
	messageGroupID: Maybe<Scalars["ID"]["output"]>;
	originalID: Maybe<Scalars["ID"]["output"]>;
};

export type MessageHistoryConnection = {
	__typename?: "MessageHistoryConnection";
	edges: Array<MessageHistoryEdge>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"]["output"];
};

export type MessageHistoryEdge = {
	__typename?: "MessageHistoryEdge";
	cursor: Scalars["Cursor"]["output"];
	node: MessageHistory;
};

export type MessageHistoryFilterInput = {
	and?: InputMaybe<Array<MessageHistoryFilterInput>>;
	authorIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	authorIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	authorIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	authorIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	authorIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	bodyContains?: InputMaybe<Scalars["String"]["input"]>;
	bodyEQ?: InputMaybe<Scalars["String"]["input"]>;
	bodyHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	bodyHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	bodyIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	bodyIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	bodyNEQ?: InputMaybe<Scalars["String"]["input"]>;
	bodyNotContains?: InputMaybe<Scalars["String"]["input"]>;
	bodyNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	bodyNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	bodyNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	createdAtEQ?: InputMaybe<Scalars["Time"]["input"]>;
	createdAtGT?: InputMaybe<Scalars["Time"]["input"]>;
	createdAtGTE?: InputMaybe<Scalars["Time"]["input"]>;
	createdAtIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	createdAtIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	createdAtLT?: InputMaybe<Scalars["Time"]["input"]>;
	createdAtLTE?: InputMaybe<Scalars["Time"]["input"]>;
	createdAtNEQ?: InputMaybe<Scalars["Time"]["input"]>;
	createdAtNotIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	historyIsSystemEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyIsSystemNEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyTimeEQ?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeGT?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeGTE?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	historyTimeLT?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeLTE?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeNEQ?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeNotIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	historyTypeEQ?: InputMaybe<HistoryType>;
	historyTypeIn?: InputMaybe<Array<HistoryType>>;
	historyTypeNEQ?: InputMaybe<HistoryType>;
	historyTypeNotIn?: InputMaybe<Array<HistoryType>>;
	historyUserIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	historyUserIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	historyUserIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyUserIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	historyUserIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	isRemovedEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	isRemovedIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	isRemovedNEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	lastEditedAtEQ?: InputMaybe<Scalars["Time"]["input"]>;
	lastEditedAtGT?: InputMaybe<Scalars["Time"]["input"]>;
	lastEditedAtGTE?: InputMaybe<Scalars["Time"]["input"]>;
	lastEditedAtIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	lastEditedAtIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	lastEditedAtLT?: InputMaybe<Scalars["Time"]["input"]>;
	lastEditedAtLTE?: InputMaybe<Scalars["Time"]["input"]>;
	lastEditedAtNEQ?: InputMaybe<Scalars["Time"]["input"]>;
	lastEditedAtNotIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	messageGroupIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	messageGroupIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	messageGroupIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	messageGroupIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	messageGroupIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	not?: InputMaybe<MessageHistoryFilterInput>;
	or?: InputMaybe<Array<MessageHistoryFilterInput>>;
	originalIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	originalIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	originalIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	originalIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	originalIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	search?: InputMaybe<Scalars["String"]["input"]>;
};

export type MessageHistoryOrder = {
	direction: OrderDirection;
	field?: InputMaybe<MessageHistoryOrderField>;
};

export enum MessageHistoryOrderField {
	HistoryTime = "HISTORY_TIME",
}

export type MessageInAuthorCreateInput = {
	body?: InputMaybe<Scalars["String"]["input"]>;
	mediaAttachments?: InputMaybe<Array<MediaAttachmentInMessageCreateInput>>;
	messageGroupID: Scalars["ID"]["input"];
	messageTopic?: InputMaybe<MessageTopicInMessageCreateInput>;
};

export type MessageInMessageGroupCreateInput = {
	body?: InputMaybe<Scalars["String"]["input"]>;
	mediaAttachments?: InputMaybe<Array<MediaAttachmentInMessageCreateInput>>;
	messageTopic?: InputMaybe<MessageTopicInMessageCreateInput>;
};

export type MessageInMessageTopicCreateInput = {
	body?: InputMaybe<Scalars["String"]["input"]>;
	mediaAttachments?: InputMaybe<Array<MediaAttachmentInMessageCreateInput>>;
	messageGroupID: Scalars["ID"]["input"];
};

export type MessageOrder = {
	direction: OrderDirection;
	field?: InputMaybe<MessageOrderField>;
};

export enum MessageOrderField {
	CreatedAt = "CREATED_AT",
}

export type MessageTopic = Node & {
	__typename?: "MessageTopic";
	id: Scalars["ID"]["output"];
	message: Message;
	messageID: Scalars["ID"]["output"];
	name: Scalars["String"]["output"];
};

export type MessageTopicConnection = {
	__typename?: "MessageTopicConnection";
	edges: Array<MessageTopicEdge>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"]["output"];
};

export type MessageTopicCreateInput = {
	message?: InputMaybe<MessageInMessageTopicCreateInput>;
	messageID?: InputMaybe<Scalars["ID"]["input"]>;
	name?: InputMaybe<Scalars["String"]["input"]>;
};

export type MessageTopicEdge = {
	__typename?: "MessageTopicEdge";
	cursor: Scalars["Cursor"]["output"];
	node: MessageTopic;
};

export type MessageTopicFilterInput = {
	and?: InputMaybe<Array<MessageTopicFilterInput>>;
	idEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	message?: InputMaybe<Array<MessageFilterInput>>;
	messageIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	messageIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	messageIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	messageIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	nameContains?: InputMaybe<Scalars["String"]["input"]>;
	nameEQ?: InputMaybe<Scalars["String"]["input"]>;
	nameHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	nameHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	nameIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	nameNEQ?: InputMaybe<Scalars["String"]["input"]>;
	nameNotContains?: InputMaybe<Scalars["String"]["input"]>;
	nameNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	nameNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	nameNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	not?: InputMaybe<MessageTopicFilterInput>;
	or?: InputMaybe<Array<MessageTopicFilterInput>>;
	search?: InputMaybe<Scalars["String"]["input"]>;
};

export type MessageTopicHistory = Node & {
	__typename?: "MessageTopicHistory";
	historyIsSystem: Scalars["Boolean"]["output"];
	historyTime: Scalars["Time"]["output"];
	historyType: HistoryType;
	historyUserID: Maybe<Scalars["ID"]["output"]>;
	id: Scalars["ID"]["output"];
	messageID: Maybe<Scalars["ID"]["output"]>;
	name: Maybe<Scalars["String"]["output"]>;
	originalID: Maybe<Scalars["ID"]["output"]>;
};

export type MessageTopicHistoryConnection = {
	__typename?: "MessageTopicHistoryConnection";
	edges: Array<MessageTopicHistoryEdge>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"]["output"];
};

export type MessageTopicHistoryEdge = {
	__typename?: "MessageTopicHistoryEdge";
	cursor: Scalars["Cursor"]["output"];
	node: MessageTopicHistory;
};

export type MessageTopicHistoryFilterInput = {
	and?: InputMaybe<Array<MessageTopicHistoryFilterInput>>;
	historyIsSystemEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyIsSystemNEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyTimeEQ?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeGT?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeGTE?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	historyTimeLT?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeLTE?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeNEQ?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeNotIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	historyTypeEQ?: InputMaybe<HistoryType>;
	historyTypeIn?: InputMaybe<Array<HistoryType>>;
	historyTypeNEQ?: InputMaybe<HistoryType>;
	historyTypeNotIn?: InputMaybe<Array<HistoryType>>;
	historyUserIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	historyUserIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	historyUserIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyUserIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	historyUserIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	messageIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	messageIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	messageIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	messageIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	messageIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	nameContains?: InputMaybe<Scalars["String"]["input"]>;
	nameEQ?: InputMaybe<Scalars["String"]["input"]>;
	nameHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	nameHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	nameIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	nameIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	nameNEQ?: InputMaybe<Scalars["String"]["input"]>;
	nameNotContains?: InputMaybe<Scalars["String"]["input"]>;
	nameNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	nameNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	nameNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	not?: InputMaybe<MessageTopicHistoryFilterInput>;
	or?: InputMaybe<Array<MessageTopicHistoryFilterInput>>;
	originalIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	originalIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	originalIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	originalIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	originalIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	search?: InputMaybe<Scalars["String"]["input"]>;
};

export type MessageTopicHistoryOrder = {
	direction: OrderDirection;
	field?: InputMaybe<MessageTopicHistoryOrderField>;
};

export enum MessageTopicHistoryOrderField {
	HistoryTime = "HISTORY_TIME",
}

export type MessageTopicInMessageCreateInput = {
	name?: InputMaybe<Scalars["String"]["input"]>;
};

export type MessageTopicOrder = {
	direction: OrderDirection;
};

export type MessageTopicUpdateBulkInput = {
	name?: InputMaybe<Scalars["String"]["input"]>;
};

export type MessageTopicUpdateInput = {
	name?: InputMaybe<Scalars["String"]["input"]>;
};

export type MessageUpdateBulkInput = {
	body?: InputMaybe<Scalars["String"]["input"]>;
	isRemoved?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type MessageUpdateInput = {
	body?: InputMaybe<Scalars["String"]["input"]>;
	isRemoved?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type ModelIdInformation = {
	__typename?: "ModelIDInformation";
	maxID: Scalars["ID"]["output"];
	minID: Scalars["ID"]["output"];
	modelName: Scalars["String"]["output"];
};

export type Mutation = {
	__typename?: "Mutation";
	createAnnouncement: Announcement;
	createBulkAnnouncements: AnnouncementConnection;
	createBulkCalendarEventResponses: CalendarEventResponseConnection;
	createBulkCalendarEvents: CalendarEventConnection;
	createBulkMediaAttachments: MediaAttachmentConnection;
	createBulkMessageGroupArchivePoints: MessageGroupArchivePointConnection;
	createBulkMessageGroups: MessageGroupConnection;
	createBulkMessageTopics: MessageTopicConnection;
	createBulkMessages: MessageConnection;
	createBulkNewsletters: NewsletterConnection;
	createBulkPermissionGroups: PermissionGroupConnection;
	createBulkPosts: PostConnection;
	createBulkSharingPolicies: SharingPolicyConnection;
	createBulkSocialComments: SocialCommentConnection;
	createBulkSocialReactions: SocialReactionConnection;
	createBulkUserGroups: UserGroupConnection;
	createBulkUserViewRecords: UserViewRecordConnection;
	createBulkUsers: UserConnection;
	createCalendarEvent: CalendarEvent;
	createCalendarEventResponse: CalendarEventResponse;
	createMediaAttachment: MediaAttachment;
	createMessage: Message;
	createMessageGroup: MessageGroup;
	createMessageGroupArchivePoint: MessageGroupArchivePoint;
	createMessageTopic: MessageTopic;
	createNewsletter: Newsletter;
	createOrUpdateMessageGroup: MessageGroup;
	createPermissionGroup: PermissionGroup;
	createPost: Post;
	createSharingPolicy: SharingPolicy;
	createSocialComment: SocialComment;
	createSocialReaction: SocialReaction;
	createUser: User;
	createUserGroup: UserGroup;
	createUserViewRecord: UserViewRecord;
	deleteAnnouncement: Scalars["Boolean"]["output"];
	deleteBulkAnnouncements: DeleteBulkResponse;
	deleteBulkCalendarEventResponses: DeleteBulkResponse;
	deleteBulkCalendarEvents: DeleteBulkResponse;
	deleteBulkMediaAttachments: DeleteBulkResponse;
	deleteBulkMessageGroupArchivePoints: DeleteBulkResponse;
	deleteBulkMessageGroups: DeleteBulkResponse;
	deleteBulkMessageTopics: DeleteBulkResponse;
	deleteBulkMessages: DeleteBulkResponse;
	deleteBulkNewsletters: DeleteBulkResponse;
	deleteBulkPermissionGroups: DeleteBulkResponse;
	deleteBulkPosts: DeleteBulkResponse;
	deleteBulkSharingPolicies: DeleteBulkResponse;
	deleteBulkSocialComments: DeleteBulkResponse;
	deleteBulkSocialReactions: DeleteBulkResponse;
	deleteBulkUserGroups: DeleteBulkResponse;
	deleteBulkUserViewRecords: DeleteBulkResponse;
	deleteBulkUsers: DeleteBulkResponse;
	deleteCalendarEvent: Scalars["Boolean"]["output"];
	deleteCalendarEventResponse: Scalars["Boolean"]["output"];
	deleteMediaAttachment: Scalars["Boolean"]["output"];
	deleteMessage: Scalars["Boolean"]["output"];
	deleteMessageGroup: Scalars["Boolean"]["output"];
	deleteMessageGroupArchivePoint: Scalars["Boolean"]["output"];
	deleteMessageTopic: Scalars["Boolean"]["output"];
	deleteNewsletter: Scalars["Boolean"]["output"];
	deletePermissionGroup: Scalars["Boolean"]["output"];
	deletePost: Scalars["Boolean"]["output"];
	deleteSharingPolicy: Scalars["Boolean"]["output"];
	deleteSocialComment: Scalars["Boolean"]["output"];
	deleteSocialReaction: Scalars["Boolean"]["output"];
	deleteUser: Scalars["Boolean"]["output"];
	deleteUserGroup: Scalars["Boolean"]["output"];
	deleteUserViewRecord: Scalars["Boolean"]["output"];
	recordView: UserViewRecord;
	recordViews: UserViewRecordConnection;
	root: Scalars["Boolean"]["output"];
	sendInviteMessage: Scalars["Boolean"]["output"];
	updateAnnouncement: Announcement;
	updateBulkAnnouncements: AnnouncementConnection;
	updateBulkCalendarEventResponses: CalendarEventResponseConnection;
	updateBulkCalendarEvents: CalendarEventConnection;
	updateBulkMediaAttachments: MediaAttachmentConnection;
	updateBulkMessageGroups: MessageGroupConnection;
	updateBulkMessageTopics: MessageTopicConnection;
	updateBulkMessages: MessageConnection;
	updateBulkNewsletters: NewsletterConnection;
	updateBulkPermissionGroups: PermissionGroupConnection;
	updateBulkPermissions: PermissionConnection;
	updateBulkPosts: PostConnection;
	updateBulkSharingPolicies: SharingPolicyConnection;
	updateBulkSocialComments: SocialCommentConnection;
	updateBulkSocialReactions: SocialReactionConnection;
	updateBulkUserGroups: UserGroupConnection;
	updateBulkUsers: UserConnection;
	updateCalendarEvent: CalendarEvent;
	updateCalendarEventResponse: CalendarEventResponse;
	updateMediaAttachment: MediaAttachment;
	updateMessage: Message;
	updateMessageGroup: MessageGroup;
	updateMessageGroupArchivePoint: MessageGroupArchivePoint;
	updateMessageTopic: MessageTopic;
	updateNewsletter: Newsletter;
	updatePermission: Permission;
	updatePermissionGroup: PermissionGroup;
	updatePost: Post;
	updateSharingPolicy: SharingPolicy;
	updateSocialComment: SocialComment;
	updateSocialReaction: SocialReaction;
	updateUser: User;
	updateUserGroup: UserGroup;
	updateUserViewRecord: UserViewRecord;
};

export type MutationCreateAnnouncementArgs = {
	input: AnnouncementCreateInput;
};

export type MutationCreateBulkAnnouncementsArgs = {
	inputs: Array<AnnouncementCreateInput>;
};

export type MutationCreateBulkCalendarEventResponsesArgs = {
	inputs: Array<CalendarEventResponseCreateInput>;
};

export type MutationCreateBulkCalendarEventsArgs = {
	inputs: Array<CalendarEventCreateInput>;
};

export type MutationCreateBulkMediaAttachmentsArgs = {
	inputs: Array<MediaAttachmentCreateInput>;
};

export type MutationCreateBulkMessageGroupArchivePointsArgs = {
	inputs: Array<MessageGroupArchivePointCreateInput>;
};

export type MutationCreateBulkMessageGroupsArgs = {
	inputs: Array<MessageGroupCreateInput>;
};

export type MutationCreateBulkMessageTopicsArgs = {
	inputs: Array<MessageTopicCreateInput>;
};

export type MutationCreateBulkMessagesArgs = {
	inputs: Array<MessageCreateInput>;
};

export type MutationCreateBulkNewslettersArgs = {
	inputs: Array<NewsletterCreateInput>;
};

export type MutationCreateBulkPermissionGroupsArgs = {
	inputs: Array<PermissionGroupCreateInput>;
};

export type MutationCreateBulkPostsArgs = {
	inputs: Array<PostCreateInput>;
};

export type MutationCreateBulkSharingPoliciesArgs = {
	inputs: Array<SharingPolicyCreateInput>;
};

export type MutationCreateBulkSocialCommentsArgs = {
	inputs: Array<SocialCommentCreateInput>;
};

export type MutationCreateBulkSocialReactionsArgs = {
	inputs: Array<SocialReactionCreateInput>;
};

export type MutationCreateBulkUserGroupsArgs = {
	inputs: Array<UserGroupCreateInput>;
};

export type MutationCreateBulkUserViewRecordsArgs = {
	inputs: Array<UserViewRecordCreateInput>;
};

export type MutationCreateBulkUsersArgs = {
	inputs: Array<UserCreateInput>;
};

export type MutationCreateCalendarEventArgs = {
	input: CalendarEventCreateInput;
};

export type MutationCreateCalendarEventResponseArgs = {
	input: CalendarEventResponseCreateInput;
};

export type MutationCreateMediaAttachmentArgs = {
	input: MediaAttachmentCreateInput;
};

export type MutationCreateMessageArgs = {
	input: MessageCreateInput;
};

export type MutationCreateMessageGroupArgs = {
	input: MessageGroupCreateInput;
};

export type MutationCreateMessageGroupArchivePointArgs = {
	input: MessageGroupArchivePointCreateInput;
};

export type MutationCreateMessageTopicArgs = {
	input: MessageTopicCreateInput;
};

export type MutationCreateNewsletterArgs = {
	input: NewsletterCreateInput;
};

export type MutationCreateOrUpdateMessageGroupArgs = {
	input: MessageGroupCreateInput;
};

export type MutationCreatePermissionGroupArgs = {
	input: PermissionGroupCreateInput;
};

export type MutationCreatePostArgs = {
	input: PostCreateInput;
};

export type MutationCreateSharingPolicyArgs = {
	input: SharingPolicyCreateInput;
};

export type MutationCreateSocialCommentArgs = {
	input: SocialCommentCreateInput;
};

export type MutationCreateSocialReactionArgs = {
	input: SocialReactionCreateInput;
};

export type MutationCreateUserArgs = {
	input: UserCreateInput;
};

export type MutationCreateUserGroupArgs = {
	input: UserGroupCreateInput;
};

export type MutationCreateUserViewRecordArgs = {
	input: UserViewRecordCreateInput;
};

export type MutationDeleteAnnouncementArgs = {
	id: Scalars["ID"]["input"];
};

export type MutationDeleteBulkAnnouncementsArgs = {
	filters: Array<AnnouncementFilterInput>;
};

export type MutationDeleteBulkCalendarEventResponsesArgs = {
	filters: Array<CalendarEventResponseFilterInput>;
};

export type MutationDeleteBulkCalendarEventsArgs = {
	filters: Array<CalendarEventFilterInput>;
};

export type MutationDeleteBulkMediaAttachmentsArgs = {
	filters: Array<MediaAttachmentFilterInput>;
};

export type MutationDeleteBulkMessageGroupArchivePointsArgs = {
	filters: Array<MessageGroupArchivePointFilterInput>;
};

export type MutationDeleteBulkMessageGroupsArgs = {
	filters: Array<MessageGroupFilterInput>;
};

export type MutationDeleteBulkMessageTopicsArgs = {
	filters: Array<MessageTopicFilterInput>;
};

export type MutationDeleteBulkMessagesArgs = {
	filters: Array<MessageFilterInput>;
};

export type MutationDeleteBulkNewslettersArgs = {
	filters: Array<NewsletterFilterInput>;
};

export type MutationDeleteBulkPermissionGroupsArgs = {
	filters: Array<PermissionGroupFilterInput>;
};

export type MutationDeleteBulkPostsArgs = {
	filters: Array<PostFilterInput>;
};

export type MutationDeleteBulkSharingPoliciesArgs = {
	filters: Array<SharingPolicyFilterInput>;
};

export type MutationDeleteBulkSocialCommentsArgs = {
	filters: Array<SocialCommentFilterInput>;
};

export type MutationDeleteBulkSocialReactionsArgs = {
	filters: Array<SocialReactionFilterInput>;
};

export type MutationDeleteBulkUserGroupsArgs = {
	filters: Array<UserGroupFilterInput>;
};

export type MutationDeleteBulkUserViewRecordsArgs = {
	filters: Array<UserViewRecordFilterInput>;
};

export type MutationDeleteBulkUsersArgs = {
	filters: Array<UserFilterInput>;
};

export type MutationDeleteCalendarEventArgs = {
	id: Scalars["ID"]["input"];
};

export type MutationDeleteCalendarEventResponseArgs = {
	id: Scalars["ID"]["input"];
};

export type MutationDeleteMediaAttachmentArgs = {
	id: Scalars["ID"]["input"];
};

export type MutationDeleteMessageArgs = {
	id: Scalars["ID"]["input"];
};

export type MutationDeleteMessageGroupArgs = {
	id: Scalars["ID"]["input"];
};

export type MutationDeleteMessageGroupArchivePointArgs = {
	id: Scalars["ID"]["input"];
};

export type MutationDeleteMessageTopicArgs = {
	id: Scalars["ID"]["input"];
};

export type MutationDeleteNewsletterArgs = {
	id: Scalars["ID"]["input"];
};

export type MutationDeletePermissionGroupArgs = {
	id: Scalars["ID"]["input"];
};

export type MutationDeletePostArgs = {
	id: Scalars["ID"]["input"];
};

export type MutationDeleteSharingPolicyArgs = {
	id: Scalars["ID"]["input"];
};

export type MutationDeleteSocialCommentArgs = {
	id: Scalars["ID"]["input"];
};

export type MutationDeleteSocialReactionArgs = {
	id: Scalars["ID"]["input"];
};

export type MutationDeleteUserArgs = {
	id: Scalars["ID"]["input"];
};

export type MutationDeleteUserGroupArgs = {
	id: Scalars["ID"]["input"];
};

export type MutationDeleteUserViewRecordArgs = {
	id: Scalars["ID"]["input"];
};

export type MutationRecordViewArgs = {
	id: Scalars["ID"]["input"];
};

export type MutationRecordViewsArgs = {
	ids: Array<Scalars["ID"]["input"]>;
};

export type MutationSendInviteMessageArgs = {
	userID: Scalars["ID"]["input"];
};

export type MutationUpdateAnnouncementArgs = {
	id: Scalars["ID"]["input"];
	input: AnnouncementUpdateInput;
};

export type MutationUpdateBulkAnnouncementsArgs = {
	filters: Array<AnnouncementFilterInput>;
	input: AnnouncementUpdateBulkInput;
};

export type MutationUpdateBulkCalendarEventResponsesArgs = {
	filters: Array<CalendarEventResponseFilterInput>;
	input: CalendarEventResponseUpdateBulkInput;
};

export type MutationUpdateBulkCalendarEventsArgs = {
	filters: Array<CalendarEventFilterInput>;
	input: CalendarEventUpdateBulkInput;
};

export type MutationUpdateBulkMediaAttachmentsArgs = {
	filters: Array<MediaAttachmentFilterInput>;
	input: MediaAttachmentUpdateBulkInput;
};

export type MutationUpdateBulkMessageGroupsArgs = {
	filters: Array<MessageGroupFilterInput>;
	input: MessageGroupUpdateBulkInput;
};

export type MutationUpdateBulkMessageTopicsArgs = {
	filters: Array<MessageTopicFilterInput>;
	input: MessageTopicUpdateBulkInput;
};

export type MutationUpdateBulkMessagesArgs = {
	filters: Array<MessageFilterInput>;
	input: MessageUpdateBulkInput;
};

export type MutationUpdateBulkNewslettersArgs = {
	filters: Array<NewsletterFilterInput>;
	input: NewsletterUpdateBulkInput;
};

export type MutationUpdateBulkPermissionGroupsArgs = {
	filters: Array<PermissionGroupFilterInput>;
	input: PermissionGroupUpdateBulkInput;
};

export type MutationUpdateBulkPermissionsArgs = {
	filters: Array<PermissionFilterInput>;
	input: PermissionUpdateBulkInput;
};

export type MutationUpdateBulkPostsArgs = {
	filters: Array<PostFilterInput>;
	input: PostUpdateBulkInput;
};

export type MutationUpdateBulkSharingPoliciesArgs = {
	filters: Array<SharingPolicyFilterInput>;
	input: SharingPolicyUpdateBulkInput;
};

export type MutationUpdateBulkSocialCommentsArgs = {
	filters: Array<SocialCommentFilterInput>;
	input: SocialCommentUpdateBulkInput;
};

export type MutationUpdateBulkSocialReactionsArgs = {
	filters: Array<SocialReactionFilterInput>;
	input: SocialReactionUpdateBulkInput;
};

export type MutationUpdateBulkUserGroupsArgs = {
	filters: Array<UserGroupFilterInput>;
	input: UserGroupUpdateBulkInput;
};

export type MutationUpdateBulkUsersArgs = {
	filters: Array<UserFilterInput>;
	input: UserUpdateBulkInput;
};

export type MutationUpdateCalendarEventArgs = {
	id: Scalars["ID"]["input"];
	input: CalendarEventUpdateInput;
};

export type MutationUpdateCalendarEventResponseArgs = {
	id: Scalars["ID"]["input"];
	input: CalendarEventResponseUpdateInput;
};

export type MutationUpdateMediaAttachmentArgs = {
	id: Scalars["ID"]["input"];
	input: MediaAttachmentUpdateInput;
};

export type MutationUpdateMessageArgs = {
	id: Scalars["ID"]["input"];
	input: MessageUpdateInput;
};

export type MutationUpdateMessageGroupArgs = {
	id: Scalars["ID"]["input"];
	input: MessageGroupUpdateInput;
};

export type MutationUpdateMessageGroupArchivePointArgs = {
	id: Scalars["ID"]["input"];
	input: MessageGroupArchivePointUpdateInput;
};

export type MutationUpdateMessageTopicArgs = {
	id: Scalars["ID"]["input"];
	input: MessageTopicUpdateInput;
};

export type MutationUpdateNewsletterArgs = {
	id: Scalars["ID"]["input"];
	input: NewsletterUpdateInput;
};

export type MutationUpdatePermissionArgs = {
	id: Scalars["ID"]["input"];
	input: PermissionUpdateInput;
};

export type MutationUpdatePermissionGroupArgs = {
	id: Scalars["ID"]["input"];
	input: PermissionGroupUpdateInput;
};

export type MutationUpdatePostArgs = {
	id: Scalars["ID"]["input"];
	input: PostUpdateInput;
};

export type MutationUpdateSharingPolicyArgs = {
	id: Scalars["ID"]["input"];
	input: SharingPolicyUpdateInput;
};

export type MutationUpdateSocialCommentArgs = {
	id: Scalars["ID"]["input"];
	input: SocialCommentUpdateInput;
};

export type MutationUpdateSocialReactionArgs = {
	id: Scalars["ID"]["input"];
	input: SocialReactionUpdateInput;
};

export type MutationUpdateUserArgs = {
	id: Scalars["ID"]["input"];
	input: UserUpdateInput;
};

export type MutationUpdateUserGroupArgs = {
	id: Scalars["ID"]["input"];
	input: UserGroupUpdateInput;
};

export type MutationUpdateUserViewRecordArgs = {
	id: Scalars["ID"]["input"];
	input: UserViewRecordUpdateInput;
};

export type Newsletter = Node & {
	__typename?: "Newsletter";
	author: Maybe<User>;
	authorID: Maybe<Scalars["ID"]["output"]>;
	body: Scalars["String"]["output"];
	id: Scalars["ID"]["output"];
	imageContentType: Scalars["String"]["output"];
	imageKey: Scalars["String"]["output"];
	imageURL: Scalars["String"]["output"];
	releaseAt: Maybe<Scalars["Time"]["output"]>;
	sharingPolicy: Maybe<SharingPolicy>;
	socialComments: Array<SocialComment>;
	socialReactions: Array<SocialReaction>;
	title: Scalars["String"]["output"];
};

export type NewsletterSocialCommentsArgs = {
	filters?: InputMaybe<Array<SocialCommentFilterInput>>;
	order?: InputMaybe<SocialCommentOrder>;
	pagination?: InputMaybe<EdgePagination>;
};

export type NewsletterSocialReactionsArgs = {
	filters?: InputMaybe<Array<SocialReactionFilterInput>>;
	order?: InputMaybe<SocialReactionOrder>;
	pagination?: InputMaybe<EdgePagination>;
};

export type NewsletterConnection = {
	__typename?: "NewsletterConnection";
	edges: Array<NewsletterEdge>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"]["output"];
};

export type NewsletterCreateInput = {
	body: Scalars["String"]["input"];
	imageContentType?: InputMaybe<Scalars["String"]["input"]>;
	imageKey?: InputMaybe<Scalars["String"]["input"]>;
	releaseAt?: InputMaybe<Scalars["Time"]["input"]>;
	sharingPolicy?: InputMaybe<SharingPolicyInNewsletterCreateInput>;
	socialComments?: InputMaybe<Array<SocialCommentInNewsletterCreateInput>>;
	socialReactions?: InputMaybe<Array<SocialReactionInNewsletterCreateInput>>;
	title: Scalars["String"]["input"];
};

export type NewsletterEdge = {
	__typename?: "NewsletterEdge";
	cursor: Scalars["Cursor"]["output"];
	node: Newsletter;
};

export type NewsletterFilterInput = {
	and?: InputMaybe<Array<NewsletterFilterInput>>;
	author?: InputMaybe<Array<UserFilterInput>>;
	authorIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	authorIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	authorIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	authorIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	authorIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	bodyContains?: InputMaybe<Scalars["String"]["input"]>;
	bodyEQ?: InputMaybe<Scalars["String"]["input"]>;
	bodyHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	bodyHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	bodyIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	bodyNEQ?: InputMaybe<Scalars["String"]["input"]>;
	bodyNotContains?: InputMaybe<Scalars["String"]["input"]>;
	bodyNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	bodyNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	bodyNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	hasAuthor?: InputMaybe<Scalars["Boolean"]["input"]>;
	hasSharingPolicy?: InputMaybe<Scalars["Boolean"]["input"]>;
	hasSocialComments?: InputMaybe<Scalars["Boolean"]["input"]>;
	hasSocialReactions?: InputMaybe<Scalars["Boolean"]["input"]>;
	idEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	imageContentTypeContains?: InputMaybe<Scalars["String"]["input"]>;
	imageContentTypeEQ?: InputMaybe<Scalars["String"]["input"]>;
	imageContentTypeHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	imageContentTypeHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	imageContentTypeIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	imageContentTypeNEQ?: InputMaybe<Scalars["String"]["input"]>;
	imageContentTypeNotContains?: InputMaybe<Scalars["String"]["input"]>;
	imageContentTypeNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	imageContentTypeNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	imageContentTypeNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	imageKeyContains?: InputMaybe<Scalars["String"]["input"]>;
	imageKeyEQ?: InputMaybe<Scalars["String"]["input"]>;
	imageKeyHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	imageKeyHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	imageKeyIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	imageKeyNEQ?: InputMaybe<Scalars["String"]["input"]>;
	imageKeyNotContains?: InputMaybe<Scalars["String"]["input"]>;
	imageKeyNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	imageKeyNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	imageKeyNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	not?: InputMaybe<NewsletterFilterInput>;
	or?: InputMaybe<Array<NewsletterFilterInput>>;
	releaseAtEQ?: InputMaybe<Scalars["Time"]["input"]>;
	releaseAtGT?: InputMaybe<Scalars["Time"]["input"]>;
	releaseAtGTE?: InputMaybe<Scalars["Time"]["input"]>;
	releaseAtIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	releaseAtIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	releaseAtLT?: InputMaybe<Scalars["Time"]["input"]>;
	releaseAtLTE?: InputMaybe<Scalars["Time"]["input"]>;
	releaseAtNEQ?: InputMaybe<Scalars["Time"]["input"]>;
	releaseAtNotIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	search?: InputMaybe<Scalars["String"]["input"]>;
	sharingPolicy?: InputMaybe<Array<SharingPolicyFilterInput>>;
	socialComments?: InputMaybe<Array<SocialCommentFilterInput>>;
	socialReactions?: InputMaybe<Array<SocialReactionFilterInput>>;
	titleContains?: InputMaybe<Scalars["String"]["input"]>;
	titleEQ?: InputMaybe<Scalars["String"]["input"]>;
	titleHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	titleHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	titleIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	titleNEQ?: InputMaybe<Scalars["String"]["input"]>;
	titleNotContains?: InputMaybe<Scalars["String"]["input"]>;
	titleNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	titleNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	titleNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
};

export type NewsletterHistory = Node & {
	__typename?: "NewsletterHistory";
	authorID: Maybe<Scalars["ID"]["output"]>;
	body: Maybe<Scalars["String"]["output"]>;
	historyIsSystem: Scalars["Boolean"]["output"];
	historyTime: Scalars["Time"]["output"];
	historyType: HistoryType;
	historyUserID: Maybe<Scalars["ID"]["output"]>;
	id: Scalars["ID"]["output"];
	imageContentType: Maybe<Scalars["String"]["output"]>;
	imageKey: Maybe<Scalars["String"]["output"]>;
	originalID: Maybe<Scalars["ID"]["output"]>;
	releaseAt: Maybe<Scalars["Time"]["output"]>;
	title: Maybe<Scalars["String"]["output"]>;
};

export type NewsletterHistoryConnection = {
	__typename?: "NewsletterHistoryConnection";
	edges: Array<NewsletterHistoryEdge>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"]["output"];
};

export type NewsletterHistoryEdge = {
	__typename?: "NewsletterHistoryEdge";
	cursor: Scalars["Cursor"]["output"];
	node: NewsletterHistory;
};

export type NewsletterHistoryFilterInput = {
	and?: InputMaybe<Array<NewsletterHistoryFilterInput>>;
	authorIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	authorIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	authorIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	authorIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	authorIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	bodyContains?: InputMaybe<Scalars["String"]["input"]>;
	bodyEQ?: InputMaybe<Scalars["String"]["input"]>;
	bodyHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	bodyHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	bodyIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	bodyIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	bodyNEQ?: InputMaybe<Scalars["String"]["input"]>;
	bodyNotContains?: InputMaybe<Scalars["String"]["input"]>;
	bodyNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	bodyNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	bodyNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	historyIsSystemEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyIsSystemNEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyTimeEQ?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeGT?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeGTE?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	historyTimeLT?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeLTE?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeNEQ?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeNotIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	historyTypeEQ?: InputMaybe<HistoryType>;
	historyTypeIn?: InputMaybe<Array<HistoryType>>;
	historyTypeNEQ?: InputMaybe<HistoryType>;
	historyTypeNotIn?: InputMaybe<Array<HistoryType>>;
	historyUserIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	historyUserIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	historyUserIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyUserIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	historyUserIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	imageContentTypeContains?: InputMaybe<Scalars["String"]["input"]>;
	imageContentTypeEQ?: InputMaybe<Scalars["String"]["input"]>;
	imageContentTypeHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	imageContentTypeHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	imageContentTypeIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	imageContentTypeIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	imageContentTypeNEQ?: InputMaybe<Scalars["String"]["input"]>;
	imageContentTypeNotContains?: InputMaybe<Scalars["String"]["input"]>;
	imageContentTypeNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	imageContentTypeNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	imageContentTypeNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	imageKeyContains?: InputMaybe<Scalars["String"]["input"]>;
	imageKeyEQ?: InputMaybe<Scalars["String"]["input"]>;
	imageKeyHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	imageKeyHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	imageKeyIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	imageKeyIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	imageKeyNEQ?: InputMaybe<Scalars["String"]["input"]>;
	imageKeyNotContains?: InputMaybe<Scalars["String"]["input"]>;
	imageKeyNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	imageKeyNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	imageKeyNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	not?: InputMaybe<NewsletterHistoryFilterInput>;
	or?: InputMaybe<Array<NewsletterHistoryFilterInput>>;
	originalIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	originalIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	originalIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	originalIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	originalIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	releaseAtEQ?: InputMaybe<Scalars["Time"]["input"]>;
	releaseAtGT?: InputMaybe<Scalars["Time"]["input"]>;
	releaseAtGTE?: InputMaybe<Scalars["Time"]["input"]>;
	releaseAtIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	releaseAtIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	releaseAtLT?: InputMaybe<Scalars["Time"]["input"]>;
	releaseAtLTE?: InputMaybe<Scalars["Time"]["input"]>;
	releaseAtNEQ?: InputMaybe<Scalars["Time"]["input"]>;
	releaseAtNotIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	search?: InputMaybe<Scalars["String"]["input"]>;
	titleContains?: InputMaybe<Scalars["String"]["input"]>;
	titleEQ?: InputMaybe<Scalars["String"]["input"]>;
	titleHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	titleHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	titleIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	titleIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	titleNEQ?: InputMaybe<Scalars["String"]["input"]>;
	titleNotContains?: InputMaybe<Scalars["String"]["input"]>;
	titleNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	titleNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	titleNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
};

export type NewsletterHistoryOrder = {
	direction: OrderDirection;
	field?: InputMaybe<NewsletterHistoryOrderField>;
};

export enum NewsletterHistoryOrderField {
	HistoryTime = "HISTORY_TIME",
}

export type NewsletterInAuthorCreateInput = {
	body: Scalars["String"]["input"];
	imageContentType?: InputMaybe<Scalars["String"]["input"]>;
	imageKey?: InputMaybe<Scalars["String"]["input"]>;
	releaseAt?: InputMaybe<Scalars["Time"]["input"]>;
	sharingPolicy?: InputMaybe<SharingPolicyInNewsletterCreateInput>;
	socialComments?: InputMaybe<Array<SocialCommentInNewsletterCreateInput>>;
	socialReactions?: InputMaybe<Array<SocialReactionInNewsletterCreateInput>>;
	title: Scalars["String"]["input"];
};

export type NewsletterInSharingPolicyCreateInput = {
	body: Scalars["String"]["input"];
	imageContentType?: InputMaybe<Scalars["String"]["input"]>;
	imageKey?: InputMaybe<Scalars["String"]["input"]>;
	releaseAt?: InputMaybe<Scalars["Time"]["input"]>;
	socialComments?: InputMaybe<Array<SocialCommentInNewsletterCreateInput>>;
	socialReactions?: InputMaybe<Array<SocialReactionInNewsletterCreateInput>>;
	title: Scalars["String"]["input"];
};

export type NewsletterOrder = {
	direction: OrderDirection;
	field?: InputMaybe<NewsletterOrderField>;
};

export enum NewsletterOrderField {
	ReleaseAt = "RELEASE_AT",
	Title = "TITLE",
}

export type NewsletterStatistics = {
	__typename?: "NewsletterStatistics";
	comments: Scalars["Int"]["output"];
	count: Scalars["Int"]["output"];
	reactions: Scalars["Int"]["output"];
	views: Scalars["Int"]["output"];
};

export type NewsletterUpdateBulkInput = {
	body?: InputMaybe<Scalars["String"]["input"]>;
	clearReleaseAt?: InputMaybe<Scalars["Boolean"]["input"]>;
	imageContentType?: InputMaybe<Scalars["String"]["input"]>;
	imageKey?: InputMaybe<Scalars["String"]["input"]>;
	releaseAt?: InputMaybe<Scalars["Time"]["input"]>;
	title?: InputMaybe<Scalars["String"]["input"]>;
};

export type NewsletterUpdateInput = {
	body?: InputMaybe<Scalars["String"]["input"]>;
	clearReleaseAt?: InputMaybe<Scalars["Boolean"]["input"]>;
	imageContentType?: InputMaybe<Scalars["String"]["input"]>;
	imageKey?: InputMaybe<Scalars["String"]["input"]>;
	releaseAt?: InputMaybe<Scalars["Time"]["input"]>;
	title?: InputMaybe<Scalars["String"]["input"]>;
};

export type Node = {
	id: Scalars["ID"]["output"];
};

export enum OrderDirection {
	Asc = "ASC",
	Desc = "DESC",
}

export type PageInfo = {
	__typename?: "PageInfo";
	endCursor: Maybe<Scalars["Cursor"]["output"]>;
	hasNextPage: Scalars["Boolean"]["output"];
	hasPreviousPage: Scalars["Boolean"]["output"];
	startCursor: Maybe<Scalars["Cursor"]["output"]>;
};

export type Pagination = {
	after?: InputMaybe<Scalars["Cursor"]["input"]>;
	before?: InputMaybe<Scalars["Cursor"]["input"]>;
	first?: InputMaybe<Scalars["Int"]["input"]>;
	last?: InputMaybe<Scalars["Int"]["input"]>;
};

export type Permission = Node & {
	__typename?: "Permission";
	action: Scalars["String"]["output"];
	description: Scalars["String"]["output"];
	family: Scalars["String"]["output"];
	id: Scalars["ID"]["output"];
	level: Scalars["String"]["output"];
	name: Scalars["String"]["output"];
	permissionGroups: Array<PermissionGroup>;
};

export type PermissionPermissionGroupsArgs = {
	filters?: InputMaybe<Array<PermissionGroupFilterInput>>;
	order?: InputMaybe<PermissionGroupOrder>;
	pagination?: InputMaybe<EdgePagination>;
};

export type PermissionConnection = {
	__typename?: "PermissionConnection";
	edges: Array<PermissionEdge>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"]["output"];
};

export type PermissionEdge = {
	__typename?: "PermissionEdge";
	cursor: Scalars["Cursor"]["output"];
	node: Permission;
};

export type PermissionFilterInput = {
	actionContains?: InputMaybe<Scalars["String"]["input"]>;
	actionEQ?: InputMaybe<Scalars["String"]["input"]>;
	actionHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	actionHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	actionIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	actionNEQ?: InputMaybe<Scalars["String"]["input"]>;
	actionNotContains?: InputMaybe<Scalars["String"]["input"]>;
	actionNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	actionNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	actionNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	and?: InputMaybe<Array<PermissionFilterInput>>;
	familyContains?: InputMaybe<Scalars["String"]["input"]>;
	familyEQ?: InputMaybe<Scalars["String"]["input"]>;
	familyHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	familyHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	familyIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	familyNEQ?: InputMaybe<Scalars["String"]["input"]>;
	familyNotContains?: InputMaybe<Scalars["String"]["input"]>;
	familyNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	familyNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	familyNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	hasPermissionGroups?: InputMaybe<Scalars["Boolean"]["input"]>;
	idEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	levelContains?: InputMaybe<Scalars["String"]["input"]>;
	levelEQ?: InputMaybe<Scalars["String"]["input"]>;
	levelHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	levelHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	levelIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	levelNEQ?: InputMaybe<Scalars["String"]["input"]>;
	levelNotContains?: InputMaybe<Scalars["String"]["input"]>;
	levelNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	levelNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	levelNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	not?: InputMaybe<PermissionFilterInput>;
	or?: InputMaybe<Array<PermissionFilterInput>>;
	permissionGroups?: InputMaybe<Array<PermissionGroupFilterInput>>;
	search?: InputMaybe<Scalars["String"]["input"]>;
};

export type PermissionGroup = Node & {
	__typename?: "PermissionGroup";
	description: Scalars["String"]["output"];
	id: Scalars["ID"]["output"];
	name: Scalars["String"]["output"];
	permissions: Array<Permission>;
	users: Array<User>;
};

export type PermissionGroupPermissionsArgs = {
	filters?: InputMaybe<Array<PermissionFilterInput>>;
	order?: InputMaybe<PermissionOrder>;
	pagination?: InputMaybe<EdgePagination>;
};

export type PermissionGroupUsersArgs = {
	filters?: InputMaybe<Array<UserFilterInput>>;
	order?: InputMaybe<UserOrder>;
	pagination?: InputMaybe<EdgePagination>;
};

export type PermissionGroupConnection = {
	__typename?: "PermissionGroupConnection";
	edges: Array<PermissionGroupEdge>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"]["output"];
};

export type PermissionGroupCreateInput = {
	description?: InputMaybe<Scalars["String"]["input"]>;
	name: Scalars["String"]["input"];
	permissionIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	userIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
};

export type PermissionGroupEdge = {
	__typename?: "PermissionGroupEdge";
	cursor: Scalars["Cursor"]["output"];
	node: PermissionGroup;
};

export type PermissionGroupFilterInput = {
	and?: InputMaybe<Array<PermissionGroupFilterInput>>;
	descriptionContains?: InputMaybe<Scalars["String"]["input"]>;
	descriptionEQ?: InputMaybe<Scalars["String"]["input"]>;
	descriptionHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	descriptionHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	descriptionIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	descriptionNEQ?: InputMaybe<Scalars["String"]["input"]>;
	descriptionNotContains?: InputMaybe<Scalars["String"]["input"]>;
	descriptionNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	descriptionNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	descriptionNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	hasPermissions?: InputMaybe<Scalars["Boolean"]["input"]>;
	hasUsers?: InputMaybe<Scalars["Boolean"]["input"]>;
	idEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	nameContains?: InputMaybe<Scalars["String"]["input"]>;
	nameEQ?: InputMaybe<Scalars["String"]["input"]>;
	nameHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	nameHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	nameIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	nameNEQ?: InputMaybe<Scalars["String"]["input"]>;
	nameNotContains?: InputMaybe<Scalars["String"]["input"]>;
	nameNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	nameNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	nameNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	not?: InputMaybe<PermissionGroupFilterInput>;
	or?: InputMaybe<Array<PermissionGroupFilterInput>>;
	permissions?: InputMaybe<Array<PermissionFilterInput>>;
	search?: InputMaybe<Scalars["String"]["input"]>;
	users?: InputMaybe<Array<UserFilterInput>>;
};

export type PermissionGroupHistory = Node & {
	__typename?: "PermissionGroupHistory";
	description: Maybe<Scalars["String"]["output"]>;
	historyIsSystem: Scalars["Boolean"]["output"];
	historyTime: Scalars["Time"]["output"];
	historyType: HistoryType;
	historyUserID: Maybe<Scalars["ID"]["output"]>;
	id: Scalars["ID"]["output"];
	name: Maybe<Scalars["String"]["output"]>;
	originalID: Maybe<Scalars["ID"]["output"]>;
};

export type PermissionGroupHistoryConnection = {
	__typename?: "PermissionGroupHistoryConnection";
	edges: Array<PermissionGroupHistoryEdge>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"]["output"];
};

export type PermissionGroupHistoryEdge = {
	__typename?: "PermissionGroupHistoryEdge";
	cursor: Scalars["Cursor"]["output"];
	node: PermissionGroupHistory;
};

export type PermissionGroupHistoryFilterInput = {
	and?: InputMaybe<Array<PermissionGroupHistoryFilterInput>>;
	descriptionContains?: InputMaybe<Scalars["String"]["input"]>;
	descriptionEQ?: InputMaybe<Scalars["String"]["input"]>;
	descriptionHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	descriptionHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	descriptionIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	descriptionIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	descriptionNEQ?: InputMaybe<Scalars["String"]["input"]>;
	descriptionNotContains?: InputMaybe<Scalars["String"]["input"]>;
	descriptionNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	descriptionNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	descriptionNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	historyIsSystemEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyIsSystemNEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyTimeEQ?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeGT?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeGTE?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	historyTimeLT?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeLTE?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeNEQ?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeNotIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	historyTypeEQ?: InputMaybe<HistoryType>;
	historyTypeIn?: InputMaybe<Array<HistoryType>>;
	historyTypeNEQ?: InputMaybe<HistoryType>;
	historyTypeNotIn?: InputMaybe<Array<HistoryType>>;
	historyUserIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	historyUserIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	historyUserIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyUserIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	historyUserIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	nameContains?: InputMaybe<Scalars["String"]["input"]>;
	nameEQ?: InputMaybe<Scalars["String"]["input"]>;
	nameHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	nameHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	nameIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	nameIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	nameNEQ?: InputMaybe<Scalars["String"]["input"]>;
	nameNotContains?: InputMaybe<Scalars["String"]["input"]>;
	nameNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	nameNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	nameNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	not?: InputMaybe<PermissionGroupHistoryFilterInput>;
	or?: InputMaybe<Array<PermissionGroupHistoryFilterInput>>;
	originalIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	originalIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	originalIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	originalIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	originalIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	search?: InputMaybe<Scalars["String"]["input"]>;
};

export type PermissionGroupHistoryOrder = {
	direction: OrderDirection;
	field?: InputMaybe<PermissionGroupHistoryOrderField>;
};

export enum PermissionGroupHistoryOrderField {
	HistoryTime = "HISTORY_TIME",
}

export type PermissionGroupOrder = {
	direction: OrderDirection;
	field?: InputMaybe<PermissionGroupOrderField>;
};

export enum PermissionGroupOrderField {
	Name = "NAME",
}

export type PermissionGroupPermissionHistory = Node & {
	__typename?: "PermissionGroupPermissionHistory";
	historyIsSystem: Scalars["Boolean"]["output"];
	historyTime: Scalars["Time"]["output"];
	historyType: HistoryType;
	historyUserID: Maybe<Scalars["ID"]["output"]>;
	id: Scalars["ID"]["output"];
	permissionGroupID: Maybe<Scalars["ID"]["output"]>;
	permissionID: Maybe<Scalars["ID"]["output"]>;
};

export type PermissionGroupPermissionHistoryConnection = {
	__typename?: "PermissionGroupPermissionHistoryConnection";
	edges: Array<PermissionGroupPermissionHistoryEdge>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"]["output"];
};

export type PermissionGroupPermissionHistoryEdge = {
	__typename?: "PermissionGroupPermissionHistoryEdge";
	cursor: Scalars["Cursor"]["output"];
	node: PermissionGroupPermissionHistory;
};

export type PermissionGroupPermissionHistoryFilterInput = {
	and?: InputMaybe<Array<PermissionGroupPermissionHistoryFilterInput>>;
	historyIsSystemEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyIsSystemNEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyTimeEQ?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeGT?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeGTE?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	historyTimeLT?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeLTE?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeNEQ?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeNotIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	historyTypeEQ?: InputMaybe<HistoryType>;
	historyTypeIn?: InputMaybe<Array<HistoryType>>;
	historyTypeNEQ?: InputMaybe<HistoryType>;
	historyTypeNotIn?: InputMaybe<Array<HistoryType>>;
	historyUserIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	historyUserIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	historyUserIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyUserIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	historyUserIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	not?: InputMaybe<PermissionGroupPermissionHistoryFilterInput>;
	or?: InputMaybe<Array<PermissionGroupPermissionHistoryFilterInput>>;
	permissionGroupIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	permissionGroupIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	permissionGroupIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	permissionGroupIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	permissionGroupIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	permissionIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	permissionIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	permissionIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	permissionIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	permissionIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
};

export type PermissionGroupPermissionHistoryOrder = {
	direction: OrderDirection;
	field?: InputMaybe<PermissionGroupPermissionHistoryOrderField>;
};

export enum PermissionGroupPermissionHistoryOrderField {
	HistoryTime = "HISTORY_TIME",
}

export type PermissionGroupUpdateBulkInput = {
	addPermissionIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	addUserIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	description?: InputMaybe<Scalars["String"]["input"]>;
	removePermissionIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	removeUserIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
};

export type PermissionGroupUpdateInput = {
	addPermissionIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	addUserIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	description?: InputMaybe<Scalars["String"]["input"]>;
	name?: InputMaybe<Scalars["String"]["input"]>;
	removePermissionIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	removeUserIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
};

export type PermissionGroupUserHistory = Node & {
	__typename?: "PermissionGroupUserHistory";
	historyIsSystem: Scalars["Boolean"]["output"];
	historyTime: Scalars["Time"]["output"];
	historyType: HistoryType;
	historyUserID: Maybe<Scalars["ID"]["output"]>;
	id: Scalars["ID"]["output"];
	permissionGroupID: Maybe<Scalars["ID"]["output"]>;
	userID: Maybe<Scalars["ID"]["output"]>;
};

export type PermissionGroupUserHistoryConnection = {
	__typename?: "PermissionGroupUserHistoryConnection";
	edges: Array<PermissionGroupUserHistoryEdge>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"]["output"];
};

export type PermissionGroupUserHistoryEdge = {
	__typename?: "PermissionGroupUserHistoryEdge";
	cursor: Scalars["Cursor"]["output"];
	node: PermissionGroupUserHistory;
};

export type PermissionGroupUserHistoryFilterInput = {
	and?: InputMaybe<Array<PermissionGroupUserHistoryFilterInput>>;
	historyIsSystemEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyIsSystemNEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyTimeEQ?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeGT?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeGTE?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	historyTimeLT?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeLTE?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeNEQ?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeNotIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	historyTypeEQ?: InputMaybe<HistoryType>;
	historyTypeIn?: InputMaybe<Array<HistoryType>>;
	historyTypeNEQ?: InputMaybe<HistoryType>;
	historyTypeNotIn?: InputMaybe<Array<HistoryType>>;
	historyUserIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	historyUserIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	historyUserIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyUserIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	historyUserIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	not?: InputMaybe<PermissionGroupUserHistoryFilterInput>;
	or?: InputMaybe<Array<PermissionGroupUserHistoryFilterInput>>;
	permissionGroupIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	permissionGroupIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	permissionGroupIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	permissionGroupIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	permissionGroupIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	userIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	userIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	userIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	userIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	userIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
};

export type PermissionGroupUserHistoryOrder = {
	direction: OrderDirection;
	field?: InputMaybe<PermissionGroupUserHistoryOrderField>;
};

export enum PermissionGroupUserHistoryOrderField {
	HistoryTime = "HISTORY_TIME",
}

export type PermissionHistory = Node & {
	__typename?: "PermissionHistory";
	action: Maybe<Scalars["String"]["output"]>;
	family: Maybe<Scalars["String"]["output"]>;
	historyIsSystem: Scalars["Boolean"]["output"];
	historyTime: Scalars["Time"]["output"];
	historyType: HistoryType;
	historyUserID: Maybe<Scalars["ID"]["output"]>;
	id: Scalars["ID"]["output"];
	level: Maybe<Scalars["String"]["output"]>;
	originalID: Maybe<Scalars["ID"]["output"]>;
};

export type PermissionHistoryConnection = {
	__typename?: "PermissionHistoryConnection";
	edges: Array<PermissionHistoryEdge>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"]["output"];
};

export type PermissionHistoryEdge = {
	__typename?: "PermissionHistoryEdge";
	cursor: Scalars["Cursor"]["output"];
	node: PermissionHistory;
};

export type PermissionHistoryFilterInput = {
	actionContains?: InputMaybe<Scalars["String"]["input"]>;
	actionEQ?: InputMaybe<Scalars["String"]["input"]>;
	actionHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	actionHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	actionIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	actionIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	actionNEQ?: InputMaybe<Scalars["String"]["input"]>;
	actionNotContains?: InputMaybe<Scalars["String"]["input"]>;
	actionNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	actionNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	actionNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	and?: InputMaybe<Array<PermissionHistoryFilterInput>>;
	familyContains?: InputMaybe<Scalars["String"]["input"]>;
	familyEQ?: InputMaybe<Scalars["String"]["input"]>;
	familyHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	familyHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	familyIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	familyIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	familyNEQ?: InputMaybe<Scalars["String"]["input"]>;
	familyNotContains?: InputMaybe<Scalars["String"]["input"]>;
	familyNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	familyNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	familyNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	historyIsSystemEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyIsSystemNEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyTimeEQ?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeGT?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeGTE?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	historyTimeLT?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeLTE?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeNEQ?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeNotIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	historyTypeEQ?: InputMaybe<HistoryType>;
	historyTypeIn?: InputMaybe<Array<HistoryType>>;
	historyTypeNEQ?: InputMaybe<HistoryType>;
	historyTypeNotIn?: InputMaybe<Array<HistoryType>>;
	historyUserIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	historyUserIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	historyUserIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyUserIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	historyUserIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	levelContains?: InputMaybe<Scalars["String"]["input"]>;
	levelEQ?: InputMaybe<Scalars["String"]["input"]>;
	levelHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	levelHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	levelIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	levelIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	levelNEQ?: InputMaybe<Scalars["String"]["input"]>;
	levelNotContains?: InputMaybe<Scalars["String"]["input"]>;
	levelNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	levelNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	levelNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	not?: InputMaybe<PermissionHistoryFilterInput>;
	or?: InputMaybe<Array<PermissionHistoryFilterInput>>;
	originalIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	originalIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	originalIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	originalIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	originalIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	search?: InputMaybe<Scalars["String"]["input"]>;
};

export type PermissionHistoryOrder = {
	direction: OrderDirection;
	field?: InputMaybe<PermissionHistoryOrderField>;
};

export enum PermissionHistoryOrderField {
	HistoryTime = "HISTORY_TIME",
}

export type PermissionOrder = {
	direction: OrderDirection;
	field?: InputMaybe<PermissionOrderField>;
};

export enum PermissionOrderField {
	Action = "ACTION",
	Family = "FAMILY",
	Level = "LEVEL",
}

export type PermissionUpdateBulkInput = {
	addPermissionGroupIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	removePermissionGroupIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
};

export type PermissionUpdateInput = {
	addPermissionGroupIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	removePermissionGroupIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
};

export type Post = Node & {
	__typename?: "Post";
	author: Maybe<User>;
	authorID: Maybe<Scalars["ID"]["output"]>;
	body: Scalars["String"]["output"];
	createdAt: Scalars["Time"]["output"];
	id: Scalars["ID"]["output"];
	mediaAttachments: Array<MediaAttachment>;
	sharingPolicy: Maybe<SharingPolicy>;
	socialComments: Array<SocialComment>;
	socialReactions: Array<SocialReaction>;
	title: Scalars["String"]["output"];
};

export type PostMediaAttachmentsArgs = {
	filters?: InputMaybe<Array<MediaAttachmentFilterInput>>;
	order?: InputMaybe<MediaAttachmentOrder>;
	pagination?: InputMaybe<EdgePagination>;
};

export type PostSocialCommentsArgs = {
	filters?: InputMaybe<Array<SocialCommentFilterInput>>;
	order?: InputMaybe<SocialCommentOrder>;
	pagination?: InputMaybe<EdgePagination>;
};

export type PostSocialReactionsArgs = {
	filters?: InputMaybe<Array<SocialReactionFilterInput>>;
	order?: InputMaybe<SocialReactionOrder>;
	pagination?: InputMaybe<EdgePagination>;
};

export type PostConnection = {
	__typename?: "PostConnection";
	edges: Array<PostEdge>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"]["output"];
};

export type PostCreateInput = {
	body?: InputMaybe<Scalars["String"]["input"]>;
	mediaAttachments?: InputMaybe<Array<MediaAttachmentInPostCreateInput>>;
	sharingPolicy?: InputMaybe<SharingPolicyInPostCreateInput>;
	socialComments?: InputMaybe<Array<SocialCommentInPostCreateInput>>;
	socialReactions?: InputMaybe<Array<SocialReactionInPostCreateInput>>;
	title?: InputMaybe<Scalars["String"]["input"]>;
};

export type PostEdge = {
	__typename?: "PostEdge";
	cursor: Scalars["Cursor"]["output"];
	node: Post;
};

export type PostFilterInput = {
	and?: InputMaybe<Array<PostFilterInput>>;
	author?: InputMaybe<Array<UserFilterInput>>;
	authorIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	authorIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	authorIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	authorIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	authorIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	bodyContains?: InputMaybe<Scalars["String"]["input"]>;
	bodyEQ?: InputMaybe<Scalars["String"]["input"]>;
	bodyHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	bodyHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	bodyIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	bodyNEQ?: InputMaybe<Scalars["String"]["input"]>;
	bodyNotContains?: InputMaybe<Scalars["String"]["input"]>;
	bodyNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	bodyNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	bodyNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	createdAtEQ?: InputMaybe<Scalars["Time"]["input"]>;
	createdAtGT?: InputMaybe<Scalars["Time"]["input"]>;
	createdAtGTE?: InputMaybe<Scalars["Time"]["input"]>;
	createdAtIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	createdAtLT?: InputMaybe<Scalars["Time"]["input"]>;
	createdAtLTE?: InputMaybe<Scalars["Time"]["input"]>;
	createdAtNEQ?: InputMaybe<Scalars["Time"]["input"]>;
	createdAtNotIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	hasAuthor?: InputMaybe<Scalars["Boolean"]["input"]>;
	hasMediaAttachments?: InputMaybe<Scalars["Boolean"]["input"]>;
	hasSharingPolicy?: InputMaybe<Scalars["Boolean"]["input"]>;
	hasSocialComments?: InputMaybe<Scalars["Boolean"]["input"]>;
	hasSocialReactions?: InputMaybe<Scalars["Boolean"]["input"]>;
	idEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	mediaAttachments?: InputMaybe<Array<MediaAttachmentFilterInput>>;
	not?: InputMaybe<PostFilterInput>;
	or?: InputMaybe<Array<PostFilterInput>>;
	search?: InputMaybe<Scalars["String"]["input"]>;
	sharingPolicy?: InputMaybe<Array<SharingPolicyFilterInput>>;
	socialComments?: InputMaybe<Array<SocialCommentFilterInput>>;
	socialReactions?: InputMaybe<Array<SocialReactionFilterInput>>;
	titleContains?: InputMaybe<Scalars["String"]["input"]>;
	titleEQ?: InputMaybe<Scalars["String"]["input"]>;
	titleHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	titleHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	titleIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	titleNEQ?: InputMaybe<Scalars["String"]["input"]>;
	titleNotContains?: InputMaybe<Scalars["String"]["input"]>;
	titleNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	titleNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	titleNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
};

export type PostHistory = Node & {
	__typename?: "PostHistory";
	authorID: Maybe<Scalars["ID"]["output"]>;
	body: Maybe<Scalars["String"]["output"]>;
	createdAt: Maybe<Scalars["Time"]["output"]>;
	historyIsSystem: Scalars["Boolean"]["output"];
	historyTime: Scalars["Time"]["output"];
	historyType: HistoryType;
	historyUserID: Maybe<Scalars["ID"]["output"]>;
	id: Scalars["ID"]["output"];
	originalID: Maybe<Scalars["ID"]["output"]>;
	title: Maybe<Scalars["String"]["output"]>;
};

export type PostHistoryConnection = {
	__typename?: "PostHistoryConnection";
	edges: Array<PostHistoryEdge>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"]["output"];
};

export type PostHistoryEdge = {
	__typename?: "PostHistoryEdge";
	cursor: Scalars["Cursor"]["output"];
	node: PostHistory;
};

export type PostHistoryFilterInput = {
	and?: InputMaybe<Array<PostHistoryFilterInput>>;
	authorIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	authorIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	authorIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	authorIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	authorIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	bodyContains?: InputMaybe<Scalars["String"]["input"]>;
	bodyEQ?: InputMaybe<Scalars["String"]["input"]>;
	bodyHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	bodyHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	bodyIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	bodyIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	bodyNEQ?: InputMaybe<Scalars["String"]["input"]>;
	bodyNotContains?: InputMaybe<Scalars["String"]["input"]>;
	bodyNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	bodyNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	bodyNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	createdAtEQ?: InputMaybe<Scalars["Time"]["input"]>;
	createdAtGT?: InputMaybe<Scalars["Time"]["input"]>;
	createdAtGTE?: InputMaybe<Scalars["Time"]["input"]>;
	createdAtIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	createdAtIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	createdAtLT?: InputMaybe<Scalars["Time"]["input"]>;
	createdAtLTE?: InputMaybe<Scalars["Time"]["input"]>;
	createdAtNEQ?: InputMaybe<Scalars["Time"]["input"]>;
	createdAtNotIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	historyIsSystemEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyIsSystemNEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyTimeEQ?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeGT?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeGTE?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	historyTimeLT?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeLTE?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeNEQ?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeNotIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	historyTypeEQ?: InputMaybe<HistoryType>;
	historyTypeIn?: InputMaybe<Array<HistoryType>>;
	historyTypeNEQ?: InputMaybe<HistoryType>;
	historyTypeNotIn?: InputMaybe<Array<HistoryType>>;
	historyUserIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	historyUserIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	historyUserIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyUserIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	historyUserIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	not?: InputMaybe<PostHistoryFilterInput>;
	or?: InputMaybe<Array<PostHistoryFilterInput>>;
	originalIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	originalIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	originalIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	originalIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	originalIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	search?: InputMaybe<Scalars["String"]["input"]>;
	titleContains?: InputMaybe<Scalars["String"]["input"]>;
	titleEQ?: InputMaybe<Scalars["String"]["input"]>;
	titleHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	titleHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	titleIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	titleIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	titleNEQ?: InputMaybe<Scalars["String"]["input"]>;
	titleNotContains?: InputMaybe<Scalars["String"]["input"]>;
	titleNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	titleNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	titleNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
};

export type PostHistoryOrder = {
	direction: OrderDirection;
	field?: InputMaybe<PostHistoryOrderField>;
};

export enum PostHistoryOrderField {
	HistoryTime = "HISTORY_TIME",
}

export type PostInAuthorCreateInput = {
	body?: InputMaybe<Scalars["String"]["input"]>;
	mediaAttachments?: InputMaybe<Array<MediaAttachmentInPostCreateInput>>;
	sharingPolicy?: InputMaybe<SharingPolicyInPostCreateInput>;
	socialComments?: InputMaybe<Array<SocialCommentInPostCreateInput>>;
	socialReactions?: InputMaybe<Array<SocialReactionInPostCreateInput>>;
	title?: InputMaybe<Scalars["String"]["input"]>;
};

export type PostInSharingPolicyCreateInput = {
	body?: InputMaybe<Scalars["String"]["input"]>;
	mediaAttachments?: InputMaybe<Array<MediaAttachmentInPostCreateInput>>;
	socialComments?: InputMaybe<Array<SocialCommentInPostCreateInput>>;
	socialReactions?: InputMaybe<Array<SocialReactionInPostCreateInput>>;
	title?: InputMaybe<Scalars["String"]["input"]>;
};

export type PostOrder = {
	direction: OrderDirection;
	field?: InputMaybe<PostOrderField>;
};

export enum PostOrderField {
	CreatedAt = "CREATED_AT",
}

export type PostStatistics = {
	__typename?: "PostStatistics";
	comments: Scalars["Int"]["output"];
	count: Scalars["Int"]["output"];
	reactions: Scalars["Int"]["output"];
	views: Scalars["Int"]["output"];
};

export type PostUpdateBulkInput = {
	body?: InputMaybe<Scalars["String"]["input"]>;
	title?: InputMaybe<Scalars["String"]["input"]>;
};

export type PostUpdateInput = {
	body?: InputMaybe<Scalars["String"]["input"]>;
	title?: InputMaybe<Scalars["String"]["input"]>;
};

export type Query = {
	__typename?: "Query";
	announcement: Announcement;
	announcementConnection: AnnouncementConnection;
	announcementHistory: AnnouncementHistory;
	announcementHistoryConnection: AnnouncementHistoryConnection;
	announcementStatistics: AnnouncementStatistics;
	calendarEvent: CalendarEvent;
	calendarEventConnection: CalendarEventConnection;
	calendarEventHistory: CalendarEventHistory;
	calendarEventHistoryConnection: CalendarEventHistoryConnection;
	calendarEventResponse: CalendarEventResponse;
	calendarEventResponseConnection: CalendarEventResponseConnection;
	calendarEventResponseHistory: CalendarEventResponseHistory;
	calendarEventResponseHistoryConnection: CalendarEventResponseHistoryConnection;
	calendarEventStatistics: CalendarEventStatistics;
	latestMessageByGroupConnection: MessageConnection;
	loginRecord: LoginRecord;
	loginRecordConnection: LoginRecordConnection;
	mediaAttachment: MediaAttachment;
	mediaAttachmentConnection: MediaAttachmentConnection;
	mediaAttachmentHistory: MediaAttachmentHistory;
	mediaAttachmentHistoryConnection: MediaAttachmentHistoryConnection;
	message: Message;
	messageConnection: MessageConnection;
	messageGroup: MessageGroup;
	messageGroupArchivePoint: MessageGroupArchivePoint;
	messageGroupArchivePointConnection: MessageGroupArchivePointConnection;
	messageGroupArchivePointHistory: MessageGroupArchivePointHistory;
	messageGroupArchivePointHistoryConnection: MessageGroupArchivePointHistoryConnection;
	messageGroupConnection: MessageGroupConnection;
	messageGroupHistory: MessageGroupHistory;
	messageGroupHistoryConnection: MessageGroupHistoryConnection;
	messageGroupUserGroupHistory: MessageGroupUserGroupHistory;
	messageGroupUserGroupHistoryConnection: MessageGroupUserGroupHistoryConnection;
	messageGroupUserHistory: MessageGroupUserHistory;
	messageGroupUserHistoryConnection: MessageGroupUserHistoryConnection;
	messageHistory: MessageHistory;
	messageHistoryConnection: MessageHistoryConnection;
	messageTopic: MessageTopic;
	messageTopicConnection: MessageTopicConnection;
	messageTopicHistory: MessageTopicHistory;
	messageTopicHistoryConnection: MessageTopicHistoryConnection;
	mfaFactor: MFAFactor;
	mfaFactorConnection: MFAFactorConnection;
	mfaInvalidOTPAttempt: MFAInvalidOTPAttempt;
	mfaInvalidOTPAttemptConnection: MFAInvalidOTPAttemptConnection;
	modelIDs: Array<ModelIdInformation>;
	newsletter: Newsletter;
	newsletterConnection: NewsletterConnection;
	newsletterHistory: NewsletterHistory;
	newsletterHistoryConnection: NewsletterHistoryConnection;
	newsletterStatistics: NewsletterStatistics;
	node: Maybe<Node>;
	permission: Permission;
	permissionConnection: PermissionConnection;
	permissionGroup: PermissionGroup;
	permissionGroupConnection: PermissionGroupConnection;
	permissionGroupHistory: PermissionGroupHistory;
	permissionGroupHistoryConnection: PermissionGroupHistoryConnection;
	permissionGroupPermissionHistory: PermissionGroupPermissionHistory;
	permissionGroupPermissionHistoryConnection: PermissionGroupPermissionHistoryConnection;
	permissionGroupUserHistory: PermissionGroupUserHistory;
	permissionGroupUserHistoryConnection: PermissionGroupUserHistoryConnection;
	permissionHistory: PermissionHistory;
	permissionHistoryConnection: PermissionHistoryConnection;
	post: Post;
	postConnection: PostConnection;
	postHistory: PostHistory;
	postHistoryConnection: PostHistoryConnection;
	postStatistics: PostStatistics;
	root: Scalars["Boolean"]["output"];
	searchResult: SearchResult;
	searchResultConnection: SearchResultConnection;
	session: Session;
	sessionConnection: SessionConnection;
	sharedUserConnection: UserConnection;
	sharingPolicy: SharingPolicy;
	sharingPolicyConnection: SharingPolicyConnection;
	sharingPolicyHistory: SharingPolicyHistory;
	sharingPolicyHistoryConnection: SharingPolicyHistoryConnection;
	sharingPolicySharedSharingPolicyUserSharedUserHistory: SharingPolicySharedSharingPolicyUserSharedUserHistory;
	sharingPolicySharedSharingPolicyUserSharedUserHistoryConnection: SharingPolicySharedSharingPolicyUserSharedUserHistoryConnection;
	sharingPolicyUserGroupHistory: SharingPolicyUserGroupHistory;
	sharingPolicyUserGroupHistoryConnection: SharingPolicyUserGroupHistoryConnection;
	sharingPolicyUserHistory: SharingPolicyUserHistory;
	sharingPolicyUserHistoryConnection: SharingPolicyUserHistoryConnection;
	socialComment: SocialComment;
	socialCommentConnection: SocialCommentConnection;
	socialCommentHistory: SocialCommentHistory;
	socialCommentHistoryConnection: SocialCommentHistoryConnection;
	socialReaction: SocialReaction;
	socialReactionConnection: SocialReactionConnection;
	socialReactionHistory: SocialReactionHistory;
	socialReactionHistoryConnection: SocialReactionHistoryConnection;
	timeline: TimelineConnection;
	trustedDevice: TrustedDevice;
	trustedDeviceConnection: TrustedDeviceConnection;
	unreadMessagesCount: Scalars["Int"]["output"];
	user: User;
	userConnection: UserConnection;
	userConnectionByBirthday: UserConnection;
	userExternalNotificationMarker: UserExternalNotificationMarker;
	userExternalNotificationMarkerConnection: UserExternalNotificationMarkerConnection;
	userGroup: UserGroup;
	userGroupConnection: UserGroupConnection;
	userGroupHistory: UserGroupHistory;
	userGroupHistoryConnection: UserGroupHistoryConnection;
	userGroupMemberGroupUserMemberHistory: UserGroupMemberGroupUserMemberHistory;
	userGroupMemberGroupUserMemberHistoryConnection: UserGroupMemberGroupUserMemberHistoryConnection;
	userGroupUserHistory: UserGroupUserHistory;
	userGroupUserHistoryConnection: UserGroupUserHistoryConnection;
	userHistory: UserHistory;
	userHistoryConnection: UserHistoryConnection;
	userViewRecord: UserViewRecord;
	userViewRecordConnection: UserViewRecordConnection;
	viewer: User;
};

export type QueryAnnouncementArgs = {
	id: Scalars["ID"]["input"];
};

export type QueryAnnouncementConnectionArgs = {
	filters?: InputMaybe<Array<AnnouncementFilterInput>>;
	order?: InputMaybe<AnnouncementOrder>;
	pagination?: InputMaybe<Pagination>;
};

export type QueryAnnouncementHistoryArgs = {
	id: Scalars["ID"]["input"];
};

export type QueryAnnouncementHistoryConnectionArgs = {
	filters?: InputMaybe<Array<AnnouncementHistoryFilterInput>>;
	order?: InputMaybe<AnnouncementHistoryOrder>;
	pagination?: InputMaybe<Pagination>;
};

export type QueryAnnouncementStatisticsArgs = {
	filters?: InputMaybe<Array<AnnouncementFilterInput>>;
};

export type QueryCalendarEventArgs = {
	id: Scalars["ID"]["input"];
};

export type QueryCalendarEventConnectionArgs = {
	filters?: InputMaybe<Array<CalendarEventFilterInput>>;
	order?: InputMaybe<CalendarEventOrder>;
	pagination?: InputMaybe<Pagination>;
};

export type QueryCalendarEventHistoryArgs = {
	id: Scalars["ID"]["input"];
};

export type QueryCalendarEventHistoryConnectionArgs = {
	filters?: InputMaybe<Array<CalendarEventHistoryFilterInput>>;
	order?: InputMaybe<CalendarEventHistoryOrder>;
	pagination?: InputMaybe<Pagination>;
};

export type QueryCalendarEventResponseArgs = {
	id: Scalars["ID"]["input"];
};

export type QueryCalendarEventResponseConnectionArgs = {
	filters?: InputMaybe<Array<CalendarEventResponseFilterInput>>;
	order?: InputMaybe<CalendarEventResponseOrder>;
	pagination?: InputMaybe<Pagination>;
};

export type QueryCalendarEventResponseHistoryArgs = {
	id: Scalars["ID"]["input"];
};

export type QueryCalendarEventResponseHistoryConnectionArgs = {
	filters?: InputMaybe<Array<CalendarEventResponseHistoryFilterInput>>;
	order?: InputMaybe<CalendarEventResponseHistoryOrder>;
	pagination?: InputMaybe<Pagination>;
};

export type QueryCalendarEventStatisticsArgs = {
	filters?: InputMaybe<Array<CalendarEventFilterInput>>;
};

export type QueryLatestMessageByGroupConnectionArgs = {
	archived?: InputMaybe<Scalars["Boolean"]["input"]>;
	filters?: InputMaybe<Array<MessageFilterInput>>;
	order?: InputMaybe<MessageOrder>;
	pagination?: InputMaybe<Pagination>;
};

export type QueryLoginRecordArgs = {
	id: Scalars["ID"]["input"];
};

export type QueryLoginRecordConnectionArgs = {
	filters?: InputMaybe<Array<LoginRecordFilterInput>>;
	order?: InputMaybe<LoginRecordOrder>;
	pagination?: InputMaybe<Pagination>;
};

export type QueryMediaAttachmentArgs = {
	id: Scalars["ID"]["input"];
};

export type QueryMediaAttachmentConnectionArgs = {
	filters?: InputMaybe<Array<MediaAttachmentFilterInput>>;
	order?: InputMaybe<MediaAttachmentOrder>;
	pagination?: InputMaybe<Pagination>;
};

export type QueryMediaAttachmentHistoryArgs = {
	id: Scalars["ID"]["input"];
};

export type QueryMediaAttachmentHistoryConnectionArgs = {
	filters?: InputMaybe<Array<MediaAttachmentHistoryFilterInput>>;
	order?: InputMaybe<MediaAttachmentHistoryOrder>;
	pagination?: InputMaybe<Pagination>;
};

export type QueryMessageArgs = {
	id: Scalars["ID"]["input"];
};

export type QueryMessageConnectionArgs = {
	filters?: InputMaybe<Array<MessageFilterInput>>;
	order?: InputMaybe<MessageOrder>;
	pagination?: InputMaybe<Pagination>;
};

export type QueryMessageGroupArgs = {
	id: Scalars["ID"]["input"];
};

export type QueryMessageGroupArchivePointArgs = {
	id: Scalars["ID"]["input"];
};

export type QueryMessageGroupArchivePointConnectionArgs = {
	filters?: InputMaybe<Array<MessageGroupArchivePointFilterInput>>;
	order?: InputMaybe<MessageGroupArchivePointOrder>;
	pagination?: InputMaybe<Pagination>;
};

export type QueryMessageGroupArchivePointHistoryArgs = {
	id: Scalars["ID"]["input"];
};

export type QueryMessageGroupArchivePointHistoryConnectionArgs = {
	filters?: InputMaybe<Array<MessageGroupArchivePointHistoryFilterInput>>;
	order?: InputMaybe<MessageGroupArchivePointHistoryOrder>;
	pagination?: InputMaybe<Pagination>;
};

export type QueryMessageGroupConnectionArgs = {
	filters?: InputMaybe<Array<MessageGroupFilterInput>>;
	order?: InputMaybe<MessageGroupOrder>;
	pagination?: InputMaybe<Pagination>;
};

export type QueryMessageGroupHistoryArgs = {
	id: Scalars["ID"]["input"];
};

export type QueryMessageGroupHistoryConnectionArgs = {
	filters?: InputMaybe<Array<MessageGroupHistoryFilterInput>>;
	order?: InputMaybe<MessageGroupHistoryOrder>;
	pagination?: InputMaybe<Pagination>;
};

export type QueryMessageGroupUserGroupHistoryArgs = {
	id: Scalars["ID"]["input"];
};

export type QueryMessageGroupUserGroupHistoryConnectionArgs = {
	filters?: InputMaybe<Array<MessageGroupUserGroupHistoryFilterInput>>;
	order?: InputMaybe<MessageGroupUserGroupHistoryOrder>;
	pagination?: InputMaybe<Pagination>;
};

export type QueryMessageGroupUserHistoryArgs = {
	id: Scalars["ID"]["input"];
};

export type QueryMessageGroupUserHistoryConnectionArgs = {
	filters?: InputMaybe<Array<MessageGroupUserHistoryFilterInput>>;
	order?: InputMaybe<MessageGroupUserHistoryOrder>;
	pagination?: InputMaybe<Pagination>;
};

export type QueryMessageHistoryArgs = {
	id: Scalars["ID"]["input"];
};

export type QueryMessageHistoryConnectionArgs = {
	filters?: InputMaybe<Array<MessageHistoryFilterInput>>;
	order?: InputMaybe<MessageHistoryOrder>;
	pagination?: InputMaybe<Pagination>;
};

export type QueryMessageTopicArgs = {
	id: Scalars["ID"]["input"];
};

export type QueryMessageTopicConnectionArgs = {
	filters?: InputMaybe<Array<MessageTopicFilterInput>>;
	order?: InputMaybe<MessageTopicOrder>;
	pagination?: InputMaybe<Pagination>;
};

export type QueryMessageTopicHistoryArgs = {
	id: Scalars["ID"]["input"];
};

export type QueryMessageTopicHistoryConnectionArgs = {
	filters?: InputMaybe<Array<MessageTopicHistoryFilterInput>>;
	order?: InputMaybe<MessageTopicHistoryOrder>;
	pagination?: InputMaybe<Pagination>;
};

export type QueryMFAFactorArgs = {
	id: Scalars["ID"]["input"];
};

export type QueryMFAFactorConnectionArgs = {
	filters?: InputMaybe<Array<MFAFactorFilterInput>>;
	order?: InputMaybe<MFAFactorOrder>;
	pagination?: InputMaybe<Pagination>;
};

export type QueryMFAInvalidOTPAttemptArgs = {
	id: Scalars["ID"]["input"];
};

export type QueryMFAInvalidOTPAttemptConnectionArgs = {
	filters?: InputMaybe<Array<MFAInvalidOTPAttemptFilterInput>>;
	order?: InputMaybe<MFAInvalidOTPAttemptOrder>;
	pagination?: InputMaybe<Pagination>;
};

export type QueryNewsletterArgs = {
	id: Scalars["ID"]["input"];
};

export type QueryNewsletterConnectionArgs = {
	filters?: InputMaybe<Array<NewsletterFilterInput>>;
	order?: InputMaybe<NewsletterOrder>;
	pagination?: InputMaybe<Pagination>;
};

export type QueryNewsletterHistoryArgs = {
	id: Scalars["ID"]["input"];
};

export type QueryNewsletterHistoryConnectionArgs = {
	filters?: InputMaybe<Array<NewsletterHistoryFilterInput>>;
	order?: InputMaybe<NewsletterHistoryOrder>;
	pagination?: InputMaybe<Pagination>;
};

export type QueryNewsletterStatisticsArgs = {
	filters?: InputMaybe<Array<NewsletterFilterInput>>;
};

export type QueryNodeArgs = {
	id: Scalars["ID"]["input"];
};

export type QueryPermissionArgs = {
	id: Scalars["ID"]["input"];
};

export type QueryPermissionConnectionArgs = {
	filters?: InputMaybe<Array<PermissionFilterInput>>;
	order?: InputMaybe<PermissionOrder>;
	pagination?: InputMaybe<Pagination>;
};

export type QueryPermissionGroupArgs = {
	id: Scalars["ID"]["input"];
};

export type QueryPermissionGroupConnectionArgs = {
	filters?: InputMaybe<Array<PermissionGroupFilterInput>>;
	order?: InputMaybe<PermissionGroupOrder>;
	pagination?: InputMaybe<Pagination>;
};

export type QueryPermissionGroupHistoryArgs = {
	id: Scalars["ID"]["input"];
};

export type QueryPermissionGroupHistoryConnectionArgs = {
	filters?: InputMaybe<Array<PermissionGroupHistoryFilterInput>>;
	order?: InputMaybe<PermissionGroupHistoryOrder>;
	pagination?: InputMaybe<Pagination>;
};

export type QueryPermissionGroupPermissionHistoryArgs = {
	id: Scalars["ID"]["input"];
};

export type QueryPermissionGroupPermissionHistoryConnectionArgs = {
	filters?: InputMaybe<Array<PermissionGroupPermissionHistoryFilterInput>>;
	order?: InputMaybe<PermissionGroupPermissionHistoryOrder>;
	pagination?: InputMaybe<Pagination>;
};

export type QueryPermissionGroupUserHistoryArgs = {
	id: Scalars["ID"]["input"];
};

export type QueryPermissionGroupUserHistoryConnectionArgs = {
	filters?: InputMaybe<Array<PermissionGroupUserHistoryFilterInput>>;
	order?: InputMaybe<PermissionGroupUserHistoryOrder>;
	pagination?: InputMaybe<Pagination>;
};

export type QueryPermissionHistoryArgs = {
	id: Scalars["ID"]["input"];
};

export type QueryPermissionHistoryConnectionArgs = {
	filters?: InputMaybe<Array<PermissionHistoryFilterInput>>;
	order?: InputMaybe<PermissionHistoryOrder>;
	pagination?: InputMaybe<Pagination>;
};

export type QueryPostArgs = {
	id: Scalars["ID"]["input"];
};

export type QueryPostConnectionArgs = {
	filters?: InputMaybe<Array<PostFilterInput>>;
	order?: InputMaybe<PostOrder>;
	pagination?: InputMaybe<Pagination>;
};

export type QueryPostHistoryArgs = {
	id: Scalars["ID"]["input"];
};

export type QueryPostHistoryConnectionArgs = {
	filters?: InputMaybe<Array<PostHistoryFilterInput>>;
	order?: InputMaybe<PostHistoryOrder>;
	pagination?: InputMaybe<Pagination>;
};

export type QueryPostStatisticsArgs = {
	filters?: InputMaybe<Array<PostFilterInput>>;
};

export type QuerySearchResultArgs = {
	id: Scalars["ID"]["input"];
};

export type QuerySearchResultConnectionArgs = {
	filters?: InputMaybe<Array<SearchResultFilterInput>>;
	order?: InputMaybe<SearchResultOrder>;
	pagination?: InputMaybe<Pagination>;
};

export type QuerySessionArgs = {
	id: Scalars["ID"]["input"];
};

export type QuerySessionConnectionArgs = {
	filters?: InputMaybe<Array<SessionFilterInput>>;
	order?: InputMaybe<SessionOrder>;
	pagination?: InputMaybe<Pagination>;
};

export type QuerySharedUserConnectionArgs = {
	filters?: InputMaybe<Array<UserFilterInput>>;
	order?: InputMaybe<UserOrder>;
	pagination?: InputMaybe<Pagination>;
	sharingPolicy: SharingPolicyCreateInput;
};

export type QuerySharingPolicyArgs = {
	id: Scalars["ID"]["input"];
};

export type QuerySharingPolicyConnectionArgs = {
	filters?: InputMaybe<Array<SharingPolicyFilterInput>>;
	order?: InputMaybe<SharingPolicyOrder>;
	pagination?: InputMaybe<Pagination>;
};

export type QuerySharingPolicyHistoryArgs = {
	id: Scalars["ID"]["input"];
};

export type QuerySharingPolicyHistoryConnectionArgs = {
	filters?: InputMaybe<Array<SharingPolicyHistoryFilterInput>>;
	order?: InputMaybe<SharingPolicyHistoryOrder>;
	pagination?: InputMaybe<Pagination>;
};

export type QuerySharingPolicySharedSharingPolicyUserSharedUserHistoryArgs = {
	id: Scalars["ID"]["input"];
};

export type QuerySharingPolicySharedSharingPolicyUserSharedUserHistoryConnectionArgs = {
	filters?: InputMaybe<Array<SharingPolicySharedSharingPolicyUserSharedUserHistoryFilterInput>>;
	order?: InputMaybe<SharingPolicySharedSharingPolicyUserSharedUserHistoryOrder>;
	pagination?: InputMaybe<Pagination>;
};

export type QuerySharingPolicyUserGroupHistoryArgs = {
	id: Scalars["ID"]["input"];
};

export type QuerySharingPolicyUserGroupHistoryConnectionArgs = {
	filters?: InputMaybe<Array<SharingPolicyUserGroupHistoryFilterInput>>;
	order?: InputMaybe<SharingPolicyUserGroupHistoryOrder>;
	pagination?: InputMaybe<Pagination>;
};

export type QuerySharingPolicyUserHistoryArgs = {
	id: Scalars["ID"]["input"];
};

export type QuerySharingPolicyUserHistoryConnectionArgs = {
	filters?: InputMaybe<Array<SharingPolicyUserHistoryFilterInput>>;
	order?: InputMaybe<SharingPolicyUserHistoryOrder>;
	pagination?: InputMaybe<Pagination>;
};

export type QuerySocialCommentArgs = {
	id: Scalars["ID"]["input"];
};

export type QuerySocialCommentConnectionArgs = {
	filters?: InputMaybe<Array<SocialCommentFilterInput>>;
	order?: InputMaybe<SocialCommentOrder>;
	pagination?: InputMaybe<Pagination>;
};

export type QuerySocialCommentHistoryArgs = {
	id: Scalars["ID"]["input"];
};

export type QuerySocialCommentHistoryConnectionArgs = {
	filters?: InputMaybe<Array<SocialCommentHistoryFilterInput>>;
	order?: InputMaybe<SocialCommentHistoryOrder>;
	pagination?: InputMaybe<Pagination>;
};

export type QuerySocialReactionArgs = {
	id: Scalars["ID"]["input"];
};

export type QuerySocialReactionConnectionArgs = {
	filters?: InputMaybe<Array<SocialReactionFilterInput>>;
	order?: InputMaybe<SocialReactionOrder>;
	pagination?: InputMaybe<Pagination>;
};

export type QuerySocialReactionHistoryArgs = {
	id: Scalars["ID"]["input"];
};

export type QuerySocialReactionHistoryConnectionArgs = {
	filters?: InputMaybe<Array<SocialReactionHistoryFilterInput>>;
	order?: InputMaybe<SocialReactionHistoryOrder>;
	pagination?: InputMaybe<Pagination>;
};

export type QueryTimelineArgs = {
	filter?: InputMaybe<TimelineFilterInput>;
	pagination?: InputMaybe<TimelinePagination>;
	timeZone?: InputMaybe<Scalars["String"]["input"]>;
};

export type QueryTrustedDeviceArgs = {
	id: Scalars["ID"]["input"];
};

export type QueryTrustedDeviceConnectionArgs = {
	filters?: InputMaybe<Array<TrustedDeviceFilterInput>>;
	order?: InputMaybe<TrustedDeviceOrder>;
	pagination?: InputMaybe<Pagination>;
};

export type QueryUserArgs = {
	id: Scalars["ID"]["input"];
};

export type QueryUserConnectionArgs = {
	filters?: InputMaybe<Array<UserFilterInput>>;
	order?: InputMaybe<UserOrder>;
	pagination?: InputMaybe<Pagination>;
};

export type QueryUserConnectionByBirthdayArgs = {
	dates: Array<Scalars["Time"]["input"]>;
	filters?: InputMaybe<Array<UserFilterInput>>;
	order?: InputMaybe<UserOrder>;
	pagination?: InputMaybe<Pagination>;
};

export type QueryUserExternalNotificationMarkerArgs = {
	id: Scalars["ID"]["input"];
};

export type QueryUserExternalNotificationMarkerConnectionArgs = {
	filters?: InputMaybe<Array<UserExternalNotificationMarkerFilterInput>>;
	order?: InputMaybe<UserExternalNotificationMarkerOrder>;
	pagination?: InputMaybe<Pagination>;
};

export type QueryUserGroupArgs = {
	id: Scalars["ID"]["input"];
};

export type QueryUserGroupConnectionArgs = {
	filters?: InputMaybe<Array<UserGroupFilterInput>>;
	order?: InputMaybe<UserGroupOrder>;
	pagination?: InputMaybe<Pagination>;
};

export type QueryUserGroupHistoryArgs = {
	id: Scalars["ID"]["input"];
};

export type QueryUserGroupHistoryConnectionArgs = {
	filters?: InputMaybe<Array<UserGroupHistoryFilterInput>>;
	order?: InputMaybe<UserGroupHistoryOrder>;
	pagination?: InputMaybe<Pagination>;
};

export type QueryUserGroupMemberGroupUserMemberHistoryArgs = {
	id: Scalars["ID"]["input"];
};

export type QueryUserGroupMemberGroupUserMemberHistoryConnectionArgs = {
	filters?: InputMaybe<Array<UserGroupMemberGroupUserMemberHistoryFilterInput>>;
	order?: InputMaybe<UserGroupMemberGroupUserMemberHistoryOrder>;
	pagination?: InputMaybe<Pagination>;
};

export type QueryUserGroupUserHistoryArgs = {
	id: Scalars["ID"]["input"];
};

export type QueryUserGroupUserHistoryConnectionArgs = {
	filters?: InputMaybe<Array<UserGroupUserHistoryFilterInput>>;
	order?: InputMaybe<UserGroupUserHistoryOrder>;
	pagination?: InputMaybe<Pagination>;
};

export type QueryUserHistoryArgs = {
	id: Scalars["ID"]["input"];
};

export type QueryUserHistoryConnectionArgs = {
	filters?: InputMaybe<Array<UserHistoryFilterInput>>;
	order?: InputMaybe<UserHistoryOrder>;
	pagination?: InputMaybe<Pagination>;
};

export type QueryUserViewRecordArgs = {
	id: Scalars["ID"]["input"];
};

export type QueryUserViewRecordConnectionArgs = {
	filters?: InputMaybe<Array<UserViewRecordFilterInput>>;
	order?: InputMaybe<UserViewRecordOrder>;
	pagination?: InputMaybe<Pagination>;
};

export type SearchResult = Node & {
	__typename?: "SearchResult";
	id: Scalars["ID"]["output"];
	modelName: Scalars["String"]["output"];
	name: Scalars["String"]["output"];
	searchText: Scalars["String"]["output"];
};

export type SearchResultConnection = {
	__typename?: "SearchResultConnection";
	edges: Array<SearchResultEdge>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"]["output"];
};

export type SearchResultEdge = {
	__typename?: "SearchResultEdge";
	cursor: Scalars["Cursor"]["output"];
	node: SearchResult;
};

export type SearchResultFilterInput = {
	and?: InputMaybe<Array<SearchResultFilterInput>>;
	idEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	modelNameContains?: InputMaybe<Scalars["String"]["input"]>;
	modelNameEQ?: InputMaybe<Scalars["String"]["input"]>;
	modelNameHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	modelNameHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	modelNameIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	modelNameNEQ?: InputMaybe<Scalars["String"]["input"]>;
	modelNameNotContains?: InputMaybe<Scalars["String"]["input"]>;
	modelNameNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	modelNameNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	modelNameNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	nameContains?: InputMaybe<Scalars["String"]["input"]>;
	nameEQ?: InputMaybe<Scalars["String"]["input"]>;
	nameHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	nameHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	nameIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	nameNEQ?: InputMaybe<Scalars["String"]["input"]>;
	nameNotContains?: InputMaybe<Scalars["String"]["input"]>;
	nameNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	nameNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	nameNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	not?: InputMaybe<SearchResultFilterInput>;
	or?: InputMaybe<Array<SearchResultFilterInput>>;
	search?: InputMaybe<Scalars["String"]["input"]>;
	searchTextContains?: InputMaybe<Scalars["String"]["input"]>;
	searchTextEQ?: InputMaybe<Scalars["String"]["input"]>;
	searchTextHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	searchTextHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	searchTextIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	searchTextNEQ?: InputMaybe<Scalars["String"]["input"]>;
	searchTextNotContains?: InputMaybe<Scalars["String"]["input"]>;
	searchTextNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	searchTextNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	searchTextNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
};

export type SearchResultOrder = {
	direction: OrderDirection;
	field?: InputMaybe<SearchResultOrderField>;
};

export enum SearchResultOrderField {
	ModelName = "MODEL_NAME",
	Name = "NAME",
}

export type Session = Node & {
	__typename?: "Session";
	createdAt: Scalars["Time"]["output"];
	expiresAt: Scalars["Time"]["output"];
	id: Scalars["ID"]["output"];
	isCurrent: Scalars["Boolean"]["output"];
	isVerified: Scalars["Boolean"]["output"];
	loginRecord: Maybe<LoginRecord>;
	longestInactiveSec: Scalars["Int"]["output"];
	mfaInvalidOTPAttempts: Array<MFAInvalidOTPAttempt>;
	trustedDevice: Maybe<TrustedDevice>;
	trustedDeviceID: Maybe<Scalars["ID"]["output"]>;
	updatedAt: Scalars["Time"]["output"];
	user: User;
	userID: Scalars["ID"]["output"];
};

export type SessionMFAInvalidOTPAttemptsArgs = {
	filters?: InputMaybe<Array<MFAInvalidOTPAttemptFilterInput>>;
	order?: InputMaybe<MFAInvalidOTPAttemptOrder>;
	pagination?: InputMaybe<EdgePagination>;
};

export type SessionConnection = {
	__typename?: "SessionConnection";
	edges: Array<SessionEdge>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"]["output"];
};

export type SessionEdge = {
	__typename?: "SessionEdge";
	cursor: Scalars["Cursor"]["output"];
	node: Session;
};

export type SessionFilterInput = {
	and?: InputMaybe<Array<SessionFilterInput>>;
	createdAtEQ?: InputMaybe<Scalars["Time"]["input"]>;
	createdAtGT?: InputMaybe<Scalars["Time"]["input"]>;
	createdAtGTE?: InputMaybe<Scalars["Time"]["input"]>;
	createdAtIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	createdAtLT?: InputMaybe<Scalars["Time"]["input"]>;
	createdAtLTE?: InputMaybe<Scalars["Time"]["input"]>;
	createdAtNEQ?: InputMaybe<Scalars["Time"]["input"]>;
	createdAtNotIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	expiresAtEQ?: InputMaybe<Scalars["Time"]["input"]>;
	expiresAtGT?: InputMaybe<Scalars["Time"]["input"]>;
	expiresAtGTE?: InputMaybe<Scalars["Time"]["input"]>;
	expiresAtIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	expiresAtLT?: InputMaybe<Scalars["Time"]["input"]>;
	expiresAtLTE?: InputMaybe<Scalars["Time"]["input"]>;
	expiresAtNEQ?: InputMaybe<Scalars["Time"]["input"]>;
	expiresAtNotIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	hasLoginRecord?: InputMaybe<Scalars["Boolean"]["input"]>;
	hasMFAInvalidOTPAttempts?: InputMaybe<Scalars["Boolean"]["input"]>;
	hasTrustedDevice?: InputMaybe<Scalars["Boolean"]["input"]>;
	idEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	isVerifiedEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	isVerifiedNEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	loginRecord?: InputMaybe<Array<LoginRecordFilterInput>>;
	longestInactiveSecEQ?: InputMaybe<Scalars["Int"]["input"]>;
	longestInactiveSecGT?: InputMaybe<Scalars["Int"]["input"]>;
	longestInactiveSecGTE?: InputMaybe<Scalars["Int"]["input"]>;
	longestInactiveSecIn?: InputMaybe<Array<Scalars["Int"]["input"]>>;
	longestInactiveSecLT?: InputMaybe<Scalars["Int"]["input"]>;
	longestInactiveSecLTE?: InputMaybe<Scalars["Int"]["input"]>;
	longestInactiveSecNEQ?: InputMaybe<Scalars["Int"]["input"]>;
	longestInactiveSecNotIn?: InputMaybe<Array<Scalars["Int"]["input"]>>;
	mfaInvalidOTPAttempts?: InputMaybe<Array<MFAInvalidOTPAttemptFilterInput>>;
	not?: InputMaybe<SessionFilterInput>;
	or?: InputMaybe<Array<SessionFilterInput>>;
	trustedDevice?: InputMaybe<Array<TrustedDeviceFilterInput>>;
	trustedDeviceIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	trustedDeviceIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	trustedDeviceIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	trustedDeviceIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	trustedDeviceIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	updatedAtEQ?: InputMaybe<Scalars["Time"]["input"]>;
	updatedAtGT?: InputMaybe<Scalars["Time"]["input"]>;
	updatedAtGTE?: InputMaybe<Scalars["Time"]["input"]>;
	updatedAtIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	updatedAtLT?: InputMaybe<Scalars["Time"]["input"]>;
	updatedAtLTE?: InputMaybe<Scalars["Time"]["input"]>;
	updatedAtNEQ?: InputMaybe<Scalars["Time"]["input"]>;
	updatedAtNotIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	user?: InputMaybe<Array<UserFilterInput>>;
	userIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	userIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	userIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	userIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
};

export type SessionOrder = {
	direction: OrderDirection;
	field?: InputMaybe<SessionOrderField>;
};

export enum SessionOrderField {
	CreatedAt = "CREATED_AT",
	ExpiresAt = "EXPIRES_AT",
	UpdatedAt = "UPDATED_AT",
}

export type SharingPolicy = Node & {
	__typename?: "SharingPolicy";
	announcement: Maybe<Announcement>;
	announcementID: Maybe<Scalars["ID"]["output"]>;
	calendarEvent: Maybe<CalendarEvent>;
	calendarEventID: Maybe<Scalars["ID"]["output"]>;
	id: Scalars["ID"]["output"];
	isPublic: Scalars["Boolean"]["output"];
	newsletter: Maybe<Newsletter>;
	newsletterID: Maybe<Scalars["ID"]["output"]>;
	post: Maybe<Post>;
	postID: Maybe<Scalars["ID"]["output"]>;
	sharedUsers: Array<User>;
	userGroups: Array<UserGroup>;
	users: Array<User>;
};

export type SharingPolicySharedUsersArgs = {
	filters?: InputMaybe<Array<UserFilterInput>>;
	order?: InputMaybe<UserOrder>;
	pagination?: InputMaybe<EdgePagination>;
};

export type SharingPolicyUserGroupsArgs = {
	filters?: InputMaybe<Array<UserGroupFilterInput>>;
	order?: InputMaybe<UserGroupOrder>;
	pagination?: InputMaybe<EdgePagination>;
};

export type SharingPolicyUsersArgs = {
	filters?: InputMaybe<Array<UserFilterInput>>;
	order?: InputMaybe<UserOrder>;
	pagination?: InputMaybe<EdgePagination>;
};

export type SharingPolicyConnection = {
	__typename?: "SharingPolicyConnection";
	edges: Array<SharingPolicyEdge>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"]["output"];
};

export type SharingPolicyCreateInput = {
	announcement?: InputMaybe<AnnouncementInSharingPolicyCreateInput>;
	announcementID?: InputMaybe<Scalars["ID"]["input"]>;
	calendarEvent?: InputMaybe<CalendarEventInSharingPolicyCreateInput>;
	calendarEventID?: InputMaybe<Scalars["ID"]["input"]>;
	isPublic?: InputMaybe<Scalars["Boolean"]["input"]>;
	newsletter?: InputMaybe<NewsletterInSharingPolicyCreateInput>;
	newsletterID?: InputMaybe<Scalars["ID"]["input"]>;
	post?: InputMaybe<PostInSharingPolicyCreateInput>;
	postID?: InputMaybe<Scalars["ID"]["input"]>;
	userGroupIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	userIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
};

export type SharingPolicyEdge = {
	__typename?: "SharingPolicyEdge";
	cursor: Scalars["Cursor"]["output"];
	node: SharingPolicy;
};

export type SharingPolicyFilterInput = {
	and?: InputMaybe<Array<SharingPolicyFilterInput>>;
	announcement?: InputMaybe<Array<AnnouncementFilterInput>>;
	announcementIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	announcementIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	announcementIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	announcementIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	announcementIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	calendarEvent?: InputMaybe<Array<CalendarEventFilterInput>>;
	calendarEventIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	calendarEventIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	calendarEventIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	calendarEventIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	calendarEventIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	hasAnnouncement?: InputMaybe<Scalars["Boolean"]["input"]>;
	hasCalendarEvent?: InputMaybe<Scalars["Boolean"]["input"]>;
	hasNewsletter?: InputMaybe<Scalars["Boolean"]["input"]>;
	hasPost?: InputMaybe<Scalars["Boolean"]["input"]>;
	hasSharedUsers?: InputMaybe<Scalars["Boolean"]["input"]>;
	hasUserGroups?: InputMaybe<Scalars["Boolean"]["input"]>;
	hasUsers?: InputMaybe<Scalars["Boolean"]["input"]>;
	idEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	isPublicEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	isPublicNEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	newsletter?: InputMaybe<Array<NewsletterFilterInput>>;
	newsletterIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	newsletterIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	newsletterIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	newsletterIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	newsletterIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	not?: InputMaybe<SharingPolicyFilterInput>;
	or?: InputMaybe<Array<SharingPolicyFilterInput>>;
	post?: InputMaybe<Array<PostFilterInput>>;
	postIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	postIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	postIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	postIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	postIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	sharedUsers?: InputMaybe<Array<UserFilterInput>>;
	userGroups?: InputMaybe<Array<UserGroupFilterInput>>;
	users?: InputMaybe<Array<UserFilterInput>>;
};

export type SharingPolicyHistory = Node & {
	__typename?: "SharingPolicyHistory";
	announcementID: Maybe<Scalars["ID"]["output"]>;
	calendarEventID: Maybe<Scalars["ID"]["output"]>;
	historyIsSystem: Scalars["Boolean"]["output"];
	historyTime: Scalars["Time"]["output"];
	historyType: HistoryType;
	historyUserID: Maybe<Scalars["ID"]["output"]>;
	id: Scalars["ID"]["output"];
	isPublic: Maybe<Scalars["Boolean"]["output"]>;
	newsletterID: Maybe<Scalars["ID"]["output"]>;
	originalID: Maybe<Scalars["ID"]["output"]>;
	postID: Maybe<Scalars["ID"]["output"]>;
};

export type SharingPolicyHistoryConnection = {
	__typename?: "SharingPolicyHistoryConnection";
	edges: Array<SharingPolicyHistoryEdge>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"]["output"];
};

export type SharingPolicyHistoryEdge = {
	__typename?: "SharingPolicyHistoryEdge";
	cursor: Scalars["Cursor"]["output"];
	node: SharingPolicyHistory;
};

export type SharingPolicyHistoryFilterInput = {
	and?: InputMaybe<Array<SharingPolicyHistoryFilterInput>>;
	announcementIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	announcementIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	announcementIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	announcementIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	announcementIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	calendarEventIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	calendarEventIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	calendarEventIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	calendarEventIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	calendarEventIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	historyIsSystemEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyIsSystemNEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyTimeEQ?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeGT?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeGTE?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	historyTimeLT?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeLTE?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeNEQ?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeNotIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	historyTypeEQ?: InputMaybe<HistoryType>;
	historyTypeIn?: InputMaybe<Array<HistoryType>>;
	historyTypeNEQ?: InputMaybe<HistoryType>;
	historyTypeNotIn?: InputMaybe<Array<HistoryType>>;
	historyUserIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	historyUserIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	historyUserIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyUserIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	historyUserIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	isPublicEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	isPublicIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	isPublicNEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	newsletterIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	newsletterIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	newsletterIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	newsletterIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	newsletterIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	not?: InputMaybe<SharingPolicyHistoryFilterInput>;
	or?: InputMaybe<Array<SharingPolicyHistoryFilterInput>>;
	originalIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	originalIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	originalIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	originalIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	originalIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	postIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	postIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	postIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	postIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	postIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
};

export type SharingPolicyHistoryOrder = {
	direction: OrderDirection;
	field?: InputMaybe<SharingPolicyHistoryOrderField>;
};

export enum SharingPolicyHistoryOrderField {
	HistoryTime = "HISTORY_TIME",
}

export type SharingPolicyInAnnouncementCreateInput = {
	calendarEvent?: InputMaybe<CalendarEventInSharingPolicyCreateInput>;
	calendarEventID?: InputMaybe<Scalars["ID"]["input"]>;
	isPublic?: InputMaybe<Scalars["Boolean"]["input"]>;
	newsletter?: InputMaybe<NewsletterInSharingPolicyCreateInput>;
	newsletterID?: InputMaybe<Scalars["ID"]["input"]>;
	post?: InputMaybe<PostInSharingPolicyCreateInput>;
	postID?: InputMaybe<Scalars["ID"]["input"]>;
	userGroupIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	userIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
};

export type SharingPolicyInCalendarEventCreateInput = {
	announcement?: InputMaybe<AnnouncementInSharingPolicyCreateInput>;
	announcementID?: InputMaybe<Scalars["ID"]["input"]>;
	isPublic?: InputMaybe<Scalars["Boolean"]["input"]>;
	newsletter?: InputMaybe<NewsletterInSharingPolicyCreateInput>;
	newsletterID?: InputMaybe<Scalars["ID"]["input"]>;
	post?: InputMaybe<PostInSharingPolicyCreateInput>;
	postID?: InputMaybe<Scalars["ID"]["input"]>;
	userGroupIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	userIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
};

export type SharingPolicyInNewsletterCreateInput = {
	announcement?: InputMaybe<AnnouncementInSharingPolicyCreateInput>;
	announcementID?: InputMaybe<Scalars["ID"]["input"]>;
	calendarEvent?: InputMaybe<CalendarEventInSharingPolicyCreateInput>;
	calendarEventID?: InputMaybe<Scalars["ID"]["input"]>;
	isPublic?: InputMaybe<Scalars["Boolean"]["input"]>;
	post?: InputMaybe<PostInSharingPolicyCreateInput>;
	postID?: InputMaybe<Scalars["ID"]["input"]>;
	userGroupIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	userIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
};

export type SharingPolicyInPostCreateInput = {
	announcement?: InputMaybe<AnnouncementInSharingPolicyCreateInput>;
	announcementID?: InputMaybe<Scalars["ID"]["input"]>;
	calendarEvent?: InputMaybe<CalendarEventInSharingPolicyCreateInput>;
	calendarEventID?: InputMaybe<Scalars["ID"]["input"]>;
	isPublic?: InputMaybe<Scalars["Boolean"]["input"]>;
	newsletter?: InputMaybe<NewsletterInSharingPolicyCreateInput>;
	newsletterID?: InputMaybe<Scalars["ID"]["input"]>;
	userGroupIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	userIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
};

export type SharingPolicyOrder = {
	direction: OrderDirection;
};

export type SharingPolicySharedSharingPolicyUserSharedUserHistory = Node & {
	__typename?: "SharingPolicySharedSharingPolicyUserSharedUserHistory";
	historyIsSystem: Scalars["Boolean"]["output"];
	historyTime: Scalars["Time"]["output"];
	historyType: HistoryType;
	historyUserID: Maybe<Scalars["ID"]["output"]>;
	id: Scalars["ID"]["output"];
	sharingPolicyID: Maybe<Scalars["ID"]["output"]>;
	userID: Maybe<Scalars["ID"]["output"]>;
};

export type SharingPolicySharedSharingPolicyUserSharedUserHistoryConnection = {
	__typename?: "SharingPolicySharedSharingPolicyUserSharedUserHistoryConnection";
	edges: Array<SharingPolicySharedSharingPolicyUserSharedUserHistoryEdge>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"]["output"];
};

export type SharingPolicySharedSharingPolicyUserSharedUserHistoryEdge = {
	__typename?: "SharingPolicySharedSharingPolicyUserSharedUserHistoryEdge";
	cursor: Scalars["Cursor"]["output"];
	node: SharingPolicySharedSharingPolicyUserSharedUserHistory;
};

export type SharingPolicySharedSharingPolicyUserSharedUserHistoryFilterInput = {
	and?: InputMaybe<Array<SharingPolicySharedSharingPolicyUserSharedUserHistoryFilterInput>>;
	historyIsSystemEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyIsSystemNEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyTimeEQ?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeGT?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeGTE?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	historyTimeLT?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeLTE?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeNEQ?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeNotIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	historyTypeEQ?: InputMaybe<HistoryType>;
	historyTypeIn?: InputMaybe<Array<HistoryType>>;
	historyTypeNEQ?: InputMaybe<HistoryType>;
	historyTypeNotIn?: InputMaybe<Array<HistoryType>>;
	historyUserIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	historyUserIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	historyUserIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyUserIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	historyUserIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	not?: InputMaybe<SharingPolicySharedSharingPolicyUserSharedUserHistoryFilterInput>;
	or?: InputMaybe<Array<SharingPolicySharedSharingPolicyUserSharedUserHistoryFilterInput>>;
	sharingPolicyIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	sharingPolicyIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	sharingPolicyIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	sharingPolicyIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	sharingPolicyIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	userIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	userIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	userIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	userIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	userIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
};

export type SharingPolicySharedSharingPolicyUserSharedUserHistoryOrder = {
	direction: OrderDirection;
	field?: InputMaybe<SharingPolicySharedSharingPolicyUserSharedUserHistoryOrderField>;
};

export enum SharingPolicySharedSharingPolicyUserSharedUserHistoryOrderField {
	HistoryTime = "HISTORY_TIME",
}

export type SharingPolicyUpdateBulkInput = {
	addUserGroupIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	addUserIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	isPublic?: InputMaybe<Scalars["Boolean"]["input"]>;
	removeUserGroupIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	removeUserIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
};

export type SharingPolicyUpdateInput = {
	addUserGroupIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	addUserIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	isPublic?: InputMaybe<Scalars["Boolean"]["input"]>;
	removeUserGroupIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	removeUserIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
};

export type SharingPolicyUserGroupHistory = Node & {
	__typename?: "SharingPolicyUserGroupHistory";
	historyIsSystem: Scalars["Boolean"]["output"];
	historyTime: Scalars["Time"]["output"];
	historyType: HistoryType;
	historyUserID: Maybe<Scalars["ID"]["output"]>;
	id: Scalars["ID"]["output"];
	sharingPolicyID: Maybe<Scalars["ID"]["output"]>;
	userGroupID: Maybe<Scalars["ID"]["output"]>;
};

export type SharingPolicyUserGroupHistoryConnection = {
	__typename?: "SharingPolicyUserGroupHistoryConnection";
	edges: Array<SharingPolicyUserGroupHistoryEdge>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"]["output"];
};

export type SharingPolicyUserGroupHistoryEdge = {
	__typename?: "SharingPolicyUserGroupHistoryEdge";
	cursor: Scalars["Cursor"]["output"];
	node: SharingPolicyUserGroupHistory;
};

export type SharingPolicyUserGroupHistoryFilterInput = {
	and?: InputMaybe<Array<SharingPolicyUserGroupHistoryFilterInput>>;
	historyIsSystemEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyIsSystemNEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyTimeEQ?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeGT?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeGTE?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	historyTimeLT?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeLTE?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeNEQ?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeNotIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	historyTypeEQ?: InputMaybe<HistoryType>;
	historyTypeIn?: InputMaybe<Array<HistoryType>>;
	historyTypeNEQ?: InputMaybe<HistoryType>;
	historyTypeNotIn?: InputMaybe<Array<HistoryType>>;
	historyUserIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	historyUserIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	historyUserIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyUserIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	historyUserIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	not?: InputMaybe<SharingPolicyUserGroupHistoryFilterInput>;
	or?: InputMaybe<Array<SharingPolicyUserGroupHistoryFilterInput>>;
	sharingPolicyIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	sharingPolicyIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	sharingPolicyIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	sharingPolicyIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	sharingPolicyIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	userGroupIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	userGroupIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	userGroupIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	userGroupIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	userGroupIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
};

export type SharingPolicyUserGroupHistoryOrder = {
	direction: OrderDirection;
	field?: InputMaybe<SharingPolicyUserGroupHistoryOrderField>;
};

export enum SharingPolicyUserGroupHistoryOrderField {
	HistoryTime = "HISTORY_TIME",
}

export type SharingPolicyUserHistory = Node & {
	__typename?: "SharingPolicyUserHistory";
	historyIsSystem: Scalars["Boolean"]["output"];
	historyTime: Scalars["Time"]["output"];
	historyType: HistoryType;
	historyUserID: Maybe<Scalars["ID"]["output"]>;
	id: Scalars["ID"]["output"];
	sharingPolicyID: Maybe<Scalars["ID"]["output"]>;
	userID: Maybe<Scalars["ID"]["output"]>;
};

export type SharingPolicyUserHistoryConnection = {
	__typename?: "SharingPolicyUserHistoryConnection";
	edges: Array<SharingPolicyUserHistoryEdge>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"]["output"];
};

export type SharingPolicyUserHistoryEdge = {
	__typename?: "SharingPolicyUserHistoryEdge";
	cursor: Scalars["Cursor"]["output"];
	node: SharingPolicyUserHistory;
};

export type SharingPolicyUserHistoryFilterInput = {
	and?: InputMaybe<Array<SharingPolicyUserHistoryFilterInput>>;
	historyIsSystemEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyIsSystemNEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyTimeEQ?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeGT?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeGTE?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	historyTimeLT?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeLTE?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeNEQ?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeNotIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	historyTypeEQ?: InputMaybe<HistoryType>;
	historyTypeIn?: InputMaybe<Array<HistoryType>>;
	historyTypeNEQ?: InputMaybe<HistoryType>;
	historyTypeNotIn?: InputMaybe<Array<HistoryType>>;
	historyUserIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	historyUserIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	historyUserIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyUserIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	historyUserIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	not?: InputMaybe<SharingPolicyUserHistoryFilterInput>;
	or?: InputMaybe<Array<SharingPolicyUserHistoryFilterInput>>;
	sharingPolicyIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	sharingPolicyIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	sharingPolicyIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	sharingPolicyIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	sharingPolicyIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	userIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	userIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	userIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	userIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	userIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
};

export type SharingPolicyUserHistoryOrder = {
	direction: OrderDirection;
	field?: InputMaybe<SharingPolicyUserHistoryOrderField>;
};

export enum SharingPolicyUserHistoryOrderField {
	HistoryTime = "HISTORY_TIME",
}

export type SocialComment = Node & {
	__typename?: "SocialComment";
	author: User;
	authorID: Scalars["ID"]["output"];
	body: Scalars["String"]["output"];
	createdAt: Scalars["Time"]["output"];
	id: Scalars["ID"]["output"];
	mediaAttachment: Maybe<MediaAttachment>;
	mediaAttachmentID: Maybe<Scalars["ID"]["output"]>;
	newsletter: Maybe<Newsletter>;
	newsletterID: Maybe<Scalars["ID"]["output"]>;
	post: Maybe<Post>;
	postID: Maybe<Scalars["ID"]["output"]>;
};

export type SocialCommentConnection = {
	__typename?: "SocialCommentConnection";
	edges: Array<SocialCommentEdge>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"]["output"];
};

export type SocialCommentCreateInput = {
	body: Scalars["String"]["input"];
	mediaAttachmentID?: InputMaybe<Scalars["ID"]["input"]>;
	newsletterID?: InputMaybe<Scalars["ID"]["input"]>;
	postID?: InputMaybe<Scalars["ID"]["input"]>;
};

export type SocialCommentEdge = {
	__typename?: "SocialCommentEdge";
	cursor: Scalars["Cursor"]["output"];
	node: SocialComment;
};

export type SocialCommentFilterInput = {
	and?: InputMaybe<Array<SocialCommentFilterInput>>;
	author?: InputMaybe<Array<UserFilterInput>>;
	authorIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	authorIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	authorIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	authorIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	bodyContains?: InputMaybe<Scalars["String"]["input"]>;
	bodyEQ?: InputMaybe<Scalars["String"]["input"]>;
	bodyHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	bodyHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	bodyIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	bodyNEQ?: InputMaybe<Scalars["String"]["input"]>;
	bodyNotContains?: InputMaybe<Scalars["String"]["input"]>;
	bodyNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	bodyNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	bodyNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	createdAtEQ?: InputMaybe<Scalars["Time"]["input"]>;
	createdAtGT?: InputMaybe<Scalars["Time"]["input"]>;
	createdAtGTE?: InputMaybe<Scalars["Time"]["input"]>;
	createdAtIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	createdAtLT?: InputMaybe<Scalars["Time"]["input"]>;
	createdAtLTE?: InputMaybe<Scalars["Time"]["input"]>;
	createdAtNEQ?: InputMaybe<Scalars["Time"]["input"]>;
	createdAtNotIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	hasMediaAttachment?: InputMaybe<Scalars["Boolean"]["input"]>;
	hasNewsletter?: InputMaybe<Scalars["Boolean"]["input"]>;
	hasPost?: InputMaybe<Scalars["Boolean"]["input"]>;
	idEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	mediaAttachment?: InputMaybe<Array<MediaAttachmentFilterInput>>;
	mediaAttachmentIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	mediaAttachmentIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	mediaAttachmentIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	mediaAttachmentIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	mediaAttachmentIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	newsletter?: InputMaybe<Array<NewsletterFilterInput>>;
	newsletterIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	newsletterIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	newsletterIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	newsletterIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	newsletterIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	not?: InputMaybe<SocialCommentFilterInput>;
	or?: InputMaybe<Array<SocialCommentFilterInput>>;
	post?: InputMaybe<Array<PostFilterInput>>;
	postIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	postIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	postIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	postIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	postIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	search?: InputMaybe<Scalars["String"]["input"]>;
};

export type SocialCommentHistory = Node & {
	__typename?: "SocialCommentHistory";
	authorID: Maybe<Scalars["ID"]["output"]>;
	body: Maybe<Scalars["String"]["output"]>;
	createdAt: Maybe<Scalars["Time"]["output"]>;
	historyIsSystem: Scalars["Boolean"]["output"];
	historyTime: Scalars["Time"]["output"];
	historyType: HistoryType;
	historyUserID: Maybe<Scalars["ID"]["output"]>;
	id: Scalars["ID"]["output"];
	mediaAttachmentID: Maybe<Scalars["ID"]["output"]>;
	newsletterID: Maybe<Scalars["ID"]["output"]>;
	originalID: Maybe<Scalars["ID"]["output"]>;
	postID: Maybe<Scalars["ID"]["output"]>;
};

export type SocialCommentHistoryConnection = {
	__typename?: "SocialCommentHistoryConnection";
	edges: Array<SocialCommentHistoryEdge>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"]["output"];
};

export type SocialCommentHistoryEdge = {
	__typename?: "SocialCommentHistoryEdge";
	cursor: Scalars["Cursor"]["output"];
	node: SocialCommentHistory;
};

export type SocialCommentHistoryFilterInput = {
	and?: InputMaybe<Array<SocialCommentHistoryFilterInput>>;
	authorIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	authorIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	authorIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	authorIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	authorIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	bodyContains?: InputMaybe<Scalars["String"]["input"]>;
	bodyEQ?: InputMaybe<Scalars["String"]["input"]>;
	bodyHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	bodyHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	bodyIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	bodyIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	bodyNEQ?: InputMaybe<Scalars["String"]["input"]>;
	bodyNotContains?: InputMaybe<Scalars["String"]["input"]>;
	bodyNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	bodyNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	bodyNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	createdAtEQ?: InputMaybe<Scalars["Time"]["input"]>;
	createdAtGT?: InputMaybe<Scalars["Time"]["input"]>;
	createdAtGTE?: InputMaybe<Scalars["Time"]["input"]>;
	createdAtIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	createdAtIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	createdAtLT?: InputMaybe<Scalars["Time"]["input"]>;
	createdAtLTE?: InputMaybe<Scalars["Time"]["input"]>;
	createdAtNEQ?: InputMaybe<Scalars["Time"]["input"]>;
	createdAtNotIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	historyIsSystemEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyIsSystemNEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyTimeEQ?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeGT?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeGTE?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	historyTimeLT?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeLTE?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeNEQ?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeNotIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	historyTypeEQ?: InputMaybe<HistoryType>;
	historyTypeIn?: InputMaybe<Array<HistoryType>>;
	historyTypeNEQ?: InputMaybe<HistoryType>;
	historyTypeNotIn?: InputMaybe<Array<HistoryType>>;
	historyUserIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	historyUserIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	historyUserIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyUserIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	historyUserIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	mediaAttachmentIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	mediaAttachmentIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	mediaAttachmentIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	mediaAttachmentIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	mediaAttachmentIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	newsletterIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	newsletterIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	newsletterIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	newsletterIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	newsletterIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	not?: InputMaybe<SocialCommentHistoryFilterInput>;
	or?: InputMaybe<Array<SocialCommentHistoryFilterInput>>;
	originalIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	originalIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	originalIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	originalIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	originalIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	postIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	postIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	postIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	postIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	postIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	search?: InputMaybe<Scalars["String"]["input"]>;
};

export type SocialCommentHistoryOrder = {
	direction: OrderDirection;
	field?: InputMaybe<SocialCommentHistoryOrderField>;
};

export enum SocialCommentHistoryOrderField {
	HistoryTime = "HISTORY_TIME",
}

export type SocialCommentInAuthorCreateInput = {
	body: Scalars["String"]["input"];
	mediaAttachmentID?: InputMaybe<Scalars["ID"]["input"]>;
	newsletterID?: InputMaybe<Scalars["ID"]["input"]>;
	postID?: InputMaybe<Scalars["ID"]["input"]>;
};

export type SocialCommentInMediaAttachmentCreateInput = {
	body: Scalars["String"]["input"];
	newsletterID?: InputMaybe<Scalars["ID"]["input"]>;
	postID?: InputMaybe<Scalars["ID"]["input"]>;
};

export type SocialCommentInNewsletterCreateInput = {
	body: Scalars["String"]["input"];
	mediaAttachmentID?: InputMaybe<Scalars["ID"]["input"]>;
	postID?: InputMaybe<Scalars["ID"]["input"]>;
};

export type SocialCommentInPostCreateInput = {
	body: Scalars["String"]["input"];
	mediaAttachmentID?: InputMaybe<Scalars["ID"]["input"]>;
	newsletterID?: InputMaybe<Scalars["ID"]["input"]>;
};

export type SocialCommentOrder = {
	direction: OrderDirection;
	field?: InputMaybe<SocialCommentOrderField>;
};

export enum SocialCommentOrderField {
	CreatedAt = "CREATED_AT",
}

export type SocialCommentUpdateBulkInput = {
	body?: InputMaybe<Scalars["String"]["input"]>;
};

export type SocialCommentUpdateInput = {
	body?: InputMaybe<Scalars["String"]["input"]>;
};

export type SocialReaction = Node & {
	__typename?: "SocialReaction";
	announcement: Maybe<Announcement>;
	announcementID: Maybe<Scalars["ID"]["output"]>;
	author: User;
	authorID: Scalars["ID"]["output"];
	createdAt: Scalars["Time"]["output"];
	id: Scalars["ID"]["output"];
	mediaAttachment: Maybe<MediaAttachment>;
	mediaAttachmentID: Maybe<Scalars["ID"]["output"]>;
	newsletter: Maybe<Newsletter>;
	newsletterID: Maybe<Scalars["ID"]["output"]>;
	post: Maybe<Post>;
	postID: Maybe<Scalars["ID"]["output"]>;
	reaction: SocialReactionReaction;
};

export type SocialReactionConnection = {
	__typename?: "SocialReactionConnection";
	edges: Array<SocialReactionEdge>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"]["output"];
};

export type SocialReactionCreateInput = {
	announcementID?: InputMaybe<Scalars["ID"]["input"]>;
	mediaAttachmentID?: InputMaybe<Scalars["ID"]["input"]>;
	newsletterID?: InputMaybe<Scalars["ID"]["input"]>;
	postID?: InputMaybe<Scalars["ID"]["input"]>;
	reaction?: InputMaybe<SocialReactionReaction>;
};

export type SocialReactionEdge = {
	__typename?: "SocialReactionEdge";
	cursor: Scalars["Cursor"]["output"];
	node: SocialReaction;
};

export type SocialReactionFilterInput = {
	and?: InputMaybe<Array<SocialReactionFilterInput>>;
	announcement?: InputMaybe<Array<AnnouncementFilterInput>>;
	announcementIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	announcementIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	announcementIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	announcementIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	announcementIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	author?: InputMaybe<Array<UserFilterInput>>;
	authorIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	authorIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	authorIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	authorIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	createdAtEQ?: InputMaybe<Scalars["Time"]["input"]>;
	createdAtGT?: InputMaybe<Scalars["Time"]["input"]>;
	createdAtGTE?: InputMaybe<Scalars["Time"]["input"]>;
	createdAtIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	createdAtLT?: InputMaybe<Scalars["Time"]["input"]>;
	createdAtLTE?: InputMaybe<Scalars["Time"]["input"]>;
	createdAtNEQ?: InputMaybe<Scalars["Time"]["input"]>;
	createdAtNotIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	hasAnnouncement?: InputMaybe<Scalars["Boolean"]["input"]>;
	hasMediaAttachment?: InputMaybe<Scalars["Boolean"]["input"]>;
	hasNewsletter?: InputMaybe<Scalars["Boolean"]["input"]>;
	hasPost?: InputMaybe<Scalars["Boolean"]["input"]>;
	idEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	mediaAttachment?: InputMaybe<Array<MediaAttachmentFilterInput>>;
	mediaAttachmentIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	mediaAttachmentIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	mediaAttachmentIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	mediaAttachmentIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	mediaAttachmentIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	newsletter?: InputMaybe<Array<NewsletterFilterInput>>;
	newsletterIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	newsletterIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	newsletterIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	newsletterIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	newsletterIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	not?: InputMaybe<SocialReactionFilterInput>;
	or?: InputMaybe<Array<SocialReactionFilterInput>>;
	post?: InputMaybe<Array<PostFilterInput>>;
	postIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	postIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	postIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	postIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	postIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	reactionEQ?: InputMaybe<SocialReactionReaction>;
	reactionIn?: InputMaybe<Array<SocialReactionReaction>>;
	reactionNEQ?: InputMaybe<SocialReactionReaction>;
	reactionNotIn?: InputMaybe<Array<SocialReactionReaction>>;
};

export type SocialReactionHistory = Node & {
	__typename?: "SocialReactionHistory";
	announcementID: Maybe<Scalars["ID"]["output"]>;
	authorID: Maybe<Scalars["ID"]["output"]>;
	createdAt: Maybe<Scalars["Time"]["output"]>;
	historyIsSystem: Scalars["Boolean"]["output"];
	historyTime: Scalars["Time"]["output"];
	historyType: HistoryType;
	historyUserID: Maybe<Scalars["ID"]["output"]>;
	id: Scalars["ID"]["output"];
	mediaAttachmentID: Maybe<Scalars["ID"]["output"]>;
	newsletterID: Maybe<Scalars["ID"]["output"]>;
	originalID: Maybe<Scalars["ID"]["output"]>;
	postID: Maybe<Scalars["ID"]["output"]>;
	reaction: Maybe<SocialReactionHistoryReaction>;
};

export type SocialReactionHistoryConnection = {
	__typename?: "SocialReactionHistoryConnection";
	edges: Array<SocialReactionHistoryEdge>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"]["output"];
};

export type SocialReactionHistoryEdge = {
	__typename?: "SocialReactionHistoryEdge";
	cursor: Scalars["Cursor"]["output"];
	node: SocialReactionHistory;
};

export type SocialReactionHistoryFilterInput = {
	and?: InputMaybe<Array<SocialReactionHistoryFilterInput>>;
	announcementIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	announcementIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	announcementIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	announcementIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	announcementIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	authorIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	authorIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	authorIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	authorIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	authorIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	createdAtEQ?: InputMaybe<Scalars["Time"]["input"]>;
	createdAtGT?: InputMaybe<Scalars["Time"]["input"]>;
	createdAtGTE?: InputMaybe<Scalars["Time"]["input"]>;
	createdAtIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	createdAtIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	createdAtLT?: InputMaybe<Scalars["Time"]["input"]>;
	createdAtLTE?: InputMaybe<Scalars["Time"]["input"]>;
	createdAtNEQ?: InputMaybe<Scalars["Time"]["input"]>;
	createdAtNotIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	historyIsSystemEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyIsSystemNEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyTimeEQ?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeGT?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeGTE?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	historyTimeLT?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeLTE?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeNEQ?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeNotIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	historyTypeEQ?: InputMaybe<HistoryType>;
	historyTypeIn?: InputMaybe<Array<HistoryType>>;
	historyTypeNEQ?: InputMaybe<HistoryType>;
	historyTypeNotIn?: InputMaybe<Array<HistoryType>>;
	historyUserIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	historyUserIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	historyUserIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyUserIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	historyUserIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	mediaAttachmentIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	mediaAttachmentIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	mediaAttachmentIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	mediaAttachmentIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	mediaAttachmentIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	newsletterIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	newsletterIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	newsletterIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	newsletterIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	newsletterIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	not?: InputMaybe<SocialReactionHistoryFilterInput>;
	or?: InputMaybe<Array<SocialReactionHistoryFilterInput>>;
	originalIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	originalIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	originalIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	originalIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	originalIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	postIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	postIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	postIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	postIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	postIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	reactionEQ?: InputMaybe<SocialReactionHistoryReaction>;
	reactionIn?: InputMaybe<Array<SocialReactionHistoryReaction>>;
	reactionIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	reactionNEQ?: InputMaybe<SocialReactionHistoryReaction>;
	reactionNotIn?: InputMaybe<Array<SocialReactionHistoryReaction>>;
};

export type SocialReactionHistoryOrder = {
	direction: OrderDirection;
	field?: InputMaybe<SocialReactionHistoryOrderField>;
};

export enum SocialReactionHistoryOrderField {
	HistoryTime = "HISTORY_TIME",
}

export enum SocialReactionHistoryReaction {
	Like = "like",
}

export type SocialReactionInAnnouncementCreateInput = {
	mediaAttachmentID?: InputMaybe<Scalars["ID"]["input"]>;
	newsletterID?: InputMaybe<Scalars["ID"]["input"]>;
	postID?: InputMaybe<Scalars["ID"]["input"]>;
	reaction?: InputMaybe<SocialReactionReaction>;
};

export type SocialReactionInAuthorCreateInput = {
	announcementID?: InputMaybe<Scalars["ID"]["input"]>;
	mediaAttachmentID?: InputMaybe<Scalars["ID"]["input"]>;
	newsletterID?: InputMaybe<Scalars["ID"]["input"]>;
	postID?: InputMaybe<Scalars["ID"]["input"]>;
	reaction?: InputMaybe<SocialReactionReaction>;
};

export type SocialReactionInMediaAttachmentCreateInput = {
	announcementID?: InputMaybe<Scalars["ID"]["input"]>;
	newsletterID?: InputMaybe<Scalars["ID"]["input"]>;
	postID?: InputMaybe<Scalars["ID"]["input"]>;
	reaction?: InputMaybe<SocialReactionReaction>;
};

export type SocialReactionInNewsletterCreateInput = {
	announcementID?: InputMaybe<Scalars["ID"]["input"]>;
	mediaAttachmentID?: InputMaybe<Scalars["ID"]["input"]>;
	postID?: InputMaybe<Scalars["ID"]["input"]>;
	reaction?: InputMaybe<SocialReactionReaction>;
};

export type SocialReactionInPostCreateInput = {
	announcementID?: InputMaybe<Scalars["ID"]["input"]>;
	mediaAttachmentID?: InputMaybe<Scalars["ID"]["input"]>;
	newsletterID?: InputMaybe<Scalars["ID"]["input"]>;
	reaction?: InputMaybe<SocialReactionReaction>;
};

export type SocialReactionOrder = {
	direction: OrderDirection;
	field?: InputMaybe<SocialReactionOrderField>;
};

export enum SocialReactionOrderField {
	CreatedAt = "CREATED_AT",
	Reaction = "REACTION",
}

export enum SocialReactionReaction {
	Like = "like",
}

export type SocialReactionUpdateBulkInput = {
	reaction?: InputMaybe<SocialReactionReaction>;
};

export type SocialReactionUpdateInput = {
	reaction?: InputMaybe<SocialReactionReaction>;
};

export type TimelineConnection = {
	__typename?: "TimelineConnection";
	hasMore: Scalars["Boolean"]["output"];
	items: Array<TimelineItem>;
};

export type TimelineFilterInput = {
	asViewerType?: InputMaybe<TimelineViewerType>;
	endTime?: InputMaybe<Scalars["Time"]["input"]>;
	objectTypeIn?: InputMaybe<Array<TimelineObjectType>>;
	startTime?: InputMaybe<Scalars["Time"]["input"]>;
	userGroupID?: InputMaybe<Scalars["ID"]["input"]>;
	userID?: InputMaybe<Scalars["ID"]["input"]>;
};

export type TimelineItem = {
	__typename?: "TimelineItem";
	actorID: Scalars["ID"]["output"];
	actorName: Scalars["String"]["output"];
	objectID: Scalars["ID"]["output"];
	objectName: Scalars["String"]["output"];
	objectTime: Scalars["Time"]["output"];
	objectTimeIsDate: Scalars["Boolean"]["output"];
	objectType: TimelineObjectType;
};

export enum TimelineObjectType {
	Announcement = "ANNOUNCEMENT",
	CalendarEvent = "CALENDAR_EVENT",
	Newsletter = "NEWSLETTER",
	Post = "POST",
}

export type TimelinePagination = {
	limit?: InputMaybe<Scalars["Int"]["input"]>;
	offset?: InputMaybe<Scalars["Int"]["input"]>;
};

export enum TimelineViewerType {
	Author = "AUTHOR",
}

export type TrustedDevice = Node & {
	__typename?: "TrustedDevice";
	createdAt: Scalars["Time"]["output"];
	id: Scalars["ID"]["output"];
	isCurrent: Scalars["Boolean"]["output"];
	name: Scalars["String"]["output"];
	sessions: Array<Session>;
	user: User;
	userID: Scalars["ID"]["output"];
};

export type TrustedDeviceSessionsArgs = {
	filters?: InputMaybe<Array<SessionFilterInput>>;
	order?: InputMaybe<SessionOrder>;
	pagination?: InputMaybe<EdgePagination>;
};

export type TrustedDeviceConnection = {
	__typename?: "TrustedDeviceConnection";
	edges: Array<TrustedDeviceEdge>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"]["output"];
};

export type TrustedDeviceEdge = {
	__typename?: "TrustedDeviceEdge";
	cursor: Scalars["Cursor"]["output"];
	node: TrustedDevice;
};

export type TrustedDeviceFilterInput = {
	and?: InputMaybe<Array<TrustedDeviceFilterInput>>;
	createdAtEQ?: InputMaybe<Scalars["Time"]["input"]>;
	createdAtGT?: InputMaybe<Scalars["Time"]["input"]>;
	createdAtGTE?: InputMaybe<Scalars["Time"]["input"]>;
	createdAtIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	createdAtLT?: InputMaybe<Scalars["Time"]["input"]>;
	createdAtLTE?: InputMaybe<Scalars["Time"]["input"]>;
	createdAtNEQ?: InputMaybe<Scalars["Time"]["input"]>;
	createdAtNotIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	hasSessions?: InputMaybe<Scalars["Boolean"]["input"]>;
	idEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	nameContains?: InputMaybe<Scalars["String"]["input"]>;
	nameEQ?: InputMaybe<Scalars["String"]["input"]>;
	nameHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	nameHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	nameIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	nameNEQ?: InputMaybe<Scalars["String"]["input"]>;
	nameNotContains?: InputMaybe<Scalars["String"]["input"]>;
	nameNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	nameNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	nameNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	not?: InputMaybe<TrustedDeviceFilterInput>;
	or?: InputMaybe<Array<TrustedDeviceFilterInput>>;
	search?: InputMaybe<Scalars["String"]["input"]>;
	sessions?: InputMaybe<Array<SessionFilterInput>>;
	user?: InputMaybe<Array<UserFilterInput>>;
	userIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	userIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	userIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	userIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
};

export type TrustedDeviceOrder = {
	direction: OrderDirection;
	field?: InputMaybe<TrustedDeviceOrderField>;
};

export enum TrustedDeviceOrderField {
	CreatedAt = "CREATED_AT",
}

export type User = Node & {
	__typename?: "User";
	authoredAnnouncements: Array<Announcement>;
	authoredCalendarEventResponses: Array<CalendarEventResponse>;
	authoredCalendarEvents: Array<CalendarEvent>;
	authoredMessageGroupArchivePoints: Array<MessageGroupArchivePoint>;
	authoredMessages: Array<Message>;
	authoredNewsletters: Array<Newsletter>;
	authoredPosts: Array<Post>;
	authoredSocialComments: Array<SocialComment>;
	authoredSocialReactions: Array<SocialReaction>;
	dateOfBirth: Maybe<Scalars["Time"]["output"]>;
	email: Scalars["String"]["output"];
	externalNotificationFrequency: UserExternalNotificationFrequency;
	familyName: Scalars["String"]["output"];
	gender: Scalars["String"]["output"];
	givenName: Scalars["String"]["output"];
	id: Scalars["ID"]["output"];
	imageContentType: Scalars["String"]["output"];
	imageKey: Scalars["String"]["output"];
	imageURL: Scalars["String"]["output"];
	isCurrent: Scalars["Boolean"]["output"];
	loginRecords: Array<LoginRecord>;
	memberGroups: Array<UserGroup>;
	messageGroups: Array<MessageGroup>;
	mfaFactor: Maybe<MFAFactor>;
	mfaInvalidOTPAttempts: Array<MFAInvalidOTPAttempt>;
	middleName: Scalars["String"]["output"];
	name: Scalars["String"]["output"];
	nameOrder: UserNameOrder;
	organizationName: Scalars["String"]["output"];
	passwordUpdatedAt: Scalars["Time"]["output"];
	permissionGroups: Array<PermissionGroup>;
	pronouns: Scalars["String"]["output"];
	publicName: Scalars["String"]["output"];
	publicNameFormat: UserPublicNameFormat;
	sessions: Array<Session>;
	sharedSharingPolicies: Array<SharingPolicy>;
	sharingPolicies: Array<SharingPolicy>;
	status: UserStatus;
	timeZoneName: Scalars["String"]["output"];
	trustedDevices: Array<TrustedDevice>;
	userExternalNotificationMarker: Maybe<UserExternalNotificationMarker>;
	userGroups: Array<UserGroup>;
	userViewRecords: Array<UserViewRecord>;
};

export type UserAuthoredAnnouncementsArgs = {
	filters?: InputMaybe<Array<AnnouncementFilterInput>>;
	order?: InputMaybe<AnnouncementOrder>;
	pagination?: InputMaybe<EdgePagination>;
};

export type UserAuthoredCalendarEventResponsesArgs = {
	filters?: InputMaybe<Array<CalendarEventResponseFilterInput>>;
	order?: InputMaybe<CalendarEventResponseOrder>;
	pagination?: InputMaybe<EdgePagination>;
};

export type UserAuthoredCalendarEventsArgs = {
	filters?: InputMaybe<Array<CalendarEventFilterInput>>;
	order?: InputMaybe<CalendarEventOrder>;
	pagination?: InputMaybe<EdgePagination>;
};

export type UserAuthoredMessageGroupArchivePointsArgs = {
	filters?: InputMaybe<Array<MessageGroupArchivePointFilterInput>>;
	order?: InputMaybe<MessageGroupArchivePointOrder>;
	pagination?: InputMaybe<EdgePagination>;
};

export type UserAuthoredMessagesArgs = {
	filters?: InputMaybe<Array<MessageFilterInput>>;
	order?: InputMaybe<MessageOrder>;
	pagination?: InputMaybe<EdgePagination>;
};

export type UserAuthoredNewslettersArgs = {
	filters?: InputMaybe<Array<NewsletterFilterInput>>;
	order?: InputMaybe<NewsletterOrder>;
	pagination?: InputMaybe<EdgePagination>;
};

export type UserAuthoredPostsArgs = {
	filters?: InputMaybe<Array<PostFilterInput>>;
	order?: InputMaybe<PostOrder>;
	pagination?: InputMaybe<EdgePagination>;
};

export type UserAuthoredSocialCommentsArgs = {
	filters?: InputMaybe<Array<SocialCommentFilterInput>>;
	order?: InputMaybe<SocialCommentOrder>;
	pagination?: InputMaybe<EdgePagination>;
};

export type UserAuthoredSocialReactionsArgs = {
	filters?: InputMaybe<Array<SocialReactionFilterInput>>;
	order?: InputMaybe<SocialReactionOrder>;
	pagination?: InputMaybe<EdgePagination>;
};

export type UserLoginRecordsArgs = {
	filters?: InputMaybe<Array<LoginRecordFilterInput>>;
	order?: InputMaybe<LoginRecordOrder>;
	pagination?: InputMaybe<EdgePagination>;
};

export type UserMemberGroupsArgs = {
	filters?: InputMaybe<Array<UserGroupFilterInput>>;
	order?: InputMaybe<UserGroupOrder>;
	pagination?: InputMaybe<EdgePagination>;
};

export type UserMessageGroupsArgs = {
	filters?: InputMaybe<Array<MessageGroupFilterInput>>;
	order?: InputMaybe<MessageGroupOrder>;
	pagination?: InputMaybe<EdgePagination>;
};

export type UserMFAInvalidOTPAttemptsArgs = {
	filters?: InputMaybe<Array<MFAInvalidOTPAttemptFilterInput>>;
	order?: InputMaybe<MFAInvalidOTPAttemptOrder>;
	pagination?: InputMaybe<EdgePagination>;
};

export type UserPermissionGroupsArgs = {
	filters?: InputMaybe<Array<PermissionGroupFilterInput>>;
	order?: InputMaybe<PermissionGroupOrder>;
	pagination?: InputMaybe<EdgePagination>;
};

export type UserSessionsArgs = {
	filters?: InputMaybe<Array<SessionFilterInput>>;
	order?: InputMaybe<SessionOrder>;
	pagination?: InputMaybe<EdgePagination>;
};

export type UserSharedSharingPoliciesArgs = {
	filters?: InputMaybe<Array<SharingPolicyFilterInput>>;
	order?: InputMaybe<SharingPolicyOrder>;
	pagination?: InputMaybe<EdgePagination>;
};

export type UserSharingPoliciesArgs = {
	filters?: InputMaybe<Array<SharingPolicyFilterInput>>;
	order?: InputMaybe<SharingPolicyOrder>;
	pagination?: InputMaybe<EdgePagination>;
};

export type UserTrustedDevicesArgs = {
	filters?: InputMaybe<Array<TrustedDeviceFilterInput>>;
	order?: InputMaybe<TrustedDeviceOrder>;
	pagination?: InputMaybe<EdgePagination>;
};

export type UserUserGroupsArgs = {
	filters?: InputMaybe<Array<UserGroupFilterInput>>;
	order?: InputMaybe<UserGroupOrder>;
	pagination?: InputMaybe<EdgePagination>;
};

export type UserUserViewRecordsArgs = {
	filters?: InputMaybe<Array<UserViewRecordFilterInput>>;
	order?: InputMaybe<UserViewRecordOrder>;
	pagination?: InputMaybe<EdgePagination>;
};

export type UserConnection = {
	__typename?: "UserConnection";
	edges: Array<UserEdge>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"]["output"];
};

export type UserCreateInput = {
	dateOfBirth?: InputMaybe<Scalars["Time"]["input"]>;
	email: Scalars["String"]["input"];
	familyName?: InputMaybe<Scalars["String"]["input"]>;
	gender?: InputMaybe<Scalars["String"]["input"]>;
	givenName?: InputMaybe<Scalars["String"]["input"]>;
	imageContentType?: InputMaybe<Scalars["String"]["input"]>;
	imageKey?: InputMaybe<Scalars["String"]["input"]>;
	messageGroupIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	middleName?: InputMaybe<Scalars["String"]["input"]>;
	nameOrder?: InputMaybe<UserNameOrder>;
	organizationName?: InputMaybe<Scalars["String"]["input"]>;
	permissionGroupIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	pronouns?: InputMaybe<Scalars["String"]["input"]>;
	publicNameFormat?: InputMaybe<UserPublicNameFormat>;
	sharingPolicyIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	timeZoneName?: InputMaybe<Scalars["String"]["input"]>;
	userGroupIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
};

export type UserEdge = {
	__typename?: "UserEdge";
	cursor: Scalars["Cursor"]["output"];
	node: User;
};

export enum UserExternalNotificationFrequency {
	Daily = "daily",
	Never = "never",
	Weekly = "weekly",
}

export type UserExternalNotificationMarker = Node & {
	__typename?: "UserExternalNotificationMarker";
	id: Scalars["ID"]["output"];
	lastCommunicationCheck: Scalars["Time"]["output"];
	lastNewsletterCheck: Scalars["Time"]["output"];
	lastSocialCheck: Scalars["Time"]["output"];
	user: User;
	userID: Scalars["ID"]["output"];
};

export type UserExternalNotificationMarkerConnection = {
	__typename?: "UserExternalNotificationMarkerConnection";
	edges: Array<UserExternalNotificationMarkerEdge>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"]["output"];
};

export type UserExternalNotificationMarkerEdge = {
	__typename?: "UserExternalNotificationMarkerEdge";
	cursor: Scalars["Cursor"]["output"];
	node: UserExternalNotificationMarker;
};

export type UserExternalNotificationMarkerFilterInput = {
	and?: InputMaybe<Array<UserExternalNotificationMarkerFilterInput>>;
	idEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	lastCommunicationCheckEQ?: InputMaybe<Scalars["Time"]["input"]>;
	lastCommunicationCheckGT?: InputMaybe<Scalars["Time"]["input"]>;
	lastCommunicationCheckGTE?: InputMaybe<Scalars["Time"]["input"]>;
	lastCommunicationCheckIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	lastCommunicationCheckLT?: InputMaybe<Scalars["Time"]["input"]>;
	lastCommunicationCheckLTE?: InputMaybe<Scalars["Time"]["input"]>;
	lastCommunicationCheckNEQ?: InputMaybe<Scalars["Time"]["input"]>;
	lastCommunicationCheckNotIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	lastNewsletterCheckEQ?: InputMaybe<Scalars["Time"]["input"]>;
	lastNewsletterCheckGT?: InputMaybe<Scalars["Time"]["input"]>;
	lastNewsletterCheckGTE?: InputMaybe<Scalars["Time"]["input"]>;
	lastNewsletterCheckIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	lastNewsletterCheckLT?: InputMaybe<Scalars["Time"]["input"]>;
	lastNewsletterCheckLTE?: InputMaybe<Scalars["Time"]["input"]>;
	lastNewsletterCheckNEQ?: InputMaybe<Scalars["Time"]["input"]>;
	lastNewsletterCheckNotIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	lastSocialCheckEQ?: InputMaybe<Scalars["Time"]["input"]>;
	lastSocialCheckGT?: InputMaybe<Scalars["Time"]["input"]>;
	lastSocialCheckGTE?: InputMaybe<Scalars["Time"]["input"]>;
	lastSocialCheckIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	lastSocialCheckLT?: InputMaybe<Scalars["Time"]["input"]>;
	lastSocialCheckLTE?: InputMaybe<Scalars["Time"]["input"]>;
	lastSocialCheckNEQ?: InputMaybe<Scalars["Time"]["input"]>;
	lastSocialCheckNotIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	not?: InputMaybe<UserExternalNotificationMarkerFilterInput>;
	or?: InputMaybe<Array<UserExternalNotificationMarkerFilterInput>>;
	user?: InputMaybe<Array<UserFilterInput>>;
	userIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	userIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	userIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	userIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
};

export type UserExternalNotificationMarkerOrder = {
	direction: OrderDirection;
	field?: InputMaybe<UserExternalNotificationMarkerOrderField>;
};

export enum UserExternalNotificationMarkerOrderField {
	LastCommunicationCheck = "LAST_COMMUNICATION_CHECK",
	LastNewsletterCheck = "LAST_NEWSLETTER_CHECK",
	LastSocialCheck = "LAST_SOCIAL_CHECK",
}

export type UserFilterInput = {
	and?: InputMaybe<Array<UserFilterInput>>;
	authoredAnnouncements?: InputMaybe<Array<AnnouncementFilterInput>>;
	authoredCalendarEventResponses?: InputMaybe<Array<CalendarEventResponseFilterInput>>;
	authoredCalendarEvents?: InputMaybe<Array<CalendarEventFilterInput>>;
	authoredMessageGroupArchivePoints?: InputMaybe<Array<MessageGroupArchivePointFilterInput>>;
	authoredMessages?: InputMaybe<Array<MessageFilterInput>>;
	authoredNewsletters?: InputMaybe<Array<NewsletterFilterInput>>;
	authoredPosts?: InputMaybe<Array<PostFilterInput>>;
	authoredSocialComments?: InputMaybe<Array<SocialCommentFilterInput>>;
	authoredSocialReactions?: InputMaybe<Array<SocialReactionFilterInput>>;
	dateOfBirthEQ?: InputMaybe<Scalars["Time"]["input"]>;
	dateOfBirthGT?: InputMaybe<Scalars["Time"]["input"]>;
	dateOfBirthGTE?: InputMaybe<Scalars["Time"]["input"]>;
	dateOfBirthIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	dateOfBirthIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	dateOfBirthLT?: InputMaybe<Scalars["Time"]["input"]>;
	dateOfBirthLTE?: InputMaybe<Scalars["Time"]["input"]>;
	dateOfBirthNEQ?: InputMaybe<Scalars["Time"]["input"]>;
	dateOfBirthNotIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	emailContains?: InputMaybe<Scalars["String"]["input"]>;
	emailEQ?: InputMaybe<Scalars["String"]["input"]>;
	emailHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	emailHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	emailIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	emailNEQ?: InputMaybe<Scalars["String"]["input"]>;
	emailNotContains?: InputMaybe<Scalars["String"]["input"]>;
	emailNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	emailNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	emailNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	externalNotificationFrequencyEQ?: InputMaybe<UserExternalNotificationFrequency>;
	externalNotificationFrequencyIn?: InputMaybe<Array<UserExternalNotificationFrequency>>;
	externalNotificationFrequencyNEQ?: InputMaybe<UserExternalNotificationFrequency>;
	externalNotificationFrequencyNotIn?: InputMaybe<Array<UserExternalNotificationFrequency>>;
	familyNameContains?: InputMaybe<Scalars["String"]["input"]>;
	familyNameEQ?: InputMaybe<Scalars["String"]["input"]>;
	familyNameHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	familyNameHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	familyNameIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	familyNameNEQ?: InputMaybe<Scalars["String"]["input"]>;
	familyNameNotContains?: InputMaybe<Scalars["String"]["input"]>;
	familyNameNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	familyNameNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	familyNameNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	genderContains?: InputMaybe<Scalars["String"]["input"]>;
	genderEQ?: InputMaybe<Scalars["String"]["input"]>;
	genderHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	genderHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	genderIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	genderNEQ?: InputMaybe<Scalars["String"]["input"]>;
	genderNotContains?: InputMaybe<Scalars["String"]["input"]>;
	genderNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	genderNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	genderNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	givenNameContains?: InputMaybe<Scalars["String"]["input"]>;
	givenNameEQ?: InputMaybe<Scalars["String"]["input"]>;
	givenNameHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	givenNameHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	givenNameIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	givenNameNEQ?: InputMaybe<Scalars["String"]["input"]>;
	givenNameNotContains?: InputMaybe<Scalars["String"]["input"]>;
	givenNameNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	givenNameNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	givenNameNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	hasAuthoredAnnouncements?: InputMaybe<Scalars["Boolean"]["input"]>;
	hasAuthoredCalendarEventResponses?: InputMaybe<Scalars["Boolean"]["input"]>;
	hasAuthoredCalendarEvents?: InputMaybe<Scalars["Boolean"]["input"]>;
	hasAuthoredMessageGroupArchivePoints?: InputMaybe<Scalars["Boolean"]["input"]>;
	hasAuthoredMessages?: InputMaybe<Scalars["Boolean"]["input"]>;
	hasAuthoredNewsletters?: InputMaybe<Scalars["Boolean"]["input"]>;
	hasAuthoredPosts?: InputMaybe<Scalars["Boolean"]["input"]>;
	hasAuthoredSocialComments?: InputMaybe<Scalars["Boolean"]["input"]>;
	hasAuthoredSocialReactions?: InputMaybe<Scalars["Boolean"]["input"]>;
	hasLoginRecords?: InputMaybe<Scalars["Boolean"]["input"]>;
	hasMFAFactor?: InputMaybe<Scalars["Boolean"]["input"]>;
	hasMFAInvalidOTPAttempts?: InputMaybe<Scalars["Boolean"]["input"]>;
	hasMemberGroups?: InputMaybe<Scalars["Boolean"]["input"]>;
	hasMessageGroups?: InputMaybe<Scalars["Boolean"]["input"]>;
	hasPermissionGroups?: InputMaybe<Scalars["Boolean"]["input"]>;
	hasSessions?: InputMaybe<Scalars["Boolean"]["input"]>;
	hasSharedSharingPolicies?: InputMaybe<Scalars["Boolean"]["input"]>;
	hasSharingPolicies?: InputMaybe<Scalars["Boolean"]["input"]>;
	hasTrustedDevices?: InputMaybe<Scalars["Boolean"]["input"]>;
	hasUserExternalNotificationMarker?: InputMaybe<Scalars["Boolean"]["input"]>;
	hasUserGroups?: InputMaybe<Scalars["Boolean"]["input"]>;
	hasUserViewRecords?: InputMaybe<Scalars["Boolean"]["input"]>;
	idEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	imageContentTypeContains?: InputMaybe<Scalars["String"]["input"]>;
	imageContentTypeEQ?: InputMaybe<Scalars["String"]["input"]>;
	imageContentTypeHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	imageContentTypeHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	imageContentTypeIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	imageContentTypeNEQ?: InputMaybe<Scalars["String"]["input"]>;
	imageContentTypeNotContains?: InputMaybe<Scalars["String"]["input"]>;
	imageContentTypeNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	imageContentTypeNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	imageContentTypeNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	imageKeyContains?: InputMaybe<Scalars["String"]["input"]>;
	imageKeyEQ?: InputMaybe<Scalars["String"]["input"]>;
	imageKeyHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	imageKeyHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	imageKeyIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	imageKeyNEQ?: InputMaybe<Scalars["String"]["input"]>;
	imageKeyNotContains?: InputMaybe<Scalars["String"]["input"]>;
	imageKeyNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	imageKeyNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	imageKeyNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	isCurrentEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	loginRecords?: InputMaybe<Array<LoginRecordFilterInput>>;
	memberGroups?: InputMaybe<Array<UserGroupFilterInput>>;
	messageGroups?: InputMaybe<Array<MessageGroupFilterInput>>;
	mfaFactor?: InputMaybe<Array<MFAFactorFilterInput>>;
	mfaInvalidOTPAttempts?: InputMaybe<Array<MFAInvalidOTPAttemptFilterInput>>;
	middleNameContains?: InputMaybe<Scalars["String"]["input"]>;
	middleNameEQ?: InputMaybe<Scalars["String"]["input"]>;
	middleNameHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	middleNameHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	middleNameIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	middleNameNEQ?: InputMaybe<Scalars["String"]["input"]>;
	middleNameNotContains?: InputMaybe<Scalars["String"]["input"]>;
	middleNameNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	middleNameNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	middleNameNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	nameOrderEQ?: InputMaybe<UserNameOrder>;
	nameOrderIn?: InputMaybe<Array<UserNameOrder>>;
	nameOrderNEQ?: InputMaybe<UserNameOrder>;
	nameOrderNotIn?: InputMaybe<Array<UserNameOrder>>;
	not?: InputMaybe<UserFilterInput>;
	or?: InputMaybe<Array<UserFilterInput>>;
	organizationNameContains?: InputMaybe<Scalars["String"]["input"]>;
	organizationNameEQ?: InputMaybe<Scalars["String"]["input"]>;
	organizationNameHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	organizationNameHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	organizationNameIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	organizationNameNEQ?: InputMaybe<Scalars["String"]["input"]>;
	organizationNameNotContains?: InputMaybe<Scalars["String"]["input"]>;
	organizationNameNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	organizationNameNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	organizationNameNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	passwordUpdatedAtEQ?: InputMaybe<Scalars["Time"]["input"]>;
	passwordUpdatedAtGT?: InputMaybe<Scalars["Time"]["input"]>;
	passwordUpdatedAtGTE?: InputMaybe<Scalars["Time"]["input"]>;
	passwordUpdatedAtIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	passwordUpdatedAtLT?: InputMaybe<Scalars["Time"]["input"]>;
	passwordUpdatedAtLTE?: InputMaybe<Scalars["Time"]["input"]>;
	passwordUpdatedAtNEQ?: InputMaybe<Scalars["Time"]["input"]>;
	passwordUpdatedAtNotIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	permissionGroups?: InputMaybe<Array<PermissionGroupFilterInput>>;
	pronounsContains?: InputMaybe<Scalars["String"]["input"]>;
	pronounsEQ?: InputMaybe<Scalars["String"]["input"]>;
	pronounsHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	pronounsHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	pronounsIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	pronounsNEQ?: InputMaybe<Scalars["String"]["input"]>;
	pronounsNotContains?: InputMaybe<Scalars["String"]["input"]>;
	pronounsNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	pronounsNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	pronounsNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	publicNameFormatEQ?: InputMaybe<UserPublicNameFormat>;
	publicNameFormatIn?: InputMaybe<Array<UserPublicNameFormat>>;
	publicNameFormatNEQ?: InputMaybe<UserPublicNameFormat>;
	publicNameFormatNotIn?: InputMaybe<Array<UserPublicNameFormat>>;
	search?: InputMaybe<Scalars["String"]["input"]>;
	sessions?: InputMaybe<Array<SessionFilterInput>>;
	sharedSharingPolicies?: InputMaybe<Array<SharingPolicyFilterInput>>;
	sharingPolicies?: InputMaybe<Array<SharingPolicyFilterInput>>;
	statusEQ?: InputMaybe<UserStatus>;
	statusIn?: InputMaybe<Array<UserStatus>>;
	statusNEQ?: InputMaybe<UserStatus>;
	statusNotIn?: InputMaybe<Array<UserStatus>>;
	timeZoneNameContains?: InputMaybe<Scalars["String"]["input"]>;
	timeZoneNameEQ?: InputMaybe<Scalars["String"]["input"]>;
	timeZoneNameHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	timeZoneNameHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	timeZoneNameIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	timeZoneNameNEQ?: InputMaybe<Scalars["String"]["input"]>;
	timeZoneNameNotContains?: InputMaybe<Scalars["String"]["input"]>;
	timeZoneNameNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	timeZoneNameNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	timeZoneNameNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	trustedDevices?: InputMaybe<Array<TrustedDeviceFilterInput>>;
	userExternalNotificationMarker?: InputMaybe<Array<UserExternalNotificationMarkerFilterInput>>;
	userGroups?: InputMaybe<Array<UserGroupFilterInput>>;
	userViewRecords?: InputMaybe<Array<UserViewRecordFilterInput>>;
};

export type UserGroup = Node & {
	__typename?: "UserGroup";
	color: Scalars["String"]["output"];
	description: Scalars["String"]["output"];
	id: Scalars["ID"]["output"];
	isPublic: Scalars["Boolean"]["output"];
	members: Array<User>;
	messageGroups: Array<MessageGroup>;
	name: Scalars["String"]["output"];
	sharingPolicies: Array<SharingPolicy>;
	users: Array<User>;
};

export type UserGroupMembersArgs = {
	filters?: InputMaybe<Array<UserFilterInput>>;
	order?: InputMaybe<UserOrder>;
	pagination?: InputMaybe<EdgePagination>;
};

export type UserGroupMessageGroupsArgs = {
	filters?: InputMaybe<Array<MessageGroupFilterInput>>;
	order?: InputMaybe<MessageGroupOrder>;
	pagination?: InputMaybe<EdgePagination>;
};

export type UserGroupSharingPoliciesArgs = {
	filters?: InputMaybe<Array<SharingPolicyFilterInput>>;
	order?: InputMaybe<SharingPolicyOrder>;
	pagination?: InputMaybe<EdgePagination>;
};

export type UserGroupUsersArgs = {
	filters?: InputMaybe<Array<UserFilterInput>>;
	order?: InputMaybe<UserOrder>;
	pagination?: InputMaybe<EdgePagination>;
};

export type UserGroupConnection = {
	__typename?: "UserGroupConnection";
	edges: Array<UserGroupEdge>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"]["output"];
};

export type UserGroupCreateInput = {
	color?: InputMaybe<Scalars["String"]["input"]>;
	description?: InputMaybe<Scalars["String"]["input"]>;
	isPublic?: InputMaybe<Scalars["Boolean"]["input"]>;
	messageGroupIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	name: Scalars["String"]["input"];
	sharingPolicyIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	userIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
};

export type UserGroupEdge = {
	__typename?: "UserGroupEdge";
	cursor: Scalars["Cursor"]["output"];
	node: UserGroup;
};

export type UserGroupFilterInput = {
	and?: InputMaybe<Array<UserGroupFilterInput>>;
	colorContains?: InputMaybe<Scalars["String"]["input"]>;
	colorEQ?: InputMaybe<Scalars["String"]["input"]>;
	colorHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	colorHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	colorIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	colorNEQ?: InputMaybe<Scalars["String"]["input"]>;
	colorNotContains?: InputMaybe<Scalars["String"]["input"]>;
	colorNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	colorNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	colorNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	descriptionContains?: InputMaybe<Scalars["String"]["input"]>;
	descriptionEQ?: InputMaybe<Scalars["String"]["input"]>;
	descriptionHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	descriptionHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	descriptionIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	descriptionNEQ?: InputMaybe<Scalars["String"]["input"]>;
	descriptionNotContains?: InputMaybe<Scalars["String"]["input"]>;
	descriptionNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	descriptionNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	descriptionNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	hasMembers?: InputMaybe<Scalars["Boolean"]["input"]>;
	hasMessageGroups?: InputMaybe<Scalars["Boolean"]["input"]>;
	hasSharingPolicies?: InputMaybe<Scalars["Boolean"]["input"]>;
	hasUsers?: InputMaybe<Scalars["Boolean"]["input"]>;
	idEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	isPublicEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	isPublicNEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	members?: InputMaybe<Array<UserFilterInput>>;
	messageGroups?: InputMaybe<Array<MessageGroupFilterInput>>;
	nameContains?: InputMaybe<Scalars["String"]["input"]>;
	nameEQ?: InputMaybe<Scalars["String"]["input"]>;
	nameHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	nameHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	nameIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	nameNEQ?: InputMaybe<Scalars["String"]["input"]>;
	nameNotContains?: InputMaybe<Scalars["String"]["input"]>;
	nameNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	nameNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	nameNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	not?: InputMaybe<UserGroupFilterInput>;
	or?: InputMaybe<Array<UserGroupFilterInput>>;
	search?: InputMaybe<Scalars["String"]["input"]>;
	sharingPolicies?: InputMaybe<Array<SharingPolicyFilterInput>>;
	users?: InputMaybe<Array<UserFilterInput>>;
};

export type UserGroupHistory = Node & {
	__typename?: "UserGroupHistory";
	color: Maybe<Scalars["String"]["output"]>;
	description: Maybe<Scalars["String"]["output"]>;
	historyIsSystem: Scalars["Boolean"]["output"];
	historyTime: Scalars["Time"]["output"];
	historyType: HistoryType;
	historyUserID: Maybe<Scalars["ID"]["output"]>;
	id: Scalars["ID"]["output"];
	isPublic: Maybe<Scalars["Boolean"]["output"]>;
	name: Maybe<Scalars["String"]["output"]>;
	originalID: Maybe<Scalars["ID"]["output"]>;
};

export type UserGroupHistoryConnection = {
	__typename?: "UserGroupHistoryConnection";
	edges: Array<UserGroupHistoryEdge>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"]["output"];
};

export type UserGroupHistoryEdge = {
	__typename?: "UserGroupHistoryEdge";
	cursor: Scalars["Cursor"]["output"];
	node: UserGroupHistory;
};

export type UserGroupHistoryFilterInput = {
	and?: InputMaybe<Array<UserGroupHistoryFilterInput>>;
	colorContains?: InputMaybe<Scalars["String"]["input"]>;
	colorEQ?: InputMaybe<Scalars["String"]["input"]>;
	colorHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	colorHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	colorIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	colorIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	colorNEQ?: InputMaybe<Scalars["String"]["input"]>;
	colorNotContains?: InputMaybe<Scalars["String"]["input"]>;
	colorNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	colorNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	colorNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	descriptionContains?: InputMaybe<Scalars["String"]["input"]>;
	descriptionEQ?: InputMaybe<Scalars["String"]["input"]>;
	descriptionHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	descriptionHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	descriptionIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	descriptionIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	descriptionNEQ?: InputMaybe<Scalars["String"]["input"]>;
	descriptionNotContains?: InputMaybe<Scalars["String"]["input"]>;
	descriptionNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	descriptionNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	descriptionNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	historyIsSystemEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyIsSystemNEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyTimeEQ?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeGT?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeGTE?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	historyTimeLT?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeLTE?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeNEQ?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeNotIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	historyTypeEQ?: InputMaybe<HistoryType>;
	historyTypeIn?: InputMaybe<Array<HistoryType>>;
	historyTypeNEQ?: InputMaybe<HistoryType>;
	historyTypeNotIn?: InputMaybe<Array<HistoryType>>;
	historyUserIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	historyUserIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	historyUserIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyUserIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	historyUserIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	isPublicEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	isPublicIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	isPublicNEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	nameContains?: InputMaybe<Scalars["String"]["input"]>;
	nameEQ?: InputMaybe<Scalars["String"]["input"]>;
	nameHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	nameHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	nameIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	nameIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	nameNEQ?: InputMaybe<Scalars["String"]["input"]>;
	nameNotContains?: InputMaybe<Scalars["String"]["input"]>;
	nameNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	nameNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	nameNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	not?: InputMaybe<UserGroupHistoryFilterInput>;
	or?: InputMaybe<Array<UserGroupHistoryFilterInput>>;
	originalIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	originalIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	originalIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	originalIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	originalIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	search?: InputMaybe<Scalars["String"]["input"]>;
};

export type UserGroupHistoryOrder = {
	direction: OrderDirection;
	field?: InputMaybe<UserGroupHistoryOrderField>;
};

export enum UserGroupHistoryOrderField {
	HistoryTime = "HISTORY_TIME",
}

export type UserGroupMemberGroupUserMemberHistory = Node & {
	__typename?: "UserGroupMemberGroupUserMemberHistory";
	historyIsSystem: Scalars["Boolean"]["output"];
	historyTime: Scalars["Time"]["output"];
	historyType: HistoryType;
	historyUserID: Maybe<Scalars["ID"]["output"]>;
	id: Scalars["ID"]["output"];
	userGroupID: Maybe<Scalars["ID"]["output"]>;
	userID: Maybe<Scalars["ID"]["output"]>;
};

export type UserGroupMemberGroupUserMemberHistoryConnection = {
	__typename?: "UserGroupMemberGroupUserMemberHistoryConnection";
	edges: Array<UserGroupMemberGroupUserMemberHistoryEdge>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"]["output"];
};

export type UserGroupMemberGroupUserMemberHistoryEdge = {
	__typename?: "UserGroupMemberGroupUserMemberHistoryEdge";
	cursor: Scalars["Cursor"]["output"];
	node: UserGroupMemberGroupUserMemberHistory;
};

export type UserGroupMemberGroupUserMemberHistoryFilterInput = {
	and?: InputMaybe<Array<UserGroupMemberGroupUserMemberHistoryFilterInput>>;
	historyIsSystemEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyIsSystemNEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyTimeEQ?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeGT?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeGTE?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	historyTimeLT?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeLTE?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeNEQ?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeNotIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	historyTypeEQ?: InputMaybe<HistoryType>;
	historyTypeIn?: InputMaybe<Array<HistoryType>>;
	historyTypeNEQ?: InputMaybe<HistoryType>;
	historyTypeNotIn?: InputMaybe<Array<HistoryType>>;
	historyUserIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	historyUserIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	historyUserIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyUserIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	historyUserIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	not?: InputMaybe<UserGroupMemberGroupUserMemberHistoryFilterInput>;
	or?: InputMaybe<Array<UserGroupMemberGroupUserMemberHistoryFilterInput>>;
	userGroupIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	userGroupIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	userGroupIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	userGroupIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	userGroupIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	userIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	userIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	userIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	userIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	userIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
};

export type UserGroupMemberGroupUserMemberHistoryOrder = {
	direction: OrderDirection;
	field?: InputMaybe<UserGroupMemberGroupUserMemberHistoryOrderField>;
};

export enum UserGroupMemberGroupUserMemberHistoryOrderField {
	HistoryTime = "HISTORY_TIME",
}

export type UserGroupOrder = {
	direction: OrderDirection;
	field?: InputMaybe<UserGroupOrderField>;
};

export enum UserGroupOrderField {
	Name = "NAME",
}

export type UserGroupUpdateBulkInput = {
	addMessageGroupIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	addSharingPolicyIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	addUserIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	color?: InputMaybe<Scalars["String"]["input"]>;
	description?: InputMaybe<Scalars["String"]["input"]>;
	isPublic?: InputMaybe<Scalars["Boolean"]["input"]>;
	name?: InputMaybe<Scalars["String"]["input"]>;
	removeMessageGroupIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	removeSharingPolicyIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	removeUserIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
};

export type UserGroupUpdateInput = {
	addMessageGroupIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	addSharingPolicyIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	addUserIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	color?: InputMaybe<Scalars["String"]["input"]>;
	description?: InputMaybe<Scalars["String"]["input"]>;
	isPublic?: InputMaybe<Scalars["Boolean"]["input"]>;
	name?: InputMaybe<Scalars["String"]["input"]>;
	removeMessageGroupIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	removeSharingPolicyIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	removeUserIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
};

export type UserGroupUserHistory = Node & {
	__typename?: "UserGroupUserHistory";
	historyIsSystem: Scalars["Boolean"]["output"];
	historyTime: Scalars["Time"]["output"];
	historyType: HistoryType;
	historyUserID: Maybe<Scalars["ID"]["output"]>;
	id: Scalars["ID"]["output"];
	userGroupID: Maybe<Scalars["ID"]["output"]>;
	userID: Maybe<Scalars["ID"]["output"]>;
};

export type UserGroupUserHistoryConnection = {
	__typename?: "UserGroupUserHistoryConnection";
	edges: Array<UserGroupUserHistoryEdge>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"]["output"];
};

export type UserGroupUserHistoryEdge = {
	__typename?: "UserGroupUserHistoryEdge";
	cursor: Scalars["Cursor"]["output"];
	node: UserGroupUserHistory;
};

export type UserGroupUserHistoryFilterInput = {
	and?: InputMaybe<Array<UserGroupUserHistoryFilterInput>>;
	historyIsSystemEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyIsSystemNEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyTimeEQ?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeGT?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeGTE?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	historyTimeLT?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeLTE?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeNEQ?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeNotIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	historyTypeEQ?: InputMaybe<HistoryType>;
	historyTypeIn?: InputMaybe<Array<HistoryType>>;
	historyTypeNEQ?: InputMaybe<HistoryType>;
	historyTypeNotIn?: InputMaybe<Array<HistoryType>>;
	historyUserIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	historyUserIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	historyUserIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyUserIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	historyUserIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	not?: InputMaybe<UserGroupUserHistoryFilterInput>;
	or?: InputMaybe<Array<UserGroupUserHistoryFilterInput>>;
	userGroupIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	userGroupIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	userGroupIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	userGroupIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	userGroupIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	userIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	userIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	userIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	userIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	userIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
};

export type UserGroupUserHistoryOrder = {
	direction: OrderDirection;
	field?: InputMaybe<UserGroupUserHistoryOrderField>;
};

export enum UserGroupUserHistoryOrderField {
	HistoryTime = "HISTORY_TIME",
}

export type UserHistory = Node & {
	__typename?: "UserHistory";
	dateOfBirth: Maybe<Scalars["Time"]["output"]>;
	email: Maybe<Scalars["String"]["output"]>;
	externalNotificationFrequency: Maybe<UserHistoryExternalNotificationFrequency>;
	familyName: Maybe<Scalars["String"]["output"]>;
	gender: Maybe<Scalars["String"]["output"]>;
	givenName: Maybe<Scalars["String"]["output"]>;
	historyIsSystem: Scalars["Boolean"]["output"];
	historyTime: Scalars["Time"]["output"];
	historyType: HistoryType;
	historyUserID: Maybe<Scalars["ID"]["output"]>;
	id: Scalars["ID"]["output"];
	imageContentType: Maybe<Scalars["String"]["output"]>;
	imageKey: Maybe<Scalars["String"]["output"]>;
	middleName: Maybe<Scalars["String"]["output"]>;
	nameOrder: Maybe<UserHistoryNameOrder>;
	organizationName: Maybe<Scalars["String"]["output"]>;
	originalID: Maybe<Scalars["ID"]["output"]>;
	passwordUpdatedAt: Maybe<Scalars["Time"]["output"]>;
	pronouns: Maybe<Scalars["String"]["output"]>;
	publicNameFormat: Maybe<UserHistoryPublicNameFormat>;
	status: Maybe<UserHistoryStatus>;
	timeZoneName: Maybe<Scalars["String"]["output"]>;
};

export type UserHistoryConnection = {
	__typename?: "UserHistoryConnection";
	edges: Array<UserHistoryEdge>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"]["output"];
};

export type UserHistoryEdge = {
	__typename?: "UserHistoryEdge";
	cursor: Scalars["Cursor"]["output"];
	node: UserHistory;
};

export enum UserHistoryExternalNotificationFrequency {
	Daily = "daily",
	Never = "never",
	Weekly = "weekly",
}

export type UserHistoryFilterInput = {
	and?: InputMaybe<Array<UserHistoryFilterInput>>;
	dateOfBirthEQ?: InputMaybe<Scalars["Time"]["input"]>;
	dateOfBirthGT?: InputMaybe<Scalars["Time"]["input"]>;
	dateOfBirthGTE?: InputMaybe<Scalars["Time"]["input"]>;
	dateOfBirthIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	dateOfBirthIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	dateOfBirthLT?: InputMaybe<Scalars["Time"]["input"]>;
	dateOfBirthLTE?: InputMaybe<Scalars["Time"]["input"]>;
	dateOfBirthNEQ?: InputMaybe<Scalars["Time"]["input"]>;
	dateOfBirthNotIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	emailContains?: InputMaybe<Scalars["String"]["input"]>;
	emailEQ?: InputMaybe<Scalars["String"]["input"]>;
	emailHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	emailHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	emailIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	emailIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	emailNEQ?: InputMaybe<Scalars["String"]["input"]>;
	emailNotContains?: InputMaybe<Scalars["String"]["input"]>;
	emailNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	emailNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	emailNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	externalNotificationFrequencyEQ?: InputMaybe<UserHistoryExternalNotificationFrequency>;
	externalNotificationFrequencyIn?: InputMaybe<Array<UserHistoryExternalNotificationFrequency>>;
	externalNotificationFrequencyIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	externalNotificationFrequencyNEQ?: InputMaybe<UserHistoryExternalNotificationFrequency>;
	externalNotificationFrequencyNotIn?: InputMaybe<Array<UserHistoryExternalNotificationFrequency>>;
	familyNameContains?: InputMaybe<Scalars["String"]["input"]>;
	familyNameEQ?: InputMaybe<Scalars["String"]["input"]>;
	familyNameHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	familyNameHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	familyNameIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	familyNameIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	familyNameNEQ?: InputMaybe<Scalars["String"]["input"]>;
	familyNameNotContains?: InputMaybe<Scalars["String"]["input"]>;
	familyNameNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	familyNameNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	familyNameNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	genderContains?: InputMaybe<Scalars["String"]["input"]>;
	genderEQ?: InputMaybe<Scalars["String"]["input"]>;
	genderHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	genderHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	genderIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	genderIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	genderNEQ?: InputMaybe<Scalars["String"]["input"]>;
	genderNotContains?: InputMaybe<Scalars["String"]["input"]>;
	genderNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	genderNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	genderNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	givenNameContains?: InputMaybe<Scalars["String"]["input"]>;
	givenNameEQ?: InputMaybe<Scalars["String"]["input"]>;
	givenNameHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	givenNameHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	givenNameIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	givenNameIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	givenNameNEQ?: InputMaybe<Scalars["String"]["input"]>;
	givenNameNotContains?: InputMaybe<Scalars["String"]["input"]>;
	givenNameNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	givenNameNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	givenNameNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	historyIsSystemEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyIsSystemNEQ?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyTimeEQ?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeGT?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeGTE?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	historyTimeLT?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeLTE?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeNEQ?: InputMaybe<Scalars["Time"]["input"]>;
	historyTimeNotIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	historyTypeEQ?: InputMaybe<HistoryType>;
	historyTypeIn?: InputMaybe<Array<HistoryType>>;
	historyTypeNEQ?: InputMaybe<HistoryType>;
	historyTypeNotIn?: InputMaybe<Array<HistoryType>>;
	historyUserIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	historyUserIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	historyUserIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	historyUserIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	historyUserIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	imageContentTypeContains?: InputMaybe<Scalars["String"]["input"]>;
	imageContentTypeEQ?: InputMaybe<Scalars["String"]["input"]>;
	imageContentTypeHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	imageContentTypeHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	imageContentTypeIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	imageContentTypeIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	imageContentTypeNEQ?: InputMaybe<Scalars["String"]["input"]>;
	imageContentTypeNotContains?: InputMaybe<Scalars["String"]["input"]>;
	imageContentTypeNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	imageContentTypeNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	imageContentTypeNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	imageKeyContains?: InputMaybe<Scalars["String"]["input"]>;
	imageKeyEQ?: InputMaybe<Scalars["String"]["input"]>;
	imageKeyHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	imageKeyHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	imageKeyIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	imageKeyIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	imageKeyNEQ?: InputMaybe<Scalars["String"]["input"]>;
	imageKeyNotContains?: InputMaybe<Scalars["String"]["input"]>;
	imageKeyNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	imageKeyNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	imageKeyNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	middleNameContains?: InputMaybe<Scalars["String"]["input"]>;
	middleNameEQ?: InputMaybe<Scalars["String"]["input"]>;
	middleNameHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	middleNameHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	middleNameIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	middleNameIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	middleNameNEQ?: InputMaybe<Scalars["String"]["input"]>;
	middleNameNotContains?: InputMaybe<Scalars["String"]["input"]>;
	middleNameNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	middleNameNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	middleNameNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	nameOrderEQ?: InputMaybe<UserHistoryNameOrder>;
	nameOrderIn?: InputMaybe<Array<UserHistoryNameOrder>>;
	nameOrderIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	nameOrderNEQ?: InputMaybe<UserHistoryNameOrder>;
	nameOrderNotIn?: InputMaybe<Array<UserHistoryNameOrder>>;
	not?: InputMaybe<UserHistoryFilterInput>;
	or?: InputMaybe<Array<UserHistoryFilterInput>>;
	organizationNameContains?: InputMaybe<Scalars["String"]["input"]>;
	organizationNameEQ?: InputMaybe<Scalars["String"]["input"]>;
	organizationNameHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	organizationNameHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	organizationNameIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	organizationNameIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	organizationNameNEQ?: InputMaybe<Scalars["String"]["input"]>;
	organizationNameNotContains?: InputMaybe<Scalars["String"]["input"]>;
	organizationNameNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	organizationNameNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	organizationNameNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	originalIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	originalIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	originalIDIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	originalIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	originalIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	passwordUpdatedAtEQ?: InputMaybe<Scalars["Time"]["input"]>;
	passwordUpdatedAtGT?: InputMaybe<Scalars["Time"]["input"]>;
	passwordUpdatedAtGTE?: InputMaybe<Scalars["Time"]["input"]>;
	passwordUpdatedAtIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	passwordUpdatedAtIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	passwordUpdatedAtLT?: InputMaybe<Scalars["Time"]["input"]>;
	passwordUpdatedAtLTE?: InputMaybe<Scalars["Time"]["input"]>;
	passwordUpdatedAtNEQ?: InputMaybe<Scalars["Time"]["input"]>;
	passwordUpdatedAtNotIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	pronounsContains?: InputMaybe<Scalars["String"]["input"]>;
	pronounsEQ?: InputMaybe<Scalars["String"]["input"]>;
	pronounsHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	pronounsHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	pronounsIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	pronounsIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	pronounsNEQ?: InputMaybe<Scalars["String"]["input"]>;
	pronounsNotContains?: InputMaybe<Scalars["String"]["input"]>;
	pronounsNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	pronounsNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	pronounsNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	publicNameFormatEQ?: InputMaybe<UserHistoryPublicNameFormat>;
	publicNameFormatIn?: InputMaybe<Array<UserHistoryPublicNameFormat>>;
	publicNameFormatIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	publicNameFormatNEQ?: InputMaybe<UserHistoryPublicNameFormat>;
	publicNameFormatNotIn?: InputMaybe<Array<UserHistoryPublicNameFormat>>;
	search?: InputMaybe<Scalars["String"]["input"]>;
	statusEQ?: InputMaybe<UserHistoryStatus>;
	statusIn?: InputMaybe<Array<UserHistoryStatus>>;
	statusIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	statusNEQ?: InputMaybe<UserHistoryStatus>;
	statusNotIn?: InputMaybe<Array<UserHistoryStatus>>;
	timeZoneNameContains?: InputMaybe<Scalars["String"]["input"]>;
	timeZoneNameEQ?: InputMaybe<Scalars["String"]["input"]>;
	timeZoneNameHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	timeZoneNameHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	timeZoneNameIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
	timeZoneNameIsNull?: InputMaybe<Scalars["Boolean"]["input"]>;
	timeZoneNameNEQ?: InputMaybe<Scalars["String"]["input"]>;
	timeZoneNameNotContains?: InputMaybe<Scalars["String"]["input"]>;
	timeZoneNameNotHasPrefix?: InputMaybe<Scalars["String"]["input"]>;
	timeZoneNameNotHasSuffix?: InputMaybe<Scalars["String"]["input"]>;
	timeZoneNameNotIn?: InputMaybe<Array<Scalars["String"]["input"]>>;
};

export enum UserHistoryNameOrder {
	FamilyGiven = "family_given",
	GivenFamily = "given_family",
}

export type UserHistoryOrder = {
	direction: OrderDirection;
	field?: InputMaybe<UserHistoryOrderField>;
};

export enum UserHistoryOrderField {
	HistoryTime = "HISTORY_TIME",
}

export enum UserHistoryPublicNameFormat {
	FullName = "full_name",
	GivenNameFamilyInitial = "given_name_family_initial",
	Hidden = "hidden",
}

export enum UserHistoryStatus {
	Active = "active",
	Created = "created",
	Disabled = "disabled",
	Invited = "invited",
}

export enum UserNameOrder {
	FamilyGiven = "family_given",
	GivenFamily = "given_family",
}

export type UserOrder = {
	direction: OrderDirection;
	field?: InputMaybe<UserOrderField>;
};

export enum UserOrderField {
	DateOfBirth = "DATE_OF_BIRTH",
	Email = "EMAIL",
	ExternalNotificationFrequency = "EXTERNAL_NOTIFICATION_FREQUENCY",
	FamilyName = "FAMILY_NAME",
	Gender = "GENDER",
	GivenName = "GIVEN_NAME",
	OrganizationName = "ORGANIZATION_NAME",
	PasswordUpdatedAt = "PASSWORD_UPDATED_AT",
	Status = "STATUS",
}

export enum UserPublicNameFormat {
	FullName = "full_name",
	GivenNameFamilyInitial = "given_name_family_initial",
	Hidden = "hidden",
}

export enum UserStatus {
	Active = "active",
	Created = "created",
	Disabled = "disabled",
	Invited = "invited",
}

export type UserUpdateBulkInput = {
	addMessageGroupIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	addPermissionGroupIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	addSharingPolicyIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	addUserGroupIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	clearDateOfBirth?: InputMaybe<Scalars["Boolean"]["input"]>;
	dateOfBirth?: InputMaybe<Scalars["Time"]["input"]>;
	externalNotificationFrequency?: InputMaybe<UserExternalNotificationFrequency>;
	familyName?: InputMaybe<Scalars["String"]["input"]>;
	gender?: InputMaybe<Scalars["String"]["input"]>;
	givenName?: InputMaybe<Scalars["String"]["input"]>;
	imageContentType?: InputMaybe<Scalars["String"]["input"]>;
	imageKey?: InputMaybe<Scalars["String"]["input"]>;
	middleName?: InputMaybe<Scalars["String"]["input"]>;
	nameOrder?: InputMaybe<UserNameOrder>;
	organizationName?: InputMaybe<Scalars["String"]["input"]>;
	pronouns?: InputMaybe<Scalars["String"]["input"]>;
	publicNameFormat?: InputMaybe<UserPublicNameFormat>;
	removeMessageGroupIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	removePermissionGroupIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	removeSharingPolicyIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	removeUserGroupIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	status?: InputMaybe<UserStatus>;
	timeZoneName?: InputMaybe<Scalars["String"]["input"]>;
};

export type UserUpdateInput = {
	addMessageGroupIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	addPermissionGroupIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	addSharingPolicyIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	addUserGroupIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	clearDateOfBirth?: InputMaybe<Scalars["Boolean"]["input"]>;
	dateOfBirth?: InputMaybe<Scalars["Time"]["input"]>;
	email?: InputMaybe<Scalars["String"]["input"]>;
	externalNotificationFrequency?: InputMaybe<UserExternalNotificationFrequency>;
	familyName?: InputMaybe<Scalars["String"]["input"]>;
	gender?: InputMaybe<Scalars["String"]["input"]>;
	givenName?: InputMaybe<Scalars["String"]["input"]>;
	imageContentType?: InputMaybe<Scalars["String"]["input"]>;
	imageKey?: InputMaybe<Scalars["String"]["input"]>;
	middleName?: InputMaybe<Scalars["String"]["input"]>;
	nameOrder?: InputMaybe<UserNameOrder>;
	organizationName?: InputMaybe<Scalars["String"]["input"]>;
	pronouns?: InputMaybe<Scalars["String"]["input"]>;
	publicNameFormat?: InputMaybe<UserPublicNameFormat>;
	removeMessageGroupIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	removePermissionGroupIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	removeSharingPolicyIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	removeUserGroupIDs?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	status?: InputMaybe<UserStatus>;
	timeZoneName?: InputMaybe<Scalars["String"]["input"]>;
};

export type UserViewRecord = Node & {
	__typename?: "UserViewRecord";
	firstViewedAt: Scalars["Time"]["output"];
	id: Scalars["ID"]["output"];
	lastViewedAt: Scalars["Time"]["output"];
	targetID: Scalars["ID"]["output"];
	user: User;
	userID: Scalars["ID"]["output"];
};

export type UserViewRecordConnection = {
	__typename?: "UserViewRecordConnection";
	edges: Array<UserViewRecordEdge>;
	pageInfo: PageInfo;
	totalCount: Scalars["Int"]["output"];
};

export type UserViewRecordCreateInput = {
	targetID: Scalars["ID"]["input"];
};

export type UserViewRecordEdge = {
	__typename?: "UserViewRecordEdge";
	cursor: Scalars["Cursor"]["output"];
	node: UserViewRecord;
};

export type UserViewRecordFilterInput = {
	and?: InputMaybe<Array<UserViewRecordFilterInput>>;
	firstViewedAtEQ?: InputMaybe<Scalars["Time"]["input"]>;
	firstViewedAtGT?: InputMaybe<Scalars["Time"]["input"]>;
	firstViewedAtGTE?: InputMaybe<Scalars["Time"]["input"]>;
	firstViewedAtIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	firstViewedAtLT?: InputMaybe<Scalars["Time"]["input"]>;
	firstViewedAtLTE?: InputMaybe<Scalars["Time"]["input"]>;
	firstViewedAtNEQ?: InputMaybe<Scalars["Time"]["input"]>;
	firstViewedAtNotIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	idEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	idNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	idNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	lastViewedAtEQ?: InputMaybe<Scalars["Time"]["input"]>;
	lastViewedAtGT?: InputMaybe<Scalars["Time"]["input"]>;
	lastViewedAtGTE?: InputMaybe<Scalars["Time"]["input"]>;
	lastViewedAtIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	lastViewedAtLT?: InputMaybe<Scalars["Time"]["input"]>;
	lastViewedAtLTE?: InputMaybe<Scalars["Time"]["input"]>;
	lastViewedAtNEQ?: InputMaybe<Scalars["Time"]["input"]>;
	lastViewedAtNotIn?: InputMaybe<Array<Scalars["Time"]["input"]>>;
	not?: InputMaybe<UserViewRecordFilterInput>;
	or?: InputMaybe<Array<UserViewRecordFilterInput>>;
	search?: InputMaybe<Scalars["String"]["input"]>;
	targetIDEQ?: InputMaybe<Scalars["Int"]["input"]>;
	targetIDGT?: InputMaybe<Scalars["Int"]["input"]>;
	targetIDGTE?: InputMaybe<Scalars["Int"]["input"]>;
	targetIDIn?: InputMaybe<Array<Scalars["Int"]["input"]>>;
	targetIDLT?: InputMaybe<Scalars["Int"]["input"]>;
	targetIDLTE?: InputMaybe<Scalars["Int"]["input"]>;
	targetIDNEQ?: InputMaybe<Scalars["Int"]["input"]>;
	targetIDNotIn?: InputMaybe<Array<Scalars["Int"]["input"]>>;
	user?: InputMaybe<Array<UserFilterInput>>;
	userIDEQ?: InputMaybe<Scalars["ID"]["input"]>;
	userIDIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
	userIDNEQ?: InputMaybe<Scalars["ID"]["input"]>;
	userIDNotIn?: InputMaybe<Array<Scalars["ID"]["input"]>>;
};

export type UserViewRecordInUserCreateInput = {
	targetID: Scalars["ID"]["input"];
};

export type UserViewRecordOrder = {
	direction: OrderDirection;
	field?: InputMaybe<UserViewRecordOrderField>;
};

export enum UserViewRecordOrderField {
	FirstViewedAt = "FIRST_VIEWED_AT",
	LastViewedAt = "LAST_VIEWED_AT",
}

export type UserViewRecordUpdateInput = {
	_filler?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type AnnouncementCountQueryVariables = Exact<{
	filters?: InputMaybe<Array<AnnouncementFilterInput> | AnnouncementFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<AnnouncementOrder>;
}>;

export type AnnouncementCountQuery = {
	__typename?: "Query";
	announcementConnection: { __typename?: "AnnouncementConnection"; totalCount: number };
};

export type AnnouncementCreateMutationVariables = Exact<{
	input: AnnouncementCreateInput;
}>;

export type AnnouncementCreateMutation = {
	__typename?: "Mutation";
	createAnnouncement: {
		__typename?: "Announcement";
		id: string;
		title: string;
		body: string;
		startTime: string;
		endTime: string | null;
		author: {
			__typename?: "User";
			id: string;
			name: string;
			publicName: string;
			givenName: string;
			familyName: string;
			isCurrent: boolean;
			imageURL: string;
			imageKey: string;
			imageContentType: string;
		} | null;
		mediaAttachments: Array<{
			__typename?: "MediaAttachment";
			id: string;
			displayOrder: number;
			title: string;
			description: string;
			isFile: boolean;
			fileURL: string;
			fileKey: string;
			fileContentType: string;
			linkURL: string;
		}>;
		sharingPolicy: {
			__typename?: "SharingPolicy";
			id: string;
			isPublic: boolean;
			userGroups: Array<{ __typename?: "UserGroup"; id: string; name: string; color: string }>;
			users: Array<{
				__typename?: "User";
				id: string;
				name: string;
				publicName: string;
				givenName: string;
				familyName: string;
				isCurrent: boolean;
			}>;
		} | null;
	};
};

export type AnnouncementDeleteMutationVariables = Exact<{
	id: Scalars["ID"]["input"];
}>;

export type AnnouncementDeleteMutation = { __typename?: "Mutation"; deleteAnnouncement: boolean };

export type AnnouncementDetailFragment = {
	__typename?: "Announcement";
	id: string;
	title: string;
	body: string;
	startTime: string;
	endTime: string | null;
	author: {
		__typename?: "User";
		id: string;
		name: string;
		publicName: string;
		givenName: string;
		familyName: string;
		isCurrent: boolean;
		imageURL: string;
		imageKey: string;
		imageContentType: string;
	} | null;
	mediaAttachments: Array<{
		__typename?: "MediaAttachment";
		id: string;
		displayOrder: number;
		title: string;
		description: string;
		isFile: boolean;
		fileURL: string;
		fileKey: string;
		fileContentType: string;
		linkURL: string;
	}>;
	sharingPolicy: {
		__typename?: "SharingPolicy";
		id: string;
		isPublic: boolean;
		userGroups: Array<{ __typename?: "UserGroup"; id: string; name: string; color: string }>;
		users: Array<{
			__typename?: "User";
			id: string;
			name: string;
			publicName: string;
			givenName: string;
			familyName: string;
			isCurrent: boolean;
		}>;
	} | null;
};

export type AnnouncementDetailQueryVariables = Exact<{
	id: Scalars["ID"]["input"];
}>;

export type AnnouncementDetailQuery = {
	__typename?: "Query";
	announcement: {
		__typename?: "Announcement";
		id: string;
		title: string;
		body: string;
		startTime: string;
		endTime: string | null;
		author: {
			__typename?: "User";
			id: string;
			name: string;
			publicName: string;
			givenName: string;
			familyName: string;
			isCurrent: boolean;
			imageURL: string;
			imageKey: string;
			imageContentType: string;
		} | null;
		mediaAttachments: Array<{
			__typename?: "MediaAttachment";
			id: string;
			displayOrder: number;
			title: string;
			description: string;
			isFile: boolean;
			fileURL: string;
			fileKey: string;
			fileContentType: string;
			linkURL: string;
		}>;
		sharingPolicy: {
			__typename?: "SharingPolicy";
			id: string;
			isPublic: boolean;
			userGroups: Array<{ __typename?: "UserGroup"; id: string; name: string; color: string }>;
			users: Array<{
				__typename?: "User";
				id: string;
				name: string;
				publicName: string;
				givenName: string;
				familyName: string;
				isCurrent: boolean;
			}>;
		} | null;
	};
};

export type AnnouncementHomePageListQueryVariables = Exact<{
	filters?: InputMaybe<Array<AnnouncementFilterInput> | AnnouncementFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<AnnouncementOrder>;
}>;

export type AnnouncementHomePageListQuery = {
	__typename?: "Query";
	announcementConnection: {
		__typename?: "AnnouncementConnection";
		pageInfo: { __typename?: "PageInfo"; endCursor: string | null; hasNextPage: boolean };
		edges: Array<{
			__typename?: "AnnouncementEdge";
			node: {
				__typename?: "Announcement";
				id: string;
				title: string;
				body: string;
				startTime: string;
				endTime: string | null;
				author: {
					__typename?: "User";
					id: string;
					name: string;
					publicName: string;
					givenName: string;
					familyName: string;
					isCurrent: boolean;
					imageURL: string;
					imageKey: string;
					imageContentType: string;
				} | null;
				mediaAttachments: Array<{
					__typename?: "MediaAttachment";
					id: string;
					title: string;
					description: string;
					isFile: boolean;
					fileURL: string;
					fileKey: string;
					fileContentType: string;
					linkURL: string;
				}>;
			};
		}>;
	};
};

export type AnnouncementCommunicationCenterPageListQueryVariables = Exact<{
	filters?: InputMaybe<Array<AnnouncementFilterInput> | AnnouncementFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<AnnouncementOrder>;
}>;

export type AnnouncementCommunicationCenterPageListQuery = {
	__typename?: "Query";
	announcementConnection: {
		__typename?: "AnnouncementConnection";
		edges: Array<{
			__typename?: "AnnouncementEdge";
			node: {
				__typename?: "Announcement";
				id: string;
				title: string;
				body: string;
				startTime: string;
				endTime: string | null;
				author: {
					__typename?: "User";
					id: string;
					name: string;
					publicName: string;
					givenName: string;
					familyName: string;
					isCurrent: boolean;
					imageURL: string;
					imageKey: string;
					imageContentType: string;
				} | null;
				mediaAttachments: Array<{
					__typename?: "MediaAttachment";
					id: string;
					title: string;
					description: string;
					isFile: boolean;
					fileURL: string;
					fileKey: string;
					fileContentType: string;
					linkURL: string;
				}>;
			};
		}>;
	};
};

export type AnnouncementIndexQueryVariables = Exact<{
	filters?: InputMaybe<Array<AnnouncementFilterInput> | AnnouncementFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<AnnouncementOrder>;
}>;

export type AnnouncementIndexQuery = {
	__typename?: "Query";
	announcementConnection: {
		__typename?: "AnnouncementConnection";
		edges: Array<{
			__typename?: "AnnouncementEdge";
			node: {
				__typename?: "Announcement";
				id: string;
				title: string;
				body: string;
				startTime: string;
				endTime: string | null;
				author: {
					__typename?: "User";
					id: string;
					name: string;
					publicName: string;
					givenName: string;
					familyName: string;
					isCurrent: boolean;
				} | null;
			};
		}>;
	};
};

export type AnnouncementNameFragment = { __typename?: "Announcement"; title: string };

export type AnnouncementNameQueryVariables = Exact<{
	id: Scalars["ID"]["input"];
}>;

export type AnnouncementNameQuery = {
	__typename?: "Query";
	announcement: { __typename?: "Announcement"; id: string; title: string };
};

export type AnnouncementNamesQueryVariables = Exact<{
	filters?: InputMaybe<Array<AnnouncementFilterInput> | AnnouncementFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<AnnouncementOrder>;
}>;

export type AnnouncementNamesQuery = {
	__typename?: "Query";
	announcementConnection: {
		__typename?: "AnnouncementConnection";
		edges: Array<{ __typename?: "AnnouncementEdge"; node: { __typename?: "Announcement"; id: string; title: string } }>;
	};
};

export type AnnouncementPaginationQueryVariables = Exact<{
	filters?: InputMaybe<Array<AnnouncementFilterInput> | AnnouncementFilterInput>;
	order?: InputMaybe<AnnouncementOrder>;
}>;

export type AnnouncementPaginationQuery = {
	__typename?: "Query";
	announcementConnection: {
		__typename?: "AnnouncementConnection";
		totalCount: number;
		edges: Array<{ __typename?: "AnnouncementEdge"; cursor: string }>;
	};
};

export type AnnouncementSelectQueryVariables = Exact<{
	filters?: InputMaybe<Array<AnnouncementFilterInput> | AnnouncementFilterInput>;
	order?: InputMaybe<AnnouncementOrder>;
}>;

export type AnnouncementSelectQuery = {
	__typename?: "Query";
	announcementConnection: {
		__typename?: "AnnouncementConnection";
		edges: Array<{ __typename?: "AnnouncementEdge"; node: { __typename?: "Announcement"; id: string; title: string } }>;
	};
};

export type AnnouncementSocialItemsQueryVariables = Exact<{
	id: Scalars["ID"]["input"];
}>;

export type AnnouncementSocialItemsQuery = {
	__typename?: "Query";
	announcement: {
		__typename?: "Announcement";
		id: string;
		socialReactions: Array<{
			__typename?: "SocialReaction";
			id: string;
			reaction: SocialReactionReaction;
			author: {
				__typename?: "User";
				id: string;
				isCurrent: boolean;
				name: string;
				publicName: string;
				givenName: string;
				familyName: string;
			};
		}>;
	};
};

export type AnnouncementStatisticsQueryVariables = Exact<{
	filters?: InputMaybe<Array<AnnouncementFilterInput> | AnnouncementFilterInput>;
}>;

export type AnnouncementStatisticsQuery = {
	__typename?: "Query";
	announcementStatistics: { __typename?: "AnnouncementStatistics"; count: number; views: number; reactions: number };
};

export type AnnouncementUpdateMutationVariables = Exact<{
	id: Scalars["ID"]["input"];
	input: AnnouncementUpdateInput;
}>;

export type AnnouncementUpdateMutation = {
	__typename?: "Mutation";
	updateAnnouncement: {
		__typename?: "Announcement";
		id: string;
		title: string;
		body: string;
		startTime: string;
		endTime: string | null;
		author: {
			__typename?: "User";
			id: string;
			name: string;
			publicName: string;
			givenName: string;
			familyName: string;
			isCurrent: boolean;
			imageURL: string;
			imageKey: string;
			imageContentType: string;
		} | null;
		mediaAttachments: Array<{
			__typename?: "MediaAttachment";
			id: string;
			displayOrder: number;
			title: string;
			description: string;
			isFile: boolean;
			fileURL: string;
			fileKey: string;
			fileContentType: string;
			linkURL: string;
		}>;
		sharingPolicy: {
			__typename?: "SharingPolicy";
			id: string;
			isPublic: boolean;
			userGroups: Array<{ __typename?: "UserGroup"; id: string; name: string; color: string }>;
			users: Array<{
				__typename?: "User";
				id: string;
				name: string;
				publicName: string;
				givenName: string;
				familyName: string;
				isCurrent: boolean;
			}>;
		} | null;
	};
};

export type CalendarEventTimingFragment = {
	__typename?: "CalendarEvent";
	isAllDay: boolean;
	startTime: string | null;
	endTime: string | null;
	startDate: string | null;
	endDate: string | null;
};

export type CalendarEventCalendarSlimListQueryVariables = Exact<{
	filters?: InputMaybe<Array<CalendarEventFilterInput> | CalendarEventFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<CalendarEventOrder>;
}>;

export type CalendarEventCalendarSlimListQuery = {
	__typename?: "Query";
	calendarEventConnection: {
		__typename?: "CalendarEventConnection";
		edges: Array<{
			__typename?: "CalendarEventEdge";
			node: {
				__typename?: "CalendarEvent";
				id: string;
				name: string;
				isAllDay: boolean;
				startTime: string | null;
				endTime: string | null;
				startDate: string | null;
				endDate: string | null;
				author: { __typename?: "User"; id: string; isCurrent: boolean } | null;
				sharingPolicy: {
					__typename?: "SharingPolicy";
					id: string;
					isPublic: boolean;
					userGroups: Array<{ __typename?: "UserGroup"; id: string; name: string; color: string }>;
				} | null;
			};
		}>;
	};
};

export type CalendarEventCalendarListQueryVariables = Exact<{
	filters?: InputMaybe<Array<CalendarEventFilterInput> | CalendarEventFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<CalendarEventOrder>;
}>;

export type CalendarEventCalendarListQuery = {
	__typename?: "Query";
	calendarEventConnection: {
		__typename?: "CalendarEventConnection";
		edges: Array<{
			__typename?: "CalendarEventEdge";
			node: {
				__typename?: "CalendarEvent";
				id: string;
				name: string;
				description: string;
				isAllDay: boolean;
				startTime: string | null;
				endTime: string | null;
				startDate: string | null;
				endDate: string | null;
				author: { __typename?: "User"; id: string; isCurrent: boolean } | null;
				sharingPolicy: {
					__typename?: "SharingPolicy";
					id: string;
					isPublic: boolean;
					userGroups: Array<{ __typename?: "UserGroup"; id: string; name: string; color: string }>;
				} | null;
			};
		}>;
	};
};

export type CalendarEventCalendarDetailFragment = {
	__typename?: "CalendarEvent";
	id: string;
	name: string;
	description: string;
	location: string;
	imageURL: string;
	imageKey: string;
	imageContentType: string;
	isAllDay: boolean;
	startTime: string | null;
	endTime: string | null;
	startDate: string | null;
	isMultiDay: boolean;
	endDate: string | null;
	allowsResponses: boolean;
	createdAt: string;
	author: {
		__typename?: "User";
		id: string;
		name: string;
		publicName: string;
		givenName: string;
		familyName: string;
		isCurrent: boolean;
		imageURL: string;
		imageKey: string;
		imageContentType: string;
	} | null;
	calendarEventResponses: Array<{
		__typename?: "CalendarEventResponse";
		id: string;
		response: CalendarEventResponseResponse;
		author: {
			__typename?: "User";
			id: string;
			name: string;
			publicName: string;
			givenName: string;
			familyName: string;
			isCurrent: boolean;
			imageURL: string;
			imageKey: string;
			imageContentType: string;
		} | null;
	}>;
	mediaAttachments: Array<{
		__typename?: "MediaAttachment";
		id: string;
		displayOrder: number;
		title: string;
		description: string;
		isFile: boolean;
		fileURL: string;
		fileKey: string;
		fileContentType: string;
		linkURL: string;
	}>;
	sharingPolicy: { __typename?: "SharingPolicy"; id: string; isPublic: boolean } | null;
};

export type CalendarEventCalendarDetailQueryVariables = Exact<{
	id: Scalars["ID"]["input"];
}>;

export type CalendarEventCalendarDetailQuery = {
	__typename?: "Query";
	calendarEventConnection: {
		__typename?: "CalendarEventConnection";
		edges: Array<{
			__typename?: "CalendarEventEdge";
			node: {
				__typename?: "CalendarEvent";
				id: string;
				name: string;
				description: string;
				location: string;
				imageURL: string;
				imageKey: string;
				imageContentType: string;
				isAllDay: boolean;
				startTime: string | null;
				endTime: string | null;
				startDate: string | null;
				isMultiDay: boolean;
				endDate: string | null;
				allowsResponses: boolean;
				createdAt: string;
				author: {
					__typename?: "User";
					id: string;
					name: string;
					publicName: string;
					givenName: string;
					familyName: string;
					isCurrent: boolean;
					imageURL: string;
					imageKey: string;
					imageContentType: string;
				} | null;
				calendarEventResponses: Array<{
					__typename?: "CalendarEventResponse";
					id: string;
					response: CalendarEventResponseResponse;
					author: {
						__typename?: "User";
						id: string;
						name: string;
						publicName: string;
						givenName: string;
						familyName: string;
						isCurrent: boolean;
						imageURL: string;
						imageKey: string;
						imageContentType: string;
					} | null;
				}>;
				mediaAttachments: Array<{
					__typename?: "MediaAttachment";
					id: string;
					displayOrder: number;
					title: string;
					description: string;
					isFile: boolean;
					fileURL: string;
					fileKey: string;
					fileContentType: string;
					linkURL: string;
				}>;
				sharingPolicy: { __typename?: "SharingPolicy"; id: string; isPublic: boolean } | null;
			};
		}>;
	};
};

export type CalendarEventCalendarDetailedListQueryVariables = Exact<{
	filters?: InputMaybe<Array<CalendarEventFilterInput> | CalendarEventFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<CalendarEventOrder>;
}>;

export type CalendarEventCalendarDetailedListQuery = {
	__typename?: "Query";
	calendarEventConnection: {
		__typename?: "CalendarEventConnection";
		edges: Array<{
			__typename?: "CalendarEventEdge";
			node: {
				__typename?: "CalendarEvent";
				id: string;
				name: string;
				description: string;
				location: string;
				imageURL: string;
				imageKey: string;
				imageContentType: string;
				isAllDay: boolean;
				startTime: string | null;
				endTime: string | null;
				startDate: string | null;
				isMultiDay: boolean;
				endDate: string | null;
				allowsResponses: boolean;
				createdAt: string;
				author: {
					__typename?: "User";
					id: string;
					name: string;
					publicName: string;
					givenName: string;
					familyName: string;
					isCurrent: boolean;
					imageURL: string;
					imageKey: string;
					imageContentType: string;
				} | null;
				calendarEventResponses: Array<{
					__typename?: "CalendarEventResponse";
					id: string;
					response: CalendarEventResponseResponse;
					author: {
						__typename?: "User";
						id: string;
						name: string;
						publicName: string;
						givenName: string;
						familyName: string;
						isCurrent: boolean;
						imageURL: string;
						imageKey: string;
						imageContentType: string;
					} | null;
				}>;
				mediaAttachments: Array<{
					__typename?: "MediaAttachment";
					id: string;
					displayOrder: number;
					title: string;
					description: string;
					isFile: boolean;
					fileURL: string;
					fileKey: string;
					fileContentType: string;
					linkURL: string;
				}>;
				sharingPolicy: { __typename?: "SharingPolicy"; id: string; isPublic: boolean } | null;
			};
		}>;
	};
};

export type CalendarEventCountQueryVariables = Exact<{
	filters?: InputMaybe<Array<CalendarEventFilterInput> | CalendarEventFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<CalendarEventOrder>;
}>;

export type CalendarEventCountQuery = {
	__typename?: "Query";
	calendarEventConnection: { __typename?: "CalendarEventConnection"; totalCount: number };
};

export type CalendarEventCreateMutationVariables = Exact<{
	input: CalendarEventCreateInput;
}>;

export type CalendarEventCreateMutation = {
	__typename?: "Mutation";
	createCalendarEvent: {
		__typename?: "CalendarEvent";
		id: string;
		name: string;
		description: string;
		location: string;
		imageURL: string;
		imageKey: string;
		imageContentType: string;
		isAllDay: boolean;
		startTime: string | null;
		endTime: string | null;
		startDate: string | null;
		isMultiDay: boolean;
		endDate: string | null;
		allowsResponses: boolean;
		createdAt: string;
		author: {
			__typename?: "User";
			id: string;
			name: string;
			publicName: string;
			givenName: string;
			familyName: string;
			isCurrent: boolean;
			imageURL: string;
			imageKey: string;
			imageContentType: string;
		} | null;
		calendarEventResponses: Array<{
			__typename?: "CalendarEventResponse";
			id: string;
			response: CalendarEventResponseResponse;
			author: {
				__typename?: "User";
				id: string;
				name: string;
				publicName: string;
				givenName: string;
				familyName: string;
				isCurrent: boolean;
				imageURL: string;
				imageKey: string;
				imageContentType: string;
			} | null;
		}>;
		mediaAttachments: Array<{
			__typename?: "MediaAttachment";
			id: string;
			displayOrder: number;
			title: string;
			description: string;
			isFile: boolean;
			fileURL: string;
			fileKey: string;
			fileContentType: string;
			linkURL: string;
		}>;
		sharingPolicy: {
			__typename?: "SharingPolicy";
			id: string;
			isPublic: boolean;
			userGroups: Array<{ __typename?: "UserGroup"; id: string; name: string; color: string }>;
			users: Array<{
				__typename?: "User";
				id: string;
				name: string;
				publicName: string;
				givenName: string;
				familyName: string;
				isCurrent: boolean;
			}>;
		} | null;
	};
};

export type CalendarEventDeleteMutationVariables = Exact<{
	id: Scalars["ID"]["input"];
}>;

export type CalendarEventDeleteMutation = { __typename?: "Mutation"; deleteCalendarEvent: boolean };

export type CalendarEventDetailFragment = {
	__typename?: "CalendarEvent";
	id: string;
	name: string;
	description: string;
	location: string;
	imageURL: string;
	imageKey: string;
	imageContentType: string;
	isAllDay: boolean;
	startTime: string | null;
	endTime: string | null;
	startDate: string | null;
	isMultiDay: boolean;
	endDate: string | null;
	allowsResponses: boolean;
	createdAt: string;
	author: {
		__typename?: "User";
		id: string;
		name: string;
		publicName: string;
		givenName: string;
		familyName: string;
		isCurrent: boolean;
		imageURL: string;
		imageKey: string;
		imageContentType: string;
	} | null;
	calendarEventResponses: Array<{
		__typename?: "CalendarEventResponse";
		id: string;
		response: CalendarEventResponseResponse;
		author: {
			__typename?: "User";
			id: string;
			name: string;
			publicName: string;
			givenName: string;
			familyName: string;
			isCurrent: boolean;
			imageURL: string;
			imageKey: string;
			imageContentType: string;
		} | null;
	}>;
	mediaAttachments: Array<{
		__typename?: "MediaAttachment";
		id: string;
		displayOrder: number;
		title: string;
		description: string;
		isFile: boolean;
		fileURL: string;
		fileKey: string;
		fileContentType: string;
		linkURL: string;
	}>;
	sharingPolicy: {
		__typename?: "SharingPolicy";
		id: string;
		isPublic: boolean;
		userGroups: Array<{ __typename?: "UserGroup"; id: string; name: string; color: string }>;
		users: Array<{
			__typename?: "User";
			id: string;
			name: string;
			publicName: string;
			givenName: string;
			familyName: string;
			isCurrent: boolean;
		}>;
	} | null;
};

export type CalendarEventDetailQueryVariables = Exact<{
	id: Scalars["ID"]["input"];
}>;

export type CalendarEventDetailQuery = {
	__typename?: "Query";
	calendarEvent: {
		__typename?: "CalendarEvent";
		id: string;
		name: string;
		description: string;
		location: string;
		imageURL: string;
		imageKey: string;
		imageContentType: string;
		isAllDay: boolean;
		startTime: string | null;
		endTime: string | null;
		startDate: string | null;
		isMultiDay: boolean;
		endDate: string | null;
		allowsResponses: boolean;
		createdAt: string;
		author: {
			__typename?: "User";
			id: string;
			name: string;
			publicName: string;
			givenName: string;
			familyName: string;
			isCurrent: boolean;
			imageURL: string;
			imageKey: string;
			imageContentType: string;
		} | null;
		calendarEventResponses: Array<{
			__typename?: "CalendarEventResponse";
			id: string;
			response: CalendarEventResponseResponse;
			author: {
				__typename?: "User";
				id: string;
				name: string;
				publicName: string;
				givenName: string;
				familyName: string;
				isCurrent: boolean;
				imageURL: string;
				imageKey: string;
				imageContentType: string;
			} | null;
		}>;
		mediaAttachments: Array<{
			__typename?: "MediaAttachment";
			id: string;
			displayOrder: number;
			title: string;
			description: string;
			isFile: boolean;
			fileURL: string;
			fileKey: string;
			fileContentType: string;
			linkURL: string;
		}>;
		sharingPolicy: {
			__typename?: "SharingPolicy";
			id: string;
			isPublic: boolean;
			userGroups: Array<{ __typename?: "UserGroup"; id: string; name: string; color: string }>;
			users: Array<{
				__typename?: "User";
				id: string;
				name: string;
				publicName: string;
				givenName: string;
				familyName: string;
				isCurrent: boolean;
			}>;
		} | null;
	};
};

export type CalendarEventIndexQueryVariables = Exact<{
	filters?: InputMaybe<Array<CalendarEventFilterInput> | CalendarEventFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<CalendarEventOrder>;
}>;

export type CalendarEventIndexQuery = {
	__typename?: "Query";
	calendarEventConnection: {
		__typename?: "CalendarEventConnection";
		edges: Array<{
			__typename?: "CalendarEventEdge";
			node: {
				__typename?: "CalendarEvent";
				id: string;
				name: string;
				description: string;
				location: string;
				imageURL: string;
				imageContentType: string;
				isAllDay: boolean;
				startTime: string | null;
				endTime: string | null;
				startDate: string | null;
				isMultiDay: boolean;
				endDate: string | null;
				allowsResponses: boolean;
				createdAt: string;
			};
		}>;
	};
};

export type CalendarEventNameFragment = { __typename?: "CalendarEvent"; name: string };

export type CalendarEventNameQueryVariables = Exact<{
	id: Scalars["ID"]["input"];
}>;

export type CalendarEventNameQuery = {
	__typename?: "Query";
	calendarEvent: { __typename?: "CalendarEvent"; id: string; name: string };
};

export type CalendarEventNamesQueryVariables = Exact<{
	filters?: InputMaybe<Array<CalendarEventFilterInput> | CalendarEventFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<CalendarEventOrder>;
}>;

export type CalendarEventNamesQuery = {
	__typename?: "Query";
	calendarEventConnection: {
		__typename?: "CalendarEventConnection";
		edges: Array<{
			__typename?: "CalendarEventEdge";
			node: { __typename?: "CalendarEvent"; id: string; name: string };
		}>;
	};
};

export type CalendarEventPaginationQueryVariables = Exact<{
	filters?: InputMaybe<Array<CalendarEventFilterInput> | CalendarEventFilterInput>;
	order?: InputMaybe<CalendarEventOrder>;
}>;

export type CalendarEventPaginationQuery = {
	__typename?: "Query";
	calendarEventConnection: {
		__typename?: "CalendarEventConnection";
		totalCount: number;
		edges: Array<{ __typename?: "CalendarEventEdge"; cursor: string }>;
	};
};

export type CalendarEventSelectQueryVariables = Exact<{
	filters?: InputMaybe<Array<CalendarEventFilterInput> | CalendarEventFilterInput>;
	order?: InputMaybe<CalendarEventOrder>;
}>;

export type CalendarEventSelectQuery = {
	__typename?: "Query";
	calendarEventConnection: {
		__typename?: "CalendarEventConnection";
		edges: Array<{
			__typename?: "CalendarEventEdge";
			node: { __typename?: "CalendarEvent"; id: string; name: string };
		}>;
	};
};

export type CalendarEventStatisticsQueryVariables = Exact<{
	filters?: InputMaybe<Array<CalendarEventFilterInput> | CalendarEventFilterInput>;
}>;

export type CalendarEventStatisticsQuery = {
	__typename?: "Query";
	calendarEventStatistics: {
		__typename?: "CalendarEventStatistics";
		count: number;
		responsesAttending: number;
		responsesMaybeAttending: number;
		responsesNotAttending: number;
	};
};

export type CalendarEventListQueryVariables = Exact<{
	filters?: InputMaybe<Array<CalendarEventFilterInput> | CalendarEventFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<CalendarEventOrder>;
}>;

export type CalendarEventListQuery = {
	__typename?: "Query";
	calendarEventConnection: {
		__typename?: "CalendarEventConnection";
		edges: Array<{
			__typename?: "CalendarEventEdge";
			node: {
				__typename?: "CalendarEvent";
				id: string;
				name: string;
				imageURL: string;
				imageContentType: string;
				isAllDay: boolean;
				startTime: string | null;
				endTime: string | null;
				startDate: string | null;
				endDate: string | null;
				allowsResponses: boolean;
				calendarEventResponses: Array<{
					__typename?: "CalendarEventResponse";
					id: string;
					response: CalendarEventResponseResponse;
				}>;
			};
		}>;
	};
};

export type CalendarEventUpdateMutationVariables = Exact<{
	id: Scalars["ID"]["input"];
	input: CalendarEventUpdateInput;
}>;

export type CalendarEventUpdateMutation = {
	__typename?: "Mutation";
	updateCalendarEvent: {
		__typename?: "CalendarEvent";
		id: string;
		name: string;
		description: string;
		location: string;
		imageURL: string;
		imageKey: string;
		imageContentType: string;
		isAllDay: boolean;
		startTime: string | null;
		endTime: string | null;
		startDate: string | null;
		isMultiDay: boolean;
		endDate: string | null;
		allowsResponses: boolean;
		createdAt: string;
		author: {
			__typename?: "User";
			id: string;
			name: string;
			publicName: string;
			givenName: string;
			familyName: string;
			isCurrent: boolean;
			imageURL: string;
			imageKey: string;
			imageContentType: string;
		} | null;
		calendarEventResponses: Array<{
			__typename?: "CalendarEventResponse";
			id: string;
			response: CalendarEventResponseResponse;
			author: {
				__typename?: "User";
				id: string;
				name: string;
				publicName: string;
				givenName: string;
				familyName: string;
				isCurrent: boolean;
				imageURL: string;
				imageKey: string;
				imageContentType: string;
			} | null;
		}>;
		mediaAttachments: Array<{
			__typename?: "MediaAttachment";
			id: string;
			displayOrder: number;
			title: string;
			description: string;
			isFile: boolean;
			fileURL: string;
			fileKey: string;
			fileContentType: string;
			linkURL: string;
		}>;
		sharingPolicy: {
			__typename?: "SharingPolicy";
			id: string;
			isPublic: boolean;
			userGroups: Array<{ __typename?: "UserGroup"; id: string; name: string; color: string }>;
			users: Array<{
				__typename?: "User";
				id: string;
				name: string;
				publicName: string;
				givenName: string;
				familyName: string;
				isCurrent: boolean;
			}>;
		} | null;
	};
};

export type CalendarEventUserListQueryVariables = Exact<{
	calendarEventID: Scalars["ID"]["input"];
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<UserOrder>;
}>;

export type CalendarEventUserListQuery = {
	__typename?: "Query";
	userConnection: {
		__typename?: "UserConnection";
		totalCount: number;
		pageInfo: { __typename?: "PageInfo"; hasNextPage: boolean; endCursor: string | null };
		edges: Array<{
			__typename?: "UserEdge";
			node: {
				__typename?: "User";
				id: string;
				name: string;
				publicName: string;
				givenName: string;
				familyName: string;
				isCurrent: boolean;
				imageURL: string;
				imageKey: string;
				imageContentType: string;
				authoredCalendarEventResponses: Array<{
					__typename?: "CalendarEventResponse";
					id: string;
					response: CalendarEventResponseResponse;
				}>;
			};
		}>;
	};
};

export type CalendarEventResponseCountQueryVariables = Exact<{
	filters?: InputMaybe<Array<CalendarEventResponseFilterInput> | CalendarEventResponseFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<CalendarEventResponseOrder>;
}>;

export type CalendarEventResponseCountQuery = {
	__typename?: "Query";
	calendarEventResponseConnection: { __typename?: "CalendarEventResponseConnection"; totalCount: number };
};

export type CalendarEventResponseCreateMutationVariables = Exact<{
	input: CalendarEventResponseCreateInput;
}>;

export type CalendarEventResponseCreateMutation = {
	__typename?: "Mutation";
	createCalendarEventResponse: {
		__typename?: "CalendarEventResponse";
		id: string;
		response: CalendarEventResponseResponse;
		author: {
			__typename?: "User";
			id: string;
			name: string;
			publicName: string;
			givenName: string;
			familyName: string;
			isCurrent: boolean;
		} | null;
		calendarEvent: { __typename?: "CalendarEvent"; id: string; name: string };
	};
};

export type CalendarEventResponseDeleteMutationVariables = Exact<{
	id: Scalars["ID"]["input"];
}>;

export type CalendarEventResponseDeleteMutation = { __typename?: "Mutation"; deleteCalendarEventResponse: boolean };

export type CalendarEventResponseDetailFragment = {
	__typename?: "CalendarEventResponse";
	id: string;
	response: CalendarEventResponseResponse;
	author: {
		__typename?: "User";
		id: string;
		name: string;
		publicName: string;
		givenName: string;
		familyName: string;
		isCurrent: boolean;
	} | null;
	calendarEvent: { __typename?: "CalendarEvent"; id: string; name: string };
};

export type CalendarEventResponseDetailQueryVariables = Exact<{
	id: Scalars["ID"]["input"];
}>;

export type CalendarEventResponseDetailQuery = {
	__typename?: "Query";
	calendarEventResponse: {
		__typename?: "CalendarEventResponse";
		id: string;
		response: CalendarEventResponseResponse;
		author: {
			__typename?: "User";
			id: string;
			name: string;
			publicName: string;
			givenName: string;
			familyName: string;
			isCurrent: boolean;
		} | null;
		calendarEvent: { __typename?: "CalendarEvent"; id: string; name: string };
	};
};

export type CalendarEventResponseIndexQueryVariables = Exact<{
	filters?: InputMaybe<Array<CalendarEventResponseFilterInput> | CalendarEventResponseFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<CalendarEventResponseOrder>;
}>;

export type CalendarEventResponseIndexQuery = {
	__typename?: "Query";
	calendarEventResponseConnection: {
		__typename?: "CalendarEventResponseConnection";
		edges: Array<{
			__typename?: "CalendarEventResponseEdge";
			node: { __typename?: "CalendarEventResponse"; id: string; response: CalendarEventResponseResponse };
		}>;
	};
};

export type CalendarEventResponseNameFragment = { __typename?: "CalendarEventResponse"; id: string };

export type CalendarEventResponseNameQueryVariables = Exact<{
	id: Scalars["ID"]["input"];
}>;

export type CalendarEventResponseNameQuery = {
	__typename?: "Query";
	calendarEventResponse: { __typename?: "CalendarEventResponse"; id: string };
};

export type CalendarEventResponseNamesQueryVariables = Exact<{
	filters?: InputMaybe<Array<CalendarEventResponseFilterInput> | CalendarEventResponseFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<CalendarEventResponseOrder>;
}>;

export type CalendarEventResponseNamesQuery = {
	__typename?: "Query";
	calendarEventResponseConnection: {
		__typename?: "CalendarEventResponseConnection";
		edges: Array<{
			__typename?: "CalendarEventResponseEdge";
			node: { __typename?: "CalendarEventResponse"; id: string };
		}>;
	};
};

export type CalendarEventResponsePaginationQueryVariables = Exact<{
	filters?: InputMaybe<Array<CalendarEventResponseFilterInput> | CalendarEventResponseFilterInput>;
	order?: InputMaybe<CalendarEventResponseOrder>;
}>;

export type CalendarEventResponsePaginationQuery = {
	__typename?: "Query";
	calendarEventResponseConnection: {
		__typename?: "CalendarEventResponseConnection";
		totalCount: number;
		edges: Array<{ __typename?: "CalendarEventResponseEdge"; cursor: string }>;
	};
};

export type CalendarEventResponseSelectQueryVariables = Exact<{
	filters?: InputMaybe<Array<CalendarEventResponseFilterInput> | CalendarEventResponseFilterInput>;
	order?: InputMaybe<CalendarEventResponseOrder>;
}>;

export type CalendarEventResponseSelectQuery = {
	__typename?: "Query";
	calendarEventResponseConnection: {
		__typename?: "CalendarEventResponseConnection";
		edges: Array<{
			__typename?: "CalendarEventResponseEdge";
			node: { __typename?: "CalendarEventResponse"; id: string };
		}>;
	};
};

export type CalendarEventResponseUpdateMutationVariables = Exact<{
	id: Scalars["ID"]["input"];
	input: CalendarEventResponseUpdateInput;
}>;

export type CalendarEventResponseUpdateMutation = {
	__typename?: "Mutation";
	updateCalendarEventResponse: {
		__typename?: "CalendarEventResponse";
		id: string;
		response: CalendarEventResponseResponse;
		author: {
			__typename?: "User";
			id: string;
			name: string;
			publicName: string;
			givenName: string;
			familyName: string;
			isCurrent: boolean;
		} | null;
		calendarEvent: { __typename?: "CalendarEvent"; id: string; name: string };
	};
};

export type MediaAttachmentCountQueryVariables = Exact<{
	filters?: InputMaybe<Array<MediaAttachmentFilterInput> | MediaAttachmentFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<MediaAttachmentOrder>;
}>;

export type MediaAttachmentCountQuery = {
	__typename?: "Query";
	mediaAttachmentConnection: { __typename?: "MediaAttachmentConnection"; totalCount: number };
};

export type MediaAttachmentCreateMutationVariables = Exact<{
	input: MediaAttachmentCreateInput;
}>;

export type MediaAttachmentCreateMutation = {
	__typename?: "Mutation";
	createMediaAttachment: {
		__typename?: "MediaAttachment";
		id: string;
		displayOrder: number;
		title: string;
		description: string;
		isFile: boolean;
		fileURL: string;
		fileKey: string;
		fileContentType: string;
		linkURL: string;
		announcement: { __typename?: "Announcement"; id: string; title: string } | null;
		calendarEvent: { __typename?: "CalendarEvent"; id: string; name: string } | null;
		message: { __typename?: "Message"; id: string } | null;
		post: { __typename?: "Post"; id: string; title: string } | null;
	};
};

export type MediaAttachmentDeleteMutationVariables = Exact<{
	id: Scalars["ID"]["input"];
}>;

export type MediaAttachmentDeleteMutation = { __typename?: "Mutation"; deleteMediaAttachment: boolean };

export type MediaAttachmentDetailFragment = {
	__typename?: "MediaAttachment";
	id: string;
	displayOrder: number;
	title: string;
	description: string;
	isFile: boolean;
	fileURL: string;
	fileKey: string;
	fileContentType: string;
	linkURL: string;
	announcement: { __typename?: "Announcement"; id: string; title: string } | null;
	calendarEvent: { __typename?: "CalendarEvent"; id: string; name: string } | null;
	message: { __typename?: "Message"; id: string } | null;
	post: { __typename?: "Post"; id: string; title: string } | null;
};

export type MediaAttachmentDetailQueryVariables = Exact<{
	id: Scalars["ID"]["input"];
}>;

export type MediaAttachmentDetailQuery = {
	__typename?: "Query";
	mediaAttachment: {
		__typename?: "MediaAttachment";
		id: string;
		displayOrder: number;
		title: string;
		description: string;
		isFile: boolean;
		fileURL: string;
		fileKey: string;
		fileContentType: string;
		linkURL: string;
		announcement: { __typename?: "Announcement"; id: string; title: string } | null;
		calendarEvent: { __typename?: "CalendarEvent"; id: string; name: string } | null;
		message: { __typename?: "Message"; id: string } | null;
		post: { __typename?: "Post"; id: string; title: string } | null;
	};
};

export type MediaAttachmentIndexQueryVariables = Exact<{
	filters?: InputMaybe<Array<MediaAttachmentFilterInput> | MediaAttachmentFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<MediaAttachmentOrder>;
}>;

export type MediaAttachmentIndexQuery = {
	__typename?: "Query";
	mediaAttachmentConnection: {
		__typename?: "MediaAttachmentConnection";
		edges: Array<{
			__typename?: "MediaAttachmentEdge";
			node: {
				__typename?: "MediaAttachment";
				id: string;
				displayOrder: number;
				title: string;
				description: string;
				isFile: boolean;
				fileURL: string;
				fileContentType: string;
				linkURL: string;
			};
		}>;
	};
};

export type MediaAttachmentNameFragment = { __typename?: "MediaAttachment"; title: string };

export type MediaAttachmentNameQueryVariables = Exact<{
	id: Scalars["ID"]["input"];
}>;

export type MediaAttachmentNameQuery = {
	__typename?: "Query";
	mediaAttachment: { __typename?: "MediaAttachment"; id: string; title: string };
};

export type MediaAttachmentNamesQueryVariables = Exact<{
	filters?: InputMaybe<Array<MediaAttachmentFilterInput> | MediaAttachmentFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<MediaAttachmentOrder>;
}>;

export type MediaAttachmentNamesQuery = {
	__typename?: "Query";
	mediaAttachmentConnection: {
		__typename?: "MediaAttachmentConnection";
		edges: Array<{
			__typename?: "MediaAttachmentEdge";
			node: { __typename?: "MediaAttachment"; id: string; title: string };
		}>;
	};
};

export type MediaAttachmentPaginationQueryVariables = Exact<{
	filters?: InputMaybe<Array<MediaAttachmentFilterInput> | MediaAttachmentFilterInput>;
	order?: InputMaybe<MediaAttachmentOrder>;
}>;

export type MediaAttachmentPaginationQuery = {
	__typename?: "Query";
	mediaAttachmentConnection: {
		__typename?: "MediaAttachmentConnection";
		totalCount: number;
		edges: Array<{ __typename?: "MediaAttachmentEdge"; cursor: string }>;
	};
};

export type MediaAttachmentSelectQueryVariables = Exact<{
	filters?: InputMaybe<Array<MediaAttachmentFilterInput> | MediaAttachmentFilterInput>;
	order?: InputMaybe<MediaAttachmentOrder>;
}>;

export type MediaAttachmentSelectQuery = {
	__typename?: "Query";
	mediaAttachmentConnection: {
		__typename?: "MediaAttachmentConnection";
		edges: Array<{
			__typename?: "MediaAttachmentEdge";
			node: { __typename?: "MediaAttachment"; id: string; title: string };
		}>;
	};
};

export type MediaAttachmentSocialItemsQueryVariables = Exact<{
	id: Scalars["ID"]["input"];
}>;

export type MediaAttachmentSocialItemsQuery = {
	__typename?: "Query";
	mediaAttachment: {
		__typename?: "MediaAttachment";
		id: string;
		socialReactions: Array<{
			__typename?: "SocialReaction";
			id: string;
			reaction: SocialReactionReaction;
			author: {
				__typename?: "User";
				id: string;
				isCurrent: boolean;
				name: string;
				publicName: string;
				givenName: string;
				familyName: string;
			};
		}>;
		socialComments: Array<{
			__typename?: "SocialComment";
			id: string;
			body: string;
			createdAt: string;
			author: {
				__typename?: "User";
				id: string;
				isCurrent: boolean;
				name: string;
				publicName: string;
				givenName: string;
				familyName: string;
				imageURL: string;
				imageKey: string;
				imageContentType: string;
			};
		}>;
	};
};

export type MediaAttachmentUpdateMutationVariables = Exact<{
	id: Scalars["ID"]["input"];
	input: MediaAttachmentUpdateInput;
}>;

export type MediaAttachmentUpdateMutation = {
	__typename?: "Mutation";
	updateMediaAttachment: {
		__typename?: "MediaAttachment";
		id: string;
		displayOrder: number;
		title: string;
		description: string;
		isFile: boolean;
		fileURL: string;
		fileKey: string;
		fileContentType: string;
		linkURL: string;
		announcement: { __typename?: "Announcement"; id: string; title: string } | null;
		calendarEvent: { __typename?: "CalendarEvent"; id: string; name: string } | null;
		message: { __typename?: "Message"; id: string } | null;
		post: { __typename?: "Post"; id: string; title: string } | null;
	};
};

export type MediaAttachmentVisualCatalogListQueryVariables = Exact<{
	filters?: InputMaybe<Array<MediaAttachmentFilterInput> | MediaAttachmentFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<MediaAttachmentOrder>;
}>;

export type MediaAttachmentVisualCatalogListQuery = {
	__typename?: "Query";
	mediaAttachmentConnection: {
		__typename?: "MediaAttachmentConnection";
		pageInfo: { __typename?: "PageInfo"; endCursor: string | null; hasNextPage: boolean };
		edges: Array<{
			__typename?: "MediaAttachmentEdge";
			node: {
				__typename?: "MediaAttachment";
				id: string;
				title: string;
				description: string;
				fileURL: string;
				fileKey: string;
				fileContentType: string;
				postID: string | null;
			};
		}>;
	};
};

export type MessageCountQueryVariables = Exact<{
	filters?: InputMaybe<Array<MessageFilterInput> | MessageFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<MessageOrder>;
}>;

export type MessageCountQuery = {
	__typename?: "Query";
	messageConnection: { __typename?: "MessageConnection"; totalCount: number };
};

export type MessageCreateMutationVariables = Exact<{
	input: MessageCreateInput;
}>;

export type MessageCreateMutation = {
	__typename?: "Mutation";
	createMessage: {
		__typename?: "Message";
		id: string;
		createdAt: string;
		body: string;
		lastEditedAt: string | null;
		isRemoved: boolean;
		author: {
			__typename?: "User";
			id: string;
			name: string;
			publicName: string;
			givenName: string;
			familyName: string;
			isCurrent: boolean;
		};
		messageGroup: {
			__typename?: "MessageGroup";
			id: string;
			customName: string;
			users: Array<{
				__typename?: "User";
				id: string;
				name: string;
				publicName: string;
				givenName: string;
				familyName: string;
				isCurrent: boolean;
			}>;
			userGroups: Array<{ __typename?: "UserGroup"; id: string; name: string }>;
		};
	};
};

export type MessageDeleteMutationVariables = Exact<{
	id: Scalars["ID"]["input"];
}>;

export type MessageDeleteMutation = { __typename?: "Mutation"; deleteMessage: boolean };

export type MessageDetailFragment = {
	__typename?: "Message";
	id: string;
	createdAt: string;
	body: string;
	lastEditedAt: string | null;
	isRemoved: boolean;
	author: {
		__typename?: "User";
		id: string;
		name: string;
		publicName: string;
		givenName: string;
		familyName: string;
		isCurrent: boolean;
	};
	messageGroup: {
		__typename?: "MessageGroup";
		id: string;
		customName: string;
		users: Array<{
			__typename?: "User";
			id: string;
			name: string;
			publicName: string;
			givenName: string;
			familyName: string;
			isCurrent: boolean;
		}>;
		userGroups: Array<{ __typename?: "UserGroup"; id: string; name: string }>;
	};
};

export type MessageDetailQueryVariables = Exact<{
	id: Scalars["ID"]["input"];
}>;

export type MessageDetailQuery = {
	__typename?: "Query";
	message: {
		__typename?: "Message";
		id: string;
		createdAt: string;
		body: string;
		lastEditedAt: string | null;
		isRemoved: boolean;
		author: {
			__typename?: "User";
			id: string;
			name: string;
			publicName: string;
			givenName: string;
			familyName: string;
			isCurrent: boolean;
		};
		messageGroup: {
			__typename?: "MessageGroup";
			id: string;
			customName: string;
			users: Array<{
				__typename?: "User";
				id: string;
				name: string;
				publicName: string;
				givenName: string;
				familyName: string;
				isCurrent: boolean;
			}>;
			userGroups: Array<{ __typename?: "UserGroup"; id: string; name: string }>;
		};
	};
};

export type MessageDetailForEditQueryVariables = Exact<{
	id: Scalars["ID"]["input"];
}>;

export type MessageDetailForEditQuery = {
	__typename?: "Query";
	message: {
		__typename?: "Message";
		id: string;
		body: string;
		mediaAttachments: Array<{
			__typename?: "MediaAttachment";
			id: string;
			displayOrder: number;
			title: string;
			description: string;
			isFile: boolean;
			fileURL: string;
			fileKey: string;
			fileContentType: string;
			linkURL: string;
		}>;
	};
};

export type MessageInMessageGroupFragment = {
	__typename?: "Message";
	id: string;
	createdAt: string;
	body: string;
	lastEditedAt: string | null;
	isRemoved: boolean;
	author: {
		__typename?: "User";
		id: string;
		name: string;
		publicName: string;
		givenName: string;
		familyName: string;
		isCurrent: boolean;
		imageURL: string;
		imageKey: string;
		imageContentType: string;
	};
	mediaAttachments: Array<{
		__typename?: "MediaAttachment";
		id: string;
		title: string;
		description: string;
		isFile: boolean;
		fileURL: string;
		fileKey: string;
		fileContentType: string;
		linkURL: string;
	}>;
	messageTopic: { __typename?: "MessageTopic"; id: string } | null;
};

export type MessageGroupMessagesListQueryVariables = Exact<{
	filters?: InputMaybe<Array<MessageFilterInput> | MessageFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<MessageOrder>;
}>;

export type MessageGroupMessagesListQuery = {
	__typename?: "Query";
	messageConnection: {
		__typename?: "MessageConnection";
		pageInfo: {
			__typename?: "PageInfo";
			startCursor: string | null;
			endCursor: string | null;
			hasNextPage: boolean;
			hasPreviousPage: boolean;
		};
		edges: Array<{
			__typename?: "MessageEdge";
			node: {
				__typename?: "Message";
				id: string;
				createdAt: string;
				body: string;
				lastEditedAt: string | null;
				isRemoved: boolean;
				author: {
					__typename?: "User";
					id: string;
					name: string;
					publicName: string;
					givenName: string;
					familyName: string;
					isCurrent: boolean;
					imageURL: string;
					imageKey: string;
					imageContentType: string;
				};
				mediaAttachments: Array<{
					__typename?: "MediaAttachment";
					id: string;
					title: string;
					description: string;
					isFile: boolean;
					fileURL: string;
					fileKey: string;
					fileContentType: string;
					linkURL: string;
				}>;
				messageTopic: { __typename?: "MessageTopic"; id: string } | null;
			};
		}>;
	};
};

export type MessageGroupLatestTopicQueryVariables = Exact<{
	messageGroupID: Scalars["ID"]["input"];
}>;

export type MessageGroupLatestTopicQuery = {
	__typename?: "Query";
	messageConnection: {
		__typename?: "MessageConnection";
		edges: Array<{
			__typename?: "MessageEdge";
			node: {
				__typename?: "Message";
				id: string;
				createdAt: string;
				body: string;
				lastEditedAt: string | null;
				isRemoved: boolean;
				author: {
					__typename?: "User";
					id: string;
					name: string;
					publicName: string;
					givenName: string;
					familyName: string;
					isCurrent: boolean;
					imageURL: string;
					imageKey: string;
					imageContentType: string;
				};
				mediaAttachments: Array<{
					__typename?: "MediaAttachment";
					id: string;
					title: string;
					description: string;
					isFile: boolean;
					fileURL: string;
					fileKey: string;
					fileContentType: string;
					linkURL: string;
				}>;
				messageTopic: { __typename?: "MessageTopic"; id: string } | null;
			};
		}>;
	};
};

export type MessageIndexQueryVariables = Exact<{
	filters?: InputMaybe<Array<MessageFilterInput> | MessageFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<MessageOrder>;
}>;

export type MessageIndexQuery = {
	__typename?: "Query";
	messageConnection: {
		__typename?: "MessageConnection";
		edges: Array<{
			__typename?: "MessageEdge";
			node: {
				__typename?: "Message";
				id: string;
				createdAt: string;
				body: string;
				lastEditedAt: string | null;
				isRemoved: boolean;
			};
		}>;
	};
};

export type LatestMessagesAndMessageGroupsListQueryVariables = Exact<{
	filters?: InputMaybe<Array<MessageFilterInput> | MessageFilterInput>;
	archived?: InputMaybe<Scalars["Boolean"]["input"]>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<MessageOrder>;
}>;

export type LatestMessagesAndMessageGroupsListQuery = {
	__typename?: "Query";
	latestMessageByGroupConnection: {
		__typename?: "MessageConnection";
		edges: Array<{
			__typename?: "MessageEdge";
			node: {
				__typename?: "Message";
				id: string;
				createdAt: string;
				body: string;
				isRemoved: boolean;
				messageGroup: {
					__typename?: "MessageGroup";
					id: string;
					customName: string;
					users: Array<{
						__typename?: "User";
						id: string;
						name: string;
						publicName: string;
						givenName: string;
						familyName: string;
						isCurrent: boolean;
						imageURL: string;
						imageKey: string;
						imageContentType: string;
					}>;
					userGroups: Array<{ __typename?: "UserGroup"; id: string; name: string; color: string }>;
				};
				mediaAttachments: Array<{ __typename?: "MediaAttachment"; id: string }>;
			};
		}>;
	};
};

export type MessageNameFragment = { __typename?: "Message"; id: string };

export type MessageNameQueryVariables = Exact<{
	id: Scalars["ID"]["input"];
}>;

export type MessageNameQuery = { __typename?: "Query"; message: { __typename?: "Message"; id: string } };

export type MessageNamesQueryVariables = Exact<{
	filters?: InputMaybe<Array<MessageFilterInput> | MessageFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<MessageOrder>;
}>;

export type MessageNamesQuery = {
	__typename?: "Query";
	messageConnection: {
		__typename?: "MessageConnection";
		edges: Array<{ __typename?: "MessageEdge"; node: { __typename?: "Message"; id: string } }>;
	};
};

export type UnreadMessagesCountQueryVariables = Exact<{ [key: string]: never }>;

export type UnreadMessagesCountQuery = { __typename?: "Query"; unreadMessagesCount: number };

export type MessagePaginationQueryVariables = Exact<{
	filters?: InputMaybe<Array<MessageFilterInput> | MessageFilterInput>;
	order?: InputMaybe<MessageOrder>;
}>;

export type MessagePaginationQuery = {
	__typename?: "Query";
	messageConnection: {
		__typename?: "MessageConnection";
		totalCount: number;
		edges: Array<{ __typename?: "MessageEdge"; cursor: string }>;
	};
};

export type MessageSelectQueryVariables = Exact<{
	filters?: InputMaybe<Array<MessageFilterInput> | MessageFilterInput>;
	order?: InputMaybe<MessageOrder>;
}>;

export type MessageSelectQuery = {
	__typename?: "Query";
	messageConnection: {
		__typename?: "MessageConnection";
		edges: Array<{ __typename?: "MessageEdge"; node: { __typename?: "Message"; id: string } }>;
	};
};

export type MessageUpdateMutationVariables = Exact<{
	id: Scalars["ID"]["input"];
	input: MessageUpdateInput;
}>;

export type MessageUpdateMutation = {
	__typename?: "Mutation";
	updateMessage: {
		__typename?: "Message";
		id: string;
		createdAt: string;
		body: string;
		lastEditedAt: string | null;
		isRemoved: boolean;
		author: {
			__typename?: "User";
			id: string;
			name: string;
			publicName: string;
			givenName: string;
			familyName: string;
			isCurrent: boolean;
		};
		messageGroup: {
			__typename?: "MessageGroup";
			id: string;
			customName: string;
			users: Array<{
				__typename?: "User";
				id: string;
				name: string;
				publicName: string;
				givenName: string;
				familyName: string;
				isCurrent: boolean;
			}>;
			userGroups: Array<{ __typename?: "UserGroup"; id: string; name: string }>;
		};
	};
};

export type MessageGroupCountQueryVariables = Exact<{
	filters?: InputMaybe<Array<MessageGroupFilterInput> | MessageGroupFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<MessageGroupOrder>;
}>;

export type MessageGroupCountQuery = {
	__typename?: "Query";
	messageGroupConnection: { __typename?: "MessageGroupConnection"; totalCount: number };
};

export type MessageGroupCreateOrUpdateMutationVariables = Exact<{
	input: MessageGroupCreateInput;
}>;

export type MessageGroupCreateOrUpdateMutation = {
	__typename?: "Mutation";
	createOrUpdateMessageGroup: {
		__typename?: "MessageGroup";
		id: string;
		customName: string;
		isOneOnOne: boolean;
		userGroups: Array<{ __typename?: "UserGroup"; id: string; name: string; color: string }>;
		users: Array<{
			__typename?: "User";
			id: string;
			name: string;
			publicName: string;
			givenName: string;
			familyName: string;
			organizationName: string;
			isCurrent: boolean;
			imageURL: string;
			imageKey: string;
			imageContentType: string;
		}>;
	};
};

export type MessageGroupCreateMutationVariables = Exact<{
	input: MessageGroupCreateInput;
}>;

export type MessageGroupCreateMutation = {
	__typename?: "Mutation";
	createMessageGroup: {
		__typename?: "MessageGroup";
		id: string;
		customName: string;
		isOneOnOne: boolean;
		userGroups: Array<{ __typename?: "UserGroup"; id: string; name: string; color: string }>;
		users: Array<{
			__typename?: "User";
			id: string;
			name: string;
			publicName: string;
			givenName: string;
			familyName: string;
			organizationName: string;
			isCurrent: boolean;
			imageURL: string;
			imageKey: string;
			imageContentType: string;
		}>;
	};
};

export type MessageGroupDeleteMutationVariables = Exact<{
	id: Scalars["ID"]["input"];
}>;

export type MessageGroupDeleteMutation = { __typename?: "Mutation"; deleteMessageGroup: boolean };

export type MessageGroupDetailFragment = {
	__typename?: "MessageGroup";
	id: string;
	customName: string;
	isOneOnOne: boolean;
	userGroups: Array<{ __typename?: "UserGroup"; id: string; name: string; color: string }>;
	users: Array<{
		__typename?: "User";
		id: string;
		name: string;
		publicName: string;
		givenName: string;
		familyName: string;
		organizationName: string;
		isCurrent: boolean;
		imageURL: string;
		imageKey: string;
		imageContentType: string;
	}>;
};

export type MessageGroupDetailQueryVariables = Exact<{
	id: Scalars["ID"]["input"];
}>;

export type MessageGroupDetailQuery = {
	__typename?: "Query";
	messageGroup: {
		__typename?: "MessageGroup";
		id: string;
		customName: string;
		isOneOnOne: boolean;
		userGroups: Array<{ __typename?: "UserGroup"; id: string; name: string; color: string }>;
		users: Array<{
			__typename?: "User";
			id: string;
			name: string;
			publicName: string;
			givenName: string;
			familyName: string;
			organizationName: string;
			isCurrent: boolean;
			imageURL: string;
			imageKey: string;
			imageContentType: string;
		}>;
	};
};

export type MessageGroupIndexQueryVariables = Exact<{
	filters?: InputMaybe<Array<MessageGroupFilterInput> | MessageGroupFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<MessageGroupOrder>;
}>;

export type MessageGroupIndexQuery = {
	__typename?: "Query";
	messageGroupConnection: {
		__typename?: "MessageGroupConnection";
		edges: Array<{
			__typename?: "MessageGroupEdge";
			node: { __typename?: "MessageGroup"; id: string; customName: string; isOneOnOne: boolean };
		}>;
	};
};

export type MessageGroupNameFragment = {
	__typename?: "MessageGroup";
	customName: string;
	users: Array<{
		__typename?: "User";
		id: string;
		name: string;
		publicName: string;
		givenName: string;
		familyName: string;
		isCurrent: boolean;
	}>;
	userGroups: Array<{ __typename?: "UserGroup"; id: string; name: string }>;
};

export type MessageGroupNameAndImageFragment = {
	__typename?: "MessageGroup";
	customName: string;
	users: Array<{
		__typename?: "User";
		id: string;
		name: string;
		publicName: string;
		givenName: string;
		familyName: string;
		isCurrent: boolean;
		imageURL: string;
		imageKey: string;
		imageContentType: string;
	}>;
	userGroups: Array<{ __typename?: "UserGroup"; id: string; name: string; color: string }>;
};

export type MessageGroupNameQueryVariables = Exact<{
	id: Scalars["ID"]["input"];
}>;

export type MessageGroupNameQuery = {
	__typename?: "Query";
	messageGroup: {
		__typename?: "MessageGroup";
		id: string;
		customName: string;
		users: Array<{
			__typename?: "User";
			id: string;
			name: string;
			publicName: string;
			givenName: string;
			familyName: string;
			isCurrent: boolean;
		}>;
		userGroups: Array<{ __typename?: "UserGroup"; id: string; name: string }>;
	};
};

export type MessageGroupNamesQueryVariables = Exact<{
	filters?: InputMaybe<Array<MessageGroupFilterInput> | MessageGroupFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<MessageGroupOrder>;
}>;

export type MessageGroupNamesQuery = {
	__typename?: "Query";
	messageGroupConnection: {
		__typename?: "MessageGroupConnection";
		edges: Array<{
			__typename?: "MessageGroupEdge";
			node: {
				__typename?: "MessageGroup";
				id: string;
				customName: string;
				users: Array<{
					__typename?: "User";
					id: string;
					name: string;
					publicName: string;
					givenName: string;
					familyName: string;
					isCurrent: boolean;
				}>;
				userGroups: Array<{ __typename?: "UserGroup"; id: string; name: string }>;
			};
		}>;
	};
};

export type MessageGroupPaginationQueryVariables = Exact<{
	filters?: InputMaybe<Array<MessageGroupFilterInput> | MessageGroupFilterInput>;
	order?: InputMaybe<MessageGroupOrder>;
}>;

export type MessageGroupPaginationQuery = {
	__typename?: "Query";
	messageGroupConnection: {
		__typename?: "MessageGroupConnection";
		totalCount: number;
		edges: Array<{ __typename?: "MessageGroupEdge"; cursor: string }>;
	};
};

export type MessageGroupUserFragment = {
	__typename?: "User";
	id: string;
	name: string;
	publicName: string;
	givenName: string;
	familyName: string;
	organizationName: string;
	isCurrent: boolean;
	imageURL: string;
	imageKey: string;
	imageContentType: string;
};

export type MessageGroupUserGroupParticipantUserListQueryVariables = Exact<{
	messageGroupID: Scalars["ID"]["input"];
}>;

export type MessageGroupUserGroupParticipantUserListQuery = {
	__typename?: "Query";
	userConnection: {
		__typename?: "UserConnection";
		edges: Array<{
			__typename?: "UserEdge";
			node: {
				__typename?: "User";
				id: string;
				name: string;
				publicName: string;
				givenName: string;
				familyName: string;
				organizationName: string;
				isCurrent: boolean;
				imageURL: string;
				imageKey: string;
				imageContentType: string;
			};
		}>;
	};
};

export type UserForMessagesFragment = {
	__typename?: "User";
	id: string;
	name: string;
	publicName: string;
	givenName: string;
	familyName: string;
	organizationName: string;
	isCurrent: boolean;
	imageURL: string;
	imageKey: string;
	imageContentType: string;
};

export type UserListForMessagesQueryVariables = Exact<{
	filters?: InputMaybe<Array<UserFilterInput> | UserFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<UserOrder>;
}>;

export type UserListForMessagesQuery = {
	__typename?: "Query";
	userConnection: {
		__typename?: "UserConnection";
		edges: Array<{
			__typename?: "UserEdge";
			node: {
				__typename?: "User";
				id: string;
				name: string;
				publicName: string;
				givenName: string;
				familyName: string;
				organizationName: string;
				isCurrent: boolean;
				imageURL: string;
				imageKey: string;
				imageContentType: string;
			};
		}>;
	};
};

export type UserAndUserGroupListForMessagesQueryVariables = Exact<{
	userFilters?: InputMaybe<Array<UserFilterInput> | UserFilterInput>;
	userGroupFilters?: InputMaybe<Array<UserGroupFilterInput> | UserGroupFilterInput>;
}>;

export type UserAndUserGroupListForMessagesQuery = {
	__typename?: "Query";
	userConnection: {
		__typename?: "UserConnection";
		edges: Array<{
			__typename?: "UserEdge";
			node: {
				__typename?: "User";
				id: string;
				name: string;
				publicName: string;
				givenName: string;
				familyName: string;
				organizationName: string;
				isCurrent: boolean;
				imageURL: string;
				imageKey: string;
				imageContentType: string;
			};
		}>;
	};
	userGroupConnection: {
		__typename?: "UserGroupConnection";
		edges: Array<{
			__typename?: "UserGroupEdge";
			node: {
				__typename?: "UserGroup";
				id: string;
				name: string;
				color: string;
				members: Array<{ __typename?: "User"; id: string; isCurrent: boolean }>;
			};
		}>;
	};
};

export type MessageGroupSelectQueryVariables = Exact<{
	filters?: InputMaybe<Array<MessageGroupFilterInput> | MessageGroupFilterInput>;
	order?: InputMaybe<MessageGroupOrder>;
}>;

export type MessageGroupSelectQuery = {
	__typename?: "Query";
	messageGroupConnection: {
		__typename?: "MessageGroupConnection";
		edges: Array<{
			__typename?: "MessageGroupEdge";
			node: {
				__typename?: "MessageGroup";
				id: string;
				customName: string;
				users: Array<{
					__typename?: "User";
					id: string;
					name: string;
					publicName: string;
					givenName: string;
					familyName: string;
					isCurrent: boolean;
				}>;
				userGroups: Array<{ __typename?: "UserGroup"; id: string; name: string }>;
			};
		}>;
	};
};

export type MessageGroupUpdateMutationVariables = Exact<{
	id: Scalars["ID"]["input"];
	input: MessageGroupUpdateInput;
}>;

export type MessageGroupUpdateMutation = {
	__typename?: "Mutation";
	updateMessageGroup: {
		__typename?: "MessageGroup";
		id: string;
		customName: string;
		isOneOnOne: boolean;
		userGroups: Array<{ __typename?: "UserGroup"; id: string; name: string; color: string }>;
		users: Array<{
			__typename?: "User";
			id: string;
			name: string;
			publicName: string;
			givenName: string;
			familyName: string;
			organizationName: string;
			isCurrent: boolean;
			imageURL: string;
			imageKey: string;
			imageContentType: string;
		}>;
	};
};

export type MessageGroupArchivePointCountQueryVariables = Exact<{
	filters?: InputMaybe<Array<MessageGroupArchivePointFilterInput> | MessageGroupArchivePointFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<MessageGroupArchivePointOrder>;
}>;

export type MessageGroupArchivePointCountQuery = {
	__typename?: "Query";
	messageGroupArchivePointConnection: { __typename?: "MessageGroupArchivePointConnection"; totalCount: number };
};

export type MessageGroupArchivePointCreateMutationVariables = Exact<{
	input: MessageGroupArchivePointCreateInput;
}>;

export type MessageGroupArchivePointCreateMutation = {
	__typename?: "Mutation";
	createMessageGroupArchivePoint: {
		__typename?: "MessageGroupArchivePoint";
		id: string;
		createdAt: string;
		author: {
			__typename?: "User";
			id: string;
			name: string;
			publicName: string;
			givenName: string;
			familyName: string;
			isCurrent: boolean;
		};
		messageGroup: {
			__typename?: "MessageGroup";
			id: string;
			customName: string;
			users: Array<{
				__typename?: "User";
				id: string;
				name: string;
				publicName: string;
				givenName: string;
				familyName: string;
				isCurrent: boolean;
			}>;
			userGroups: Array<{ __typename?: "UserGroup"; id: string; name: string }>;
		};
	};
};

export type MessageGroupArchivePointDeleteMutationVariables = Exact<{
	id: Scalars["ID"]["input"];
}>;

export type MessageGroupArchivePointDeleteMutation = {
	__typename?: "Mutation";
	deleteMessageGroupArchivePoint: boolean;
};

export type MessageGroupArchivePointDetailFragment = {
	__typename?: "MessageGroupArchivePoint";
	id: string;
	createdAt: string;
	author: {
		__typename?: "User";
		id: string;
		name: string;
		publicName: string;
		givenName: string;
		familyName: string;
		isCurrent: boolean;
	};
	messageGroup: {
		__typename?: "MessageGroup";
		id: string;
		customName: string;
		users: Array<{
			__typename?: "User";
			id: string;
			name: string;
			publicName: string;
			givenName: string;
			familyName: string;
			isCurrent: boolean;
		}>;
		userGroups: Array<{ __typename?: "UserGroup"; id: string; name: string }>;
	};
};

export type MessageGroupArchivePointDetailQueryVariables = Exact<{
	id: Scalars["ID"]["input"];
}>;

export type MessageGroupArchivePointDetailQuery = {
	__typename?: "Query";
	messageGroupArchivePoint: {
		__typename?: "MessageGroupArchivePoint";
		id: string;
		createdAt: string;
		author: {
			__typename?: "User";
			id: string;
			name: string;
			publicName: string;
			givenName: string;
			familyName: string;
			isCurrent: boolean;
		};
		messageGroup: {
			__typename?: "MessageGroup";
			id: string;
			customName: string;
			users: Array<{
				__typename?: "User";
				id: string;
				name: string;
				publicName: string;
				givenName: string;
				familyName: string;
				isCurrent: boolean;
			}>;
			userGroups: Array<{ __typename?: "UserGroup"; id: string; name: string }>;
		};
	};
};

export type MessageGroupArchivePointIndexQueryVariables = Exact<{
	filters?: InputMaybe<Array<MessageGroupArchivePointFilterInput> | MessageGroupArchivePointFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<MessageGroupArchivePointOrder>;
}>;

export type MessageGroupArchivePointIndexQuery = {
	__typename?: "Query";
	messageGroupArchivePointConnection: {
		__typename?: "MessageGroupArchivePointConnection";
		edges: Array<{
			__typename?: "MessageGroupArchivePointEdge";
			node: { __typename?: "MessageGroupArchivePoint"; id: string; createdAt: string };
		}>;
	};
};

export type MessageGroupArchivePointListInMessageGroupQueryVariables = Exact<{
	filters?: InputMaybe<Array<MessageGroupArchivePointFilterInput> | MessageGroupArchivePointFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<MessageGroupArchivePointOrder>;
}>;

export type MessageGroupArchivePointListInMessageGroupQuery = {
	__typename?: "Query";
	messageGroupArchivePointConnection: {
		__typename?: "MessageGroupArchivePointConnection";
		edges: Array<{
			__typename?: "MessageGroupArchivePointEdge";
			node: {
				__typename?: "MessageGroupArchivePoint";
				id: string;
				createdAt: string;
				author: {
					__typename?: "User";
					id: string;
					name: string;
					publicName: string;
					givenName: string;
					familyName: string;
					isCurrent: boolean;
					imageURL: string;
					imageKey: string;
					imageContentType: string;
				};
			};
		}>;
	};
};

export type MessageGroupArchivePointNameFragment = { __typename?: "MessageGroupArchivePoint"; id: string };

export type MessageGroupArchivePointNameQueryVariables = Exact<{
	id: Scalars["ID"]["input"];
}>;

export type MessageGroupArchivePointNameQuery = {
	__typename?: "Query";
	messageGroupArchivePoint: { __typename?: "MessageGroupArchivePoint"; id: string };
};

export type MessageGroupArchivePointNamesQueryVariables = Exact<{
	filters?: InputMaybe<Array<MessageGroupArchivePointFilterInput> | MessageGroupArchivePointFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<MessageGroupArchivePointOrder>;
}>;

export type MessageGroupArchivePointNamesQuery = {
	__typename?: "Query";
	messageGroupArchivePointConnection: {
		__typename?: "MessageGroupArchivePointConnection";
		edges: Array<{
			__typename?: "MessageGroupArchivePointEdge";
			node: { __typename?: "MessageGroupArchivePoint"; id: string };
		}>;
	};
};

export type MessageGroupArchivePointPaginationQueryVariables = Exact<{
	filters?: InputMaybe<Array<MessageGroupArchivePointFilterInput> | MessageGroupArchivePointFilterInput>;
	order?: InputMaybe<MessageGroupArchivePointOrder>;
}>;

export type MessageGroupArchivePointPaginationQuery = {
	__typename?: "Query";
	messageGroupArchivePointConnection: {
		__typename?: "MessageGroupArchivePointConnection";
		totalCount: number;
		edges: Array<{ __typename?: "MessageGroupArchivePointEdge"; cursor: string }>;
	};
};

export type MessageGroupArchivePointSelectQueryVariables = Exact<{
	filters?: InputMaybe<Array<MessageGroupArchivePointFilterInput> | MessageGroupArchivePointFilterInput>;
	order?: InputMaybe<MessageGroupArchivePointOrder>;
}>;

export type MessageGroupArchivePointSelectQuery = {
	__typename?: "Query";
	messageGroupArchivePointConnection: {
		__typename?: "MessageGroupArchivePointConnection";
		edges: Array<{
			__typename?: "MessageGroupArchivePointEdge";
			node: { __typename?: "MessageGroupArchivePoint"; id: string };
		}>;
	};
};

export type MessageGroupArchivePointUpdateMutationVariables = Exact<{
	id: Scalars["ID"]["input"];
	input: MessageGroupArchivePointUpdateInput;
}>;

export type MessageGroupArchivePointUpdateMutation = {
	__typename?: "Mutation";
	updateMessageGroupArchivePoint: {
		__typename?: "MessageGroupArchivePoint";
		id: string;
		createdAt: string;
		author: {
			__typename?: "User";
			id: string;
			name: string;
			publicName: string;
			givenName: string;
			familyName: string;
			isCurrent: boolean;
		};
		messageGroup: {
			__typename?: "MessageGroup";
			id: string;
			customName: string;
			users: Array<{
				__typename?: "User";
				id: string;
				name: string;
				publicName: string;
				givenName: string;
				familyName: string;
				isCurrent: boolean;
			}>;
			userGroups: Array<{ __typename?: "UserGroup"; id: string; name: string }>;
		};
	};
};

export type MessageTopicCountQueryVariables = Exact<{
	filters?: InputMaybe<Array<MessageTopicFilterInput> | MessageTopicFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<MessageTopicOrder>;
}>;

export type MessageTopicCountQuery = {
	__typename?: "Query";
	messageTopicConnection: { __typename?: "MessageTopicConnection"; totalCount: number };
};

export type MessageTopicCreateMutationVariables = Exact<{
	input: MessageTopicCreateInput;
}>;

export type MessageTopicCreateMutation = {
	__typename?: "Mutation";
	createMessageTopic: {
		__typename?: "MessageTopic";
		id: string;
		name: string;
		message: { __typename?: "Message"; id: string };
	};
};

export type MessageTopicDeleteMutationVariables = Exact<{
	id: Scalars["ID"]["input"];
}>;

export type MessageTopicDeleteMutation = { __typename?: "Mutation"; deleteMessageTopic: boolean };

export type MessageTopicDetailFragment = {
	__typename?: "MessageTopic";
	id: string;
	name: string;
	message: { __typename?: "Message"; id: string };
};

export type MessageTopicDetailQueryVariables = Exact<{
	id: Scalars["ID"]["input"];
}>;

export type MessageTopicDetailQuery = {
	__typename?: "Query";
	messageTopic: {
		__typename?: "MessageTopic";
		id: string;
		name: string;
		message: { __typename?: "Message"; id: string };
	};
};

export type MessageTopicIndexQueryVariables = Exact<{
	filters?: InputMaybe<Array<MessageTopicFilterInput> | MessageTopicFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<MessageTopicOrder>;
}>;

export type MessageTopicIndexQuery = {
	__typename?: "Query";
	messageTopicConnection: {
		__typename?: "MessageTopicConnection";
		edges: Array<{ __typename?: "MessageTopicEdge"; node: { __typename?: "MessageTopic"; id: string; name: string } }>;
	};
};

export type MessageTopicNameFragment = { __typename?: "MessageTopic"; name: string };

export type MessageTopicNameQueryVariables = Exact<{
	id: Scalars["ID"]["input"];
}>;

export type MessageTopicNameQuery = {
	__typename?: "Query";
	messageTopic: { __typename?: "MessageTopic"; id: string; name: string };
};

export type MessageTopicNamesQueryVariables = Exact<{
	filters?: InputMaybe<Array<MessageTopicFilterInput> | MessageTopicFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<MessageTopicOrder>;
}>;

export type MessageTopicNamesQuery = {
	__typename?: "Query";
	messageTopicConnection: {
		__typename?: "MessageTopicConnection";
		edges: Array<{ __typename?: "MessageTopicEdge"; node: { __typename?: "MessageTopic"; id: string; name: string } }>;
	};
};

export type MessageTopicPaginationQueryVariables = Exact<{
	filters?: InputMaybe<Array<MessageTopicFilterInput> | MessageTopicFilterInput>;
	order?: InputMaybe<MessageTopicOrder>;
}>;

export type MessageTopicPaginationQuery = {
	__typename?: "Query";
	messageTopicConnection: {
		__typename?: "MessageTopicConnection";
		totalCount: number;
		edges: Array<{ __typename?: "MessageTopicEdge"; cursor: string }>;
	};
};

export type MessageTopicSelectQueryVariables = Exact<{
	filters?: InputMaybe<Array<MessageTopicFilterInput> | MessageTopicFilterInput>;
	order?: InputMaybe<MessageTopicOrder>;
}>;

export type MessageTopicSelectQuery = {
	__typename?: "Query";
	messageTopicConnection: {
		__typename?: "MessageTopicConnection";
		edges: Array<{ __typename?: "MessageTopicEdge"; node: { __typename?: "MessageTopic"; id: string; name: string } }>;
	};
};

export type MessageTopicUpdateMutationVariables = Exact<{
	id: Scalars["ID"]["input"];
	input: MessageTopicUpdateInput;
}>;

export type MessageTopicUpdateMutation = {
	__typename?: "Mutation";
	updateMessageTopic: {
		__typename?: "MessageTopic";
		id: string;
		name: string;
		message: { __typename?: "Message"; id: string };
	};
};

export type NewsletterCountQueryVariables = Exact<{
	filters?: InputMaybe<Array<NewsletterFilterInput> | NewsletterFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<NewsletterOrder>;
}>;

export type NewsletterCountQuery = {
	__typename?: "Query";
	newsletterConnection: { __typename?: "NewsletterConnection"; totalCount: number };
};

export type NewsletterCreateMutationVariables = Exact<{
	input: NewsletterCreateInput;
}>;

export type NewsletterCreateMutation = {
	__typename?: "Mutation";
	createNewsletter: {
		__typename?: "Newsletter";
		id: string;
		title: string;
		imageURL: string;
		imageKey: string;
		imageContentType: string;
		body: string;
		releaseAt: string | null;
		author: {
			__typename?: "User";
			id: string;
			name: string;
			publicName: string;
			givenName: string;
			familyName: string;
			isCurrent: boolean;
			imageURL: string;
			imageKey: string;
			imageContentType: string;
		} | null;
		sharingPolicy: {
			__typename?: "SharingPolicy";
			id: string;
			isPublic: boolean;
			userGroups: Array<{ __typename?: "UserGroup"; id: string; name: string; color: string }>;
			users: Array<{
				__typename?: "User";
				id: string;
				name: string;
				publicName: string;
				givenName: string;
				familyName: string;
				isCurrent: boolean;
			}>;
		} | null;
	};
};

export type NewsletterDeleteMutationVariables = Exact<{
	id: Scalars["ID"]["input"];
}>;

export type NewsletterDeleteMutation = { __typename?: "Mutation"; deleteNewsletter: boolean };

export type NewsletterDetailFragment = {
	__typename?: "Newsletter";
	id: string;
	title: string;
	imageURL: string;
	imageKey: string;
	imageContentType: string;
	body: string;
	releaseAt: string | null;
	author: {
		__typename?: "User";
		id: string;
		name: string;
		publicName: string;
		givenName: string;
		familyName: string;
		isCurrent: boolean;
		imageURL: string;
		imageKey: string;
		imageContentType: string;
	} | null;
	sharingPolicy: {
		__typename?: "SharingPolicy";
		id: string;
		isPublic: boolean;
		userGroups: Array<{ __typename?: "UserGroup"; id: string; name: string; color: string }>;
		users: Array<{
			__typename?: "User";
			id: string;
			name: string;
			publicName: string;
			givenName: string;
			familyName: string;
			isCurrent: boolean;
		}>;
	} | null;
};

export type NewsletterDetailQueryVariables = Exact<{
	id: Scalars["ID"]["input"];
}>;

export type NewsletterDetailQuery = {
	__typename?: "Query";
	newsletter: {
		__typename?: "Newsletter";
		id: string;
		title: string;
		imageURL: string;
		imageKey: string;
		imageContentType: string;
		body: string;
		releaseAt: string | null;
		author: {
			__typename?: "User";
			id: string;
			name: string;
			publicName: string;
			givenName: string;
			familyName: string;
			isCurrent: boolean;
			imageURL: string;
			imageKey: string;
			imageContentType: string;
		} | null;
		sharingPolicy: {
			__typename?: "SharingPolicy";
			id: string;
			isPublic: boolean;
			userGroups: Array<{ __typename?: "UserGroup"; id: string; name: string; color: string }>;
			users: Array<{
				__typename?: "User";
				id: string;
				name: string;
				publicName: string;
				givenName: string;
				familyName: string;
				isCurrent: boolean;
			}>;
		} | null;
	};
};

export type NewsletterDisplayListItemFragment = {
	__typename?: "Newsletter";
	id: string;
	title: string;
	imageURL: string;
	imageKey: string;
	imageContentType: string;
	body: string;
	releaseAt: string | null;
	author: {
		__typename?: "User";
		id: string;
		name: string;
		publicName: string;
		givenName: string;
		familyName: string;
		isCurrent: boolean;
		imageURL: string;
		imageKey: string;
		imageContentType: string;
	} | null;
};

export type NewsletterDisplayListQueryVariables = Exact<{
	filters?: InputMaybe<Array<NewsletterFilterInput> | NewsletterFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<NewsletterOrder>;
}>;

export type NewsletterDisplayListQuery = {
	__typename?: "Query";
	newsletterConnection: {
		__typename?: "NewsletterConnection";
		edges: Array<{
			__typename?: "NewsletterEdge";
			node: {
				__typename?: "Newsletter";
				id: string;
				title: string;
				imageURL: string;
				imageKey: string;
				imageContentType: string;
				body: string;
				releaseAt: string | null;
				author: {
					__typename?: "User";
					id: string;
					name: string;
					publicName: string;
					givenName: string;
					familyName: string;
					isCurrent: boolean;
					imageURL: string;
					imageKey: string;
					imageContentType: string;
				} | null;
			};
		}>;
	};
};

export type NewsletterIndexQueryVariables = Exact<{
	filters?: InputMaybe<Array<NewsletterFilterInput> | NewsletterFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<NewsletterOrder>;
}>;

export type NewsletterIndexQuery = {
	__typename?: "Query";
	newsletterConnection: {
		__typename?: "NewsletterConnection";
		edges: Array<{
			__typename?: "NewsletterEdge";
			node: {
				__typename?: "Newsletter";
				id: string;
				title: string;
				imageURL: string;
				imageContentType: string;
				body: string;
				releaseAt: string | null;
				author: {
					__typename?: "User";
					id: string;
					name: string;
					publicName: string;
					givenName: string;
					familyName: string;
					isCurrent: boolean;
				} | null;
			};
		}>;
	};
};

export type NewsletterNameFragment = { __typename?: "Newsletter"; title: string };

export type NewsletterNameQueryVariables = Exact<{
	id: Scalars["ID"]["input"];
}>;

export type NewsletterNameQuery = {
	__typename?: "Query";
	newsletter: { __typename?: "Newsletter"; id: string; title: string };
};

export type NewsletterNamesQueryVariables = Exact<{
	filters?: InputMaybe<Array<NewsletterFilterInput> | NewsletterFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<NewsletterOrder>;
}>;

export type NewsletterNamesQuery = {
	__typename?: "Query";
	newsletterConnection: {
		__typename?: "NewsletterConnection";
		edges: Array<{ __typename?: "NewsletterEdge"; node: { __typename?: "Newsletter"; id: string; title: string } }>;
	};
};

export type NewsletterPaginationQueryVariables = Exact<{
	filters?: InputMaybe<Array<NewsletterFilterInput> | NewsletterFilterInput>;
	order?: InputMaybe<NewsletterOrder>;
}>;

export type NewsletterPaginationQuery = {
	__typename?: "Query";
	newsletterConnection: {
		__typename?: "NewsletterConnection";
		totalCount: number;
		edges: Array<{ __typename?: "NewsletterEdge"; cursor: string }>;
	};
};

export type NewsletterSelectQueryVariables = Exact<{
	filters?: InputMaybe<Array<NewsletterFilterInput> | NewsletterFilterInput>;
	order?: InputMaybe<NewsletterOrder>;
}>;

export type NewsletterSelectQuery = {
	__typename?: "Query";
	newsletterConnection: {
		__typename?: "NewsletterConnection";
		edges: Array<{ __typename?: "NewsletterEdge"; node: { __typename?: "Newsletter"; id: string; title: string } }>;
	};
};

export type NewsletterSocialItemsQueryVariables = Exact<{
	id: Scalars["ID"]["input"];
}>;

export type NewsletterSocialItemsQuery = {
	__typename?: "Query";
	newsletter: {
		__typename?: "Newsletter";
		id: string;
		socialReactions: Array<{
			__typename?: "SocialReaction";
			id: string;
			reaction: SocialReactionReaction;
			author: {
				__typename?: "User";
				id: string;
				isCurrent: boolean;
				name: string;
				publicName: string;
				givenName: string;
				familyName: string;
			};
		}>;
		socialComments: Array<{
			__typename?: "SocialComment";
			id: string;
			body: string;
			createdAt: string;
			author: {
				__typename?: "User";
				id: string;
				isCurrent: boolean;
				name: string;
				publicName: string;
				givenName: string;
				familyName: string;
				imageURL: string;
				imageKey: string;
				imageContentType: string;
			};
		}>;
	};
};

export type NewsletterStatisticsQueryVariables = Exact<{
	filters?: InputMaybe<Array<NewsletterFilterInput> | NewsletterFilterInput>;
}>;

export type NewsletterStatisticsQuery = {
	__typename?: "Query";
	newsletterStatistics: {
		__typename?: "NewsletterStatistics";
		count: number;
		views: number;
		reactions: number;
		comments: number;
	};
};

export type NewsletterUpdateMutationVariables = Exact<{
	id: Scalars["ID"]["input"];
	input: NewsletterUpdateInput;
}>;

export type NewsletterUpdateMutation = {
	__typename?: "Mutation";
	updateNewsletter: {
		__typename?: "Newsletter";
		id: string;
		title: string;
		imageURL: string;
		imageKey: string;
		imageContentType: string;
		body: string;
		releaseAt: string | null;
		author: {
			__typename?: "User";
			id: string;
			name: string;
			publicName: string;
			givenName: string;
			familyName: string;
			isCurrent: boolean;
			imageURL: string;
			imageKey: string;
			imageContentType: string;
		} | null;
		sharingPolicy: {
			__typename?: "SharingPolicy";
			id: string;
			isPublic: boolean;
			userGroups: Array<{ __typename?: "UserGroup"; id: string; name: string; color: string }>;
			users: Array<{
				__typename?: "User";
				id: string;
				name: string;
				publicName: string;
				givenName: string;
				familyName: string;
				isCurrent: boolean;
			}>;
		} | null;
	};
};

export type PermissionCountQueryVariables = Exact<{
	filters?: InputMaybe<Array<PermissionFilterInput> | PermissionFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<PermissionOrder>;
}>;

export type PermissionCountQuery = {
	__typename?: "Query";
	permissionConnection: { __typename?: "PermissionConnection"; totalCount: number };
};

export type PermissionDetailFragment = {
	__typename?: "Permission";
	id: string;
	name: string;
	family: string;
	action: string;
	level: string;
	description: string;
	permissionGroups: Array<{ __typename?: "PermissionGroup"; id: string; name: string }>;
};

export type PermissionDetailQueryVariables = Exact<{
	id: Scalars["ID"]["input"];
}>;

export type PermissionDetailQuery = {
	__typename?: "Query";
	permission: {
		__typename?: "Permission";
		id: string;
		name: string;
		family: string;
		action: string;
		level: string;
		description: string;
		permissionGroups: Array<{ __typename?: "PermissionGroup"; id: string; name: string }>;
	};
};

export type PermissionIndexQueryVariables = Exact<{
	filters?: InputMaybe<Array<PermissionFilterInput> | PermissionFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<PermissionOrder>;
}>;

export type PermissionIndexQuery = {
	__typename?: "Query";
	permissionConnection: {
		__typename?: "PermissionConnection";
		edges: Array<{
			__typename?: "PermissionEdge";
			node: {
				__typename?: "Permission";
				id: string;
				name: string;
				family: string;
				action: string;
				level: string;
				description: string;
			};
		}>;
	};
};

export type PermissionNameFragment = { __typename?: "Permission"; name: string };

export type PermissionNameQueryVariables = Exact<{
	id: Scalars["ID"]["input"];
}>;

export type PermissionNameQuery = {
	__typename?: "Query";
	permission: { __typename?: "Permission"; id: string; name: string };
};

export type PermissionNamesQueryVariables = Exact<{
	filters?: InputMaybe<Array<PermissionFilterInput> | PermissionFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<PermissionOrder>;
}>;

export type PermissionNamesQuery = {
	__typename?: "Query";
	permissionConnection: {
		__typename?: "PermissionConnection";
		edges: Array<{ __typename?: "PermissionEdge"; node: { __typename?: "Permission"; id: string; name: string } }>;
	};
};

export type PermissionPaginationQueryVariables = Exact<{
	filters?: InputMaybe<Array<PermissionFilterInput> | PermissionFilterInput>;
	order?: InputMaybe<PermissionOrder>;
}>;

export type PermissionPaginationQuery = {
	__typename?: "Query";
	permissionConnection: {
		__typename?: "PermissionConnection";
		totalCount: number;
		edges: Array<{ __typename?: "PermissionEdge"; cursor: string }>;
	};
};

export type PermissionSelectQueryVariables = Exact<{
	filters?: InputMaybe<Array<PermissionFilterInput> | PermissionFilterInput>;
	order?: InputMaybe<PermissionOrder>;
}>;

export type PermissionSelectQuery = {
	__typename?: "Query";
	permissionConnection: {
		__typename?: "PermissionConnection";
		edges: Array<{ __typename?: "PermissionEdge"; node: { __typename?: "Permission"; id: string; name: string } }>;
	};
};

export type PermissionUpdateMutationVariables = Exact<{
	id: Scalars["ID"]["input"];
	input: PermissionUpdateInput;
}>;

export type PermissionUpdateMutation = {
	__typename?: "Mutation";
	updatePermission: {
		__typename?: "Permission";
		id: string;
		name: string;
		family: string;
		action: string;
		level: string;
		description: string;
		permissionGroups: Array<{ __typename?: "PermissionGroup"; id: string; name: string }>;
	};
};

export type PermissionGroupCheckUniqueNameQueryVariables = Exact<{
	ignoreID?: InputMaybe<Scalars["ID"]["input"]>;
	name: Scalars["String"]["input"];
}>;

export type PermissionGroupCheckUniqueNameQuery = {
	__typename?: "Query";
	permissionGroupConnection: { __typename?: "PermissionGroupConnection"; totalCount: number };
};

export type PermissionGroupCountQueryVariables = Exact<{
	filters?: InputMaybe<Array<PermissionGroupFilterInput> | PermissionGroupFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<PermissionGroupOrder>;
}>;

export type PermissionGroupCountQuery = {
	__typename?: "Query";
	permissionGroupConnection: { __typename?: "PermissionGroupConnection"; totalCount: number };
};

export type PermissionGroupCreateMutationVariables = Exact<{
	input: PermissionGroupCreateInput;
}>;

export type PermissionGroupCreateMutation = {
	__typename?: "Mutation";
	createPermissionGroup: {
		__typename?: "PermissionGroup";
		id: string;
		name: string;
		description: string;
		permissions: Array<{ __typename?: "Permission"; id: string; name: string }>;
		users: Array<{
			__typename?: "User";
			id: string;
			name: string;
			publicName: string;
			givenName: string;
			familyName: string;
			isCurrent: boolean;
		}>;
	};
};

export type PermissionGroupDeleteMutationVariables = Exact<{
	id: Scalars["ID"]["input"];
}>;

export type PermissionGroupDeleteMutation = { __typename?: "Mutation"; deletePermissionGroup: boolean };

export type PermissionGroupDetailFragment = {
	__typename?: "PermissionGroup";
	id: string;
	name: string;
	description: string;
	permissions: Array<{ __typename?: "Permission"; id: string; name: string }>;
	users: Array<{
		__typename?: "User";
		id: string;
		name: string;
		publicName: string;
		givenName: string;
		familyName: string;
		isCurrent: boolean;
	}>;
};

export type PermissionGroupDetailQueryVariables = Exact<{
	id: Scalars["ID"]["input"];
}>;

export type PermissionGroupDetailQuery = {
	__typename?: "Query";
	permissionGroup: {
		__typename?: "PermissionGroup";
		id: string;
		name: string;
		description: string;
		permissions: Array<{ __typename?: "Permission"; id: string; name: string }>;
		users: Array<{
			__typename?: "User";
			id: string;
			name: string;
			publicName: string;
			givenName: string;
			familyName: string;
			isCurrent: boolean;
		}>;
	};
};

export type PermissionGroupIndexQueryVariables = Exact<{
	filters?: InputMaybe<Array<PermissionGroupFilterInput> | PermissionGroupFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<PermissionGroupOrder>;
}>;

export type PermissionGroupIndexQuery = {
	__typename?: "Query";
	permissionGroupConnection: {
		__typename?: "PermissionGroupConnection";
		edges: Array<{
			__typename?: "PermissionGroupEdge";
			node: { __typename?: "PermissionGroup"; id: string; name: string; description: string };
		}>;
	};
};

export type PermissionGroupNameFragment = { __typename?: "PermissionGroup"; name: string };

export type PermissionGroupNameQueryVariables = Exact<{
	id: Scalars["ID"]["input"];
}>;

export type PermissionGroupNameQuery = {
	__typename?: "Query";
	permissionGroup: { __typename?: "PermissionGroup"; id: string; name: string };
};

export type PermissionGroupNamesQueryVariables = Exact<{
	filters?: InputMaybe<Array<PermissionGroupFilterInput> | PermissionGroupFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<PermissionGroupOrder>;
}>;

export type PermissionGroupNamesQuery = {
	__typename?: "Query";
	permissionGroupConnection: {
		__typename?: "PermissionGroupConnection";
		edges: Array<{
			__typename?: "PermissionGroupEdge";
			node: { __typename?: "PermissionGroup"; id: string; name: string };
		}>;
	};
};

export type PermissionGroupPaginationQueryVariables = Exact<{
	filters?: InputMaybe<Array<PermissionGroupFilterInput> | PermissionGroupFilterInput>;
	order?: InputMaybe<PermissionGroupOrder>;
}>;

export type PermissionGroupPaginationQuery = {
	__typename?: "Query";
	permissionGroupConnection: {
		__typename?: "PermissionGroupConnection";
		totalCount: number;
		edges: Array<{ __typename?: "PermissionGroupEdge"; cursor: string }>;
	};
};

export type PermissionGroupSelectQueryVariables = Exact<{
	filters?: InputMaybe<Array<PermissionGroupFilterInput> | PermissionGroupFilterInput>;
	order?: InputMaybe<PermissionGroupOrder>;
}>;

export type PermissionGroupSelectQuery = {
	__typename?: "Query";
	permissionGroupConnection: {
		__typename?: "PermissionGroupConnection";
		edges: Array<{
			__typename?: "PermissionGroupEdge";
			node: { __typename?: "PermissionGroup"; id: string; name: string };
		}>;
	};
};

export type PermissionGroupUpdateMutationVariables = Exact<{
	id: Scalars["ID"]["input"];
	input: PermissionGroupUpdateInput;
}>;

export type PermissionGroupUpdateMutation = {
	__typename?: "Mutation";
	updatePermissionGroup: {
		__typename?: "PermissionGroup";
		id: string;
		name: string;
		description: string;
		permissions: Array<{ __typename?: "Permission"; id: string; name: string }>;
		users: Array<{
			__typename?: "User";
			id: string;
			name: string;
			publicName: string;
			givenName: string;
			familyName: string;
			isCurrent: boolean;
		}>;
	};
};

export type PostCountQueryVariables = Exact<{
	filters?: InputMaybe<Array<PostFilterInput> | PostFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<PostOrder>;
}>;

export type PostCountQuery = {
	__typename?: "Query";
	postConnection: { __typename?: "PostConnection"; totalCount: number };
};

export type PostCreateMutationVariables = Exact<{
	input: PostCreateInput;
}>;

export type PostCreateMutation = {
	__typename?: "Mutation";
	createPost: {
		__typename?: "Post";
		id: string;
		createdAt: string;
		title: string;
		body: string;
		author: {
			__typename?: "User";
			id: string;
			name: string;
			publicName: string;
			givenName: string;
			familyName: string;
			isCurrent: boolean;
			imageURL: string;
			imageKey: string;
			imageContentType: string;
		} | null;
		mediaAttachments: Array<{
			__typename?: "MediaAttachment";
			id: string;
			displayOrder: number;
			title: string;
			description: string;
			isFile: boolean;
			fileURL: string;
			fileKey: string;
			fileContentType: string;
			linkURL: string;
		}>;
		socialReactions: Array<{
			__typename?: "SocialReaction";
			id: string;
			author: {
				__typename?: "User";
				id: string;
				isCurrent: boolean;
				name: string;
				publicName: string;
				givenName: string;
				familyName: string;
			};
		}>;
		socialComments: Array<{
			__typename?: "SocialComment";
			id: string;
			body: string;
			createdAt: string;
			author: {
				__typename?: "User";
				id: string;
				isCurrent: boolean;
				name: string;
				publicName: string;
				givenName: string;
				familyName: string;
				imageURL: string;
				imageKey: string;
				imageContentType: string;
			};
		}>;
		sharingPolicy: {
			__typename?: "SharingPolicy";
			id: string;
			isPublic: boolean;
			userGroups: Array<{ __typename?: "UserGroup"; id: string; name: string; color: string }>;
			users: Array<{
				__typename?: "User";
				id: string;
				name: string;
				publicName: string;
				givenName: string;
				familyName: string;
				isCurrent: boolean;
			}>;
		} | null;
	};
};

export type PostDeleteMutationVariables = Exact<{
	id: Scalars["ID"]["input"];
}>;

export type PostDeleteMutation = { __typename?: "Mutation"; deletePost: boolean };

export type PostDetailFragment = {
	__typename?: "Post";
	id: string;
	createdAt: string;
	title: string;
	body: string;
	author: {
		__typename?: "User";
		id: string;
		name: string;
		publicName: string;
		givenName: string;
		familyName: string;
		isCurrent: boolean;
		imageURL: string;
		imageKey: string;
		imageContentType: string;
	} | null;
	mediaAttachments: Array<{
		__typename?: "MediaAttachment";
		id: string;
		displayOrder: number;
		title: string;
		description: string;
		isFile: boolean;
		fileURL: string;
		fileKey: string;
		fileContentType: string;
		linkURL: string;
	}>;
	socialReactions: Array<{
		__typename?: "SocialReaction";
		id: string;
		author: {
			__typename?: "User";
			id: string;
			isCurrent: boolean;
			name: string;
			publicName: string;
			givenName: string;
			familyName: string;
		};
	}>;
	socialComments: Array<{
		__typename?: "SocialComment";
		id: string;
		body: string;
		createdAt: string;
		author: {
			__typename?: "User";
			id: string;
			isCurrent: boolean;
			name: string;
			publicName: string;
			givenName: string;
			familyName: string;
			imageURL: string;
			imageKey: string;
			imageContentType: string;
		};
	}>;
	sharingPolicy: {
		__typename?: "SharingPolicy";
		id: string;
		isPublic: boolean;
		userGroups: Array<{ __typename?: "UserGroup"; id: string; name: string; color: string }>;
		users: Array<{
			__typename?: "User";
			id: string;
			name: string;
			publicName: string;
			givenName: string;
			familyName: string;
			isCurrent: boolean;
		}>;
	} | null;
};

export type PostDetailQueryVariables = Exact<{
	id: Scalars["ID"]["input"];
}>;

export type PostDetailQuery = {
	__typename?: "Query";
	post: {
		__typename?: "Post";
		id: string;
		createdAt: string;
		title: string;
		body: string;
		author: {
			__typename?: "User";
			id: string;
			name: string;
			publicName: string;
			givenName: string;
			familyName: string;
			isCurrent: boolean;
			imageURL: string;
			imageKey: string;
			imageContentType: string;
		} | null;
		mediaAttachments: Array<{
			__typename?: "MediaAttachment";
			id: string;
			displayOrder: number;
			title: string;
			description: string;
			isFile: boolean;
			fileURL: string;
			fileKey: string;
			fileContentType: string;
			linkURL: string;
		}>;
		socialReactions: Array<{
			__typename?: "SocialReaction";
			id: string;
			author: {
				__typename?: "User";
				id: string;
				isCurrent: boolean;
				name: string;
				publicName: string;
				givenName: string;
				familyName: string;
			};
		}>;
		socialComments: Array<{
			__typename?: "SocialComment";
			id: string;
			body: string;
			createdAt: string;
			author: {
				__typename?: "User";
				id: string;
				isCurrent: boolean;
				name: string;
				publicName: string;
				givenName: string;
				familyName: string;
				imageURL: string;
				imageKey: string;
				imageContentType: string;
			};
		}>;
		sharingPolicy: {
			__typename?: "SharingPolicy";
			id: string;
			isPublic: boolean;
			userGroups: Array<{ __typename?: "UserGroup"; id: string; name: string; color: string }>;
			users: Array<{
				__typename?: "User";
				id: string;
				name: string;
				publicName: string;
				givenName: string;
				familyName: string;
				isCurrent: boolean;
			}>;
		} | null;
	};
};

export type PostIndexQueryVariables = Exact<{
	filters?: InputMaybe<Array<PostFilterInput> | PostFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<PostOrder>;
}>;

export type PostIndexQuery = {
	__typename?: "Query";
	postConnection: {
		__typename?: "PostConnection";
		edges: Array<{
			__typename?: "PostEdge";
			node: {
				__typename?: "Post";
				id: string;
				createdAt: string;
				title: string;
				body: string;
				author: {
					__typename?: "User";
					id: string;
					name: string;
					publicName: string;
					givenName: string;
					familyName: string;
					isCurrent: boolean;
				} | null;
			};
		}>;
	};
};

export type PostNameFragment = { __typename?: "Post"; title: string };

export type PostNameQueryVariables = Exact<{
	id: Scalars["ID"]["input"];
}>;

export type PostNameQuery = { __typename?: "Query"; post: { __typename?: "Post"; id: string; title: string } };

export type PostNamesQueryVariables = Exact<{
	filters?: InputMaybe<Array<PostFilterInput> | PostFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<PostOrder>;
}>;

export type PostNamesQuery = {
	__typename?: "Query";
	postConnection: {
		__typename?: "PostConnection";
		edges: Array<{ __typename?: "PostEdge"; node: { __typename?: "Post"; id: string; title: string } }>;
	};
};

export type PostPaginationQueryVariables = Exact<{
	filters?: InputMaybe<Array<PostFilterInput> | PostFilterInput>;
	order?: InputMaybe<PostOrder>;
}>;

export type PostPaginationQuery = {
	__typename?: "Query";
	postConnection: {
		__typename?: "PostConnection";
		totalCount: number;
		edges: Array<{ __typename?: "PostEdge"; cursor: string }>;
	};
};

export type PostSelectQueryVariables = Exact<{
	filters?: InputMaybe<Array<PostFilterInput> | PostFilterInput>;
	order?: InputMaybe<PostOrder>;
}>;

export type PostSelectQuery = {
	__typename?: "Query";
	postConnection: {
		__typename?: "PostConnection";
		edges: Array<{ __typename?: "PostEdge"; node: { __typename?: "Post"; id: string; title: string } }>;
	};
};

export type PostSocialItemsQueryVariables = Exact<{
	id: Scalars["ID"]["input"];
}>;

export type PostSocialItemsQuery = {
	__typename?: "Query";
	post: {
		__typename?: "Post";
		id: string;
		socialReactions: Array<{
			__typename?: "SocialReaction";
			id: string;
			reaction: SocialReactionReaction;
			author: {
				__typename?: "User";
				id: string;
				isCurrent: boolean;
				name: string;
				publicName: string;
				givenName: string;
				familyName: string;
			};
		}>;
		socialComments: Array<{
			__typename?: "SocialComment";
			id: string;
			body: string;
			createdAt: string;
			author: {
				__typename?: "User";
				id: string;
				isCurrent: boolean;
				name: string;
				publicName: string;
				givenName: string;
				familyName: string;
				imageURL: string;
				imageKey: string;
				imageContentType: string;
			};
		}>;
	};
};

export type PostStatisticsQueryVariables = Exact<{
	filters?: InputMaybe<Array<PostFilterInput> | PostFilterInput>;
}>;

export type PostStatisticsQuery = {
	__typename?: "Query";
	postStatistics: { __typename?: "PostStatistics"; count: number; views: number; reactions: number; comments: number };
};

export type PostUpdateMutationVariables = Exact<{
	id: Scalars["ID"]["input"];
	input: PostUpdateInput;
}>;

export type PostUpdateMutation = {
	__typename?: "Mutation";
	updatePost: {
		__typename?: "Post";
		id: string;
		createdAt: string;
		title: string;
		body: string;
		author: {
			__typename?: "User";
			id: string;
			name: string;
			publicName: string;
			givenName: string;
			familyName: string;
			isCurrent: boolean;
			imageURL: string;
			imageKey: string;
			imageContentType: string;
		} | null;
		mediaAttachments: Array<{
			__typename?: "MediaAttachment";
			id: string;
			displayOrder: number;
			title: string;
			description: string;
			isFile: boolean;
			fileURL: string;
			fileKey: string;
			fileContentType: string;
			linkURL: string;
		}>;
		socialReactions: Array<{
			__typename?: "SocialReaction";
			id: string;
			author: {
				__typename?: "User";
				id: string;
				isCurrent: boolean;
				name: string;
				publicName: string;
				givenName: string;
				familyName: string;
			};
		}>;
		socialComments: Array<{
			__typename?: "SocialComment";
			id: string;
			body: string;
			createdAt: string;
			author: {
				__typename?: "User";
				id: string;
				isCurrent: boolean;
				name: string;
				publicName: string;
				givenName: string;
				familyName: string;
				imageURL: string;
				imageKey: string;
				imageContentType: string;
			};
		}>;
		sharingPolicy: {
			__typename?: "SharingPolicy";
			id: string;
			isPublic: boolean;
			userGroups: Array<{ __typename?: "UserGroup"; id: string; name: string; color: string }>;
			users: Array<{
				__typename?: "User";
				id: string;
				name: string;
				publicName: string;
				givenName: string;
				familyName: string;
				isCurrent: boolean;
			}>;
		} | null;
	};
};

export type CommunicationCenterStatisticsQueryVariables = Exact<{
	announcementFilters?: InputMaybe<Array<AnnouncementFilterInput> | AnnouncementFilterInput>;
	newsletterFilters?: InputMaybe<Array<NewsletterFilterInput> | NewsletterFilterInput>;
	postFilters?: InputMaybe<Array<PostFilterInput> | PostFilterInput>;
	calendarEventFilters?: InputMaybe<Array<CalendarEventFilterInput> | CalendarEventFilterInput>;
}>;

export type CommunicationCenterStatisticsQuery = {
	__typename?: "Query";
	announcementStatistics: { __typename?: "AnnouncementStatistics"; count: number; views: number; reactions: number };
	newsletterStatistics: {
		__typename?: "NewsletterStatistics";
		count: number;
		views: number;
		reactions: number;
		comments: number;
	};
	postStatistics: { __typename?: "PostStatistics"; count: number; views: number; reactions: number; comments: number };
	calendarEventStatistics: {
		__typename?: "CalendarEventStatistics";
		count: number;
		responsesAttending: number;
		responsesMaybeAttending: number;
		responsesNotAttending: number;
	};
};

export type SharingPolicyCountQueryVariables = Exact<{
	filters?: InputMaybe<Array<SharingPolicyFilterInput> | SharingPolicyFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<SharingPolicyOrder>;
}>;

export type SharingPolicyCountQuery = {
	__typename?: "Query";
	sharingPolicyConnection: { __typename?: "SharingPolicyConnection"; totalCount: number };
};

export type SharingPolicyCreateMutationVariables = Exact<{
	input: SharingPolicyCreateInput;
}>;

export type SharingPolicyCreateMutation = {
	__typename?: "Mutation";
	createSharingPolicy: {
		__typename?: "SharingPolicy";
		id: string;
		isPublic: boolean;
		announcement: { __typename?: "Announcement"; id: string; title: string } | null;
		calendarEvent: { __typename?: "CalendarEvent"; id: string; name: string } | null;
		newsletter: { __typename?: "Newsletter"; id: string; title: string } | null;
		post: { __typename?: "Post"; id: string; title: string } | null;
		userGroups: Array<{ __typename?: "UserGroup"; id: string; name: string }>;
		users: Array<{
			__typename?: "User";
			id: string;
			name: string;
			publicName: string;
			givenName: string;
			familyName: string;
			isCurrent: boolean;
		}>;
	};
};

export type SharingPolicyDeleteMutationVariables = Exact<{
	id: Scalars["ID"]["input"];
}>;

export type SharingPolicyDeleteMutation = { __typename?: "Mutation"; deleteSharingPolicy: boolean };

export type SharingPolicyDetailInParentFragment = {
	__typename?: "SharingPolicy";
	id: string;
	isPublic: boolean;
	userGroups: Array<{ __typename?: "UserGroup"; id: string; name: string; color: string }>;
	users: Array<{
		__typename?: "User";
		id: string;
		name: string;
		publicName: string;
		givenName: string;
		familyName: string;
		isCurrent: boolean;
	}>;
};

export type SharingPolicyDetailFragment = {
	__typename?: "SharingPolicy";
	id: string;
	isPublic: boolean;
	announcement: { __typename?: "Announcement"; id: string; title: string } | null;
	calendarEvent: { __typename?: "CalendarEvent"; id: string; name: string } | null;
	newsletter: { __typename?: "Newsletter"; id: string; title: string } | null;
	post: { __typename?: "Post"; id: string; title: string } | null;
	userGroups: Array<{ __typename?: "UserGroup"; id: string; name: string }>;
	users: Array<{
		__typename?: "User";
		id: string;
		name: string;
		publicName: string;
		givenName: string;
		familyName: string;
		isCurrent: boolean;
	}>;
};

export type SharingPolicyDetailQueryVariables = Exact<{
	id: Scalars["ID"]["input"];
}>;

export type SharingPolicyDetailQuery = {
	__typename?: "Query";
	sharingPolicy: {
		__typename?: "SharingPolicy";
		id: string;
		isPublic: boolean;
		announcement: { __typename?: "Announcement"; id: string; title: string } | null;
		calendarEvent: { __typename?: "CalendarEvent"; id: string; name: string } | null;
		newsletter: { __typename?: "Newsletter"; id: string; title: string } | null;
		post: { __typename?: "Post"; id: string; title: string } | null;
		userGroups: Array<{ __typename?: "UserGroup"; id: string; name: string }>;
		users: Array<{
			__typename?: "User";
			id: string;
			name: string;
			publicName: string;
			givenName: string;
			familyName: string;
			isCurrent: boolean;
		}>;
	};
};

export type SharingPolicyIndexQueryVariables = Exact<{
	filters?: InputMaybe<Array<SharingPolicyFilterInput> | SharingPolicyFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<SharingPolicyOrder>;
}>;

export type SharingPolicyIndexQuery = {
	__typename?: "Query";
	sharingPolicyConnection: {
		__typename?: "SharingPolicyConnection";
		edges: Array<{
			__typename?: "SharingPolicyEdge";
			node: { __typename?: "SharingPolicy"; id: string; isPublic: boolean };
		}>;
	};
};

export type SharingPolicyNameFragment = { __typename?: "SharingPolicy"; id: string };

export type SharingPolicyNameQueryVariables = Exact<{
	id: Scalars["ID"]["input"];
}>;

export type SharingPolicyNameQuery = {
	__typename?: "Query";
	sharingPolicy: { __typename?: "SharingPolicy"; id: string };
};

export type SharingPolicyNamesQueryVariables = Exact<{
	filters?: InputMaybe<Array<SharingPolicyFilterInput> | SharingPolicyFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<SharingPolicyOrder>;
}>;

export type SharingPolicyNamesQuery = {
	__typename?: "Query";
	sharingPolicyConnection: {
		__typename?: "SharingPolicyConnection";
		edges: Array<{ __typename?: "SharingPolicyEdge"; node: { __typename?: "SharingPolicy"; id: string } }>;
	};
};

export type SharingPolicyPaginationQueryVariables = Exact<{
	filters?: InputMaybe<Array<SharingPolicyFilterInput> | SharingPolicyFilterInput>;
	order?: InputMaybe<SharingPolicyOrder>;
}>;

export type SharingPolicyPaginationQuery = {
	__typename?: "Query";
	sharingPolicyConnection: {
		__typename?: "SharingPolicyConnection";
		totalCount: number;
		edges: Array<{ __typename?: "SharingPolicyEdge"; cursor: string }>;
	};
};

export type SharingPolicySelectQueryVariables = Exact<{
	filters?: InputMaybe<Array<SharingPolicyFilterInput> | SharingPolicyFilterInput>;
	order?: InputMaybe<SharingPolicyOrder>;
}>;

export type SharingPolicySelectQuery = {
	__typename?: "Query";
	sharingPolicyConnection: {
		__typename?: "SharingPolicyConnection";
		edges: Array<{ __typename?: "SharingPolicyEdge"; node: { __typename?: "SharingPolicy"; id: string } }>;
	};
};

export type SharingPolicyUpdateMutationVariables = Exact<{
	id: Scalars["ID"]["input"];
	input: SharingPolicyUpdateInput;
}>;

export type SharingPolicyUpdateMutation = {
	__typename?: "Mutation";
	updateSharingPolicy: {
		__typename?: "SharingPolicy";
		id: string;
		isPublic: boolean;
		announcement: { __typename?: "Announcement"; id: string; title: string } | null;
		calendarEvent: { __typename?: "CalendarEvent"; id: string; name: string } | null;
		newsletter: { __typename?: "Newsletter"; id: string; title: string } | null;
		post: { __typename?: "Post"; id: string; title: string } | null;
		userGroups: Array<{ __typename?: "UserGroup"; id: string; name: string }>;
		users: Array<{
			__typename?: "User";
			id: string;
			name: string;
			publicName: string;
			givenName: string;
			familyName: string;
			isCurrent: boolean;
		}>;
	};
};

export type SharingPolicyPreviewQueryVariables = Exact<{
	filters?: InputMaybe<Array<SharingPolicyFilterInput> | SharingPolicyFilterInput>;
}>;

export type SharingPolicyPreviewQuery = {
	__typename?: "Query";
	sharingPolicyConnection: {
		__typename?: "SharingPolicyConnection";
		edges: Array<{
			__typename?: "SharingPolicyEdge";
			node: {
				__typename?: "SharingPolicy";
				id: string;
				isPublic: boolean;
				userGroups: Array<{ __typename?: "UserGroup"; id: string; name: string }>;
			};
		}>;
	};
	userConnection: { __typename?: "UserConnection"; totalCount: number };
};

export type SharingPolicyUsersPreviewQueryVariables = Exact<{
	sharingPolicy: SharingPolicyCreateInput;
	filters?: InputMaybe<Array<UserFilterInput> | UserFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<UserOrder>;
}>;

export type SharingPolicyUsersPreviewQuery = {
	__typename?: "Query";
	sharedUserConnection: {
		__typename?: "UserConnection";
		totalCount: number;
		pageInfo: { __typename?: "PageInfo"; hasNextPage: boolean; endCursor: string | null };
		edges: Array<{
			__typename?: "UserEdge";
			node: {
				__typename?: "User";
				id: string;
				name: string;
				publicName: string;
				givenName: string;
				familyName: string;
				organizationName: string;
				isCurrent: boolean;
				imageURL: string;
				imageKey: string;
				imageContentType: string;
			};
		}>;
	};
};

export type SocialCommentCountQueryVariables = Exact<{
	filters?: InputMaybe<Array<SocialCommentFilterInput> | SocialCommentFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<SocialCommentOrder>;
}>;

export type SocialCommentCountQuery = {
	__typename?: "Query";
	socialCommentConnection: { __typename?: "SocialCommentConnection"; totalCount: number };
};

export type SocialCommentCreateMutationVariables = Exact<{
	input: SocialCommentCreateInput;
}>;

export type SocialCommentCreateMutation = {
	__typename?: "Mutation";
	createSocialComment: {
		__typename?: "SocialComment";
		id: string;
		createdAt: string;
		body: string;
		author: {
			__typename?: "User";
			id: string;
			name: string;
			publicName: string;
			givenName: string;
			familyName: string;
			isCurrent: boolean;
		};
		mediaAttachment: { __typename?: "MediaAttachment"; id: string; title: string } | null;
		newsletter: { __typename?: "Newsletter"; id: string; title: string } | null;
		post: { __typename?: "Post"; id: string; title: string } | null;
	};
};

export type SocialCommentDeleteMutationVariables = Exact<{
	id: Scalars["ID"]["input"];
}>;

export type SocialCommentDeleteMutation = { __typename?: "Mutation"; deleteSocialComment: boolean };

export type SocialCommentDetailFragment = {
	__typename?: "SocialComment";
	id: string;
	createdAt: string;
	body: string;
	author: {
		__typename?: "User";
		id: string;
		name: string;
		publicName: string;
		givenName: string;
		familyName: string;
		isCurrent: boolean;
	};
	mediaAttachment: { __typename?: "MediaAttachment"; id: string; title: string } | null;
	newsletter: { __typename?: "Newsletter"; id: string; title: string } | null;
	post: { __typename?: "Post"; id: string; title: string } | null;
};

export type SocialCommentDetailQueryVariables = Exact<{
	id: Scalars["ID"]["input"];
}>;

export type SocialCommentDetailQuery = {
	__typename?: "Query";
	socialComment: {
		__typename?: "SocialComment";
		id: string;
		createdAt: string;
		body: string;
		author: {
			__typename?: "User";
			id: string;
			name: string;
			publicName: string;
			givenName: string;
			familyName: string;
			isCurrent: boolean;
		};
		mediaAttachment: { __typename?: "MediaAttachment"; id: string; title: string } | null;
		newsletter: { __typename?: "Newsletter"; id: string; title: string } | null;
		post: { __typename?: "Post"; id: string; title: string } | null;
	};
};

export type SocialCommentIndexQueryVariables = Exact<{
	filters?: InputMaybe<Array<SocialCommentFilterInput> | SocialCommentFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<SocialCommentOrder>;
}>;

export type SocialCommentIndexQuery = {
	__typename?: "Query";
	socialCommentConnection: {
		__typename?: "SocialCommentConnection";
		edges: Array<{
			__typename?: "SocialCommentEdge";
			node: { __typename?: "SocialComment"; id: string; createdAt: string; body: string };
		}>;
	};
};

export type SocialCommentListQueryVariables = Exact<{
	filters?: InputMaybe<Array<SocialCommentFilterInput> | SocialCommentFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<SocialCommentOrder>;
}>;

export type SocialCommentListQuery = {
	__typename?: "Query";
	socialCommentConnection: {
		__typename?: "SocialCommentConnection";
		totalCount: number;
		edges: Array<{
			__typename?: "SocialCommentEdge";
			node: {
				__typename?: "SocialComment";
				id: string;
				body: string;
				createdAt: string;
				author: {
					__typename?: "User";
					id: string;
					isCurrent: boolean;
					name: string;
					publicName: string;
					givenName: string;
					familyName: string;
					imageURL: string;
					imageKey: string;
					imageContentType: string;
				};
			};
		}>;
	};
};

export type SocialCommentNameFragment = { __typename?: "SocialComment"; id: string };

export type SocialCommentNameQueryVariables = Exact<{
	id: Scalars["ID"]["input"];
}>;

export type SocialCommentNameQuery = {
	__typename?: "Query";
	socialComment: { __typename?: "SocialComment"; id: string };
};

export type SocialCommentNamesQueryVariables = Exact<{
	filters?: InputMaybe<Array<SocialCommentFilterInput> | SocialCommentFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<SocialCommentOrder>;
}>;

export type SocialCommentNamesQuery = {
	__typename?: "Query";
	socialCommentConnection: {
		__typename?: "SocialCommentConnection";
		edges: Array<{ __typename?: "SocialCommentEdge"; node: { __typename?: "SocialComment"; id: string } }>;
	};
};

export type SocialCommentPaginationQueryVariables = Exact<{
	filters?: InputMaybe<Array<SocialCommentFilterInput> | SocialCommentFilterInput>;
	order?: InputMaybe<SocialCommentOrder>;
}>;

export type SocialCommentPaginationQuery = {
	__typename?: "Query";
	socialCommentConnection: {
		__typename?: "SocialCommentConnection";
		totalCount: number;
		edges: Array<{ __typename?: "SocialCommentEdge"; cursor: string }>;
	};
};

export type SocialCommentSelectQueryVariables = Exact<{
	filters?: InputMaybe<Array<SocialCommentFilterInput> | SocialCommentFilterInput>;
	order?: InputMaybe<SocialCommentOrder>;
}>;

export type SocialCommentSelectQuery = {
	__typename?: "Query";
	socialCommentConnection: {
		__typename?: "SocialCommentConnection";
		edges: Array<{ __typename?: "SocialCommentEdge"; node: { __typename?: "SocialComment"; id: string } }>;
	};
};

export type SocialCommentUpdateMutationVariables = Exact<{
	id: Scalars["ID"]["input"];
	input: SocialCommentUpdateInput;
}>;

export type SocialCommentUpdateMutation = {
	__typename?: "Mutation";
	updateSocialComment: {
		__typename?: "SocialComment";
		id: string;
		createdAt: string;
		body: string;
		author: {
			__typename?: "User";
			id: string;
			name: string;
			publicName: string;
			givenName: string;
			familyName: string;
			isCurrent: boolean;
		};
		mediaAttachment: { __typename?: "MediaAttachment"; id: string; title: string } | null;
		newsletter: { __typename?: "Newsletter"; id: string; title: string } | null;
		post: { __typename?: "Post"; id: string; title: string } | null;
	};
};

export type SocialReactionCountQueryVariables = Exact<{
	filters?: InputMaybe<Array<SocialReactionFilterInput> | SocialReactionFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<SocialReactionOrder>;
}>;

export type SocialReactionCountQuery = {
	__typename?: "Query";
	socialReactionConnection: { __typename?: "SocialReactionConnection"; totalCount: number };
};

export type SocialReactionCreateMutationVariables = Exact<{
	input: SocialReactionCreateInput;
}>;

export type SocialReactionCreateMutation = {
	__typename?: "Mutation";
	createSocialReaction: {
		__typename?: "SocialReaction";
		id: string;
		createdAt: string;
		reaction: SocialReactionReaction;
		announcement: { __typename?: "Announcement"; id: string; title: string } | null;
		author: {
			__typename?: "User";
			id: string;
			name: string;
			publicName: string;
			givenName: string;
			familyName: string;
			isCurrent: boolean;
		};
		mediaAttachment: { __typename?: "MediaAttachment"; id: string; title: string } | null;
		newsletter: { __typename?: "Newsletter"; id: string; title: string } | null;
		post: { __typename?: "Post"; id: string; title: string } | null;
	};
};

export type SocialReactionDeleteMutationVariables = Exact<{
	id: Scalars["ID"]["input"];
}>;

export type SocialReactionDeleteMutation = { __typename?: "Mutation"; deleteSocialReaction: boolean };

export type SocialReactionDetailFragment = {
	__typename?: "SocialReaction";
	id: string;
	createdAt: string;
	reaction: SocialReactionReaction;
	announcement: { __typename?: "Announcement"; id: string; title: string } | null;
	author: {
		__typename?: "User";
		id: string;
		name: string;
		publicName: string;
		givenName: string;
		familyName: string;
		isCurrent: boolean;
	};
	mediaAttachment: { __typename?: "MediaAttachment"; id: string; title: string } | null;
	newsletter: { __typename?: "Newsletter"; id: string; title: string } | null;
	post: { __typename?: "Post"; id: string; title: string } | null;
};

export type SocialReactionDetailQueryVariables = Exact<{
	id: Scalars["ID"]["input"];
}>;

export type SocialReactionDetailQuery = {
	__typename?: "Query";
	socialReaction: {
		__typename?: "SocialReaction";
		id: string;
		createdAt: string;
		reaction: SocialReactionReaction;
		announcement: { __typename?: "Announcement"; id: string; title: string } | null;
		author: {
			__typename?: "User";
			id: string;
			name: string;
			publicName: string;
			givenName: string;
			familyName: string;
			isCurrent: boolean;
		};
		mediaAttachment: { __typename?: "MediaAttachment"; id: string; title: string } | null;
		newsletter: { __typename?: "Newsletter"; id: string; title: string } | null;
		post: { __typename?: "Post"; id: string; title: string } | null;
	};
};

export type SocialReactionIndexQueryVariables = Exact<{
	filters?: InputMaybe<Array<SocialReactionFilterInput> | SocialReactionFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<SocialReactionOrder>;
}>;

export type SocialReactionIndexQuery = {
	__typename?: "Query";
	socialReactionConnection: {
		__typename?: "SocialReactionConnection";
		edges: Array<{
			__typename?: "SocialReactionEdge";
			node: { __typename?: "SocialReaction"; id: string; createdAt: string; reaction: SocialReactionReaction };
		}>;
	};
};

export type SocialReactionNameFragment = { __typename?: "SocialReaction"; id: string };

export type SocialReactionNameQueryVariables = Exact<{
	id: Scalars["ID"]["input"];
}>;

export type SocialReactionNameQuery = {
	__typename?: "Query";
	socialReaction: { __typename?: "SocialReaction"; id: string };
};

export type SocialReactionNamesQueryVariables = Exact<{
	filters?: InputMaybe<Array<SocialReactionFilterInput> | SocialReactionFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<SocialReactionOrder>;
}>;

export type SocialReactionNamesQuery = {
	__typename?: "Query";
	socialReactionConnection: {
		__typename?: "SocialReactionConnection";
		edges: Array<{ __typename?: "SocialReactionEdge"; node: { __typename?: "SocialReaction"; id: string } }>;
	};
};

export type SocialReactionPaginationQueryVariables = Exact<{
	filters?: InputMaybe<Array<SocialReactionFilterInput> | SocialReactionFilterInput>;
	order?: InputMaybe<SocialReactionOrder>;
}>;

export type SocialReactionPaginationQuery = {
	__typename?: "Query";
	socialReactionConnection: {
		__typename?: "SocialReactionConnection";
		totalCount: number;
		edges: Array<{ __typename?: "SocialReactionEdge"; cursor: string }>;
	};
};

export type SocialReactionSelectQueryVariables = Exact<{
	filters?: InputMaybe<Array<SocialReactionFilterInput> | SocialReactionFilterInput>;
	order?: InputMaybe<SocialReactionOrder>;
}>;

export type SocialReactionSelectQuery = {
	__typename?: "Query";
	socialReactionConnection: {
		__typename?: "SocialReactionConnection";
		edges: Array<{ __typename?: "SocialReactionEdge"; node: { __typename?: "SocialReaction"; id: string } }>;
	};
};

export type SocialReactionUpdateMutationVariables = Exact<{
	id: Scalars["ID"]["input"];
	input: SocialReactionUpdateInput;
}>;

export type SocialReactionUpdateMutation = {
	__typename?: "Mutation";
	updateSocialReaction: {
		__typename?: "SocialReaction";
		id: string;
		createdAt: string;
		reaction: SocialReactionReaction;
		announcement: { __typename?: "Announcement"; id: string; title: string } | null;
		author: {
			__typename?: "User";
			id: string;
			name: string;
			publicName: string;
			givenName: string;
			familyName: string;
			isCurrent: boolean;
		};
		mediaAttachment: { __typename?: "MediaAttachment"; id: string; title: string } | null;
		newsletter: { __typename?: "Newsletter"; id: string; title: string } | null;
		post: { __typename?: "Post"; id: string; title: string } | null;
	};
};

export type UserCheckUniqueEmailQueryVariables = Exact<{
	ignoreID?: InputMaybe<Scalars["ID"]["input"]>;
	email: Scalars["String"]["input"];
}>;

export type UserCheckUniqueEmailQuery = {
	__typename?: "Query";
	userConnection: { __typename?: "UserConnection"; totalCount: number };
};

export type UserCountQueryVariables = Exact<{
	filters?: InputMaybe<Array<UserFilterInput> | UserFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<UserOrder>;
}>;

export type UserCountQuery = {
	__typename?: "Query";
	userConnection: { __typename?: "UserConnection"; totalCount: number };
};

export type UserCreateMutationVariables = Exact<{
	input: UserCreateInput;
}>;

export type UserCreateMutation = {
	__typename?: "Mutation";
	createUser: {
		__typename?: "User";
		id: string;
		imageURL: string;
		imageKey: string;
		imageContentType: string;
		name: string;
		publicName: string;
		givenName: string;
		middleName: string;
		familyName: string;
		nameOrder: UserNameOrder;
		publicNameFormat: UserPublicNameFormat;
		organizationName: string;
		gender: string;
		pronouns: string;
		dateOfBirth: string | null;
		email: string;
		status: UserStatus;
		passwordUpdatedAt: string;
		isCurrent: boolean;
		timeZoneName: string;
		externalNotificationFrequency: UserExternalNotificationFrequency;
		permissionGroups: Array<{ __typename?: "PermissionGroup"; id: string; name: string }>;
	};
};

export type UserDeleteMutationVariables = Exact<{
	id: Scalars["ID"]["input"];
}>;

export type UserDeleteMutation = { __typename?: "Mutation"; deleteUser: boolean };

export type UserDetailFragment = {
	__typename?: "User";
	id: string;
	imageURL: string;
	imageKey: string;
	imageContentType: string;
	name: string;
	publicName: string;
	givenName: string;
	middleName: string;
	familyName: string;
	nameOrder: UserNameOrder;
	publicNameFormat: UserPublicNameFormat;
	organizationName: string;
	gender: string;
	pronouns: string;
	dateOfBirth: string | null;
	email: string;
	status: UserStatus;
	passwordUpdatedAt: string;
	isCurrent: boolean;
	timeZoneName: string;
	externalNotificationFrequency: UserExternalNotificationFrequency;
	permissionGroups: Array<{ __typename?: "PermissionGroup"; id: string; name: string }>;
};

export type UserDetailQueryVariables = Exact<{
	id: Scalars["ID"]["input"];
}>;

export type UserDetailQuery = {
	__typename?: "Query";
	user: {
		__typename?: "User";
		id: string;
		imageURL: string;
		imageKey: string;
		imageContentType: string;
		name: string;
		publicName: string;
		givenName: string;
		middleName: string;
		familyName: string;
		nameOrder: UserNameOrder;
		publicNameFormat: UserPublicNameFormat;
		organizationName: string;
		gender: string;
		pronouns: string;
		dateOfBirth: string | null;
		email: string;
		status: UserStatus;
		passwordUpdatedAt: string;
		isCurrent: boolean;
		timeZoneName: string;
		externalNotificationFrequency: UserExternalNotificationFrequency;
		permissionGroups: Array<{ __typename?: "PermissionGroup"; id: string; name: string }>;
	};
};

export type UserIndexQueryVariables = Exact<{
	filters?: InputMaybe<Array<UserFilterInput> | UserFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<UserOrder>;
}>;

export type UserIndexQuery = {
	__typename?: "Query";
	userConnection: {
		__typename?: "UserConnection";
		edges: Array<{
			__typename?: "UserEdge";
			node: {
				__typename?: "User";
				id: string;
				imageURL: string;
				imageContentType: string;
				name: string;
				publicName: string;
				givenName: string;
				middleName: string;
				familyName: string;
				nameOrder: UserNameOrder;
				publicNameFormat: UserPublicNameFormat;
				organizationName: string;
				gender: string;
				pronouns: string;
				dateOfBirth: string | null;
				email: string;
				status: UserStatus;
				passwordUpdatedAt: string;
				isCurrent: boolean;
				timeZoneName: string;
				externalNotificationFrequency: UserExternalNotificationFrequency;
			};
		}>;
	};
};

export type SendUserInviteMessageMutationVariables = Exact<{
	userID: Scalars["ID"]["input"];
}>;

export type SendUserInviteMessageMutation = { __typename?: "Mutation"; sendInviteMessage: boolean };

export type UserDetailedSelectListQueryVariables = Exact<{
	filters?: InputMaybe<Array<UserFilterInput> | UserFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<UserOrder>;
}>;

export type UserDetailedSelectListQuery = {
	__typename?: "Query";
	userConnection: {
		__typename?: "UserConnection";
		edges: Array<{
			__typename?: "UserEdge";
			node: {
				__typename?: "User";
				id: string;
				organizationName: string;
				name: string;
				publicName: string;
				givenName: string;
				familyName: string;
				isCurrent: boolean;
			};
		}>;
	};
};

export type UserNamesDescriptionsAndImagesQueryVariables = Exact<{
	filters?: InputMaybe<Array<UserFilterInput> | UserFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<UserOrder>;
}>;

export type UserNamesDescriptionsAndImagesQuery = {
	__typename?: "Query";
	userConnection: {
		__typename?: "UserConnection";
		pageInfo: { __typename?: "PageInfo"; hasNextPage: boolean; endCursor: string | null };
		edges: Array<{
			__typename?: "UserEdge";
			node: {
				__typename?: "User";
				id: string;
				name: string;
				publicName: string;
				givenName: string;
				familyName: string;
				organizationName: string;
				isCurrent: boolean;
				imageURL: string;
				imageKey: string;
				imageContentType: string;
			};
		}>;
	};
};

export type UserNameFragment = {
	__typename?: "User";
	id: string;
	name: string;
	publicName: string;
	givenName: string;
	familyName: string;
	isCurrent: boolean;
};

export type UserNameAndImageFragment = {
	__typename?: "User";
	id: string;
	name: string;
	publicName: string;
	givenName: string;
	familyName: string;
	isCurrent: boolean;
	imageURL: string;
	imageKey: string;
	imageContentType: string;
};

export type UserNameDescriptionAndImageFragment = {
	__typename?: "User";
	id: string;
	name: string;
	publicName: string;
	givenName: string;
	familyName: string;
	organizationName: string;
	isCurrent: boolean;
	imageURL: string;
	imageKey: string;
	imageContentType: string;
};

export type UserNameQueryVariables = Exact<{
	id: Scalars["ID"]["input"];
}>;

export type UserNameQuery = {
	__typename?: "Query";
	user: {
		__typename?: "User";
		id: string;
		name: string;
		publicName: string;
		givenName: string;
		familyName: string;
		isCurrent: boolean;
	};
};

export type UserNamesAndImagesQueryVariables = Exact<{
	filters?: InputMaybe<Array<UserFilterInput> | UserFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<UserOrder>;
}>;

export type UserNamesAndImagesQuery = {
	__typename?: "Query";
	userConnection: {
		__typename?: "UserConnection";
		edges: Array<{
			__typename?: "UserEdge";
			node: {
				__typename?: "User";
				id: string;
				name: string;
				publicName: string;
				givenName: string;
				familyName: string;
				isCurrent: boolean;
				imageURL: string;
				imageKey: string;
				imageContentType: string;
			};
		}>;
	};
};

export type UserNamesQueryVariables = Exact<{
	filters?: InputMaybe<Array<UserFilterInput> | UserFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<UserOrder>;
}>;

export type UserNamesQuery = {
	__typename?: "Query";
	userConnection: {
		__typename?: "UserConnection";
		edges: Array<{
			__typename?: "UserEdge";
			node: {
				__typename?: "User";
				id: string;
				name: string;
				publicName: string;
				givenName: string;
				familyName: string;
				isCurrent: boolean;
			};
		}>;
	};
};

export type UserPaginationQueryVariables = Exact<{
	filters?: InputMaybe<Array<UserFilterInput> | UserFilterInput>;
	order?: InputMaybe<UserOrder>;
}>;

export type UserPaginationQuery = {
	__typename?: "Query";
	userConnection: {
		__typename?: "UserConnection";
		totalCount: number;
		edges: Array<{ __typename?: "UserEdge"; cursor: string }>;
	};
};

export type UserSelectQueryVariables = Exact<{
	filters?: InputMaybe<Array<UserFilterInput> | UserFilterInput>;
	order?: InputMaybe<UserOrder>;
}>;

export type UserSelectQuery = {
	__typename?: "Query";
	userConnection: {
		__typename?: "UserConnection";
		edges: Array<{
			__typename?: "UserEdge";
			node: {
				__typename?: "User";
				id: string;
				name: string;
				publicName: string;
				givenName: string;
				familyName: string;
				isCurrent: boolean;
			};
		}>;
	};
};

export type UserUpdateMutationVariables = Exact<{
	id: Scalars["ID"]["input"];
	input: UserUpdateInput;
}>;

export type UserUpdateMutation = {
	__typename?: "Mutation";
	updateUser: {
		__typename?: "User";
		id: string;
		imageURL: string;
		imageKey: string;
		imageContentType: string;
		name: string;
		publicName: string;
		givenName: string;
		middleName: string;
		familyName: string;
		nameOrder: UserNameOrder;
		publicNameFormat: UserPublicNameFormat;
		organizationName: string;
		gender: string;
		pronouns: string;
		dateOfBirth: string | null;
		email: string;
		status: UserStatus;
		passwordUpdatedAt: string;
		isCurrent: boolean;
		timeZoneName: string;
		externalNotificationFrequency: UserExternalNotificationFrequency;
		permissionGroups: Array<{ __typename?: "PermissionGroup"; id: string; name: string }>;
	};
};

export type InternalPortalsViewerInfoQueryVariables = Exact<{ [key: string]: never }>;

export type InternalPortalsViewerInfoQuery = {
	__typename?: "Query";
	viewer: {
		__typename?: "User";
		id: string;
		name: string;
		publicName: string;
		givenName: string;
		familyName: string;
		organizationName: string;
		isCurrent: boolean;
		imageURL: string;
		imageKey: string;
		imageContentType: string;
	};
};

export type ViewerPublicNameFormatQueryVariables = Exact<{ [key: string]: never }>;

export type ViewerPublicNameFormatQuery = {
	__typename?: "Query";
	viewer: { __typename?: "User"; id: string; publicNameFormat: UserPublicNameFormat };
};

export type UserGroupCountQueryVariables = Exact<{
	filters?: InputMaybe<Array<UserGroupFilterInput> | UserGroupFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<UserGroupOrder>;
}>;

export type UserGroupCountQuery = {
	__typename?: "Query";
	userGroupConnection: { __typename?: "UserGroupConnection"; totalCount: number };
};

export type UserGroupCreateMutationVariables = Exact<{
	input: UserGroupCreateInput;
}>;

export type UserGroupCreateMutation = {
	__typename?: "Mutation";
	createUserGroup: {
		__typename?: "UserGroup";
		id: string;
		name: string;
		description: string;
		color: string;
		isPublic: boolean;
		users: Array<{
			__typename?: "User";
			id: string;
			name: string;
			publicName: string;
			givenName: string;
			familyName: string;
			isCurrent: boolean;
		}>;
	};
};

export type UserGroupDeleteMutationVariables = Exact<{
	id: Scalars["ID"]["input"];
}>;

export type UserGroupDeleteMutation = { __typename?: "Mutation"; deleteUserGroup: boolean };

export type UserGroupDetailFragment = {
	__typename?: "UserGroup";
	id: string;
	name: string;
	description: string;
	color: string;
	isPublic: boolean;
	users: Array<{
		__typename?: "User";
		id: string;
		name: string;
		publicName: string;
		givenName: string;
		familyName: string;
		isCurrent: boolean;
	}>;
};

export type UserGroupDetailQueryVariables = Exact<{
	id: Scalars["ID"]["input"];
}>;

export type UserGroupDetailQuery = {
	__typename?: "Query";
	userGroup: {
		__typename?: "UserGroup";
		id: string;
		name: string;
		description: string;
		color: string;
		isPublic: boolean;
		users: Array<{
			__typename?: "User";
			id: string;
			name: string;
			publicName: string;
			givenName: string;
			familyName: string;
			isCurrent: boolean;
		}>;
	};
};

export type UserGroupIDsQueryVariables = Exact<{
	filters?: InputMaybe<Array<UserGroupFilterInput> | UserGroupFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<UserGroupOrder>;
}>;

export type UserGroupIDsQuery = {
	__typename?: "Query";
	userGroupConnection: {
		__typename?: "UserGroupConnection";
		edges: Array<{ __typename?: "UserGroupEdge"; node: { __typename?: "UserGroup"; id: string } }>;
	};
};

export type UserGroupIndexQueryVariables = Exact<{
	filters?: InputMaybe<Array<UserGroupFilterInput> | UserGroupFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<UserGroupOrder>;
}>;

export type UserGroupIndexQuery = {
	__typename?: "Query";
	userGroupConnection: {
		__typename?: "UserGroupConnection";
		edges: Array<{
			__typename?: "UserGroupEdge";
			node: {
				__typename?: "UserGroup";
				id: string;
				name: string;
				description: string;
				color: string;
				isPublic: boolean;
				members: Array<{ __typename?: "User"; id: string }>;
			};
		}>;
	};
};

export type UserGroupDetailedSelectListQueryVariables = Exact<{
	filters?: InputMaybe<Array<UserGroupFilterInput> | UserGroupFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<UserGroupOrder>;
}>;

export type UserGroupDetailedSelectListQuery = {
	__typename?: "Query";
	userGroupConnection: {
		__typename?: "UserGroupConnection";
		edges: Array<{
			__typename?: "UserGroupEdge";
			node: {
				__typename?: "UserGroup";
				id: string;
				description: string;
				name: string;
				currentUserMembers: Array<{ __typename?: "User"; id: string }>;
			};
		}>;
	};
};

export type UserGroupNameFragment = { __typename?: "UserGroup"; name: string };

export type UserGroupNameAndColorFragment = { __typename?: "UserGroup"; name: string; color: string };

export type UserGroupNameQueryVariables = Exact<{
	id: Scalars["ID"]["input"];
}>;

export type UserGroupNameQuery = {
	__typename?: "Query";
	userGroup: { __typename?: "UserGroup"; id: string; name: string };
};

export type UserGroupNamesQueryVariables = Exact<{
	filters?: InputMaybe<Array<UserGroupFilterInput> | UserGroupFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<UserGroupOrder>;
}>;

export type UserGroupNamesQuery = {
	__typename?: "Query";
	userGroupConnection: {
		__typename?: "UserGroupConnection";
		edges: Array<{ __typename?: "UserGroupEdge"; node: { __typename?: "UserGroup"; id: string; name: string } }>;
	};
};

export type UserGroupNamesAndColorsQueryVariables = Exact<{
	filters?: InputMaybe<Array<UserGroupFilterInput> | UserGroupFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<UserGroupOrder>;
}>;

export type UserGroupNamesAndColorsQuery = {
	__typename?: "Query";
	userGroupConnection: {
		__typename?: "UserGroupConnection";
		edges: Array<{
			__typename?: "UserGroupEdge";
			node: { __typename?: "UserGroup"; id: string; name: string; color: string };
		}>;
	};
};

export type UserGroupPaginationQueryVariables = Exact<{
	filters?: InputMaybe<Array<UserGroupFilterInput> | UserGroupFilterInput>;
	order?: InputMaybe<UserGroupOrder>;
}>;

export type UserGroupPaginationQuery = {
	__typename?: "Query";
	userGroupConnection: {
		__typename?: "UserGroupConnection";
		totalCount: number;
		edges: Array<{ __typename?: "UserGroupEdge"; cursor: string }>;
	};
};

export type UserGroupSelectQueryVariables = Exact<{
	filters?: InputMaybe<Array<UserGroupFilterInput> | UserGroupFilterInput>;
	order?: InputMaybe<UserGroupOrder>;
}>;

export type UserGroupSelectQuery = {
	__typename?: "Query";
	userGroupConnection: {
		__typename?: "UserGroupConnection";
		edges: Array<{ __typename?: "UserGroupEdge"; node: { __typename?: "UserGroup"; id: string; name: string } }>;
	};
};

export type UserGroupUpdateMutationVariables = Exact<{
	id: Scalars["ID"]["input"];
	input: UserGroupUpdateInput;
}>;

export type UserGroupUpdateMutation = {
	__typename?: "Mutation";
	updateUserGroup: {
		__typename?: "UserGroup";
		id: string;
		name: string;
		description: string;
		color: string;
		isPublic: boolean;
		users: Array<{
			__typename?: "User";
			id: string;
			name: string;
			publicName: string;
			givenName: string;
			familyName: string;
			isCurrent: boolean;
		}>;
	};
};

export type UserViewRecordCountQueryVariables = Exact<{
	filters?: InputMaybe<Array<UserViewRecordFilterInput> | UserViewRecordFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<UserViewRecordOrder>;
}>;

export type UserViewRecordCountQuery = {
	__typename?: "Query";
	userViewRecordConnection: { __typename?: "UserViewRecordConnection"; totalCount: number };
};

export type UserViewRecordCreateMutationVariables = Exact<{
	input: UserViewRecordCreateInput;
}>;

export type UserViewRecordCreateMutation = {
	__typename?: "Mutation";
	createUserViewRecord: {
		__typename?: "UserViewRecord";
		id: string;
		targetID: string;
		firstViewedAt: string;
		lastViewedAt: string;
		user: {
			__typename?: "User";
			id: string;
			name: string;
			publicName: string;
			givenName: string;
			familyName: string;
			isCurrent: boolean;
		};
	};
};

export type UserViewRecordDeleteMutationVariables = Exact<{
	id: Scalars["ID"]["input"];
}>;

export type UserViewRecordDeleteMutation = { __typename?: "Mutation"; deleteUserViewRecord: boolean };

export type UserViewRecordDetailFragment = {
	__typename?: "UserViewRecord";
	id: string;
	targetID: string;
	firstViewedAt: string;
	lastViewedAt: string;
	user: {
		__typename?: "User";
		id: string;
		name: string;
		publicName: string;
		givenName: string;
		familyName: string;
		isCurrent: boolean;
	};
};

export type UserViewRecordDetailQueryVariables = Exact<{
	id: Scalars["ID"]["input"];
}>;

export type UserViewRecordDetailQuery = {
	__typename?: "Query";
	userViewRecord: {
		__typename?: "UserViewRecord";
		id: string;
		targetID: string;
		firstViewedAt: string;
		lastViewedAt: string;
		user: {
			__typename?: "User";
			id: string;
			name: string;
			publicName: string;
			givenName: string;
			familyName: string;
			isCurrent: boolean;
		};
	};
};

export type UserViewRecordIDsQueryVariables = Exact<{
	filters?: InputMaybe<Array<UserViewRecordFilterInput> | UserViewRecordFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<UserViewRecordOrder>;
}>;

export type UserViewRecordIDsQuery = {
	__typename?: "Query";
	userViewRecordConnection: {
		__typename?: "UserViewRecordConnection";
		edges: Array<{
			__typename?: "UserViewRecordEdge";
			node: { __typename?: "UserViewRecord"; id: string; targetID: string };
		}>;
	};
};

export type UserViewRecordIndexQueryVariables = Exact<{
	filters?: InputMaybe<Array<UserViewRecordFilterInput> | UserViewRecordFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<UserViewRecordOrder>;
}>;

export type UserViewRecordIndexQuery = {
	__typename?: "Query";
	userViewRecordConnection: {
		__typename?: "UserViewRecordConnection";
		edges: Array<{
			__typename?: "UserViewRecordEdge";
			node: {
				__typename?: "UserViewRecord";
				id: string;
				targetID: string;
				firstViewedAt: string;
				lastViewedAt: string;
			};
		}>;
	};
};

export type UserViewRecordNameFragment = { __typename?: "UserViewRecord"; id: string };

export type UserViewRecordNameQueryVariables = Exact<{
	id: Scalars["ID"]["input"];
}>;

export type UserViewRecordNameQuery = {
	__typename?: "Query";
	userViewRecord: { __typename?: "UserViewRecord"; id: string };
};

export type UserViewRecordNamesQueryVariables = Exact<{
	filters?: InputMaybe<Array<UserViewRecordFilterInput> | UserViewRecordFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<UserViewRecordOrder>;
}>;

export type UserViewRecordNamesQuery = {
	__typename?: "Query";
	userViewRecordConnection: {
		__typename?: "UserViewRecordConnection";
		edges: Array<{ __typename?: "UserViewRecordEdge"; node: { __typename?: "UserViewRecord"; id: string } }>;
	};
};

export type UserViewRecordPaginationQueryVariables = Exact<{
	filters?: InputMaybe<Array<UserViewRecordFilterInput> | UserViewRecordFilterInput>;
	order?: InputMaybe<UserViewRecordOrder>;
}>;

export type UserViewRecordPaginationQuery = {
	__typename?: "Query";
	userViewRecordConnection: {
		__typename?: "UserViewRecordConnection";
		totalCount: number;
		edges: Array<{ __typename?: "UserViewRecordEdge"; cursor: string }>;
	};
};

export type RecordViewMutationVariables = Exact<{
	id: Scalars["ID"]["input"];
}>;

export type RecordViewMutation = {
	__typename?: "Mutation";
	recordView: {
		__typename?: "UserViewRecord";
		id: string;
		targetID: string;
		userID: string;
		firstViewedAt: string;
		lastViewedAt: string;
	};
};

export type RecordViewsMutationVariables = Exact<{
	ids: Array<Scalars["ID"]["input"]> | Scalars["ID"]["input"];
}>;

export type RecordViewsMutation = {
	__typename?: "Mutation";
	recordViews: {
		__typename?: "UserViewRecordConnection";
		edges: Array<{
			__typename?: "UserViewRecordEdge";
			node: {
				__typename?: "UserViewRecord";
				id: string;
				targetID: string;
				userID: string;
				firstViewedAt: string;
				lastViewedAt: string;
			};
		}>;
	};
};

export type UserViewRecordSelectQueryVariables = Exact<{
	filters?: InputMaybe<Array<UserViewRecordFilterInput> | UserViewRecordFilterInput>;
	order?: InputMaybe<UserViewRecordOrder>;
}>;

export type UserViewRecordSelectQuery = {
	__typename?: "Query";
	userViewRecordConnection: {
		__typename?: "UserViewRecordConnection";
		edges: Array<{ __typename?: "UserViewRecordEdge"; node: { __typename?: "UserViewRecord"; id: string } }>;
	};
};

export type UserViewRecordListForTargetQueryVariables = Exact<{
	filters?: InputMaybe<Array<UserViewRecordFilterInput> | UserViewRecordFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<UserViewRecordOrder>;
}>;

export type UserViewRecordListForTargetQuery = {
	__typename?: "Query";
	userViewRecordConnection: {
		__typename?: "UserViewRecordConnection";
		edges: Array<{
			__typename?: "UserViewRecordEdge";
			node: { __typename?: "UserViewRecord"; id: string; targetID: string; lastViewedAt: string };
		}>;
	};
};

export type UserViewRecordListForTargetWithUserQueryVariables = Exact<{
	filters?: InputMaybe<Array<UserViewRecordFilterInput> | UserViewRecordFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<UserViewRecordOrder>;
}>;

export type UserViewRecordListForTargetWithUserQuery = {
	__typename?: "Query";
	userViewRecordConnection: {
		__typename?: "UserViewRecordConnection";
		edges: Array<{
			__typename?: "UserViewRecordEdge";
			node: {
				__typename?: "UserViewRecord";
				id: string;
				targetID: string;
				lastViewedAt: string;
				user: {
					__typename?: "User";
					id: string;
					name: string;
					publicName: string;
					givenName: string;
					familyName: string;
					isCurrent: boolean;
				};
			};
		}>;
	};
};

export type UserViewRecordUpdateMutationVariables = Exact<{
	id: Scalars["ID"]["input"];
	input: UserViewRecordUpdateInput;
}>;

export type UserViewRecordUpdateMutation = {
	__typename?: "Mutation";
	updateUserViewRecord: {
		__typename?: "UserViewRecord";
		id: string;
		targetID: string;
		firstViewedAt: string;
		lastViewedAt: string;
		user: {
			__typename?: "User";
			id: string;
			name: string;
			publicName: string;
			givenName: string;
			familyName: string;
			isCurrent: boolean;
		};
	};
};

export type BirthdaysQueryVariables = Exact<{
	dates: Array<Scalars["Time"]["input"]> | Scalars["Time"]["input"];
	filters?: InputMaybe<Array<UserFilterInput> | UserFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<UserOrder>;
}>;

export type BirthdaysQuery = {
	__typename?: "Query";
	userConnectionByBirthday: {
		__typename?: "UserConnection";
		edges: Array<{
			__typename?: "UserEdge";
			node: {
				__typename?: "User";
				id: string;
				givenName: string;
				familyName: string;
				dateOfBirth: string | null;
				name: string;
				publicName: string;
				isCurrent: boolean;
				imageURL: string;
				imageKey: string;
				imageContentType: string;
			};
		}>;
	};
};

export type GlobalSearchQueryVariables = Exact<{
	filters: Array<SearchResultFilterInput> | SearchResultFilterInput;
}>;

export type GlobalSearchQuery = {
	__typename?: "Query";
	searchResultConnection: {
		__typename?: "SearchResultConnection";
		edges: Array<{
			__typename?: "SearchResultEdge";
			node: { __typename?: "SearchResult"; id: string; name: string; modelName: string; searchText: string };
		}>;
	};
};

export type ModelIDsQueryVariables = Exact<{ [key: string]: never }>;

export type ModelIDsQuery = {
	__typename?: "Query";
	modelIDs: Array<{ __typename?: "ModelIDInformation"; modelName: string; minID: string; maxID: string }>;
};

export type TimelineQueryVariables = Exact<{
	filter?: InputMaybe<TimelineFilterInput>;
	pagination?: InputMaybe<TimelinePagination>;
	timeZone?: InputMaybe<Scalars["String"]["input"]>;
}>;

export type TimelineQuery = {
	__typename?: "Query";
	timeline: {
		__typename?: "TimelineConnection";
		hasMore: boolean;
		items: Array<{
			__typename?: "TimelineItem";
			objectType: TimelineObjectType;
			objectTime: string;
			objectTimeIsDate: boolean;
			objectID: string;
		}>;
	};
};

export type TimelineAnnouncementListQueryVariables = Exact<{
	filters?: InputMaybe<Array<AnnouncementFilterInput> | AnnouncementFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<AnnouncementOrder>;
}>;

export type TimelineAnnouncementListQuery = {
	__typename?: "Query";
	announcementConnection: {
		__typename?: "AnnouncementConnection";
		edges: Array<{
			__typename?: "AnnouncementEdge";
			node: {
				__typename?: "Announcement";
				id: string;
				title: string;
				body: string;
				startTime: string;
				endTime: string | null;
				author: {
					__typename?: "User";
					id: string;
					name: string;
					publicName: string;
					givenName: string;
					familyName: string;
					isCurrent: boolean;
					imageURL: string;
					imageKey: string;
					imageContentType: string;
				} | null;
				mediaAttachments: Array<{
					__typename?: "MediaAttachment";
					id: string;
					title: string;
					description: string;
					isFile: boolean;
					fileURL: string;
					fileKey: string;
					fileContentType: string;
					linkURL: string;
				}>;
				socialReactions: Array<{
					__typename?: "SocialReaction";
					id: string;
					author: {
						__typename?: "User";
						id: string;
						isCurrent: boolean;
						name: string;
						publicName: string;
						givenName: string;
						familyName: string;
					};
				}>;
				sharingPolicy: {
					__typename?: "SharingPolicy";
					id: string;
					isPublic: boolean;
					userGroups: Array<{ __typename?: "UserGroup"; id: string; name: string; color: string }>;
				} | null;
			};
		}>;
	};
};

export type TimelineCalendarEventListQueryVariables = Exact<{
	filters?: InputMaybe<Array<CalendarEventFilterInput> | CalendarEventFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<CalendarEventOrder>;
}>;

export type TimelineCalendarEventListQuery = {
	__typename?: "Query";
	calendarEventConnection: {
		__typename?: "CalendarEventConnection";
		edges: Array<{
			__typename?: "CalendarEventEdge";
			node: {
				__typename?: "CalendarEvent";
				id: string;
				name: string;
				description: string;
				location: string;
				imageURL: string;
				imageKey: string;
				imageContentType: string;
				isAllDay: boolean;
				startTime: string | null;
				endTime: string | null;
				startDate: string | null;
				isMultiDay: boolean;
				endDate: string | null;
				allowsResponses: boolean;
				createdAt: string;
				author: {
					__typename?: "User";
					id: string;
					name: string;
					publicName: string;
					givenName: string;
					familyName: string;
					isCurrent: boolean;
					imageURL: string;
					imageKey: string;
					imageContentType: string;
				} | null;
				calendarEventResponses: Array<{
					__typename?: "CalendarEventResponse";
					id: string;
					response: CalendarEventResponseResponse;
					author: {
						__typename?: "User";
						id: string;
						name: string;
						publicName: string;
						givenName: string;
						familyName: string;
						isCurrent: boolean;
						imageURL: string;
						imageKey: string;
						imageContentType: string;
					} | null;
				}>;
				mediaAttachments: Array<{
					__typename?: "MediaAttachment";
					id: string;
					displayOrder: number;
					title: string;
					description: string;
					isFile: boolean;
					fileURL: string;
					fileKey: string;
					fileContentType: string;
					linkURL: string;
				}>;
				sharingPolicy: { __typename?: "SharingPolicy"; id: string; isPublic: boolean } | null;
			};
		}>;
	};
};

export type TimelineNewsletterListQueryVariables = Exact<{
	filters?: InputMaybe<Array<NewsletterFilterInput> | NewsletterFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<NewsletterOrder>;
}>;

export type TimelineNewsletterListQuery = {
	__typename?: "Query";
	newsletterConnection: {
		__typename?: "NewsletterConnection";
		edges: Array<{
			__typename?: "NewsletterEdge";
			node: {
				__typename?: "Newsletter";
				id: string;
				title: string;
				imageURL: string;
				imageKey: string;
				imageContentType: string;
				body: string;
				releaseAt: string | null;
				socialReactions: Array<{
					__typename?: "SocialReaction";
					id: string;
					author: {
						__typename?: "User";
						id: string;
						isCurrent: boolean;
						name: string;
						publicName: string;
						givenName: string;
						familyName: string;
					};
				}>;
				socialComments: Array<{
					__typename?: "SocialComment";
					id: string;
					body: string;
					createdAt: string;
					author: {
						__typename?: "User";
						id: string;
						isCurrent: boolean;
						name: string;
						publicName: string;
						givenName: string;
						familyName: string;
						imageURL: string;
						imageKey: string;
						imageContentType: string;
					};
				}>;
				sharingPolicy: {
					__typename?: "SharingPolicy";
					id: string;
					isPublic: boolean;
					userGroups: Array<{ __typename?: "UserGroup"; id: string; name: string; color: string }>;
				} | null;
				author: {
					__typename?: "User";
					id: string;
					name: string;
					publicName: string;
					givenName: string;
					familyName: string;
					isCurrent: boolean;
					imageURL: string;
					imageKey: string;
					imageContentType: string;
				} | null;
			};
		}>;
	};
};

export type TimelinePostListQueryVariables = Exact<{
	filters?: InputMaybe<Array<PostFilterInput> | PostFilterInput>;
	pagination?: InputMaybe<Pagination>;
	order?: InputMaybe<PostOrder>;
}>;

export type TimelinePostListQuery = {
	__typename?: "Query";
	postConnection: {
		__typename?: "PostConnection";
		edges: Array<{
			__typename?: "PostEdge";
			node: {
				__typename?: "Post";
				id: string;
				createdAt: string;
				title: string;
				body: string;
				author: {
					__typename?: "User";
					id: string;
					name: string;
					publicName: string;
					givenName: string;
					familyName: string;
					isCurrent: boolean;
					imageURL: string;
					imageKey: string;
					imageContentType: string;
				} | null;
				mediaAttachments: Array<{
					__typename?: "MediaAttachment";
					id: string;
					title: string;
					description: string;
					isFile: boolean;
					fileURL: string;
					fileKey: string;
					fileContentType: string;
					linkURL: string;
				}>;
				socialReactions: Array<{
					__typename?: "SocialReaction";
					id: string;
					author: {
						__typename?: "User";
						id: string;
						isCurrent: boolean;
						name: string;
						publicName: string;
						givenName: string;
						familyName: string;
					};
				}>;
				socialComments: Array<{
					__typename?: "SocialComment";
					id: string;
					body: string;
					createdAt: string;
					author: {
						__typename?: "User";
						id: string;
						isCurrent: boolean;
						name: string;
						publicName: string;
						givenName: string;
						familyName: string;
						imageURL: string;
						imageKey: string;
						imageContentType: string;
					};
				}>;
				sharingPolicy: {
					__typename?: "SharingPolicy";
					id: string;
					isPublic: boolean;
					userGroups: Array<{ __typename?: "UserGroup"; id: string; name: string; color: string }>;
				} | null;
			};
		}>;
	};
};

export type ViewerCommunicationRecordCountsQueryVariables = Exact<{ [key: string]: never }>;

export type ViewerCommunicationRecordCountsQuery = {
	__typename?: "Query";
	announcementConnection: { __typename?: "AnnouncementConnection"; totalCount: number };
	calendarEventConnection: { __typename?: "CalendarEventConnection"; totalCount: number };
	newsletterConnection: { __typename?: "NewsletterConnection"; totalCount: number };
	postConnection: { __typename?: "PostConnection"; totalCount: number };
};

export type ViewerWithPermissionsQueryVariables = Exact<{ [key: string]: never }>;

export type ViewerWithPermissionsQuery = {
	__typename?: "Query";
	viewer: { __typename?: "User"; id: string; email: string; status: UserStatus };
	permissionConnection: {
		__typename?: "PermissionConnection";
		edges: Array<{ __typename?: "PermissionEdge"; node: { __typename?: "Permission"; name: string } }>;
	};
};

export const UserNameAndImageFragmentDoc = gql`
	fragment UserNameAndImage on User {
		id
		name
		publicName
		givenName
		familyName
		isCurrent
		imageURL
		imageKey
		imageContentType
	}
`;
export const UserGroupNameAndColorFragmentDoc = gql`
	fragment UserGroupNameAndColor on UserGroup {
		name
		color
	}
`;
export const UserNameFragmentDoc = gql`
	fragment UserName on User {
		id
		name
		publicName
		givenName
		familyName
		isCurrent
	}
`;
export const SharingPolicyDetailInParentFragmentDoc = gql`
	fragment SharingPolicyDetailInParent on SharingPolicy {
		id
		isPublic
		userGroups {
			id
			...UserGroupNameAndColor
		}
		users {
			id
			...UserName
		}
	}
	${UserGroupNameAndColorFragmentDoc}
	${UserNameFragmentDoc}
`;
export const AnnouncementDetailFragmentDoc = gql`
	fragment AnnouncementDetail on Announcement {
		id
		title
		body
		startTime
		endTime
		author {
			id
			...UserNameAndImage
		}
		mediaAttachments(order: { field: DISPLAY_ORDER, direction: ASC }) {
			id
			displayOrder
			title
			description
			isFile
			fileURL
			fileKey
			fileContentType
			linkURL
		}
		sharingPolicy {
			...SharingPolicyDetailInParent
		}
	}
	${UserNameAndImageFragmentDoc}
	${SharingPolicyDetailInParentFragmentDoc}
`;
export const CalendarEventTimingFragmentDoc = gql`
	fragment CalendarEventTiming on CalendarEvent {
		isAllDay
		startTime
		endTime
		startDate
		endDate
	}
`;
export const CalendarEventCalendarDetailFragmentDoc = gql`
	fragment CalendarEventCalendarDetail on CalendarEvent {
		id
		name
		description
		location
		imageURL
		imageKey
		imageContentType
		isAllDay
		startTime
		endTime
		startDate
		isMultiDay
		endDate
		allowsResponses
		createdAt
		author {
			id
			...UserNameAndImage
		}
		calendarEventResponses(filters: { author: { isCurrentEQ: true } }) {
			id
			response
			author {
				id
				...UserNameAndImage
			}
		}
		mediaAttachments(order: { field: DISPLAY_ORDER, direction: ASC }) {
			id
			displayOrder
			title
			description
			isFile
			fileURL
			fileKey
			fileContentType
			linkURL
		}
		sharingPolicy {
			id
			isPublic
		}
	}
	${UserNameAndImageFragmentDoc}
`;
export const CalendarEventDetailFragmentDoc = gql`
	fragment CalendarEventDetail on CalendarEvent {
		id
		name
		description
		location
		imageURL
		imageKey
		imageContentType
		isAllDay
		startTime
		endTime
		startDate
		isMultiDay
		endDate
		allowsResponses
		createdAt
		author {
			id
			...UserNameAndImage
		}
		calendarEventResponses(filters: { author: { isCurrentEQ: true } }) {
			id
			response
			author {
				id
				...UserNameAndImage
			}
		}
		mediaAttachments(order: { field: DISPLAY_ORDER, direction: ASC }) {
			id
			displayOrder
			title
			description
			isFile
			fileURL
			fileKey
			fileContentType
			linkURL
		}
		sharingPolicy {
			...SharingPolicyDetailInParent
		}
	}
	${UserNameAndImageFragmentDoc}
	${SharingPolicyDetailInParentFragmentDoc}
`;
export const CalendarEventNameFragmentDoc = gql`
	fragment CalendarEventName on CalendarEvent {
		name
	}
`;
export const CalendarEventResponseDetailFragmentDoc = gql`
	fragment CalendarEventResponseDetail on CalendarEventResponse {
		id
		response
		author {
			id
			...UserName
		}
		calendarEvent {
			id
			...CalendarEventName
		}
	}
	${UserNameFragmentDoc}
	${CalendarEventNameFragmentDoc}
`;
export const CalendarEventResponseNameFragmentDoc = gql`
	fragment CalendarEventResponseName on CalendarEventResponse {
		id
	}
`;
export const AnnouncementNameFragmentDoc = gql`
	fragment AnnouncementName on Announcement {
		title
	}
`;
export const MessageNameFragmentDoc = gql`
	fragment MessageName on Message {
		id
	}
`;
export const PostNameFragmentDoc = gql`
	fragment PostName on Post {
		title
	}
`;
export const MediaAttachmentDetailFragmentDoc = gql`
	fragment MediaAttachmentDetail on MediaAttachment {
		id
		displayOrder
		title
		description
		isFile
		fileURL
		fileKey
		fileContentType
		linkURL
		announcement {
			id
			...AnnouncementName
		}
		calendarEvent {
			id
			...CalendarEventName
		}
		message {
			id
			...MessageName
		}
		post {
			id
			...PostName
		}
	}
	${AnnouncementNameFragmentDoc}
	${CalendarEventNameFragmentDoc}
	${MessageNameFragmentDoc}
	${PostNameFragmentDoc}
`;
export const UserGroupNameFragmentDoc = gql`
	fragment UserGroupName on UserGroup {
		name
	}
`;
export const MessageGroupNameFragmentDoc = gql`
	fragment MessageGroupName on MessageGroup {
		customName
		users {
			id
			...UserName
		}
		userGroups {
			id
			...UserGroupName
		}
	}
	${UserNameFragmentDoc}
	${UserGroupNameFragmentDoc}
`;
export const MessageDetailFragmentDoc = gql`
	fragment MessageDetail on Message {
		id
		createdAt
		body
		lastEditedAt
		isRemoved
		author {
			id
			...UserName
		}
		messageGroup {
			id
			...MessageGroupName
		}
	}
	${UserNameFragmentDoc}
	${MessageGroupNameFragmentDoc}
`;
export const MessageInMessageGroupFragmentDoc = gql`
	fragment MessageInMessageGroup on Message {
		id
		createdAt
		body
		lastEditedAt
		isRemoved
		author {
			id
			...UserNameAndImage
		}
		mediaAttachments(order: { field: DISPLAY_ORDER, direction: ASC }) {
			id
			title
			description
			isFile
			fileURL
			fileKey
			fileContentType
			linkURL
		}
		messageTopic {
			id
		}
	}
	${UserNameAndImageFragmentDoc}
`;
export const UserNameDescriptionAndImageFragmentDoc = gql`
	fragment UserNameDescriptionAndImage on User {
		id
		name
		publicName
		givenName
		familyName
		organizationName
		isCurrent
		imageURL
		imageKey
		imageContentType
	}
`;
export const MessageGroupUserFragmentDoc = gql`
	fragment MessageGroupUser on User {
		id
		...UserNameDescriptionAndImage
	}
	${UserNameDescriptionAndImageFragmentDoc}
`;
export const MessageGroupDetailFragmentDoc = gql`
	fragment MessageGroupDetail on MessageGroup {
		id
		customName
		isOneOnOne
		userGroups {
			id
			...UserGroupNameAndColor
		}
		users {
			...MessageGroupUser
		}
	}
	${UserGroupNameAndColorFragmentDoc}
	${MessageGroupUserFragmentDoc}
`;
export const MessageGroupNameAndImageFragmentDoc = gql`
	fragment MessageGroupNameAndImage on MessageGroup {
		customName
		users {
			id
			...UserNameAndImage
		}
		userGroups {
			id
			...UserGroupNameAndColor
		}
	}
	${UserNameAndImageFragmentDoc}
	${UserGroupNameAndColorFragmentDoc}
`;
export const UserForMessagesFragmentDoc = gql`
	fragment UserForMessages on User {
		id
		...UserNameDescriptionAndImage
	}
	${UserNameDescriptionAndImageFragmentDoc}
`;
export const MessageGroupArchivePointDetailFragmentDoc = gql`
	fragment MessageGroupArchivePointDetail on MessageGroupArchivePoint {
		id
		createdAt
		author {
			id
			...UserName
		}
		messageGroup {
			id
			...MessageGroupName
		}
	}
	${UserNameFragmentDoc}
	${MessageGroupNameFragmentDoc}
`;
export const MessageGroupArchivePointNameFragmentDoc = gql`
	fragment MessageGroupArchivePointName on MessageGroupArchivePoint {
		id
	}
`;
export const MessageTopicDetailFragmentDoc = gql`
	fragment MessageTopicDetail on MessageTopic {
		id
		name
		message {
			id
			...MessageName
		}
	}
	${MessageNameFragmentDoc}
`;
export const MessageTopicNameFragmentDoc = gql`
	fragment MessageTopicName on MessageTopic {
		name
	}
`;
export const NewsletterDetailFragmentDoc = gql`
	fragment NewsletterDetail on Newsletter {
		id
		title
		imageURL
		imageKey
		imageContentType
		body
		releaseAt
		author {
			id
			...UserNameAndImage
		}
		sharingPolicy {
			...SharingPolicyDetailInParent
		}
	}
	${UserNameAndImageFragmentDoc}
	${SharingPolicyDetailInParentFragmentDoc}
`;
export const NewsletterDisplayListItemFragmentDoc = gql`
	fragment NewsletterDisplayListItem on Newsletter {
		id
		title
		imageURL
		imageKey
		imageContentType
		body
		releaseAt
		author {
			id
			...UserNameAndImage
		}
	}
	${UserNameAndImageFragmentDoc}
`;
export const PermissionGroupNameFragmentDoc = gql`
	fragment PermissionGroupName on PermissionGroup {
		name
	}
`;
export const PermissionDetailFragmentDoc = gql`
	fragment PermissionDetail on Permission {
		id
		name
		family
		action
		level
		description
		permissionGroups {
			id
			...PermissionGroupName
		}
	}
	${PermissionGroupNameFragmentDoc}
`;
export const PermissionNameFragmentDoc = gql`
	fragment PermissionName on Permission {
		name
	}
`;
export const PermissionGroupDetailFragmentDoc = gql`
	fragment PermissionGroupDetail on PermissionGroup {
		id
		name
		description
		permissions {
			id
			...PermissionName
		}
		users {
			id
			...UserName
		}
	}
	${PermissionNameFragmentDoc}
	${UserNameFragmentDoc}
`;
export const PostDetailFragmentDoc = gql`
	fragment PostDetail on Post {
		id
		createdAt
		title
		body
		author {
			id
			...UserNameAndImage
		}
		mediaAttachments(order: { field: DISPLAY_ORDER, direction: ASC }) {
			id
			displayOrder
			title
			description
			isFile
			fileURL
			fileKey
			fileContentType
			linkURL
		}
		socialReactions(order: { field: CREATED_AT, direction: DESC }) {
			id
			author {
				id
				...UserName
				isCurrent
			}
		}
		socialComments(order: { field: CREATED_AT, direction: DESC }) {
			id
			body
			createdAt
			author {
				id
				...UserNameAndImage
				isCurrent
			}
		}
		sharingPolicy {
			...SharingPolicyDetailInParent
		}
	}
	${UserNameAndImageFragmentDoc}
	${UserNameFragmentDoc}
	${SharingPolicyDetailInParentFragmentDoc}
`;
export const NewsletterNameFragmentDoc = gql`
	fragment NewsletterName on Newsletter {
		title
	}
`;
export const SharingPolicyDetailFragmentDoc = gql`
	fragment SharingPolicyDetail on SharingPolicy {
		id
		isPublic
		announcement {
			id
			...AnnouncementName
		}
		calendarEvent {
			id
			...CalendarEventName
		}
		newsletter {
			id
			...NewsletterName
		}
		post {
			id
			...PostName
		}
		userGroups {
			id
			...UserGroupName
		}
		users {
			id
			...UserName
		}
	}
	${AnnouncementNameFragmentDoc}
	${CalendarEventNameFragmentDoc}
	${NewsletterNameFragmentDoc}
	${PostNameFragmentDoc}
	${UserGroupNameFragmentDoc}
	${UserNameFragmentDoc}
`;
export const SharingPolicyNameFragmentDoc = gql`
	fragment SharingPolicyName on SharingPolicy {
		id
	}
`;
export const MediaAttachmentNameFragmentDoc = gql`
	fragment MediaAttachmentName on MediaAttachment {
		title
	}
`;
export const SocialCommentDetailFragmentDoc = gql`
	fragment SocialCommentDetail on SocialComment {
		id
		createdAt
		body
		author {
			id
			...UserName
		}
		mediaAttachment {
			id
			...MediaAttachmentName
		}
		newsletter {
			id
			...NewsletterName
		}
		post {
			id
			...PostName
		}
	}
	${UserNameFragmentDoc}
	${MediaAttachmentNameFragmentDoc}
	${NewsletterNameFragmentDoc}
	${PostNameFragmentDoc}
`;
export const SocialCommentNameFragmentDoc = gql`
	fragment SocialCommentName on SocialComment {
		id
	}
`;
export const SocialReactionDetailFragmentDoc = gql`
	fragment SocialReactionDetail on SocialReaction {
		id
		createdAt
		reaction
		announcement {
			id
			...AnnouncementName
		}
		author {
			id
			...UserName
		}
		mediaAttachment {
			id
			...MediaAttachmentName
		}
		newsletter {
			id
			...NewsletterName
		}
		post {
			id
			...PostName
		}
	}
	${AnnouncementNameFragmentDoc}
	${UserNameFragmentDoc}
	${MediaAttachmentNameFragmentDoc}
	${NewsletterNameFragmentDoc}
	${PostNameFragmentDoc}
`;
export const SocialReactionNameFragmentDoc = gql`
	fragment SocialReactionName on SocialReaction {
		id
	}
`;
export const UserDetailFragmentDoc = gql`
	fragment UserDetail on User {
		id
		imageURL
		imageKey
		imageContentType
		name
		publicName
		givenName
		middleName
		familyName
		nameOrder
		publicNameFormat
		organizationName
		gender
		pronouns
		dateOfBirth
		email
		status
		passwordUpdatedAt
		isCurrent
		timeZoneName
		externalNotificationFrequency
		permissionGroups {
			id
			...PermissionGroupName
		}
	}
	${PermissionGroupNameFragmentDoc}
`;
export const UserGroupDetailFragmentDoc = gql`
	fragment UserGroupDetail on UserGroup {
		id
		name
		description
		color
		isPublic
		users {
			id
			...UserName
		}
	}
	${UserNameFragmentDoc}
`;
export const UserViewRecordDetailFragmentDoc = gql`
	fragment UserViewRecordDetail on UserViewRecord {
		id
		targetID
		firstViewedAt
		lastViewedAt
		user {
			id
			...UserName
		}
	}
	${UserNameFragmentDoc}
`;
export const UserViewRecordNameFragmentDoc = gql`
	fragment UserViewRecordName on UserViewRecord {
		id
	}
`;
export const AnnouncementCountDocument = gql`
	query announcementCount($filters: [AnnouncementFilterInput!], $pagination: Pagination, $order: AnnouncementOrder) {
		announcementConnection(filters: $filters, pagination: $pagination, order: $order) {
			totalCount
		}
	}
`;

/**
 * __useAnnouncementCountQuery__
 *
 * To run a query within a React component, call `useAnnouncementCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useAnnouncementCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAnnouncementCountQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useAnnouncementCountQuery(
	baseOptions?: Apollo.QueryHookOptions<AnnouncementCountQuery, AnnouncementCountQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<AnnouncementCountQuery, AnnouncementCountQueryVariables>(AnnouncementCountDocument, options);
}
export function useAnnouncementCountLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<AnnouncementCountQuery, AnnouncementCountQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<AnnouncementCountQuery, AnnouncementCountQueryVariables>(
		AnnouncementCountDocument,
		options,
	);
}
export function useAnnouncementCountSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<AnnouncementCountQuery, AnnouncementCountQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<AnnouncementCountQuery, AnnouncementCountQueryVariables>(
		AnnouncementCountDocument,
		options,
	);
}
export type AnnouncementCountQueryHookResult = ReturnType<typeof useAnnouncementCountQuery>;
export type AnnouncementCountLazyQueryHookResult = ReturnType<typeof useAnnouncementCountLazyQuery>;
export type AnnouncementCountSuspenseQueryHookResult = ReturnType<typeof useAnnouncementCountSuspenseQuery>;
export type AnnouncementCountQueryResult = Apollo.QueryResult<AnnouncementCountQuery, AnnouncementCountQueryVariables>;
export const AnnouncementCreateDocument = gql`
	mutation announcementCreate($input: AnnouncementCreateInput!) {
		createAnnouncement(input: $input) {
			...AnnouncementDetail
		}
	}
	${AnnouncementDetailFragmentDoc}
`;
export type AnnouncementCreateMutationFn = Apollo.MutationFunction<
	AnnouncementCreateMutation,
	AnnouncementCreateMutationVariables
>;

/**
 * __useAnnouncementCreateMutation__
 *
 * To run a mutation, you first call `useAnnouncementCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAnnouncementCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [announcementCreateMutation, { data, loading, error }] = useAnnouncementCreateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAnnouncementCreateMutation(
	baseOptions?: Apollo.MutationHookOptions<AnnouncementCreateMutation, AnnouncementCreateMutationVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<AnnouncementCreateMutation, AnnouncementCreateMutationVariables>(
		AnnouncementCreateDocument,
		options,
	);
}
export type AnnouncementCreateMutationHookResult = ReturnType<typeof useAnnouncementCreateMutation>;
export type AnnouncementCreateMutationResult = Apollo.MutationResult<AnnouncementCreateMutation>;
export type AnnouncementCreateMutationOptions = Apollo.BaseMutationOptions<
	AnnouncementCreateMutation,
	AnnouncementCreateMutationVariables
>;
export const AnnouncementDeleteDocument = gql`
	mutation announcementDelete($id: ID!) {
		deleteAnnouncement(id: $id)
	}
`;
export type AnnouncementDeleteMutationFn = Apollo.MutationFunction<
	AnnouncementDeleteMutation,
	AnnouncementDeleteMutationVariables
>;

/**
 * __useAnnouncementDeleteMutation__
 *
 * To run a mutation, you first call `useAnnouncementDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAnnouncementDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [announcementDeleteMutation, { data, loading, error }] = useAnnouncementDeleteMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAnnouncementDeleteMutation(
	baseOptions?: Apollo.MutationHookOptions<AnnouncementDeleteMutation, AnnouncementDeleteMutationVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<AnnouncementDeleteMutation, AnnouncementDeleteMutationVariables>(
		AnnouncementDeleteDocument,
		options,
	);
}
export type AnnouncementDeleteMutationHookResult = ReturnType<typeof useAnnouncementDeleteMutation>;
export type AnnouncementDeleteMutationResult = Apollo.MutationResult<AnnouncementDeleteMutation>;
export type AnnouncementDeleteMutationOptions = Apollo.BaseMutationOptions<
	AnnouncementDeleteMutation,
	AnnouncementDeleteMutationVariables
>;
export const AnnouncementDetailDocument = gql`
	query announcementDetail($id: ID!) {
		announcement(id: $id) {
			...AnnouncementDetail
		}
	}
	${AnnouncementDetailFragmentDoc}
`;

/**
 * __useAnnouncementDetailQuery__
 *
 * To run a query within a React component, call `useAnnouncementDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useAnnouncementDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAnnouncementDetailQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAnnouncementDetailQuery(
	baseOptions: Apollo.QueryHookOptions<AnnouncementDetailQuery, AnnouncementDetailQueryVariables> &
		({ variables: AnnouncementDetailQueryVariables; skip?: boolean } | { skip: boolean }),
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<AnnouncementDetailQuery, AnnouncementDetailQueryVariables>(
		AnnouncementDetailDocument,
		options,
	);
}
export function useAnnouncementDetailLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<AnnouncementDetailQuery, AnnouncementDetailQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<AnnouncementDetailQuery, AnnouncementDetailQueryVariables>(
		AnnouncementDetailDocument,
		options,
	);
}
export function useAnnouncementDetailSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<AnnouncementDetailQuery, AnnouncementDetailQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<AnnouncementDetailQuery, AnnouncementDetailQueryVariables>(
		AnnouncementDetailDocument,
		options,
	);
}
export type AnnouncementDetailQueryHookResult = ReturnType<typeof useAnnouncementDetailQuery>;
export type AnnouncementDetailLazyQueryHookResult = ReturnType<typeof useAnnouncementDetailLazyQuery>;
export type AnnouncementDetailSuspenseQueryHookResult = ReturnType<typeof useAnnouncementDetailSuspenseQuery>;
export type AnnouncementDetailQueryResult = Apollo.QueryResult<
	AnnouncementDetailQuery,
	AnnouncementDetailQueryVariables
>;
export const AnnouncementHomePageListDocument = gql`
	query announcementHomePageList(
		$filters: [AnnouncementFilterInput!]
		$pagination: Pagination
		$order: AnnouncementOrder
	) {
		announcementConnection(filters: $filters, pagination: $pagination, order: $order) {
			pageInfo {
				endCursor
				hasNextPage
			}
			edges {
				node {
					id
					title
					body
					startTime
					endTime
					author {
						id
						...UserNameAndImage
					}
					mediaAttachments(order: { field: DISPLAY_ORDER, direction: ASC }) {
						id
						title
						description
						isFile
						fileURL
						fileKey
						fileContentType
						linkURL
					}
				}
			}
		}
	}
	${UserNameAndImageFragmentDoc}
`;

/**
 * __useAnnouncementHomePageListQuery__
 *
 * To run a query within a React component, call `useAnnouncementHomePageListQuery` and pass it any options that fit your needs.
 * When your component renders, `useAnnouncementHomePageListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAnnouncementHomePageListQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useAnnouncementHomePageListQuery(
	baseOptions?: Apollo.QueryHookOptions<AnnouncementHomePageListQuery, AnnouncementHomePageListQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<AnnouncementHomePageListQuery, AnnouncementHomePageListQueryVariables>(
		AnnouncementHomePageListDocument,
		options,
	);
}
export function useAnnouncementHomePageListLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<AnnouncementHomePageListQuery, AnnouncementHomePageListQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<AnnouncementHomePageListQuery, AnnouncementHomePageListQueryVariables>(
		AnnouncementHomePageListDocument,
		options,
	);
}
export function useAnnouncementHomePageListSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<AnnouncementHomePageListQuery, AnnouncementHomePageListQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<AnnouncementHomePageListQuery, AnnouncementHomePageListQueryVariables>(
		AnnouncementHomePageListDocument,
		options,
	);
}
export type AnnouncementHomePageListQueryHookResult = ReturnType<typeof useAnnouncementHomePageListQuery>;
export type AnnouncementHomePageListLazyQueryHookResult = ReturnType<typeof useAnnouncementHomePageListLazyQuery>;
export type AnnouncementHomePageListSuspenseQueryHookResult = ReturnType<
	typeof useAnnouncementHomePageListSuspenseQuery
>;
export type AnnouncementHomePageListQueryResult = Apollo.QueryResult<
	AnnouncementHomePageListQuery,
	AnnouncementHomePageListQueryVariables
>;
export const AnnouncementCommunicationCenterPageListDocument = gql`
	query announcementCommunicationCenterPageList(
		$filters: [AnnouncementFilterInput!]
		$pagination: Pagination
		$order: AnnouncementOrder
	) {
		announcementConnection(filters: $filters, pagination: $pagination, order: $order) {
			edges {
				node {
					id
					title
					body
					startTime
					endTime
					author {
						id
						...UserNameAndImage
					}
					mediaAttachments(order: { field: DISPLAY_ORDER, direction: ASC }) {
						id
						title
						description
						isFile
						fileURL
						fileKey
						fileContentType
						linkURL
					}
				}
			}
		}
	}
	${UserNameAndImageFragmentDoc}
`;

/**
 * __useAnnouncementCommunicationCenterPageListQuery__
 *
 * To run a query within a React component, call `useAnnouncementCommunicationCenterPageListQuery` and pass it any options that fit your needs.
 * When your component renders, `useAnnouncementCommunicationCenterPageListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAnnouncementCommunicationCenterPageListQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useAnnouncementCommunicationCenterPageListQuery(
	baseOptions?: Apollo.QueryHookOptions<
		AnnouncementCommunicationCenterPageListQuery,
		AnnouncementCommunicationCenterPageListQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<
		AnnouncementCommunicationCenterPageListQuery,
		AnnouncementCommunicationCenterPageListQueryVariables
	>(AnnouncementCommunicationCenterPageListDocument, options);
}
export function useAnnouncementCommunicationCenterPageListLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		AnnouncementCommunicationCenterPageListQuery,
		AnnouncementCommunicationCenterPageListQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		AnnouncementCommunicationCenterPageListQuery,
		AnnouncementCommunicationCenterPageListQueryVariables
	>(AnnouncementCommunicationCenterPageListDocument, options);
}
export function useAnnouncementCommunicationCenterPageListSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		AnnouncementCommunicationCenterPageListQuery,
		AnnouncementCommunicationCenterPageListQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<
		AnnouncementCommunicationCenterPageListQuery,
		AnnouncementCommunicationCenterPageListQueryVariables
	>(AnnouncementCommunicationCenterPageListDocument, options);
}
export type AnnouncementCommunicationCenterPageListQueryHookResult = ReturnType<
	typeof useAnnouncementCommunicationCenterPageListQuery
>;
export type AnnouncementCommunicationCenterPageListLazyQueryHookResult = ReturnType<
	typeof useAnnouncementCommunicationCenterPageListLazyQuery
>;
export type AnnouncementCommunicationCenterPageListSuspenseQueryHookResult = ReturnType<
	typeof useAnnouncementCommunicationCenterPageListSuspenseQuery
>;
export type AnnouncementCommunicationCenterPageListQueryResult = Apollo.QueryResult<
	AnnouncementCommunicationCenterPageListQuery,
	AnnouncementCommunicationCenterPageListQueryVariables
>;
export const AnnouncementIndexDocument = gql`
	query announcementIndex($filters: [AnnouncementFilterInput!], $pagination: Pagination, $order: AnnouncementOrder) {
		announcementConnection(filters: $filters, pagination: $pagination, order: $order) {
			edges {
				node {
					id
					title
					body
					startTime
					endTime
					author {
						id
						...UserName
					}
				}
			}
		}
	}
	${UserNameFragmentDoc}
`;

/**
 * __useAnnouncementIndexQuery__
 *
 * To run a query within a React component, call `useAnnouncementIndexQuery` and pass it any options that fit your needs.
 * When your component renders, `useAnnouncementIndexQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAnnouncementIndexQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useAnnouncementIndexQuery(
	baseOptions?: Apollo.QueryHookOptions<AnnouncementIndexQuery, AnnouncementIndexQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<AnnouncementIndexQuery, AnnouncementIndexQueryVariables>(AnnouncementIndexDocument, options);
}
export function useAnnouncementIndexLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<AnnouncementIndexQuery, AnnouncementIndexQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<AnnouncementIndexQuery, AnnouncementIndexQueryVariables>(
		AnnouncementIndexDocument,
		options,
	);
}
export function useAnnouncementIndexSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<AnnouncementIndexQuery, AnnouncementIndexQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<AnnouncementIndexQuery, AnnouncementIndexQueryVariables>(
		AnnouncementIndexDocument,
		options,
	);
}
export type AnnouncementIndexQueryHookResult = ReturnType<typeof useAnnouncementIndexQuery>;
export type AnnouncementIndexLazyQueryHookResult = ReturnType<typeof useAnnouncementIndexLazyQuery>;
export type AnnouncementIndexSuspenseQueryHookResult = ReturnType<typeof useAnnouncementIndexSuspenseQuery>;
export type AnnouncementIndexQueryResult = Apollo.QueryResult<AnnouncementIndexQuery, AnnouncementIndexQueryVariables>;
export const AnnouncementNameDocument = gql`
	query announcementName($id: ID!) {
		announcement(id: $id) {
			id
			...AnnouncementName
		}
	}
	${AnnouncementNameFragmentDoc}
`;

/**
 * __useAnnouncementNameQuery__
 *
 * To run a query within a React component, call `useAnnouncementNameQuery` and pass it any options that fit your needs.
 * When your component renders, `useAnnouncementNameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAnnouncementNameQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAnnouncementNameQuery(
	baseOptions: Apollo.QueryHookOptions<AnnouncementNameQuery, AnnouncementNameQueryVariables> &
		({ variables: AnnouncementNameQueryVariables; skip?: boolean } | { skip: boolean }),
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<AnnouncementNameQuery, AnnouncementNameQueryVariables>(AnnouncementNameDocument, options);
}
export function useAnnouncementNameLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<AnnouncementNameQuery, AnnouncementNameQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<AnnouncementNameQuery, AnnouncementNameQueryVariables>(AnnouncementNameDocument, options);
}
export function useAnnouncementNameSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<AnnouncementNameQuery, AnnouncementNameQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<AnnouncementNameQuery, AnnouncementNameQueryVariables>(
		AnnouncementNameDocument,
		options,
	);
}
export type AnnouncementNameQueryHookResult = ReturnType<typeof useAnnouncementNameQuery>;
export type AnnouncementNameLazyQueryHookResult = ReturnType<typeof useAnnouncementNameLazyQuery>;
export type AnnouncementNameSuspenseQueryHookResult = ReturnType<typeof useAnnouncementNameSuspenseQuery>;
export type AnnouncementNameQueryResult = Apollo.QueryResult<AnnouncementNameQuery, AnnouncementNameQueryVariables>;
export const AnnouncementNamesDocument = gql`
	query announcementNames($filters: [AnnouncementFilterInput!], $pagination: Pagination, $order: AnnouncementOrder) {
		announcementConnection(filters: $filters, pagination: $pagination, order: $order) {
			edges {
				node {
					id
					...AnnouncementName
				}
			}
		}
	}
	${AnnouncementNameFragmentDoc}
`;

/**
 * __useAnnouncementNamesQuery__
 *
 * To run a query within a React component, call `useAnnouncementNamesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAnnouncementNamesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAnnouncementNamesQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useAnnouncementNamesQuery(
	baseOptions?: Apollo.QueryHookOptions<AnnouncementNamesQuery, AnnouncementNamesQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<AnnouncementNamesQuery, AnnouncementNamesQueryVariables>(AnnouncementNamesDocument, options);
}
export function useAnnouncementNamesLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<AnnouncementNamesQuery, AnnouncementNamesQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<AnnouncementNamesQuery, AnnouncementNamesQueryVariables>(
		AnnouncementNamesDocument,
		options,
	);
}
export function useAnnouncementNamesSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<AnnouncementNamesQuery, AnnouncementNamesQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<AnnouncementNamesQuery, AnnouncementNamesQueryVariables>(
		AnnouncementNamesDocument,
		options,
	);
}
export type AnnouncementNamesQueryHookResult = ReturnType<typeof useAnnouncementNamesQuery>;
export type AnnouncementNamesLazyQueryHookResult = ReturnType<typeof useAnnouncementNamesLazyQuery>;
export type AnnouncementNamesSuspenseQueryHookResult = ReturnType<typeof useAnnouncementNamesSuspenseQuery>;
export type AnnouncementNamesQueryResult = Apollo.QueryResult<AnnouncementNamesQuery, AnnouncementNamesQueryVariables>;
export const AnnouncementPaginationDocument = gql`
	query announcementPagination($filters: [AnnouncementFilterInput!], $order: AnnouncementOrder) {
		announcementConnection(filters: $filters, order: $order) {
			totalCount
			edges {
				cursor
			}
		}
	}
`;

/**
 * __useAnnouncementPaginationQuery__
 *
 * To run a query within a React component, call `useAnnouncementPaginationQuery` and pass it any options that fit your needs.
 * When your component renders, `useAnnouncementPaginationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAnnouncementPaginationQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useAnnouncementPaginationQuery(
	baseOptions?: Apollo.QueryHookOptions<AnnouncementPaginationQuery, AnnouncementPaginationQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<AnnouncementPaginationQuery, AnnouncementPaginationQueryVariables>(
		AnnouncementPaginationDocument,
		options,
	);
}
export function useAnnouncementPaginationLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<AnnouncementPaginationQuery, AnnouncementPaginationQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<AnnouncementPaginationQuery, AnnouncementPaginationQueryVariables>(
		AnnouncementPaginationDocument,
		options,
	);
}
export function useAnnouncementPaginationSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<AnnouncementPaginationQuery, AnnouncementPaginationQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<AnnouncementPaginationQuery, AnnouncementPaginationQueryVariables>(
		AnnouncementPaginationDocument,
		options,
	);
}
export type AnnouncementPaginationQueryHookResult = ReturnType<typeof useAnnouncementPaginationQuery>;
export type AnnouncementPaginationLazyQueryHookResult = ReturnType<typeof useAnnouncementPaginationLazyQuery>;
export type AnnouncementPaginationSuspenseQueryHookResult = ReturnType<typeof useAnnouncementPaginationSuspenseQuery>;
export type AnnouncementPaginationQueryResult = Apollo.QueryResult<
	AnnouncementPaginationQuery,
	AnnouncementPaginationQueryVariables
>;
export const AnnouncementSelectDocument = gql`
	query announcementSelect($filters: [AnnouncementFilterInput!], $order: AnnouncementOrder) {
		announcementConnection(filters: $filters, order: $order) {
			edges {
				node {
					id
					...AnnouncementName
				}
			}
		}
	}
	${AnnouncementNameFragmentDoc}
`;

/**
 * __useAnnouncementSelectQuery__
 *
 * To run a query within a React component, call `useAnnouncementSelectQuery` and pass it any options that fit your needs.
 * When your component renders, `useAnnouncementSelectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAnnouncementSelectQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useAnnouncementSelectQuery(
	baseOptions?: Apollo.QueryHookOptions<AnnouncementSelectQuery, AnnouncementSelectQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<AnnouncementSelectQuery, AnnouncementSelectQueryVariables>(
		AnnouncementSelectDocument,
		options,
	);
}
export function useAnnouncementSelectLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<AnnouncementSelectQuery, AnnouncementSelectQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<AnnouncementSelectQuery, AnnouncementSelectQueryVariables>(
		AnnouncementSelectDocument,
		options,
	);
}
export function useAnnouncementSelectSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<AnnouncementSelectQuery, AnnouncementSelectQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<AnnouncementSelectQuery, AnnouncementSelectQueryVariables>(
		AnnouncementSelectDocument,
		options,
	);
}
export type AnnouncementSelectQueryHookResult = ReturnType<typeof useAnnouncementSelectQuery>;
export type AnnouncementSelectLazyQueryHookResult = ReturnType<typeof useAnnouncementSelectLazyQuery>;
export type AnnouncementSelectSuspenseQueryHookResult = ReturnType<typeof useAnnouncementSelectSuspenseQuery>;
export type AnnouncementSelectQueryResult = Apollo.QueryResult<
	AnnouncementSelectQuery,
	AnnouncementSelectQueryVariables
>;
export const AnnouncementSocialItemsDocument = gql`
	query announcementSocialItems($id: ID!) {
		announcement(id: $id) {
			id
			socialReactions(order: { field: CREATED_AT, direction: DESC }) {
				id
				reaction
				author {
					id
					...UserName
					isCurrent
				}
			}
		}
	}
	${UserNameFragmentDoc}
`;

/**
 * __useAnnouncementSocialItemsQuery__
 *
 * To run a query within a React component, call `useAnnouncementSocialItemsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAnnouncementSocialItemsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAnnouncementSocialItemsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAnnouncementSocialItemsQuery(
	baseOptions: Apollo.QueryHookOptions<AnnouncementSocialItemsQuery, AnnouncementSocialItemsQueryVariables> &
		({ variables: AnnouncementSocialItemsQueryVariables; skip?: boolean } | { skip: boolean }),
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<AnnouncementSocialItemsQuery, AnnouncementSocialItemsQueryVariables>(
		AnnouncementSocialItemsDocument,
		options,
	);
}
export function useAnnouncementSocialItemsLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<AnnouncementSocialItemsQuery, AnnouncementSocialItemsQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<AnnouncementSocialItemsQuery, AnnouncementSocialItemsQueryVariables>(
		AnnouncementSocialItemsDocument,
		options,
	);
}
export function useAnnouncementSocialItemsSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<AnnouncementSocialItemsQuery, AnnouncementSocialItemsQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<AnnouncementSocialItemsQuery, AnnouncementSocialItemsQueryVariables>(
		AnnouncementSocialItemsDocument,
		options,
	);
}
export type AnnouncementSocialItemsQueryHookResult = ReturnType<typeof useAnnouncementSocialItemsQuery>;
export type AnnouncementSocialItemsLazyQueryHookResult = ReturnType<typeof useAnnouncementSocialItemsLazyQuery>;
export type AnnouncementSocialItemsSuspenseQueryHookResult = ReturnType<typeof useAnnouncementSocialItemsSuspenseQuery>;
export type AnnouncementSocialItemsQueryResult = Apollo.QueryResult<
	AnnouncementSocialItemsQuery,
	AnnouncementSocialItemsQueryVariables
>;
export const AnnouncementStatisticsDocument = gql`
	query announcementStatistics($filters: [AnnouncementFilterInput!]) {
		announcementStatistics(filters: $filters) {
			count
			views
			reactions
		}
	}
`;

/**
 * __useAnnouncementStatisticsQuery__
 *
 * To run a query within a React component, call `useAnnouncementStatisticsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAnnouncementStatisticsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAnnouncementStatisticsQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useAnnouncementStatisticsQuery(
	baseOptions?: Apollo.QueryHookOptions<AnnouncementStatisticsQuery, AnnouncementStatisticsQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<AnnouncementStatisticsQuery, AnnouncementStatisticsQueryVariables>(
		AnnouncementStatisticsDocument,
		options,
	);
}
export function useAnnouncementStatisticsLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<AnnouncementStatisticsQuery, AnnouncementStatisticsQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<AnnouncementStatisticsQuery, AnnouncementStatisticsQueryVariables>(
		AnnouncementStatisticsDocument,
		options,
	);
}
export function useAnnouncementStatisticsSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<AnnouncementStatisticsQuery, AnnouncementStatisticsQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<AnnouncementStatisticsQuery, AnnouncementStatisticsQueryVariables>(
		AnnouncementStatisticsDocument,
		options,
	);
}
export type AnnouncementStatisticsQueryHookResult = ReturnType<typeof useAnnouncementStatisticsQuery>;
export type AnnouncementStatisticsLazyQueryHookResult = ReturnType<typeof useAnnouncementStatisticsLazyQuery>;
export type AnnouncementStatisticsSuspenseQueryHookResult = ReturnType<typeof useAnnouncementStatisticsSuspenseQuery>;
export type AnnouncementStatisticsQueryResult = Apollo.QueryResult<
	AnnouncementStatisticsQuery,
	AnnouncementStatisticsQueryVariables
>;
export const AnnouncementUpdateDocument = gql`
	mutation announcementUpdate($id: ID!, $input: AnnouncementUpdateInput!) {
		updateAnnouncement(id: $id, input: $input) {
			...AnnouncementDetail
		}
	}
	${AnnouncementDetailFragmentDoc}
`;
export type AnnouncementUpdateMutationFn = Apollo.MutationFunction<
	AnnouncementUpdateMutation,
	AnnouncementUpdateMutationVariables
>;

/**
 * __useAnnouncementUpdateMutation__
 *
 * To run a mutation, you first call `useAnnouncementUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAnnouncementUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [announcementUpdateMutation, { data, loading, error }] = useAnnouncementUpdateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAnnouncementUpdateMutation(
	baseOptions?: Apollo.MutationHookOptions<AnnouncementUpdateMutation, AnnouncementUpdateMutationVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<AnnouncementUpdateMutation, AnnouncementUpdateMutationVariables>(
		AnnouncementUpdateDocument,
		options,
	);
}
export type AnnouncementUpdateMutationHookResult = ReturnType<typeof useAnnouncementUpdateMutation>;
export type AnnouncementUpdateMutationResult = Apollo.MutationResult<AnnouncementUpdateMutation>;
export type AnnouncementUpdateMutationOptions = Apollo.BaseMutationOptions<
	AnnouncementUpdateMutation,
	AnnouncementUpdateMutationVariables
>;
export const CalendarEventCalendarSlimListDocument = gql`
	query calendarEventCalendarSlimList(
		$filters: [CalendarEventFilterInput!]
		$pagination: Pagination
		$order: CalendarEventOrder
	) {
		calendarEventConnection(filters: $filters, pagination: $pagination, order: $order) {
			edges {
				node {
					id
					name
					...CalendarEventTiming
					author {
						id
						isCurrent
					}
					sharingPolicy {
						id
						isPublic
						userGroups {
							id
							...UserGroupNameAndColor
						}
					}
				}
			}
		}
	}
	${CalendarEventTimingFragmentDoc}
	${UserGroupNameAndColorFragmentDoc}
`;

/**
 * __useCalendarEventCalendarSlimListQuery__
 *
 * To run a query within a React component, call `useCalendarEventCalendarSlimListQuery` and pass it any options that fit your needs.
 * When your component renders, `useCalendarEventCalendarSlimListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCalendarEventCalendarSlimListQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useCalendarEventCalendarSlimListQuery(
	baseOptions?: Apollo.QueryHookOptions<
		CalendarEventCalendarSlimListQuery,
		CalendarEventCalendarSlimListQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<CalendarEventCalendarSlimListQuery, CalendarEventCalendarSlimListQueryVariables>(
		CalendarEventCalendarSlimListDocument,
		options,
	);
}
export function useCalendarEventCalendarSlimListLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		CalendarEventCalendarSlimListQuery,
		CalendarEventCalendarSlimListQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<CalendarEventCalendarSlimListQuery, CalendarEventCalendarSlimListQueryVariables>(
		CalendarEventCalendarSlimListDocument,
		options,
	);
}
export function useCalendarEventCalendarSlimListSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		CalendarEventCalendarSlimListQuery,
		CalendarEventCalendarSlimListQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<CalendarEventCalendarSlimListQuery, CalendarEventCalendarSlimListQueryVariables>(
		CalendarEventCalendarSlimListDocument,
		options,
	);
}
export type CalendarEventCalendarSlimListQueryHookResult = ReturnType<typeof useCalendarEventCalendarSlimListQuery>;
export type CalendarEventCalendarSlimListLazyQueryHookResult = ReturnType<
	typeof useCalendarEventCalendarSlimListLazyQuery
>;
export type CalendarEventCalendarSlimListSuspenseQueryHookResult = ReturnType<
	typeof useCalendarEventCalendarSlimListSuspenseQuery
>;
export type CalendarEventCalendarSlimListQueryResult = Apollo.QueryResult<
	CalendarEventCalendarSlimListQuery,
	CalendarEventCalendarSlimListQueryVariables
>;
export const CalendarEventCalendarListDocument = gql`
	query calendarEventCalendarList(
		$filters: [CalendarEventFilterInput!]
		$pagination: Pagination
		$order: CalendarEventOrder
	) {
		calendarEventConnection(filters: $filters, pagination: $pagination, order: $order) {
			edges {
				node {
					id
					name
					description
					...CalendarEventTiming
					author {
						id
						isCurrent
					}
					sharingPolicy {
						id
						isPublic
						userGroups {
							id
							...UserGroupNameAndColor
						}
					}
				}
			}
		}
	}
	${CalendarEventTimingFragmentDoc}
	${UserGroupNameAndColorFragmentDoc}
`;

/**
 * __useCalendarEventCalendarListQuery__
 *
 * To run a query within a React component, call `useCalendarEventCalendarListQuery` and pass it any options that fit your needs.
 * When your component renders, `useCalendarEventCalendarListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCalendarEventCalendarListQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useCalendarEventCalendarListQuery(
	baseOptions?: Apollo.QueryHookOptions<CalendarEventCalendarListQuery, CalendarEventCalendarListQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<CalendarEventCalendarListQuery, CalendarEventCalendarListQueryVariables>(
		CalendarEventCalendarListDocument,
		options,
	);
}
export function useCalendarEventCalendarListLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<CalendarEventCalendarListQuery, CalendarEventCalendarListQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<CalendarEventCalendarListQuery, CalendarEventCalendarListQueryVariables>(
		CalendarEventCalendarListDocument,
		options,
	);
}
export function useCalendarEventCalendarListSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		CalendarEventCalendarListQuery,
		CalendarEventCalendarListQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<CalendarEventCalendarListQuery, CalendarEventCalendarListQueryVariables>(
		CalendarEventCalendarListDocument,
		options,
	);
}
export type CalendarEventCalendarListQueryHookResult = ReturnType<typeof useCalendarEventCalendarListQuery>;
export type CalendarEventCalendarListLazyQueryHookResult = ReturnType<typeof useCalendarEventCalendarListLazyQuery>;
export type CalendarEventCalendarListSuspenseQueryHookResult = ReturnType<
	typeof useCalendarEventCalendarListSuspenseQuery
>;
export type CalendarEventCalendarListQueryResult = Apollo.QueryResult<
	CalendarEventCalendarListQuery,
	CalendarEventCalendarListQueryVariables
>;
export const CalendarEventCalendarDetailDocument = gql`
	query calendarEventCalendarDetail($id: ID!) {
		calendarEventConnection(filters: { idEQ: $id }) {
			edges {
				node {
					...CalendarEventCalendarDetail
				}
			}
		}
	}
	${CalendarEventCalendarDetailFragmentDoc}
`;

/**
 * __useCalendarEventCalendarDetailQuery__
 *
 * To run a query within a React component, call `useCalendarEventCalendarDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useCalendarEventCalendarDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCalendarEventCalendarDetailQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCalendarEventCalendarDetailQuery(
	baseOptions: Apollo.QueryHookOptions<CalendarEventCalendarDetailQuery, CalendarEventCalendarDetailQueryVariables> &
		({ variables: CalendarEventCalendarDetailQueryVariables; skip?: boolean } | { skip: boolean }),
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<CalendarEventCalendarDetailQuery, CalendarEventCalendarDetailQueryVariables>(
		CalendarEventCalendarDetailDocument,
		options,
	);
}
export function useCalendarEventCalendarDetailLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		CalendarEventCalendarDetailQuery,
		CalendarEventCalendarDetailQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<CalendarEventCalendarDetailQuery, CalendarEventCalendarDetailQueryVariables>(
		CalendarEventCalendarDetailDocument,
		options,
	);
}
export function useCalendarEventCalendarDetailSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		CalendarEventCalendarDetailQuery,
		CalendarEventCalendarDetailQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<CalendarEventCalendarDetailQuery, CalendarEventCalendarDetailQueryVariables>(
		CalendarEventCalendarDetailDocument,
		options,
	);
}
export type CalendarEventCalendarDetailQueryHookResult = ReturnType<typeof useCalendarEventCalendarDetailQuery>;
export type CalendarEventCalendarDetailLazyQueryHookResult = ReturnType<typeof useCalendarEventCalendarDetailLazyQuery>;
export type CalendarEventCalendarDetailSuspenseQueryHookResult = ReturnType<
	typeof useCalendarEventCalendarDetailSuspenseQuery
>;
export type CalendarEventCalendarDetailQueryResult = Apollo.QueryResult<
	CalendarEventCalendarDetailQuery,
	CalendarEventCalendarDetailQueryVariables
>;
export const CalendarEventCalendarDetailedListDocument = gql`
	query calendarEventCalendarDetailedList(
		$filters: [CalendarEventFilterInput!]
		$pagination: Pagination
		$order: CalendarEventOrder
	) {
		calendarEventConnection(filters: $filters, pagination: $pagination, order: $order) {
			edges {
				node {
					...CalendarEventCalendarDetail
				}
			}
		}
	}
	${CalendarEventCalendarDetailFragmentDoc}
`;

/**
 * __useCalendarEventCalendarDetailedListQuery__
 *
 * To run a query within a React component, call `useCalendarEventCalendarDetailedListQuery` and pass it any options that fit your needs.
 * When your component renders, `useCalendarEventCalendarDetailedListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCalendarEventCalendarDetailedListQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useCalendarEventCalendarDetailedListQuery(
	baseOptions?: Apollo.QueryHookOptions<
		CalendarEventCalendarDetailedListQuery,
		CalendarEventCalendarDetailedListQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<CalendarEventCalendarDetailedListQuery, CalendarEventCalendarDetailedListQueryVariables>(
		CalendarEventCalendarDetailedListDocument,
		options,
	);
}
export function useCalendarEventCalendarDetailedListLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		CalendarEventCalendarDetailedListQuery,
		CalendarEventCalendarDetailedListQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<CalendarEventCalendarDetailedListQuery, CalendarEventCalendarDetailedListQueryVariables>(
		CalendarEventCalendarDetailedListDocument,
		options,
	);
}
export function useCalendarEventCalendarDetailedListSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		CalendarEventCalendarDetailedListQuery,
		CalendarEventCalendarDetailedListQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<
		CalendarEventCalendarDetailedListQuery,
		CalendarEventCalendarDetailedListQueryVariables
	>(CalendarEventCalendarDetailedListDocument, options);
}
export type CalendarEventCalendarDetailedListQueryHookResult = ReturnType<
	typeof useCalendarEventCalendarDetailedListQuery
>;
export type CalendarEventCalendarDetailedListLazyQueryHookResult = ReturnType<
	typeof useCalendarEventCalendarDetailedListLazyQuery
>;
export type CalendarEventCalendarDetailedListSuspenseQueryHookResult = ReturnType<
	typeof useCalendarEventCalendarDetailedListSuspenseQuery
>;
export type CalendarEventCalendarDetailedListQueryResult = Apollo.QueryResult<
	CalendarEventCalendarDetailedListQuery,
	CalendarEventCalendarDetailedListQueryVariables
>;
export const CalendarEventCountDocument = gql`
	query calendarEventCount($filters: [CalendarEventFilterInput!], $pagination: Pagination, $order: CalendarEventOrder) {
		calendarEventConnection(filters: $filters, pagination: $pagination, order: $order) {
			totalCount
		}
	}
`;

/**
 * __useCalendarEventCountQuery__
 *
 * To run a query within a React component, call `useCalendarEventCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useCalendarEventCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCalendarEventCountQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useCalendarEventCountQuery(
	baseOptions?: Apollo.QueryHookOptions<CalendarEventCountQuery, CalendarEventCountQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<CalendarEventCountQuery, CalendarEventCountQueryVariables>(
		CalendarEventCountDocument,
		options,
	);
}
export function useCalendarEventCountLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<CalendarEventCountQuery, CalendarEventCountQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<CalendarEventCountQuery, CalendarEventCountQueryVariables>(
		CalendarEventCountDocument,
		options,
	);
}
export function useCalendarEventCountSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<CalendarEventCountQuery, CalendarEventCountQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<CalendarEventCountQuery, CalendarEventCountQueryVariables>(
		CalendarEventCountDocument,
		options,
	);
}
export type CalendarEventCountQueryHookResult = ReturnType<typeof useCalendarEventCountQuery>;
export type CalendarEventCountLazyQueryHookResult = ReturnType<typeof useCalendarEventCountLazyQuery>;
export type CalendarEventCountSuspenseQueryHookResult = ReturnType<typeof useCalendarEventCountSuspenseQuery>;
export type CalendarEventCountQueryResult = Apollo.QueryResult<
	CalendarEventCountQuery,
	CalendarEventCountQueryVariables
>;
export const CalendarEventCreateDocument = gql`
	mutation calendarEventCreate($input: CalendarEventCreateInput!) {
		createCalendarEvent(input: $input) {
			...CalendarEventDetail
		}
	}
	${CalendarEventDetailFragmentDoc}
`;
export type CalendarEventCreateMutationFn = Apollo.MutationFunction<
	CalendarEventCreateMutation,
	CalendarEventCreateMutationVariables
>;

/**
 * __useCalendarEventCreateMutation__
 *
 * To run a mutation, you first call `useCalendarEventCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCalendarEventCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [calendarEventCreateMutation, { data, loading, error }] = useCalendarEventCreateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCalendarEventCreateMutation(
	baseOptions?: Apollo.MutationHookOptions<CalendarEventCreateMutation, CalendarEventCreateMutationVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<CalendarEventCreateMutation, CalendarEventCreateMutationVariables>(
		CalendarEventCreateDocument,
		options,
	);
}
export type CalendarEventCreateMutationHookResult = ReturnType<typeof useCalendarEventCreateMutation>;
export type CalendarEventCreateMutationResult = Apollo.MutationResult<CalendarEventCreateMutation>;
export type CalendarEventCreateMutationOptions = Apollo.BaseMutationOptions<
	CalendarEventCreateMutation,
	CalendarEventCreateMutationVariables
>;
export const CalendarEventDeleteDocument = gql`
	mutation calendarEventDelete($id: ID!) {
		deleteCalendarEvent(id: $id)
	}
`;
export type CalendarEventDeleteMutationFn = Apollo.MutationFunction<
	CalendarEventDeleteMutation,
	CalendarEventDeleteMutationVariables
>;

/**
 * __useCalendarEventDeleteMutation__
 *
 * To run a mutation, you first call `useCalendarEventDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCalendarEventDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [calendarEventDeleteMutation, { data, loading, error }] = useCalendarEventDeleteMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCalendarEventDeleteMutation(
	baseOptions?: Apollo.MutationHookOptions<CalendarEventDeleteMutation, CalendarEventDeleteMutationVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<CalendarEventDeleteMutation, CalendarEventDeleteMutationVariables>(
		CalendarEventDeleteDocument,
		options,
	);
}
export type CalendarEventDeleteMutationHookResult = ReturnType<typeof useCalendarEventDeleteMutation>;
export type CalendarEventDeleteMutationResult = Apollo.MutationResult<CalendarEventDeleteMutation>;
export type CalendarEventDeleteMutationOptions = Apollo.BaseMutationOptions<
	CalendarEventDeleteMutation,
	CalendarEventDeleteMutationVariables
>;
export const CalendarEventDetailDocument = gql`
	query calendarEventDetail($id: ID!) {
		calendarEvent(id: $id) {
			...CalendarEventDetail
		}
	}
	${CalendarEventDetailFragmentDoc}
`;

/**
 * __useCalendarEventDetailQuery__
 *
 * To run a query within a React component, call `useCalendarEventDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useCalendarEventDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCalendarEventDetailQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCalendarEventDetailQuery(
	baseOptions: Apollo.QueryHookOptions<CalendarEventDetailQuery, CalendarEventDetailQueryVariables> &
		({ variables: CalendarEventDetailQueryVariables; skip?: boolean } | { skip: boolean }),
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<CalendarEventDetailQuery, CalendarEventDetailQueryVariables>(
		CalendarEventDetailDocument,
		options,
	);
}
export function useCalendarEventDetailLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<CalendarEventDetailQuery, CalendarEventDetailQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<CalendarEventDetailQuery, CalendarEventDetailQueryVariables>(
		CalendarEventDetailDocument,
		options,
	);
}
export function useCalendarEventDetailSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<CalendarEventDetailQuery, CalendarEventDetailQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<CalendarEventDetailQuery, CalendarEventDetailQueryVariables>(
		CalendarEventDetailDocument,
		options,
	);
}
export type CalendarEventDetailQueryHookResult = ReturnType<typeof useCalendarEventDetailQuery>;
export type CalendarEventDetailLazyQueryHookResult = ReturnType<typeof useCalendarEventDetailLazyQuery>;
export type CalendarEventDetailSuspenseQueryHookResult = ReturnType<typeof useCalendarEventDetailSuspenseQuery>;
export type CalendarEventDetailQueryResult = Apollo.QueryResult<
	CalendarEventDetailQuery,
	CalendarEventDetailQueryVariables
>;
export const CalendarEventIndexDocument = gql`
	query calendarEventIndex($filters: [CalendarEventFilterInput!], $pagination: Pagination, $order: CalendarEventOrder) {
		calendarEventConnection(filters: $filters, pagination: $pagination, order: $order) {
			edges {
				node {
					id
					name
					description
					location
					imageURL
					imageContentType
					isAllDay
					startTime
					endTime
					startDate
					isMultiDay
					endDate
					allowsResponses
					createdAt
				}
			}
		}
	}
`;

/**
 * __useCalendarEventIndexQuery__
 *
 * To run a query within a React component, call `useCalendarEventIndexQuery` and pass it any options that fit your needs.
 * When your component renders, `useCalendarEventIndexQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCalendarEventIndexQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useCalendarEventIndexQuery(
	baseOptions?: Apollo.QueryHookOptions<CalendarEventIndexQuery, CalendarEventIndexQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<CalendarEventIndexQuery, CalendarEventIndexQueryVariables>(
		CalendarEventIndexDocument,
		options,
	);
}
export function useCalendarEventIndexLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<CalendarEventIndexQuery, CalendarEventIndexQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<CalendarEventIndexQuery, CalendarEventIndexQueryVariables>(
		CalendarEventIndexDocument,
		options,
	);
}
export function useCalendarEventIndexSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<CalendarEventIndexQuery, CalendarEventIndexQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<CalendarEventIndexQuery, CalendarEventIndexQueryVariables>(
		CalendarEventIndexDocument,
		options,
	);
}
export type CalendarEventIndexQueryHookResult = ReturnType<typeof useCalendarEventIndexQuery>;
export type CalendarEventIndexLazyQueryHookResult = ReturnType<typeof useCalendarEventIndexLazyQuery>;
export type CalendarEventIndexSuspenseQueryHookResult = ReturnType<typeof useCalendarEventIndexSuspenseQuery>;
export type CalendarEventIndexQueryResult = Apollo.QueryResult<
	CalendarEventIndexQuery,
	CalendarEventIndexQueryVariables
>;
export const CalendarEventNameDocument = gql`
	query calendarEventName($id: ID!) {
		calendarEvent(id: $id) {
			id
			...CalendarEventName
		}
	}
	${CalendarEventNameFragmentDoc}
`;

/**
 * __useCalendarEventNameQuery__
 *
 * To run a query within a React component, call `useCalendarEventNameQuery` and pass it any options that fit your needs.
 * When your component renders, `useCalendarEventNameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCalendarEventNameQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCalendarEventNameQuery(
	baseOptions: Apollo.QueryHookOptions<CalendarEventNameQuery, CalendarEventNameQueryVariables> &
		({ variables: CalendarEventNameQueryVariables; skip?: boolean } | { skip: boolean }),
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<CalendarEventNameQuery, CalendarEventNameQueryVariables>(CalendarEventNameDocument, options);
}
export function useCalendarEventNameLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<CalendarEventNameQuery, CalendarEventNameQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<CalendarEventNameQuery, CalendarEventNameQueryVariables>(
		CalendarEventNameDocument,
		options,
	);
}
export function useCalendarEventNameSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<CalendarEventNameQuery, CalendarEventNameQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<CalendarEventNameQuery, CalendarEventNameQueryVariables>(
		CalendarEventNameDocument,
		options,
	);
}
export type CalendarEventNameQueryHookResult = ReturnType<typeof useCalendarEventNameQuery>;
export type CalendarEventNameLazyQueryHookResult = ReturnType<typeof useCalendarEventNameLazyQuery>;
export type CalendarEventNameSuspenseQueryHookResult = ReturnType<typeof useCalendarEventNameSuspenseQuery>;
export type CalendarEventNameQueryResult = Apollo.QueryResult<CalendarEventNameQuery, CalendarEventNameQueryVariables>;
export const CalendarEventNamesDocument = gql`
	query calendarEventNames($filters: [CalendarEventFilterInput!], $pagination: Pagination, $order: CalendarEventOrder) {
		calendarEventConnection(filters: $filters, pagination: $pagination, order: $order) {
			edges {
				node {
					id
					...CalendarEventName
				}
			}
		}
	}
	${CalendarEventNameFragmentDoc}
`;

/**
 * __useCalendarEventNamesQuery__
 *
 * To run a query within a React component, call `useCalendarEventNamesQuery` and pass it any options that fit your needs.
 * When your component renders, `useCalendarEventNamesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCalendarEventNamesQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useCalendarEventNamesQuery(
	baseOptions?: Apollo.QueryHookOptions<CalendarEventNamesQuery, CalendarEventNamesQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<CalendarEventNamesQuery, CalendarEventNamesQueryVariables>(
		CalendarEventNamesDocument,
		options,
	);
}
export function useCalendarEventNamesLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<CalendarEventNamesQuery, CalendarEventNamesQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<CalendarEventNamesQuery, CalendarEventNamesQueryVariables>(
		CalendarEventNamesDocument,
		options,
	);
}
export function useCalendarEventNamesSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<CalendarEventNamesQuery, CalendarEventNamesQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<CalendarEventNamesQuery, CalendarEventNamesQueryVariables>(
		CalendarEventNamesDocument,
		options,
	);
}
export type CalendarEventNamesQueryHookResult = ReturnType<typeof useCalendarEventNamesQuery>;
export type CalendarEventNamesLazyQueryHookResult = ReturnType<typeof useCalendarEventNamesLazyQuery>;
export type CalendarEventNamesSuspenseQueryHookResult = ReturnType<typeof useCalendarEventNamesSuspenseQuery>;
export type CalendarEventNamesQueryResult = Apollo.QueryResult<
	CalendarEventNamesQuery,
	CalendarEventNamesQueryVariables
>;
export const CalendarEventPaginationDocument = gql`
	query calendarEventPagination($filters: [CalendarEventFilterInput!], $order: CalendarEventOrder) {
		calendarEventConnection(filters: $filters, order: $order) {
			totalCount
			edges {
				cursor
			}
		}
	}
`;

/**
 * __useCalendarEventPaginationQuery__
 *
 * To run a query within a React component, call `useCalendarEventPaginationQuery` and pass it any options that fit your needs.
 * When your component renders, `useCalendarEventPaginationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCalendarEventPaginationQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useCalendarEventPaginationQuery(
	baseOptions?: Apollo.QueryHookOptions<CalendarEventPaginationQuery, CalendarEventPaginationQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<CalendarEventPaginationQuery, CalendarEventPaginationQueryVariables>(
		CalendarEventPaginationDocument,
		options,
	);
}
export function useCalendarEventPaginationLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<CalendarEventPaginationQuery, CalendarEventPaginationQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<CalendarEventPaginationQuery, CalendarEventPaginationQueryVariables>(
		CalendarEventPaginationDocument,
		options,
	);
}
export function useCalendarEventPaginationSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<CalendarEventPaginationQuery, CalendarEventPaginationQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<CalendarEventPaginationQuery, CalendarEventPaginationQueryVariables>(
		CalendarEventPaginationDocument,
		options,
	);
}
export type CalendarEventPaginationQueryHookResult = ReturnType<typeof useCalendarEventPaginationQuery>;
export type CalendarEventPaginationLazyQueryHookResult = ReturnType<typeof useCalendarEventPaginationLazyQuery>;
export type CalendarEventPaginationSuspenseQueryHookResult = ReturnType<typeof useCalendarEventPaginationSuspenseQuery>;
export type CalendarEventPaginationQueryResult = Apollo.QueryResult<
	CalendarEventPaginationQuery,
	CalendarEventPaginationQueryVariables
>;
export const CalendarEventSelectDocument = gql`
	query calendarEventSelect($filters: [CalendarEventFilterInput!], $order: CalendarEventOrder) {
		calendarEventConnection(filters: $filters, order: $order) {
			edges {
				node {
					id
					...CalendarEventName
				}
			}
		}
	}
	${CalendarEventNameFragmentDoc}
`;

/**
 * __useCalendarEventSelectQuery__
 *
 * To run a query within a React component, call `useCalendarEventSelectQuery` and pass it any options that fit your needs.
 * When your component renders, `useCalendarEventSelectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCalendarEventSelectQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useCalendarEventSelectQuery(
	baseOptions?: Apollo.QueryHookOptions<CalendarEventSelectQuery, CalendarEventSelectQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<CalendarEventSelectQuery, CalendarEventSelectQueryVariables>(
		CalendarEventSelectDocument,
		options,
	);
}
export function useCalendarEventSelectLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<CalendarEventSelectQuery, CalendarEventSelectQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<CalendarEventSelectQuery, CalendarEventSelectQueryVariables>(
		CalendarEventSelectDocument,
		options,
	);
}
export function useCalendarEventSelectSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<CalendarEventSelectQuery, CalendarEventSelectQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<CalendarEventSelectQuery, CalendarEventSelectQueryVariables>(
		CalendarEventSelectDocument,
		options,
	);
}
export type CalendarEventSelectQueryHookResult = ReturnType<typeof useCalendarEventSelectQuery>;
export type CalendarEventSelectLazyQueryHookResult = ReturnType<typeof useCalendarEventSelectLazyQuery>;
export type CalendarEventSelectSuspenseQueryHookResult = ReturnType<typeof useCalendarEventSelectSuspenseQuery>;
export type CalendarEventSelectQueryResult = Apollo.QueryResult<
	CalendarEventSelectQuery,
	CalendarEventSelectQueryVariables
>;
export const CalendarEventStatisticsDocument = gql`
	query calendarEventStatistics($filters: [CalendarEventFilterInput!]) {
		calendarEventStatistics(filters: $filters) {
			count
			responsesAttending
			responsesMaybeAttending
			responsesNotAttending
		}
	}
`;

/**
 * __useCalendarEventStatisticsQuery__
 *
 * To run a query within a React component, call `useCalendarEventStatisticsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCalendarEventStatisticsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCalendarEventStatisticsQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useCalendarEventStatisticsQuery(
	baseOptions?: Apollo.QueryHookOptions<CalendarEventStatisticsQuery, CalendarEventStatisticsQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<CalendarEventStatisticsQuery, CalendarEventStatisticsQueryVariables>(
		CalendarEventStatisticsDocument,
		options,
	);
}
export function useCalendarEventStatisticsLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<CalendarEventStatisticsQuery, CalendarEventStatisticsQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<CalendarEventStatisticsQuery, CalendarEventStatisticsQueryVariables>(
		CalendarEventStatisticsDocument,
		options,
	);
}
export function useCalendarEventStatisticsSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<CalendarEventStatisticsQuery, CalendarEventStatisticsQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<CalendarEventStatisticsQuery, CalendarEventStatisticsQueryVariables>(
		CalendarEventStatisticsDocument,
		options,
	);
}
export type CalendarEventStatisticsQueryHookResult = ReturnType<typeof useCalendarEventStatisticsQuery>;
export type CalendarEventStatisticsLazyQueryHookResult = ReturnType<typeof useCalendarEventStatisticsLazyQuery>;
export type CalendarEventStatisticsSuspenseQueryHookResult = ReturnType<typeof useCalendarEventStatisticsSuspenseQuery>;
export type CalendarEventStatisticsQueryResult = Apollo.QueryResult<
	CalendarEventStatisticsQuery,
	CalendarEventStatisticsQueryVariables
>;
export const CalendarEventListDocument = gql`
	query calendarEventList($filters: [CalendarEventFilterInput!], $pagination: Pagination, $order: CalendarEventOrder) {
		calendarEventConnection(filters: $filters, pagination: $pagination, order: $order) {
			edges {
				node {
					id
					name
					imageURL
					imageContentType
					isAllDay
					startTime
					endTime
					startDate
					endDate
					allowsResponses
					calendarEventResponses(filters: { author: { isCurrentEQ: true } }) {
						id
						response
					}
				}
			}
		}
	}
`;

/**
 * __useCalendarEventListQuery__
 *
 * To run a query within a React component, call `useCalendarEventListQuery` and pass it any options that fit your needs.
 * When your component renders, `useCalendarEventListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCalendarEventListQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useCalendarEventListQuery(
	baseOptions?: Apollo.QueryHookOptions<CalendarEventListQuery, CalendarEventListQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<CalendarEventListQuery, CalendarEventListQueryVariables>(CalendarEventListDocument, options);
}
export function useCalendarEventListLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<CalendarEventListQuery, CalendarEventListQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<CalendarEventListQuery, CalendarEventListQueryVariables>(
		CalendarEventListDocument,
		options,
	);
}
export function useCalendarEventListSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<CalendarEventListQuery, CalendarEventListQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<CalendarEventListQuery, CalendarEventListQueryVariables>(
		CalendarEventListDocument,
		options,
	);
}
export type CalendarEventListQueryHookResult = ReturnType<typeof useCalendarEventListQuery>;
export type CalendarEventListLazyQueryHookResult = ReturnType<typeof useCalendarEventListLazyQuery>;
export type CalendarEventListSuspenseQueryHookResult = ReturnType<typeof useCalendarEventListSuspenseQuery>;
export type CalendarEventListQueryResult = Apollo.QueryResult<CalendarEventListQuery, CalendarEventListQueryVariables>;
export const CalendarEventUpdateDocument = gql`
	mutation calendarEventUpdate($id: ID!, $input: CalendarEventUpdateInput!) {
		updateCalendarEvent(id: $id, input: $input) {
			...CalendarEventDetail
		}
	}
	${CalendarEventDetailFragmentDoc}
`;
export type CalendarEventUpdateMutationFn = Apollo.MutationFunction<
	CalendarEventUpdateMutation,
	CalendarEventUpdateMutationVariables
>;

/**
 * __useCalendarEventUpdateMutation__
 *
 * To run a mutation, you first call `useCalendarEventUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCalendarEventUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [calendarEventUpdateMutation, { data, loading, error }] = useCalendarEventUpdateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCalendarEventUpdateMutation(
	baseOptions?: Apollo.MutationHookOptions<CalendarEventUpdateMutation, CalendarEventUpdateMutationVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<CalendarEventUpdateMutation, CalendarEventUpdateMutationVariables>(
		CalendarEventUpdateDocument,
		options,
	);
}
export type CalendarEventUpdateMutationHookResult = ReturnType<typeof useCalendarEventUpdateMutation>;
export type CalendarEventUpdateMutationResult = Apollo.MutationResult<CalendarEventUpdateMutation>;
export type CalendarEventUpdateMutationOptions = Apollo.BaseMutationOptions<
	CalendarEventUpdateMutation,
	CalendarEventUpdateMutationVariables
>;
export const CalendarEventUserListDocument = gql`
	query calendarEventUserList($calendarEventID: ID!, $pagination: Pagination, $order: UserOrder) {
		userConnection(
			filters: {
				or: [
					{
						sharedSharingPolicies: { calendarEventIDEQ: $calendarEventID }
						not: {
							authoredCalendarEventResponses: [{ calendarEventIDEQ: $calendarEventID, responseEQ: not_attending }]
						}
					}
					{ authoredCalendarEventResponses: [{ calendarEventIDEQ: $calendarEventID, responseNEQ: not_attending }] }
				]
			}
			pagination: $pagination
			order: $order
		) {
			totalCount
			pageInfo {
				hasNextPage
				endCursor
			}
			edges {
				node {
					id
					...UserNameAndImage
					authoredCalendarEventResponses(filters: { calendarEventIDEQ: $calendarEventID }) {
						id
						response
					}
				}
			}
		}
	}
	${UserNameAndImageFragmentDoc}
`;

/**
 * __useCalendarEventUserListQuery__
 *
 * To run a query within a React component, call `useCalendarEventUserListQuery` and pass it any options that fit your needs.
 * When your component renders, `useCalendarEventUserListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCalendarEventUserListQuery({
 *   variables: {
 *      calendarEventID: // value for 'calendarEventID'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useCalendarEventUserListQuery(
	baseOptions: Apollo.QueryHookOptions<CalendarEventUserListQuery, CalendarEventUserListQueryVariables> &
		({ variables: CalendarEventUserListQueryVariables; skip?: boolean } | { skip: boolean }),
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<CalendarEventUserListQuery, CalendarEventUserListQueryVariables>(
		CalendarEventUserListDocument,
		options,
	);
}
export function useCalendarEventUserListLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<CalendarEventUserListQuery, CalendarEventUserListQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<CalendarEventUserListQuery, CalendarEventUserListQueryVariables>(
		CalendarEventUserListDocument,
		options,
	);
}
export function useCalendarEventUserListSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<CalendarEventUserListQuery, CalendarEventUserListQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<CalendarEventUserListQuery, CalendarEventUserListQueryVariables>(
		CalendarEventUserListDocument,
		options,
	);
}
export type CalendarEventUserListQueryHookResult = ReturnType<typeof useCalendarEventUserListQuery>;
export type CalendarEventUserListLazyQueryHookResult = ReturnType<typeof useCalendarEventUserListLazyQuery>;
export type CalendarEventUserListSuspenseQueryHookResult = ReturnType<typeof useCalendarEventUserListSuspenseQuery>;
export type CalendarEventUserListQueryResult = Apollo.QueryResult<
	CalendarEventUserListQuery,
	CalendarEventUserListQueryVariables
>;
export const CalendarEventResponseCountDocument = gql`
	query calendarEventResponseCount(
		$filters: [CalendarEventResponseFilterInput!]
		$pagination: Pagination
		$order: CalendarEventResponseOrder
	) {
		calendarEventResponseConnection(filters: $filters, pagination: $pagination, order: $order) {
			totalCount
		}
	}
`;

/**
 * __useCalendarEventResponseCountQuery__
 *
 * To run a query within a React component, call `useCalendarEventResponseCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useCalendarEventResponseCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCalendarEventResponseCountQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useCalendarEventResponseCountQuery(
	baseOptions?: Apollo.QueryHookOptions<CalendarEventResponseCountQuery, CalendarEventResponseCountQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<CalendarEventResponseCountQuery, CalendarEventResponseCountQueryVariables>(
		CalendarEventResponseCountDocument,
		options,
	);
}
export function useCalendarEventResponseCountLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<CalendarEventResponseCountQuery, CalendarEventResponseCountQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<CalendarEventResponseCountQuery, CalendarEventResponseCountQueryVariables>(
		CalendarEventResponseCountDocument,
		options,
	);
}
export function useCalendarEventResponseCountSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		CalendarEventResponseCountQuery,
		CalendarEventResponseCountQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<CalendarEventResponseCountQuery, CalendarEventResponseCountQueryVariables>(
		CalendarEventResponseCountDocument,
		options,
	);
}
export type CalendarEventResponseCountQueryHookResult = ReturnType<typeof useCalendarEventResponseCountQuery>;
export type CalendarEventResponseCountLazyQueryHookResult = ReturnType<typeof useCalendarEventResponseCountLazyQuery>;
export type CalendarEventResponseCountSuspenseQueryHookResult = ReturnType<
	typeof useCalendarEventResponseCountSuspenseQuery
>;
export type CalendarEventResponseCountQueryResult = Apollo.QueryResult<
	CalendarEventResponseCountQuery,
	CalendarEventResponseCountQueryVariables
>;
export const CalendarEventResponseCreateDocument = gql`
	mutation calendarEventResponseCreate($input: CalendarEventResponseCreateInput!) {
		createCalendarEventResponse(input: $input) {
			...CalendarEventResponseDetail
		}
	}
	${CalendarEventResponseDetailFragmentDoc}
`;
export type CalendarEventResponseCreateMutationFn = Apollo.MutationFunction<
	CalendarEventResponseCreateMutation,
	CalendarEventResponseCreateMutationVariables
>;

/**
 * __useCalendarEventResponseCreateMutation__
 *
 * To run a mutation, you first call `useCalendarEventResponseCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCalendarEventResponseCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [calendarEventResponseCreateMutation, { data, loading, error }] = useCalendarEventResponseCreateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCalendarEventResponseCreateMutation(
	baseOptions?: Apollo.MutationHookOptions<
		CalendarEventResponseCreateMutation,
		CalendarEventResponseCreateMutationVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<CalendarEventResponseCreateMutation, CalendarEventResponseCreateMutationVariables>(
		CalendarEventResponseCreateDocument,
		options,
	);
}
export type CalendarEventResponseCreateMutationHookResult = ReturnType<typeof useCalendarEventResponseCreateMutation>;
export type CalendarEventResponseCreateMutationResult = Apollo.MutationResult<CalendarEventResponseCreateMutation>;
export type CalendarEventResponseCreateMutationOptions = Apollo.BaseMutationOptions<
	CalendarEventResponseCreateMutation,
	CalendarEventResponseCreateMutationVariables
>;
export const CalendarEventResponseDeleteDocument = gql`
	mutation calendarEventResponseDelete($id: ID!) {
		deleteCalendarEventResponse(id: $id)
	}
`;
export type CalendarEventResponseDeleteMutationFn = Apollo.MutationFunction<
	CalendarEventResponseDeleteMutation,
	CalendarEventResponseDeleteMutationVariables
>;

/**
 * __useCalendarEventResponseDeleteMutation__
 *
 * To run a mutation, you first call `useCalendarEventResponseDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCalendarEventResponseDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [calendarEventResponseDeleteMutation, { data, loading, error }] = useCalendarEventResponseDeleteMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCalendarEventResponseDeleteMutation(
	baseOptions?: Apollo.MutationHookOptions<
		CalendarEventResponseDeleteMutation,
		CalendarEventResponseDeleteMutationVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<CalendarEventResponseDeleteMutation, CalendarEventResponseDeleteMutationVariables>(
		CalendarEventResponseDeleteDocument,
		options,
	);
}
export type CalendarEventResponseDeleteMutationHookResult = ReturnType<typeof useCalendarEventResponseDeleteMutation>;
export type CalendarEventResponseDeleteMutationResult = Apollo.MutationResult<CalendarEventResponseDeleteMutation>;
export type CalendarEventResponseDeleteMutationOptions = Apollo.BaseMutationOptions<
	CalendarEventResponseDeleteMutation,
	CalendarEventResponseDeleteMutationVariables
>;
export const CalendarEventResponseDetailDocument = gql`
	query calendarEventResponseDetail($id: ID!) {
		calendarEventResponse(id: $id) {
			...CalendarEventResponseDetail
		}
	}
	${CalendarEventResponseDetailFragmentDoc}
`;

/**
 * __useCalendarEventResponseDetailQuery__
 *
 * To run a query within a React component, call `useCalendarEventResponseDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useCalendarEventResponseDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCalendarEventResponseDetailQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCalendarEventResponseDetailQuery(
	baseOptions: Apollo.QueryHookOptions<CalendarEventResponseDetailQuery, CalendarEventResponseDetailQueryVariables> &
		({ variables: CalendarEventResponseDetailQueryVariables; skip?: boolean } | { skip: boolean }),
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<CalendarEventResponseDetailQuery, CalendarEventResponseDetailQueryVariables>(
		CalendarEventResponseDetailDocument,
		options,
	);
}
export function useCalendarEventResponseDetailLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		CalendarEventResponseDetailQuery,
		CalendarEventResponseDetailQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<CalendarEventResponseDetailQuery, CalendarEventResponseDetailQueryVariables>(
		CalendarEventResponseDetailDocument,
		options,
	);
}
export function useCalendarEventResponseDetailSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		CalendarEventResponseDetailQuery,
		CalendarEventResponseDetailQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<CalendarEventResponseDetailQuery, CalendarEventResponseDetailQueryVariables>(
		CalendarEventResponseDetailDocument,
		options,
	);
}
export type CalendarEventResponseDetailQueryHookResult = ReturnType<typeof useCalendarEventResponseDetailQuery>;
export type CalendarEventResponseDetailLazyQueryHookResult = ReturnType<typeof useCalendarEventResponseDetailLazyQuery>;
export type CalendarEventResponseDetailSuspenseQueryHookResult = ReturnType<
	typeof useCalendarEventResponseDetailSuspenseQuery
>;
export type CalendarEventResponseDetailQueryResult = Apollo.QueryResult<
	CalendarEventResponseDetailQuery,
	CalendarEventResponseDetailQueryVariables
>;
export const CalendarEventResponseIndexDocument = gql`
	query calendarEventResponseIndex(
		$filters: [CalendarEventResponseFilterInput!]
		$pagination: Pagination
		$order: CalendarEventResponseOrder
	) {
		calendarEventResponseConnection(filters: $filters, pagination: $pagination, order: $order) {
			edges {
				node {
					id
					response
				}
			}
		}
	}
`;

/**
 * __useCalendarEventResponseIndexQuery__
 *
 * To run a query within a React component, call `useCalendarEventResponseIndexQuery` and pass it any options that fit your needs.
 * When your component renders, `useCalendarEventResponseIndexQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCalendarEventResponseIndexQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useCalendarEventResponseIndexQuery(
	baseOptions?: Apollo.QueryHookOptions<CalendarEventResponseIndexQuery, CalendarEventResponseIndexQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<CalendarEventResponseIndexQuery, CalendarEventResponseIndexQueryVariables>(
		CalendarEventResponseIndexDocument,
		options,
	);
}
export function useCalendarEventResponseIndexLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<CalendarEventResponseIndexQuery, CalendarEventResponseIndexQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<CalendarEventResponseIndexQuery, CalendarEventResponseIndexQueryVariables>(
		CalendarEventResponseIndexDocument,
		options,
	);
}
export function useCalendarEventResponseIndexSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		CalendarEventResponseIndexQuery,
		CalendarEventResponseIndexQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<CalendarEventResponseIndexQuery, CalendarEventResponseIndexQueryVariables>(
		CalendarEventResponseIndexDocument,
		options,
	);
}
export type CalendarEventResponseIndexQueryHookResult = ReturnType<typeof useCalendarEventResponseIndexQuery>;
export type CalendarEventResponseIndexLazyQueryHookResult = ReturnType<typeof useCalendarEventResponseIndexLazyQuery>;
export type CalendarEventResponseIndexSuspenseQueryHookResult = ReturnType<
	typeof useCalendarEventResponseIndexSuspenseQuery
>;
export type CalendarEventResponseIndexQueryResult = Apollo.QueryResult<
	CalendarEventResponseIndexQuery,
	CalendarEventResponseIndexQueryVariables
>;
export const CalendarEventResponseNameDocument = gql`
	query calendarEventResponseName($id: ID!) {
		calendarEventResponse(id: $id) {
			id
			...CalendarEventResponseName
		}
	}
	${CalendarEventResponseNameFragmentDoc}
`;

/**
 * __useCalendarEventResponseNameQuery__
 *
 * To run a query within a React component, call `useCalendarEventResponseNameQuery` and pass it any options that fit your needs.
 * When your component renders, `useCalendarEventResponseNameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCalendarEventResponseNameQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCalendarEventResponseNameQuery(
	baseOptions: Apollo.QueryHookOptions<CalendarEventResponseNameQuery, CalendarEventResponseNameQueryVariables> &
		({ variables: CalendarEventResponseNameQueryVariables; skip?: boolean } | { skip: boolean }),
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<CalendarEventResponseNameQuery, CalendarEventResponseNameQueryVariables>(
		CalendarEventResponseNameDocument,
		options,
	);
}
export function useCalendarEventResponseNameLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<CalendarEventResponseNameQuery, CalendarEventResponseNameQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<CalendarEventResponseNameQuery, CalendarEventResponseNameQueryVariables>(
		CalendarEventResponseNameDocument,
		options,
	);
}
export function useCalendarEventResponseNameSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		CalendarEventResponseNameQuery,
		CalendarEventResponseNameQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<CalendarEventResponseNameQuery, CalendarEventResponseNameQueryVariables>(
		CalendarEventResponseNameDocument,
		options,
	);
}
export type CalendarEventResponseNameQueryHookResult = ReturnType<typeof useCalendarEventResponseNameQuery>;
export type CalendarEventResponseNameLazyQueryHookResult = ReturnType<typeof useCalendarEventResponseNameLazyQuery>;
export type CalendarEventResponseNameSuspenseQueryHookResult = ReturnType<
	typeof useCalendarEventResponseNameSuspenseQuery
>;
export type CalendarEventResponseNameQueryResult = Apollo.QueryResult<
	CalendarEventResponseNameQuery,
	CalendarEventResponseNameQueryVariables
>;
export const CalendarEventResponseNamesDocument = gql`
	query calendarEventResponseNames(
		$filters: [CalendarEventResponseFilterInput!]
		$pagination: Pagination
		$order: CalendarEventResponseOrder
	) {
		calendarEventResponseConnection(filters: $filters, pagination: $pagination, order: $order) {
			edges {
				node {
					id
					...CalendarEventResponseName
				}
			}
		}
	}
	${CalendarEventResponseNameFragmentDoc}
`;

/**
 * __useCalendarEventResponseNamesQuery__
 *
 * To run a query within a React component, call `useCalendarEventResponseNamesQuery` and pass it any options that fit your needs.
 * When your component renders, `useCalendarEventResponseNamesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCalendarEventResponseNamesQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useCalendarEventResponseNamesQuery(
	baseOptions?: Apollo.QueryHookOptions<CalendarEventResponseNamesQuery, CalendarEventResponseNamesQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<CalendarEventResponseNamesQuery, CalendarEventResponseNamesQueryVariables>(
		CalendarEventResponseNamesDocument,
		options,
	);
}
export function useCalendarEventResponseNamesLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<CalendarEventResponseNamesQuery, CalendarEventResponseNamesQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<CalendarEventResponseNamesQuery, CalendarEventResponseNamesQueryVariables>(
		CalendarEventResponseNamesDocument,
		options,
	);
}
export function useCalendarEventResponseNamesSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		CalendarEventResponseNamesQuery,
		CalendarEventResponseNamesQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<CalendarEventResponseNamesQuery, CalendarEventResponseNamesQueryVariables>(
		CalendarEventResponseNamesDocument,
		options,
	);
}
export type CalendarEventResponseNamesQueryHookResult = ReturnType<typeof useCalendarEventResponseNamesQuery>;
export type CalendarEventResponseNamesLazyQueryHookResult = ReturnType<typeof useCalendarEventResponseNamesLazyQuery>;
export type CalendarEventResponseNamesSuspenseQueryHookResult = ReturnType<
	typeof useCalendarEventResponseNamesSuspenseQuery
>;
export type CalendarEventResponseNamesQueryResult = Apollo.QueryResult<
	CalendarEventResponseNamesQuery,
	CalendarEventResponseNamesQueryVariables
>;
export const CalendarEventResponsePaginationDocument = gql`
	query calendarEventResponsePagination(
		$filters: [CalendarEventResponseFilterInput!]
		$order: CalendarEventResponseOrder
	) {
		calendarEventResponseConnection(filters: $filters, order: $order) {
			totalCount
			edges {
				cursor
			}
		}
	}
`;

/**
 * __useCalendarEventResponsePaginationQuery__
 *
 * To run a query within a React component, call `useCalendarEventResponsePaginationQuery` and pass it any options that fit your needs.
 * When your component renders, `useCalendarEventResponsePaginationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCalendarEventResponsePaginationQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useCalendarEventResponsePaginationQuery(
	baseOptions?: Apollo.QueryHookOptions<
		CalendarEventResponsePaginationQuery,
		CalendarEventResponsePaginationQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<CalendarEventResponsePaginationQuery, CalendarEventResponsePaginationQueryVariables>(
		CalendarEventResponsePaginationDocument,
		options,
	);
}
export function useCalendarEventResponsePaginationLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		CalendarEventResponsePaginationQuery,
		CalendarEventResponsePaginationQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<CalendarEventResponsePaginationQuery, CalendarEventResponsePaginationQueryVariables>(
		CalendarEventResponsePaginationDocument,
		options,
	);
}
export function useCalendarEventResponsePaginationSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		CalendarEventResponsePaginationQuery,
		CalendarEventResponsePaginationQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<CalendarEventResponsePaginationQuery, CalendarEventResponsePaginationQueryVariables>(
		CalendarEventResponsePaginationDocument,
		options,
	);
}
export type CalendarEventResponsePaginationQueryHookResult = ReturnType<typeof useCalendarEventResponsePaginationQuery>;
export type CalendarEventResponsePaginationLazyQueryHookResult = ReturnType<
	typeof useCalendarEventResponsePaginationLazyQuery
>;
export type CalendarEventResponsePaginationSuspenseQueryHookResult = ReturnType<
	typeof useCalendarEventResponsePaginationSuspenseQuery
>;
export type CalendarEventResponsePaginationQueryResult = Apollo.QueryResult<
	CalendarEventResponsePaginationQuery,
	CalendarEventResponsePaginationQueryVariables
>;
export const CalendarEventResponseSelectDocument = gql`
	query calendarEventResponseSelect($filters: [CalendarEventResponseFilterInput!], $order: CalendarEventResponseOrder) {
		calendarEventResponseConnection(filters: $filters, order: $order) {
			edges {
				node {
					id
					...CalendarEventResponseName
				}
			}
		}
	}
	${CalendarEventResponseNameFragmentDoc}
`;

/**
 * __useCalendarEventResponseSelectQuery__
 *
 * To run a query within a React component, call `useCalendarEventResponseSelectQuery` and pass it any options that fit your needs.
 * When your component renders, `useCalendarEventResponseSelectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCalendarEventResponseSelectQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useCalendarEventResponseSelectQuery(
	baseOptions?: Apollo.QueryHookOptions<CalendarEventResponseSelectQuery, CalendarEventResponseSelectQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<CalendarEventResponseSelectQuery, CalendarEventResponseSelectQueryVariables>(
		CalendarEventResponseSelectDocument,
		options,
	);
}
export function useCalendarEventResponseSelectLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		CalendarEventResponseSelectQuery,
		CalendarEventResponseSelectQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<CalendarEventResponseSelectQuery, CalendarEventResponseSelectQueryVariables>(
		CalendarEventResponseSelectDocument,
		options,
	);
}
export function useCalendarEventResponseSelectSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		CalendarEventResponseSelectQuery,
		CalendarEventResponseSelectQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<CalendarEventResponseSelectQuery, CalendarEventResponseSelectQueryVariables>(
		CalendarEventResponseSelectDocument,
		options,
	);
}
export type CalendarEventResponseSelectQueryHookResult = ReturnType<typeof useCalendarEventResponseSelectQuery>;
export type CalendarEventResponseSelectLazyQueryHookResult = ReturnType<typeof useCalendarEventResponseSelectLazyQuery>;
export type CalendarEventResponseSelectSuspenseQueryHookResult = ReturnType<
	typeof useCalendarEventResponseSelectSuspenseQuery
>;
export type CalendarEventResponseSelectQueryResult = Apollo.QueryResult<
	CalendarEventResponseSelectQuery,
	CalendarEventResponseSelectQueryVariables
>;
export const CalendarEventResponseUpdateDocument = gql`
	mutation calendarEventResponseUpdate($id: ID!, $input: CalendarEventResponseUpdateInput!) {
		updateCalendarEventResponse(id: $id, input: $input) {
			...CalendarEventResponseDetail
		}
	}
	${CalendarEventResponseDetailFragmentDoc}
`;
export type CalendarEventResponseUpdateMutationFn = Apollo.MutationFunction<
	CalendarEventResponseUpdateMutation,
	CalendarEventResponseUpdateMutationVariables
>;

/**
 * __useCalendarEventResponseUpdateMutation__
 *
 * To run a mutation, you first call `useCalendarEventResponseUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCalendarEventResponseUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [calendarEventResponseUpdateMutation, { data, loading, error }] = useCalendarEventResponseUpdateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCalendarEventResponseUpdateMutation(
	baseOptions?: Apollo.MutationHookOptions<
		CalendarEventResponseUpdateMutation,
		CalendarEventResponseUpdateMutationVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<CalendarEventResponseUpdateMutation, CalendarEventResponseUpdateMutationVariables>(
		CalendarEventResponseUpdateDocument,
		options,
	);
}
export type CalendarEventResponseUpdateMutationHookResult = ReturnType<typeof useCalendarEventResponseUpdateMutation>;
export type CalendarEventResponseUpdateMutationResult = Apollo.MutationResult<CalendarEventResponseUpdateMutation>;
export type CalendarEventResponseUpdateMutationOptions = Apollo.BaseMutationOptions<
	CalendarEventResponseUpdateMutation,
	CalendarEventResponseUpdateMutationVariables
>;
export const MediaAttachmentCountDocument = gql`
	query mediaAttachmentCount(
		$filters: [MediaAttachmentFilterInput!]
		$pagination: Pagination
		$order: MediaAttachmentOrder
	) {
		mediaAttachmentConnection(filters: $filters, pagination: $pagination, order: $order) {
			totalCount
		}
	}
`;

/**
 * __useMediaAttachmentCountQuery__
 *
 * To run a query within a React component, call `useMediaAttachmentCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useMediaAttachmentCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMediaAttachmentCountQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useMediaAttachmentCountQuery(
	baseOptions?: Apollo.QueryHookOptions<MediaAttachmentCountQuery, MediaAttachmentCountQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<MediaAttachmentCountQuery, MediaAttachmentCountQueryVariables>(
		MediaAttachmentCountDocument,
		options,
	);
}
export function useMediaAttachmentCountLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<MediaAttachmentCountQuery, MediaAttachmentCountQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<MediaAttachmentCountQuery, MediaAttachmentCountQueryVariables>(
		MediaAttachmentCountDocument,
		options,
	);
}
export function useMediaAttachmentCountSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<MediaAttachmentCountQuery, MediaAttachmentCountQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<MediaAttachmentCountQuery, MediaAttachmentCountQueryVariables>(
		MediaAttachmentCountDocument,
		options,
	);
}
export type MediaAttachmentCountQueryHookResult = ReturnType<typeof useMediaAttachmentCountQuery>;
export type MediaAttachmentCountLazyQueryHookResult = ReturnType<typeof useMediaAttachmentCountLazyQuery>;
export type MediaAttachmentCountSuspenseQueryHookResult = ReturnType<typeof useMediaAttachmentCountSuspenseQuery>;
export type MediaAttachmentCountQueryResult = Apollo.QueryResult<
	MediaAttachmentCountQuery,
	MediaAttachmentCountQueryVariables
>;
export const MediaAttachmentCreateDocument = gql`
	mutation mediaAttachmentCreate($input: MediaAttachmentCreateInput!) {
		createMediaAttachment(input: $input) {
			...MediaAttachmentDetail
		}
	}
	${MediaAttachmentDetailFragmentDoc}
`;
export type MediaAttachmentCreateMutationFn = Apollo.MutationFunction<
	MediaAttachmentCreateMutation,
	MediaAttachmentCreateMutationVariables
>;

/**
 * __useMediaAttachmentCreateMutation__
 *
 * To run a mutation, you first call `useMediaAttachmentCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMediaAttachmentCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [mediaAttachmentCreateMutation, { data, loading, error }] = useMediaAttachmentCreateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useMediaAttachmentCreateMutation(
	baseOptions?: Apollo.MutationHookOptions<MediaAttachmentCreateMutation, MediaAttachmentCreateMutationVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<MediaAttachmentCreateMutation, MediaAttachmentCreateMutationVariables>(
		MediaAttachmentCreateDocument,
		options,
	);
}
export type MediaAttachmentCreateMutationHookResult = ReturnType<typeof useMediaAttachmentCreateMutation>;
export type MediaAttachmentCreateMutationResult = Apollo.MutationResult<MediaAttachmentCreateMutation>;
export type MediaAttachmentCreateMutationOptions = Apollo.BaseMutationOptions<
	MediaAttachmentCreateMutation,
	MediaAttachmentCreateMutationVariables
>;
export const MediaAttachmentDeleteDocument = gql`
	mutation mediaAttachmentDelete($id: ID!) {
		deleteMediaAttachment(id: $id)
	}
`;
export type MediaAttachmentDeleteMutationFn = Apollo.MutationFunction<
	MediaAttachmentDeleteMutation,
	MediaAttachmentDeleteMutationVariables
>;

/**
 * __useMediaAttachmentDeleteMutation__
 *
 * To run a mutation, you first call `useMediaAttachmentDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMediaAttachmentDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [mediaAttachmentDeleteMutation, { data, loading, error }] = useMediaAttachmentDeleteMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useMediaAttachmentDeleteMutation(
	baseOptions?: Apollo.MutationHookOptions<MediaAttachmentDeleteMutation, MediaAttachmentDeleteMutationVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<MediaAttachmentDeleteMutation, MediaAttachmentDeleteMutationVariables>(
		MediaAttachmentDeleteDocument,
		options,
	);
}
export type MediaAttachmentDeleteMutationHookResult = ReturnType<typeof useMediaAttachmentDeleteMutation>;
export type MediaAttachmentDeleteMutationResult = Apollo.MutationResult<MediaAttachmentDeleteMutation>;
export type MediaAttachmentDeleteMutationOptions = Apollo.BaseMutationOptions<
	MediaAttachmentDeleteMutation,
	MediaAttachmentDeleteMutationVariables
>;
export const MediaAttachmentDetailDocument = gql`
	query mediaAttachmentDetail($id: ID!) {
		mediaAttachment(id: $id) {
			...MediaAttachmentDetail
		}
	}
	${MediaAttachmentDetailFragmentDoc}
`;

/**
 * __useMediaAttachmentDetailQuery__
 *
 * To run a query within a React component, call `useMediaAttachmentDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useMediaAttachmentDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMediaAttachmentDetailQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useMediaAttachmentDetailQuery(
	baseOptions: Apollo.QueryHookOptions<MediaAttachmentDetailQuery, MediaAttachmentDetailQueryVariables> &
		({ variables: MediaAttachmentDetailQueryVariables; skip?: boolean } | { skip: boolean }),
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<MediaAttachmentDetailQuery, MediaAttachmentDetailQueryVariables>(
		MediaAttachmentDetailDocument,
		options,
	);
}
export function useMediaAttachmentDetailLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<MediaAttachmentDetailQuery, MediaAttachmentDetailQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<MediaAttachmentDetailQuery, MediaAttachmentDetailQueryVariables>(
		MediaAttachmentDetailDocument,
		options,
	);
}
export function useMediaAttachmentDetailSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<MediaAttachmentDetailQuery, MediaAttachmentDetailQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<MediaAttachmentDetailQuery, MediaAttachmentDetailQueryVariables>(
		MediaAttachmentDetailDocument,
		options,
	);
}
export type MediaAttachmentDetailQueryHookResult = ReturnType<typeof useMediaAttachmentDetailQuery>;
export type MediaAttachmentDetailLazyQueryHookResult = ReturnType<typeof useMediaAttachmentDetailLazyQuery>;
export type MediaAttachmentDetailSuspenseQueryHookResult = ReturnType<typeof useMediaAttachmentDetailSuspenseQuery>;
export type MediaAttachmentDetailQueryResult = Apollo.QueryResult<
	MediaAttachmentDetailQuery,
	MediaAttachmentDetailQueryVariables
>;
export const MediaAttachmentIndexDocument = gql`
	query mediaAttachmentIndex(
		$filters: [MediaAttachmentFilterInput!]
		$pagination: Pagination
		$order: MediaAttachmentOrder
	) {
		mediaAttachmentConnection(filters: $filters, pagination: $pagination, order: $order) {
			edges {
				node {
					id
					displayOrder
					title
					description
					isFile
					fileURL
					fileContentType
					linkURL
				}
			}
		}
	}
`;

/**
 * __useMediaAttachmentIndexQuery__
 *
 * To run a query within a React component, call `useMediaAttachmentIndexQuery` and pass it any options that fit your needs.
 * When your component renders, `useMediaAttachmentIndexQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMediaAttachmentIndexQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useMediaAttachmentIndexQuery(
	baseOptions?: Apollo.QueryHookOptions<MediaAttachmentIndexQuery, MediaAttachmentIndexQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<MediaAttachmentIndexQuery, MediaAttachmentIndexQueryVariables>(
		MediaAttachmentIndexDocument,
		options,
	);
}
export function useMediaAttachmentIndexLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<MediaAttachmentIndexQuery, MediaAttachmentIndexQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<MediaAttachmentIndexQuery, MediaAttachmentIndexQueryVariables>(
		MediaAttachmentIndexDocument,
		options,
	);
}
export function useMediaAttachmentIndexSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<MediaAttachmentIndexQuery, MediaAttachmentIndexQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<MediaAttachmentIndexQuery, MediaAttachmentIndexQueryVariables>(
		MediaAttachmentIndexDocument,
		options,
	);
}
export type MediaAttachmentIndexQueryHookResult = ReturnType<typeof useMediaAttachmentIndexQuery>;
export type MediaAttachmentIndexLazyQueryHookResult = ReturnType<typeof useMediaAttachmentIndexLazyQuery>;
export type MediaAttachmentIndexSuspenseQueryHookResult = ReturnType<typeof useMediaAttachmentIndexSuspenseQuery>;
export type MediaAttachmentIndexQueryResult = Apollo.QueryResult<
	MediaAttachmentIndexQuery,
	MediaAttachmentIndexQueryVariables
>;
export const MediaAttachmentNameDocument = gql`
	query mediaAttachmentName($id: ID!) {
		mediaAttachment(id: $id) {
			id
			...MediaAttachmentName
		}
	}
	${MediaAttachmentNameFragmentDoc}
`;

/**
 * __useMediaAttachmentNameQuery__
 *
 * To run a query within a React component, call `useMediaAttachmentNameQuery` and pass it any options that fit your needs.
 * When your component renders, `useMediaAttachmentNameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMediaAttachmentNameQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useMediaAttachmentNameQuery(
	baseOptions: Apollo.QueryHookOptions<MediaAttachmentNameQuery, MediaAttachmentNameQueryVariables> &
		({ variables: MediaAttachmentNameQueryVariables; skip?: boolean } | { skip: boolean }),
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<MediaAttachmentNameQuery, MediaAttachmentNameQueryVariables>(
		MediaAttachmentNameDocument,
		options,
	);
}
export function useMediaAttachmentNameLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<MediaAttachmentNameQuery, MediaAttachmentNameQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<MediaAttachmentNameQuery, MediaAttachmentNameQueryVariables>(
		MediaAttachmentNameDocument,
		options,
	);
}
export function useMediaAttachmentNameSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<MediaAttachmentNameQuery, MediaAttachmentNameQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<MediaAttachmentNameQuery, MediaAttachmentNameQueryVariables>(
		MediaAttachmentNameDocument,
		options,
	);
}
export type MediaAttachmentNameQueryHookResult = ReturnType<typeof useMediaAttachmentNameQuery>;
export type MediaAttachmentNameLazyQueryHookResult = ReturnType<typeof useMediaAttachmentNameLazyQuery>;
export type MediaAttachmentNameSuspenseQueryHookResult = ReturnType<typeof useMediaAttachmentNameSuspenseQuery>;
export type MediaAttachmentNameQueryResult = Apollo.QueryResult<
	MediaAttachmentNameQuery,
	MediaAttachmentNameQueryVariables
>;
export const MediaAttachmentNamesDocument = gql`
	query mediaAttachmentNames(
		$filters: [MediaAttachmentFilterInput!]
		$pagination: Pagination
		$order: MediaAttachmentOrder
	) {
		mediaAttachmentConnection(filters: $filters, pagination: $pagination, order: $order) {
			edges {
				node {
					id
					...MediaAttachmentName
				}
			}
		}
	}
	${MediaAttachmentNameFragmentDoc}
`;

/**
 * __useMediaAttachmentNamesQuery__
 *
 * To run a query within a React component, call `useMediaAttachmentNamesQuery` and pass it any options that fit your needs.
 * When your component renders, `useMediaAttachmentNamesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMediaAttachmentNamesQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useMediaAttachmentNamesQuery(
	baseOptions?: Apollo.QueryHookOptions<MediaAttachmentNamesQuery, MediaAttachmentNamesQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<MediaAttachmentNamesQuery, MediaAttachmentNamesQueryVariables>(
		MediaAttachmentNamesDocument,
		options,
	);
}
export function useMediaAttachmentNamesLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<MediaAttachmentNamesQuery, MediaAttachmentNamesQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<MediaAttachmentNamesQuery, MediaAttachmentNamesQueryVariables>(
		MediaAttachmentNamesDocument,
		options,
	);
}
export function useMediaAttachmentNamesSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<MediaAttachmentNamesQuery, MediaAttachmentNamesQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<MediaAttachmentNamesQuery, MediaAttachmentNamesQueryVariables>(
		MediaAttachmentNamesDocument,
		options,
	);
}
export type MediaAttachmentNamesQueryHookResult = ReturnType<typeof useMediaAttachmentNamesQuery>;
export type MediaAttachmentNamesLazyQueryHookResult = ReturnType<typeof useMediaAttachmentNamesLazyQuery>;
export type MediaAttachmentNamesSuspenseQueryHookResult = ReturnType<typeof useMediaAttachmentNamesSuspenseQuery>;
export type MediaAttachmentNamesQueryResult = Apollo.QueryResult<
	MediaAttachmentNamesQuery,
	MediaAttachmentNamesQueryVariables
>;
export const MediaAttachmentPaginationDocument = gql`
	query mediaAttachmentPagination($filters: [MediaAttachmentFilterInput!], $order: MediaAttachmentOrder) {
		mediaAttachmentConnection(filters: $filters, order: $order) {
			totalCount
			edges {
				cursor
			}
		}
	}
`;

/**
 * __useMediaAttachmentPaginationQuery__
 *
 * To run a query within a React component, call `useMediaAttachmentPaginationQuery` and pass it any options that fit your needs.
 * When your component renders, `useMediaAttachmentPaginationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMediaAttachmentPaginationQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useMediaAttachmentPaginationQuery(
	baseOptions?: Apollo.QueryHookOptions<MediaAttachmentPaginationQuery, MediaAttachmentPaginationQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<MediaAttachmentPaginationQuery, MediaAttachmentPaginationQueryVariables>(
		MediaAttachmentPaginationDocument,
		options,
	);
}
export function useMediaAttachmentPaginationLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<MediaAttachmentPaginationQuery, MediaAttachmentPaginationQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<MediaAttachmentPaginationQuery, MediaAttachmentPaginationQueryVariables>(
		MediaAttachmentPaginationDocument,
		options,
	);
}
export function useMediaAttachmentPaginationSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		MediaAttachmentPaginationQuery,
		MediaAttachmentPaginationQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<MediaAttachmentPaginationQuery, MediaAttachmentPaginationQueryVariables>(
		MediaAttachmentPaginationDocument,
		options,
	);
}
export type MediaAttachmentPaginationQueryHookResult = ReturnType<typeof useMediaAttachmentPaginationQuery>;
export type MediaAttachmentPaginationLazyQueryHookResult = ReturnType<typeof useMediaAttachmentPaginationLazyQuery>;
export type MediaAttachmentPaginationSuspenseQueryHookResult = ReturnType<
	typeof useMediaAttachmentPaginationSuspenseQuery
>;
export type MediaAttachmentPaginationQueryResult = Apollo.QueryResult<
	MediaAttachmentPaginationQuery,
	MediaAttachmentPaginationQueryVariables
>;
export const MediaAttachmentSelectDocument = gql`
	query mediaAttachmentSelect($filters: [MediaAttachmentFilterInput!], $order: MediaAttachmentOrder) {
		mediaAttachmentConnection(filters: $filters, order: $order) {
			edges {
				node {
					id
					...MediaAttachmentName
				}
			}
		}
	}
	${MediaAttachmentNameFragmentDoc}
`;

/**
 * __useMediaAttachmentSelectQuery__
 *
 * To run a query within a React component, call `useMediaAttachmentSelectQuery` and pass it any options that fit your needs.
 * When your component renders, `useMediaAttachmentSelectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMediaAttachmentSelectQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useMediaAttachmentSelectQuery(
	baseOptions?: Apollo.QueryHookOptions<MediaAttachmentSelectQuery, MediaAttachmentSelectQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<MediaAttachmentSelectQuery, MediaAttachmentSelectQueryVariables>(
		MediaAttachmentSelectDocument,
		options,
	);
}
export function useMediaAttachmentSelectLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<MediaAttachmentSelectQuery, MediaAttachmentSelectQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<MediaAttachmentSelectQuery, MediaAttachmentSelectQueryVariables>(
		MediaAttachmentSelectDocument,
		options,
	);
}
export function useMediaAttachmentSelectSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<MediaAttachmentSelectQuery, MediaAttachmentSelectQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<MediaAttachmentSelectQuery, MediaAttachmentSelectQueryVariables>(
		MediaAttachmentSelectDocument,
		options,
	);
}
export type MediaAttachmentSelectQueryHookResult = ReturnType<typeof useMediaAttachmentSelectQuery>;
export type MediaAttachmentSelectLazyQueryHookResult = ReturnType<typeof useMediaAttachmentSelectLazyQuery>;
export type MediaAttachmentSelectSuspenseQueryHookResult = ReturnType<typeof useMediaAttachmentSelectSuspenseQuery>;
export type MediaAttachmentSelectQueryResult = Apollo.QueryResult<
	MediaAttachmentSelectQuery,
	MediaAttachmentSelectQueryVariables
>;
export const MediaAttachmentSocialItemsDocument = gql`
	query mediaAttachmentSocialItems($id: ID!) {
		mediaAttachment(id: $id) {
			id
			socialReactions(order: { field: CREATED_AT, direction: DESC }) {
				id
				reaction
				author {
					id
					...UserName
					isCurrent
				}
			}
			socialComments(order: { field: CREATED_AT, direction: DESC }) {
				id
				body
				createdAt
				author {
					id
					...UserNameAndImage
					isCurrent
				}
			}
		}
	}
	${UserNameFragmentDoc}
	${UserNameAndImageFragmentDoc}
`;

/**
 * __useMediaAttachmentSocialItemsQuery__
 *
 * To run a query within a React component, call `useMediaAttachmentSocialItemsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMediaAttachmentSocialItemsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMediaAttachmentSocialItemsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useMediaAttachmentSocialItemsQuery(
	baseOptions: Apollo.QueryHookOptions<MediaAttachmentSocialItemsQuery, MediaAttachmentSocialItemsQueryVariables> &
		({ variables: MediaAttachmentSocialItemsQueryVariables; skip?: boolean } | { skip: boolean }),
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<MediaAttachmentSocialItemsQuery, MediaAttachmentSocialItemsQueryVariables>(
		MediaAttachmentSocialItemsDocument,
		options,
	);
}
export function useMediaAttachmentSocialItemsLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<MediaAttachmentSocialItemsQuery, MediaAttachmentSocialItemsQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<MediaAttachmentSocialItemsQuery, MediaAttachmentSocialItemsQueryVariables>(
		MediaAttachmentSocialItemsDocument,
		options,
	);
}
export function useMediaAttachmentSocialItemsSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		MediaAttachmentSocialItemsQuery,
		MediaAttachmentSocialItemsQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<MediaAttachmentSocialItemsQuery, MediaAttachmentSocialItemsQueryVariables>(
		MediaAttachmentSocialItemsDocument,
		options,
	);
}
export type MediaAttachmentSocialItemsQueryHookResult = ReturnType<typeof useMediaAttachmentSocialItemsQuery>;
export type MediaAttachmentSocialItemsLazyQueryHookResult = ReturnType<typeof useMediaAttachmentSocialItemsLazyQuery>;
export type MediaAttachmentSocialItemsSuspenseQueryHookResult = ReturnType<
	typeof useMediaAttachmentSocialItemsSuspenseQuery
>;
export type MediaAttachmentSocialItemsQueryResult = Apollo.QueryResult<
	MediaAttachmentSocialItemsQuery,
	MediaAttachmentSocialItemsQueryVariables
>;
export const MediaAttachmentUpdateDocument = gql`
	mutation mediaAttachmentUpdate($id: ID!, $input: MediaAttachmentUpdateInput!) {
		updateMediaAttachment(id: $id, input: $input) {
			...MediaAttachmentDetail
		}
	}
	${MediaAttachmentDetailFragmentDoc}
`;
export type MediaAttachmentUpdateMutationFn = Apollo.MutationFunction<
	MediaAttachmentUpdateMutation,
	MediaAttachmentUpdateMutationVariables
>;

/**
 * __useMediaAttachmentUpdateMutation__
 *
 * To run a mutation, you first call `useMediaAttachmentUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMediaAttachmentUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [mediaAttachmentUpdateMutation, { data, loading, error }] = useMediaAttachmentUpdateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useMediaAttachmentUpdateMutation(
	baseOptions?: Apollo.MutationHookOptions<MediaAttachmentUpdateMutation, MediaAttachmentUpdateMutationVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<MediaAttachmentUpdateMutation, MediaAttachmentUpdateMutationVariables>(
		MediaAttachmentUpdateDocument,
		options,
	);
}
export type MediaAttachmentUpdateMutationHookResult = ReturnType<typeof useMediaAttachmentUpdateMutation>;
export type MediaAttachmentUpdateMutationResult = Apollo.MutationResult<MediaAttachmentUpdateMutation>;
export type MediaAttachmentUpdateMutationOptions = Apollo.BaseMutationOptions<
	MediaAttachmentUpdateMutation,
	MediaAttachmentUpdateMutationVariables
>;
export const MediaAttachmentVisualCatalogListDocument = gql`
	query mediaAttachmentVisualCatalogList(
		$filters: [MediaAttachmentFilterInput!]
		$pagination: Pagination
		$order: MediaAttachmentOrder
	) {
		mediaAttachmentConnection(filters: $filters, pagination: $pagination, order: $order) {
			pageInfo {
				endCursor
				hasNextPage
			}
			edges {
				node {
					id
					title
					description
					fileURL
					fileKey
					fileContentType
					postID
				}
			}
		}
	}
`;

/**
 * __useMediaAttachmentVisualCatalogListQuery__
 *
 * To run a query within a React component, call `useMediaAttachmentVisualCatalogListQuery` and pass it any options that fit your needs.
 * When your component renders, `useMediaAttachmentVisualCatalogListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMediaAttachmentVisualCatalogListQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useMediaAttachmentVisualCatalogListQuery(
	baseOptions?: Apollo.QueryHookOptions<
		MediaAttachmentVisualCatalogListQuery,
		MediaAttachmentVisualCatalogListQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<MediaAttachmentVisualCatalogListQuery, MediaAttachmentVisualCatalogListQueryVariables>(
		MediaAttachmentVisualCatalogListDocument,
		options,
	);
}
export function useMediaAttachmentVisualCatalogListLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		MediaAttachmentVisualCatalogListQuery,
		MediaAttachmentVisualCatalogListQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<MediaAttachmentVisualCatalogListQuery, MediaAttachmentVisualCatalogListQueryVariables>(
		MediaAttachmentVisualCatalogListDocument,
		options,
	);
}
export function useMediaAttachmentVisualCatalogListSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		MediaAttachmentVisualCatalogListQuery,
		MediaAttachmentVisualCatalogListQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<MediaAttachmentVisualCatalogListQuery, MediaAttachmentVisualCatalogListQueryVariables>(
		MediaAttachmentVisualCatalogListDocument,
		options,
	);
}
export type MediaAttachmentVisualCatalogListQueryHookResult = ReturnType<
	typeof useMediaAttachmentVisualCatalogListQuery
>;
export type MediaAttachmentVisualCatalogListLazyQueryHookResult = ReturnType<
	typeof useMediaAttachmentVisualCatalogListLazyQuery
>;
export type MediaAttachmentVisualCatalogListSuspenseQueryHookResult = ReturnType<
	typeof useMediaAttachmentVisualCatalogListSuspenseQuery
>;
export type MediaAttachmentVisualCatalogListQueryResult = Apollo.QueryResult<
	MediaAttachmentVisualCatalogListQuery,
	MediaAttachmentVisualCatalogListQueryVariables
>;
export const MessageCountDocument = gql`
	query messageCount($filters: [MessageFilterInput!], $pagination: Pagination, $order: MessageOrder) {
		messageConnection(filters: $filters, pagination: $pagination, order: $order) {
			totalCount
		}
	}
`;

/**
 * __useMessageCountQuery__
 *
 * To run a query within a React component, call `useMessageCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useMessageCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMessageCountQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useMessageCountQuery(
	baseOptions?: Apollo.QueryHookOptions<MessageCountQuery, MessageCountQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<MessageCountQuery, MessageCountQueryVariables>(MessageCountDocument, options);
}
export function useMessageCountLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<MessageCountQuery, MessageCountQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<MessageCountQuery, MessageCountQueryVariables>(MessageCountDocument, options);
}
export function useMessageCountSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<MessageCountQuery, MessageCountQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<MessageCountQuery, MessageCountQueryVariables>(MessageCountDocument, options);
}
export type MessageCountQueryHookResult = ReturnType<typeof useMessageCountQuery>;
export type MessageCountLazyQueryHookResult = ReturnType<typeof useMessageCountLazyQuery>;
export type MessageCountSuspenseQueryHookResult = ReturnType<typeof useMessageCountSuspenseQuery>;
export type MessageCountQueryResult = Apollo.QueryResult<MessageCountQuery, MessageCountQueryVariables>;
export const MessageCreateDocument = gql`
	mutation messageCreate($input: MessageCreateInput!) {
		createMessage(input: $input) {
			...MessageDetail
		}
	}
	${MessageDetailFragmentDoc}
`;
export type MessageCreateMutationFn = Apollo.MutationFunction<MessageCreateMutation, MessageCreateMutationVariables>;

/**
 * __useMessageCreateMutation__
 *
 * To run a mutation, you first call `useMessageCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMessageCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [messageCreateMutation, { data, loading, error }] = useMessageCreateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useMessageCreateMutation(
	baseOptions?: Apollo.MutationHookOptions<MessageCreateMutation, MessageCreateMutationVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<MessageCreateMutation, MessageCreateMutationVariables>(MessageCreateDocument, options);
}
export type MessageCreateMutationHookResult = ReturnType<typeof useMessageCreateMutation>;
export type MessageCreateMutationResult = Apollo.MutationResult<MessageCreateMutation>;
export type MessageCreateMutationOptions = Apollo.BaseMutationOptions<
	MessageCreateMutation,
	MessageCreateMutationVariables
>;
export const MessageDeleteDocument = gql`
	mutation messageDelete($id: ID!) {
		deleteMessage(id: $id)
	}
`;
export type MessageDeleteMutationFn = Apollo.MutationFunction<MessageDeleteMutation, MessageDeleteMutationVariables>;

/**
 * __useMessageDeleteMutation__
 *
 * To run a mutation, you first call `useMessageDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMessageDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [messageDeleteMutation, { data, loading, error }] = useMessageDeleteMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useMessageDeleteMutation(
	baseOptions?: Apollo.MutationHookOptions<MessageDeleteMutation, MessageDeleteMutationVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<MessageDeleteMutation, MessageDeleteMutationVariables>(MessageDeleteDocument, options);
}
export type MessageDeleteMutationHookResult = ReturnType<typeof useMessageDeleteMutation>;
export type MessageDeleteMutationResult = Apollo.MutationResult<MessageDeleteMutation>;
export type MessageDeleteMutationOptions = Apollo.BaseMutationOptions<
	MessageDeleteMutation,
	MessageDeleteMutationVariables
>;
export const MessageDetailDocument = gql`
	query messageDetail($id: ID!) {
		message(id: $id) {
			...MessageDetail
		}
	}
	${MessageDetailFragmentDoc}
`;

/**
 * __useMessageDetailQuery__
 *
 * To run a query within a React component, call `useMessageDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useMessageDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMessageDetailQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useMessageDetailQuery(
	baseOptions: Apollo.QueryHookOptions<MessageDetailQuery, MessageDetailQueryVariables> &
		({ variables: MessageDetailQueryVariables; skip?: boolean } | { skip: boolean }),
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<MessageDetailQuery, MessageDetailQueryVariables>(MessageDetailDocument, options);
}
export function useMessageDetailLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<MessageDetailQuery, MessageDetailQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<MessageDetailQuery, MessageDetailQueryVariables>(MessageDetailDocument, options);
}
export function useMessageDetailSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<MessageDetailQuery, MessageDetailQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<MessageDetailQuery, MessageDetailQueryVariables>(MessageDetailDocument, options);
}
export type MessageDetailQueryHookResult = ReturnType<typeof useMessageDetailQuery>;
export type MessageDetailLazyQueryHookResult = ReturnType<typeof useMessageDetailLazyQuery>;
export type MessageDetailSuspenseQueryHookResult = ReturnType<typeof useMessageDetailSuspenseQuery>;
export type MessageDetailQueryResult = Apollo.QueryResult<MessageDetailQuery, MessageDetailQueryVariables>;
export const MessageDetailForEditDocument = gql`
	query messageDetailForEdit($id: ID!) {
		message(id: $id) {
			id
			body
			mediaAttachments(order: { field: DISPLAY_ORDER, direction: ASC }) {
				id
				displayOrder
				title
				description
				isFile
				fileURL
				fileKey
				fileContentType
				linkURL
			}
		}
	}
`;

/**
 * __useMessageDetailForEditQuery__
 *
 * To run a query within a React component, call `useMessageDetailForEditQuery` and pass it any options that fit your needs.
 * When your component renders, `useMessageDetailForEditQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMessageDetailForEditQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useMessageDetailForEditQuery(
	baseOptions: Apollo.QueryHookOptions<MessageDetailForEditQuery, MessageDetailForEditQueryVariables> &
		({ variables: MessageDetailForEditQueryVariables; skip?: boolean } | { skip: boolean }),
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<MessageDetailForEditQuery, MessageDetailForEditQueryVariables>(
		MessageDetailForEditDocument,
		options,
	);
}
export function useMessageDetailForEditLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<MessageDetailForEditQuery, MessageDetailForEditQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<MessageDetailForEditQuery, MessageDetailForEditQueryVariables>(
		MessageDetailForEditDocument,
		options,
	);
}
export function useMessageDetailForEditSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<MessageDetailForEditQuery, MessageDetailForEditQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<MessageDetailForEditQuery, MessageDetailForEditQueryVariables>(
		MessageDetailForEditDocument,
		options,
	);
}
export type MessageDetailForEditQueryHookResult = ReturnType<typeof useMessageDetailForEditQuery>;
export type MessageDetailForEditLazyQueryHookResult = ReturnType<typeof useMessageDetailForEditLazyQuery>;
export type MessageDetailForEditSuspenseQueryHookResult = ReturnType<typeof useMessageDetailForEditSuspenseQuery>;
export type MessageDetailForEditQueryResult = Apollo.QueryResult<
	MessageDetailForEditQuery,
	MessageDetailForEditQueryVariables
>;
export const MessageGroupMessagesListDocument = gql`
	query messageGroupMessagesList($filters: [MessageFilterInput!], $pagination: Pagination, $order: MessageOrder) {
		messageConnection(filters: $filters, pagination: $pagination, order: $order) {
			pageInfo {
				startCursor
				endCursor
				hasNextPage
				hasPreviousPage
			}
			edges {
				node {
					...MessageInMessageGroup
				}
			}
		}
	}
	${MessageInMessageGroupFragmentDoc}
`;

/**
 * __useMessageGroupMessagesListQuery__
 *
 * To run a query within a React component, call `useMessageGroupMessagesListQuery` and pass it any options that fit your needs.
 * When your component renders, `useMessageGroupMessagesListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMessageGroupMessagesListQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useMessageGroupMessagesListQuery(
	baseOptions?: Apollo.QueryHookOptions<MessageGroupMessagesListQuery, MessageGroupMessagesListQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<MessageGroupMessagesListQuery, MessageGroupMessagesListQueryVariables>(
		MessageGroupMessagesListDocument,
		options,
	);
}
export function useMessageGroupMessagesListLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<MessageGroupMessagesListQuery, MessageGroupMessagesListQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<MessageGroupMessagesListQuery, MessageGroupMessagesListQueryVariables>(
		MessageGroupMessagesListDocument,
		options,
	);
}
export function useMessageGroupMessagesListSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<MessageGroupMessagesListQuery, MessageGroupMessagesListQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<MessageGroupMessagesListQuery, MessageGroupMessagesListQueryVariables>(
		MessageGroupMessagesListDocument,
		options,
	);
}
export type MessageGroupMessagesListQueryHookResult = ReturnType<typeof useMessageGroupMessagesListQuery>;
export type MessageGroupMessagesListLazyQueryHookResult = ReturnType<typeof useMessageGroupMessagesListLazyQuery>;
export type MessageGroupMessagesListSuspenseQueryHookResult = ReturnType<
	typeof useMessageGroupMessagesListSuspenseQuery
>;
export type MessageGroupMessagesListQueryResult = Apollo.QueryResult<
	MessageGroupMessagesListQuery,
	MessageGroupMessagesListQueryVariables
>;
export const MessageGroupLatestTopicDocument = gql`
	query messageGroupLatestTopic($messageGroupID: ID!) {
		messageConnection(
			filters: { messageGroupIDEQ: $messageGroupID, hasMessageTopic: true }
			order: { field: CREATED_AT, direction: DESC }
			pagination: { first: 1 }
		) {
			edges {
				node {
					...MessageInMessageGroup
				}
			}
		}
	}
	${MessageInMessageGroupFragmentDoc}
`;

/**
 * __useMessageGroupLatestTopicQuery__
 *
 * To run a query within a React component, call `useMessageGroupLatestTopicQuery` and pass it any options that fit your needs.
 * When your component renders, `useMessageGroupLatestTopicQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMessageGroupLatestTopicQuery({
 *   variables: {
 *      messageGroupID: // value for 'messageGroupID'
 *   },
 * });
 */
export function useMessageGroupLatestTopicQuery(
	baseOptions: Apollo.QueryHookOptions<MessageGroupLatestTopicQuery, MessageGroupLatestTopicQueryVariables> &
		({ variables: MessageGroupLatestTopicQueryVariables; skip?: boolean } | { skip: boolean }),
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<MessageGroupLatestTopicQuery, MessageGroupLatestTopicQueryVariables>(
		MessageGroupLatestTopicDocument,
		options,
	);
}
export function useMessageGroupLatestTopicLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<MessageGroupLatestTopicQuery, MessageGroupLatestTopicQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<MessageGroupLatestTopicQuery, MessageGroupLatestTopicQueryVariables>(
		MessageGroupLatestTopicDocument,
		options,
	);
}
export function useMessageGroupLatestTopicSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<MessageGroupLatestTopicQuery, MessageGroupLatestTopicQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<MessageGroupLatestTopicQuery, MessageGroupLatestTopicQueryVariables>(
		MessageGroupLatestTopicDocument,
		options,
	);
}
export type MessageGroupLatestTopicQueryHookResult = ReturnType<typeof useMessageGroupLatestTopicQuery>;
export type MessageGroupLatestTopicLazyQueryHookResult = ReturnType<typeof useMessageGroupLatestTopicLazyQuery>;
export type MessageGroupLatestTopicSuspenseQueryHookResult = ReturnType<typeof useMessageGroupLatestTopicSuspenseQuery>;
export type MessageGroupLatestTopicQueryResult = Apollo.QueryResult<
	MessageGroupLatestTopicQuery,
	MessageGroupLatestTopicQueryVariables
>;
export const MessageIndexDocument = gql`
	query messageIndex($filters: [MessageFilterInput!], $pagination: Pagination, $order: MessageOrder) {
		messageConnection(filters: $filters, pagination: $pagination, order: $order) {
			edges {
				node {
					id
					createdAt
					body
					lastEditedAt
					isRemoved
				}
			}
		}
	}
`;

/**
 * __useMessageIndexQuery__
 *
 * To run a query within a React component, call `useMessageIndexQuery` and pass it any options that fit your needs.
 * When your component renders, `useMessageIndexQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMessageIndexQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useMessageIndexQuery(
	baseOptions?: Apollo.QueryHookOptions<MessageIndexQuery, MessageIndexQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<MessageIndexQuery, MessageIndexQueryVariables>(MessageIndexDocument, options);
}
export function useMessageIndexLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<MessageIndexQuery, MessageIndexQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<MessageIndexQuery, MessageIndexQueryVariables>(MessageIndexDocument, options);
}
export function useMessageIndexSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<MessageIndexQuery, MessageIndexQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<MessageIndexQuery, MessageIndexQueryVariables>(MessageIndexDocument, options);
}
export type MessageIndexQueryHookResult = ReturnType<typeof useMessageIndexQuery>;
export type MessageIndexLazyQueryHookResult = ReturnType<typeof useMessageIndexLazyQuery>;
export type MessageIndexSuspenseQueryHookResult = ReturnType<typeof useMessageIndexSuspenseQuery>;
export type MessageIndexQueryResult = Apollo.QueryResult<MessageIndexQuery, MessageIndexQueryVariables>;
export const LatestMessagesAndMessageGroupsListDocument = gql`
	query latestMessagesAndMessageGroupsList(
		$filters: [MessageFilterInput!]
		$archived: Boolean
		$pagination: Pagination
		$order: MessageOrder
	) {
		latestMessageByGroupConnection(filters: $filters, archived: $archived, pagination: $pagination, order: $order) {
			edges {
				node {
					id
					createdAt
					body
					isRemoved
					messageGroup {
						id
						...MessageGroupNameAndImage
					}
					mediaAttachments {
						id
					}
				}
			}
		}
	}
	${MessageGroupNameAndImageFragmentDoc}
`;

/**
 * __useLatestMessagesAndMessageGroupsListQuery__
 *
 * To run a query within a React component, call `useLatestMessagesAndMessageGroupsListQuery` and pass it any options that fit your needs.
 * When your component renders, `useLatestMessagesAndMessageGroupsListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLatestMessagesAndMessageGroupsListQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      archived: // value for 'archived'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useLatestMessagesAndMessageGroupsListQuery(
	baseOptions?: Apollo.QueryHookOptions<
		LatestMessagesAndMessageGroupsListQuery,
		LatestMessagesAndMessageGroupsListQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<LatestMessagesAndMessageGroupsListQuery, LatestMessagesAndMessageGroupsListQueryVariables>(
		LatestMessagesAndMessageGroupsListDocument,
		options,
	);
}
export function useLatestMessagesAndMessageGroupsListLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		LatestMessagesAndMessageGroupsListQuery,
		LatestMessagesAndMessageGroupsListQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<LatestMessagesAndMessageGroupsListQuery, LatestMessagesAndMessageGroupsListQueryVariables>(
		LatestMessagesAndMessageGroupsListDocument,
		options,
	);
}
export function useLatestMessagesAndMessageGroupsListSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		LatestMessagesAndMessageGroupsListQuery,
		LatestMessagesAndMessageGroupsListQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<
		LatestMessagesAndMessageGroupsListQuery,
		LatestMessagesAndMessageGroupsListQueryVariables
	>(LatestMessagesAndMessageGroupsListDocument, options);
}
export type LatestMessagesAndMessageGroupsListQueryHookResult = ReturnType<
	typeof useLatestMessagesAndMessageGroupsListQuery
>;
export type LatestMessagesAndMessageGroupsListLazyQueryHookResult = ReturnType<
	typeof useLatestMessagesAndMessageGroupsListLazyQuery
>;
export type LatestMessagesAndMessageGroupsListSuspenseQueryHookResult = ReturnType<
	typeof useLatestMessagesAndMessageGroupsListSuspenseQuery
>;
export type LatestMessagesAndMessageGroupsListQueryResult = Apollo.QueryResult<
	LatestMessagesAndMessageGroupsListQuery,
	LatestMessagesAndMessageGroupsListQueryVariables
>;
export const MessageNameDocument = gql`
	query messageName($id: ID!) {
		message(id: $id) {
			id
			...MessageName
		}
	}
	${MessageNameFragmentDoc}
`;

/**
 * __useMessageNameQuery__
 *
 * To run a query within a React component, call `useMessageNameQuery` and pass it any options that fit your needs.
 * When your component renders, `useMessageNameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMessageNameQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useMessageNameQuery(
	baseOptions: Apollo.QueryHookOptions<MessageNameQuery, MessageNameQueryVariables> &
		({ variables: MessageNameQueryVariables; skip?: boolean } | { skip: boolean }),
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<MessageNameQuery, MessageNameQueryVariables>(MessageNameDocument, options);
}
export function useMessageNameLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<MessageNameQuery, MessageNameQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<MessageNameQuery, MessageNameQueryVariables>(MessageNameDocument, options);
}
export function useMessageNameSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<MessageNameQuery, MessageNameQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<MessageNameQuery, MessageNameQueryVariables>(MessageNameDocument, options);
}
export type MessageNameQueryHookResult = ReturnType<typeof useMessageNameQuery>;
export type MessageNameLazyQueryHookResult = ReturnType<typeof useMessageNameLazyQuery>;
export type MessageNameSuspenseQueryHookResult = ReturnType<typeof useMessageNameSuspenseQuery>;
export type MessageNameQueryResult = Apollo.QueryResult<MessageNameQuery, MessageNameQueryVariables>;
export const MessageNamesDocument = gql`
	query messageNames($filters: [MessageFilterInput!], $pagination: Pagination, $order: MessageOrder) {
		messageConnection(filters: $filters, pagination: $pagination, order: $order) {
			edges {
				node {
					id
					...MessageName
				}
			}
		}
	}
	${MessageNameFragmentDoc}
`;

/**
 * __useMessageNamesQuery__
 *
 * To run a query within a React component, call `useMessageNamesQuery` and pass it any options that fit your needs.
 * When your component renders, `useMessageNamesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMessageNamesQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useMessageNamesQuery(
	baseOptions?: Apollo.QueryHookOptions<MessageNamesQuery, MessageNamesQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<MessageNamesQuery, MessageNamesQueryVariables>(MessageNamesDocument, options);
}
export function useMessageNamesLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<MessageNamesQuery, MessageNamesQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<MessageNamesQuery, MessageNamesQueryVariables>(MessageNamesDocument, options);
}
export function useMessageNamesSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<MessageNamesQuery, MessageNamesQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<MessageNamesQuery, MessageNamesQueryVariables>(MessageNamesDocument, options);
}
export type MessageNamesQueryHookResult = ReturnType<typeof useMessageNamesQuery>;
export type MessageNamesLazyQueryHookResult = ReturnType<typeof useMessageNamesLazyQuery>;
export type MessageNamesSuspenseQueryHookResult = ReturnType<typeof useMessageNamesSuspenseQuery>;
export type MessageNamesQueryResult = Apollo.QueryResult<MessageNamesQuery, MessageNamesQueryVariables>;
export const UnreadMessagesCountDocument = gql`
	query unreadMessagesCount {
		unreadMessagesCount
	}
`;

/**
 * __useUnreadMessagesCountQuery__
 *
 * To run a query within a React component, call `useUnreadMessagesCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useUnreadMessagesCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUnreadMessagesCountQuery({
 *   variables: {
 *   },
 * });
 */
export function useUnreadMessagesCountQuery(
	baseOptions?: Apollo.QueryHookOptions<UnreadMessagesCountQuery, UnreadMessagesCountQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<UnreadMessagesCountQuery, UnreadMessagesCountQueryVariables>(
		UnreadMessagesCountDocument,
		options,
	);
}
export function useUnreadMessagesCountLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<UnreadMessagesCountQuery, UnreadMessagesCountQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<UnreadMessagesCountQuery, UnreadMessagesCountQueryVariables>(
		UnreadMessagesCountDocument,
		options,
	);
}
export function useUnreadMessagesCountSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<UnreadMessagesCountQuery, UnreadMessagesCountQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<UnreadMessagesCountQuery, UnreadMessagesCountQueryVariables>(
		UnreadMessagesCountDocument,
		options,
	);
}
export type UnreadMessagesCountQueryHookResult = ReturnType<typeof useUnreadMessagesCountQuery>;
export type UnreadMessagesCountLazyQueryHookResult = ReturnType<typeof useUnreadMessagesCountLazyQuery>;
export type UnreadMessagesCountSuspenseQueryHookResult = ReturnType<typeof useUnreadMessagesCountSuspenseQuery>;
export type UnreadMessagesCountQueryResult = Apollo.QueryResult<
	UnreadMessagesCountQuery,
	UnreadMessagesCountQueryVariables
>;
export const MessagePaginationDocument = gql`
	query messagePagination($filters: [MessageFilterInput!], $order: MessageOrder) {
		messageConnection(filters: $filters, order: $order) {
			totalCount
			edges {
				cursor
			}
		}
	}
`;

/**
 * __useMessagePaginationQuery__
 *
 * To run a query within a React component, call `useMessagePaginationQuery` and pass it any options that fit your needs.
 * When your component renders, `useMessagePaginationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMessagePaginationQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useMessagePaginationQuery(
	baseOptions?: Apollo.QueryHookOptions<MessagePaginationQuery, MessagePaginationQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<MessagePaginationQuery, MessagePaginationQueryVariables>(MessagePaginationDocument, options);
}
export function useMessagePaginationLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<MessagePaginationQuery, MessagePaginationQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<MessagePaginationQuery, MessagePaginationQueryVariables>(
		MessagePaginationDocument,
		options,
	);
}
export function useMessagePaginationSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<MessagePaginationQuery, MessagePaginationQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<MessagePaginationQuery, MessagePaginationQueryVariables>(
		MessagePaginationDocument,
		options,
	);
}
export type MessagePaginationQueryHookResult = ReturnType<typeof useMessagePaginationQuery>;
export type MessagePaginationLazyQueryHookResult = ReturnType<typeof useMessagePaginationLazyQuery>;
export type MessagePaginationSuspenseQueryHookResult = ReturnType<typeof useMessagePaginationSuspenseQuery>;
export type MessagePaginationQueryResult = Apollo.QueryResult<MessagePaginationQuery, MessagePaginationQueryVariables>;
export const MessageSelectDocument = gql`
	query messageSelect($filters: [MessageFilterInput!], $order: MessageOrder) {
		messageConnection(filters: $filters, order: $order) {
			edges {
				node {
					id
					...MessageName
				}
			}
		}
	}
	${MessageNameFragmentDoc}
`;

/**
 * __useMessageSelectQuery__
 *
 * To run a query within a React component, call `useMessageSelectQuery` and pass it any options that fit your needs.
 * When your component renders, `useMessageSelectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMessageSelectQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useMessageSelectQuery(
	baseOptions?: Apollo.QueryHookOptions<MessageSelectQuery, MessageSelectQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<MessageSelectQuery, MessageSelectQueryVariables>(MessageSelectDocument, options);
}
export function useMessageSelectLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<MessageSelectQuery, MessageSelectQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<MessageSelectQuery, MessageSelectQueryVariables>(MessageSelectDocument, options);
}
export function useMessageSelectSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<MessageSelectQuery, MessageSelectQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<MessageSelectQuery, MessageSelectQueryVariables>(MessageSelectDocument, options);
}
export type MessageSelectQueryHookResult = ReturnType<typeof useMessageSelectQuery>;
export type MessageSelectLazyQueryHookResult = ReturnType<typeof useMessageSelectLazyQuery>;
export type MessageSelectSuspenseQueryHookResult = ReturnType<typeof useMessageSelectSuspenseQuery>;
export type MessageSelectQueryResult = Apollo.QueryResult<MessageSelectQuery, MessageSelectQueryVariables>;
export const MessageUpdateDocument = gql`
	mutation messageUpdate($id: ID!, $input: MessageUpdateInput!) {
		updateMessage(id: $id, input: $input) {
			...MessageDetail
		}
	}
	${MessageDetailFragmentDoc}
`;
export type MessageUpdateMutationFn = Apollo.MutationFunction<MessageUpdateMutation, MessageUpdateMutationVariables>;

/**
 * __useMessageUpdateMutation__
 *
 * To run a mutation, you first call `useMessageUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMessageUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [messageUpdateMutation, { data, loading, error }] = useMessageUpdateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useMessageUpdateMutation(
	baseOptions?: Apollo.MutationHookOptions<MessageUpdateMutation, MessageUpdateMutationVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<MessageUpdateMutation, MessageUpdateMutationVariables>(MessageUpdateDocument, options);
}
export type MessageUpdateMutationHookResult = ReturnType<typeof useMessageUpdateMutation>;
export type MessageUpdateMutationResult = Apollo.MutationResult<MessageUpdateMutation>;
export type MessageUpdateMutationOptions = Apollo.BaseMutationOptions<
	MessageUpdateMutation,
	MessageUpdateMutationVariables
>;
export const MessageGroupCountDocument = gql`
	query messageGroupCount($filters: [MessageGroupFilterInput!], $pagination: Pagination, $order: MessageGroupOrder) {
		messageGroupConnection(filters: $filters, pagination: $pagination, order: $order) {
			totalCount
		}
	}
`;

/**
 * __useMessageGroupCountQuery__
 *
 * To run a query within a React component, call `useMessageGroupCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useMessageGroupCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMessageGroupCountQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useMessageGroupCountQuery(
	baseOptions?: Apollo.QueryHookOptions<MessageGroupCountQuery, MessageGroupCountQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<MessageGroupCountQuery, MessageGroupCountQueryVariables>(MessageGroupCountDocument, options);
}
export function useMessageGroupCountLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<MessageGroupCountQuery, MessageGroupCountQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<MessageGroupCountQuery, MessageGroupCountQueryVariables>(
		MessageGroupCountDocument,
		options,
	);
}
export function useMessageGroupCountSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<MessageGroupCountQuery, MessageGroupCountQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<MessageGroupCountQuery, MessageGroupCountQueryVariables>(
		MessageGroupCountDocument,
		options,
	);
}
export type MessageGroupCountQueryHookResult = ReturnType<typeof useMessageGroupCountQuery>;
export type MessageGroupCountLazyQueryHookResult = ReturnType<typeof useMessageGroupCountLazyQuery>;
export type MessageGroupCountSuspenseQueryHookResult = ReturnType<typeof useMessageGroupCountSuspenseQuery>;
export type MessageGroupCountQueryResult = Apollo.QueryResult<MessageGroupCountQuery, MessageGroupCountQueryVariables>;
export const MessageGroupCreateOrUpdateDocument = gql`
	mutation messageGroupCreateOrUpdate($input: MessageGroupCreateInput!) {
		createOrUpdateMessageGroup(input: $input) {
			...MessageGroupDetail
		}
	}
	${MessageGroupDetailFragmentDoc}
`;
export type MessageGroupCreateOrUpdateMutationFn = Apollo.MutationFunction<
	MessageGroupCreateOrUpdateMutation,
	MessageGroupCreateOrUpdateMutationVariables
>;

/**
 * __useMessageGroupCreateOrUpdateMutation__
 *
 * To run a mutation, you first call `useMessageGroupCreateOrUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMessageGroupCreateOrUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [messageGroupCreateOrUpdateMutation, { data, loading, error }] = useMessageGroupCreateOrUpdateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useMessageGroupCreateOrUpdateMutation(
	baseOptions?: Apollo.MutationHookOptions<
		MessageGroupCreateOrUpdateMutation,
		MessageGroupCreateOrUpdateMutationVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<MessageGroupCreateOrUpdateMutation, MessageGroupCreateOrUpdateMutationVariables>(
		MessageGroupCreateOrUpdateDocument,
		options,
	);
}
export type MessageGroupCreateOrUpdateMutationHookResult = ReturnType<typeof useMessageGroupCreateOrUpdateMutation>;
export type MessageGroupCreateOrUpdateMutationResult = Apollo.MutationResult<MessageGroupCreateOrUpdateMutation>;
export type MessageGroupCreateOrUpdateMutationOptions = Apollo.BaseMutationOptions<
	MessageGroupCreateOrUpdateMutation,
	MessageGroupCreateOrUpdateMutationVariables
>;
export const MessageGroupCreateDocument = gql`
	mutation messageGroupCreate($input: MessageGroupCreateInput!) {
		createMessageGroup(input: $input) {
			...MessageGroupDetail
		}
	}
	${MessageGroupDetailFragmentDoc}
`;
export type MessageGroupCreateMutationFn = Apollo.MutationFunction<
	MessageGroupCreateMutation,
	MessageGroupCreateMutationVariables
>;

/**
 * __useMessageGroupCreateMutation__
 *
 * To run a mutation, you first call `useMessageGroupCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMessageGroupCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [messageGroupCreateMutation, { data, loading, error }] = useMessageGroupCreateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useMessageGroupCreateMutation(
	baseOptions?: Apollo.MutationHookOptions<MessageGroupCreateMutation, MessageGroupCreateMutationVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<MessageGroupCreateMutation, MessageGroupCreateMutationVariables>(
		MessageGroupCreateDocument,
		options,
	);
}
export type MessageGroupCreateMutationHookResult = ReturnType<typeof useMessageGroupCreateMutation>;
export type MessageGroupCreateMutationResult = Apollo.MutationResult<MessageGroupCreateMutation>;
export type MessageGroupCreateMutationOptions = Apollo.BaseMutationOptions<
	MessageGroupCreateMutation,
	MessageGroupCreateMutationVariables
>;
export const MessageGroupDeleteDocument = gql`
	mutation messageGroupDelete($id: ID!) {
		deleteMessageGroup(id: $id)
	}
`;
export type MessageGroupDeleteMutationFn = Apollo.MutationFunction<
	MessageGroupDeleteMutation,
	MessageGroupDeleteMutationVariables
>;

/**
 * __useMessageGroupDeleteMutation__
 *
 * To run a mutation, you first call `useMessageGroupDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMessageGroupDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [messageGroupDeleteMutation, { data, loading, error }] = useMessageGroupDeleteMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useMessageGroupDeleteMutation(
	baseOptions?: Apollo.MutationHookOptions<MessageGroupDeleteMutation, MessageGroupDeleteMutationVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<MessageGroupDeleteMutation, MessageGroupDeleteMutationVariables>(
		MessageGroupDeleteDocument,
		options,
	);
}
export type MessageGroupDeleteMutationHookResult = ReturnType<typeof useMessageGroupDeleteMutation>;
export type MessageGroupDeleteMutationResult = Apollo.MutationResult<MessageGroupDeleteMutation>;
export type MessageGroupDeleteMutationOptions = Apollo.BaseMutationOptions<
	MessageGroupDeleteMutation,
	MessageGroupDeleteMutationVariables
>;
export const MessageGroupDetailDocument = gql`
	query messageGroupDetail($id: ID!) {
		messageGroup(id: $id) {
			...MessageGroupDetail
		}
	}
	${MessageGroupDetailFragmentDoc}
`;

/**
 * __useMessageGroupDetailQuery__
 *
 * To run a query within a React component, call `useMessageGroupDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useMessageGroupDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMessageGroupDetailQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useMessageGroupDetailQuery(
	baseOptions: Apollo.QueryHookOptions<MessageGroupDetailQuery, MessageGroupDetailQueryVariables> &
		({ variables: MessageGroupDetailQueryVariables; skip?: boolean } | { skip: boolean }),
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<MessageGroupDetailQuery, MessageGroupDetailQueryVariables>(
		MessageGroupDetailDocument,
		options,
	);
}
export function useMessageGroupDetailLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<MessageGroupDetailQuery, MessageGroupDetailQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<MessageGroupDetailQuery, MessageGroupDetailQueryVariables>(
		MessageGroupDetailDocument,
		options,
	);
}
export function useMessageGroupDetailSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<MessageGroupDetailQuery, MessageGroupDetailQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<MessageGroupDetailQuery, MessageGroupDetailQueryVariables>(
		MessageGroupDetailDocument,
		options,
	);
}
export type MessageGroupDetailQueryHookResult = ReturnType<typeof useMessageGroupDetailQuery>;
export type MessageGroupDetailLazyQueryHookResult = ReturnType<typeof useMessageGroupDetailLazyQuery>;
export type MessageGroupDetailSuspenseQueryHookResult = ReturnType<typeof useMessageGroupDetailSuspenseQuery>;
export type MessageGroupDetailQueryResult = Apollo.QueryResult<
	MessageGroupDetailQuery,
	MessageGroupDetailQueryVariables
>;
export const MessageGroupIndexDocument = gql`
	query messageGroupIndex($filters: [MessageGroupFilterInput!], $pagination: Pagination, $order: MessageGroupOrder) {
		messageGroupConnection(filters: $filters, pagination: $pagination, order: $order) {
			edges {
				node {
					id
					customName
					isOneOnOne
				}
			}
		}
	}
`;

/**
 * __useMessageGroupIndexQuery__
 *
 * To run a query within a React component, call `useMessageGroupIndexQuery` and pass it any options that fit your needs.
 * When your component renders, `useMessageGroupIndexQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMessageGroupIndexQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useMessageGroupIndexQuery(
	baseOptions?: Apollo.QueryHookOptions<MessageGroupIndexQuery, MessageGroupIndexQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<MessageGroupIndexQuery, MessageGroupIndexQueryVariables>(MessageGroupIndexDocument, options);
}
export function useMessageGroupIndexLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<MessageGroupIndexQuery, MessageGroupIndexQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<MessageGroupIndexQuery, MessageGroupIndexQueryVariables>(
		MessageGroupIndexDocument,
		options,
	);
}
export function useMessageGroupIndexSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<MessageGroupIndexQuery, MessageGroupIndexQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<MessageGroupIndexQuery, MessageGroupIndexQueryVariables>(
		MessageGroupIndexDocument,
		options,
	);
}
export type MessageGroupIndexQueryHookResult = ReturnType<typeof useMessageGroupIndexQuery>;
export type MessageGroupIndexLazyQueryHookResult = ReturnType<typeof useMessageGroupIndexLazyQuery>;
export type MessageGroupIndexSuspenseQueryHookResult = ReturnType<typeof useMessageGroupIndexSuspenseQuery>;
export type MessageGroupIndexQueryResult = Apollo.QueryResult<MessageGroupIndexQuery, MessageGroupIndexQueryVariables>;
export const MessageGroupNameDocument = gql`
	query messageGroupName($id: ID!) {
		messageGroup(id: $id) {
			id
			...MessageGroupName
		}
	}
	${MessageGroupNameFragmentDoc}
`;

/**
 * __useMessageGroupNameQuery__
 *
 * To run a query within a React component, call `useMessageGroupNameQuery` and pass it any options that fit your needs.
 * When your component renders, `useMessageGroupNameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMessageGroupNameQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useMessageGroupNameQuery(
	baseOptions: Apollo.QueryHookOptions<MessageGroupNameQuery, MessageGroupNameQueryVariables> &
		({ variables: MessageGroupNameQueryVariables; skip?: boolean } | { skip: boolean }),
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<MessageGroupNameQuery, MessageGroupNameQueryVariables>(MessageGroupNameDocument, options);
}
export function useMessageGroupNameLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<MessageGroupNameQuery, MessageGroupNameQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<MessageGroupNameQuery, MessageGroupNameQueryVariables>(MessageGroupNameDocument, options);
}
export function useMessageGroupNameSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<MessageGroupNameQuery, MessageGroupNameQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<MessageGroupNameQuery, MessageGroupNameQueryVariables>(
		MessageGroupNameDocument,
		options,
	);
}
export type MessageGroupNameQueryHookResult = ReturnType<typeof useMessageGroupNameQuery>;
export type MessageGroupNameLazyQueryHookResult = ReturnType<typeof useMessageGroupNameLazyQuery>;
export type MessageGroupNameSuspenseQueryHookResult = ReturnType<typeof useMessageGroupNameSuspenseQuery>;
export type MessageGroupNameQueryResult = Apollo.QueryResult<MessageGroupNameQuery, MessageGroupNameQueryVariables>;
export const MessageGroupNamesDocument = gql`
	query messageGroupNames($filters: [MessageGroupFilterInput!], $pagination: Pagination, $order: MessageGroupOrder) {
		messageGroupConnection(filters: $filters, pagination: $pagination, order: $order) {
			edges {
				node {
					id
					...MessageGroupName
				}
			}
		}
	}
	${MessageGroupNameFragmentDoc}
`;

/**
 * __useMessageGroupNamesQuery__
 *
 * To run a query within a React component, call `useMessageGroupNamesQuery` and pass it any options that fit your needs.
 * When your component renders, `useMessageGroupNamesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMessageGroupNamesQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useMessageGroupNamesQuery(
	baseOptions?: Apollo.QueryHookOptions<MessageGroupNamesQuery, MessageGroupNamesQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<MessageGroupNamesQuery, MessageGroupNamesQueryVariables>(MessageGroupNamesDocument, options);
}
export function useMessageGroupNamesLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<MessageGroupNamesQuery, MessageGroupNamesQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<MessageGroupNamesQuery, MessageGroupNamesQueryVariables>(
		MessageGroupNamesDocument,
		options,
	);
}
export function useMessageGroupNamesSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<MessageGroupNamesQuery, MessageGroupNamesQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<MessageGroupNamesQuery, MessageGroupNamesQueryVariables>(
		MessageGroupNamesDocument,
		options,
	);
}
export type MessageGroupNamesQueryHookResult = ReturnType<typeof useMessageGroupNamesQuery>;
export type MessageGroupNamesLazyQueryHookResult = ReturnType<typeof useMessageGroupNamesLazyQuery>;
export type MessageGroupNamesSuspenseQueryHookResult = ReturnType<typeof useMessageGroupNamesSuspenseQuery>;
export type MessageGroupNamesQueryResult = Apollo.QueryResult<MessageGroupNamesQuery, MessageGroupNamesQueryVariables>;
export const MessageGroupPaginationDocument = gql`
	query messageGroupPagination($filters: [MessageGroupFilterInput!], $order: MessageGroupOrder) {
		messageGroupConnection(filters: $filters, order: $order) {
			totalCount
			edges {
				cursor
			}
		}
	}
`;

/**
 * __useMessageGroupPaginationQuery__
 *
 * To run a query within a React component, call `useMessageGroupPaginationQuery` and pass it any options that fit your needs.
 * When your component renders, `useMessageGroupPaginationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMessageGroupPaginationQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useMessageGroupPaginationQuery(
	baseOptions?: Apollo.QueryHookOptions<MessageGroupPaginationQuery, MessageGroupPaginationQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<MessageGroupPaginationQuery, MessageGroupPaginationQueryVariables>(
		MessageGroupPaginationDocument,
		options,
	);
}
export function useMessageGroupPaginationLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<MessageGroupPaginationQuery, MessageGroupPaginationQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<MessageGroupPaginationQuery, MessageGroupPaginationQueryVariables>(
		MessageGroupPaginationDocument,
		options,
	);
}
export function useMessageGroupPaginationSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<MessageGroupPaginationQuery, MessageGroupPaginationQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<MessageGroupPaginationQuery, MessageGroupPaginationQueryVariables>(
		MessageGroupPaginationDocument,
		options,
	);
}
export type MessageGroupPaginationQueryHookResult = ReturnType<typeof useMessageGroupPaginationQuery>;
export type MessageGroupPaginationLazyQueryHookResult = ReturnType<typeof useMessageGroupPaginationLazyQuery>;
export type MessageGroupPaginationSuspenseQueryHookResult = ReturnType<typeof useMessageGroupPaginationSuspenseQuery>;
export type MessageGroupPaginationQueryResult = Apollo.QueryResult<
	MessageGroupPaginationQuery,
	MessageGroupPaginationQueryVariables
>;
export const MessageGroupUserGroupParticipantUserListDocument = gql`
	query messageGroupUserGroupParticipantUserList($messageGroupID: ID!) {
		userConnection(
			filters: {
				and: [
					{ memberGroups: { messageGroups: { idEQ: $messageGroupID } } }
					{ not: { messageGroups: { idEQ: $messageGroupID } } }
				]
			}
		) {
			edges {
				node {
					...MessageGroupUser
				}
			}
		}
	}
	${MessageGroupUserFragmentDoc}
`;

/**
 * __useMessageGroupUserGroupParticipantUserListQuery__
 *
 * To run a query within a React component, call `useMessageGroupUserGroupParticipantUserListQuery` and pass it any options that fit your needs.
 * When your component renders, `useMessageGroupUserGroupParticipantUserListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMessageGroupUserGroupParticipantUserListQuery({
 *   variables: {
 *      messageGroupID: // value for 'messageGroupID'
 *   },
 * });
 */
export function useMessageGroupUserGroupParticipantUserListQuery(
	baseOptions: Apollo.QueryHookOptions<
		MessageGroupUserGroupParticipantUserListQuery,
		MessageGroupUserGroupParticipantUserListQueryVariables
	> &
		({ variables: MessageGroupUserGroupParticipantUserListQueryVariables; skip?: boolean } | { skip: boolean }),
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<
		MessageGroupUserGroupParticipantUserListQuery,
		MessageGroupUserGroupParticipantUserListQueryVariables
	>(MessageGroupUserGroupParticipantUserListDocument, options);
}
export function useMessageGroupUserGroupParticipantUserListLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		MessageGroupUserGroupParticipantUserListQuery,
		MessageGroupUserGroupParticipantUserListQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		MessageGroupUserGroupParticipantUserListQuery,
		MessageGroupUserGroupParticipantUserListQueryVariables
	>(MessageGroupUserGroupParticipantUserListDocument, options);
}
export function useMessageGroupUserGroupParticipantUserListSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		MessageGroupUserGroupParticipantUserListQuery,
		MessageGroupUserGroupParticipantUserListQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<
		MessageGroupUserGroupParticipantUserListQuery,
		MessageGroupUserGroupParticipantUserListQueryVariables
	>(MessageGroupUserGroupParticipantUserListDocument, options);
}
export type MessageGroupUserGroupParticipantUserListQueryHookResult = ReturnType<
	typeof useMessageGroupUserGroupParticipantUserListQuery
>;
export type MessageGroupUserGroupParticipantUserListLazyQueryHookResult = ReturnType<
	typeof useMessageGroupUserGroupParticipantUserListLazyQuery
>;
export type MessageGroupUserGroupParticipantUserListSuspenseQueryHookResult = ReturnType<
	typeof useMessageGroupUserGroupParticipantUserListSuspenseQuery
>;
export type MessageGroupUserGroupParticipantUserListQueryResult = Apollo.QueryResult<
	MessageGroupUserGroupParticipantUserListQuery,
	MessageGroupUserGroupParticipantUserListQueryVariables
>;
export const UserListForMessagesDocument = gql`
	query userListForMessages($filters: [UserFilterInput!], $pagination: Pagination, $order: UserOrder) {
		userConnection(filters: $filters, pagination: $pagination, order: $order) {
			edges {
				node {
					...UserForMessages
				}
			}
		}
	}
	${UserForMessagesFragmentDoc}
`;

/**
 * __useUserListForMessagesQuery__
 *
 * To run a query within a React component, call `useUserListForMessagesQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserListForMessagesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserListForMessagesQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useUserListForMessagesQuery(
	baseOptions?: Apollo.QueryHookOptions<UserListForMessagesQuery, UserListForMessagesQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<UserListForMessagesQuery, UserListForMessagesQueryVariables>(
		UserListForMessagesDocument,
		options,
	);
}
export function useUserListForMessagesLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<UserListForMessagesQuery, UserListForMessagesQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<UserListForMessagesQuery, UserListForMessagesQueryVariables>(
		UserListForMessagesDocument,
		options,
	);
}
export function useUserListForMessagesSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<UserListForMessagesQuery, UserListForMessagesQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<UserListForMessagesQuery, UserListForMessagesQueryVariables>(
		UserListForMessagesDocument,
		options,
	);
}
export type UserListForMessagesQueryHookResult = ReturnType<typeof useUserListForMessagesQuery>;
export type UserListForMessagesLazyQueryHookResult = ReturnType<typeof useUserListForMessagesLazyQuery>;
export type UserListForMessagesSuspenseQueryHookResult = ReturnType<typeof useUserListForMessagesSuspenseQuery>;
export type UserListForMessagesQueryResult = Apollo.QueryResult<
	UserListForMessagesQuery,
	UserListForMessagesQueryVariables
>;
export const UserAndUserGroupListForMessagesDocument = gql`
	query userAndUserGroupListForMessages($userFilters: [UserFilterInput!], $userGroupFilters: [UserGroupFilterInput!]) {
		userConnection(filters: $userFilters) {
			edges {
				node {
					...UserForMessages
				}
			}
		}
		userGroupConnection(filters: $userGroupFilters) {
			edges {
				node {
					id
					...UserGroupNameAndColor
					members {
						id
						isCurrent
					}
				}
			}
		}
	}
	${UserForMessagesFragmentDoc}
	${UserGroupNameAndColorFragmentDoc}
`;

/**
 * __useUserAndUserGroupListForMessagesQuery__
 *
 * To run a query within a React component, call `useUserAndUserGroupListForMessagesQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserAndUserGroupListForMessagesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserAndUserGroupListForMessagesQuery({
 *   variables: {
 *      userFilters: // value for 'userFilters'
 *      userGroupFilters: // value for 'userGroupFilters'
 *   },
 * });
 */
export function useUserAndUserGroupListForMessagesQuery(
	baseOptions?: Apollo.QueryHookOptions<
		UserAndUserGroupListForMessagesQuery,
		UserAndUserGroupListForMessagesQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<UserAndUserGroupListForMessagesQuery, UserAndUserGroupListForMessagesQueryVariables>(
		UserAndUserGroupListForMessagesDocument,
		options,
	);
}
export function useUserAndUserGroupListForMessagesLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		UserAndUserGroupListForMessagesQuery,
		UserAndUserGroupListForMessagesQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<UserAndUserGroupListForMessagesQuery, UserAndUserGroupListForMessagesQueryVariables>(
		UserAndUserGroupListForMessagesDocument,
		options,
	);
}
export function useUserAndUserGroupListForMessagesSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		UserAndUserGroupListForMessagesQuery,
		UserAndUserGroupListForMessagesQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<UserAndUserGroupListForMessagesQuery, UserAndUserGroupListForMessagesQueryVariables>(
		UserAndUserGroupListForMessagesDocument,
		options,
	);
}
export type UserAndUserGroupListForMessagesQueryHookResult = ReturnType<typeof useUserAndUserGroupListForMessagesQuery>;
export type UserAndUserGroupListForMessagesLazyQueryHookResult = ReturnType<
	typeof useUserAndUserGroupListForMessagesLazyQuery
>;
export type UserAndUserGroupListForMessagesSuspenseQueryHookResult = ReturnType<
	typeof useUserAndUserGroupListForMessagesSuspenseQuery
>;
export type UserAndUserGroupListForMessagesQueryResult = Apollo.QueryResult<
	UserAndUserGroupListForMessagesQuery,
	UserAndUserGroupListForMessagesQueryVariables
>;
export const MessageGroupSelectDocument = gql`
	query messageGroupSelect($filters: [MessageGroupFilterInput!], $order: MessageGroupOrder) {
		messageGroupConnection(filters: $filters, order: $order) {
			edges {
				node {
					id
					...MessageGroupName
				}
			}
		}
	}
	${MessageGroupNameFragmentDoc}
`;

/**
 * __useMessageGroupSelectQuery__
 *
 * To run a query within a React component, call `useMessageGroupSelectQuery` and pass it any options that fit your needs.
 * When your component renders, `useMessageGroupSelectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMessageGroupSelectQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useMessageGroupSelectQuery(
	baseOptions?: Apollo.QueryHookOptions<MessageGroupSelectQuery, MessageGroupSelectQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<MessageGroupSelectQuery, MessageGroupSelectQueryVariables>(
		MessageGroupSelectDocument,
		options,
	);
}
export function useMessageGroupSelectLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<MessageGroupSelectQuery, MessageGroupSelectQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<MessageGroupSelectQuery, MessageGroupSelectQueryVariables>(
		MessageGroupSelectDocument,
		options,
	);
}
export function useMessageGroupSelectSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<MessageGroupSelectQuery, MessageGroupSelectQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<MessageGroupSelectQuery, MessageGroupSelectQueryVariables>(
		MessageGroupSelectDocument,
		options,
	);
}
export type MessageGroupSelectQueryHookResult = ReturnType<typeof useMessageGroupSelectQuery>;
export type MessageGroupSelectLazyQueryHookResult = ReturnType<typeof useMessageGroupSelectLazyQuery>;
export type MessageGroupSelectSuspenseQueryHookResult = ReturnType<typeof useMessageGroupSelectSuspenseQuery>;
export type MessageGroupSelectQueryResult = Apollo.QueryResult<
	MessageGroupSelectQuery,
	MessageGroupSelectQueryVariables
>;
export const MessageGroupUpdateDocument = gql`
	mutation messageGroupUpdate($id: ID!, $input: MessageGroupUpdateInput!) {
		updateMessageGroup(id: $id, input: $input) {
			...MessageGroupDetail
		}
	}
	${MessageGroupDetailFragmentDoc}
`;
export type MessageGroupUpdateMutationFn = Apollo.MutationFunction<
	MessageGroupUpdateMutation,
	MessageGroupUpdateMutationVariables
>;

/**
 * __useMessageGroupUpdateMutation__
 *
 * To run a mutation, you first call `useMessageGroupUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMessageGroupUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [messageGroupUpdateMutation, { data, loading, error }] = useMessageGroupUpdateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useMessageGroupUpdateMutation(
	baseOptions?: Apollo.MutationHookOptions<MessageGroupUpdateMutation, MessageGroupUpdateMutationVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<MessageGroupUpdateMutation, MessageGroupUpdateMutationVariables>(
		MessageGroupUpdateDocument,
		options,
	);
}
export type MessageGroupUpdateMutationHookResult = ReturnType<typeof useMessageGroupUpdateMutation>;
export type MessageGroupUpdateMutationResult = Apollo.MutationResult<MessageGroupUpdateMutation>;
export type MessageGroupUpdateMutationOptions = Apollo.BaseMutationOptions<
	MessageGroupUpdateMutation,
	MessageGroupUpdateMutationVariables
>;
export const MessageGroupArchivePointCountDocument = gql`
	query messageGroupArchivePointCount(
		$filters: [MessageGroupArchivePointFilterInput!]
		$pagination: Pagination
		$order: MessageGroupArchivePointOrder
	) {
		messageGroupArchivePointConnection(filters: $filters, pagination: $pagination, order: $order) {
			totalCount
		}
	}
`;

/**
 * __useMessageGroupArchivePointCountQuery__
 *
 * To run a query within a React component, call `useMessageGroupArchivePointCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useMessageGroupArchivePointCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMessageGroupArchivePointCountQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useMessageGroupArchivePointCountQuery(
	baseOptions?: Apollo.QueryHookOptions<
		MessageGroupArchivePointCountQuery,
		MessageGroupArchivePointCountQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<MessageGroupArchivePointCountQuery, MessageGroupArchivePointCountQueryVariables>(
		MessageGroupArchivePointCountDocument,
		options,
	);
}
export function useMessageGroupArchivePointCountLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		MessageGroupArchivePointCountQuery,
		MessageGroupArchivePointCountQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<MessageGroupArchivePointCountQuery, MessageGroupArchivePointCountQueryVariables>(
		MessageGroupArchivePointCountDocument,
		options,
	);
}
export function useMessageGroupArchivePointCountSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		MessageGroupArchivePointCountQuery,
		MessageGroupArchivePointCountQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<MessageGroupArchivePointCountQuery, MessageGroupArchivePointCountQueryVariables>(
		MessageGroupArchivePointCountDocument,
		options,
	);
}
export type MessageGroupArchivePointCountQueryHookResult = ReturnType<typeof useMessageGroupArchivePointCountQuery>;
export type MessageGroupArchivePointCountLazyQueryHookResult = ReturnType<
	typeof useMessageGroupArchivePointCountLazyQuery
>;
export type MessageGroupArchivePointCountSuspenseQueryHookResult = ReturnType<
	typeof useMessageGroupArchivePointCountSuspenseQuery
>;
export type MessageGroupArchivePointCountQueryResult = Apollo.QueryResult<
	MessageGroupArchivePointCountQuery,
	MessageGroupArchivePointCountQueryVariables
>;
export const MessageGroupArchivePointCreateDocument = gql`
	mutation messageGroupArchivePointCreate($input: MessageGroupArchivePointCreateInput!) {
		createMessageGroupArchivePoint(input: $input) {
			...MessageGroupArchivePointDetail
		}
	}
	${MessageGroupArchivePointDetailFragmentDoc}
`;
export type MessageGroupArchivePointCreateMutationFn = Apollo.MutationFunction<
	MessageGroupArchivePointCreateMutation,
	MessageGroupArchivePointCreateMutationVariables
>;

/**
 * __useMessageGroupArchivePointCreateMutation__
 *
 * To run a mutation, you first call `useMessageGroupArchivePointCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMessageGroupArchivePointCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [messageGroupArchivePointCreateMutation, { data, loading, error }] = useMessageGroupArchivePointCreateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useMessageGroupArchivePointCreateMutation(
	baseOptions?: Apollo.MutationHookOptions<
		MessageGroupArchivePointCreateMutation,
		MessageGroupArchivePointCreateMutationVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<MessageGroupArchivePointCreateMutation, MessageGroupArchivePointCreateMutationVariables>(
		MessageGroupArchivePointCreateDocument,
		options,
	);
}
export type MessageGroupArchivePointCreateMutationHookResult = ReturnType<
	typeof useMessageGroupArchivePointCreateMutation
>;
export type MessageGroupArchivePointCreateMutationResult =
	Apollo.MutationResult<MessageGroupArchivePointCreateMutation>;
export type MessageGroupArchivePointCreateMutationOptions = Apollo.BaseMutationOptions<
	MessageGroupArchivePointCreateMutation,
	MessageGroupArchivePointCreateMutationVariables
>;
export const MessageGroupArchivePointDeleteDocument = gql`
	mutation messageGroupArchivePointDelete($id: ID!) {
		deleteMessageGroupArchivePoint(id: $id)
	}
`;
export type MessageGroupArchivePointDeleteMutationFn = Apollo.MutationFunction<
	MessageGroupArchivePointDeleteMutation,
	MessageGroupArchivePointDeleteMutationVariables
>;

/**
 * __useMessageGroupArchivePointDeleteMutation__
 *
 * To run a mutation, you first call `useMessageGroupArchivePointDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMessageGroupArchivePointDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [messageGroupArchivePointDeleteMutation, { data, loading, error }] = useMessageGroupArchivePointDeleteMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useMessageGroupArchivePointDeleteMutation(
	baseOptions?: Apollo.MutationHookOptions<
		MessageGroupArchivePointDeleteMutation,
		MessageGroupArchivePointDeleteMutationVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<MessageGroupArchivePointDeleteMutation, MessageGroupArchivePointDeleteMutationVariables>(
		MessageGroupArchivePointDeleteDocument,
		options,
	);
}
export type MessageGroupArchivePointDeleteMutationHookResult = ReturnType<
	typeof useMessageGroupArchivePointDeleteMutation
>;
export type MessageGroupArchivePointDeleteMutationResult =
	Apollo.MutationResult<MessageGroupArchivePointDeleteMutation>;
export type MessageGroupArchivePointDeleteMutationOptions = Apollo.BaseMutationOptions<
	MessageGroupArchivePointDeleteMutation,
	MessageGroupArchivePointDeleteMutationVariables
>;
export const MessageGroupArchivePointDetailDocument = gql`
	query messageGroupArchivePointDetail($id: ID!) {
		messageGroupArchivePoint(id: $id) {
			...MessageGroupArchivePointDetail
		}
	}
	${MessageGroupArchivePointDetailFragmentDoc}
`;

/**
 * __useMessageGroupArchivePointDetailQuery__
 *
 * To run a query within a React component, call `useMessageGroupArchivePointDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useMessageGroupArchivePointDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMessageGroupArchivePointDetailQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useMessageGroupArchivePointDetailQuery(
	baseOptions: Apollo.QueryHookOptions<
		MessageGroupArchivePointDetailQuery,
		MessageGroupArchivePointDetailQueryVariables
	> &
		({ variables: MessageGroupArchivePointDetailQueryVariables; skip?: boolean } | { skip: boolean }),
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<MessageGroupArchivePointDetailQuery, MessageGroupArchivePointDetailQueryVariables>(
		MessageGroupArchivePointDetailDocument,
		options,
	);
}
export function useMessageGroupArchivePointDetailLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		MessageGroupArchivePointDetailQuery,
		MessageGroupArchivePointDetailQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<MessageGroupArchivePointDetailQuery, MessageGroupArchivePointDetailQueryVariables>(
		MessageGroupArchivePointDetailDocument,
		options,
	);
}
export function useMessageGroupArchivePointDetailSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		MessageGroupArchivePointDetailQuery,
		MessageGroupArchivePointDetailQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<MessageGroupArchivePointDetailQuery, MessageGroupArchivePointDetailQueryVariables>(
		MessageGroupArchivePointDetailDocument,
		options,
	);
}
export type MessageGroupArchivePointDetailQueryHookResult = ReturnType<typeof useMessageGroupArchivePointDetailQuery>;
export type MessageGroupArchivePointDetailLazyQueryHookResult = ReturnType<
	typeof useMessageGroupArchivePointDetailLazyQuery
>;
export type MessageGroupArchivePointDetailSuspenseQueryHookResult = ReturnType<
	typeof useMessageGroupArchivePointDetailSuspenseQuery
>;
export type MessageGroupArchivePointDetailQueryResult = Apollo.QueryResult<
	MessageGroupArchivePointDetailQuery,
	MessageGroupArchivePointDetailQueryVariables
>;
export const MessageGroupArchivePointIndexDocument = gql`
	query messageGroupArchivePointIndex(
		$filters: [MessageGroupArchivePointFilterInput!]
		$pagination: Pagination
		$order: MessageGroupArchivePointOrder
	) {
		messageGroupArchivePointConnection(filters: $filters, pagination: $pagination, order: $order) {
			edges {
				node {
					id
					createdAt
				}
			}
		}
	}
`;

/**
 * __useMessageGroupArchivePointIndexQuery__
 *
 * To run a query within a React component, call `useMessageGroupArchivePointIndexQuery` and pass it any options that fit your needs.
 * When your component renders, `useMessageGroupArchivePointIndexQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMessageGroupArchivePointIndexQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useMessageGroupArchivePointIndexQuery(
	baseOptions?: Apollo.QueryHookOptions<
		MessageGroupArchivePointIndexQuery,
		MessageGroupArchivePointIndexQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<MessageGroupArchivePointIndexQuery, MessageGroupArchivePointIndexQueryVariables>(
		MessageGroupArchivePointIndexDocument,
		options,
	);
}
export function useMessageGroupArchivePointIndexLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		MessageGroupArchivePointIndexQuery,
		MessageGroupArchivePointIndexQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<MessageGroupArchivePointIndexQuery, MessageGroupArchivePointIndexQueryVariables>(
		MessageGroupArchivePointIndexDocument,
		options,
	);
}
export function useMessageGroupArchivePointIndexSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		MessageGroupArchivePointIndexQuery,
		MessageGroupArchivePointIndexQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<MessageGroupArchivePointIndexQuery, MessageGroupArchivePointIndexQueryVariables>(
		MessageGroupArchivePointIndexDocument,
		options,
	);
}
export type MessageGroupArchivePointIndexQueryHookResult = ReturnType<typeof useMessageGroupArchivePointIndexQuery>;
export type MessageGroupArchivePointIndexLazyQueryHookResult = ReturnType<
	typeof useMessageGroupArchivePointIndexLazyQuery
>;
export type MessageGroupArchivePointIndexSuspenseQueryHookResult = ReturnType<
	typeof useMessageGroupArchivePointIndexSuspenseQuery
>;
export type MessageGroupArchivePointIndexQueryResult = Apollo.QueryResult<
	MessageGroupArchivePointIndexQuery,
	MessageGroupArchivePointIndexQueryVariables
>;
export const MessageGroupArchivePointListInMessageGroupDocument = gql`
	query messageGroupArchivePointListInMessageGroup(
		$filters: [MessageGroupArchivePointFilterInput!]
		$pagination: Pagination
		$order: MessageGroupArchivePointOrder
	) {
		messageGroupArchivePointConnection(filters: $filters, pagination: $pagination, order: $order) {
			edges {
				node {
					id
					createdAt
					author {
						id
						...UserNameAndImage
					}
				}
			}
		}
	}
	${UserNameAndImageFragmentDoc}
`;

/**
 * __useMessageGroupArchivePointListInMessageGroupQuery__
 *
 * To run a query within a React component, call `useMessageGroupArchivePointListInMessageGroupQuery` and pass it any options that fit your needs.
 * When your component renders, `useMessageGroupArchivePointListInMessageGroupQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMessageGroupArchivePointListInMessageGroupQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useMessageGroupArchivePointListInMessageGroupQuery(
	baseOptions?: Apollo.QueryHookOptions<
		MessageGroupArchivePointListInMessageGroupQuery,
		MessageGroupArchivePointListInMessageGroupQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<
		MessageGroupArchivePointListInMessageGroupQuery,
		MessageGroupArchivePointListInMessageGroupQueryVariables
	>(MessageGroupArchivePointListInMessageGroupDocument, options);
}
export function useMessageGroupArchivePointListInMessageGroupLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		MessageGroupArchivePointListInMessageGroupQuery,
		MessageGroupArchivePointListInMessageGroupQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		MessageGroupArchivePointListInMessageGroupQuery,
		MessageGroupArchivePointListInMessageGroupQueryVariables
	>(MessageGroupArchivePointListInMessageGroupDocument, options);
}
export function useMessageGroupArchivePointListInMessageGroupSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		MessageGroupArchivePointListInMessageGroupQuery,
		MessageGroupArchivePointListInMessageGroupQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<
		MessageGroupArchivePointListInMessageGroupQuery,
		MessageGroupArchivePointListInMessageGroupQueryVariables
	>(MessageGroupArchivePointListInMessageGroupDocument, options);
}
export type MessageGroupArchivePointListInMessageGroupQueryHookResult = ReturnType<
	typeof useMessageGroupArchivePointListInMessageGroupQuery
>;
export type MessageGroupArchivePointListInMessageGroupLazyQueryHookResult = ReturnType<
	typeof useMessageGroupArchivePointListInMessageGroupLazyQuery
>;
export type MessageGroupArchivePointListInMessageGroupSuspenseQueryHookResult = ReturnType<
	typeof useMessageGroupArchivePointListInMessageGroupSuspenseQuery
>;
export type MessageGroupArchivePointListInMessageGroupQueryResult = Apollo.QueryResult<
	MessageGroupArchivePointListInMessageGroupQuery,
	MessageGroupArchivePointListInMessageGroupQueryVariables
>;
export const MessageGroupArchivePointNameDocument = gql`
	query messageGroupArchivePointName($id: ID!) {
		messageGroupArchivePoint(id: $id) {
			id
			...MessageGroupArchivePointName
		}
	}
	${MessageGroupArchivePointNameFragmentDoc}
`;

/**
 * __useMessageGroupArchivePointNameQuery__
 *
 * To run a query within a React component, call `useMessageGroupArchivePointNameQuery` and pass it any options that fit your needs.
 * When your component renders, `useMessageGroupArchivePointNameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMessageGroupArchivePointNameQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useMessageGroupArchivePointNameQuery(
	baseOptions: Apollo.QueryHookOptions<MessageGroupArchivePointNameQuery, MessageGroupArchivePointNameQueryVariables> &
		({ variables: MessageGroupArchivePointNameQueryVariables; skip?: boolean } | { skip: boolean }),
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<MessageGroupArchivePointNameQuery, MessageGroupArchivePointNameQueryVariables>(
		MessageGroupArchivePointNameDocument,
		options,
	);
}
export function useMessageGroupArchivePointNameLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		MessageGroupArchivePointNameQuery,
		MessageGroupArchivePointNameQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<MessageGroupArchivePointNameQuery, MessageGroupArchivePointNameQueryVariables>(
		MessageGroupArchivePointNameDocument,
		options,
	);
}
export function useMessageGroupArchivePointNameSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		MessageGroupArchivePointNameQuery,
		MessageGroupArchivePointNameQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<MessageGroupArchivePointNameQuery, MessageGroupArchivePointNameQueryVariables>(
		MessageGroupArchivePointNameDocument,
		options,
	);
}
export type MessageGroupArchivePointNameQueryHookResult = ReturnType<typeof useMessageGroupArchivePointNameQuery>;
export type MessageGroupArchivePointNameLazyQueryHookResult = ReturnType<
	typeof useMessageGroupArchivePointNameLazyQuery
>;
export type MessageGroupArchivePointNameSuspenseQueryHookResult = ReturnType<
	typeof useMessageGroupArchivePointNameSuspenseQuery
>;
export type MessageGroupArchivePointNameQueryResult = Apollo.QueryResult<
	MessageGroupArchivePointNameQuery,
	MessageGroupArchivePointNameQueryVariables
>;
export const MessageGroupArchivePointNamesDocument = gql`
	query messageGroupArchivePointNames(
		$filters: [MessageGroupArchivePointFilterInput!]
		$pagination: Pagination
		$order: MessageGroupArchivePointOrder
	) {
		messageGroupArchivePointConnection(filters: $filters, pagination: $pagination, order: $order) {
			edges {
				node {
					id
					...MessageGroupArchivePointName
				}
			}
		}
	}
	${MessageGroupArchivePointNameFragmentDoc}
`;

/**
 * __useMessageGroupArchivePointNamesQuery__
 *
 * To run a query within a React component, call `useMessageGroupArchivePointNamesQuery` and pass it any options that fit your needs.
 * When your component renders, `useMessageGroupArchivePointNamesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMessageGroupArchivePointNamesQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useMessageGroupArchivePointNamesQuery(
	baseOptions?: Apollo.QueryHookOptions<
		MessageGroupArchivePointNamesQuery,
		MessageGroupArchivePointNamesQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<MessageGroupArchivePointNamesQuery, MessageGroupArchivePointNamesQueryVariables>(
		MessageGroupArchivePointNamesDocument,
		options,
	);
}
export function useMessageGroupArchivePointNamesLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		MessageGroupArchivePointNamesQuery,
		MessageGroupArchivePointNamesQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<MessageGroupArchivePointNamesQuery, MessageGroupArchivePointNamesQueryVariables>(
		MessageGroupArchivePointNamesDocument,
		options,
	);
}
export function useMessageGroupArchivePointNamesSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		MessageGroupArchivePointNamesQuery,
		MessageGroupArchivePointNamesQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<MessageGroupArchivePointNamesQuery, MessageGroupArchivePointNamesQueryVariables>(
		MessageGroupArchivePointNamesDocument,
		options,
	);
}
export type MessageGroupArchivePointNamesQueryHookResult = ReturnType<typeof useMessageGroupArchivePointNamesQuery>;
export type MessageGroupArchivePointNamesLazyQueryHookResult = ReturnType<
	typeof useMessageGroupArchivePointNamesLazyQuery
>;
export type MessageGroupArchivePointNamesSuspenseQueryHookResult = ReturnType<
	typeof useMessageGroupArchivePointNamesSuspenseQuery
>;
export type MessageGroupArchivePointNamesQueryResult = Apollo.QueryResult<
	MessageGroupArchivePointNamesQuery,
	MessageGroupArchivePointNamesQueryVariables
>;
export const MessageGroupArchivePointPaginationDocument = gql`
	query messageGroupArchivePointPagination(
		$filters: [MessageGroupArchivePointFilterInput!]
		$order: MessageGroupArchivePointOrder
	) {
		messageGroupArchivePointConnection(filters: $filters, order: $order) {
			totalCount
			edges {
				cursor
			}
		}
	}
`;

/**
 * __useMessageGroupArchivePointPaginationQuery__
 *
 * To run a query within a React component, call `useMessageGroupArchivePointPaginationQuery` and pass it any options that fit your needs.
 * When your component renders, `useMessageGroupArchivePointPaginationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMessageGroupArchivePointPaginationQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useMessageGroupArchivePointPaginationQuery(
	baseOptions?: Apollo.QueryHookOptions<
		MessageGroupArchivePointPaginationQuery,
		MessageGroupArchivePointPaginationQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<MessageGroupArchivePointPaginationQuery, MessageGroupArchivePointPaginationQueryVariables>(
		MessageGroupArchivePointPaginationDocument,
		options,
	);
}
export function useMessageGroupArchivePointPaginationLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		MessageGroupArchivePointPaginationQuery,
		MessageGroupArchivePointPaginationQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<MessageGroupArchivePointPaginationQuery, MessageGroupArchivePointPaginationQueryVariables>(
		MessageGroupArchivePointPaginationDocument,
		options,
	);
}
export function useMessageGroupArchivePointPaginationSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		MessageGroupArchivePointPaginationQuery,
		MessageGroupArchivePointPaginationQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<
		MessageGroupArchivePointPaginationQuery,
		MessageGroupArchivePointPaginationQueryVariables
	>(MessageGroupArchivePointPaginationDocument, options);
}
export type MessageGroupArchivePointPaginationQueryHookResult = ReturnType<
	typeof useMessageGroupArchivePointPaginationQuery
>;
export type MessageGroupArchivePointPaginationLazyQueryHookResult = ReturnType<
	typeof useMessageGroupArchivePointPaginationLazyQuery
>;
export type MessageGroupArchivePointPaginationSuspenseQueryHookResult = ReturnType<
	typeof useMessageGroupArchivePointPaginationSuspenseQuery
>;
export type MessageGroupArchivePointPaginationQueryResult = Apollo.QueryResult<
	MessageGroupArchivePointPaginationQuery,
	MessageGroupArchivePointPaginationQueryVariables
>;
export const MessageGroupArchivePointSelectDocument = gql`
	query messageGroupArchivePointSelect(
		$filters: [MessageGroupArchivePointFilterInput!]
		$order: MessageGroupArchivePointOrder
	) {
		messageGroupArchivePointConnection(filters: $filters, order: $order) {
			edges {
				node {
					id
					...MessageGroupArchivePointName
				}
			}
		}
	}
	${MessageGroupArchivePointNameFragmentDoc}
`;

/**
 * __useMessageGroupArchivePointSelectQuery__
 *
 * To run a query within a React component, call `useMessageGroupArchivePointSelectQuery` and pass it any options that fit your needs.
 * When your component renders, `useMessageGroupArchivePointSelectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMessageGroupArchivePointSelectQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useMessageGroupArchivePointSelectQuery(
	baseOptions?: Apollo.QueryHookOptions<
		MessageGroupArchivePointSelectQuery,
		MessageGroupArchivePointSelectQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<MessageGroupArchivePointSelectQuery, MessageGroupArchivePointSelectQueryVariables>(
		MessageGroupArchivePointSelectDocument,
		options,
	);
}
export function useMessageGroupArchivePointSelectLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		MessageGroupArchivePointSelectQuery,
		MessageGroupArchivePointSelectQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<MessageGroupArchivePointSelectQuery, MessageGroupArchivePointSelectQueryVariables>(
		MessageGroupArchivePointSelectDocument,
		options,
	);
}
export function useMessageGroupArchivePointSelectSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		MessageGroupArchivePointSelectQuery,
		MessageGroupArchivePointSelectQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<MessageGroupArchivePointSelectQuery, MessageGroupArchivePointSelectQueryVariables>(
		MessageGroupArchivePointSelectDocument,
		options,
	);
}
export type MessageGroupArchivePointSelectQueryHookResult = ReturnType<typeof useMessageGroupArchivePointSelectQuery>;
export type MessageGroupArchivePointSelectLazyQueryHookResult = ReturnType<
	typeof useMessageGroupArchivePointSelectLazyQuery
>;
export type MessageGroupArchivePointSelectSuspenseQueryHookResult = ReturnType<
	typeof useMessageGroupArchivePointSelectSuspenseQuery
>;
export type MessageGroupArchivePointSelectQueryResult = Apollo.QueryResult<
	MessageGroupArchivePointSelectQuery,
	MessageGroupArchivePointSelectQueryVariables
>;
export const MessageGroupArchivePointUpdateDocument = gql`
	mutation messageGroupArchivePointUpdate($id: ID!, $input: MessageGroupArchivePointUpdateInput!) {
		updateMessageGroupArchivePoint(id: $id, input: $input) {
			...MessageGroupArchivePointDetail
		}
	}
	${MessageGroupArchivePointDetailFragmentDoc}
`;
export type MessageGroupArchivePointUpdateMutationFn = Apollo.MutationFunction<
	MessageGroupArchivePointUpdateMutation,
	MessageGroupArchivePointUpdateMutationVariables
>;

/**
 * __useMessageGroupArchivePointUpdateMutation__
 *
 * To run a mutation, you first call `useMessageGroupArchivePointUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMessageGroupArchivePointUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [messageGroupArchivePointUpdateMutation, { data, loading, error }] = useMessageGroupArchivePointUpdateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useMessageGroupArchivePointUpdateMutation(
	baseOptions?: Apollo.MutationHookOptions<
		MessageGroupArchivePointUpdateMutation,
		MessageGroupArchivePointUpdateMutationVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<MessageGroupArchivePointUpdateMutation, MessageGroupArchivePointUpdateMutationVariables>(
		MessageGroupArchivePointUpdateDocument,
		options,
	);
}
export type MessageGroupArchivePointUpdateMutationHookResult = ReturnType<
	typeof useMessageGroupArchivePointUpdateMutation
>;
export type MessageGroupArchivePointUpdateMutationResult =
	Apollo.MutationResult<MessageGroupArchivePointUpdateMutation>;
export type MessageGroupArchivePointUpdateMutationOptions = Apollo.BaseMutationOptions<
	MessageGroupArchivePointUpdateMutation,
	MessageGroupArchivePointUpdateMutationVariables
>;
export const MessageTopicCountDocument = gql`
	query messageTopicCount($filters: [MessageTopicFilterInput!], $pagination: Pagination, $order: MessageTopicOrder) {
		messageTopicConnection(filters: $filters, pagination: $pagination, order: $order) {
			totalCount
		}
	}
`;

/**
 * __useMessageTopicCountQuery__
 *
 * To run a query within a React component, call `useMessageTopicCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useMessageTopicCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMessageTopicCountQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useMessageTopicCountQuery(
	baseOptions?: Apollo.QueryHookOptions<MessageTopicCountQuery, MessageTopicCountQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<MessageTopicCountQuery, MessageTopicCountQueryVariables>(MessageTopicCountDocument, options);
}
export function useMessageTopicCountLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<MessageTopicCountQuery, MessageTopicCountQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<MessageTopicCountQuery, MessageTopicCountQueryVariables>(
		MessageTopicCountDocument,
		options,
	);
}
export function useMessageTopicCountSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<MessageTopicCountQuery, MessageTopicCountQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<MessageTopicCountQuery, MessageTopicCountQueryVariables>(
		MessageTopicCountDocument,
		options,
	);
}
export type MessageTopicCountQueryHookResult = ReturnType<typeof useMessageTopicCountQuery>;
export type MessageTopicCountLazyQueryHookResult = ReturnType<typeof useMessageTopicCountLazyQuery>;
export type MessageTopicCountSuspenseQueryHookResult = ReturnType<typeof useMessageTopicCountSuspenseQuery>;
export type MessageTopicCountQueryResult = Apollo.QueryResult<MessageTopicCountQuery, MessageTopicCountQueryVariables>;
export const MessageTopicCreateDocument = gql`
	mutation messageTopicCreate($input: MessageTopicCreateInput!) {
		createMessageTopic(input: $input) {
			...MessageTopicDetail
		}
	}
	${MessageTopicDetailFragmentDoc}
`;
export type MessageTopicCreateMutationFn = Apollo.MutationFunction<
	MessageTopicCreateMutation,
	MessageTopicCreateMutationVariables
>;

/**
 * __useMessageTopicCreateMutation__
 *
 * To run a mutation, you first call `useMessageTopicCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMessageTopicCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [messageTopicCreateMutation, { data, loading, error }] = useMessageTopicCreateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useMessageTopicCreateMutation(
	baseOptions?: Apollo.MutationHookOptions<MessageTopicCreateMutation, MessageTopicCreateMutationVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<MessageTopicCreateMutation, MessageTopicCreateMutationVariables>(
		MessageTopicCreateDocument,
		options,
	);
}
export type MessageTopicCreateMutationHookResult = ReturnType<typeof useMessageTopicCreateMutation>;
export type MessageTopicCreateMutationResult = Apollo.MutationResult<MessageTopicCreateMutation>;
export type MessageTopicCreateMutationOptions = Apollo.BaseMutationOptions<
	MessageTopicCreateMutation,
	MessageTopicCreateMutationVariables
>;
export const MessageTopicDeleteDocument = gql`
	mutation messageTopicDelete($id: ID!) {
		deleteMessageTopic(id: $id)
	}
`;
export type MessageTopicDeleteMutationFn = Apollo.MutationFunction<
	MessageTopicDeleteMutation,
	MessageTopicDeleteMutationVariables
>;

/**
 * __useMessageTopicDeleteMutation__
 *
 * To run a mutation, you first call `useMessageTopicDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMessageTopicDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [messageTopicDeleteMutation, { data, loading, error }] = useMessageTopicDeleteMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useMessageTopicDeleteMutation(
	baseOptions?: Apollo.MutationHookOptions<MessageTopicDeleteMutation, MessageTopicDeleteMutationVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<MessageTopicDeleteMutation, MessageTopicDeleteMutationVariables>(
		MessageTopicDeleteDocument,
		options,
	);
}
export type MessageTopicDeleteMutationHookResult = ReturnType<typeof useMessageTopicDeleteMutation>;
export type MessageTopicDeleteMutationResult = Apollo.MutationResult<MessageTopicDeleteMutation>;
export type MessageTopicDeleteMutationOptions = Apollo.BaseMutationOptions<
	MessageTopicDeleteMutation,
	MessageTopicDeleteMutationVariables
>;
export const MessageTopicDetailDocument = gql`
	query messageTopicDetail($id: ID!) {
		messageTopic(id: $id) {
			...MessageTopicDetail
		}
	}
	${MessageTopicDetailFragmentDoc}
`;

/**
 * __useMessageTopicDetailQuery__
 *
 * To run a query within a React component, call `useMessageTopicDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useMessageTopicDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMessageTopicDetailQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useMessageTopicDetailQuery(
	baseOptions: Apollo.QueryHookOptions<MessageTopicDetailQuery, MessageTopicDetailQueryVariables> &
		({ variables: MessageTopicDetailQueryVariables; skip?: boolean } | { skip: boolean }),
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<MessageTopicDetailQuery, MessageTopicDetailQueryVariables>(
		MessageTopicDetailDocument,
		options,
	);
}
export function useMessageTopicDetailLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<MessageTopicDetailQuery, MessageTopicDetailQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<MessageTopicDetailQuery, MessageTopicDetailQueryVariables>(
		MessageTopicDetailDocument,
		options,
	);
}
export function useMessageTopicDetailSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<MessageTopicDetailQuery, MessageTopicDetailQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<MessageTopicDetailQuery, MessageTopicDetailQueryVariables>(
		MessageTopicDetailDocument,
		options,
	);
}
export type MessageTopicDetailQueryHookResult = ReturnType<typeof useMessageTopicDetailQuery>;
export type MessageTopicDetailLazyQueryHookResult = ReturnType<typeof useMessageTopicDetailLazyQuery>;
export type MessageTopicDetailSuspenseQueryHookResult = ReturnType<typeof useMessageTopicDetailSuspenseQuery>;
export type MessageTopicDetailQueryResult = Apollo.QueryResult<
	MessageTopicDetailQuery,
	MessageTopicDetailQueryVariables
>;
export const MessageTopicIndexDocument = gql`
	query messageTopicIndex($filters: [MessageTopicFilterInput!], $pagination: Pagination, $order: MessageTopicOrder) {
		messageTopicConnection(filters: $filters, pagination: $pagination, order: $order) {
			edges {
				node {
					id
					name
				}
			}
		}
	}
`;

/**
 * __useMessageTopicIndexQuery__
 *
 * To run a query within a React component, call `useMessageTopicIndexQuery` and pass it any options that fit your needs.
 * When your component renders, `useMessageTopicIndexQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMessageTopicIndexQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useMessageTopicIndexQuery(
	baseOptions?: Apollo.QueryHookOptions<MessageTopicIndexQuery, MessageTopicIndexQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<MessageTopicIndexQuery, MessageTopicIndexQueryVariables>(MessageTopicIndexDocument, options);
}
export function useMessageTopicIndexLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<MessageTopicIndexQuery, MessageTopicIndexQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<MessageTopicIndexQuery, MessageTopicIndexQueryVariables>(
		MessageTopicIndexDocument,
		options,
	);
}
export function useMessageTopicIndexSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<MessageTopicIndexQuery, MessageTopicIndexQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<MessageTopicIndexQuery, MessageTopicIndexQueryVariables>(
		MessageTopicIndexDocument,
		options,
	);
}
export type MessageTopicIndexQueryHookResult = ReturnType<typeof useMessageTopicIndexQuery>;
export type MessageTopicIndexLazyQueryHookResult = ReturnType<typeof useMessageTopicIndexLazyQuery>;
export type MessageTopicIndexSuspenseQueryHookResult = ReturnType<typeof useMessageTopicIndexSuspenseQuery>;
export type MessageTopicIndexQueryResult = Apollo.QueryResult<MessageTopicIndexQuery, MessageTopicIndexQueryVariables>;
export const MessageTopicNameDocument = gql`
	query messageTopicName($id: ID!) {
		messageTopic(id: $id) {
			id
			...MessageTopicName
		}
	}
	${MessageTopicNameFragmentDoc}
`;

/**
 * __useMessageTopicNameQuery__
 *
 * To run a query within a React component, call `useMessageTopicNameQuery` and pass it any options that fit your needs.
 * When your component renders, `useMessageTopicNameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMessageTopicNameQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useMessageTopicNameQuery(
	baseOptions: Apollo.QueryHookOptions<MessageTopicNameQuery, MessageTopicNameQueryVariables> &
		({ variables: MessageTopicNameQueryVariables; skip?: boolean } | { skip: boolean }),
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<MessageTopicNameQuery, MessageTopicNameQueryVariables>(MessageTopicNameDocument, options);
}
export function useMessageTopicNameLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<MessageTopicNameQuery, MessageTopicNameQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<MessageTopicNameQuery, MessageTopicNameQueryVariables>(MessageTopicNameDocument, options);
}
export function useMessageTopicNameSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<MessageTopicNameQuery, MessageTopicNameQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<MessageTopicNameQuery, MessageTopicNameQueryVariables>(
		MessageTopicNameDocument,
		options,
	);
}
export type MessageTopicNameQueryHookResult = ReturnType<typeof useMessageTopicNameQuery>;
export type MessageTopicNameLazyQueryHookResult = ReturnType<typeof useMessageTopicNameLazyQuery>;
export type MessageTopicNameSuspenseQueryHookResult = ReturnType<typeof useMessageTopicNameSuspenseQuery>;
export type MessageTopicNameQueryResult = Apollo.QueryResult<MessageTopicNameQuery, MessageTopicNameQueryVariables>;
export const MessageTopicNamesDocument = gql`
	query messageTopicNames($filters: [MessageTopicFilterInput!], $pagination: Pagination, $order: MessageTopicOrder) {
		messageTopicConnection(filters: $filters, pagination: $pagination, order: $order) {
			edges {
				node {
					id
					...MessageTopicName
				}
			}
		}
	}
	${MessageTopicNameFragmentDoc}
`;

/**
 * __useMessageTopicNamesQuery__
 *
 * To run a query within a React component, call `useMessageTopicNamesQuery` and pass it any options that fit your needs.
 * When your component renders, `useMessageTopicNamesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMessageTopicNamesQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useMessageTopicNamesQuery(
	baseOptions?: Apollo.QueryHookOptions<MessageTopicNamesQuery, MessageTopicNamesQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<MessageTopicNamesQuery, MessageTopicNamesQueryVariables>(MessageTopicNamesDocument, options);
}
export function useMessageTopicNamesLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<MessageTopicNamesQuery, MessageTopicNamesQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<MessageTopicNamesQuery, MessageTopicNamesQueryVariables>(
		MessageTopicNamesDocument,
		options,
	);
}
export function useMessageTopicNamesSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<MessageTopicNamesQuery, MessageTopicNamesQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<MessageTopicNamesQuery, MessageTopicNamesQueryVariables>(
		MessageTopicNamesDocument,
		options,
	);
}
export type MessageTopicNamesQueryHookResult = ReturnType<typeof useMessageTopicNamesQuery>;
export type MessageTopicNamesLazyQueryHookResult = ReturnType<typeof useMessageTopicNamesLazyQuery>;
export type MessageTopicNamesSuspenseQueryHookResult = ReturnType<typeof useMessageTopicNamesSuspenseQuery>;
export type MessageTopicNamesQueryResult = Apollo.QueryResult<MessageTopicNamesQuery, MessageTopicNamesQueryVariables>;
export const MessageTopicPaginationDocument = gql`
	query messageTopicPagination($filters: [MessageTopicFilterInput!], $order: MessageTopicOrder) {
		messageTopicConnection(filters: $filters, order: $order) {
			totalCount
			edges {
				cursor
			}
		}
	}
`;

/**
 * __useMessageTopicPaginationQuery__
 *
 * To run a query within a React component, call `useMessageTopicPaginationQuery` and pass it any options that fit your needs.
 * When your component renders, `useMessageTopicPaginationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMessageTopicPaginationQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useMessageTopicPaginationQuery(
	baseOptions?: Apollo.QueryHookOptions<MessageTopicPaginationQuery, MessageTopicPaginationQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<MessageTopicPaginationQuery, MessageTopicPaginationQueryVariables>(
		MessageTopicPaginationDocument,
		options,
	);
}
export function useMessageTopicPaginationLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<MessageTopicPaginationQuery, MessageTopicPaginationQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<MessageTopicPaginationQuery, MessageTopicPaginationQueryVariables>(
		MessageTopicPaginationDocument,
		options,
	);
}
export function useMessageTopicPaginationSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<MessageTopicPaginationQuery, MessageTopicPaginationQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<MessageTopicPaginationQuery, MessageTopicPaginationQueryVariables>(
		MessageTopicPaginationDocument,
		options,
	);
}
export type MessageTopicPaginationQueryHookResult = ReturnType<typeof useMessageTopicPaginationQuery>;
export type MessageTopicPaginationLazyQueryHookResult = ReturnType<typeof useMessageTopicPaginationLazyQuery>;
export type MessageTopicPaginationSuspenseQueryHookResult = ReturnType<typeof useMessageTopicPaginationSuspenseQuery>;
export type MessageTopicPaginationQueryResult = Apollo.QueryResult<
	MessageTopicPaginationQuery,
	MessageTopicPaginationQueryVariables
>;
export const MessageTopicSelectDocument = gql`
	query messageTopicSelect($filters: [MessageTopicFilterInput!], $order: MessageTopicOrder) {
		messageTopicConnection(filters: $filters, order: $order) {
			edges {
				node {
					id
					...MessageTopicName
				}
			}
		}
	}
	${MessageTopicNameFragmentDoc}
`;

/**
 * __useMessageTopicSelectQuery__
 *
 * To run a query within a React component, call `useMessageTopicSelectQuery` and pass it any options that fit your needs.
 * When your component renders, `useMessageTopicSelectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMessageTopicSelectQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useMessageTopicSelectQuery(
	baseOptions?: Apollo.QueryHookOptions<MessageTopicSelectQuery, MessageTopicSelectQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<MessageTopicSelectQuery, MessageTopicSelectQueryVariables>(
		MessageTopicSelectDocument,
		options,
	);
}
export function useMessageTopicSelectLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<MessageTopicSelectQuery, MessageTopicSelectQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<MessageTopicSelectQuery, MessageTopicSelectQueryVariables>(
		MessageTopicSelectDocument,
		options,
	);
}
export function useMessageTopicSelectSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<MessageTopicSelectQuery, MessageTopicSelectQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<MessageTopicSelectQuery, MessageTopicSelectQueryVariables>(
		MessageTopicSelectDocument,
		options,
	);
}
export type MessageTopicSelectQueryHookResult = ReturnType<typeof useMessageTopicSelectQuery>;
export type MessageTopicSelectLazyQueryHookResult = ReturnType<typeof useMessageTopicSelectLazyQuery>;
export type MessageTopicSelectSuspenseQueryHookResult = ReturnType<typeof useMessageTopicSelectSuspenseQuery>;
export type MessageTopicSelectQueryResult = Apollo.QueryResult<
	MessageTopicSelectQuery,
	MessageTopicSelectQueryVariables
>;
export const MessageTopicUpdateDocument = gql`
	mutation messageTopicUpdate($id: ID!, $input: MessageTopicUpdateInput!) {
		updateMessageTopic(id: $id, input: $input) {
			...MessageTopicDetail
		}
	}
	${MessageTopicDetailFragmentDoc}
`;
export type MessageTopicUpdateMutationFn = Apollo.MutationFunction<
	MessageTopicUpdateMutation,
	MessageTopicUpdateMutationVariables
>;

/**
 * __useMessageTopicUpdateMutation__
 *
 * To run a mutation, you first call `useMessageTopicUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMessageTopicUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [messageTopicUpdateMutation, { data, loading, error }] = useMessageTopicUpdateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useMessageTopicUpdateMutation(
	baseOptions?: Apollo.MutationHookOptions<MessageTopicUpdateMutation, MessageTopicUpdateMutationVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<MessageTopicUpdateMutation, MessageTopicUpdateMutationVariables>(
		MessageTopicUpdateDocument,
		options,
	);
}
export type MessageTopicUpdateMutationHookResult = ReturnType<typeof useMessageTopicUpdateMutation>;
export type MessageTopicUpdateMutationResult = Apollo.MutationResult<MessageTopicUpdateMutation>;
export type MessageTopicUpdateMutationOptions = Apollo.BaseMutationOptions<
	MessageTopicUpdateMutation,
	MessageTopicUpdateMutationVariables
>;
export const NewsletterCountDocument = gql`
	query newsletterCount($filters: [NewsletterFilterInput!], $pagination: Pagination, $order: NewsletterOrder) {
		newsletterConnection(filters: $filters, pagination: $pagination, order: $order) {
			totalCount
		}
	}
`;

/**
 * __useNewsletterCountQuery__
 *
 * To run a query within a React component, call `useNewsletterCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useNewsletterCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNewsletterCountQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useNewsletterCountQuery(
	baseOptions?: Apollo.QueryHookOptions<NewsletterCountQuery, NewsletterCountQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<NewsletterCountQuery, NewsletterCountQueryVariables>(NewsletterCountDocument, options);
}
export function useNewsletterCountLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<NewsletterCountQuery, NewsletterCountQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<NewsletterCountQuery, NewsletterCountQueryVariables>(NewsletterCountDocument, options);
}
export function useNewsletterCountSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<NewsletterCountQuery, NewsletterCountQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<NewsletterCountQuery, NewsletterCountQueryVariables>(NewsletterCountDocument, options);
}
export type NewsletterCountQueryHookResult = ReturnType<typeof useNewsletterCountQuery>;
export type NewsletterCountLazyQueryHookResult = ReturnType<typeof useNewsletterCountLazyQuery>;
export type NewsletterCountSuspenseQueryHookResult = ReturnType<typeof useNewsletterCountSuspenseQuery>;
export type NewsletterCountQueryResult = Apollo.QueryResult<NewsletterCountQuery, NewsletterCountQueryVariables>;
export const NewsletterCreateDocument = gql`
	mutation newsletterCreate($input: NewsletterCreateInput!) {
		createNewsletter(input: $input) {
			...NewsletterDetail
		}
	}
	${NewsletterDetailFragmentDoc}
`;
export type NewsletterCreateMutationFn = Apollo.MutationFunction<
	NewsletterCreateMutation,
	NewsletterCreateMutationVariables
>;

/**
 * __useNewsletterCreateMutation__
 *
 * To run a mutation, you first call `useNewsletterCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useNewsletterCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [newsletterCreateMutation, { data, loading, error }] = useNewsletterCreateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useNewsletterCreateMutation(
	baseOptions?: Apollo.MutationHookOptions<NewsletterCreateMutation, NewsletterCreateMutationVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<NewsletterCreateMutation, NewsletterCreateMutationVariables>(
		NewsletterCreateDocument,
		options,
	);
}
export type NewsletterCreateMutationHookResult = ReturnType<typeof useNewsletterCreateMutation>;
export type NewsletterCreateMutationResult = Apollo.MutationResult<NewsletterCreateMutation>;
export type NewsletterCreateMutationOptions = Apollo.BaseMutationOptions<
	NewsletterCreateMutation,
	NewsletterCreateMutationVariables
>;
export const NewsletterDeleteDocument = gql`
	mutation newsletterDelete($id: ID!) {
		deleteNewsletter(id: $id)
	}
`;
export type NewsletterDeleteMutationFn = Apollo.MutationFunction<
	NewsletterDeleteMutation,
	NewsletterDeleteMutationVariables
>;

/**
 * __useNewsletterDeleteMutation__
 *
 * To run a mutation, you first call `useNewsletterDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useNewsletterDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [newsletterDeleteMutation, { data, loading, error }] = useNewsletterDeleteMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useNewsletterDeleteMutation(
	baseOptions?: Apollo.MutationHookOptions<NewsletterDeleteMutation, NewsletterDeleteMutationVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<NewsletterDeleteMutation, NewsletterDeleteMutationVariables>(
		NewsletterDeleteDocument,
		options,
	);
}
export type NewsletterDeleteMutationHookResult = ReturnType<typeof useNewsletterDeleteMutation>;
export type NewsletterDeleteMutationResult = Apollo.MutationResult<NewsletterDeleteMutation>;
export type NewsletterDeleteMutationOptions = Apollo.BaseMutationOptions<
	NewsletterDeleteMutation,
	NewsletterDeleteMutationVariables
>;
export const NewsletterDetailDocument = gql`
	query newsletterDetail($id: ID!) {
		newsletter(id: $id) {
			...NewsletterDetail
		}
	}
	${NewsletterDetailFragmentDoc}
`;

/**
 * __useNewsletterDetailQuery__
 *
 * To run a query within a React component, call `useNewsletterDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useNewsletterDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNewsletterDetailQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useNewsletterDetailQuery(
	baseOptions: Apollo.QueryHookOptions<NewsletterDetailQuery, NewsletterDetailQueryVariables> &
		({ variables: NewsletterDetailQueryVariables; skip?: boolean } | { skip: boolean }),
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<NewsletterDetailQuery, NewsletterDetailQueryVariables>(NewsletterDetailDocument, options);
}
export function useNewsletterDetailLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<NewsletterDetailQuery, NewsletterDetailQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<NewsletterDetailQuery, NewsletterDetailQueryVariables>(NewsletterDetailDocument, options);
}
export function useNewsletterDetailSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<NewsletterDetailQuery, NewsletterDetailQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<NewsletterDetailQuery, NewsletterDetailQueryVariables>(
		NewsletterDetailDocument,
		options,
	);
}
export type NewsletterDetailQueryHookResult = ReturnType<typeof useNewsletterDetailQuery>;
export type NewsletterDetailLazyQueryHookResult = ReturnType<typeof useNewsletterDetailLazyQuery>;
export type NewsletterDetailSuspenseQueryHookResult = ReturnType<typeof useNewsletterDetailSuspenseQuery>;
export type NewsletterDetailQueryResult = Apollo.QueryResult<NewsletterDetailQuery, NewsletterDetailQueryVariables>;
export const NewsletterDisplayListDocument = gql`
	query newsletterDisplayList($filters: [NewsletterFilterInput!], $pagination: Pagination, $order: NewsletterOrder) {
		newsletterConnection(filters: $filters, pagination: $pagination, order: $order) {
			edges {
				node {
					...NewsletterDisplayListItem
				}
			}
		}
	}
	${NewsletterDisplayListItemFragmentDoc}
`;

/**
 * __useNewsletterDisplayListQuery__
 *
 * To run a query within a React component, call `useNewsletterDisplayListQuery` and pass it any options that fit your needs.
 * When your component renders, `useNewsletterDisplayListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNewsletterDisplayListQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useNewsletterDisplayListQuery(
	baseOptions?: Apollo.QueryHookOptions<NewsletterDisplayListQuery, NewsletterDisplayListQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<NewsletterDisplayListQuery, NewsletterDisplayListQueryVariables>(
		NewsletterDisplayListDocument,
		options,
	);
}
export function useNewsletterDisplayListLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<NewsletterDisplayListQuery, NewsletterDisplayListQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<NewsletterDisplayListQuery, NewsletterDisplayListQueryVariables>(
		NewsletterDisplayListDocument,
		options,
	);
}
export function useNewsletterDisplayListSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<NewsletterDisplayListQuery, NewsletterDisplayListQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<NewsletterDisplayListQuery, NewsletterDisplayListQueryVariables>(
		NewsletterDisplayListDocument,
		options,
	);
}
export type NewsletterDisplayListQueryHookResult = ReturnType<typeof useNewsletterDisplayListQuery>;
export type NewsletterDisplayListLazyQueryHookResult = ReturnType<typeof useNewsletterDisplayListLazyQuery>;
export type NewsletterDisplayListSuspenseQueryHookResult = ReturnType<typeof useNewsletterDisplayListSuspenseQuery>;
export type NewsletterDisplayListQueryResult = Apollo.QueryResult<
	NewsletterDisplayListQuery,
	NewsletterDisplayListQueryVariables
>;
export const NewsletterIndexDocument = gql`
	query newsletterIndex($filters: [NewsletterFilterInput!], $pagination: Pagination, $order: NewsletterOrder) {
		newsletterConnection(filters: $filters, pagination: $pagination, order: $order) {
			edges {
				node {
					id
					title
					imageURL
					imageContentType
					body
					releaseAt
					author {
						id
						...UserName
					}
				}
			}
		}
	}
	${UserNameFragmentDoc}
`;

/**
 * __useNewsletterIndexQuery__
 *
 * To run a query within a React component, call `useNewsletterIndexQuery` and pass it any options that fit your needs.
 * When your component renders, `useNewsletterIndexQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNewsletterIndexQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useNewsletterIndexQuery(
	baseOptions?: Apollo.QueryHookOptions<NewsletterIndexQuery, NewsletterIndexQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<NewsletterIndexQuery, NewsletterIndexQueryVariables>(NewsletterIndexDocument, options);
}
export function useNewsletterIndexLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<NewsletterIndexQuery, NewsletterIndexQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<NewsletterIndexQuery, NewsletterIndexQueryVariables>(NewsletterIndexDocument, options);
}
export function useNewsletterIndexSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<NewsletterIndexQuery, NewsletterIndexQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<NewsletterIndexQuery, NewsletterIndexQueryVariables>(NewsletterIndexDocument, options);
}
export type NewsletterIndexQueryHookResult = ReturnType<typeof useNewsletterIndexQuery>;
export type NewsletterIndexLazyQueryHookResult = ReturnType<typeof useNewsletterIndexLazyQuery>;
export type NewsletterIndexSuspenseQueryHookResult = ReturnType<typeof useNewsletterIndexSuspenseQuery>;
export type NewsletterIndexQueryResult = Apollo.QueryResult<NewsletterIndexQuery, NewsletterIndexQueryVariables>;
export const NewsletterNameDocument = gql`
	query newsletterName($id: ID!) {
		newsletter(id: $id) {
			id
			...NewsletterName
		}
	}
	${NewsletterNameFragmentDoc}
`;

/**
 * __useNewsletterNameQuery__
 *
 * To run a query within a React component, call `useNewsletterNameQuery` and pass it any options that fit your needs.
 * When your component renders, `useNewsletterNameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNewsletterNameQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useNewsletterNameQuery(
	baseOptions: Apollo.QueryHookOptions<NewsletterNameQuery, NewsletterNameQueryVariables> &
		({ variables: NewsletterNameQueryVariables; skip?: boolean } | { skip: boolean }),
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<NewsletterNameQuery, NewsletterNameQueryVariables>(NewsletterNameDocument, options);
}
export function useNewsletterNameLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<NewsletterNameQuery, NewsletterNameQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<NewsletterNameQuery, NewsletterNameQueryVariables>(NewsletterNameDocument, options);
}
export function useNewsletterNameSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<NewsletterNameQuery, NewsletterNameQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<NewsletterNameQuery, NewsletterNameQueryVariables>(NewsletterNameDocument, options);
}
export type NewsletterNameQueryHookResult = ReturnType<typeof useNewsletterNameQuery>;
export type NewsletterNameLazyQueryHookResult = ReturnType<typeof useNewsletterNameLazyQuery>;
export type NewsletterNameSuspenseQueryHookResult = ReturnType<typeof useNewsletterNameSuspenseQuery>;
export type NewsletterNameQueryResult = Apollo.QueryResult<NewsletterNameQuery, NewsletterNameQueryVariables>;
export const NewsletterNamesDocument = gql`
	query newsletterNames($filters: [NewsletterFilterInput!], $pagination: Pagination, $order: NewsletterOrder) {
		newsletterConnection(filters: $filters, pagination: $pagination, order: $order) {
			edges {
				node {
					id
					...NewsletterName
				}
			}
		}
	}
	${NewsletterNameFragmentDoc}
`;

/**
 * __useNewsletterNamesQuery__
 *
 * To run a query within a React component, call `useNewsletterNamesQuery` and pass it any options that fit your needs.
 * When your component renders, `useNewsletterNamesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNewsletterNamesQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useNewsletterNamesQuery(
	baseOptions?: Apollo.QueryHookOptions<NewsletterNamesQuery, NewsletterNamesQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<NewsletterNamesQuery, NewsletterNamesQueryVariables>(NewsletterNamesDocument, options);
}
export function useNewsletterNamesLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<NewsletterNamesQuery, NewsletterNamesQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<NewsletterNamesQuery, NewsletterNamesQueryVariables>(NewsletterNamesDocument, options);
}
export function useNewsletterNamesSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<NewsletterNamesQuery, NewsletterNamesQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<NewsletterNamesQuery, NewsletterNamesQueryVariables>(NewsletterNamesDocument, options);
}
export type NewsletterNamesQueryHookResult = ReturnType<typeof useNewsletterNamesQuery>;
export type NewsletterNamesLazyQueryHookResult = ReturnType<typeof useNewsletterNamesLazyQuery>;
export type NewsletterNamesSuspenseQueryHookResult = ReturnType<typeof useNewsletterNamesSuspenseQuery>;
export type NewsletterNamesQueryResult = Apollo.QueryResult<NewsletterNamesQuery, NewsletterNamesQueryVariables>;
export const NewsletterPaginationDocument = gql`
	query newsletterPagination($filters: [NewsletterFilterInput!], $order: NewsletterOrder) {
		newsletterConnection(filters: $filters, order: $order) {
			totalCount
			edges {
				cursor
			}
		}
	}
`;

/**
 * __useNewsletterPaginationQuery__
 *
 * To run a query within a React component, call `useNewsletterPaginationQuery` and pass it any options that fit your needs.
 * When your component renders, `useNewsletterPaginationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNewsletterPaginationQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useNewsletterPaginationQuery(
	baseOptions?: Apollo.QueryHookOptions<NewsletterPaginationQuery, NewsletterPaginationQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<NewsletterPaginationQuery, NewsletterPaginationQueryVariables>(
		NewsletterPaginationDocument,
		options,
	);
}
export function useNewsletterPaginationLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<NewsletterPaginationQuery, NewsletterPaginationQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<NewsletterPaginationQuery, NewsletterPaginationQueryVariables>(
		NewsletterPaginationDocument,
		options,
	);
}
export function useNewsletterPaginationSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<NewsletterPaginationQuery, NewsletterPaginationQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<NewsletterPaginationQuery, NewsletterPaginationQueryVariables>(
		NewsletterPaginationDocument,
		options,
	);
}
export type NewsletterPaginationQueryHookResult = ReturnType<typeof useNewsletterPaginationQuery>;
export type NewsletterPaginationLazyQueryHookResult = ReturnType<typeof useNewsletterPaginationLazyQuery>;
export type NewsletterPaginationSuspenseQueryHookResult = ReturnType<typeof useNewsletterPaginationSuspenseQuery>;
export type NewsletterPaginationQueryResult = Apollo.QueryResult<
	NewsletterPaginationQuery,
	NewsletterPaginationQueryVariables
>;
export const NewsletterSelectDocument = gql`
	query newsletterSelect($filters: [NewsletterFilterInput!], $order: NewsletterOrder) {
		newsletterConnection(filters: $filters, order: $order) {
			edges {
				node {
					id
					...NewsletterName
				}
			}
		}
	}
	${NewsletterNameFragmentDoc}
`;

/**
 * __useNewsletterSelectQuery__
 *
 * To run a query within a React component, call `useNewsletterSelectQuery` and pass it any options that fit your needs.
 * When your component renders, `useNewsletterSelectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNewsletterSelectQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useNewsletterSelectQuery(
	baseOptions?: Apollo.QueryHookOptions<NewsletterSelectQuery, NewsletterSelectQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<NewsletterSelectQuery, NewsletterSelectQueryVariables>(NewsletterSelectDocument, options);
}
export function useNewsletterSelectLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<NewsletterSelectQuery, NewsletterSelectQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<NewsletterSelectQuery, NewsletterSelectQueryVariables>(NewsletterSelectDocument, options);
}
export function useNewsletterSelectSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<NewsletterSelectQuery, NewsletterSelectQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<NewsletterSelectQuery, NewsletterSelectQueryVariables>(
		NewsletterSelectDocument,
		options,
	);
}
export type NewsletterSelectQueryHookResult = ReturnType<typeof useNewsletterSelectQuery>;
export type NewsletterSelectLazyQueryHookResult = ReturnType<typeof useNewsletterSelectLazyQuery>;
export type NewsletterSelectSuspenseQueryHookResult = ReturnType<typeof useNewsletterSelectSuspenseQuery>;
export type NewsletterSelectQueryResult = Apollo.QueryResult<NewsletterSelectQuery, NewsletterSelectQueryVariables>;
export const NewsletterSocialItemsDocument = gql`
	query newsletterSocialItems($id: ID!) {
		newsletter(id: $id) {
			id
			socialReactions(order: { field: CREATED_AT, direction: DESC }) {
				id
				reaction
				author {
					id
					...UserName
					isCurrent
				}
			}
			socialComments(order: { field: CREATED_AT, direction: DESC }) {
				id
				body
				createdAt
				author {
					id
					...UserNameAndImage
					isCurrent
				}
			}
		}
	}
	${UserNameFragmentDoc}
	${UserNameAndImageFragmentDoc}
`;

/**
 * __useNewsletterSocialItemsQuery__
 *
 * To run a query within a React component, call `useNewsletterSocialItemsQuery` and pass it any options that fit your needs.
 * When your component renders, `useNewsletterSocialItemsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNewsletterSocialItemsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useNewsletterSocialItemsQuery(
	baseOptions: Apollo.QueryHookOptions<NewsletterSocialItemsQuery, NewsletterSocialItemsQueryVariables> &
		({ variables: NewsletterSocialItemsQueryVariables; skip?: boolean } | { skip: boolean }),
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<NewsletterSocialItemsQuery, NewsletterSocialItemsQueryVariables>(
		NewsletterSocialItemsDocument,
		options,
	);
}
export function useNewsletterSocialItemsLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<NewsletterSocialItemsQuery, NewsletterSocialItemsQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<NewsletterSocialItemsQuery, NewsletterSocialItemsQueryVariables>(
		NewsletterSocialItemsDocument,
		options,
	);
}
export function useNewsletterSocialItemsSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<NewsletterSocialItemsQuery, NewsletterSocialItemsQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<NewsletterSocialItemsQuery, NewsletterSocialItemsQueryVariables>(
		NewsletterSocialItemsDocument,
		options,
	);
}
export type NewsletterSocialItemsQueryHookResult = ReturnType<typeof useNewsletterSocialItemsQuery>;
export type NewsletterSocialItemsLazyQueryHookResult = ReturnType<typeof useNewsletterSocialItemsLazyQuery>;
export type NewsletterSocialItemsSuspenseQueryHookResult = ReturnType<typeof useNewsletterSocialItemsSuspenseQuery>;
export type NewsletterSocialItemsQueryResult = Apollo.QueryResult<
	NewsletterSocialItemsQuery,
	NewsletterSocialItemsQueryVariables
>;
export const NewsletterStatisticsDocument = gql`
	query newsletterStatistics($filters: [NewsletterFilterInput!]) {
		newsletterStatistics(filters: $filters) {
			count
			views
			reactions
			comments
		}
	}
`;

/**
 * __useNewsletterStatisticsQuery__
 *
 * To run a query within a React component, call `useNewsletterStatisticsQuery` and pass it any options that fit your needs.
 * When your component renders, `useNewsletterStatisticsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNewsletterStatisticsQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useNewsletterStatisticsQuery(
	baseOptions?: Apollo.QueryHookOptions<NewsletterStatisticsQuery, NewsletterStatisticsQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<NewsletterStatisticsQuery, NewsletterStatisticsQueryVariables>(
		NewsletterStatisticsDocument,
		options,
	);
}
export function useNewsletterStatisticsLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<NewsletterStatisticsQuery, NewsletterStatisticsQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<NewsletterStatisticsQuery, NewsletterStatisticsQueryVariables>(
		NewsletterStatisticsDocument,
		options,
	);
}
export function useNewsletterStatisticsSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<NewsletterStatisticsQuery, NewsletterStatisticsQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<NewsletterStatisticsQuery, NewsletterStatisticsQueryVariables>(
		NewsletterStatisticsDocument,
		options,
	);
}
export type NewsletterStatisticsQueryHookResult = ReturnType<typeof useNewsletterStatisticsQuery>;
export type NewsletterStatisticsLazyQueryHookResult = ReturnType<typeof useNewsletterStatisticsLazyQuery>;
export type NewsletterStatisticsSuspenseQueryHookResult = ReturnType<typeof useNewsletterStatisticsSuspenseQuery>;
export type NewsletterStatisticsQueryResult = Apollo.QueryResult<
	NewsletterStatisticsQuery,
	NewsletterStatisticsQueryVariables
>;
export const NewsletterUpdateDocument = gql`
	mutation newsletterUpdate($id: ID!, $input: NewsletterUpdateInput!) {
		updateNewsletter(id: $id, input: $input) {
			...NewsletterDetail
		}
	}
	${NewsletterDetailFragmentDoc}
`;
export type NewsletterUpdateMutationFn = Apollo.MutationFunction<
	NewsletterUpdateMutation,
	NewsletterUpdateMutationVariables
>;

/**
 * __useNewsletterUpdateMutation__
 *
 * To run a mutation, you first call `useNewsletterUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useNewsletterUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [newsletterUpdateMutation, { data, loading, error }] = useNewsletterUpdateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useNewsletterUpdateMutation(
	baseOptions?: Apollo.MutationHookOptions<NewsletterUpdateMutation, NewsletterUpdateMutationVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<NewsletterUpdateMutation, NewsletterUpdateMutationVariables>(
		NewsletterUpdateDocument,
		options,
	);
}
export type NewsletterUpdateMutationHookResult = ReturnType<typeof useNewsletterUpdateMutation>;
export type NewsletterUpdateMutationResult = Apollo.MutationResult<NewsletterUpdateMutation>;
export type NewsletterUpdateMutationOptions = Apollo.BaseMutationOptions<
	NewsletterUpdateMutation,
	NewsletterUpdateMutationVariables
>;
export const PermissionCountDocument = gql`
	query permissionCount($filters: [PermissionFilterInput!], $pagination: Pagination, $order: PermissionOrder) {
		permissionConnection(filters: $filters, pagination: $pagination, order: $order) {
			totalCount
		}
	}
`;

/**
 * __usePermissionCountQuery__
 *
 * To run a query within a React component, call `usePermissionCountQuery` and pass it any options that fit your needs.
 * When your component renders, `usePermissionCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePermissionCountQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function usePermissionCountQuery(
	baseOptions?: Apollo.QueryHookOptions<PermissionCountQuery, PermissionCountQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<PermissionCountQuery, PermissionCountQueryVariables>(PermissionCountDocument, options);
}
export function usePermissionCountLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<PermissionCountQuery, PermissionCountQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<PermissionCountQuery, PermissionCountQueryVariables>(PermissionCountDocument, options);
}
export function usePermissionCountSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<PermissionCountQuery, PermissionCountQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<PermissionCountQuery, PermissionCountQueryVariables>(PermissionCountDocument, options);
}
export type PermissionCountQueryHookResult = ReturnType<typeof usePermissionCountQuery>;
export type PermissionCountLazyQueryHookResult = ReturnType<typeof usePermissionCountLazyQuery>;
export type PermissionCountSuspenseQueryHookResult = ReturnType<typeof usePermissionCountSuspenseQuery>;
export type PermissionCountQueryResult = Apollo.QueryResult<PermissionCountQuery, PermissionCountQueryVariables>;
export const PermissionDetailDocument = gql`
	query permissionDetail($id: ID!) {
		permission(id: $id) {
			...PermissionDetail
		}
	}
	${PermissionDetailFragmentDoc}
`;

/**
 * __usePermissionDetailQuery__
 *
 * To run a query within a React component, call `usePermissionDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `usePermissionDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePermissionDetailQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function usePermissionDetailQuery(
	baseOptions: Apollo.QueryHookOptions<PermissionDetailQuery, PermissionDetailQueryVariables> &
		({ variables: PermissionDetailQueryVariables; skip?: boolean } | { skip: boolean }),
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<PermissionDetailQuery, PermissionDetailQueryVariables>(PermissionDetailDocument, options);
}
export function usePermissionDetailLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<PermissionDetailQuery, PermissionDetailQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<PermissionDetailQuery, PermissionDetailQueryVariables>(PermissionDetailDocument, options);
}
export function usePermissionDetailSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<PermissionDetailQuery, PermissionDetailQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<PermissionDetailQuery, PermissionDetailQueryVariables>(
		PermissionDetailDocument,
		options,
	);
}
export type PermissionDetailQueryHookResult = ReturnType<typeof usePermissionDetailQuery>;
export type PermissionDetailLazyQueryHookResult = ReturnType<typeof usePermissionDetailLazyQuery>;
export type PermissionDetailSuspenseQueryHookResult = ReturnType<typeof usePermissionDetailSuspenseQuery>;
export type PermissionDetailQueryResult = Apollo.QueryResult<PermissionDetailQuery, PermissionDetailQueryVariables>;
export const PermissionIndexDocument = gql`
	query permissionIndex($filters: [PermissionFilterInput!], $pagination: Pagination, $order: PermissionOrder) {
		permissionConnection(filters: $filters, pagination: $pagination, order: $order) {
			edges {
				node {
					id
					name
					family
					action
					level
					description
				}
			}
		}
	}
`;

/**
 * __usePermissionIndexQuery__
 *
 * To run a query within a React component, call `usePermissionIndexQuery` and pass it any options that fit your needs.
 * When your component renders, `usePermissionIndexQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePermissionIndexQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function usePermissionIndexQuery(
	baseOptions?: Apollo.QueryHookOptions<PermissionIndexQuery, PermissionIndexQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<PermissionIndexQuery, PermissionIndexQueryVariables>(PermissionIndexDocument, options);
}
export function usePermissionIndexLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<PermissionIndexQuery, PermissionIndexQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<PermissionIndexQuery, PermissionIndexQueryVariables>(PermissionIndexDocument, options);
}
export function usePermissionIndexSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<PermissionIndexQuery, PermissionIndexQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<PermissionIndexQuery, PermissionIndexQueryVariables>(PermissionIndexDocument, options);
}
export type PermissionIndexQueryHookResult = ReturnType<typeof usePermissionIndexQuery>;
export type PermissionIndexLazyQueryHookResult = ReturnType<typeof usePermissionIndexLazyQuery>;
export type PermissionIndexSuspenseQueryHookResult = ReturnType<typeof usePermissionIndexSuspenseQuery>;
export type PermissionIndexQueryResult = Apollo.QueryResult<PermissionIndexQuery, PermissionIndexQueryVariables>;
export const PermissionNameDocument = gql`
	query permissionName($id: ID!) {
		permission(id: $id) {
			id
			...PermissionName
		}
	}
	${PermissionNameFragmentDoc}
`;

/**
 * __usePermissionNameQuery__
 *
 * To run a query within a React component, call `usePermissionNameQuery` and pass it any options that fit your needs.
 * When your component renders, `usePermissionNameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePermissionNameQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function usePermissionNameQuery(
	baseOptions: Apollo.QueryHookOptions<PermissionNameQuery, PermissionNameQueryVariables> &
		({ variables: PermissionNameQueryVariables; skip?: boolean } | { skip: boolean }),
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<PermissionNameQuery, PermissionNameQueryVariables>(PermissionNameDocument, options);
}
export function usePermissionNameLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<PermissionNameQuery, PermissionNameQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<PermissionNameQuery, PermissionNameQueryVariables>(PermissionNameDocument, options);
}
export function usePermissionNameSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<PermissionNameQuery, PermissionNameQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<PermissionNameQuery, PermissionNameQueryVariables>(PermissionNameDocument, options);
}
export type PermissionNameQueryHookResult = ReturnType<typeof usePermissionNameQuery>;
export type PermissionNameLazyQueryHookResult = ReturnType<typeof usePermissionNameLazyQuery>;
export type PermissionNameSuspenseQueryHookResult = ReturnType<typeof usePermissionNameSuspenseQuery>;
export type PermissionNameQueryResult = Apollo.QueryResult<PermissionNameQuery, PermissionNameQueryVariables>;
export const PermissionNamesDocument = gql`
	query permissionNames($filters: [PermissionFilterInput!], $pagination: Pagination, $order: PermissionOrder) {
		permissionConnection(filters: $filters, pagination: $pagination, order: $order) {
			edges {
				node {
					id
					...PermissionName
				}
			}
		}
	}
	${PermissionNameFragmentDoc}
`;

/**
 * __usePermissionNamesQuery__
 *
 * To run a query within a React component, call `usePermissionNamesQuery` and pass it any options that fit your needs.
 * When your component renders, `usePermissionNamesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePermissionNamesQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function usePermissionNamesQuery(
	baseOptions?: Apollo.QueryHookOptions<PermissionNamesQuery, PermissionNamesQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<PermissionNamesQuery, PermissionNamesQueryVariables>(PermissionNamesDocument, options);
}
export function usePermissionNamesLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<PermissionNamesQuery, PermissionNamesQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<PermissionNamesQuery, PermissionNamesQueryVariables>(PermissionNamesDocument, options);
}
export function usePermissionNamesSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<PermissionNamesQuery, PermissionNamesQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<PermissionNamesQuery, PermissionNamesQueryVariables>(PermissionNamesDocument, options);
}
export type PermissionNamesQueryHookResult = ReturnType<typeof usePermissionNamesQuery>;
export type PermissionNamesLazyQueryHookResult = ReturnType<typeof usePermissionNamesLazyQuery>;
export type PermissionNamesSuspenseQueryHookResult = ReturnType<typeof usePermissionNamesSuspenseQuery>;
export type PermissionNamesQueryResult = Apollo.QueryResult<PermissionNamesQuery, PermissionNamesQueryVariables>;
export const PermissionPaginationDocument = gql`
	query permissionPagination($filters: [PermissionFilterInput!], $order: PermissionOrder) {
		permissionConnection(filters: $filters, order: $order) {
			totalCount
			edges {
				cursor
			}
		}
	}
`;

/**
 * __usePermissionPaginationQuery__
 *
 * To run a query within a React component, call `usePermissionPaginationQuery` and pass it any options that fit your needs.
 * When your component renders, `usePermissionPaginationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePermissionPaginationQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      order: // value for 'order'
 *   },
 * });
 */
export function usePermissionPaginationQuery(
	baseOptions?: Apollo.QueryHookOptions<PermissionPaginationQuery, PermissionPaginationQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<PermissionPaginationQuery, PermissionPaginationQueryVariables>(
		PermissionPaginationDocument,
		options,
	);
}
export function usePermissionPaginationLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<PermissionPaginationQuery, PermissionPaginationQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<PermissionPaginationQuery, PermissionPaginationQueryVariables>(
		PermissionPaginationDocument,
		options,
	);
}
export function usePermissionPaginationSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<PermissionPaginationQuery, PermissionPaginationQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<PermissionPaginationQuery, PermissionPaginationQueryVariables>(
		PermissionPaginationDocument,
		options,
	);
}
export type PermissionPaginationQueryHookResult = ReturnType<typeof usePermissionPaginationQuery>;
export type PermissionPaginationLazyQueryHookResult = ReturnType<typeof usePermissionPaginationLazyQuery>;
export type PermissionPaginationSuspenseQueryHookResult = ReturnType<typeof usePermissionPaginationSuspenseQuery>;
export type PermissionPaginationQueryResult = Apollo.QueryResult<
	PermissionPaginationQuery,
	PermissionPaginationQueryVariables
>;
export const PermissionSelectDocument = gql`
	query permissionSelect($filters: [PermissionFilterInput!], $order: PermissionOrder) {
		permissionConnection(filters: $filters, order: $order) {
			edges {
				node {
					id
					...PermissionName
				}
			}
		}
	}
	${PermissionNameFragmentDoc}
`;

/**
 * __usePermissionSelectQuery__
 *
 * To run a query within a React component, call `usePermissionSelectQuery` and pass it any options that fit your needs.
 * When your component renders, `usePermissionSelectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePermissionSelectQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      order: // value for 'order'
 *   },
 * });
 */
export function usePermissionSelectQuery(
	baseOptions?: Apollo.QueryHookOptions<PermissionSelectQuery, PermissionSelectQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<PermissionSelectQuery, PermissionSelectQueryVariables>(PermissionSelectDocument, options);
}
export function usePermissionSelectLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<PermissionSelectQuery, PermissionSelectQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<PermissionSelectQuery, PermissionSelectQueryVariables>(PermissionSelectDocument, options);
}
export function usePermissionSelectSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<PermissionSelectQuery, PermissionSelectQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<PermissionSelectQuery, PermissionSelectQueryVariables>(
		PermissionSelectDocument,
		options,
	);
}
export type PermissionSelectQueryHookResult = ReturnType<typeof usePermissionSelectQuery>;
export type PermissionSelectLazyQueryHookResult = ReturnType<typeof usePermissionSelectLazyQuery>;
export type PermissionSelectSuspenseQueryHookResult = ReturnType<typeof usePermissionSelectSuspenseQuery>;
export type PermissionSelectQueryResult = Apollo.QueryResult<PermissionSelectQuery, PermissionSelectQueryVariables>;
export const PermissionUpdateDocument = gql`
	mutation permissionUpdate($id: ID!, $input: PermissionUpdateInput!) {
		updatePermission(id: $id, input: $input) {
			...PermissionDetail
		}
	}
	${PermissionDetailFragmentDoc}
`;
export type PermissionUpdateMutationFn = Apollo.MutationFunction<
	PermissionUpdateMutation,
	PermissionUpdateMutationVariables
>;

/**
 * __usePermissionUpdateMutation__
 *
 * To run a mutation, you first call `usePermissionUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePermissionUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [permissionUpdateMutation, { data, loading, error }] = usePermissionUpdateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePermissionUpdateMutation(
	baseOptions?: Apollo.MutationHookOptions<PermissionUpdateMutation, PermissionUpdateMutationVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<PermissionUpdateMutation, PermissionUpdateMutationVariables>(
		PermissionUpdateDocument,
		options,
	);
}
export type PermissionUpdateMutationHookResult = ReturnType<typeof usePermissionUpdateMutation>;
export type PermissionUpdateMutationResult = Apollo.MutationResult<PermissionUpdateMutation>;
export type PermissionUpdateMutationOptions = Apollo.BaseMutationOptions<
	PermissionUpdateMutation,
	PermissionUpdateMutationVariables
>;
export const PermissionGroupCheckUniqueNameDocument = gql`
	query permissionGroupCheckUniqueName($ignoreID: ID, $name: String!) {
		permissionGroupConnection(filters: { idNEQ: $ignoreID, nameEQ: $name }) {
			totalCount
		}
	}
`;

/**
 * __usePermissionGroupCheckUniqueNameQuery__
 *
 * To run a query within a React component, call `usePermissionGroupCheckUniqueNameQuery` and pass it any options that fit your needs.
 * When your component renders, `usePermissionGroupCheckUniqueNameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePermissionGroupCheckUniqueNameQuery({
 *   variables: {
 *      ignoreID: // value for 'ignoreID'
 *      name: // value for 'name'
 *   },
 * });
 */
export function usePermissionGroupCheckUniqueNameQuery(
	baseOptions: Apollo.QueryHookOptions<
		PermissionGroupCheckUniqueNameQuery,
		PermissionGroupCheckUniqueNameQueryVariables
	> &
		({ variables: PermissionGroupCheckUniqueNameQueryVariables; skip?: boolean } | { skip: boolean }),
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<PermissionGroupCheckUniqueNameQuery, PermissionGroupCheckUniqueNameQueryVariables>(
		PermissionGroupCheckUniqueNameDocument,
		options,
	);
}
export function usePermissionGroupCheckUniqueNameLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		PermissionGroupCheckUniqueNameQuery,
		PermissionGroupCheckUniqueNameQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<PermissionGroupCheckUniqueNameQuery, PermissionGroupCheckUniqueNameQueryVariables>(
		PermissionGroupCheckUniqueNameDocument,
		options,
	);
}
export function usePermissionGroupCheckUniqueNameSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		PermissionGroupCheckUniqueNameQuery,
		PermissionGroupCheckUniqueNameQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<PermissionGroupCheckUniqueNameQuery, PermissionGroupCheckUniqueNameQueryVariables>(
		PermissionGroupCheckUniqueNameDocument,
		options,
	);
}
export type PermissionGroupCheckUniqueNameQueryHookResult = ReturnType<typeof usePermissionGroupCheckUniqueNameQuery>;
export type PermissionGroupCheckUniqueNameLazyQueryHookResult = ReturnType<
	typeof usePermissionGroupCheckUniqueNameLazyQuery
>;
export type PermissionGroupCheckUniqueNameSuspenseQueryHookResult = ReturnType<
	typeof usePermissionGroupCheckUniqueNameSuspenseQuery
>;
export type PermissionGroupCheckUniqueNameQueryResult = Apollo.QueryResult<
	PermissionGroupCheckUniqueNameQuery,
	PermissionGroupCheckUniqueNameQueryVariables
>;
export const PermissionGroupCountDocument = gql`
	query permissionGroupCount(
		$filters: [PermissionGroupFilterInput!]
		$pagination: Pagination
		$order: PermissionGroupOrder
	) {
		permissionGroupConnection(filters: $filters, pagination: $pagination, order: $order) {
			totalCount
		}
	}
`;

/**
 * __usePermissionGroupCountQuery__
 *
 * To run a query within a React component, call `usePermissionGroupCountQuery` and pass it any options that fit your needs.
 * When your component renders, `usePermissionGroupCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePermissionGroupCountQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function usePermissionGroupCountQuery(
	baseOptions?: Apollo.QueryHookOptions<PermissionGroupCountQuery, PermissionGroupCountQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<PermissionGroupCountQuery, PermissionGroupCountQueryVariables>(
		PermissionGroupCountDocument,
		options,
	);
}
export function usePermissionGroupCountLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<PermissionGroupCountQuery, PermissionGroupCountQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<PermissionGroupCountQuery, PermissionGroupCountQueryVariables>(
		PermissionGroupCountDocument,
		options,
	);
}
export function usePermissionGroupCountSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<PermissionGroupCountQuery, PermissionGroupCountQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<PermissionGroupCountQuery, PermissionGroupCountQueryVariables>(
		PermissionGroupCountDocument,
		options,
	);
}
export type PermissionGroupCountQueryHookResult = ReturnType<typeof usePermissionGroupCountQuery>;
export type PermissionGroupCountLazyQueryHookResult = ReturnType<typeof usePermissionGroupCountLazyQuery>;
export type PermissionGroupCountSuspenseQueryHookResult = ReturnType<typeof usePermissionGroupCountSuspenseQuery>;
export type PermissionGroupCountQueryResult = Apollo.QueryResult<
	PermissionGroupCountQuery,
	PermissionGroupCountQueryVariables
>;
export const PermissionGroupCreateDocument = gql`
	mutation permissionGroupCreate($input: PermissionGroupCreateInput!) {
		createPermissionGroup(input: $input) {
			...PermissionGroupDetail
		}
	}
	${PermissionGroupDetailFragmentDoc}
`;
export type PermissionGroupCreateMutationFn = Apollo.MutationFunction<
	PermissionGroupCreateMutation,
	PermissionGroupCreateMutationVariables
>;

/**
 * __usePermissionGroupCreateMutation__
 *
 * To run a mutation, you first call `usePermissionGroupCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePermissionGroupCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [permissionGroupCreateMutation, { data, loading, error }] = usePermissionGroupCreateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePermissionGroupCreateMutation(
	baseOptions?: Apollo.MutationHookOptions<PermissionGroupCreateMutation, PermissionGroupCreateMutationVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<PermissionGroupCreateMutation, PermissionGroupCreateMutationVariables>(
		PermissionGroupCreateDocument,
		options,
	);
}
export type PermissionGroupCreateMutationHookResult = ReturnType<typeof usePermissionGroupCreateMutation>;
export type PermissionGroupCreateMutationResult = Apollo.MutationResult<PermissionGroupCreateMutation>;
export type PermissionGroupCreateMutationOptions = Apollo.BaseMutationOptions<
	PermissionGroupCreateMutation,
	PermissionGroupCreateMutationVariables
>;
export const PermissionGroupDeleteDocument = gql`
	mutation permissionGroupDelete($id: ID!) {
		deletePermissionGroup(id: $id)
	}
`;
export type PermissionGroupDeleteMutationFn = Apollo.MutationFunction<
	PermissionGroupDeleteMutation,
	PermissionGroupDeleteMutationVariables
>;

/**
 * __usePermissionGroupDeleteMutation__
 *
 * To run a mutation, you first call `usePermissionGroupDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePermissionGroupDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [permissionGroupDeleteMutation, { data, loading, error }] = usePermissionGroupDeleteMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function usePermissionGroupDeleteMutation(
	baseOptions?: Apollo.MutationHookOptions<PermissionGroupDeleteMutation, PermissionGroupDeleteMutationVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<PermissionGroupDeleteMutation, PermissionGroupDeleteMutationVariables>(
		PermissionGroupDeleteDocument,
		options,
	);
}
export type PermissionGroupDeleteMutationHookResult = ReturnType<typeof usePermissionGroupDeleteMutation>;
export type PermissionGroupDeleteMutationResult = Apollo.MutationResult<PermissionGroupDeleteMutation>;
export type PermissionGroupDeleteMutationOptions = Apollo.BaseMutationOptions<
	PermissionGroupDeleteMutation,
	PermissionGroupDeleteMutationVariables
>;
export const PermissionGroupDetailDocument = gql`
	query permissionGroupDetail($id: ID!) {
		permissionGroup(id: $id) {
			...PermissionGroupDetail
		}
	}
	${PermissionGroupDetailFragmentDoc}
`;

/**
 * __usePermissionGroupDetailQuery__
 *
 * To run a query within a React component, call `usePermissionGroupDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `usePermissionGroupDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePermissionGroupDetailQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function usePermissionGroupDetailQuery(
	baseOptions: Apollo.QueryHookOptions<PermissionGroupDetailQuery, PermissionGroupDetailQueryVariables> &
		({ variables: PermissionGroupDetailQueryVariables; skip?: boolean } | { skip: boolean }),
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<PermissionGroupDetailQuery, PermissionGroupDetailQueryVariables>(
		PermissionGroupDetailDocument,
		options,
	);
}
export function usePermissionGroupDetailLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<PermissionGroupDetailQuery, PermissionGroupDetailQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<PermissionGroupDetailQuery, PermissionGroupDetailQueryVariables>(
		PermissionGroupDetailDocument,
		options,
	);
}
export function usePermissionGroupDetailSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<PermissionGroupDetailQuery, PermissionGroupDetailQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<PermissionGroupDetailQuery, PermissionGroupDetailQueryVariables>(
		PermissionGroupDetailDocument,
		options,
	);
}
export type PermissionGroupDetailQueryHookResult = ReturnType<typeof usePermissionGroupDetailQuery>;
export type PermissionGroupDetailLazyQueryHookResult = ReturnType<typeof usePermissionGroupDetailLazyQuery>;
export type PermissionGroupDetailSuspenseQueryHookResult = ReturnType<typeof usePermissionGroupDetailSuspenseQuery>;
export type PermissionGroupDetailQueryResult = Apollo.QueryResult<
	PermissionGroupDetailQuery,
	PermissionGroupDetailQueryVariables
>;
export const PermissionGroupIndexDocument = gql`
	query permissionGroupIndex(
		$filters: [PermissionGroupFilterInput!]
		$pagination: Pagination
		$order: PermissionGroupOrder
	) {
		permissionGroupConnection(filters: $filters, pagination: $pagination, order: $order) {
			edges {
				node {
					id
					name
					description
				}
			}
		}
	}
`;

/**
 * __usePermissionGroupIndexQuery__
 *
 * To run a query within a React component, call `usePermissionGroupIndexQuery` and pass it any options that fit your needs.
 * When your component renders, `usePermissionGroupIndexQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePermissionGroupIndexQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function usePermissionGroupIndexQuery(
	baseOptions?: Apollo.QueryHookOptions<PermissionGroupIndexQuery, PermissionGroupIndexQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<PermissionGroupIndexQuery, PermissionGroupIndexQueryVariables>(
		PermissionGroupIndexDocument,
		options,
	);
}
export function usePermissionGroupIndexLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<PermissionGroupIndexQuery, PermissionGroupIndexQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<PermissionGroupIndexQuery, PermissionGroupIndexQueryVariables>(
		PermissionGroupIndexDocument,
		options,
	);
}
export function usePermissionGroupIndexSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<PermissionGroupIndexQuery, PermissionGroupIndexQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<PermissionGroupIndexQuery, PermissionGroupIndexQueryVariables>(
		PermissionGroupIndexDocument,
		options,
	);
}
export type PermissionGroupIndexQueryHookResult = ReturnType<typeof usePermissionGroupIndexQuery>;
export type PermissionGroupIndexLazyQueryHookResult = ReturnType<typeof usePermissionGroupIndexLazyQuery>;
export type PermissionGroupIndexSuspenseQueryHookResult = ReturnType<typeof usePermissionGroupIndexSuspenseQuery>;
export type PermissionGroupIndexQueryResult = Apollo.QueryResult<
	PermissionGroupIndexQuery,
	PermissionGroupIndexQueryVariables
>;
export const PermissionGroupNameDocument = gql`
	query permissionGroupName($id: ID!) {
		permissionGroup(id: $id) {
			id
			...PermissionGroupName
		}
	}
	${PermissionGroupNameFragmentDoc}
`;

/**
 * __usePermissionGroupNameQuery__
 *
 * To run a query within a React component, call `usePermissionGroupNameQuery` and pass it any options that fit your needs.
 * When your component renders, `usePermissionGroupNameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePermissionGroupNameQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function usePermissionGroupNameQuery(
	baseOptions: Apollo.QueryHookOptions<PermissionGroupNameQuery, PermissionGroupNameQueryVariables> &
		({ variables: PermissionGroupNameQueryVariables; skip?: boolean } | { skip: boolean }),
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<PermissionGroupNameQuery, PermissionGroupNameQueryVariables>(
		PermissionGroupNameDocument,
		options,
	);
}
export function usePermissionGroupNameLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<PermissionGroupNameQuery, PermissionGroupNameQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<PermissionGroupNameQuery, PermissionGroupNameQueryVariables>(
		PermissionGroupNameDocument,
		options,
	);
}
export function usePermissionGroupNameSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<PermissionGroupNameQuery, PermissionGroupNameQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<PermissionGroupNameQuery, PermissionGroupNameQueryVariables>(
		PermissionGroupNameDocument,
		options,
	);
}
export type PermissionGroupNameQueryHookResult = ReturnType<typeof usePermissionGroupNameQuery>;
export type PermissionGroupNameLazyQueryHookResult = ReturnType<typeof usePermissionGroupNameLazyQuery>;
export type PermissionGroupNameSuspenseQueryHookResult = ReturnType<typeof usePermissionGroupNameSuspenseQuery>;
export type PermissionGroupNameQueryResult = Apollo.QueryResult<
	PermissionGroupNameQuery,
	PermissionGroupNameQueryVariables
>;
export const PermissionGroupNamesDocument = gql`
	query permissionGroupNames(
		$filters: [PermissionGroupFilterInput!]
		$pagination: Pagination
		$order: PermissionGroupOrder
	) {
		permissionGroupConnection(filters: $filters, pagination: $pagination, order: $order) {
			edges {
				node {
					id
					...PermissionGroupName
				}
			}
		}
	}
	${PermissionGroupNameFragmentDoc}
`;

/**
 * __usePermissionGroupNamesQuery__
 *
 * To run a query within a React component, call `usePermissionGroupNamesQuery` and pass it any options that fit your needs.
 * When your component renders, `usePermissionGroupNamesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePermissionGroupNamesQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function usePermissionGroupNamesQuery(
	baseOptions?: Apollo.QueryHookOptions<PermissionGroupNamesQuery, PermissionGroupNamesQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<PermissionGroupNamesQuery, PermissionGroupNamesQueryVariables>(
		PermissionGroupNamesDocument,
		options,
	);
}
export function usePermissionGroupNamesLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<PermissionGroupNamesQuery, PermissionGroupNamesQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<PermissionGroupNamesQuery, PermissionGroupNamesQueryVariables>(
		PermissionGroupNamesDocument,
		options,
	);
}
export function usePermissionGroupNamesSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<PermissionGroupNamesQuery, PermissionGroupNamesQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<PermissionGroupNamesQuery, PermissionGroupNamesQueryVariables>(
		PermissionGroupNamesDocument,
		options,
	);
}
export type PermissionGroupNamesQueryHookResult = ReturnType<typeof usePermissionGroupNamesQuery>;
export type PermissionGroupNamesLazyQueryHookResult = ReturnType<typeof usePermissionGroupNamesLazyQuery>;
export type PermissionGroupNamesSuspenseQueryHookResult = ReturnType<typeof usePermissionGroupNamesSuspenseQuery>;
export type PermissionGroupNamesQueryResult = Apollo.QueryResult<
	PermissionGroupNamesQuery,
	PermissionGroupNamesQueryVariables
>;
export const PermissionGroupPaginationDocument = gql`
	query permissionGroupPagination($filters: [PermissionGroupFilterInput!], $order: PermissionGroupOrder) {
		permissionGroupConnection(filters: $filters, order: $order) {
			totalCount
			edges {
				cursor
			}
		}
	}
`;

/**
 * __usePermissionGroupPaginationQuery__
 *
 * To run a query within a React component, call `usePermissionGroupPaginationQuery` and pass it any options that fit your needs.
 * When your component renders, `usePermissionGroupPaginationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePermissionGroupPaginationQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      order: // value for 'order'
 *   },
 * });
 */
export function usePermissionGroupPaginationQuery(
	baseOptions?: Apollo.QueryHookOptions<PermissionGroupPaginationQuery, PermissionGroupPaginationQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<PermissionGroupPaginationQuery, PermissionGroupPaginationQueryVariables>(
		PermissionGroupPaginationDocument,
		options,
	);
}
export function usePermissionGroupPaginationLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<PermissionGroupPaginationQuery, PermissionGroupPaginationQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<PermissionGroupPaginationQuery, PermissionGroupPaginationQueryVariables>(
		PermissionGroupPaginationDocument,
		options,
	);
}
export function usePermissionGroupPaginationSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		PermissionGroupPaginationQuery,
		PermissionGroupPaginationQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<PermissionGroupPaginationQuery, PermissionGroupPaginationQueryVariables>(
		PermissionGroupPaginationDocument,
		options,
	);
}
export type PermissionGroupPaginationQueryHookResult = ReturnType<typeof usePermissionGroupPaginationQuery>;
export type PermissionGroupPaginationLazyQueryHookResult = ReturnType<typeof usePermissionGroupPaginationLazyQuery>;
export type PermissionGroupPaginationSuspenseQueryHookResult = ReturnType<
	typeof usePermissionGroupPaginationSuspenseQuery
>;
export type PermissionGroupPaginationQueryResult = Apollo.QueryResult<
	PermissionGroupPaginationQuery,
	PermissionGroupPaginationQueryVariables
>;
export const PermissionGroupSelectDocument = gql`
	query permissionGroupSelect($filters: [PermissionGroupFilterInput!], $order: PermissionGroupOrder) {
		permissionGroupConnection(filters: $filters, order: $order) {
			edges {
				node {
					id
					...PermissionGroupName
				}
			}
		}
	}
	${PermissionGroupNameFragmentDoc}
`;

/**
 * __usePermissionGroupSelectQuery__
 *
 * To run a query within a React component, call `usePermissionGroupSelectQuery` and pass it any options that fit your needs.
 * When your component renders, `usePermissionGroupSelectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePermissionGroupSelectQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      order: // value for 'order'
 *   },
 * });
 */
export function usePermissionGroupSelectQuery(
	baseOptions?: Apollo.QueryHookOptions<PermissionGroupSelectQuery, PermissionGroupSelectQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<PermissionGroupSelectQuery, PermissionGroupSelectQueryVariables>(
		PermissionGroupSelectDocument,
		options,
	);
}
export function usePermissionGroupSelectLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<PermissionGroupSelectQuery, PermissionGroupSelectQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<PermissionGroupSelectQuery, PermissionGroupSelectQueryVariables>(
		PermissionGroupSelectDocument,
		options,
	);
}
export function usePermissionGroupSelectSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<PermissionGroupSelectQuery, PermissionGroupSelectQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<PermissionGroupSelectQuery, PermissionGroupSelectQueryVariables>(
		PermissionGroupSelectDocument,
		options,
	);
}
export type PermissionGroupSelectQueryHookResult = ReturnType<typeof usePermissionGroupSelectQuery>;
export type PermissionGroupSelectLazyQueryHookResult = ReturnType<typeof usePermissionGroupSelectLazyQuery>;
export type PermissionGroupSelectSuspenseQueryHookResult = ReturnType<typeof usePermissionGroupSelectSuspenseQuery>;
export type PermissionGroupSelectQueryResult = Apollo.QueryResult<
	PermissionGroupSelectQuery,
	PermissionGroupSelectQueryVariables
>;
export const PermissionGroupUpdateDocument = gql`
	mutation permissionGroupUpdate($id: ID!, $input: PermissionGroupUpdateInput!) {
		updatePermissionGroup(id: $id, input: $input) {
			...PermissionGroupDetail
		}
	}
	${PermissionGroupDetailFragmentDoc}
`;
export type PermissionGroupUpdateMutationFn = Apollo.MutationFunction<
	PermissionGroupUpdateMutation,
	PermissionGroupUpdateMutationVariables
>;

/**
 * __usePermissionGroupUpdateMutation__
 *
 * To run a mutation, you first call `usePermissionGroupUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePermissionGroupUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [permissionGroupUpdateMutation, { data, loading, error }] = usePermissionGroupUpdateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePermissionGroupUpdateMutation(
	baseOptions?: Apollo.MutationHookOptions<PermissionGroupUpdateMutation, PermissionGroupUpdateMutationVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<PermissionGroupUpdateMutation, PermissionGroupUpdateMutationVariables>(
		PermissionGroupUpdateDocument,
		options,
	);
}
export type PermissionGroupUpdateMutationHookResult = ReturnType<typeof usePermissionGroupUpdateMutation>;
export type PermissionGroupUpdateMutationResult = Apollo.MutationResult<PermissionGroupUpdateMutation>;
export type PermissionGroupUpdateMutationOptions = Apollo.BaseMutationOptions<
	PermissionGroupUpdateMutation,
	PermissionGroupUpdateMutationVariables
>;
export const PostCountDocument = gql`
	query postCount($filters: [PostFilterInput!], $pagination: Pagination, $order: PostOrder) {
		postConnection(filters: $filters, pagination: $pagination, order: $order) {
			totalCount
		}
	}
`;

/**
 * __usePostCountQuery__
 *
 * To run a query within a React component, call `usePostCountQuery` and pass it any options that fit your needs.
 * When your component renders, `usePostCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePostCountQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function usePostCountQuery(baseOptions?: Apollo.QueryHookOptions<PostCountQuery, PostCountQueryVariables>) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<PostCountQuery, PostCountQueryVariables>(PostCountDocument, options);
}
export function usePostCountLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<PostCountQuery, PostCountQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<PostCountQuery, PostCountQueryVariables>(PostCountDocument, options);
}
export function usePostCountSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<PostCountQuery, PostCountQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<PostCountQuery, PostCountQueryVariables>(PostCountDocument, options);
}
export type PostCountQueryHookResult = ReturnType<typeof usePostCountQuery>;
export type PostCountLazyQueryHookResult = ReturnType<typeof usePostCountLazyQuery>;
export type PostCountSuspenseQueryHookResult = ReturnType<typeof usePostCountSuspenseQuery>;
export type PostCountQueryResult = Apollo.QueryResult<PostCountQuery, PostCountQueryVariables>;
export const PostCreateDocument = gql`
	mutation postCreate($input: PostCreateInput!) {
		createPost(input: $input) {
			...PostDetail
		}
	}
	${PostDetailFragmentDoc}
`;
export type PostCreateMutationFn = Apollo.MutationFunction<PostCreateMutation, PostCreateMutationVariables>;

/**
 * __usePostCreateMutation__
 *
 * To run a mutation, you first call `usePostCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePostCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [postCreateMutation, { data, loading, error }] = usePostCreateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePostCreateMutation(
	baseOptions?: Apollo.MutationHookOptions<PostCreateMutation, PostCreateMutationVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<PostCreateMutation, PostCreateMutationVariables>(PostCreateDocument, options);
}
export type PostCreateMutationHookResult = ReturnType<typeof usePostCreateMutation>;
export type PostCreateMutationResult = Apollo.MutationResult<PostCreateMutation>;
export type PostCreateMutationOptions = Apollo.BaseMutationOptions<PostCreateMutation, PostCreateMutationVariables>;
export const PostDeleteDocument = gql`
	mutation postDelete($id: ID!) {
		deletePost(id: $id)
	}
`;
export type PostDeleteMutationFn = Apollo.MutationFunction<PostDeleteMutation, PostDeleteMutationVariables>;

/**
 * __usePostDeleteMutation__
 *
 * To run a mutation, you first call `usePostDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePostDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [postDeleteMutation, { data, loading, error }] = usePostDeleteMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function usePostDeleteMutation(
	baseOptions?: Apollo.MutationHookOptions<PostDeleteMutation, PostDeleteMutationVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<PostDeleteMutation, PostDeleteMutationVariables>(PostDeleteDocument, options);
}
export type PostDeleteMutationHookResult = ReturnType<typeof usePostDeleteMutation>;
export type PostDeleteMutationResult = Apollo.MutationResult<PostDeleteMutation>;
export type PostDeleteMutationOptions = Apollo.BaseMutationOptions<PostDeleteMutation, PostDeleteMutationVariables>;
export const PostDetailDocument = gql`
	query postDetail($id: ID!) {
		post(id: $id) {
			...PostDetail
		}
	}
	${PostDetailFragmentDoc}
`;

/**
 * __usePostDetailQuery__
 *
 * To run a query within a React component, call `usePostDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `usePostDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePostDetailQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function usePostDetailQuery(
	baseOptions: Apollo.QueryHookOptions<PostDetailQuery, PostDetailQueryVariables> &
		({ variables: PostDetailQueryVariables; skip?: boolean } | { skip: boolean }),
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<PostDetailQuery, PostDetailQueryVariables>(PostDetailDocument, options);
}
export function usePostDetailLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<PostDetailQuery, PostDetailQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<PostDetailQuery, PostDetailQueryVariables>(PostDetailDocument, options);
}
export function usePostDetailSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<PostDetailQuery, PostDetailQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<PostDetailQuery, PostDetailQueryVariables>(PostDetailDocument, options);
}
export type PostDetailQueryHookResult = ReturnType<typeof usePostDetailQuery>;
export type PostDetailLazyQueryHookResult = ReturnType<typeof usePostDetailLazyQuery>;
export type PostDetailSuspenseQueryHookResult = ReturnType<typeof usePostDetailSuspenseQuery>;
export type PostDetailQueryResult = Apollo.QueryResult<PostDetailQuery, PostDetailQueryVariables>;
export const PostIndexDocument = gql`
	query postIndex($filters: [PostFilterInput!], $pagination: Pagination, $order: PostOrder) {
		postConnection(filters: $filters, pagination: $pagination, order: $order) {
			edges {
				node {
					id
					createdAt
					title
					body
					author {
						id
						...UserName
					}
				}
			}
		}
	}
	${UserNameFragmentDoc}
`;

/**
 * __usePostIndexQuery__
 *
 * To run a query within a React component, call `usePostIndexQuery` and pass it any options that fit your needs.
 * When your component renders, `usePostIndexQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePostIndexQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function usePostIndexQuery(baseOptions?: Apollo.QueryHookOptions<PostIndexQuery, PostIndexQueryVariables>) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<PostIndexQuery, PostIndexQueryVariables>(PostIndexDocument, options);
}
export function usePostIndexLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<PostIndexQuery, PostIndexQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<PostIndexQuery, PostIndexQueryVariables>(PostIndexDocument, options);
}
export function usePostIndexSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<PostIndexQuery, PostIndexQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<PostIndexQuery, PostIndexQueryVariables>(PostIndexDocument, options);
}
export type PostIndexQueryHookResult = ReturnType<typeof usePostIndexQuery>;
export type PostIndexLazyQueryHookResult = ReturnType<typeof usePostIndexLazyQuery>;
export type PostIndexSuspenseQueryHookResult = ReturnType<typeof usePostIndexSuspenseQuery>;
export type PostIndexQueryResult = Apollo.QueryResult<PostIndexQuery, PostIndexQueryVariables>;
export const PostNameDocument = gql`
	query postName($id: ID!) {
		post(id: $id) {
			id
			...PostName
		}
	}
	${PostNameFragmentDoc}
`;

/**
 * __usePostNameQuery__
 *
 * To run a query within a React component, call `usePostNameQuery` and pass it any options that fit your needs.
 * When your component renders, `usePostNameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePostNameQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function usePostNameQuery(
	baseOptions: Apollo.QueryHookOptions<PostNameQuery, PostNameQueryVariables> &
		({ variables: PostNameQueryVariables; skip?: boolean } | { skip: boolean }),
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<PostNameQuery, PostNameQueryVariables>(PostNameDocument, options);
}
export function usePostNameLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PostNameQuery, PostNameQueryVariables>) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<PostNameQuery, PostNameQueryVariables>(PostNameDocument, options);
}
export function usePostNameSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<PostNameQuery, PostNameQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<PostNameQuery, PostNameQueryVariables>(PostNameDocument, options);
}
export type PostNameQueryHookResult = ReturnType<typeof usePostNameQuery>;
export type PostNameLazyQueryHookResult = ReturnType<typeof usePostNameLazyQuery>;
export type PostNameSuspenseQueryHookResult = ReturnType<typeof usePostNameSuspenseQuery>;
export type PostNameQueryResult = Apollo.QueryResult<PostNameQuery, PostNameQueryVariables>;
export const PostNamesDocument = gql`
	query postNames($filters: [PostFilterInput!], $pagination: Pagination, $order: PostOrder) {
		postConnection(filters: $filters, pagination: $pagination, order: $order) {
			edges {
				node {
					id
					...PostName
				}
			}
		}
	}
	${PostNameFragmentDoc}
`;

/**
 * __usePostNamesQuery__
 *
 * To run a query within a React component, call `usePostNamesQuery` and pass it any options that fit your needs.
 * When your component renders, `usePostNamesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePostNamesQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function usePostNamesQuery(baseOptions?: Apollo.QueryHookOptions<PostNamesQuery, PostNamesQueryVariables>) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<PostNamesQuery, PostNamesQueryVariables>(PostNamesDocument, options);
}
export function usePostNamesLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<PostNamesQuery, PostNamesQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<PostNamesQuery, PostNamesQueryVariables>(PostNamesDocument, options);
}
export function usePostNamesSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<PostNamesQuery, PostNamesQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<PostNamesQuery, PostNamesQueryVariables>(PostNamesDocument, options);
}
export type PostNamesQueryHookResult = ReturnType<typeof usePostNamesQuery>;
export type PostNamesLazyQueryHookResult = ReturnType<typeof usePostNamesLazyQuery>;
export type PostNamesSuspenseQueryHookResult = ReturnType<typeof usePostNamesSuspenseQuery>;
export type PostNamesQueryResult = Apollo.QueryResult<PostNamesQuery, PostNamesQueryVariables>;
export const PostPaginationDocument = gql`
	query postPagination($filters: [PostFilterInput!], $order: PostOrder) {
		postConnection(filters: $filters, order: $order) {
			totalCount
			edges {
				cursor
			}
		}
	}
`;

/**
 * __usePostPaginationQuery__
 *
 * To run a query within a React component, call `usePostPaginationQuery` and pass it any options that fit your needs.
 * When your component renders, `usePostPaginationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePostPaginationQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      order: // value for 'order'
 *   },
 * });
 */
export function usePostPaginationQuery(
	baseOptions?: Apollo.QueryHookOptions<PostPaginationQuery, PostPaginationQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<PostPaginationQuery, PostPaginationQueryVariables>(PostPaginationDocument, options);
}
export function usePostPaginationLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<PostPaginationQuery, PostPaginationQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<PostPaginationQuery, PostPaginationQueryVariables>(PostPaginationDocument, options);
}
export function usePostPaginationSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<PostPaginationQuery, PostPaginationQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<PostPaginationQuery, PostPaginationQueryVariables>(PostPaginationDocument, options);
}
export type PostPaginationQueryHookResult = ReturnType<typeof usePostPaginationQuery>;
export type PostPaginationLazyQueryHookResult = ReturnType<typeof usePostPaginationLazyQuery>;
export type PostPaginationSuspenseQueryHookResult = ReturnType<typeof usePostPaginationSuspenseQuery>;
export type PostPaginationQueryResult = Apollo.QueryResult<PostPaginationQuery, PostPaginationQueryVariables>;
export const PostSelectDocument = gql`
	query postSelect($filters: [PostFilterInput!], $order: PostOrder) {
		postConnection(filters: $filters, order: $order) {
			edges {
				node {
					id
					...PostName
				}
			}
		}
	}
	${PostNameFragmentDoc}
`;

/**
 * __usePostSelectQuery__
 *
 * To run a query within a React component, call `usePostSelectQuery` and pass it any options that fit your needs.
 * When your component renders, `usePostSelectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePostSelectQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      order: // value for 'order'
 *   },
 * });
 */
export function usePostSelectQuery(baseOptions?: Apollo.QueryHookOptions<PostSelectQuery, PostSelectQueryVariables>) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<PostSelectQuery, PostSelectQueryVariables>(PostSelectDocument, options);
}
export function usePostSelectLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<PostSelectQuery, PostSelectQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<PostSelectQuery, PostSelectQueryVariables>(PostSelectDocument, options);
}
export function usePostSelectSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<PostSelectQuery, PostSelectQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<PostSelectQuery, PostSelectQueryVariables>(PostSelectDocument, options);
}
export type PostSelectQueryHookResult = ReturnType<typeof usePostSelectQuery>;
export type PostSelectLazyQueryHookResult = ReturnType<typeof usePostSelectLazyQuery>;
export type PostSelectSuspenseQueryHookResult = ReturnType<typeof usePostSelectSuspenseQuery>;
export type PostSelectQueryResult = Apollo.QueryResult<PostSelectQuery, PostSelectQueryVariables>;
export const PostSocialItemsDocument = gql`
	query postSocialItems($id: ID!) {
		post(id: $id) {
			id
			socialReactions(order: { field: CREATED_AT, direction: DESC }) {
				id
				reaction
				author {
					id
					...UserName
					isCurrent
				}
			}
			socialComments(order: { field: CREATED_AT, direction: DESC }) {
				id
				body
				createdAt
				author {
					id
					...UserNameAndImage
					isCurrent
				}
			}
		}
	}
	${UserNameFragmentDoc}
	${UserNameAndImageFragmentDoc}
`;

/**
 * __usePostSocialItemsQuery__
 *
 * To run a query within a React component, call `usePostSocialItemsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePostSocialItemsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePostSocialItemsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function usePostSocialItemsQuery(
	baseOptions: Apollo.QueryHookOptions<PostSocialItemsQuery, PostSocialItemsQueryVariables> &
		({ variables: PostSocialItemsQueryVariables; skip?: boolean } | { skip: boolean }),
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<PostSocialItemsQuery, PostSocialItemsQueryVariables>(PostSocialItemsDocument, options);
}
export function usePostSocialItemsLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<PostSocialItemsQuery, PostSocialItemsQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<PostSocialItemsQuery, PostSocialItemsQueryVariables>(PostSocialItemsDocument, options);
}
export function usePostSocialItemsSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<PostSocialItemsQuery, PostSocialItemsQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<PostSocialItemsQuery, PostSocialItemsQueryVariables>(PostSocialItemsDocument, options);
}
export type PostSocialItemsQueryHookResult = ReturnType<typeof usePostSocialItemsQuery>;
export type PostSocialItemsLazyQueryHookResult = ReturnType<typeof usePostSocialItemsLazyQuery>;
export type PostSocialItemsSuspenseQueryHookResult = ReturnType<typeof usePostSocialItemsSuspenseQuery>;
export type PostSocialItemsQueryResult = Apollo.QueryResult<PostSocialItemsQuery, PostSocialItemsQueryVariables>;
export const PostStatisticsDocument = gql`
	query postStatistics($filters: [PostFilterInput!]) {
		postStatistics(filters: $filters) {
			count
			views
			reactions
			comments
		}
	}
`;

/**
 * __usePostStatisticsQuery__
 *
 * To run a query within a React component, call `usePostStatisticsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePostStatisticsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePostStatisticsQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function usePostStatisticsQuery(
	baseOptions?: Apollo.QueryHookOptions<PostStatisticsQuery, PostStatisticsQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<PostStatisticsQuery, PostStatisticsQueryVariables>(PostStatisticsDocument, options);
}
export function usePostStatisticsLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<PostStatisticsQuery, PostStatisticsQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<PostStatisticsQuery, PostStatisticsQueryVariables>(PostStatisticsDocument, options);
}
export function usePostStatisticsSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<PostStatisticsQuery, PostStatisticsQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<PostStatisticsQuery, PostStatisticsQueryVariables>(PostStatisticsDocument, options);
}
export type PostStatisticsQueryHookResult = ReturnType<typeof usePostStatisticsQuery>;
export type PostStatisticsLazyQueryHookResult = ReturnType<typeof usePostStatisticsLazyQuery>;
export type PostStatisticsSuspenseQueryHookResult = ReturnType<typeof usePostStatisticsSuspenseQuery>;
export type PostStatisticsQueryResult = Apollo.QueryResult<PostStatisticsQuery, PostStatisticsQueryVariables>;
export const PostUpdateDocument = gql`
	mutation postUpdate($id: ID!, $input: PostUpdateInput!) {
		updatePost(id: $id, input: $input) {
			...PostDetail
		}
	}
	${PostDetailFragmentDoc}
`;
export type PostUpdateMutationFn = Apollo.MutationFunction<PostUpdateMutation, PostUpdateMutationVariables>;

/**
 * __usePostUpdateMutation__
 *
 * To run a mutation, you first call `usePostUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePostUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [postUpdateMutation, { data, loading, error }] = usePostUpdateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePostUpdateMutation(
	baseOptions?: Apollo.MutationHookOptions<PostUpdateMutation, PostUpdateMutationVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<PostUpdateMutation, PostUpdateMutationVariables>(PostUpdateDocument, options);
}
export type PostUpdateMutationHookResult = ReturnType<typeof usePostUpdateMutation>;
export type PostUpdateMutationResult = Apollo.MutationResult<PostUpdateMutation>;
export type PostUpdateMutationOptions = Apollo.BaseMutationOptions<PostUpdateMutation, PostUpdateMutationVariables>;
export const CommunicationCenterStatisticsDocument = gql`
	query communicationCenterStatistics(
		$announcementFilters: [AnnouncementFilterInput!]
		$newsletterFilters: [NewsletterFilterInput!]
		$postFilters: [PostFilterInput!]
		$calendarEventFilters: [CalendarEventFilterInput!]
	) {
		announcementStatistics(filters: $announcementFilters) {
			count
			views
			reactions
		}
		newsletterStatistics(filters: $newsletterFilters) {
			count
			views
			reactions
			comments
		}
		postStatistics(filters: $postFilters) {
			count
			views
			reactions
			comments
		}
		calendarEventStatistics(filters: $calendarEventFilters) {
			count
			responsesAttending
			responsesMaybeAttending
			responsesNotAttending
		}
	}
`;

/**
 * __useCommunicationCenterStatisticsQuery__
 *
 * To run a query within a React component, call `useCommunicationCenterStatisticsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCommunicationCenterStatisticsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCommunicationCenterStatisticsQuery({
 *   variables: {
 *      announcementFilters: // value for 'announcementFilters'
 *      newsletterFilters: // value for 'newsletterFilters'
 *      postFilters: // value for 'postFilters'
 *      calendarEventFilters: // value for 'calendarEventFilters'
 *   },
 * });
 */
export function useCommunicationCenterStatisticsQuery(
	baseOptions?: Apollo.QueryHookOptions<
		CommunicationCenterStatisticsQuery,
		CommunicationCenterStatisticsQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<CommunicationCenterStatisticsQuery, CommunicationCenterStatisticsQueryVariables>(
		CommunicationCenterStatisticsDocument,
		options,
	);
}
export function useCommunicationCenterStatisticsLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		CommunicationCenterStatisticsQuery,
		CommunicationCenterStatisticsQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<CommunicationCenterStatisticsQuery, CommunicationCenterStatisticsQueryVariables>(
		CommunicationCenterStatisticsDocument,
		options,
	);
}
export function useCommunicationCenterStatisticsSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		CommunicationCenterStatisticsQuery,
		CommunicationCenterStatisticsQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<CommunicationCenterStatisticsQuery, CommunicationCenterStatisticsQueryVariables>(
		CommunicationCenterStatisticsDocument,
		options,
	);
}
export type CommunicationCenterStatisticsQueryHookResult = ReturnType<typeof useCommunicationCenterStatisticsQuery>;
export type CommunicationCenterStatisticsLazyQueryHookResult = ReturnType<
	typeof useCommunicationCenterStatisticsLazyQuery
>;
export type CommunicationCenterStatisticsSuspenseQueryHookResult = ReturnType<
	typeof useCommunicationCenterStatisticsSuspenseQuery
>;
export type CommunicationCenterStatisticsQueryResult = Apollo.QueryResult<
	CommunicationCenterStatisticsQuery,
	CommunicationCenterStatisticsQueryVariables
>;
export const SharingPolicyCountDocument = gql`
	query sharingPolicyCount($filters: [SharingPolicyFilterInput!], $pagination: Pagination, $order: SharingPolicyOrder) {
		sharingPolicyConnection(filters: $filters, pagination: $pagination, order: $order) {
			totalCount
		}
	}
`;

/**
 * __useSharingPolicyCountQuery__
 *
 * To run a query within a React component, call `useSharingPolicyCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useSharingPolicyCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSharingPolicyCountQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useSharingPolicyCountQuery(
	baseOptions?: Apollo.QueryHookOptions<SharingPolicyCountQuery, SharingPolicyCountQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<SharingPolicyCountQuery, SharingPolicyCountQueryVariables>(
		SharingPolicyCountDocument,
		options,
	);
}
export function useSharingPolicyCountLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<SharingPolicyCountQuery, SharingPolicyCountQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<SharingPolicyCountQuery, SharingPolicyCountQueryVariables>(
		SharingPolicyCountDocument,
		options,
	);
}
export function useSharingPolicyCountSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<SharingPolicyCountQuery, SharingPolicyCountQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<SharingPolicyCountQuery, SharingPolicyCountQueryVariables>(
		SharingPolicyCountDocument,
		options,
	);
}
export type SharingPolicyCountQueryHookResult = ReturnType<typeof useSharingPolicyCountQuery>;
export type SharingPolicyCountLazyQueryHookResult = ReturnType<typeof useSharingPolicyCountLazyQuery>;
export type SharingPolicyCountSuspenseQueryHookResult = ReturnType<typeof useSharingPolicyCountSuspenseQuery>;
export type SharingPolicyCountQueryResult = Apollo.QueryResult<
	SharingPolicyCountQuery,
	SharingPolicyCountQueryVariables
>;
export const SharingPolicyCreateDocument = gql`
	mutation sharingPolicyCreate($input: SharingPolicyCreateInput!) {
		createSharingPolicy(input: $input) {
			...SharingPolicyDetail
		}
	}
	${SharingPolicyDetailFragmentDoc}
`;
export type SharingPolicyCreateMutationFn = Apollo.MutationFunction<
	SharingPolicyCreateMutation,
	SharingPolicyCreateMutationVariables
>;

/**
 * __useSharingPolicyCreateMutation__
 *
 * To run a mutation, you first call `useSharingPolicyCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSharingPolicyCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sharingPolicyCreateMutation, { data, loading, error }] = useSharingPolicyCreateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSharingPolicyCreateMutation(
	baseOptions?: Apollo.MutationHookOptions<SharingPolicyCreateMutation, SharingPolicyCreateMutationVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<SharingPolicyCreateMutation, SharingPolicyCreateMutationVariables>(
		SharingPolicyCreateDocument,
		options,
	);
}
export type SharingPolicyCreateMutationHookResult = ReturnType<typeof useSharingPolicyCreateMutation>;
export type SharingPolicyCreateMutationResult = Apollo.MutationResult<SharingPolicyCreateMutation>;
export type SharingPolicyCreateMutationOptions = Apollo.BaseMutationOptions<
	SharingPolicyCreateMutation,
	SharingPolicyCreateMutationVariables
>;
export const SharingPolicyDeleteDocument = gql`
	mutation sharingPolicyDelete($id: ID!) {
		deleteSharingPolicy(id: $id)
	}
`;
export type SharingPolicyDeleteMutationFn = Apollo.MutationFunction<
	SharingPolicyDeleteMutation,
	SharingPolicyDeleteMutationVariables
>;

/**
 * __useSharingPolicyDeleteMutation__
 *
 * To run a mutation, you first call `useSharingPolicyDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSharingPolicyDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sharingPolicyDeleteMutation, { data, loading, error }] = useSharingPolicyDeleteMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSharingPolicyDeleteMutation(
	baseOptions?: Apollo.MutationHookOptions<SharingPolicyDeleteMutation, SharingPolicyDeleteMutationVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<SharingPolicyDeleteMutation, SharingPolicyDeleteMutationVariables>(
		SharingPolicyDeleteDocument,
		options,
	);
}
export type SharingPolicyDeleteMutationHookResult = ReturnType<typeof useSharingPolicyDeleteMutation>;
export type SharingPolicyDeleteMutationResult = Apollo.MutationResult<SharingPolicyDeleteMutation>;
export type SharingPolicyDeleteMutationOptions = Apollo.BaseMutationOptions<
	SharingPolicyDeleteMutation,
	SharingPolicyDeleteMutationVariables
>;
export const SharingPolicyDetailDocument = gql`
	query sharingPolicyDetail($id: ID!) {
		sharingPolicy(id: $id) {
			...SharingPolicyDetail
		}
	}
	${SharingPolicyDetailFragmentDoc}
`;

/**
 * __useSharingPolicyDetailQuery__
 *
 * To run a query within a React component, call `useSharingPolicyDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useSharingPolicyDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSharingPolicyDetailQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSharingPolicyDetailQuery(
	baseOptions: Apollo.QueryHookOptions<SharingPolicyDetailQuery, SharingPolicyDetailQueryVariables> &
		({ variables: SharingPolicyDetailQueryVariables; skip?: boolean } | { skip: boolean }),
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<SharingPolicyDetailQuery, SharingPolicyDetailQueryVariables>(
		SharingPolicyDetailDocument,
		options,
	);
}
export function useSharingPolicyDetailLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<SharingPolicyDetailQuery, SharingPolicyDetailQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<SharingPolicyDetailQuery, SharingPolicyDetailQueryVariables>(
		SharingPolicyDetailDocument,
		options,
	);
}
export function useSharingPolicyDetailSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<SharingPolicyDetailQuery, SharingPolicyDetailQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<SharingPolicyDetailQuery, SharingPolicyDetailQueryVariables>(
		SharingPolicyDetailDocument,
		options,
	);
}
export type SharingPolicyDetailQueryHookResult = ReturnType<typeof useSharingPolicyDetailQuery>;
export type SharingPolicyDetailLazyQueryHookResult = ReturnType<typeof useSharingPolicyDetailLazyQuery>;
export type SharingPolicyDetailSuspenseQueryHookResult = ReturnType<typeof useSharingPolicyDetailSuspenseQuery>;
export type SharingPolicyDetailQueryResult = Apollo.QueryResult<
	SharingPolicyDetailQuery,
	SharingPolicyDetailQueryVariables
>;
export const SharingPolicyIndexDocument = gql`
	query sharingPolicyIndex($filters: [SharingPolicyFilterInput!], $pagination: Pagination, $order: SharingPolicyOrder) {
		sharingPolicyConnection(filters: $filters, pagination: $pagination, order: $order) {
			edges {
				node {
					id
					isPublic
				}
			}
		}
	}
`;

/**
 * __useSharingPolicyIndexQuery__
 *
 * To run a query within a React component, call `useSharingPolicyIndexQuery` and pass it any options that fit your needs.
 * When your component renders, `useSharingPolicyIndexQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSharingPolicyIndexQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useSharingPolicyIndexQuery(
	baseOptions?: Apollo.QueryHookOptions<SharingPolicyIndexQuery, SharingPolicyIndexQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<SharingPolicyIndexQuery, SharingPolicyIndexQueryVariables>(
		SharingPolicyIndexDocument,
		options,
	);
}
export function useSharingPolicyIndexLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<SharingPolicyIndexQuery, SharingPolicyIndexQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<SharingPolicyIndexQuery, SharingPolicyIndexQueryVariables>(
		SharingPolicyIndexDocument,
		options,
	);
}
export function useSharingPolicyIndexSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<SharingPolicyIndexQuery, SharingPolicyIndexQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<SharingPolicyIndexQuery, SharingPolicyIndexQueryVariables>(
		SharingPolicyIndexDocument,
		options,
	);
}
export type SharingPolicyIndexQueryHookResult = ReturnType<typeof useSharingPolicyIndexQuery>;
export type SharingPolicyIndexLazyQueryHookResult = ReturnType<typeof useSharingPolicyIndexLazyQuery>;
export type SharingPolicyIndexSuspenseQueryHookResult = ReturnType<typeof useSharingPolicyIndexSuspenseQuery>;
export type SharingPolicyIndexQueryResult = Apollo.QueryResult<
	SharingPolicyIndexQuery,
	SharingPolicyIndexQueryVariables
>;
export const SharingPolicyNameDocument = gql`
	query sharingPolicyName($id: ID!) {
		sharingPolicy(id: $id) {
			id
			...SharingPolicyName
		}
	}
	${SharingPolicyNameFragmentDoc}
`;

/**
 * __useSharingPolicyNameQuery__
 *
 * To run a query within a React component, call `useSharingPolicyNameQuery` and pass it any options that fit your needs.
 * When your component renders, `useSharingPolicyNameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSharingPolicyNameQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSharingPolicyNameQuery(
	baseOptions: Apollo.QueryHookOptions<SharingPolicyNameQuery, SharingPolicyNameQueryVariables> &
		({ variables: SharingPolicyNameQueryVariables; skip?: boolean } | { skip: boolean }),
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<SharingPolicyNameQuery, SharingPolicyNameQueryVariables>(SharingPolicyNameDocument, options);
}
export function useSharingPolicyNameLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<SharingPolicyNameQuery, SharingPolicyNameQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<SharingPolicyNameQuery, SharingPolicyNameQueryVariables>(
		SharingPolicyNameDocument,
		options,
	);
}
export function useSharingPolicyNameSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<SharingPolicyNameQuery, SharingPolicyNameQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<SharingPolicyNameQuery, SharingPolicyNameQueryVariables>(
		SharingPolicyNameDocument,
		options,
	);
}
export type SharingPolicyNameQueryHookResult = ReturnType<typeof useSharingPolicyNameQuery>;
export type SharingPolicyNameLazyQueryHookResult = ReturnType<typeof useSharingPolicyNameLazyQuery>;
export type SharingPolicyNameSuspenseQueryHookResult = ReturnType<typeof useSharingPolicyNameSuspenseQuery>;
export type SharingPolicyNameQueryResult = Apollo.QueryResult<SharingPolicyNameQuery, SharingPolicyNameQueryVariables>;
export const SharingPolicyNamesDocument = gql`
	query sharingPolicyNames($filters: [SharingPolicyFilterInput!], $pagination: Pagination, $order: SharingPolicyOrder) {
		sharingPolicyConnection(filters: $filters, pagination: $pagination, order: $order) {
			edges {
				node {
					id
					...SharingPolicyName
				}
			}
		}
	}
	${SharingPolicyNameFragmentDoc}
`;

/**
 * __useSharingPolicyNamesQuery__
 *
 * To run a query within a React component, call `useSharingPolicyNamesQuery` and pass it any options that fit your needs.
 * When your component renders, `useSharingPolicyNamesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSharingPolicyNamesQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useSharingPolicyNamesQuery(
	baseOptions?: Apollo.QueryHookOptions<SharingPolicyNamesQuery, SharingPolicyNamesQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<SharingPolicyNamesQuery, SharingPolicyNamesQueryVariables>(
		SharingPolicyNamesDocument,
		options,
	);
}
export function useSharingPolicyNamesLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<SharingPolicyNamesQuery, SharingPolicyNamesQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<SharingPolicyNamesQuery, SharingPolicyNamesQueryVariables>(
		SharingPolicyNamesDocument,
		options,
	);
}
export function useSharingPolicyNamesSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<SharingPolicyNamesQuery, SharingPolicyNamesQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<SharingPolicyNamesQuery, SharingPolicyNamesQueryVariables>(
		SharingPolicyNamesDocument,
		options,
	);
}
export type SharingPolicyNamesQueryHookResult = ReturnType<typeof useSharingPolicyNamesQuery>;
export type SharingPolicyNamesLazyQueryHookResult = ReturnType<typeof useSharingPolicyNamesLazyQuery>;
export type SharingPolicyNamesSuspenseQueryHookResult = ReturnType<typeof useSharingPolicyNamesSuspenseQuery>;
export type SharingPolicyNamesQueryResult = Apollo.QueryResult<
	SharingPolicyNamesQuery,
	SharingPolicyNamesQueryVariables
>;
export const SharingPolicyPaginationDocument = gql`
	query sharingPolicyPagination($filters: [SharingPolicyFilterInput!], $order: SharingPolicyOrder) {
		sharingPolicyConnection(filters: $filters, order: $order) {
			totalCount
			edges {
				cursor
			}
		}
	}
`;

/**
 * __useSharingPolicyPaginationQuery__
 *
 * To run a query within a React component, call `useSharingPolicyPaginationQuery` and pass it any options that fit your needs.
 * When your component renders, `useSharingPolicyPaginationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSharingPolicyPaginationQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useSharingPolicyPaginationQuery(
	baseOptions?: Apollo.QueryHookOptions<SharingPolicyPaginationQuery, SharingPolicyPaginationQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<SharingPolicyPaginationQuery, SharingPolicyPaginationQueryVariables>(
		SharingPolicyPaginationDocument,
		options,
	);
}
export function useSharingPolicyPaginationLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<SharingPolicyPaginationQuery, SharingPolicyPaginationQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<SharingPolicyPaginationQuery, SharingPolicyPaginationQueryVariables>(
		SharingPolicyPaginationDocument,
		options,
	);
}
export function useSharingPolicyPaginationSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<SharingPolicyPaginationQuery, SharingPolicyPaginationQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<SharingPolicyPaginationQuery, SharingPolicyPaginationQueryVariables>(
		SharingPolicyPaginationDocument,
		options,
	);
}
export type SharingPolicyPaginationQueryHookResult = ReturnType<typeof useSharingPolicyPaginationQuery>;
export type SharingPolicyPaginationLazyQueryHookResult = ReturnType<typeof useSharingPolicyPaginationLazyQuery>;
export type SharingPolicyPaginationSuspenseQueryHookResult = ReturnType<typeof useSharingPolicyPaginationSuspenseQuery>;
export type SharingPolicyPaginationQueryResult = Apollo.QueryResult<
	SharingPolicyPaginationQuery,
	SharingPolicyPaginationQueryVariables
>;
export const SharingPolicySelectDocument = gql`
	query sharingPolicySelect($filters: [SharingPolicyFilterInput!], $order: SharingPolicyOrder) {
		sharingPolicyConnection(filters: $filters, order: $order) {
			edges {
				node {
					id
					...SharingPolicyName
				}
			}
		}
	}
	${SharingPolicyNameFragmentDoc}
`;

/**
 * __useSharingPolicySelectQuery__
 *
 * To run a query within a React component, call `useSharingPolicySelectQuery` and pass it any options that fit your needs.
 * When your component renders, `useSharingPolicySelectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSharingPolicySelectQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useSharingPolicySelectQuery(
	baseOptions?: Apollo.QueryHookOptions<SharingPolicySelectQuery, SharingPolicySelectQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<SharingPolicySelectQuery, SharingPolicySelectQueryVariables>(
		SharingPolicySelectDocument,
		options,
	);
}
export function useSharingPolicySelectLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<SharingPolicySelectQuery, SharingPolicySelectQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<SharingPolicySelectQuery, SharingPolicySelectQueryVariables>(
		SharingPolicySelectDocument,
		options,
	);
}
export function useSharingPolicySelectSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<SharingPolicySelectQuery, SharingPolicySelectQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<SharingPolicySelectQuery, SharingPolicySelectQueryVariables>(
		SharingPolicySelectDocument,
		options,
	);
}
export type SharingPolicySelectQueryHookResult = ReturnType<typeof useSharingPolicySelectQuery>;
export type SharingPolicySelectLazyQueryHookResult = ReturnType<typeof useSharingPolicySelectLazyQuery>;
export type SharingPolicySelectSuspenseQueryHookResult = ReturnType<typeof useSharingPolicySelectSuspenseQuery>;
export type SharingPolicySelectQueryResult = Apollo.QueryResult<
	SharingPolicySelectQuery,
	SharingPolicySelectQueryVariables
>;
export const SharingPolicyUpdateDocument = gql`
	mutation sharingPolicyUpdate($id: ID!, $input: SharingPolicyUpdateInput!) {
		updateSharingPolicy(id: $id, input: $input) {
			...SharingPolicyDetail
		}
	}
	${SharingPolicyDetailFragmentDoc}
`;
export type SharingPolicyUpdateMutationFn = Apollo.MutationFunction<
	SharingPolicyUpdateMutation,
	SharingPolicyUpdateMutationVariables
>;

/**
 * __useSharingPolicyUpdateMutation__
 *
 * To run a mutation, you first call `useSharingPolicyUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSharingPolicyUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sharingPolicyUpdateMutation, { data, loading, error }] = useSharingPolicyUpdateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSharingPolicyUpdateMutation(
	baseOptions?: Apollo.MutationHookOptions<SharingPolicyUpdateMutation, SharingPolicyUpdateMutationVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<SharingPolicyUpdateMutation, SharingPolicyUpdateMutationVariables>(
		SharingPolicyUpdateDocument,
		options,
	);
}
export type SharingPolicyUpdateMutationHookResult = ReturnType<typeof useSharingPolicyUpdateMutation>;
export type SharingPolicyUpdateMutationResult = Apollo.MutationResult<SharingPolicyUpdateMutation>;
export type SharingPolicyUpdateMutationOptions = Apollo.BaseMutationOptions<
	SharingPolicyUpdateMutation,
	SharingPolicyUpdateMutationVariables
>;
export const SharingPolicyPreviewDocument = gql`
	query sharingPolicyPreview($filters: [SharingPolicyFilterInput!]) {
		sharingPolicyConnection(filters: $filters) {
			edges {
				node {
					id
					isPublic
					userGroups {
						id
						...UserGroupName
					}
				}
			}
		}
		userConnection(filters: { sharedSharingPolicies: $filters }) {
			totalCount
		}
	}
	${UserGroupNameFragmentDoc}
`;

/**
 * __useSharingPolicyPreviewQuery__
 *
 * To run a query within a React component, call `useSharingPolicyPreviewQuery` and pass it any options that fit your needs.
 * When your component renders, `useSharingPolicyPreviewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSharingPolicyPreviewQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useSharingPolicyPreviewQuery(
	baseOptions?: Apollo.QueryHookOptions<SharingPolicyPreviewQuery, SharingPolicyPreviewQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<SharingPolicyPreviewQuery, SharingPolicyPreviewQueryVariables>(
		SharingPolicyPreviewDocument,
		options,
	);
}
export function useSharingPolicyPreviewLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<SharingPolicyPreviewQuery, SharingPolicyPreviewQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<SharingPolicyPreviewQuery, SharingPolicyPreviewQueryVariables>(
		SharingPolicyPreviewDocument,
		options,
	);
}
export function useSharingPolicyPreviewSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<SharingPolicyPreviewQuery, SharingPolicyPreviewQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<SharingPolicyPreviewQuery, SharingPolicyPreviewQueryVariables>(
		SharingPolicyPreviewDocument,
		options,
	);
}
export type SharingPolicyPreviewQueryHookResult = ReturnType<typeof useSharingPolicyPreviewQuery>;
export type SharingPolicyPreviewLazyQueryHookResult = ReturnType<typeof useSharingPolicyPreviewLazyQuery>;
export type SharingPolicyPreviewSuspenseQueryHookResult = ReturnType<typeof useSharingPolicyPreviewSuspenseQuery>;
export type SharingPolicyPreviewQueryResult = Apollo.QueryResult<
	SharingPolicyPreviewQuery,
	SharingPolicyPreviewQueryVariables
>;
export const SharingPolicyUsersPreviewDocument = gql`
	query sharingPolicyUsersPreview(
		$sharingPolicy: SharingPolicyCreateInput!
		$filters: [UserFilterInput!]
		$pagination: Pagination
		$order: UserOrder
	) {
		sharedUserConnection(sharingPolicy: $sharingPolicy, filters: $filters, pagination: $pagination, order: $order) {
			totalCount
			pageInfo {
				hasNextPage
				endCursor
			}
			edges {
				node {
					id
					...UserNameDescriptionAndImage
				}
			}
		}
	}
	${UserNameDescriptionAndImageFragmentDoc}
`;

/**
 * __useSharingPolicyUsersPreviewQuery__
 *
 * To run a query within a React component, call `useSharingPolicyUsersPreviewQuery` and pass it any options that fit your needs.
 * When your component renders, `useSharingPolicyUsersPreviewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSharingPolicyUsersPreviewQuery({
 *   variables: {
 *      sharingPolicy: // value for 'sharingPolicy'
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useSharingPolicyUsersPreviewQuery(
	baseOptions: Apollo.QueryHookOptions<SharingPolicyUsersPreviewQuery, SharingPolicyUsersPreviewQueryVariables> &
		({ variables: SharingPolicyUsersPreviewQueryVariables; skip?: boolean } | { skip: boolean }),
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<SharingPolicyUsersPreviewQuery, SharingPolicyUsersPreviewQueryVariables>(
		SharingPolicyUsersPreviewDocument,
		options,
	);
}
export function useSharingPolicyUsersPreviewLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<SharingPolicyUsersPreviewQuery, SharingPolicyUsersPreviewQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<SharingPolicyUsersPreviewQuery, SharingPolicyUsersPreviewQueryVariables>(
		SharingPolicyUsersPreviewDocument,
		options,
	);
}
export function useSharingPolicyUsersPreviewSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		SharingPolicyUsersPreviewQuery,
		SharingPolicyUsersPreviewQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<SharingPolicyUsersPreviewQuery, SharingPolicyUsersPreviewQueryVariables>(
		SharingPolicyUsersPreviewDocument,
		options,
	);
}
export type SharingPolicyUsersPreviewQueryHookResult = ReturnType<typeof useSharingPolicyUsersPreviewQuery>;
export type SharingPolicyUsersPreviewLazyQueryHookResult = ReturnType<typeof useSharingPolicyUsersPreviewLazyQuery>;
export type SharingPolicyUsersPreviewSuspenseQueryHookResult = ReturnType<
	typeof useSharingPolicyUsersPreviewSuspenseQuery
>;
export type SharingPolicyUsersPreviewQueryResult = Apollo.QueryResult<
	SharingPolicyUsersPreviewQuery,
	SharingPolicyUsersPreviewQueryVariables
>;
export const SocialCommentCountDocument = gql`
	query socialCommentCount($filters: [SocialCommentFilterInput!], $pagination: Pagination, $order: SocialCommentOrder) {
		socialCommentConnection(filters: $filters, pagination: $pagination, order: $order) {
			totalCount
		}
	}
`;

/**
 * __useSocialCommentCountQuery__
 *
 * To run a query within a React component, call `useSocialCommentCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useSocialCommentCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSocialCommentCountQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useSocialCommentCountQuery(
	baseOptions?: Apollo.QueryHookOptions<SocialCommentCountQuery, SocialCommentCountQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<SocialCommentCountQuery, SocialCommentCountQueryVariables>(
		SocialCommentCountDocument,
		options,
	);
}
export function useSocialCommentCountLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<SocialCommentCountQuery, SocialCommentCountQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<SocialCommentCountQuery, SocialCommentCountQueryVariables>(
		SocialCommentCountDocument,
		options,
	);
}
export function useSocialCommentCountSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<SocialCommentCountQuery, SocialCommentCountQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<SocialCommentCountQuery, SocialCommentCountQueryVariables>(
		SocialCommentCountDocument,
		options,
	);
}
export type SocialCommentCountQueryHookResult = ReturnType<typeof useSocialCommentCountQuery>;
export type SocialCommentCountLazyQueryHookResult = ReturnType<typeof useSocialCommentCountLazyQuery>;
export type SocialCommentCountSuspenseQueryHookResult = ReturnType<typeof useSocialCommentCountSuspenseQuery>;
export type SocialCommentCountQueryResult = Apollo.QueryResult<
	SocialCommentCountQuery,
	SocialCommentCountQueryVariables
>;
export const SocialCommentCreateDocument = gql`
	mutation socialCommentCreate($input: SocialCommentCreateInput!) {
		createSocialComment(input: $input) {
			...SocialCommentDetail
		}
	}
	${SocialCommentDetailFragmentDoc}
`;
export type SocialCommentCreateMutationFn = Apollo.MutationFunction<
	SocialCommentCreateMutation,
	SocialCommentCreateMutationVariables
>;

/**
 * __useSocialCommentCreateMutation__
 *
 * To run a mutation, you first call `useSocialCommentCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSocialCommentCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [socialCommentCreateMutation, { data, loading, error }] = useSocialCommentCreateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSocialCommentCreateMutation(
	baseOptions?: Apollo.MutationHookOptions<SocialCommentCreateMutation, SocialCommentCreateMutationVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<SocialCommentCreateMutation, SocialCommentCreateMutationVariables>(
		SocialCommentCreateDocument,
		options,
	);
}
export type SocialCommentCreateMutationHookResult = ReturnType<typeof useSocialCommentCreateMutation>;
export type SocialCommentCreateMutationResult = Apollo.MutationResult<SocialCommentCreateMutation>;
export type SocialCommentCreateMutationOptions = Apollo.BaseMutationOptions<
	SocialCommentCreateMutation,
	SocialCommentCreateMutationVariables
>;
export const SocialCommentDeleteDocument = gql`
	mutation socialCommentDelete($id: ID!) {
		deleteSocialComment(id: $id)
	}
`;
export type SocialCommentDeleteMutationFn = Apollo.MutationFunction<
	SocialCommentDeleteMutation,
	SocialCommentDeleteMutationVariables
>;

/**
 * __useSocialCommentDeleteMutation__
 *
 * To run a mutation, you first call `useSocialCommentDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSocialCommentDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [socialCommentDeleteMutation, { data, loading, error }] = useSocialCommentDeleteMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSocialCommentDeleteMutation(
	baseOptions?: Apollo.MutationHookOptions<SocialCommentDeleteMutation, SocialCommentDeleteMutationVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<SocialCommentDeleteMutation, SocialCommentDeleteMutationVariables>(
		SocialCommentDeleteDocument,
		options,
	);
}
export type SocialCommentDeleteMutationHookResult = ReturnType<typeof useSocialCommentDeleteMutation>;
export type SocialCommentDeleteMutationResult = Apollo.MutationResult<SocialCommentDeleteMutation>;
export type SocialCommentDeleteMutationOptions = Apollo.BaseMutationOptions<
	SocialCommentDeleteMutation,
	SocialCommentDeleteMutationVariables
>;
export const SocialCommentDetailDocument = gql`
	query socialCommentDetail($id: ID!) {
		socialComment(id: $id) {
			...SocialCommentDetail
		}
	}
	${SocialCommentDetailFragmentDoc}
`;

/**
 * __useSocialCommentDetailQuery__
 *
 * To run a query within a React component, call `useSocialCommentDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useSocialCommentDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSocialCommentDetailQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSocialCommentDetailQuery(
	baseOptions: Apollo.QueryHookOptions<SocialCommentDetailQuery, SocialCommentDetailQueryVariables> &
		({ variables: SocialCommentDetailQueryVariables; skip?: boolean } | { skip: boolean }),
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<SocialCommentDetailQuery, SocialCommentDetailQueryVariables>(
		SocialCommentDetailDocument,
		options,
	);
}
export function useSocialCommentDetailLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<SocialCommentDetailQuery, SocialCommentDetailQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<SocialCommentDetailQuery, SocialCommentDetailQueryVariables>(
		SocialCommentDetailDocument,
		options,
	);
}
export function useSocialCommentDetailSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<SocialCommentDetailQuery, SocialCommentDetailQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<SocialCommentDetailQuery, SocialCommentDetailQueryVariables>(
		SocialCommentDetailDocument,
		options,
	);
}
export type SocialCommentDetailQueryHookResult = ReturnType<typeof useSocialCommentDetailQuery>;
export type SocialCommentDetailLazyQueryHookResult = ReturnType<typeof useSocialCommentDetailLazyQuery>;
export type SocialCommentDetailSuspenseQueryHookResult = ReturnType<typeof useSocialCommentDetailSuspenseQuery>;
export type SocialCommentDetailQueryResult = Apollo.QueryResult<
	SocialCommentDetailQuery,
	SocialCommentDetailQueryVariables
>;
export const SocialCommentIndexDocument = gql`
	query socialCommentIndex($filters: [SocialCommentFilterInput!], $pagination: Pagination, $order: SocialCommentOrder) {
		socialCommentConnection(filters: $filters, pagination: $pagination, order: $order) {
			edges {
				node {
					id
					createdAt
					body
				}
			}
		}
	}
`;

/**
 * __useSocialCommentIndexQuery__
 *
 * To run a query within a React component, call `useSocialCommentIndexQuery` and pass it any options that fit your needs.
 * When your component renders, `useSocialCommentIndexQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSocialCommentIndexQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useSocialCommentIndexQuery(
	baseOptions?: Apollo.QueryHookOptions<SocialCommentIndexQuery, SocialCommentIndexQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<SocialCommentIndexQuery, SocialCommentIndexQueryVariables>(
		SocialCommentIndexDocument,
		options,
	);
}
export function useSocialCommentIndexLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<SocialCommentIndexQuery, SocialCommentIndexQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<SocialCommentIndexQuery, SocialCommentIndexQueryVariables>(
		SocialCommentIndexDocument,
		options,
	);
}
export function useSocialCommentIndexSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<SocialCommentIndexQuery, SocialCommentIndexQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<SocialCommentIndexQuery, SocialCommentIndexQueryVariables>(
		SocialCommentIndexDocument,
		options,
	);
}
export type SocialCommentIndexQueryHookResult = ReturnType<typeof useSocialCommentIndexQuery>;
export type SocialCommentIndexLazyQueryHookResult = ReturnType<typeof useSocialCommentIndexLazyQuery>;
export type SocialCommentIndexSuspenseQueryHookResult = ReturnType<typeof useSocialCommentIndexSuspenseQuery>;
export type SocialCommentIndexQueryResult = Apollo.QueryResult<
	SocialCommentIndexQuery,
	SocialCommentIndexQueryVariables
>;
export const SocialCommentListDocument = gql`
	query socialCommentList($filters: [SocialCommentFilterInput!], $pagination: Pagination, $order: SocialCommentOrder) {
		socialCommentConnection(filters: $filters, pagination: $pagination, order: $order) {
			totalCount
			edges {
				node {
					id
					body
					createdAt
					author {
						id
						...UserNameAndImage
						isCurrent
					}
				}
			}
		}
	}
	${UserNameAndImageFragmentDoc}
`;

/**
 * __useSocialCommentListQuery__
 *
 * To run a query within a React component, call `useSocialCommentListQuery` and pass it any options that fit your needs.
 * When your component renders, `useSocialCommentListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSocialCommentListQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useSocialCommentListQuery(
	baseOptions?: Apollo.QueryHookOptions<SocialCommentListQuery, SocialCommentListQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<SocialCommentListQuery, SocialCommentListQueryVariables>(SocialCommentListDocument, options);
}
export function useSocialCommentListLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<SocialCommentListQuery, SocialCommentListQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<SocialCommentListQuery, SocialCommentListQueryVariables>(
		SocialCommentListDocument,
		options,
	);
}
export function useSocialCommentListSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<SocialCommentListQuery, SocialCommentListQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<SocialCommentListQuery, SocialCommentListQueryVariables>(
		SocialCommentListDocument,
		options,
	);
}
export type SocialCommentListQueryHookResult = ReturnType<typeof useSocialCommentListQuery>;
export type SocialCommentListLazyQueryHookResult = ReturnType<typeof useSocialCommentListLazyQuery>;
export type SocialCommentListSuspenseQueryHookResult = ReturnType<typeof useSocialCommentListSuspenseQuery>;
export type SocialCommentListQueryResult = Apollo.QueryResult<SocialCommentListQuery, SocialCommentListQueryVariables>;
export const SocialCommentNameDocument = gql`
	query socialCommentName($id: ID!) {
		socialComment(id: $id) {
			id
			...SocialCommentName
		}
	}
	${SocialCommentNameFragmentDoc}
`;

/**
 * __useSocialCommentNameQuery__
 *
 * To run a query within a React component, call `useSocialCommentNameQuery` and pass it any options that fit your needs.
 * When your component renders, `useSocialCommentNameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSocialCommentNameQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSocialCommentNameQuery(
	baseOptions: Apollo.QueryHookOptions<SocialCommentNameQuery, SocialCommentNameQueryVariables> &
		({ variables: SocialCommentNameQueryVariables; skip?: boolean } | { skip: boolean }),
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<SocialCommentNameQuery, SocialCommentNameQueryVariables>(SocialCommentNameDocument, options);
}
export function useSocialCommentNameLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<SocialCommentNameQuery, SocialCommentNameQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<SocialCommentNameQuery, SocialCommentNameQueryVariables>(
		SocialCommentNameDocument,
		options,
	);
}
export function useSocialCommentNameSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<SocialCommentNameQuery, SocialCommentNameQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<SocialCommentNameQuery, SocialCommentNameQueryVariables>(
		SocialCommentNameDocument,
		options,
	);
}
export type SocialCommentNameQueryHookResult = ReturnType<typeof useSocialCommentNameQuery>;
export type SocialCommentNameLazyQueryHookResult = ReturnType<typeof useSocialCommentNameLazyQuery>;
export type SocialCommentNameSuspenseQueryHookResult = ReturnType<typeof useSocialCommentNameSuspenseQuery>;
export type SocialCommentNameQueryResult = Apollo.QueryResult<SocialCommentNameQuery, SocialCommentNameQueryVariables>;
export const SocialCommentNamesDocument = gql`
	query socialCommentNames($filters: [SocialCommentFilterInput!], $pagination: Pagination, $order: SocialCommentOrder) {
		socialCommentConnection(filters: $filters, pagination: $pagination, order: $order) {
			edges {
				node {
					id
					...SocialCommentName
				}
			}
		}
	}
	${SocialCommentNameFragmentDoc}
`;

/**
 * __useSocialCommentNamesQuery__
 *
 * To run a query within a React component, call `useSocialCommentNamesQuery` and pass it any options that fit your needs.
 * When your component renders, `useSocialCommentNamesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSocialCommentNamesQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useSocialCommentNamesQuery(
	baseOptions?: Apollo.QueryHookOptions<SocialCommentNamesQuery, SocialCommentNamesQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<SocialCommentNamesQuery, SocialCommentNamesQueryVariables>(
		SocialCommentNamesDocument,
		options,
	);
}
export function useSocialCommentNamesLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<SocialCommentNamesQuery, SocialCommentNamesQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<SocialCommentNamesQuery, SocialCommentNamesQueryVariables>(
		SocialCommentNamesDocument,
		options,
	);
}
export function useSocialCommentNamesSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<SocialCommentNamesQuery, SocialCommentNamesQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<SocialCommentNamesQuery, SocialCommentNamesQueryVariables>(
		SocialCommentNamesDocument,
		options,
	);
}
export type SocialCommentNamesQueryHookResult = ReturnType<typeof useSocialCommentNamesQuery>;
export type SocialCommentNamesLazyQueryHookResult = ReturnType<typeof useSocialCommentNamesLazyQuery>;
export type SocialCommentNamesSuspenseQueryHookResult = ReturnType<typeof useSocialCommentNamesSuspenseQuery>;
export type SocialCommentNamesQueryResult = Apollo.QueryResult<
	SocialCommentNamesQuery,
	SocialCommentNamesQueryVariables
>;
export const SocialCommentPaginationDocument = gql`
	query socialCommentPagination($filters: [SocialCommentFilterInput!], $order: SocialCommentOrder) {
		socialCommentConnection(filters: $filters, order: $order) {
			totalCount
			edges {
				cursor
			}
		}
	}
`;

/**
 * __useSocialCommentPaginationQuery__
 *
 * To run a query within a React component, call `useSocialCommentPaginationQuery` and pass it any options that fit your needs.
 * When your component renders, `useSocialCommentPaginationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSocialCommentPaginationQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useSocialCommentPaginationQuery(
	baseOptions?: Apollo.QueryHookOptions<SocialCommentPaginationQuery, SocialCommentPaginationQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<SocialCommentPaginationQuery, SocialCommentPaginationQueryVariables>(
		SocialCommentPaginationDocument,
		options,
	);
}
export function useSocialCommentPaginationLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<SocialCommentPaginationQuery, SocialCommentPaginationQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<SocialCommentPaginationQuery, SocialCommentPaginationQueryVariables>(
		SocialCommentPaginationDocument,
		options,
	);
}
export function useSocialCommentPaginationSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<SocialCommentPaginationQuery, SocialCommentPaginationQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<SocialCommentPaginationQuery, SocialCommentPaginationQueryVariables>(
		SocialCommentPaginationDocument,
		options,
	);
}
export type SocialCommentPaginationQueryHookResult = ReturnType<typeof useSocialCommentPaginationQuery>;
export type SocialCommentPaginationLazyQueryHookResult = ReturnType<typeof useSocialCommentPaginationLazyQuery>;
export type SocialCommentPaginationSuspenseQueryHookResult = ReturnType<typeof useSocialCommentPaginationSuspenseQuery>;
export type SocialCommentPaginationQueryResult = Apollo.QueryResult<
	SocialCommentPaginationQuery,
	SocialCommentPaginationQueryVariables
>;
export const SocialCommentSelectDocument = gql`
	query socialCommentSelect($filters: [SocialCommentFilterInput!], $order: SocialCommentOrder) {
		socialCommentConnection(filters: $filters, order: $order) {
			edges {
				node {
					id
					...SocialCommentName
				}
			}
		}
	}
	${SocialCommentNameFragmentDoc}
`;

/**
 * __useSocialCommentSelectQuery__
 *
 * To run a query within a React component, call `useSocialCommentSelectQuery` and pass it any options that fit your needs.
 * When your component renders, `useSocialCommentSelectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSocialCommentSelectQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useSocialCommentSelectQuery(
	baseOptions?: Apollo.QueryHookOptions<SocialCommentSelectQuery, SocialCommentSelectQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<SocialCommentSelectQuery, SocialCommentSelectQueryVariables>(
		SocialCommentSelectDocument,
		options,
	);
}
export function useSocialCommentSelectLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<SocialCommentSelectQuery, SocialCommentSelectQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<SocialCommentSelectQuery, SocialCommentSelectQueryVariables>(
		SocialCommentSelectDocument,
		options,
	);
}
export function useSocialCommentSelectSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<SocialCommentSelectQuery, SocialCommentSelectQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<SocialCommentSelectQuery, SocialCommentSelectQueryVariables>(
		SocialCommentSelectDocument,
		options,
	);
}
export type SocialCommentSelectQueryHookResult = ReturnType<typeof useSocialCommentSelectQuery>;
export type SocialCommentSelectLazyQueryHookResult = ReturnType<typeof useSocialCommentSelectLazyQuery>;
export type SocialCommentSelectSuspenseQueryHookResult = ReturnType<typeof useSocialCommentSelectSuspenseQuery>;
export type SocialCommentSelectQueryResult = Apollo.QueryResult<
	SocialCommentSelectQuery,
	SocialCommentSelectQueryVariables
>;
export const SocialCommentUpdateDocument = gql`
	mutation socialCommentUpdate($id: ID!, $input: SocialCommentUpdateInput!) {
		updateSocialComment(id: $id, input: $input) {
			...SocialCommentDetail
		}
	}
	${SocialCommentDetailFragmentDoc}
`;
export type SocialCommentUpdateMutationFn = Apollo.MutationFunction<
	SocialCommentUpdateMutation,
	SocialCommentUpdateMutationVariables
>;

/**
 * __useSocialCommentUpdateMutation__
 *
 * To run a mutation, you first call `useSocialCommentUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSocialCommentUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [socialCommentUpdateMutation, { data, loading, error }] = useSocialCommentUpdateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSocialCommentUpdateMutation(
	baseOptions?: Apollo.MutationHookOptions<SocialCommentUpdateMutation, SocialCommentUpdateMutationVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<SocialCommentUpdateMutation, SocialCommentUpdateMutationVariables>(
		SocialCommentUpdateDocument,
		options,
	);
}
export type SocialCommentUpdateMutationHookResult = ReturnType<typeof useSocialCommentUpdateMutation>;
export type SocialCommentUpdateMutationResult = Apollo.MutationResult<SocialCommentUpdateMutation>;
export type SocialCommentUpdateMutationOptions = Apollo.BaseMutationOptions<
	SocialCommentUpdateMutation,
	SocialCommentUpdateMutationVariables
>;
export const SocialReactionCountDocument = gql`
	query socialReactionCount(
		$filters: [SocialReactionFilterInput!]
		$pagination: Pagination
		$order: SocialReactionOrder
	) {
		socialReactionConnection(filters: $filters, pagination: $pagination, order: $order) {
			totalCount
		}
	}
`;

/**
 * __useSocialReactionCountQuery__
 *
 * To run a query within a React component, call `useSocialReactionCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useSocialReactionCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSocialReactionCountQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useSocialReactionCountQuery(
	baseOptions?: Apollo.QueryHookOptions<SocialReactionCountQuery, SocialReactionCountQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<SocialReactionCountQuery, SocialReactionCountQueryVariables>(
		SocialReactionCountDocument,
		options,
	);
}
export function useSocialReactionCountLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<SocialReactionCountQuery, SocialReactionCountQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<SocialReactionCountQuery, SocialReactionCountQueryVariables>(
		SocialReactionCountDocument,
		options,
	);
}
export function useSocialReactionCountSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<SocialReactionCountQuery, SocialReactionCountQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<SocialReactionCountQuery, SocialReactionCountQueryVariables>(
		SocialReactionCountDocument,
		options,
	);
}
export type SocialReactionCountQueryHookResult = ReturnType<typeof useSocialReactionCountQuery>;
export type SocialReactionCountLazyQueryHookResult = ReturnType<typeof useSocialReactionCountLazyQuery>;
export type SocialReactionCountSuspenseQueryHookResult = ReturnType<typeof useSocialReactionCountSuspenseQuery>;
export type SocialReactionCountQueryResult = Apollo.QueryResult<
	SocialReactionCountQuery,
	SocialReactionCountQueryVariables
>;
export const SocialReactionCreateDocument = gql`
	mutation socialReactionCreate($input: SocialReactionCreateInput!) {
		createSocialReaction(input: $input) {
			...SocialReactionDetail
		}
	}
	${SocialReactionDetailFragmentDoc}
`;
export type SocialReactionCreateMutationFn = Apollo.MutationFunction<
	SocialReactionCreateMutation,
	SocialReactionCreateMutationVariables
>;

/**
 * __useSocialReactionCreateMutation__
 *
 * To run a mutation, you first call `useSocialReactionCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSocialReactionCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [socialReactionCreateMutation, { data, loading, error }] = useSocialReactionCreateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSocialReactionCreateMutation(
	baseOptions?: Apollo.MutationHookOptions<SocialReactionCreateMutation, SocialReactionCreateMutationVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<SocialReactionCreateMutation, SocialReactionCreateMutationVariables>(
		SocialReactionCreateDocument,
		options,
	);
}
export type SocialReactionCreateMutationHookResult = ReturnType<typeof useSocialReactionCreateMutation>;
export type SocialReactionCreateMutationResult = Apollo.MutationResult<SocialReactionCreateMutation>;
export type SocialReactionCreateMutationOptions = Apollo.BaseMutationOptions<
	SocialReactionCreateMutation,
	SocialReactionCreateMutationVariables
>;
export const SocialReactionDeleteDocument = gql`
	mutation socialReactionDelete($id: ID!) {
		deleteSocialReaction(id: $id)
	}
`;
export type SocialReactionDeleteMutationFn = Apollo.MutationFunction<
	SocialReactionDeleteMutation,
	SocialReactionDeleteMutationVariables
>;

/**
 * __useSocialReactionDeleteMutation__
 *
 * To run a mutation, you first call `useSocialReactionDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSocialReactionDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [socialReactionDeleteMutation, { data, loading, error }] = useSocialReactionDeleteMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSocialReactionDeleteMutation(
	baseOptions?: Apollo.MutationHookOptions<SocialReactionDeleteMutation, SocialReactionDeleteMutationVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<SocialReactionDeleteMutation, SocialReactionDeleteMutationVariables>(
		SocialReactionDeleteDocument,
		options,
	);
}
export type SocialReactionDeleteMutationHookResult = ReturnType<typeof useSocialReactionDeleteMutation>;
export type SocialReactionDeleteMutationResult = Apollo.MutationResult<SocialReactionDeleteMutation>;
export type SocialReactionDeleteMutationOptions = Apollo.BaseMutationOptions<
	SocialReactionDeleteMutation,
	SocialReactionDeleteMutationVariables
>;
export const SocialReactionDetailDocument = gql`
	query socialReactionDetail($id: ID!) {
		socialReaction(id: $id) {
			...SocialReactionDetail
		}
	}
	${SocialReactionDetailFragmentDoc}
`;

/**
 * __useSocialReactionDetailQuery__
 *
 * To run a query within a React component, call `useSocialReactionDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useSocialReactionDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSocialReactionDetailQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSocialReactionDetailQuery(
	baseOptions: Apollo.QueryHookOptions<SocialReactionDetailQuery, SocialReactionDetailQueryVariables> &
		({ variables: SocialReactionDetailQueryVariables; skip?: boolean } | { skip: boolean }),
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<SocialReactionDetailQuery, SocialReactionDetailQueryVariables>(
		SocialReactionDetailDocument,
		options,
	);
}
export function useSocialReactionDetailLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<SocialReactionDetailQuery, SocialReactionDetailQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<SocialReactionDetailQuery, SocialReactionDetailQueryVariables>(
		SocialReactionDetailDocument,
		options,
	);
}
export function useSocialReactionDetailSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<SocialReactionDetailQuery, SocialReactionDetailQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<SocialReactionDetailQuery, SocialReactionDetailQueryVariables>(
		SocialReactionDetailDocument,
		options,
	);
}
export type SocialReactionDetailQueryHookResult = ReturnType<typeof useSocialReactionDetailQuery>;
export type SocialReactionDetailLazyQueryHookResult = ReturnType<typeof useSocialReactionDetailLazyQuery>;
export type SocialReactionDetailSuspenseQueryHookResult = ReturnType<typeof useSocialReactionDetailSuspenseQuery>;
export type SocialReactionDetailQueryResult = Apollo.QueryResult<
	SocialReactionDetailQuery,
	SocialReactionDetailQueryVariables
>;
export const SocialReactionIndexDocument = gql`
	query socialReactionIndex(
		$filters: [SocialReactionFilterInput!]
		$pagination: Pagination
		$order: SocialReactionOrder
	) {
		socialReactionConnection(filters: $filters, pagination: $pagination, order: $order) {
			edges {
				node {
					id
					createdAt
					reaction
				}
			}
		}
	}
`;

/**
 * __useSocialReactionIndexQuery__
 *
 * To run a query within a React component, call `useSocialReactionIndexQuery` and pass it any options that fit your needs.
 * When your component renders, `useSocialReactionIndexQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSocialReactionIndexQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useSocialReactionIndexQuery(
	baseOptions?: Apollo.QueryHookOptions<SocialReactionIndexQuery, SocialReactionIndexQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<SocialReactionIndexQuery, SocialReactionIndexQueryVariables>(
		SocialReactionIndexDocument,
		options,
	);
}
export function useSocialReactionIndexLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<SocialReactionIndexQuery, SocialReactionIndexQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<SocialReactionIndexQuery, SocialReactionIndexQueryVariables>(
		SocialReactionIndexDocument,
		options,
	);
}
export function useSocialReactionIndexSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<SocialReactionIndexQuery, SocialReactionIndexQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<SocialReactionIndexQuery, SocialReactionIndexQueryVariables>(
		SocialReactionIndexDocument,
		options,
	);
}
export type SocialReactionIndexQueryHookResult = ReturnType<typeof useSocialReactionIndexQuery>;
export type SocialReactionIndexLazyQueryHookResult = ReturnType<typeof useSocialReactionIndexLazyQuery>;
export type SocialReactionIndexSuspenseQueryHookResult = ReturnType<typeof useSocialReactionIndexSuspenseQuery>;
export type SocialReactionIndexQueryResult = Apollo.QueryResult<
	SocialReactionIndexQuery,
	SocialReactionIndexQueryVariables
>;
export const SocialReactionNameDocument = gql`
	query socialReactionName($id: ID!) {
		socialReaction(id: $id) {
			id
			...SocialReactionName
		}
	}
	${SocialReactionNameFragmentDoc}
`;

/**
 * __useSocialReactionNameQuery__
 *
 * To run a query within a React component, call `useSocialReactionNameQuery` and pass it any options that fit your needs.
 * When your component renders, `useSocialReactionNameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSocialReactionNameQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSocialReactionNameQuery(
	baseOptions: Apollo.QueryHookOptions<SocialReactionNameQuery, SocialReactionNameQueryVariables> &
		({ variables: SocialReactionNameQueryVariables; skip?: boolean } | { skip: boolean }),
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<SocialReactionNameQuery, SocialReactionNameQueryVariables>(
		SocialReactionNameDocument,
		options,
	);
}
export function useSocialReactionNameLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<SocialReactionNameQuery, SocialReactionNameQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<SocialReactionNameQuery, SocialReactionNameQueryVariables>(
		SocialReactionNameDocument,
		options,
	);
}
export function useSocialReactionNameSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<SocialReactionNameQuery, SocialReactionNameQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<SocialReactionNameQuery, SocialReactionNameQueryVariables>(
		SocialReactionNameDocument,
		options,
	);
}
export type SocialReactionNameQueryHookResult = ReturnType<typeof useSocialReactionNameQuery>;
export type SocialReactionNameLazyQueryHookResult = ReturnType<typeof useSocialReactionNameLazyQuery>;
export type SocialReactionNameSuspenseQueryHookResult = ReturnType<typeof useSocialReactionNameSuspenseQuery>;
export type SocialReactionNameQueryResult = Apollo.QueryResult<
	SocialReactionNameQuery,
	SocialReactionNameQueryVariables
>;
export const SocialReactionNamesDocument = gql`
	query socialReactionNames(
		$filters: [SocialReactionFilterInput!]
		$pagination: Pagination
		$order: SocialReactionOrder
	) {
		socialReactionConnection(filters: $filters, pagination: $pagination, order: $order) {
			edges {
				node {
					id
					...SocialReactionName
				}
			}
		}
	}
	${SocialReactionNameFragmentDoc}
`;

/**
 * __useSocialReactionNamesQuery__
 *
 * To run a query within a React component, call `useSocialReactionNamesQuery` and pass it any options that fit your needs.
 * When your component renders, `useSocialReactionNamesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSocialReactionNamesQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useSocialReactionNamesQuery(
	baseOptions?: Apollo.QueryHookOptions<SocialReactionNamesQuery, SocialReactionNamesQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<SocialReactionNamesQuery, SocialReactionNamesQueryVariables>(
		SocialReactionNamesDocument,
		options,
	);
}
export function useSocialReactionNamesLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<SocialReactionNamesQuery, SocialReactionNamesQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<SocialReactionNamesQuery, SocialReactionNamesQueryVariables>(
		SocialReactionNamesDocument,
		options,
	);
}
export function useSocialReactionNamesSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<SocialReactionNamesQuery, SocialReactionNamesQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<SocialReactionNamesQuery, SocialReactionNamesQueryVariables>(
		SocialReactionNamesDocument,
		options,
	);
}
export type SocialReactionNamesQueryHookResult = ReturnType<typeof useSocialReactionNamesQuery>;
export type SocialReactionNamesLazyQueryHookResult = ReturnType<typeof useSocialReactionNamesLazyQuery>;
export type SocialReactionNamesSuspenseQueryHookResult = ReturnType<typeof useSocialReactionNamesSuspenseQuery>;
export type SocialReactionNamesQueryResult = Apollo.QueryResult<
	SocialReactionNamesQuery,
	SocialReactionNamesQueryVariables
>;
export const SocialReactionPaginationDocument = gql`
	query socialReactionPagination($filters: [SocialReactionFilterInput!], $order: SocialReactionOrder) {
		socialReactionConnection(filters: $filters, order: $order) {
			totalCount
			edges {
				cursor
			}
		}
	}
`;

/**
 * __useSocialReactionPaginationQuery__
 *
 * To run a query within a React component, call `useSocialReactionPaginationQuery` and pass it any options that fit your needs.
 * When your component renders, `useSocialReactionPaginationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSocialReactionPaginationQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useSocialReactionPaginationQuery(
	baseOptions?: Apollo.QueryHookOptions<SocialReactionPaginationQuery, SocialReactionPaginationQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<SocialReactionPaginationQuery, SocialReactionPaginationQueryVariables>(
		SocialReactionPaginationDocument,
		options,
	);
}
export function useSocialReactionPaginationLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<SocialReactionPaginationQuery, SocialReactionPaginationQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<SocialReactionPaginationQuery, SocialReactionPaginationQueryVariables>(
		SocialReactionPaginationDocument,
		options,
	);
}
export function useSocialReactionPaginationSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<SocialReactionPaginationQuery, SocialReactionPaginationQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<SocialReactionPaginationQuery, SocialReactionPaginationQueryVariables>(
		SocialReactionPaginationDocument,
		options,
	);
}
export type SocialReactionPaginationQueryHookResult = ReturnType<typeof useSocialReactionPaginationQuery>;
export type SocialReactionPaginationLazyQueryHookResult = ReturnType<typeof useSocialReactionPaginationLazyQuery>;
export type SocialReactionPaginationSuspenseQueryHookResult = ReturnType<
	typeof useSocialReactionPaginationSuspenseQuery
>;
export type SocialReactionPaginationQueryResult = Apollo.QueryResult<
	SocialReactionPaginationQuery,
	SocialReactionPaginationQueryVariables
>;
export const SocialReactionSelectDocument = gql`
	query socialReactionSelect($filters: [SocialReactionFilterInput!], $order: SocialReactionOrder) {
		socialReactionConnection(filters: $filters, order: $order) {
			edges {
				node {
					id
					...SocialReactionName
				}
			}
		}
	}
	${SocialReactionNameFragmentDoc}
`;

/**
 * __useSocialReactionSelectQuery__
 *
 * To run a query within a React component, call `useSocialReactionSelectQuery` and pass it any options that fit your needs.
 * When your component renders, `useSocialReactionSelectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSocialReactionSelectQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useSocialReactionSelectQuery(
	baseOptions?: Apollo.QueryHookOptions<SocialReactionSelectQuery, SocialReactionSelectQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<SocialReactionSelectQuery, SocialReactionSelectQueryVariables>(
		SocialReactionSelectDocument,
		options,
	);
}
export function useSocialReactionSelectLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<SocialReactionSelectQuery, SocialReactionSelectQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<SocialReactionSelectQuery, SocialReactionSelectQueryVariables>(
		SocialReactionSelectDocument,
		options,
	);
}
export function useSocialReactionSelectSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<SocialReactionSelectQuery, SocialReactionSelectQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<SocialReactionSelectQuery, SocialReactionSelectQueryVariables>(
		SocialReactionSelectDocument,
		options,
	);
}
export type SocialReactionSelectQueryHookResult = ReturnType<typeof useSocialReactionSelectQuery>;
export type SocialReactionSelectLazyQueryHookResult = ReturnType<typeof useSocialReactionSelectLazyQuery>;
export type SocialReactionSelectSuspenseQueryHookResult = ReturnType<typeof useSocialReactionSelectSuspenseQuery>;
export type SocialReactionSelectQueryResult = Apollo.QueryResult<
	SocialReactionSelectQuery,
	SocialReactionSelectQueryVariables
>;
export const SocialReactionUpdateDocument = gql`
	mutation socialReactionUpdate($id: ID!, $input: SocialReactionUpdateInput!) {
		updateSocialReaction(id: $id, input: $input) {
			...SocialReactionDetail
		}
	}
	${SocialReactionDetailFragmentDoc}
`;
export type SocialReactionUpdateMutationFn = Apollo.MutationFunction<
	SocialReactionUpdateMutation,
	SocialReactionUpdateMutationVariables
>;

/**
 * __useSocialReactionUpdateMutation__
 *
 * To run a mutation, you first call `useSocialReactionUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSocialReactionUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [socialReactionUpdateMutation, { data, loading, error }] = useSocialReactionUpdateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSocialReactionUpdateMutation(
	baseOptions?: Apollo.MutationHookOptions<SocialReactionUpdateMutation, SocialReactionUpdateMutationVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<SocialReactionUpdateMutation, SocialReactionUpdateMutationVariables>(
		SocialReactionUpdateDocument,
		options,
	);
}
export type SocialReactionUpdateMutationHookResult = ReturnType<typeof useSocialReactionUpdateMutation>;
export type SocialReactionUpdateMutationResult = Apollo.MutationResult<SocialReactionUpdateMutation>;
export type SocialReactionUpdateMutationOptions = Apollo.BaseMutationOptions<
	SocialReactionUpdateMutation,
	SocialReactionUpdateMutationVariables
>;
export const UserCheckUniqueEmailDocument = gql`
	query userCheckUniqueEmail($ignoreID: ID, $email: String!) {
		userConnection(filters: { idNEQ: $ignoreID, emailEQ: $email }) {
			totalCount
		}
	}
`;

/**
 * __useUserCheckUniqueEmailQuery__
 *
 * To run a query within a React component, call `useUserCheckUniqueEmailQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserCheckUniqueEmailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserCheckUniqueEmailQuery({
 *   variables: {
 *      ignoreID: // value for 'ignoreID'
 *      email: // value for 'email'
 *   },
 * });
 */
export function useUserCheckUniqueEmailQuery(
	baseOptions: Apollo.QueryHookOptions<UserCheckUniqueEmailQuery, UserCheckUniqueEmailQueryVariables> &
		({ variables: UserCheckUniqueEmailQueryVariables; skip?: boolean } | { skip: boolean }),
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<UserCheckUniqueEmailQuery, UserCheckUniqueEmailQueryVariables>(
		UserCheckUniqueEmailDocument,
		options,
	);
}
export function useUserCheckUniqueEmailLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<UserCheckUniqueEmailQuery, UserCheckUniqueEmailQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<UserCheckUniqueEmailQuery, UserCheckUniqueEmailQueryVariables>(
		UserCheckUniqueEmailDocument,
		options,
	);
}
export function useUserCheckUniqueEmailSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<UserCheckUniqueEmailQuery, UserCheckUniqueEmailQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<UserCheckUniqueEmailQuery, UserCheckUniqueEmailQueryVariables>(
		UserCheckUniqueEmailDocument,
		options,
	);
}
export type UserCheckUniqueEmailQueryHookResult = ReturnType<typeof useUserCheckUniqueEmailQuery>;
export type UserCheckUniqueEmailLazyQueryHookResult = ReturnType<typeof useUserCheckUniqueEmailLazyQuery>;
export type UserCheckUniqueEmailSuspenseQueryHookResult = ReturnType<typeof useUserCheckUniqueEmailSuspenseQuery>;
export type UserCheckUniqueEmailQueryResult = Apollo.QueryResult<
	UserCheckUniqueEmailQuery,
	UserCheckUniqueEmailQueryVariables
>;
export const UserCountDocument = gql`
	query userCount($filters: [UserFilterInput!], $pagination: Pagination, $order: UserOrder) {
		userConnection(filters: $filters, pagination: $pagination, order: $order) {
			totalCount
		}
	}
`;

/**
 * __useUserCountQuery__
 *
 * To run a query within a React component, call `useUserCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserCountQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useUserCountQuery(baseOptions?: Apollo.QueryHookOptions<UserCountQuery, UserCountQueryVariables>) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<UserCountQuery, UserCountQueryVariables>(UserCountDocument, options);
}
export function useUserCountLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<UserCountQuery, UserCountQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<UserCountQuery, UserCountQueryVariables>(UserCountDocument, options);
}
export function useUserCountSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<UserCountQuery, UserCountQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<UserCountQuery, UserCountQueryVariables>(UserCountDocument, options);
}
export type UserCountQueryHookResult = ReturnType<typeof useUserCountQuery>;
export type UserCountLazyQueryHookResult = ReturnType<typeof useUserCountLazyQuery>;
export type UserCountSuspenseQueryHookResult = ReturnType<typeof useUserCountSuspenseQuery>;
export type UserCountQueryResult = Apollo.QueryResult<UserCountQuery, UserCountQueryVariables>;
export const UserCreateDocument = gql`
	mutation userCreate($input: UserCreateInput!) {
		createUser(input: $input) {
			...UserDetail
		}
	}
	${UserDetailFragmentDoc}
`;
export type UserCreateMutationFn = Apollo.MutationFunction<UserCreateMutation, UserCreateMutationVariables>;

/**
 * __useUserCreateMutation__
 *
 * To run a mutation, you first call `useUserCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUserCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [userCreateMutation, { data, loading, error }] = useUserCreateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUserCreateMutation(
	baseOptions?: Apollo.MutationHookOptions<UserCreateMutation, UserCreateMutationVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<UserCreateMutation, UserCreateMutationVariables>(UserCreateDocument, options);
}
export type UserCreateMutationHookResult = ReturnType<typeof useUserCreateMutation>;
export type UserCreateMutationResult = Apollo.MutationResult<UserCreateMutation>;
export type UserCreateMutationOptions = Apollo.BaseMutationOptions<UserCreateMutation, UserCreateMutationVariables>;
export const UserDeleteDocument = gql`
	mutation userDelete($id: ID!) {
		deleteUser(id: $id)
	}
`;
export type UserDeleteMutationFn = Apollo.MutationFunction<UserDeleteMutation, UserDeleteMutationVariables>;

/**
 * __useUserDeleteMutation__
 *
 * To run a mutation, you first call `useUserDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUserDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [userDeleteMutation, { data, loading, error }] = useUserDeleteMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUserDeleteMutation(
	baseOptions?: Apollo.MutationHookOptions<UserDeleteMutation, UserDeleteMutationVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<UserDeleteMutation, UserDeleteMutationVariables>(UserDeleteDocument, options);
}
export type UserDeleteMutationHookResult = ReturnType<typeof useUserDeleteMutation>;
export type UserDeleteMutationResult = Apollo.MutationResult<UserDeleteMutation>;
export type UserDeleteMutationOptions = Apollo.BaseMutationOptions<UserDeleteMutation, UserDeleteMutationVariables>;
export const UserDetailDocument = gql`
	query userDetail($id: ID!) {
		user(id: $id) {
			...UserDetail
		}
	}
	${UserDetailFragmentDoc}
`;

/**
 * __useUserDetailQuery__
 *
 * To run a query within a React component, call `useUserDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserDetailQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUserDetailQuery(
	baseOptions: Apollo.QueryHookOptions<UserDetailQuery, UserDetailQueryVariables> &
		({ variables: UserDetailQueryVariables; skip?: boolean } | { skip: boolean }),
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<UserDetailQuery, UserDetailQueryVariables>(UserDetailDocument, options);
}
export function useUserDetailLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<UserDetailQuery, UserDetailQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<UserDetailQuery, UserDetailQueryVariables>(UserDetailDocument, options);
}
export function useUserDetailSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<UserDetailQuery, UserDetailQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<UserDetailQuery, UserDetailQueryVariables>(UserDetailDocument, options);
}
export type UserDetailQueryHookResult = ReturnType<typeof useUserDetailQuery>;
export type UserDetailLazyQueryHookResult = ReturnType<typeof useUserDetailLazyQuery>;
export type UserDetailSuspenseQueryHookResult = ReturnType<typeof useUserDetailSuspenseQuery>;
export type UserDetailQueryResult = Apollo.QueryResult<UserDetailQuery, UserDetailQueryVariables>;
export const UserIndexDocument = gql`
	query userIndex($filters: [UserFilterInput!], $pagination: Pagination, $order: UserOrder) {
		userConnection(filters: $filters, pagination: $pagination, order: $order) {
			edges {
				node {
					id
					imageURL
					imageContentType
					name
					publicName
					givenName
					middleName
					familyName
					nameOrder
					publicNameFormat
					organizationName
					gender
					pronouns
					dateOfBirth
					email
					status
					passwordUpdatedAt
					isCurrent
					timeZoneName
					externalNotificationFrequency
				}
			}
		}
	}
`;

/**
 * __useUserIndexQuery__
 *
 * To run a query within a React component, call `useUserIndexQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserIndexQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserIndexQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useUserIndexQuery(baseOptions?: Apollo.QueryHookOptions<UserIndexQuery, UserIndexQueryVariables>) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<UserIndexQuery, UserIndexQueryVariables>(UserIndexDocument, options);
}
export function useUserIndexLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<UserIndexQuery, UserIndexQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<UserIndexQuery, UserIndexQueryVariables>(UserIndexDocument, options);
}
export function useUserIndexSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<UserIndexQuery, UserIndexQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<UserIndexQuery, UserIndexQueryVariables>(UserIndexDocument, options);
}
export type UserIndexQueryHookResult = ReturnType<typeof useUserIndexQuery>;
export type UserIndexLazyQueryHookResult = ReturnType<typeof useUserIndexLazyQuery>;
export type UserIndexSuspenseQueryHookResult = ReturnType<typeof useUserIndexSuspenseQuery>;
export type UserIndexQueryResult = Apollo.QueryResult<UserIndexQuery, UserIndexQueryVariables>;
export const SendUserInviteMessageDocument = gql`
	mutation sendUserInviteMessage($userID: ID!) {
		sendInviteMessage(userID: $userID)
	}
`;
export type SendUserInviteMessageMutationFn = Apollo.MutationFunction<
	SendUserInviteMessageMutation,
	SendUserInviteMessageMutationVariables
>;

/**
 * __useSendUserInviteMessageMutation__
 *
 * To run a mutation, you first call `useSendUserInviteMessageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendUserInviteMessageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendUserInviteMessageMutation, { data, loading, error }] = useSendUserInviteMessageMutation({
 *   variables: {
 *      userID: // value for 'userID'
 *   },
 * });
 */
export function useSendUserInviteMessageMutation(
	baseOptions?: Apollo.MutationHookOptions<SendUserInviteMessageMutation, SendUserInviteMessageMutationVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<SendUserInviteMessageMutation, SendUserInviteMessageMutationVariables>(
		SendUserInviteMessageDocument,
		options,
	);
}
export type SendUserInviteMessageMutationHookResult = ReturnType<typeof useSendUserInviteMessageMutation>;
export type SendUserInviteMessageMutationResult = Apollo.MutationResult<SendUserInviteMessageMutation>;
export type SendUserInviteMessageMutationOptions = Apollo.BaseMutationOptions<
	SendUserInviteMessageMutation,
	SendUserInviteMessageMutationVariables
>;
export const UserDetailedSelectListDocument = gql`
	query userDetailedSelectList($filters: [UserFilterInput!], $pagination: Pagination, $order: UserOrder) {
		userConnection(filters: $filters, pagination: $pagination, order: $order) {
			edges {
				node {
					id
					...UserName
					organizationName
				}
			}
		}
	}
	${UserNameFragmentDoc}
`;

/**
 * __useUserDetailedSelectListQuery__
 *
 * To run a query within a React component, call `useUserDetailedSelectListQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserDetailedSelectListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserDetailedSelectListQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useUserDetailedSelectListQuery(
	baseOptions?: Apollo.QueryHookOptions<UserDetailedSelectListQuery, UserDetailedSelectListQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<UserDetailedSelectListQuery, UserDetailedSelectListQueryVariables>(
		UserDetailedSelectListDocument,
		options,
	);
}
export function useUserDetailedSelectListLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<UserDetailedSelectListQuery, UserDetailedSelectListQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<UserDetailedSelectListQuery, UserDetailedSelectListQueryVariables>(
		UserDetailedSelectListDocument,
		options,
	);
}
export function useUserDetailedSelectListSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<UserDetailedSelectListQuery, UserDetailedSelectListQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<UserDetailedSelectListQuery, UserDetailedSelectListQueryVariables>(
		UserDetailedSelectListDocument,
		options,
	);
}
export type UserDetailedSelectListQueryHookResult = ReturnType<typeof useUserDetailedSelectListQuery>;
export type UserDetailedSelectListLazyQueryHookResult = ReturnType<typeof useUserDetailedSelectListLazyQuery>;
export type UserDetailedSelectListSuspenseQueryHookResult = ReturnType<typeof useUserDetailedSelectListSuspenseQuery>;
export type UserDetailedSelectListQueryResult = Apollo.QueryResult<
	UserDetailedSelectListQuery,
	UserDetailedSelectListQueryVariables
>;
export const UserNamesDescriptionsAndImagesDocument = gql`
	query userNamesDescriptionsAndImages($filters: [UserFilterInput!], $pagination: Pagination, $order: UserOrder) {
		userConnection(filters: $filters, pagination: $pagination, order: $order) {
			pageInfo {
				hasNextPage
				endCursor
			}
			edges {
				node {
					id
					...UserNameDescriptionAndImage
				}
			}
		}
	}
	${UserNameDescriptionAndImageFragmentDoc}
`;

/**
 * __useUserNamesDescriptionsAndImagesQuery__
 *
 * To run a query within a React component, call `useUserNamesDescriptionsAndImagesQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserNamesDescriptionsAndImagesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserNamesDescriptionsAndImagesQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useUserNamesDescriptionsAndImagesQuery(
	baseOptions?: Apollo.QueryHookOptions<
		UserNamesDescriptionsAndImagesQuery,
		UserNamesDescriptionsAndImagesQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<UserNamesDescriptionsAndImagesQuery, UserNamesDescriptionsAndImagesQueryVariables>(
		UserNamesDescriptionsAndImagesDocument,
		options,
	);
}
export function useUserNamesDescriptionsAndImagesLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		UserNamesDescriptionsAndImagesQuery,
		UserNamesDescriptionsAndImagesQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<UserNamesDescriptionsAndImagesQuery, UserNamesDescriptionsAndImagesQueryVariables>(
		UserNamesDescriptionsAndImagesDocument,
		options,
	);
}
export function useUserNamesDescriptionsAndImagesSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		UserNamesDescriptionsAndImagesQuery,
		UserNamesDescriptionsAndImagesQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<UserNamesDescriptionsAndImagesQuery, UserNamesDescriptionsAndImagesQueryVariables>(
		UserNamesDescriptionsAndImagesDocument,
		options,
	);
}
export type UserNamesDescriptionsAndImagesQueryHookResult = ReturnType<typeof useUserNamesDescriptionsAndImagesQuery>;
export type UserNamesDescriptionsAndImagesLazyQueryHookResult = ReturnType<
	typeof useUserNamesDescriptionsAndImagesLazyQuery
>;
export type UserNamesDescriptionsAndImagesSuspenseQueryHookResult = ReturnType<
	typeof useUserNamesDescriptionsAndImagesSuspenseQuery
>;
export type UserNamesDescriptionsAndImagesQueryResult = Apollo.QueryResult<
	UserNamesDescriptionsAndImagesQuery,
	UserNamesDescriptionsAndImagesQueryVariables
>;
export const UserNameDocument = gql`
	query userName($id: ID!) {
		user(id: $id) {
			id
			...UserName
		}
	}
	${UserNameFragmentDoc}
`;

/**
 * __useUserNameQuery__
 *
 * To run a query within a React component, call `useUserNameQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserNameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserNameQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUserNameQuery(
	baseOptions: Apollo.QueryHookOptions<UserNameQuery, UserNameQueryVariables> &
		({ variables: UserNameQueryVariables; skip?: boolean } | { skip: boolean }),
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<UserNameQuery, UserNameQueryVariables>(UserNameDocument, options);
}
export function useUserNameLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserNameQuery, UserNameQueryVariables>) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<UserNameQuery, UserNameQueryVariables>(UserNameDocument, options);
}
export function useUserNameSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<UserNameQuery, UserNameQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<UserNameQuery, UserNameQueryVariables>(UserNameDocument, options);
}
export type UserNameQueryHookResult = ReturnType<typeof useUserNameQuery>;
export type UserNameLazyQueryHookResult = ReturnType<typeof useUserNameLazyQuery>;
export type UserNameSuspenseQueryHookResult = ReturnType<typeof useUserNameSuspenseQuery>;
export type UserNameQueryResult = Apollo.QueryResult<UserNameQuery, UserNameQueryVariables>;
export const UserNamesAndImagesDocument = gql`
	query userNamesAndImages($filters: [UserFilterInput!], $pagination: Pagination, $order: UserOrder) {
		userConnection(filters: $filters, pagination: $pagination, order: $order) {
			edges {
				node {
					id
					...UserNameAndImage
				}
			}
		}
	}
	${UserNameAndImageFragmentDoc}
`;

/**
 * __useUserNamesAndImagesQuery__
 *
 * To run a query within a React component, call `useUserNamesAndImagesQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserNamesAndImagesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserNamesAndImagesQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useUserNamesAndImagesQuery(
	baseOptions?: Apollo.QueryHookOptions<UserNamesAndImagesQuery, UserNamesAndImagesQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<UserNamesAndImagesQuery, UserNamesAndImagesQueryVariables>(
		UserNamesAndImagesDocument,
		options,
	);
}
export function useUserNamesAndImagesLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<UserNamesAndImagesQuery, UserNamesAndImagesQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<UserNamesAndImagesQuery, UserNamesAndImagesQueryVariables>(
		UserNamesAndImagesDocument,
		options,
	);
}
export function useUserNamesAndImagesSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<UserNamesAndImagesQuery, UserNamesAndImagesQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<UserNamesAndImagesQuery, UserNamesAndImagesQueryVariables>(
		UserNamesAndImagesDocument,
		options,
	);
}
export type UserNamesAndImagesQueryHookResult = ReturnType<typeof useUserNamesAndImagesQuery>;
export type UserNamesAndImagesLazyQueryHookResult = ReturnType<typeof useUserNamesAndImagesLazyQuery>;
export type UserNamesAndImagesSuspenseQueryHookResult = ReturnType<typeof useUserNamesAndImagesSuspenseQuery>;
export type UserNamesAndImagesQueryResult = Apollo.QueryResult<
	UserNamesAndImagesQuery,
	UserNamesAndImagesQueryVariables
>;
export const UserNamesDocument = gql`
	query userNames($filters: [UserFilterInput!], $pagination: Pagination, $order: UserOrder) {
		userConnection(filters: $filters, pagination: $pagination, order: $order) {
			edges {
				node {
					id
					...UserName
				}
			}
		}
	}
	${UserNameFragmentDoc}
`;

/**
 * __useUserNamesQuery__
 *
 * To run a query within a React component, call `useUserNamesQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserNamesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserNamesQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useUserNamesQuery(baseOptions?: Apollo.QueryHookOptions<UserNamesQuery, UserNamesQueryVariables>) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<UserNamesQuery, UserNamesQueryVariables>(UserNamesDocument, options);
}
export function useUserNamesLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<UserNamesQuery, UserNamesQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<UserNamesQuery, UserNamesQueryVariables>(UserNamesDocument, options);
}
export function useUserNamesSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<UserNamesQuery, UserNamesQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<UserNamesQuery, UserNamesQueryVariables>(UserNamesDocument, options);
}
export type UserNamesQueryHookResult = ReturnType<typeof useUserNamesQuery>;
export type UserNamesLazyQueryHookResult = ReturnType<typeof useUserNamesLazyQuery>;
export type UserNamesSuspenseQueryHookResult = ReturnType<typeof useUserNamesSuspenseQuery>;
export type UserNamesQueryResult = Apollo.QueryResult<UserNamesQuery, UserNamesQueryVariables>;
export const UserPaginationDocument = gql`
	query userPagination($filters: [UserFilterInput!], $order: UserOrder) {
		userConnection(filters: $filters, order: $order) {
			totalCount
			edges {
				cursor
			}
		}
	}
`;

/**
 * __useUserPaginationQuery__
 *
 * To run a query within a React component, call `useUserPaginationQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserPaginationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserPaginationQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useUserPaginationQuery(
	baseOptions?: Apollo.QueryHookOptions<UserPaginationQuery, UserPaginationQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<UserPaginationQuery, UserPaginationQueryVariables>(UserPaginationDocument, options);
}
export function useUserPaginationLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<UserPaginationQuery, UserPaginationQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<UserPaginationQuery, UserPaginationQueryVariables>(UserPaginationDocument, options);
}
export function useUserPaginationSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<UserPaginationQuery, UserPaginationQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<UserPaginationQuery, UserPaginationQueryVariables>(UserPaginationDocument, options);
}
export type UserPaginationQueryHookResult = ReturnType<typeof useUserPaginationQuery>;
export type UserPaginationLazyQueryHookResult = ReturnType<typeof useUserPaginationLazyQuery>;
export type UserPaginationSuspenseQueryHookResult = ReturnType<typeof useUserPaginationSuspenseQuery>;
export type UserPaginationQueryResult = Apollo.QueryResult<UserPaginationQuery, UserPaginationQueryVariables>;
export const UserSelectDocument = gql`
	query userSelect($filters: [UserFilterInput!], $order: UserOrder) {
		userConnection(filters: $filters, order: $order) {
			edges {
				node {
					id
					...UserName
				}
			}
		}
	}
	${UserNameFragmentDoc}
`;

/**
 * __useUserSelectQuery__
 *
 * To run a query within a React component, call `useUserSelectQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserSelectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserSelectQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useUserSelectQuery(baseOptions?: Apollo.QueryHookOptions<UserSelectQuery, UserSelectQueryVariables>) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<UserSelectQuery, UserSelectQueryVariables>(UserSelectDocument, options);
}
export function useUserSelectLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<UserSelectQuery, UserSelectQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<UserSelectQuery, UserSelectQueryVariables>(UserSelectDocument, options);
}
export function useUserSelectSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<UserSelectQuery, UserSelectQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<UserSelectQuery, UserSelectQueryVariables>(UserSelectDocument, options);
}
export type UserSelectQueryHookResult = ReturnType<typeof useUserSelectQuery>;
export type UserSelectLazyQueryHookResult = ReturnType<typeof useUserSelectLazyQuery>;
export type UserSelectSuspenseQueryHookResult = ReturnType<typeof useUserSelectSuspenseQuery>;
export type UserSelectQueryResult = Apollo.QueryResult<UserSelectQuery, UserSelectQueryVariables>;
export const UserUpdateDocument = gql`
	mutation userUpdate($id: ID!, $input: UserUpdateInput!) {
		updateUser(id: $id, input: $input) {
			...UserDetail
		}
	}
	${UserDetailFragmentDoc}
`;
export type UserUpdateMutationFn = Apollo.MutationFunction<UserUpdateMutation, UserUpdateMutationVariables>;

/**
 * __useUserUpdateMutation__
 *
 * To run a mutation, you first call `useUserUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUserUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [userUpdateMutation, { data, loading, error }] = useUserUpdateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUserUpdateMutation(
	baseOptions?: Apollo.MutationHookOptions<UserUpdateMutation, UserUpdateMutationVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<UserUpdateMutation, UserUpdateMutationVariables>(UserUpdateDocument, options);
}
export type UserUpdateMutationHookResult = ReturnType<typeof useUserUpdateMutation>;
export type UserUpdateMutationResult = Apollo.MutationResult<UserUpdateMutation>;
export type UserUpdateMutationOptions = Apollo.BaseMutationOptions<UserUpdateMutation, UserUpdateMutationVariables>;
export const InternalPortalsViewerInfoDocument = gql`
	query internalPortalsViewerInfo {
		viewer {
			id
			...UserNameDescriptionAndImage
		}
	}
	${UserNameDescriptionAndImageFragmentDoc}
`;

/**
 * __useInternalPortalsViewerInfoQuery__
 *
 * To run a query within a React component, call `useInternalPortalsViewerInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useInternalPortalsViewerInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInternalPortalsViewerInfoQuery({
 *   variables: {
 *   },
 * });
 */
export function useInternalPortalsViewerInfoQuery(
	baseOptions?: Apollo.QueryHookOptions<InternalPortalsViewerInfoQuery, InternalPortalsViewerInfoQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<InternalPortalsViewerInfoQuery, InternalPortalsViewerInfoQueryVariables>(
		InternalPortalsViewerInfoDocument,
		options,
	);
}
export function useInternalPortalsViewerInfoLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<InternalPortalsViewerInfoQuery, InternalPortalsViewerInfoQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<InternalPortalsViewerInfoQuery, InternalPortalsViewerInfoQueryVariables>(
		InternalPortalsViewerInfoDocument,
		options,
	);
}
export function useInternalPortalsViewerInfoSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		InternalPortalsViewerInfoQuery,
		InternalPortalsViewerInfoQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<InternalPortalsViewerInfoQuery, InternalPortalsViewerInfoQueryVariables>(
		InternalPortalsViewerInfoDocument,
		options,
	);
}
export type InternalPortalsViewerInfoQueryHookResult = ReturnType<typeof useInternalPortalsViewerInfoQuery>;
export type InternalPortalsViewerInfoLazyQueryHookResult = ReturnType<typeof useInternalPortalsViewerInfoLazyQuery>;
export type InternalPortalsViewerInfoSuspenseQueryHookResult = ReturnType<
	typeof useInternalPortalsViewerInfoSuspenseQuery
>;
export type InternalPortalsViewerInfoQueryResult = Apollo.QueryResult<
	InternalPortalsViewerInfoQuery,
	InternalPortalsViewerInfoQueryVariables
>;
export const ViewerPublicNameFormatDocument = gql`
	query viewerPublicNameFormat {
		viewer {
			id
			publicNameFormat
		}
	}
`;

/**
 * __useViewerPublicNameFormatQuery__
 *
 * To run a query within a React component, call `useViewerPublicNameFormatQuery` and pass it any options that fit your needs.
 * When your component renders, `useViewerPublicNameFormatQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useViewerPublicNameFormatQuery({
 *   variables: {
 *   },
 * });
 */
export function useViewerPublicNameFormatQuery(
	baseOptions?: Apollo.QueryHookOptions<ViewerPublicNameFormatQuery, ViewerPublicNameFormatQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<ViewerPublicNameFormatQuery, ViewerPublicNameFormatQueryVariables>(
		ViewerPublicNameFormatDocument,
		options,
	);
}
export function useViewerPublicNameFormatLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<ViewerPublicNameFormatQuery, ViewerPublicNameFormatQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<ViewerPublicNameFormatQuery, ViewerPublicNameFormatQueryVariables>(
		ViewerPublicNameFormatDocument,
		options,
	);
}
export function useViewerPublicNameFormatSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<ViewerPublicNameFormatQuery, ViewerPublicNameFormatQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<ViewerPublicNameFormatQuery, ViewerPublicNameFormatQueryVariables>(
		ViewerPublicNameFormatDocument,
		options,
	);
}
export type ViewerPublicNameFormatQueryHookResult = ReturnType<typeof useViewerPublicNameFormatQuery>;
export type ViewerPublicNameFormatLazyQueryHookResult = ReturnType<typeof useViewerPublicNameFormatLazyQuery>;
export type ViewerPublicNameFormatSuspenseQueryHookResult = ReturnType<typeof useViewerPublicNameFormatSuspenseQuery>;
export type ViewerPublicNameFormatQueryResult = Apollo.QueryResult<
	ViewerPublicNameFormatQuery,
	ViewerPublicNameFormatQueryVariables
>;
export const UserGroupCountDocument = gql`
	query userGroupCount($filters: [UserGroupFilterInput!], $pagination: Pagination, $order: UserGroupOrder) {
		userGroupConnection(filters: $filters, pagination: $pagination, order: $order) {
			totalCount
		}
	}
`;

/**
 * __useUserGroupCountQuery__
 *
 * To run a query within a React component, call `useUserGroupCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserGroupCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserGroupCountQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useUserGroupCountQuery(
	baseOptions?: Apollo.QueryHookOptions<UserGroupCountQuery, UserGroupCountQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<UserGroupCountQuery, UserGroupCountQueryVariables>(UserGroupCountDocument, options);
}
export function useUserGroupCountLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<UserGroupCountQuery, UserGroupCountQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<UserGroupCountQuery, UserGroupCountQueryVariables>(UserGroupCountDocument, options);
}
export function useUserGroupCountSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<UserGroupCountQuery, UserGroupCountQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<UserGroupCountQuery, UserGroupCountQueryVariables>(UserGroupCountDocument, options);
}
export type UserGroupCountQueryHookResult = ReturnType<typeof useUserGroupCountQuery>;
export type UserGroupCountLazyQueryHookResult = ReturnType<typeof useUserGroupCountLazyQuery>;
export type UserGroupCountSuspenseQueryHookResult = ReturnType<typeof useUserGroupCountSuspenseQuery>;
export type UserGroupCountQueryResult = Apollo.QueryResult<UserGroupCountQuery, UserGroupCountQueryVariables>;
export const UserGroupCreateDocument = gql`
	mutation userGroupCreate($input: UserGroupCreateInput!) {
		createUserGroup(input: $input) {
			...UserGroupDetail
		}
	}
	${UserGroupDetailFragmentDoc}
`;
export type UserGroupCreateMutationFn = Apollo.MutationFunction<
	UserGroupCreateMutation,
	UserGroupCreateMutationVariables
>;

/**
 * __useUserGroupCreateMutation__
 *
 * To run a mutation, you first call `useUserGroupCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUserGroupCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [userGroupCreateMutation, { data, loading, error }] = useUserGroupCreateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUserGroupCreateMutation(
	baseOptions?: Apollo.MutationHookOptions<UserGroupCreateMutation, UserGroupCreateMutationVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<UserGroupCreateMutation, UserGroupCreateMutationVariables>(
		UserGroupCreateDocument,
		options,
	);
}
export type UserGroupCreateMutationHookResult = ReturnType<typeof useUserGroupCreateMutation>;
export type UserGroupCreateMutationResult = Apollo.MutationResult<UserGroupCreateMutation>;
export type UserGroupCreateMutationOptions = Apollo.BaseMutationOptions<
	UserGroupCreateMutation,
	UserGroupCreateMutationVariables
>;
export const UserGroupDeleteDocument = gql`
	mutation userGroupDelete($id: ID!) {
		deleteUserGroup(id: $id)
	}
`;
export type UserGroupDeleteMutationFn = Apollo.MutationFunction<
	UserGroupDeleteMutation,
	UserGroupDeleteMutationVariables
>;

/**
 * __useUserGroupDeleteMutation__
 *
 * To run a mutation, you first call `useUserGroupDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUserGroupDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [userGroupDeleteMutation, { data, loading, error }] = useUserGroupDeleteMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUserGroupDeleteMutation(
	baseOptions?: Apollo.MutationHookOptions<UserGroupDeleteMutation, UserGroupDeleteMutationVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<UserGroupDeleteMutation, UserGroupDeleteMutationVariables>(
		UserGroupDeleteDocument,
		options,
	);
}
export type UserGroupDeleteMutationHookResult = ReturnType<typeof useUserGroupDeleteMutation>;
export type UserGroupDeleteMutationResult = Apollo.MutationResult<UserGroupDeleteMutation>;
export type UserGroupDeleteMutationOptions = Apollo.BaseMutationOptions<
	UserGroupDeleteMutation,
	UserGroupDeleteMutationVariables
>;
export const UserGroupDetailDocument = gql`
	query userGroupDetail($id: ID!) {
		userGroup(id: $id) {
			...UserGroupDetail
		}
	}
	${UserGroupDetailFragmentDoc}
`;

/**
 * __useUserGroupDetailQuery__
 *
 * To run a query within a React component, call `useUserGroupDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserGroupDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserGroupDetailQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUserGroupDetailQuery(
	baseOptions: Apollo.QueryHookOptions<UserGroupDetailQuery, UserGroupDetailQueryVariables> &
		({ variables: UserGroupDetailQueryVariables; skip?: boolean } | { skip: boolean }),
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<UserGroupDetailQuery, UserGroupDetailQueryVariables>(UserGroupDetailDocument, options);
}
export function useUserGroupDetailLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<UserGroupDetailQuery, UserGroupDetailQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<UserGroupDetailQuery, UserGroupDetailQueryVariables>(UserGroupDetailDocument, options);
}
export function useUserGroupDetailSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<UserGroupDetailQuery, UserGroupDetailQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<UserGroupDetailQuery, UserGroupDetailQueryVariables>(UserGroupDetailDocument, options);
}
export type UserGroupDetailQueryHookResult = ReturnType<typeof useUserGroupDetailQuery>;
export type UserGroupDetailLazyQueryHookResult = ReturnType<typeof useUserGroupDetailLazyQuery>;
export type UserGroupDetailSuspenseQueryHookResult = ReturnType<typeof useUserGroupDetailSuspenseQuery>;
export type UserGroupDetailQueryResult = Apollo.QueryResult<UserGroupDetailQuery, UserGroupDetailQueryVariables>;
export const UserGroupIDsDocument = gql`
	query userGroupIDs($filters: [UserGroupFilterInput!], $pagination: Pagination, $order: UserGroupOrder) {
		userGroupConnection(filters: $filters, pagination: $pagination, order: $order) {
			edges {
				node {
					id
				}
			}
		}
	}
`;

/**
 * __useUserGroupIDsQuery__
 *
 * To run a query within a React component, call `useUserGroupIDsQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserGroupIDsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserGroupIDsQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useUserGroupIDsQuery(
	baseOptions?: Apollo.QueryHookOptions<UserGroupIDsQuery, UserGroupIDsQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<UserGroupIDsQuery, UserGroupIDsQueryVariables>(UserGroupIDsDocument, options);
}
export function useUserGroupIDsLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<UserGroupIDsQuery, UserGroupIDsQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<UserGroupIDsQuery, UserGroupIDsQueryVariables>(UserGroupIDsDocument, options);
}
export function useUserGroupIDsSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<UserGroupIDsQuery, UserGroupIDsQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<UserGroupIDsQuery, UserGroupIDsQueryVariables>(UserGroupIDsDocument, options);
}
export type UserGroupIDsQueryHookResult = ReturnType<typeof useUserGroupIDsQuery>;
export type UserGroupIDsLazyQueryHookResult = ReturnType<typeof useUserGroupIDsLazyQuery>;
export type UserGroupIDsSuspenseQueryHookResult = ReturnType<typeof useUserGroupIDsSuspenseQuery>;
export type UserGroupIDsQueryResult = Apollo.QueryResult<UserGroupIDsQuery, UserGroupIDsQueryVariables>;
export const UserGroupIndexDocument = gql`
	query userGroupIndex($filters: [UserGroupFilterInput!], $pagination: Pagination, $order: UserGroupOrder) {
		userGroupConnection(filters: $filters, pagination: $pagination, order: $order) {
			edges {
				node {
					id
					name
					description
					color
					isPublic
					members {
						id
					}
				}
			}
		}
	}
`;

/**
 * __useUserGroupIndexQuery__
 *
 * To run a query within a React component, call `useUserGroupIndexQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserGroupIndexQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserGroupIndexQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useUserGroupIndexQuery(
	baseOptions?: Apollo.QueryHookOptions<UserGroupIndexQuery, UserGroupIndexQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<UserGroupIndexQuery, UserGroupIndexQueryVariables>(UserGroupIndexDocument, options);
}
export function useUserGroupIndexLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<UserGroupIndexQuery, UserGroupIndexQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<UserGroupIndexQuery, UserGroupIndexQueryVariables>(UserGroupIndexDocument, options);
}
export function useUserGroupIndexSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<UserGroupIndexQuery, UserGroupIndexQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<UserGroupIndexQuery, UserGroupIndexQueryVariables>(UserGroupIndexDocument, options);
}
export type UserGroupIndexQueryHookResult = ReturnType<typeof useUserGroupIndexQuery>;
export type UserGroupIndexLazyQueryHookResult = ReturnType<typeof useUserGroupIndexLazyQuery>;
export type UserGroupIndexSuspenseQueryHookResult = ReturnType<typeof useUserGroupIndexSuspenseQuery>;
export type UserGroupIndexQueryResult = Apollo.QueryResult<UserGroupIndexQuery, UserGroupIndexQueryVariables>;
export const UserGroupDetailedSelectListDocument = gql`
	query userGroupDetailedSelectList(
		$filters: [UserGroupFilterInput!]
		$pagination: Pagination
		$order: UserGroupOrder
	) {
		userGroupConnection(filters: $filters, pagination: $pagination, order: $order) {
			edges {
				node {
					id
					...UserGroupName
					description
					currentUserMembers: members(filters: { isCurrentEQ: true }) {
						id
					}
				}
			}
		}
	}
	${UserGroupNameFragmentDoc}
`;

/**
 * __useUserGroupDetailedSelectListQuery__
 *
 * To run a query within a React component, call `useUserGroupDetailedSelectListQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserGroupDetailedSelectListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserGroupDetailedSelectListQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useUserGroupDetailedSelectListQuery(
	baseOptions?: Apollo.QueryHookOptions<UserGroupDetailedSelectListQuery, UserGroupDetailedSelectListQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<UserGroupDetailedSelectListQuery, UserGroupDetailedSelectListQueryVariables>(
		UserGroupDetailedSelectListDocument,
		options,
	);
}
export function useUserGroupDetailedSelectListLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		UserGroupDetailedSelectListQuery,
		UserGroupDetailedSelectListQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<UserGroupDetailedSelectListQuery, UserGroupDetailedSelectListQueryVariables>(
		UserGroupDetailedSelectListDocument,
		options,
	);
}
export function useUserGroupDetailedSelectListSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		UserGroupDetailedSelectListQuery,
		UserGroupDetailedSelectListQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<UserGroupDetailedSelectListQuery, UserGroupDetailedSelectListQueryVariables>(
		UserGroupDetailedSelectListDocument,
		options,
	);
}
export type UserGroupDetailedSelectListQueryHookResult = ReturnType<typeof useUserGroupDetailedSelectListQuery>;
export type UserGroupDetailedSelectListLazyQueryHookResult = ReturnType<typeof useUserGroupDetailedSelectListLazyQuery>;
export type UserGroupDetailedSelectListSuspenseQueryHookResult = ReturnType<
	typeof useUserGroupDetailedSelectListSuspenseQuery
>;
export type UserGroupDetailedSelectListQueryResult = Apollo.QueryResult<
	UserGroupDetailedSelectListQuery,
	UserGroupDetailedSelectListQueryVariables
>;
export const UserGroupNameDocument = gql`
	query userGroupName($id: ID!) {
		userGroup(id: $id) {
			id
			...UserGroupName
		}
	}
	${UserGroupNameFragmentDoc}
`;

/**
 * __useUserGroupNameQuery__
 *
 * To run a query within a React component, call `useUserGroupNameQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserGroupNameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserGroupNameQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUserGroupNameQuery(
	baseOptions: Apollo.QueryHookOptions<UserGroupNameQuery, UserGroupNameQueryVariables> &
		({ variables: UserGroupNameQueryVariables; skip?: boolean } | { skip: boolean }),
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<UserGroupNameQuery, UserGroupNameQueryVariables>(UserGroupNameDocument, options);
}
export function useUserGroupNameLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<UserGroupNameQuery, UserGroupNameQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<UserGroupNameQuery, UserGroupNameQueryVariables>(UserGroupNameDocument, options);
}
export function useUserGroupNameSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<UserGroupNameQuery, UserGroupNameQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<UserGroupNameQuery, UserGroupNameQueryVariables>(UserGroupNameDocument, options);
}
export type UserGroupNameQueryHookResult = ReturnType<typeof useUserGroupNameQuery>;
export type UserGroupNameLazyQueryHookResult = ReturnType<typeof useUserGroupNameLazyQuery>;
export type UserGroupNameSuspenseQueryHookResult = ReturnType<typeof useUserGroupNameSuspenseQuery>;
export type UserGroupNameQueryResult = Apollo.QueryResult<UserGroupNameQuery, UserGroupNameQueryVariables>;
export const UserGroupNamesDocument = gql`
	query userGroupNames($filters: [UserGroupFilterInput!], $pagination: Pagination, $order: UserGroupOrder) {
		userGroupConnection(filters: $filters, pagination: $pagination, order: $order) {
			edges {
				node {
					id
					...UserGroupName
				}
			}
		}
	}
	${UserGroupNameFragmentDoc}
`;

/**
 * __useUserGroupNamesQuery__
 *
 * To run a query within a React component, call `useUserGroupNamesQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserGroupNamesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserGroupNamesQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useUserGroupNamesQuery(
	baseOptions?: Apollo.QueryHookOptions<UserGroupNamesQuery, UserGroupNamesQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<UserGroupNamesQuery, UserGroupNamesQueryVariables>(UserGroupNamesDocument, options);
}
export function useUserGroupNamesLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<UserGroupNamesQuery, UserGroupNamesQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<UserGroupNamesQuery, UserGroupNamesQueryVariables>(UserGroupNamesDocument, options);
}
export function useUserGroupNamesSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<UserGroupNamesQuery, UserGroupNamesQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<UserGroupNamesQuery, UserGroupNamesQueryVariables>(UserGroupNamesDocument, options);
}
export type UserGroupNamesQueryHookResult = ReturnType<typeof useUserGroupNamesQuery>;
export type UserGroupNamesLazyQueryHookResult = ReturnType<typeof useUserGroupNamesLazyQuery>;
export type UserGroupNamesSuspenseQueryHookResult = ReturnType<typeof useUserGroupNamesSuspenseQuery>;
export type UserGroupNamesQueryResult = Apollo.QueryResult<UserGroupNamesQuery, UserGroupNamesQueryVariables>;
export const UserGroupNamesAndColorsDocument = gql`
	query userGroupNamesAndColors($filters: [UserGroupFilterInput!], $pagination: Pagination, $order: UserGroupOrder) {
		userGroupConnection(filters: $filters, pagination: $pagination, order: $order) {
			edges {
				node {
					id
					...UserGroupNameAndColor
				}
			}
		}
	}
	${UserGroupNameAndColorFragmentDoc}
`;

/**
 * __useUserGroupNamesAndColorsQuery__
 *
 * To run a query within a React component, call `useUserGroupNamesAndColorsQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserGroupNamesAndColorsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserGroupNamesAndColorsQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useUserGroupNamesAndColorsQuery(
	baseOptions?: Apollo.QueryHookOptions<UserGroupNamesAndColorsQuery, UserGroupNamesAndColorsQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<UserGroupNamesAndColorsQuery, UserGroupNamesAndColorsQueryVariables>(
		UserGroupNamesAndColorsDocument,
		options,
	);
}
export function useUserGroupNamesAndColorsLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<UserGroupNamesAndColorsQuery, UserGroupNamesAndColorsQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<UserGroupNamesAndColorsQuery, UserGroupNamesAndColorsQueryVariables>(
		UserGroupNamesAndColorsDocument,
		options,
	);
}
export function useUserGroupNamesAndColorsSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<UserGroupNamesAndColorsQuery, UserGroupNamesAndColorsQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<UserGroupNamesAndColorsQuery, UserGroupNamesAndColorsQueryVariables>(
		UserGroupNamesAndColorsDocument,
		options,
	);
}
export type UserGroupNamesAndColorsQueryHookResult = ReturnType<typeof useUserGroupNamesAndColorsQuery>;
export type UserGroupNamesAndColorsLazyQueryHookResult = ReturnType<typeof useUserGroupNamesAndColorsLazyQuery>;
export type UserGroupNamesAndColorsSuspenseQueryHookResult = ReturnType<typeof useUserGroupNamesAndColorsSuspenseQuery>;
export type UserGroupNamesAndColorsQueryResult = Apollo.QueryResult<
	UserGroupNamesAndColorsQuery,
	UserGroupNamesAndColorsQueryVariables
>;
export const UserGroupPaginationDocument = gql`
	query userGroupPagination($filters: [UserGroupFilterInput!], $order: UserGroupOrder) {
		userGroupConnection(filters: $filters, order: $order) {
			totalCount
			edges {
				cursor
			}
		}
	}
`;

/**
 * __useUserGroupPaginationQuery__
 *
 * To run a query within a React component, call `useUserGroupPaginationQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserGroupPaginationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserGroupPaginationQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useUserGroupPaginationQuery(
	baseOptions?: Apollo.QueryHookOptions<UserGroupPaginationQuery, UserGroupPaginationQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<UserGroupPaginationQuery, UserGroupPaginationQueryVariables>(
		UserGroupPaginationDocument,
		options,
	);
}
export function useUserGroupPaginationLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<UserGroupPaginationQuery, UserGroupPaginationQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<UserGroupPaginationQuery, UserGroupPaginationQueryVariables>(
		UserGroupPaginationDocument,
		options,
	);
}
export function useUserGroupPaginationSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<UserGroupPaginationQuery, UserGroupPaginationQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<UserGroupPaginationQuery, UserGroupPaginationQueryVariables>(
		UserGroupPaginationDocument,
		options,
	);
}
export type UserGroupPaginationQueryHookResult = ReturnType<typeof useUserGroupPaginationQuery>;
export type UserGroupPaginationLazyQueryHookResult = ReturnType<typeof useUserGroupPaginationLazyQuery>;
export type UserGroupPaginationSuspenseQueryHookResult = ReturnType<typeof useUserGroupPaginationSuspenseQuery>;
export type UserGroupPaginationQueryResult = Apollo.QueryResult<
	UserGroupPaginationQuery,
	UserGroupPaginationQueryVariables
>;
export const UserGroupSelectDocument = gql`
	query userGroupSelect($filters: [UserGroupFilterInput!], $order: UserGroupOrder) {
		userGroupConnection(filters: $filters, order: $order) {
			edges {
				node {
					id
					...UserGroupName
				}
			}
		}
	}
	${UserGroupNameFragmentDoc}
`;

/**
 * __useUserGroupSelectQuery__
 *
 * To run a query within a React component, call `useUserGroupSelectQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserGroupSelectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserGroupSelectQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useUserGroupSelectQuery(
	baseOptions?: Apollo.QueryHookOptions<UserGroupSelectQuery, UserGroupSelectQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<UserGroupSelectQuery, UserGroupSelectQueryVariables>(UserGroupSelectDocument, options);
}
export function useUserGroupSelectLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<UserGroupSelectQuery, UserGroupSelectQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<UserGroupSelectQuery, UserGroupSelectQueryVariables>(UserGroupSelectDocument, options);
}
export function useUserGroupSelectSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<UserGroupSelectQuery, UserGroupSelectQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<UserGroupSelectQuery, UserGroupSelectQueryVariables>(UserGroupSelectDocument, options);
}
export type UserGroupSelectQueryHookResult = ReturnType<typeof useUserGroupSelectQuery>;
export type UserGroupSelectLazyQueryHookResult = ReturnType<typeof useUserGroupSelectLazyQuery>;
export type UserGroupSelectSuspenseQueryHookResult = ReturnType<typeof useUserGroupSelectSuspenseQuery>;
export type UserGroupSelectQueryResult = Apollo.QueryResult<UserGroupSelectQuery, UserGroupSelectQueryVariables>;
export const UserGroupUpdateDocument = gql`
	mutation userGroupUpdate($id: ID!, $input: UserGroupUpdateInput!) {
		updateUserGroup(id: $id, input: $input) {
			...UserGroupDetail
		}
	}
	${UserGroupDetailFragmentDoc}
`;
export type UserGroupUpdateMutationFn = Apollo.MutationFunction<
	UserGroupUpdateMutation,
	UserGroupUpdateMutationVariables
>;

/**
 * __useUserGroupUpdateMutation__
 *
 * To run a mutation, you first call `useUserGroupUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUserGroupUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [userGroupUpdateMutation, { data, loading, error }] = useUserGroupUpdateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUserGroupUpdateMutation(
	baseOptions?: Apollo.MutationHookOptions<UserGroupUpdateMutation, UserGroupUpdateMutationVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<UserGroupUpdateMutation, UserGroupUpdateMutationVariables>(
		UserGroupUpdateDocument,
		options,
	);
}
export type UserGroupUpdateMutationHookResult = ReturnType<typeof useUserGroupUpdateMutation>;
export type UserGroupUpdateMutationResult = Apollo.MutationResult<UserGroupUpdateMutation>;
export type UserGroupUpdateMutationOptions = Apollo.BaseMutationOptions<
	UserGroupUpdateMutation,
	UserGroupUpdateMutationVariables
>;
export const UserViewRecordCountDocument = gql`
	query userViewRecordCount(
		$filters: [UserViewRecordFilterInput!]
		$pagination: Pagination
		$order: UserViewRecordOrder
	) {
		userViewRecordConnection(filters: $filters, pagination: $pagination, order: $order) {
			totalCount
		}
	}
`;

/**
 * __useUserViewRecordCountQuery__
 *
 * To run a query within a React component, call `useUserViewRecordCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserViewRecordCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserViewRecordCountQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useUserViewRecordCountQuery(
	baseOptions?: Apollo.QueryHookOptions<UserViewRecordCountQuery, UserViewRecordCountQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<UserViewRecordCountQuery, UserViewRecordCountQueryVariables>(
		UserViewRecordCountDocument,
		options,
	);
}
export function useUserViewRecordCountLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<UserViewRecordCountQuery, UserViewRecordCountQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<UserViewRecordCountQuery, UserViewRecordCountQueryVariables>(
		UserViewRecordCountDocument,
		options,
	);
}
export function useUserViewRecordCountSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<UserViewRecordCountQuery, UserViewRecordCountQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<UserViewRecordCountQuery, UserViewRecordCountQueryVariables>(
		UserViewRecordCountDocument,
		options,
	);
}
export type UserViewRecordCountQueryHookResult = ReturnType<typeof useUserViewRecordCountQuery>;
export type UserViewRecordCountLazyQueryHookResult = ReturnType<typeof useUserViewRecordCountLazyQuery>;
export type UserViewRecordCountSuspenseQueryHookResult = ReturnType<typeof useUserViewRecordCountSuspenseQuery>;
export type UserViewRecordCountQueryResult = Apollo.QueryResult<
	UserViewRecordCountQuery,
	UserViewRecordCountQueryVariables
>;
export const UserViewRecordCreateDocument = gql`
	mutation userViewRecordCreate($input: UserViewRecordCreateInput!) {
		createUserViewRecord(input: $input) {
			...UserViewRecordDetail
		}
	}
	${UserViewRecordDetailFragmentDoc}
`;
export type UserViewRecordCreateMutationFn = Apollo.MutationFunction<
	UserViewRecordCreateMutation,
	UserViewRecordCreateMutationVariables
>;

/**
 * __useUserViewRecordCreateMutation__
 *
 * To run a mutation, you first call `useUserViewRecordCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUserViewRecordCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [userViewRecordCreateMutation, { data, loading, error }] = useUserViewRecordCreateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUserViewRecordCreateMutation(
	baseOptions?: Apollo.MutationHookOptions<UserViewRecordCreateMutation, UserViewRecordCreateMutationVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<UserViewRecordCreateMutation, UserViewRecordCreateMutationVariables>(
		UserViewRecordCreateDocument,
		options,
	);
}
export type UserViewRecordCreateMutationHookResult = ReturnType<typeof useUserViewRecordCreateMutation>;
export type UserViewRecordCreateMutationResult = Apollo.MutationResult<UserViewRecordCreateMutation>;
export type UserViewRecordCreateMutationOptions = Apollo.BaseMutationOptions<
	UserViewRecordCreateMutation,
	UserViewRecordCreateMutationVariables
>;
export const UserViewRecordDeleteDocument = gql`
	mutation userViewRecordDelete($id: ID!) {
		deleteUserViewRecord(id: $id)
	}
`;
export type UserViewRecordDeleteMutationFn = Apollo.MutationFunction<
	UserViewRecordDeleteMutation,
	UserViewRecordDeleteMutationVariables
>;

/**
 * __useUserViewRecordDeleteMutation__
 *
 * To run a mutation, you first call `useUserViewRecordDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUserViewRecordDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [userViewRecordDeleteMutation, { data, loading, error }] = useUserViewRecordDeleteMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUserViewRecordDeleteMutation(
	baseOptions?: Apollo.MutationHookOptions<UserViewRecordDeleteMutation, UserViewRecordDeleteMutationVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<UserViewRecordDeleteMutation, UserViewRecordDeleteMutationVariables>(
		UserViewRecordDeleteDocument,
		options,
	);
}
export type UserViewRecordDeleteMutationHookResult = ReturnType<typeof useUserViewRecordDeleteMutation>;
export type UserViewRecordDeleteMutationResult = Apollo.MutationResult<UserViewRecordDeleteMutation>;
export type UserViewRecordDeleteMutationOptions = Apollo.BaseMutationOptions<
	UserViewRecordDeleteMutation,
	UserViewRecordDeleteMutationVariables
>;
export const UserViewRecordDetailDocument = gql`
	query userViewRecordDetail($id: ID!) {
		userViewRecord(id: $id) {
			...UserViewRecordDetail
		}
	}
	${UserViewRecordDetailFragmentDoc}
`;

/**
 * __useUserViewRecordDetailQuery__
 *
 * To run a query within a React component, call `useUserViewRecordDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserViewRecordDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserViewRecordDetailQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUserViewRecordDetailQuery(
	baseOptions: Apollo.QueryHookOptions<UserViewRecordDetailQuery, UserViewRecordDetailQueryVariables> &
		({ variables: UserViewRecordDetailQueryVariables; skip?: boolean } | { skip: boolean }),
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<UserViewRecordDetailQuery, UserViewRecordDetailQueryVariables>(
		UserViewRecordDetailDocument,
		options,
	);
}
export function useUserViewRecordDetailLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<UserViewRecordDetailQuery, UserViewRecordDetailQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<UserViewRecordDetailQuery, UserViewRecordDetailQueryVariables>(
		UserViewRecordDetailDocument,
		options,
	);
}
export function useUserViewRecordDetailSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<UserViewRecordDetailQuery, UserViewRecordDetailQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<UserViewRecordDetailQuery, UserViewRecordDetailQueryVariables>(
		UserViewRecordDetailDocument,
		options,
	);
}
export type UserViewRecordDetailQueryHookResult = ReturnType<typeof useUserViewRecordDetailQuery>;
export type UserViewRecordDetailLazyQueryHookResult = ReturnType<typeof useUserViewRecordDetailLazyQuery>;
export type UserViewRecordDetailSuspenseQueryHookResult = ReturnType<typeof useUserViewRecordDetailSuspenseQuery>;
export type UserViewRecordDetailQueryResult = Apollo.QueryResult<
	UserViewRecordDetailQuery,
	UserViewRecordDetailQueryVariables
>;
export const UserViewRecordIDsDocument = gql`
	query userViewRecordIDs(
		$filters: [UserViewRecordFilterInput!]
		$pagination: Pagination
		$order: UserViewRecordOrder
	) {
		userViewRecordConnection(filters: $filters, pagination: $pagination, order: $order) {
			edges {
				node {
					id
					targetID
				}
			}
		}
	}
`;

/**
 * __useUserViewRecordIDsQuery__
 *
 * To run a query within a React component, call `useUserViewRecordIDsQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserViewRecordIDsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserViewRecordIDsQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useUserViewRecordIDsQuery(
	baseOptions?: Apollo.QueryHookOptions<UserViewRecordIDsQuery, UserViewRecordIDsQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<UserViewRecordIDsQuery, UserViewRecordIDsQueryVariables>(UserViewRecordIDsDocument, options);
}
export function useUserViewRecordIDsLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<UserViewRecordIDsQuery, UserViewRecordIDsQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<UserViewRecordIDsQuery, UserViewRecordIDsQueryVariables>(
		UserViewRecordIDsDocument,
		options,
	);
}
export function useUserViewRecordIDsSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<UserViewRecordIDsQuery, UserViewRecordIDsQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<UserViewRecordIDsQuery, UserViewRecordIDsQueryVariables>(
		UserViewRecordIDsDocument,
		options,
	);
}
export type UserViewRecordIDsQueryHookResult = ReturnType<typeof useUserViewRecordIDsQuery>;
export type UserViewRecordIDsLazyQueryHookResult = ReturnType<typeof useUserViewRecordIDsLazyQuery>;
export type UserViewRecordIDsSuspenseQueryHookResult = ReturnType<typeof useUserViewRecordIDsSuspenseQuery>;
export type UserViewRecordIDsQueryResult = Apollo.QueryResult<UserViewRecordIDsQuery, UserViewRecordIDsQueryVariables>;
export const UserViewRecordIndexDocument = gql`
	query userViewRecordIndex(
		$filters: [UserViewRecordFilterInput!]
		$pagination: Pagination
		$order: UserViewRecordOrder
	) {
		userViewRecordConnection(filters: $filters, pagination: $pagination, order: $order) {
			edges {
				node {
					id
					targetID
					firstViewedAt
					lastViewedAt
				}
			}
		}
	}
`;

/**
 * __useUserViewRecordIndexQuery__
 *
 * To run a query within a React component, call `useUserViewRecordIndexQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserViewRecordIndexQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserViewRecordIndexQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useUserViewRecordIndexQuery(
	baseOptions?: Apollo.QueryHookOptions<UserViewRecordIndexQuery, UserViewRecordIndexQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<UserViewRecordIndexQuery, UserViewRecordIndexQueryVariables>(
		UserViewRecordIndexDocument,
		options,
	);
}
export function useUserViewRecordIndexLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<UserViewRecordIndexQuery, UserViewRecordIndexQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<UserViewRecordIndexQuery, UserViewRecordIndexQueryVariables>(
		UserViewRecordIndexDocument,
		options,
	);
}
export function useUserViewRecordIndexSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<UserViewRecordIndexQuery, UserViewRecordIndexQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<UserViewRecordIndexQuery, UserViewRecordIndexQueryVariables>(
		UserViewRecordIndexDocument,
		options,
	);
}
export type UserViewRecordIndexQueryHookResult = ReturnType<typeof useUserViewRecordIndexQuery>;
export type UserViewRecordIndexLazyQueryHookResult = ReturnType<typeof useUserViewRecordIndexLazyQuery>;
export type UserViewRecordIndexSuspenseQueryHookResult = ReturnType<typeof useUserViewRecordIndexSuspenseQuery>;
export type UserViewRecordIndexQueryResult = Apollo.QueryResult<
	UserViewRecordIndexQuery,
	UserViewRecordIndexQueryVariables
>;
export const UserViewRecordNameDocument = gql`
	query userViewRecordName($id: ID!) {
		userViewRecord(id: $id) {
			id
			...UserViewRecordName
		}
	}
	${UserViewRecordNameFragmentDoc}
`;

/**
 * __useUserViewRecordNameQuery__
 *
 * To run a query within a React component, call `useUserViewRecordNameQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserViewRecordNameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserViewRecordNameQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUserViewRecordNameQuery(
	baseOptions: Apollo.QueryHookOptions<UserViewRecordNameQuery, UserViewRecordNameQueryVariables> &
		({ variables: UserViewRecordNameQueryVariables; skip?: boolean } | { skip: boolean }),
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<UserViewRecordNameQuery, UserViewRecordNameQueryVariables>(
		UserViewRecordNameDocument,
		options,
	);
}
export function useUserViewRecordNameLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<UserViewRecordNameQuery, UserViewRecordNameQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<UserViewRecordNameQuery, UserViewRecordNameQueryVariables>(
		UserViewRecordNameDocument,
		options,
	);
}
export function useUserViewRecordNameSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<UserViewRecordNameQuery, UserViewRecordNameQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<UserViewRecordNameQuery, UserViewRecordNameQueryVariables>(
		UserViewRecordNameDocument,
		options,
	);
}
export type UserViewRecordNameQueryHookResult = ReturnType<typeof useUserViewRecordNameQuery>;
export type UserViewRecordNameLazyQueryHookResult = ReturnType<typeof useUserViewRecordNameLazyQuery>;
export type UserViewRecordNameSuspenseQueryHookResult = ReturnType<typeof useUserViewRecordNameSuspenseQuery>;
export type UserViewRecordNameQueryResult = Apollo.QueryResult<
	UserViewRecordNameQuery,
	UserViewRecordNameQueryVariables
>;
export const UserViewRecordNamesDocument = gql`
	query userViewRecordNames(
		$filters: [UserViewRecordFilterInput!]
		$pagination: Pagination
		$order: UserViewRecordOrder
	) {
		userViewRecordConnection(filters: $filters, pagination: $pagination, order: $order) {
			edges {
				node {
					id
					...UserViewRecordName
				}
			}
		}
	}
	${UserViewRecordNameFragmentDoc}
`;

/**
 * __useUserViewRecordNamesQuery__
 *
 * To run a query within a React component, call `useUserViewRecordNamesQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserViewRecordNamesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserViewRecordNamesQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useUserViewRecordNamesQuery(
	baseOptions?: Apollo.QueryHookOptions<UserViewRecordNamesQuery, UserViewRecordNamesQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<UserViewRecordNamesQuery, UserViewRecordNamesQueryVariables>(
		UserViewRecordNamesDocument,
		options,
	);
}
export function useUserViewRecordNamesLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<UserViewRecordNamesQuery, UserViewRecordNamesQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<UserViewRecordNamesQuery, UserViewRecordNamesQueryVariables>(
		UserViewRecordNamesDocument,
		options,
	);
}
export function useUserViewRecordNamesSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<UserViewRecordNamesQuery, UserViewRecordNamesQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<UserViewRecordNamesQuery, UserViewRecordNamesQueryVariables>(
		UserViewRecordNamesDocument,
		options,
	);
}
export type UserViewRecordNamesQueryHookResult = ReturnType<typeof useUserViewRecordNamesQuery>;
export type UserViewRecordNamesLazyQueryHookResult = ReturnType<typeof useUserViewRecordNamesLazyQuery>;
export type UserViewRecordNamesSuspenseQueryHookResult = ReturnType<typeof useUserViewRecordNamesSuspenseQuery>;
export type UserViewRecordNamesQueryResult = Apollo.QueryResult<
	UserViewRecordNamesQuery,
	UserViewRecordNamesQueryVariables
>;
export const UserViewRecordPaginationDocument = gql`
	query userViewRecordPagination($filters: [UserViewRecordFilterInput!], $order: UserViewRecordOrder) {
		userViewRecordConnection(filters: $filters, order: $order) {
			totalCount
			edges {
				cursor
			}
		}
	}
`;

/**
 * __useUserViewRecordPaginationQuery__
 *
 * To run a query within a React component, call `useUserViewRecordPaginationQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserViewRecordPaginationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserViewRecordPaginationQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useUserViewRecordPaginationQuery(
	baseOptions?: Apollo.QueryHookOptions<UserViewRecordPaginationQuery, UserViewRecordPaginationQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<UserViewRecordPaginationQuery, UserViewRecordPaginationQueryVariables>(
		UserViewRecordPaginationDocument,
		options,
	);
}
export function useUserViewRecordPaginationLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<UserViewRecordPaginationQuery, UserViewRecordPaginationQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<UserViewRecordPaginationQuery, UserViewRecordPaginationQueryVariables>(
		UserViewRecordPaginationDocument,
		options,
	);
}
export function useUserViewRecordPaginationSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<UserViewRecordPaginationQuery, UserViewRecordPaginationQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<UserViewRecordPaginationQuery, UserViewRecordPaginationQueryVariables>(
		UserViewRecordPaginationDocument,
		options,
	);
}
export type UserViewRecordPaginationQueryHookResult = ReturnType<typeof useUserViewRecordPaginationQuery>;
export type UserViewRecordPaginationLazyQueryHookResult = ReturnType<typeof useUserViewRecordPaginationLazyQuery>;
export type UserViewRecordPaginationSuspenseQueryHookResult = ReturnType<
	typeof useUserViewRecordPaginationSuspenseQuery
>;
export type UserViewRecordPaginationQueryResult = Apollo.QueryResult<
	UserViewRecordPaginationQuery,
	UserViewRecordPaginationQueryVariables
>;
export const RecordViewDocument = gql`
	mutation recordView($id: ID!) {
		recordView(id: $id) {
			id
			targetID
			userID
			firstViewedAt
			lastViewedAt
		}
	}
`;
export type RecordViewMutationFn = Apollo.MutationFunction<RecordViewMutation, RecordViewMutationVariables>;

/**
 * __useRecordViewMutation__
 *
 * To run a mutation, you first call `useRecordViewMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRecordViewMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [recordViewMutation, { data, loading, error }] = useRecordViewMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRecordViewMutation(
	baseOptions?: Apollo.MutationHookOptions<RecordViewMutation, RecordViewMutationVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<RecordViewMutation, RecordViewMutationVariables>(RecordViewDocument, options);
}
export type RecordViewMutationHookResult = ReturnType<typeof useRecordViewMutation>;
export type RecordViewMutationResult = Apollo.MutationResult<RecordViewMutation>;
export type RecordViewMutationOptions = Apollo.BaseMutationOptions<RecordViewMutation, RecordViewMutationVariables>;
export const RecordViewsDocument = gql`
	mutation recordViews($ids: [ID!]!) {
		recordViews(ids: $ids) {
			edges {
				node {
					id
					targetID
					userID
					firstViewedAt
					lastViewedAt
				}
			}
		}
	}
`;
export type RecordViewsMutationFn = Apollo.MutationFunction<RecordViewsMutation, RecordViewsMutationVariables>;

/**
 * __useRecordViewsMutation__
 *
 * To run a mutation, you first call `useRecordViewsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRecordViewsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [recordViewsMutation, { data, loading, error }] = useRecordViewsMutation({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useRecordViewsMutation(
	baseOptions?: Apollo.MutationHookOptions<RecordViewsMutation, RecordViewsMutationVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<RecordViewsMutation, RecordViewsMutationVariables>(RecordViewsDocument, options);
}
export type RecordViewsMutationHookResult = ReturnType<typeof useRecordViewsMutation>;
export type RecordViewsMutationResult = Apollo.MutationResult<RecordViewsMutation>;
export type RecordViewsMutationOptions = Apollo.BaseMutationOptions<RecordViewsMutation, RecordViewsMutationVariables>;
export const UserViewRecordSelectDocument = gql`
	query userViewRecordSelect($filters: [UserViewRecordFilterInput!], $order: UserViewRecordOrder) {
		userViewRecordConnection(filters: $filters, order: $order) {
			edges {
				node {
					id
					...UserViewRecordName
				}
			}
		}
	}
	${UserViewRecordNameFragmentDoc}
`;

/**
 * __useUserViewRecordSelectQuery__
 *
 * To run a query within a React component, call `useUserViewRecordSelectQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserViewRecordSelectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserViewRecordSelectQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useUserViewRecordSelectQuery(
	baseOptions?: Apollo.QueryHookOptions<UserViewRecordSelectQuery, UserViewRecordSelectQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<UserViewRecordSelectQuery, UserViewRecordSelectQueryVariables>(
		UserViewRecordSelectDocument,
		options,
	);
}
export function useUserViewRecordSelectLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<UserViewRecordSelectQuery, UserViewRecordSelectQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<UserViewRecordSelectQuery, UserViewRecordSelectQueryVariables>(
		UserViewRecordSelectDocument,
		options,
	);
}
export function useUserViewRecordSelectSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<UserViewRecordSelectQuery, UserViewRecordSelectQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<UserViewRecordSelectQuery, UserViewRecordSelectQueryVariables>(
		UserViewRecordSelectDocument,
		options,
	);
}
export type UserViewRecordSelectQueryHookResult = ReturnType<typeof useUserViewRecordSelectQuery>;
export type UserViewRecordSelectLazyQueryHookResult = ReturnType<typeof useUserViewRecordSelectLazyQuery>;
export type UserViewRecordSelectSuspenseQueryHookResult = ReturnType<typeof useUserViewRecordSelectSuspenseQuery>;
export type UserViewRecordSelectQueryResult = Apollo.QueryResult<
	UserViewRecordSelectQuery,
	UserViewRecordSelectQueryVariables
>;
export const UserViewRecordListForTargetDocument = gql`
	query userViewRecordListForTarget(
		$filters: [UserViewRecordFilterInput!]
		$pagination: Pagination
		$order: UserViewRecordOrder
	) {
		userViewRecordConnection(filters: $filters, pagination: $pagination, order: $order) {
			edges {
				node {
					id
					targetID
					lastViewedAt
				}
			}
		}
	}
`;

/**
 * __useUserViewRecordListForTargetQuery__
 *
 * To run a query within a React component, call `useUserViewRecordListForTargetQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserViewRecordListForTargetQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserViewRecordListForTargetQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useUserViewRecordListForTargetQuery(
	baseOptions?: Apollo.QueryHookOptions<UserViewRecordListForTargetQuery, UserViewRecordListForTargetQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<UserViewRecordListForTargetQuery, UserViewRecordListForTargetQueryVariables>(
		UserViewRecordListForTargetDocument,
		options,
	);
}
export function useUserViewRecordListForTargetLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		UserViewRecordListForTargetQuery,
		UserViewRecordListForTargetQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<UserViewRecordListForTargetQuery, UserViewRecordListForTargetQueryVariables>(
		UserViewRecordListForTargetDocument,
		options,
	);
}
export function useUserViewRecordListForTargetSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		UserViewRecordListForTargetQuery,
		UserViewRecordListForTargetQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<UserViewRecordListForTargetQuery, UserViewRecordListForTargetQueryVariables>(
		UserViewRecordListForTargetDocument,
		options,
	);
}
export type UserViewRecordListForTargetQueryHookResult = ReturnType<typeof useUserViewRecordListForTargetQuery>;
export type UserViewRecordListForTargetLazyQueryHookResult = ReturnType<typeof useUserViewRecordListForTargetLazyQuery>;
export type UserViewRecordListForTargetSuspenseQueryHookResult = ReturnType<
	typeof useUserViewRecordListForTargetSuspenseQuery
>;
export type UserViewRecordListForTargetQueryResult = Apollo.QueryResult<
	UserViewRecordListForTargetQuery,
	UserViewRecordListForTargetQueryVariables
>;
export const UserViewRecordListForTargetWithUserDocument = gql`
	query userViewRecordListForTargetWithUser(
		$filters: [UserViewRecordFilterInput!]
		$pagination: Pagination
		$order: UserViewRecordOrder
	) {
		userViewRecordConnection(filters: $filters, pagination: $pagination, order: $order) {
			edges {
				node {
					id
					targetID
					lastViewedAt
					user {
						id
						...UserName
					}
				}
			}
		}
	}
	${UserNameFragmentDoc}
`;

/**
 * __useUserViewRecordListForTargetWithUserQuery__
 *
 * To run a query within a React component, call `useUserViewRecordListForTargetWithUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserViewRecordListForTargetWithUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserViewRecordListForTargetWithUserQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useUserViewRecordListForTargetWithUserQuery(
	baseOptions?: Apollo.QueryHookOptions<
		UserViewRecordListForTargetWithUserQuery,
		UserViewRecordListForTargetWithUserQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<UserViewRecordListForTargetWithUserQuery, UserViewRecordListForTargetWithUserQueryVariables>(
		UserViewRecordListForTargetWithUserDocument,
		options,
	);
}
export function useUserViewRecordListForTargetWithUserLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		UserViewRecordListForTargetWithUserQuery,
		UserViewRecordListForTargetWithUserQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		UserViewRecordListForTargetWithUserQuery,
		UserViewRecordListForTargetWithUserQueryVariables
	>(UserViewRecordListForTargetWithUserDocument, options);
}
export function useUserViewRecordListForTargetWithUserSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		UserViewRecordListForTargetWithUserQuery,
		UserViewRecordListForTargetWithUserQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<
		UserViewRecordListForTargetWithUserQuery,
		UserViewRecordListForTargetWithUserQueryVariables
	>(UserViewRecordListForTargetWithUserDocument, options);
}
export type UserViewRecordListForTargetWithUserQueryHookResult = ReturnType<
	typeof useUserViewRecordListForTargetWithUserQuery
>;
export type UserViewRecordListForTargetWithUserLazyQueryHookResult = ReturnType<
	typeof useUserViewRecordListForTargetWithUserLazyQuery
>;
export type UserViewRecordListForTargetWithUserSuspenseQueryHookResult = ReturnType<
	typeof useUserViewRecordListForTargetWithUserSuspenseQuery
>;
export type UserViewRecordListForTargetWithUserQueryResult = Apollo.QueryResult<
	UserViewRecordListForTargetWithUserQuery,
	UserViewRecordListForTargetWithUserQueryVariables
>;
export const UserViewRecordUpdateDocument = gql`
	mutation userViewRecordUpdate($id: ID!, $input: UserViewRecordUpdateInput!) {
		updateUserViewRecord(id: $id, input: $input) {
			...UserViewRecordDetail
		}
	}
	${UserViewRecordDetailFragmentDoc}
`;
export type UserViewRecordUpdateMutationFn = Apollo.MutationFunction<
	UserViewRecordUpdateMutation,
	UserViewRecordUpdateMutationVariables
>;

/**
 * __useUserViewRecordUpdateMutation__
 *
 * To run a mutation, you first call `useUserViewRecordUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUserViewRecordUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [userViewRecordUpdateMutation, { data, loading, error }] = useUserViewRecordUpdateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUserViewRecordUpdateMutation(
	baseOptions?: Apollo.MutationHookOptions<UserViewRecordUpdateMutation, UserViewRecordUpdateMutationVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<UserViewRecordUpdateMutation, UserViewRecordUpdateMutationVariables>(
		UserViewRecordUpdateDocument,
		options,
	);
}
export type UserViewRecordUpdateMutationHookResult = ReturnType<typeof useUserViewRecordUpdateMutation>;
export type UserViewRecordUpdateMutationResult = Apollo.MutationResult<UserViewRecordUpdateMutation>;
export type UserViewRecordUpdateMutationOptions = Apollo.BaseMutationOptions<
	UserViewRecordUpdateMutation,
	UserViewRecordUpdateMutationVariables
>;
export const BirthdaysDocument = gql`
	query birthdays($dates: [Time!]!, $filters: [UserFilterInput!], $pagination: Pagination, $order: UserOrder) {
		userConnectionByBirthday(dates: $dates, filters: $filters, pagination: $pagination, order: $order) {
			edges {
				node {
					id
					...UserNameAndImage
					givenName
					familyName
					dateOfBirth
				}
			}
		}
	}
	${UserNameAndImageFragmentDoc}
`;

/**
 * __useBirthdaysQuery__
 *
 * To run a query within a React component, call `useBirthdaysQuery` and pass it any options that fit your needs.
 * When your component renders, `useBirthdaysQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBirthdaysQuery({
 *   variables: {
 *      dates: // value for 'dates'
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useBirthdaysQuery(
	baseOptions: Apollo.QueryHookOptions<BirthdaysQuery, BirthdaysQueryVariables> &
		({ variables: BirthdaysQueryVariables; skip?: boolean } | { skip: boolean }),
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<BirthdaysQuery, BirthdaysQueryVariables>(BirthdaysDocument, options);
}
export function useBirthdaysLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<BirthdaysQuery, BirthdaysQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<BirthdaysQuery, BirthdaysQueryVariables>(BirthdaysDocument, options);
}
export function useBirthdaysSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<BirthdaysQuery, BirthdaysQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<BirthdaysQuery, BirthdaysQueryVariables>(BirthdaysDocument, options);
}
export type BirthdaysQueryHookResult = ReturnType<typeof useBirthdaysQuery>;
export type BirthdaysLazyQueryHookResult = ReturnType<typeof useBirthdaysLazyQuery>;
export type BirthdaysSuspenseQueryHookResult = ReturnType<typeof useBirthdaysSuspenseQuery>;
export type BirthdaysQueryResult = Apollo.QueryResult<BirthdaysQuery, BirthdaysQueryVariables>;
export const GlobalSearchDocument = gql`
	query globalSearch($filters: [SearchResultFilterInput!]!) {
		searchResultConnection(filters: $filters, pagination: { first: 100 }) {
			edges {
				node {
					id
					name
					modelName
					searchText
				}
			}
		}
	}
`;

/**
 * __useGlobalSearchQuery__
 *
 * To run a query within a React component, call `useGlobalSearchQuery` and pass it any options that fit your needs.
 * When your component renders, `useGlobalSearchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGlobalSearchQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useGlobalSearchQuery(
	baseOptions: Apollo.QueryHookOptions<GlobalSearchQuery, GlobalSearchQueryVariables> &
		({ variables: GlobalSearchQueryVariables; skip?: boolean } | { skip: boolean }),
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<GlobalSearchQuery, GlobalSearchQueryVariables>(GlobalSearchDocument, options);
}
export function useGlobalSearchLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<GlobalSearchQuery, GlobalSearchQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<GlobalSearchQuery, GlobalSearchQueryVariables>(GlobalSearchDocument, options);
}
export function useGlobalSearchSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<GlobalSearchQuery, GlobalSearchQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<GlobalSearchQuery, GlobalSearchQueryVariables>(GlobalSearchDocument, options);
}
export type GlobalSearchQueryHookResult = ReturnType<typeof useGlobalSearchQuery>;
export type GlobalSearchLazyQueryHookResult = ReturnType<typeof useGlobalSearchLazyQuery>;
export type GlobalSearchSuspenseQueryHookResult = ReturnType<typeof useGlobalSearchSuspenseQuery>;
export type GlobalSearchQueryResult = Apollo.QueryResult<GlobalSearchQuery, GlobalSearchQueryVariables>;
export const ModelIDsDocument = gql`
	query modelIDs {
		modelIDs {
			modelName
			minID
			maxID
		}
	}
`;

/**
 * __useModelIDsQuery__
 *
 * To run a query within a React component, call `useModelIDsQuery` and pass it any options that fit your needs.
 * When your component renders, `useModelIDsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useModelIDsQuery({
 *   variables: {
 *   },
 * });
 */
export function useModelIDsQuery(baseOptions?: Apollo.QueryHookOptions<ModelIDsQuery, ModelIDsQueryVariables>) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<ModelIDsQuery, ModelIDsQueryVariables>(ModelIDsDocument, options);
}
export function useModelIDsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ModelIDsQuery, ModelIDsQueryVariables>) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<ModelIDsQuery, ModelIDsQueryVariables>(ModelIDsDocument, options);
}
export function useModelIDsSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<ModelIDsQuery, ModelIDsQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<ModelIDsQuery, ModelIDsQueryVariables>(ModelIDsDocument, options);
}
export type ModelIDsQueryHookResult = ReturnType<typeof useModelIDsQuery>;
export type ModelIDsLazyQueryHookResult = ReturnType<typeof useModelIDsLazyQuery>;
export type ModelIDsSuspenseQueryHookResult = ReturnType<typeof useModelIDsSuspenseQuery>;
export type ModelIDsQueryResult = Apollo.QueryResult<ModelIDsQuery, ModelIDsQueryVariables>;
export const TimelineDocument = gql`
	query timeline($filter: TimelineFilterInput, $pagination: TimelinePagination, $timeZone: String) {
		timeline(filter: $filter, pagination: $pagination, timeZone: $timeZone) {
			hasMore
			items {
				objectType
				objectTime
				objectTimeIsDate
				objectID
			}
		}
	}
`;

/**
 * __useTimelineQuery__
 *
 * To run a query within a React component, call `useTimelineQuery` and pass it any options that fit your needs.
 * When your component renders, `useTimelineQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTimelineQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      pagination: // value for 'pagination'
 *      timeZone: // value for 'timeZone'
 *   },
 * });
 */
export function useTimelineQuery(baseOptions?: Apollo.QueryHookOptions<TimelineQuery, TimelineQueryVariables>) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<TimelineQuery, TimelineQueryVariables>(TimelineDocument, options);
}
export function useTimelineLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TimelineQuery, TimelineQueryVariables>) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<TimelineQuery, TimelineQueryVariables>(TimelineDocument, options);
}
export function useTimelineSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<TimelineQuery, TimelineQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<TimelineQuery, TimelineQueryVariables>(TimelineDocument, options);
}
export type TimelineQueryHookResult = ReturnType<typeof useTimelineQuery>;
export type TimelineLazyQueryHookResult = ReturnType<typeof useTimelineLazyQuery>;
export type TimelineSuspenseQueryHookResult = ReturnType<typeof useTimelineSuspenseQuery>;
export type TimelineQueryResult = Apollo.QueryResult<TimelineQuery, TimelineQueryVariables>;
export const TimelineAnnouncementListDocument = gql`
	query timelineAnnouncementList(
		$filters: [AnnouncementFilterInput!]
		$pagination: Pagination
		$order: AnnouncementOrder
	) {
		announcementConnection(filters: $filters, pagination: $pagination, order: $order) {
			edges {
				node {
					id
					title
					body
					startTime
					endTime
					author {
						id
						...UserNameAndImage
					}
					mediaAttachments(order: { field: DISPLAY_ORDER, direction: ASC }) {
						id
						title
						description
						isFile
						fileURL
						fileKey
						fileContentType
						linkURL
					}
					socialReactions(order: { field: CREATED_AT, direction: DESC }) {
						id
						author {
							id
							...UserName
							isCurrent
						}
					}
					sharingPolicy {
						id
						isPublic
						userGroups {
							id
							...UserGroupNameAndColor
						}
					}
				}
			}
		}
	}
	${UserNameAndImageFragmentDoc}
	${UserNameFragmentDoc}
	${UserGroupNameAndColorFragmentDoc}
`;

/**
 * __useTimelineAnnouncementListQuery__
 *
 * To run a query within a React component, call `useTimelineAnnouncementListQuery` and pass it any options that fit your needs.
 * When your component renders, `useTimelineAnnouncementListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTimelineAnnouncementListQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useTimelineAnnouncementListQuery(
	baseOptions?: Apollo.QueryHookOptions<TimelineAnnouncementListQuery, TimelineAnnouncementListQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<TimelineAnnouncementListQuery, TimelineAnnouncementListQueryVariables>(
		TimelineAnnouncementListDocument,
		options,
	);
}
export function useTimelineAnnouncementListLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<TimelineAnnouncementListQuery, TimelineAnnouncementListQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<TimelineAnnouncementListQuery, TimelineAnnouncementListQueryVariables>(
		TimelineAnnouncementListDocument,
		options,
	);
}
export function useTimelineAnnouncementListSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<TimelineAnnouncementListQuery, TimelineAnnouncementListQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<TimelineAnnouncementListQuery, TimelineAnnouncementListQueryVariables>(
		TimelineAnnouncementListDocument,
		options,
	);
}
export type TimelineAnnouncementListQueryHookResult = ReturnType<typeof useTimelineAnnouncementListQuery>;
export type TimelineAnnouncementListLazyQueryHookResult = ReturnType<typeof useTimelineAnnouncementListLazyQuery>;
export type TimelineAnnouncementListSuspenseQueryHookResult = ReturnType<
	typeof useTimelineAnnouncementListSuspenseQuery
>;
export type TimelineAnnouncementListQueryResult = Apollo.QueryResult<
	TimelineAnnouncementListQuery,
	TimelineAnnouncementListQueryVariables
>;
export const TimelineCalendarEventListDocument = gql`
	query timelineCalendarEventList(
		$filters: [CalendarEventFilterInput!]
		$pagination: Pagination
		$order: CalendarEventOrder
	) {
		calendarEventConnection(filters: $filters, pagination: $pagination, order: $order) {
			edges {
				node {
					...CalendarEventCalendarDetail
				}
			}
		}
	}
	${CalendarEventCalendarDetailFragmentDoc}
`;

/**
 * __useTimelineCalendarEventListQuery__
 *
 * To run a query within a React component, call `useTimelineCalendarEventListQuery` and pass it any options that fit your needs.
 * When your component renders, `useTimelineCalendarEventListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTimelineCalendarEventListQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useTimelineCalendarEventListQuery(
	baseOptions?: Apollo.QueryHookOptions<TimelineCalendarEventListQuery, TimelineCalendarEventListQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<TimelineCalendarEventListQuery, TimelineCalendarEventListQueryVariables>(
		TimelineCalendarEventListDocument,
		options,
	);
}
export function useTimelineCalendarEventListLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<TimelineCalendarEventListQuery, TimelineCalendarEventListQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<TimelineCalendarEventListQuery, TimelineCalendarEventListQueryVariables>(
		TimelineCalendarEventListDocument,
		options,
	);
}
export function useTimelineCalendarEventListSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		TimelineCalendarEventListQuery,
		TimelineCalendarEventListQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<TimelineCalendarEventListQuery, TimelineCalendarEventListQueryVariables>(
		TimelineCalendarEventListDocument,
		options,
	);
}
export type TimelineCalendarEventListQueryHookResult = ReturnType<typeof useTimelineCalendarEventListQuery>;
export type TimelineCalendarEventListLazyQueryHookResult = ReturnType<typeof useTimelineCalendarEventListLazyQuery>;
export type TimelineCalendarEventListSuspenseQueryHookResult = ReturnType<
	typeof useTimelineCalendarEventListSuspenseQuery
>;
export type TimelineCalendarEventListQueryResult = Apollo.QueryResult<
	TimelineCalendarEventListQuery,
	TimelineCalendarEventListQueryVariables
>;
export const TimelineNewsletterListDocument = gql`
	query timelineNewsletterList($filters: [NewsletterFilterInput!], $pagination: Pagination, $order: NewsletterOrder) {
		newsletterConnection(filters: $filters, pagination: $pagination, order: $order) {
			edges {
				node {
					...NewsletterDisplayListItem
					socialReactions(order: { field: CREATED_AT, direction: DESC }) {
						id
						author {
							id
							...UserName
							isCurrent
						}
					}
					socialComments(order: { field: CREATED_AT, direction: DESC }) {
						id
						body
						createdAt
						author {
							id
							...UserNameAndImage
							isCurrent
						}
					}
					sharingPolicy {
						id
						isPublic
						userGroups {
							id
							...UserGroupNameAndColor
						}
					}
				}
			}
		}
	}
	${NewsletterDisplayListItemFragmentDoc}
	${UserNameFragmentDoc}
	${UserNameAndImageFragmentDoc}
	${UserGroupNameAndColorFragmentDoc}
`;

/**
 * __useTimelineNewsletterListQuery__
 *
 * To run a query within a React component, call `useTimelineNewsletterListQuery` and pass it any options that fit your needs.
 * When your component renders, `useTimelineNewsletterListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTimelineNewsletterListQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useTimelineNewsletterListQuery(
	baseOptions?: Apollo.QueryHookOptions<TimelineNewsletterListQuery, TimelineNewsletterListQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<TimelineNewsletterListQuery, TimelineNewsletterListQueryVariables>(
		TimelineNewsletterListDocument,
		options,
	);
}
export function useTimelineNewsletterListLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<TimelineNewsletterListQuery, TimelineNewsletterListQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<TimelineNewsletterListQuery, TimelineNewsletterListQueryVariables>(
		TimelineNewsletterListDocument,
		options,
	);
}
export function useTimelineNewsletterListSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<TimelineNewsletterListQuery, TimelineNewsletterListQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<TimelineNewsletterListQuery, TimelineNewsletterListQueryVariables>(
		TimelineNewsletterListDocument,
		options,
	);
}
export type TimelineNewsletterListQueryHookResult = ReturnType<typeof useTimelineNewsletterListQuery>;
export type TimelineNewsletterListLazyQueryHookResult = ReturnType<typeof useTimelineNewsletterListLazyQuery>;
export type TimelineNewsletterListSuspenseQueryHookResult = ReturnType<typeof useTimelineNewsletterListSuspenseQuery>;
export type TimelineNewsletterListQueryResult = Apollo.QueryResult<
	TimelineNewsletterListQuery,
	TimelineNewsletterListQueryVariables
>;
export const TimelinePostListDocument = gql`
	query timelinePostList($filters: [PostFilterInput!], $pagination: Pagination, $order: PostOrder) {
		postConnection(filters: $filters, pagination: $pagination, order: $order) {
			edges {
				node {
					id
					createdAt
					title
					body
					author {
						id
						...UserNameAndImage
					}
					mediaAttachments(order: { field: DISPLAY_ORDER, direction: ASC }) {
						id
						title
						description
						isFile
						fileURL
						fileKey
						fileContentType
						linkURL
					}
					socialReactions(order: { field: CREATED_AT, direction: DESC }) {
						id
						author {
							id
							...UserName
							isCurrent
						}
					}
					socialComments(order: { field: CREATED_AT, direction: DESC }) {
						id
						body
						createdAt
						author {
							id
							...UserNameAndImage
							isCurrent
						}
					}
					sharingPolicy {
						id
						isPublic
						userGroups {
							id
							...UserGroupNameAndColor
						}
					}
				}
			}
		}
	}
	${UserNameAndImageFragmentDoc}
	${UserNameFragmentDoc}
	${UserGroupNameAndColorFragmentDoc}
`;

/**
 * __useTimelinePostListQuery__
 *
 * To run a query within a React component, call `useTimelinePostListQuery` and pass it any options that fit your needs.
 * When your component renders, `useTimelinePostListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTimelinePostListQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useTimelinePostListQuery(
	baseOptions?: Apollo.QueryHookOptions<TimelinePostListQuery, TimelinePostListQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<TimelinePostListQuery, TimelinePostListQueryVariables>(TimelinePostListDocument, options);
}
export function useTimelinePostListLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<TimelinePostListQuery, TimelinePostListQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<TimelinePostListQuery, TimelinePostListQueryVariables>(TimelinePostListDocument, options);
}
export function useTimelinePostListSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<TimelinePostListQuery, TimelinePostListQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<TimelinePostListQuery, TimelinePostListQueryVariables>(
		TimelinePostListDocument,
		options,
	);
}
export type TimelinePostListQueryHookResult = ReturnType<typeof useTimelinePostListQuery>;
export type TimelinePostListLazyQueryHookResult = ReturnType<typeof useTimelinePostListLazyQuery>;
export type TimelinePostListSuspenseQueryHookResult = ReturnType<typeof useTimelinePostListSuspenseQuery>;
export type TimelinePostListQueryResult = Apollo.QueryResult<TimelinePostListQuery, TimelinePostListQueryVariables>;
export const ViewerCommunicationRecordCountsDocument = gql`
	query viewerCommunicationRecordCounts {
		announcementConnection(filters: { author: { isCurrentEQ: true } }) {
			totalCount
		}
		calendarEventConnection(filters: { author: { isCurrentEQ: true } }) {
			totalCount
		}
		newsletterConnection(filters: { author: { isCurrentEQ: true } }) {
			totalCount
		}
		postConnection(filters: { author: { isCurrentEQ: true } }) {
			totalCount
		}
	}
`;

/**
 * __useViewerCommunicationRecordCountsQuery__
 *
 * To run a query within a React component, call `useViewerCommunicationRecordCountsQuery` and pass it any options that fit your needs.
 * When your component renders, `useViewerCommunicationRecordCountsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useViewerCommunicationRecordCountsQuery({
 *   variables: {
 *   },
 * });
 */
export function useViewerCommunicationRecordCountsQuery(
	baseOptions?: Apollo.QueryHookOptions<
		ViewerCommunicationRecordCountsQuery,
		ViewerCommunicationRecordCountsQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<ViewerCommunicationRecordCountsQuery, ViewerCommunicationRecordCountsQueryVariables>(
		ViewerCommunicationRecordCountsDocument,
		options,
	);
}
export function useViewerCommunicationRecordCountsLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		ViewerCommunicationRecordCountsQuery,
		ViewerCommunicationRecordCountsQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<ViewerCommunicationRecordCountsQuery, ViewerCommunicationRecordCountsQueryVariables>(
		ViewerCommunicationRecordCountsDocument,
		options,
	);
}
export function useViewerCommunicationRecordCountsSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		ViewerCommunicationRecordCountsQuery,
		ViewerCommunicationRecordCountsQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<ViewerCommunicationRecordCountsQuery, ViewerCommunicationRecordCountsQueryVariables>(
		ViewerCommunicationRecordCountsDocument,
		options,
	);
}
export type ViewerCommunicationRecordCountsQueryHookResult = ReturnType<typeof useViewerCommunicationRecordCountsQuery>;
export type ViewerCommunicationRecordCountsLazyQueryHookResult = ReturnType<
	typeof useViewerCommunicationRecordCountsLazyQuery
>;
export type ViewerCommunicationRecordCountsSuspenseQueryHookResult = ReturnType<
	typeof useViewerCommunicationRecordCountsSuspenseQuery
>;
export type ViewerCommunicationRecordCountsQueryResult = Apollo.QueryResult<
	ViewerCommunicationRecordCountsQuery,
	ViewerCommunicationRecordCountsQueryVariables
>;
export const ViewerWithPermissionsDocument = gql`
	query viewerWithPermissions {
		viewer {
			id
			email
			status
		}
		permissionConnection(filters: { permissionGroups: { users: { isCurrentEQ: true } } }) {
			edges {
				node {
					name
				}
			}
		}
	}
`;

/**
 * __useViewerWithPermissionsQuery__
 *
 * To run a query within a React component, call `useViewerWithPermissionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useViewerWithPermissionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useViewerWithPermissionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useViewerWithPermissionsQuery(
	baseOptions?: Apollo.QueryHookOptions<ViewerWithPermissionsQuery, ViewerWithPermissionsQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<ViewerWithPermissionsQuery, ViewerWithPermissionsQueryVariables>(
		ViewerWithPermissionsDocument,
		options,
	);
}
export function useViewerWithPermissionsLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<ViewerWithPermissionsQuery, ViewerWithPermissionsQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<ViewerWithPermissionsQuery, ViewerWithPermissionsQueryVariables>(
		ViewerWithPermissionsDocument,
		options,
	);
}
export function useViewerWithPermissionsSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<ViewerWithPermissionsQuery, ViewerWithPermissionsQueryVariables>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<ViewerWithPermissionsQuery, ViewerWithPermissionsQueryVariables>(
		ViewerWithPermissionsDocument,
		options,
	);
}
export type ViewerWithPermissionsQueryHookResult = ReturnType<typeof useViewerWithPermissionsQuery>;
export type ViewerWithPermissionsLazyQueryHookResult = ReturnType<typeof useViewerWithPermissionsLazyQuery>;
export type ViewerWithPermissionsSuspenseQueryHookResult = ReturnType<typeof useViewerWithPermissionsSuspenseQuery>;
export type ViewerWithPermissionsQueryResult = Apollo.QueryResult<
	ViewerWithPermissionsQuery,
	ViewerWithPermissionsQueryVariables
>;
